export interface LocaleEntry {
  id: string;
  en: string;
  fr: string;
  es: string;
  de: string;
  pl: string;
  ru: string;
  uk: string;
  ko: string;
  zh: string;
  ja: string;
}

export interface LocaleData {
  type: string;
  entries: LocaleEntry[];
}

export const localeData: LocaleData[] =
  [{
    'type': 'items',
    'entries': [{
      'id': 'AcornItem',
      'en': 'Acorn',
      'fr': 'Gland',
      'es': 'Bellota',
      'de': 'Eichel',
      'pl': 'Żołądź',
      'ru': 'Жёлудь',
      'uk': 'Жолудь',
      'ko': '도토리',
      'zh': '橡子',
      'ja': 'ドングリ',
    }, {
      'id': 'AcornPowderItem',
      'en': 'Acorn Powder',
      'fr': 'Poudre de gland',
      'es': 'Polvo de Bellota',
      'de': 'Eichelpulver',
      'pl': 'Mączka z żołędzi',
      'ru': 'Мука из желудей',
      'uk': 'Порошок із жолудів',
      'ko': '도토리 분말',
      'zh': '橡子粉',
      'ja': 'ドングリの粉',
    }, {
      'id': 'AdornedAshlarBasaltBenchItem',
      'en': 'Adorned Ashlar Basalt Bench',
      'fr': 'Banc en basalte taillé orné',
      'es': 'Banco adornado (sillar de basalto)',
      'de': 'Geschmückte Basaltquaderbank',
      'pl': 'Zdobiona ławka z ciosanego bazaltu',
      'ru': 'Украшенная лавка из резного базальта',
      'uk': 'Прикрашена лавка із різьбленого базальту',
      'ko': '장식된 각진 현무암 벤치',
      'zh': '装饰过的阿什拉尔玄武岩长凳',
      'ja': 'Adorned Ashlar Basalt Bench',
    }, {
      'id': 'AdornedAshlarBasaltChairItem',
      'en': 'Adorned Ashlar Basalt Chair',
      'fr': 'Chaise en basalte taillé ornée',
      'es': 'Silla adornada (sillar de basalto)',
      'de': 'Geschmückter Basaltquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego bazaltu',
      'ru': 'Украшенный стул из резного базальта',
      'uk': 'Прикрашений стілець із різьбленого базальту',
      'ko': '장식된 각진 현무암 의자',
      'zh': '装饰过的阿什拉尔玄武岩的椅子',
      'ja': 'Adorned Ashlar Basalt Chair',
    }, {
      'id': 'AdornedAshlarBasaltTableItem',
      'en': 'Adorned Ashlar Basalt Table',
      'fr': 'Table en basalte taillé ornée',
      'es': 'Mesa adornada (sillar de basalto)',
      'de': 'Geschmückter Basaltquadertisch',
      'pl': 'Zdobiony stół z ciosanego bazaltu',
      'ru': 'Украшенный стол из резного базальта',
      'uk': 'Прикрашений стіл із різьбленого базальту',
      'ko': '장식된 각진 현무암 탁자',
      'zh': '装饰过的阿什拉尔玄武岩桌',
      'ja': 'Adorned Ashlar Basalt Table',
    }, {
      'id': 'AdornedAshlarGneissBenchItem',
      'en': 'Adorned Ashlar Gneiss Bench',
      'fr': 'Banc en gneiss taillé orné',
      'es': 'Banco adornado (sillar de granito)',
      'de': 'Geschmückte Gneisquaderbank',
      'pl': 'Zdobiona ławka z ciosanego gnejsu',
      'ru': 'Украшенная лавка из резного гнейса',
      'uk': 'Прикрашена лавка із різьбленого гнейсу',
      'ko': '장식된 각진 편마암 벤치',
      'zh': '装饰过的阿什拉尔片麻岩长凳',
      'ja': 'Adorned Ashlar Gneiss Bench',
    }, {
      'id': 'AdornedAshlarGneissChairItem',
      'en': 'Adorned Ashlar Gneiss Chair',
      'fr': 'Chaise en gneiss taillé ornée',
      'es': 'Silla adornada (sillar de granito)',
      'de': 'Geschmückter Gneisquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego gnejsu',
      'ru': 'Украшенный стул из резного гнейса',
      'uk': 'Прикрашений стілець із різьбленого гнейсу',
      'ko': '장식된 각진 편마암 의자',
      'zh': '装饰过的阿什拉尔片麻岩椅子',
      'ja': 'Adorned Ashlar Gneiss Chair',
    }, {
      'id': 'AdornedAshlarGneissTableItem',
      'en': 'Adorned Ashlar Gneiss Table',
      'fr': 'Table en gneiss taillé ornée',
      'es': 'Mesa adornada (sillar de gneis)',
      'de': 'Geschmückter Gneisquadertisch',
      'pl': 'Zdobiony stół z ciosanego gnejsu',
      'ru': 'Украшенный стол из резного гнейса',
      'uk': 'Прикрашений стіл із різьбленого гнейсу',
      'ko': '장식된 각진 편마암 탁자',
      'zh': '装饰过的阿什拉尔片麻岩桌',
      'ja': 'Adorned Ashlar Gneiss Table',
    }, {
      'id': 'AdornedAshlarGraniteBenchItem',
      'en': 'Adorned Ashlar Granite Bench',
      'fr': 'Banc en granite taillé orné',
      'es': 'Banco adornado (sillar de granito)',
      'de': 'Geschmückte Granitquaderbank',
      'pl': 'Zdobiona ławka z ciosanego granitu',
      'ru': 'Украшенная лавка из резного гранита',
      'uk': 'Прикрашена лавка із різьбленого граніту',
      'ko': '장식된 각진 화강암 벤치',
      'zh': '装饰过的阿什拉尔花岗岩长凳',
      'ja': 'Adorned Ashlar Granite Bench',
    }, {
      'id': 'AdornedAshlarGraniteChairItem',
      'en': 'Adorned Ashlar Granite Chair',
      'fr': 'Chaise en granite taillé ornée',
      'es': 'Silla adornada (sillar de granito)',
      'de': 'Geschmückter Granitquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego granitu',
      'ru': 'Украшенный стул из резного гранита',
      'uk': 'Прикрашений стілець із різьбленого граніту',
      'ko': '장식된 각진 화강암 의자',
      'zh': '装饰过的阿什拉尔花岗岩椅子',
      'ja': 'Adorned Ashlar Granite Chair',
    }, {
      'id': 'AdornedAshlarGraniteTableItem',
      'en': 'Adorned Ashlar Granite Table',
      'fr': 'Table en granite taillé ornée',
      'es': 'Mesa adornada (sillar de granito)',
      'de': 'Geschmückter Granitquadertisch',
      'pl': 'Zdobiony stół z ciosanego granitu',
      'ru': 'Украшенный стол из резного гранита',
      'uk': 'Прикрашений стіл із різьбленого граніту',
      'ko': '장식된 각진 화강암 탁자',
      'zh': '装饰过的阿什拉尔花岗岩桌',
      'ja': 'Adorned Ashlar Granite Table',
    }, {
      'id': 'AdornedAshlarLimestoneBenchItem',
      'en': 'Adorned Ashlar Limestone Bench',
      'fr': 'Banc en calcaire taillé ornée',
      'es': 'Banco adornado (sillar de piedra caliza)',
      'de': 'Geschmückter Kalksteinquaderbank',
      'pl': 'Zdobiona ławka z ciosanego wapienia',
      'ru': 'Украшенная лавка из резного известняка',
      'uk': 'Прикрашена лавка із різьбленого вапняку',
      'ko': '장식된 각진 석회암 벤치',
      'zh': '装饰过的阿什拉尔石灰石长凳',
      'ja': 'Adorned Ashlar Limestone Bench',
    }, {
      'id': 'AdornedAshlarLimestoneChairItem',
      'en': 'Adorned Ashlar Limestone Chair',
      'fr': 'Chaise en calcaire taillé ornée',
      'es': 'Silla adornada (sillar de piedra caliza)',
      'de': 'Geschmückter Kalksteinquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego wapienia',
      'ru': 'Украшенный стул из резного известняка',
      'uk': 'Прикрашений стілець із різьбленого вапняку',
      'ko': '장식된 각진 석회암 의자',
      'zh': '装饰过的阿什拉尔石灰石的椅子',
      'ja': 'Adorned Ashlar Limestone Chair',
    }, {
      'id': 'AdornedAshlarLimestoneTableItem',
      'en': 'Adorned Ashlar Limestone Table',
      'fr': 'Table en calcaire taillé ornée',
      'es': 'Mesa adornada (sillar de piedra caliza)',
      'de': 'Geschmückter Kalksteinquadertisch',
      'pl': 'Zdobiony stół z ciosanego wapienia',
      'ru': 'Украшенный стол из резного известняка',
      'uk': 'Прикрашений стіл із різьбленого вапняку',
      'ko': '장식된 각진 석회암 탁자',
      'zh': '装饰过的阿什拉尔石灰石桌',
      'ja': 'Adorned Ashlar Limestone Table',
    }, {
      'id': 'AdornedAshlarSandstoneBenchItem',
      'en': 'Adorned Ashlar Sandstone Bench',
      'fr': 'Banc en grès taillé orné',
      'es': 'Banco adornado (sillar de arenisca)',
      'de': 'Geschmückter Sandsteinquaderbank',
      'pl': 'Zdobiona ławka z ciosanego piaskowca',
      'ru': 'Украшенная лавка из резного песчаника',
      'uk': 'Прикрашена лавка із різьбленого пісковика',
      'ko': '장식된 각진 사암 벤치',
      'zh': '装饰过的阿什拉尔砂岩长凳',
      'ja': 'Adorned Ashlar Sandstone Bench',
    }, {
      'id': 'AdornedAshlarSandstoneChairItem',
      'en': 'Adorned Ashlar Sandstone Chair',
      'fr': 'Chaise en grès taillé ornée',
      'es': 'Silla adornada (sillar de arenisca)',
      'de': 'Geschmückter Sandsteinquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego piaskowca',
      'ru': 'Украшенный стул из резного песчаника',
      'uk': 'Прикрашений стілець із різьбленого пісковика',
      'ko': '장식된 각진 사암 의자',
      'zh': '装饰过的阿什拉尔砂岩椅',
      'ja': 'Adorned Ashlar Sandstone Chair',
    }, {
      'id': 'AdornedAshlarSandstoneTableItem',
      'en': 'Adorned Ashlar Sandstone Table',
      'fr': 'Table en grès taillé ornée',
      'es': 'Mesa adornada (sillar de arenisca)',
      'de': 'Geschmückter Sandsteinquadertisch',
      'pl': 'Zdobiony stół z ciosanego piaskowca',
      'ru': 'Украшенный стол из резного песчаника',
      'uk': 'Прикрашений стіл із різьбленого піщаника',
      'ko': '장식된 각진 사암 탁자',
      'zh': '装饰过的阿什拉尔砂岩桌',
      'ja': 'Adorned Ashlar Sandstone Table',
    }, {
      'id': 'AdornedAshlarShaleBenchItem',
      'en': 'Adorned Ashlar Shale Bench',
      'fr': 'Banc en schiste taillé orné',
      'es': 'Banco adornado de pizarra (sillar)',
      'de': 'Geschmückter Schieferquaderbank',
      'pl': 'Zdobiona ławka z ciosanego łupku',
      'ru': 'Украшенная лавка из резного сланца',
      'uk': 'Прикрашена лавка із різьбленого сланцю',
      'ko': '장식된 각진 이판암 벤치',
      'zh': '装饰过的阿什拉尔页岩长凳',
      'ja': 'Adorned Ashlar Shale Bench',
    }, {
      'id': 'AdornedAshlarShaleChairItem',
      'en': 'Adorned Ashlar Shale Chair',
      'fr': 'Chaise en schiste taillé ornée',
      'es': 'Silla adornada de pizarra (sillar)',
      'de': 'Geschmückter Schieferquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego łupku',
      'ru': 'Украшенный стул из резного сланца',
      'uk': 'Прикрашений стілець із різьбленого сланцю',
      'ko': '장식된 각진 이판암 탁자',
      'zh': '装饰过的阿什拉尔页岩椅',
      'ja': 'Adorned Ashlar Shale Chair',
    }, {
      'id': 'AdornedAshlarShaleTableItem',
      'en': 'Adorned Ashlar Shale Table',
      'fr': 'Table en schiste taillé ornée',
      'es': 'Mesa adornada de pizarra (sillar)',
      'de': 'Geschmückter Schieferquadertisch',
      'pl': 'Zdobiony stół z ciosanego łupku',
      'ru': 'Украшенный стол из резного сланца',
      'uk': 'Прикрашений стіл із різьбленого сланцю',
      'ko': '장식된 각진 이판암 탁자',
      'zh': '装饰过的阿什拉尔页岩桌',
      'ja': 'Adorned Ashlar Shale Table',
    }, {
      'id': 'AdornedAshlarStoneBenchItem',
      'en': 'Adorned Ashlar Stone Bench',
      'fr': 'Banc en pierre taillée ornée',
      'es': 'Banco adornado (sillar de piedra)',
      'de': 'Geschmückter Steinquaderbank',
      'pl': 'Zdobiona ławka z ciosanego kamienia',
      'ru': 'Украшенная лавка из резного камня',
      'uk': 'Прикрашена лавка з різьбленого каменю',
      'ko': '장식된 각진 석재 벤치',
      'zh': '装饰过的阿什拉尔石凳',
      'ja': 'Adorned Ashlar Stone Bench',
    }, {
      'id': 'AdornedAshlarStoneChairItem',
      'en': 'Adorned Ashlar Stone Chair',
      'fr': 'Chaise en pierre taillée ornée',
      'es': 'Silla adornada (sillar de piedra)',
      'de': 'Geschmückter Steinquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego kamienia',
      'ru': 'Украшенный стул из резного камня',
      'uk': 'Прикрашений стілець з різьбленого каменю',
      'ko': '장식된 각진 석재 의자',
      'zh': '装饰过的阿什拉尔石椅',
      'ja': 'Adorned Ashlar Stone Chair',
    }, {
      'id': 'AdornedAshlarStoneTableItem',
      'en': 'Adorned Ashlar Stone Table',
      'fr': 'Table en pierre taillée ornée',
      'es': 'Mesa adornada (sillar de piedra)',
      'de': 'Geschmückter Steinquadertisch',
      'pl': 'Zdobiony stół z ciosanego kamienia',
      'ru': 'Украшенный стол из резного камня',
      'uk': 'Прикрашений стіл з різьбленого каменю',
      'ko': '장식된 각진 석재 탁자',
      'zh': '装饰过的阿什拉尔石桌',
      'ja': 'Adorned Ashlar Stone Table',
    }, {
      'id': 'AdvancedBakingUpgradeItem',
      'en': 'Advanced Baking Upgrade',
      'fr': 'Amélioration Avancée : Boulangerie avancée',
      'es': 'Mejora avanzada: Horneado',
      'de': 'Fortschrittliches Upgrade: Backen',
      'pl': 'Ulepszenie Zaawansowanego Pieczenia',
      'ru': 'Улучшение для продвинутой выпечки',
      'uk': 'Просунуте покращення випічки',
      'ko': '고급 제빵 기술 업그레이드',
      'zh': '高级烘烤升级',
      'ja': 'Advanced Baking Upgrade',
    }, {
      'id': 'AdvancedCarpentryTableItem',
      'en': 'Advanced Carpentry Table',
      'fr': 'Établi de menuiserie avancé',
      'es': 'Mesa de carpintería avanzada',
      'de': 'Verbesserter Schreinerhandwerkstisch',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Продвинутый верстак плотника',
      'uk': 'Розширений теслярський стіл',
      'ko': '고급 목공 작업대',
      'zh': '高级木工桌',
      'ja': 'Advanced Carpentry Table',
    }, {
      'id': 'AdvancedCircuitItem',
      'en': 'Advanced Circuit',
      'fr': 'Circuit avancé',
      'es': 'Circuito avanzado',
      'de': 'Fortschrittlicher Schaltkreis',
      'pl': 'Zaawansowany Obwód',
      'ru': 'Продвинутая электросхема',
      'uk': 'Покращена електросхема',
      'ko': '고급 전자회로',
      'zh': '先进电路',
      'ja': 'Advanced Circuit',
    }, {
      'id': 'AdvancedCombustionEngineItem',
      'en': 'Advanced Combustion Engine',
      'fr': 'Moteur à combustion avancé',
      'es': 'Motor de Combustión Avanzado',
      'de': 'Fortschrittlicher Verbrennungsmotor',
      'pl': 'Zaawansowany silnik spalinowy',
      'ru': 'Улучшенный двигатель внутреннего сгорания',
      'uk': 'Удосконалений двигун внутрішнього згоряння',
      'ko': '고급 연소기관',
      'zh': '高级内燃机',
      'ja': '高度な内燃機関',
    }, {
      'id': 'AdvancedCookingUpgradeItem',
      'en': 'Advanced Cooking Upgrade',
      'fr': 'Amélioration Avancée : Cuisine avancée',
      'es': 'Mejora avanzada: Cocina',
      'de': 'Fortschrittliches Upgrade: Kochen',
      'pl': 'Zaawansowane ulepszenie Gotowania',
      'ru': 'Улучшение для продвинутой кулинарии',
      'uk': 'Просунуте покращення приготування їжі',
      'ko': '고급 요리 기술 업그레이드',
      'zh': '高级烹饪升级',
      'ja': 'Advanced Cooking Upgrade',
    }, {
      'id': 'AdvancedMasonryTableItem',
      'en': 'Advanced Masonry Table',
      'fr': 'Établi de maçonnerie avancé',
      'es': 'Mesa de mampostería avanzada',
      'de': 'Verbesserter Steinmetztisch',
      'pl': 'Zaawansowany stół kamieniarski',
      'ru': 'Продвинутый верстак каменщика',
      'uk': 'Покращенний верстак муляра',
      'ko': '고급 석공 작업대',
      'zh': '高级石工台',
      'ja': 'Advanced Masonry Table',
    }, {
      'id': 'AdvancedMasonryUpgradeItem',
      'en': 'Advanced Masonry Upgrade',
      'fr': 'Amélioration Moderne : Maçonnerie avancée',
      'es': 'Mejora: Mampostería avanzada',
      'de': 'Fortschrittliches Upgrade: Steinmetz',
      'pl': 'Zaawansowane ulepszenie Kamieniarstwa',
      'ru': 'Продвинутое улучшение для каменной кладки',
      'uk': 'Просунуте покращення кладки',
      'ko': '고급 석조 기술 업그레이드',
      'zh': '高级石工升级组件',
      'ja': 'Advanced Masonry Upgrade',
    }, {
      'id': 'Advanced Research',
      'en': 'Advanced Research',
      'fr': 'Recherche avancée',
      'es': 'Investigación avanzada',
      'de': 'Fortgeschrittene Forschung',
      'pl': 'Zaawansowane badanie',
      'ru': 'Продвинутое исследование',
      'uk': 'Вдосконалене дослідження',
      'ko': '고급 연구',
      'zh': '高级研究',
      'ja': 'Advanced Research',
    }, {
      'id': 'AdvancedSmeltingUpgradeItem',
      'en': 'Advanced Smelting Upgrade',
      'fr': 'Amélioration Avancée : Fonte avancée',
      'es': 'Mejora avanzada: Fundición',
      'de': 'Fortschrittliches Upgrade: Schmelzen',
      'pl': 'Zaawansowane ulepszenie Wytapiania',
      'ru': 'Улучшение для продвинутой выплавки',
      'uk': 'Просунуте покращення виплавки',
      'ko': '고급 제련 기술 업그레이드',
      'zh': '高级冶炼升级',
      'ja': 'Advanced Smelting Upgrade',
    }, {
      'id': 'AdvancedTailoringTableItem',
      'en': 'Advanced Tailoring Table',
      'fr': 'Établi de couturier avancé',
      'es': 'Mesa de sastrería avanzada',
      'de': 'Verbesserter Schneidertisch',
      'pl': 'Advanced Tailoring Table',
      'ru': 'Продвинутый Стол Портного',
      'uk': 'Advanced Tailoring Table',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝台',
      'ja': 'Advanced Tailoring Table',
    }, {
      'id': 'AdvancedUpgradeLvl1Item',
      'en': 'Advanced Upgrade 1',
      'fr': 'Amélioration Avancée Nv1',
      'es': 'Mejora avanzada 1',
      'de': 'Fortschrittliches Upgrade 1',
      'pl': 'Zaawansowane ulepszenie 1',
      'ru': 'Продвинутое улучшение 1',
      'uk': 'Просунуте покращення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级1',
      'ja': 'Advanced Upgrade 1',
    }, {
      'id': 'AdvancedUpgradeLvl2Item',
      'en': 'Advanced Upgrade 2',
      'fr': 'Amélioration Avancée Nv2',
      'es': 'Mejora avanzada 2',
      'de': 'Fortschrittliches Upgrade 2',
      'pl': 'Zaawansowane ulepszenie 2',
      'ru': 'Продвинутое улучшение 2',
      'uk': 'Просунуте покращення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级2',
      'ja': 'Advanced Upgrade 2',
    }, {
      'id': 'AdvancedUpgradeLvl3Item',
      'en': 'Advanced Upgrade 3',
      'fr': 'Amélioration Avancée Nv3',
      'es': 'Mejora avanzada 3',
      'de': 'Fortschrittliches Upgrade 3',
      'pl': 'Zaawansowane ulepszenie 3',
      'ru': 'Продвинутое улучшение 3',
      'uk': 'Просунуте покращення 3',
      'ko': '고급 업그레이드 3',
      'zh': '高级升级3',
      'ja': 'Advanced Upgrade 3',
    }, {
      'id': 'AdvancedUpgradeLvl4Item',
      'en': 'Advanced Upgrade 4',
      'fr': 'Amélioration Avancée Nv4',
      'es': 'Mejora avanzada 4',
      'de': 'Fortschrittliches Upgrade 4',
      'pl': 'Zaawansowane ulepszenie 4',
      'ru': 'Продвинутое улучшение 4',
      'uk': 'Просунуте покращення 4',
      'ko': '고급 업그레이드 4',
      'zh': '高级升级4',
      'ja': 'Advanced Upgrade 4',
    }, {
      'id': 'AgaveLeavesItem',
      'en': 'Agave Leaves',
      'fr': 'Feuille d\u0027agave',
      'es': 'Hojas de agave',
      'de': 'Agavenblätter',
      'pl': 'Agave Leaves',
      'ru': 'Листья агавы',
      'uk': 'Листя агави',
      'ko': '용설란 잎',
      'zh': '龙舌兰叶子',
      'ja': 'リュウゼツランの葉',
    }, {
      'id': 'AgaveSeedItem',
      'en': 'Agave Seed',
      'fr': 'Graine d\u0027agave',
      'es': 'Semilla de agave',
      'de': 'Samen (Agave)',
      'pl': 'Nasiono agawy',
      'ru': 'Семечко агавы',
      'uk': 'Насіння агави',
      'ko': '용설란 씨앗',
      'zh': '龙舌兰种子',
      'ja': 'アガベの種子',
    }, {
      'id': 'AgoutiCarcassItem',
      'en': 'Agouti Carcass',
      'fr': 'Cadavre d\u0027agouti',
      'es': 'Cadáver de agutí',
      'de': 'Agutikadaver',
      'pl': 'Tusza aguti',
      'ru': 'Туша агути',
      'uk': 'Туша агуті',
      'ko': '아구티 사체',
      'zh': '刺豚鼠遗骸',
      'ja': 'Agouti Carcass',
    }, {
      'id': 'AgoutiEnchiladasItem',
      'en': 'Agouti Enchiladas',
      'fr': 'Enchiladas d\u0027agouti',
      'es': 'Enchiladas de agutí',
      'de': 'Agouti Enchiladas',
      'pl': 'Agouti Enchiladas',
      'ru': 'Энчиладас с агути',
      'uk': 'Agouti Enchiladas',
      'ko': 'Agouti Enchiladas',
      'zh': '刺鼠玉米卷',
      'ja': 'Agouti Enchiladas',
    }, {
      'id': 'AgricultureResearchPaperAdvancedItem',
      'en': 'Agriculture Research Paper Advanced',
      'fr': 'Papier de recherche : Agriculture avancée',
      'es': 'Trabajo de investigación en agricultura (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Landwirtschaft',
      'pl': 'Agriculture Research Paper Advanced',
      'ru': 'Исследование по продвинутому сельскому хозяйству',
      'uk': 'Дослідження вдосконаленого сільського господарства',
      'ko': '고급 농업 연구지',
      'zh': '高级农业研究论文',
      'ja': 'Agriculture Research Paper Advanced',
    }, {
      'id': 'AgricultureResearchPaperModernItem',
      'en': 'Agriculture Research Paper Modern',
      'fr': 'Papier de recherche : Agriculture moderne',
      'es': 'Trabajo de investigación en agricultura (moderno)',
      'de': 'Modernes Forschungspapier: Landwirtschaft',
      'pl': 'Nowoczesny artykuł badawczy Agrokultury',
      'ru': 'Исследование по современному сельскому хозяйству',
      'uk': 'Дослідження сучасного сільського господарства',
      'ko': '현대식 농업 연구지',
      'zh': '现代农业研究论文',
      'ja': 'Agriculture Research Paper Modern',
    }, {
      'id': 'AlligatorCarcassItem',
      'en': 'Alligator Carcass',
      'fr': 'Cadavre d\u0027alligator',
      'es': 'Cadáver de caimán',
      'de': 'Alligatorkadaver',
      'pl': 'Tusza aligatora',
      'ru': 'Туша аллигатора',
      'uk': 'Туша алігатора',
      'ko': '악어 사체',
      'zh': '鳄鱼遗骸',
      'ja': 'Alligator Carcass',
    }, {
      'id': 'AmanitaMushroomSporesItem',
      'en': 'Amanita Mushroom Spores',
      'fr': 'Spores d\u0027amanite tue-mouches',
      'es': 'Esporas de Amanita Muscaria',
      'de': 'Sporen (Fliegenpilz)',
      'pl': 'Zarodniki Muchomora Czerwonego',
      'ru': 'Споры мухоморов',
      'uk': 'Спори мухомора',
      'ko': '광대버섯 포자',
      'zh': '鹅膏菌孢子',
      'ja': 'ベニテングダケの胞子',
    }, {
      'id': 'AmanitaMushroomsItem',
      'en': 'Amanita Mushrooms',
      'fr': 'Amanites tue-mouches',
      'es': 'Amanita Muscaria',
      'de': 'Fliegenpilze',
      'pl': 'Muchomor Czerwony',
      'ru': 'Мухоморы',
      'uk': 'Мухомори',
      'ko': '광대버섯',
      'zh': '鹅膏菌',
      'ja': 'ベニテングダケ',
    }, {
      'id': 'AmendmentsItem',
      'en': 'Amendments',
      'fr': 'Pupitre d\u0027amendements',
      'es': 'Enmiendas',
      'de': 'Verfassungsänderungen',
      'pl': 'Poprawki',
      'ru': 'Поправки',
      'uk': 'Поправки',
      'ko': '입법부',
      'zh': '修正案',
      'ja': 'Amendments',
    }, {
      'id': 'Animal',
      'en': 'Animal',
      'fr': 'Animal',
      'es': 'Animal',
      'de': 'Tier',
      'pl': 'Zwierzę',
      'ru': 'Животное',
      'uk': 'Тварина',
      'ko': '동물',
      'zh': '动物',
      'ja': '動物',
    }, {
      'id': 'AnvilItem',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Ковадло',
      'ko': '모루',
      'zh': '铁砧',
      'ja': '金床',
    }, {
      'id': 'ArcticWillowSeedItem',
      'en': 'Arctic Willow Seed',
      'fr': 'Graine de saule arctique',
      'es': 'Semilla de Sauce del Ártico',
      'de': 'Samen (Arktische-Weide)',
      'pl': 'Nasiono wierzby arktycznej',
      'ru': 'Семечко ивы арктической',
      'uk': 'Насіння верби арктичної',
      'ko': '북극버들 씨앗',
      'zh': '极地柳种子',
      'ja': '北極ヤナギの種子',
    }, {
      'id': 'ArrastraItem',
      'en': 'Arrastra',
      'fr': 'Concasseur à meules en pierre',
      'es': 'Arrastra',
      'de': 'Bergbau-Pochmühle',
      'pl': 'Opór',
      'ru': 'Аррастра',
      'uk': 'Аррастра',
      'ko': '돌 맷돌',
      'zh': '碎金研磨机',
      'ja': 'Arrastra',
    }, {
      'id': 'ArrowItem',
      'en': 'Arrow',
      'fr': 'Flèche',
      'es': 'Flecha',
      'de': 'Pfeil',
      'pl': 'Strzała',
      'ru': 'Стрела',
      'uk': 'Стріла',
      'ko': '화살',
      'zh': '箭',
      'ja': '矢',
    }, {
      'id': 'AshlarBasaltItem',
      'en': 'Ashlar Basalt',
      'fr': 'Basalte taillé',
      'es': 'Sillar de basalto',
      'de': 'Quader aus Basalt',
      'pl': 'Ciosany bazalt',
      'ru': 'Резной базальт',
      'uk': 'Різьблений Базальт',
      'ko': '각진 현무암',
      'zh': '阿什拉尔玄武岩',
      'ja': 'Ashlar Basalt',
    }, {
      'id': 'AshlarBasaltBenchItem',
      'en': 'Ashlar Basalt Bench',
      'fr': 'Banc en basalte taillé',
      'es': 'Banco (sillar de basalto)',
      'de': 'Basaltquaderbank',
      'pl': 'Ławka z ciosanego bazaltu',
      'ru': 'Лавка из резного базальта',
      'uk': 'Лавка з обтесаного базальту',
      'ko': '각진 현무암 벤치',
      'zh': '阿什拉尔玄武岩长凳',
      'ja': 'Ashlar Basalt Bench',
    }, {
      'id': 'AshlarBasaltChairItem',
      'en': 'Ashlar Basalt Chair',
      'fr': 'Chaise en basalte taillé',
      'es': 'Silla (sillar de basalto)',
      'de': 'Basaltquaderstuhl',
      'pl': 'Krzesło z ciosanego bazaltu',
      'ru': 'Стул из резного базальта',
      'uk': 'Стілець з обтесаного базальту',
      'ko': '각진 현무암 의자',
      'zh': '阿什拉尔玄武岩椅子',
      'ja': 'Ashlar Basalt Chair',
    }, {
      'id': 'AshlarBasaltDoorItem',
      'en': 'Ashlar Basalt Door',
      'fr': 'Porte en basalte taillé',
      'es': 'Puerta (sillar de basalto)',
      'de': 'Basaltquadertür',
      'pl': 'Ciosane bazaltowe drzwi',
      'ru': 'Дверь из резного базальта',
      'uk': 'Двері з обтесаного базальту',
      'ko': '각진 현무암 문',
      'zh': '阿什拉尔玄武岩门',
      'ja': 'Ashlar Basalt Door',
    }, {
      'id': 'AshlarBasaltFireplaceItem',
      'en': 'Ashlar Basalt Fireplace',
      'fr': 'Cheminée en basalte taillé',
      'es': 'Chimenea (sillar de basalto)',
      'de': 'Basaltquaderfeuerstelle',
      'pl': 'Kominek z ciosanego bazaltu',
      'ru': 'Камин из резного базальта',
      'uk': 'Камін з обтесаного базальту',
      'ko': '각진 현무암 벽난로',
      'zh': '阿什拉尔玄武岩壁炉',
      'ja': 'Ashlar Basalt Fireplace',
    }, {
      'id': 'AshlarBasaltTableItem',
      'en': 'Ashlar Basalt Table',
      'fr': 'Table en basalte taillé',
      'es': 'Mesa (sillar de basalto)',
      'de': 'Basaltquadertisch',
      'pl': 'Stół z ciosanego bazaltu',
      'ru': 'Стол из резного базальта',
      'uk': 'Стіл з обтесаного базальту',
      'ko': '각진 현무암 탁자',
      'zh': '阿什拉尔玄武岩桌',
      'ja': 'Ashlar Basalt Table',
    }, {
      'id': 'AshlarGneissItem',
      'en': 'Ashlar Gneiss',
      'fr': 'Gneiss taillé',
      'es': 'Sillar de gneis',
      'de': 'Quader aus Gneis',
      'pl': 'Ciosany gnejs',
      'ru': 'Резной гнейс',
      'uk': 'Різьблений гнейс',
      'ko': '각진 편마암',
      'zh': '阿什拉尔片麻岩',
      'ja': 'Ashlar Gneiss',
    }, {
      'id': 'AshlarGneissBenchItem',
      'en': 'Ashlar Gneiss Bench',
      'fr': 'Banc en gneiss taillé',
      'es': 'Banco (sillar de gneis)',
      'de': 'Gneisquaderbank',
      'pl': 'Ławka z ciosanego gnejsu',
      'ru': 'Лавка из резного гнейса',
      'uk': 'Лавка з обтесаного гнейсу',
      'ko': '각진 편마암 벤치',
      'zh': '阿什拉尔片麻岩长凳',
      'ja': 'Ashlar Gneiss Bench',
    }, {
      'id': 'AshlarGneissChairItem',
      'en': 'Ashlar Gneiss Chair',
      'fr': 'Chaise en gneiss taillé',
      'es': 'Silla (sillar de gneis)',
      'de': 'Gneisquaderstuhl',
      'pl': 'Krzesło z ciosanego gnejsu',
      'ru': 'Стул из резного гнейса',
      'uk': 'Стілець з обтесаного гнейсу',
      'ko': '각진 편마암 의자',
      'zh': '阿什拉尔片麻岩椅子',
      'ja': 'Ashlar Gneiss Chair',
    }, {
      'id': 'AshlarGneissDoorItem',
      'en': 'Ashlar Gneiss Door',
      'fr': 'Porte en gneiss taillé',
      'es': 'Puerta (sillar de gneis)',
      'de': 'Gneisquadertür',
      'pl': 'Ciosane gnejsowe drzwi',
      'ru': 'Дверь из резного гнейса',
      'uk': 'Двері з обтесаного гнейсу',
      'ko': '각진 편마암 문',
      'zh': '阿什拉尔片麻岩门',
      'ja': 'Ashlar Gneiss Door',
    }, {
      'id': 'AshlarGneissFireplaceItem',
      'en': 'Ashlar Gneiss Fireplace',
      'fr': 'Cheminée en gneiss taillé',
      'es': 'Chimenea (sillar de gneis)',
      'de': 'Gneisquaderfeuerstelle',
      'pl': 'Kominek z ciosanego gnejsu',
      'ru': 'Камин из резного гнейса',
      'uk': 'Камін з обтесаного гнейсу',
      'ko': '각진 편마암 벽난로',
      'zh': '阿什拉尔片麻岩壁炉',
      'ja': 'Ashlar Gneiss Fireplace',
    }, {
      'id': 'AshlarGneissTableItem',
      'en': 'Ashlar Gneiss Table',
      'fr': 'Table en gneiss taillé',
      'es': 'Mesa (sillar de gneis)',
      'de': 'Gneisquadertisch',
      'pl': 'Stół z ciosanego gnejsu',
      'ru': 'Стол из резного гнейса',
      'uk': 'Стіл з обтесаного гнейсу',
      'ko': '각진 편마암 탁자',
      'zh': '阿什拉尔片麻岩桌',
      'ja': 'Ashlar Gneiss Table',
    }, {
      'id': 'AshlarGraniteItem',
      'en': 'Ashlar Granite',
      'fr': 'Granite taillé',
      'es': 'Sillar de granito',
      'de': 'Quader aus Granit',
      'pl': 'Ciosany granit',
      'ru': 'Резной гранит',
      'uk': 'Різьблений Граніт',
      'ko': '각진 화강암',
      'zh': '阿什拉尔花岗岩',
      'ja': 'Ashlar Granite',
    }, {
      'id': 'AshlarGraniteBenchItem',
      'en': 'Ashlar Granite Bench',
      'fr': 'Banc en granite taillé',
      'es': 'Banco (sillar de granito)',
      'de': 'Granitquaderbank',
      'pl': 'Ławka z ciosanego granitu',
      'ru': 'Лавка из резного гранита',
      'uk': 'Лавка з обтесаного граніту',
      'ko': '각진 화강암 벤치',
      'zh': '阿什拉尔花岗岩长凳',
      'ja': 'Ashlar Granite Bench',
    }, {
      'id': 'AshlarGraniteChairItem',
      'en': 'Ashlar Granite Chair',
      'fr': 'Chaise en granite taillé',
      'es': 'Silla (sillar de granito)',
      'de': 'Granitquaderstuhl',
      'pl': 'Krzesło z ciosanego granitu',
      'ru': 'Стул из резного гранита',
      'uk': 'Стілець з обтесаного граніту',
      'ko': '각진 화강암 의자',
      'zh': '阿什拉尔花岗岩椅子',
      'ja': 'Ashlar Granite Chair',
    }, {
      'id': 'AshlarGraniteDoorItem',
      'en': 'Ashlar Granite Door',
      'fr': 'Porte en granit taillé',
      'es': 'Puerta (sillar de granito)',
      'de': 'Granitquadertür',
      'pl': 'Ciosane granitowe drzwi',
      'ru': 'Дверь из резного гранита',
      'uk': 'Двері з обтесаного граніту',
      'ko': '각진 화강암 문',
      'zh': '阿什拉尔花岗岩门',
      'ja': 'Ashlar Granite Door',
    }, {
      'id': 'AshlarGraniteFireplaceItem',
      'en': 'Ashlar Granite Fireplace',
      'fr': 'Cheminée en granite taillé',
      'es': 'Chimenea (sillar de granito)',
      'de': 'Granitquaderfeuerstelle',
      'pl': 'Kominek z ciosanego granitu',
      'ru': 'Камин из резного гранита',
      'uk': 'Камін з обтесаного граніту',
      'ko': '각진 화강암 벽난로',
      'zh': '阿什拉尔花岗岩壁炉',
      'ja': 'Ashlar Granite Fireplace',
    }, {
      'id': 'AshlarGraniteTableItem',
      'en': 'Ashlar Granite Table',
      'fr': 'Table en granite taillé',
      'es': 'Mesa (sillar de arenisca)',
      'de': 'Granitquadertisch',
      'pl': 'Stół z ciosanego granitu',
      'ru': 'Стол из резного гранита',
      'uk': 'Стіл з обтесаного граніту',
      'ko': '각진 화강암 탁자',
      'zh': '花岗岩桌子',
      'ja': 'Ashlar Granite Table',
    }, {
      'id': 'AshlarLargeBasaltFountainItem',
      'en': 'Ashlar Large Basalt Fountain',
      'fr': 'Grande fontaine en basalte taillé',
      'es': 'Fuente grande (sillar de basalto)',
      'de': 'Großer Basaltquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego bazaltu',
      'ru': 'Фонтан из резного базальта',
      'uk': 'Великий фонтан з обтесаного базальту',
      'ko': '각진 현무함 대형분수',
      'zh': '大型阿什拉尔型玄武岩喷泉',
      'ja': 'Ashlar Large Basalt Fountain',
    }, {
      'id': 'AshlarLargeGneissFountainItem',
      'en': 'Ashlar Large Gneiss Fountain',
      'fr': 'Grande fontaine en gneiss taillé',
      'es': 'Fuente grande (sillar de gneis)',
      'de': 'Großer Gneisquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego gnejsu',
      'ru': 'Фонтан из резного гнейса',
      'uk': 'Великий фонтан з обтесаного гнейсу',
      'ko': '각진 편마암 대형분수',
      'zh': '大型阿什拉尔片麻岩喷泉',
      'ja': 'Ashlar Large Gneiss Fountain',
    }, {
      'id': 'AshlarLargeGraniteFountainItem',
      'en': 'Ashlar Large Granite Fountain',
      'fr': 'Grande fontaine en granite taillé',
      'es': 'Fuente grande (sillar de granito)',
      'de': 'Großer Granitquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego granitu',
      'ru': 'Фонтан из резного гранита',
      'uk': 'Великий фонтан з обтесаного граніту',
      'ko': '각진 화강암 대형분수',
      'zh': '大型阿什拉尔型花岗岩喷泉',
      'ja': 'Ashlar Large Granite Fountain',
    }, {
      'id': 'AshlarLargeLimestoneFountainItem',
      'en': 'Ashlar Large Limestone Fountain',
      'fr': 'Grande fontaine en calcaire taillé',
      'es': 'Fuente grande (sillar de piedra caliza)',
      'de': 'Großer Kalksteinquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego wapienia',
      'ru': 'Фонтан из резного известняка',
      'uk': 'Великий фонтан з обтесаного вапняку',
      'ko': '각진 석회암 대형분수',
      'zh': '大型阿什拉尔型石灰石喷泉',
      'ja': 'Ashlar Large Limestone Fountain',
    }, {
      'id': 'AshlarLargeSandstoneFountainItem',
      'en': 'Ashlar Large Sandstone Fountain',
      'fr': 'Grande fontaine en grès taillé',
      'es': 'Fuente grande (sillar de arenisca)',
      'de': 'Großer Sandsteinquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego piaskowca',
      'ru': 'Фонтан из резного песчаника',
      'uk': 'Великий фонтан з обтесаного пісковику',
      'ko': '각진 사암 대형분수',
      'zh': '大型阿什拉尔型砂岩喷泉',
      'ja': 'Ashlar Large Sandstone Fountain',
    }, {
      'id': 'AshlarLargeShaleFountainItem',
      'en': 'Ashlar Large Shale Fountain',
      'fr': 'Grande fontaine en schiste taillé',
      'es': 'Fuente grande de pizarra (sillar)',
      'de': 'Großer Schieferquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego łupku',
      'ru': 'Фонтан из резного сланца',
      'uk': 'Великий фонтан з обтесаного сланцю',
      'ko': '각진 이판암 대형분수',
      'zh': '大型阿什拉尔型页岩喷泉',
      'ja': 'Ashlar Large Shale Fountain',
    }, {
      'id': 'AshlarLargeStoneFountainItem',
      'en': 'Ashlar Large Stone Fountain',
      'fr': 'Grande fontaine en pierre taillée',
      'es': 'Fuente grande (sillar de piedra)',
      'de': 'Großer Steinquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego kamienia',
      'ru': 'Фонтан из резного камня',
      'uk': 'Великий фонтан з обтесаного каменю',
      'ko': '각진 석재 대형분수',
      'zh': '大型阿什拉尔型石喷泉',
      'ja': 'Ashlar Large Stone Fountain',
    }, {
      'id': 'AshlarLimestoneItem',
      'en': 'Ashlar Limestone',
      'fr': 'Calcaire taillé',
      'es': 'Sillar de piedra caliza',
      'de': 'Quader aus Kalkstein',
      'pl': 'Ciosany wapień',
      'ru': 'Резной известняк',
      'uk': 'Різьблений Вапняк',
      'ko': '각진 석회암',
      'zh': '阿什拉尔石灰石',
      'ja': 'Ashlar Limestone',
    }, {
      'id': 'AshlarLimestoneBenchItem',
      'en': 'Ashlar Limestone Bench',
      'fr': 'Banc en calcaire taillé',
      'es': 'Banco (sillar de piedra caliza)',
      'de': 'Kalksteinquaderbank',
      'pl': 'Ławka z ciosanego kamienia',
      'ru': 'Лавка из резного известняка',
      'uk': 'Лавка з облицювального вапняку',
      'ko': '각진 석회암 벤치',
      'zh': '阿什拉尔石灰石长凳',
      'ja': 'Ashlar Limestone Bench',
    }, {
      'id': 'AshlarLimestoneChairItem',
      'en': 'Ashlar Limestone Chair',
      'fr': 'Chaise en calcaire taillé',
      'es': 'Silla (sillar de piedra caliza)',
      'de': 'Kalksteinquaderstuhl',
      'pl': 'Krzesło z ciosanego wapienia',
      'ru': 'Стул из резного известняка',
      'uk': 'Стілець із облицювального вапняку',
      'ko': '각진 석회암 의자',
      'zh': '阿什拉尔石灰石椅子',
      'ja': 'Ashlar Limestone Chair',
    }, {
      'id': 'AshlarLimestoneDoorItem',
      'en': 'Ashlar Limestone Door',
      'fr': 'Porte en pierre calcaire',
      'es': 'Puerta (sillar de piedra caliza)',
      'de': 'Kalksteinquadertür',
      'pl': 'Ciosane wapienne drzwi',
      'ru': 'Дверь из резного известняка',
      'uk': 'Двері з обтесаного вапняку',
      'ko': '각진 석회암 문',
      'zh': '阿什拉尔石灰石门',
      'ja': 'Ashlar Limestone Door',
    }, {
      'id': 'AshlarLimestoneFireplaceItem',
      'en': 'Ashlar Limestone Fireplace',
      'fr': 'Cheminée en calcaire taillé',
      'es': 'Chimenea (sillar de piedra caliza)',
      'de': 'Kalksteinquaderfeuerstelle',
      'pl': 'Kominek z ciosanego wapienia',
      'ru': 'Камин из обработанного известняка',
      'uk': 'Камін із облицювального вапняку',
      'ko': '각진 석회암 벽난로',
      'zh': '阿什拉尔石灰石壁炉',
      'ja': 'Ashlar Limestone Fireplace',
    }, {
      'id': 'AshlarLimestoneTableItem',
      'en': 'Ashlar Limestone Table',
      'fr': 'Table en calcaire taillé',
      'es': 'Mesa (sillar de piedra caliza)',
      'de': 'Kalksteinquadertisch',
      'pl': 'Stół z ciosanego wapienia',
      'ru': 'Стол из резного известняка',
      'uk': 'Стіл із облицювального вапняку',
      'ko': '각진 석회암 탁자',
      'zh': '阿什拉尔石灰石桌',
      'ja': 'Ashlar Limestone Table',
    }, {
      'id': 'AshlarSandstoneItem',
      'en': 'Ashlar Sandstone',
      'fr': 'Grès taillé',
      'es': 'Sillar de arenisca',
      'de': 'Quader aus Sandstein',
      'pl': 'Ciosany piaskowiec',
      'ru': 'Резной песчаник',
      'uk': ' Обтесаний піщаник',
      'ko': '각진 사암',
      'zh': '阿什拉尔砂岩',
      'ja': 'Ashlar Sandstone',
    }, {
      'id': 'AshlarSandstoneBenchItem',
      'en': 'Ashlar Sandstone Bench',
      'fr': 'Banc en grès taillé',
      'es': 'Banco (sillar de arenisca)',
      'de': 'Sandsteinquaderbank',
      'pl': 'Ławka z ciosanego piaskowca',
      'ru': 'Лавка из резного песчаника',
      'uk': 'Лавка з облицювального пісковику',
      'ko': '각진 사암 벤치',
      'zh': '阿什拉尔砂岩长凳',
      'ja': 'Ashlar Sandstone Bench',
    }, {
      'id': 'AshlarSandstoneChairItem',
      'en': 'Ashlar Sandstone Chair',
      'fr': 'Chaise en grès taillé',
      'es': 'Silla (sillar de arenisca)',
      'de': 'Sandsteinquaderstuhl',
      'pl': 'Krzesło z ciosanego piaskowca',
      'ru': 'Стул из резного песчаника',
      'uk': 'Стілець із облицювального пісковику',
      'ko': '각진 사암 의자',
      'zh': '阿什拉尔砂岩椅',
      'ja': 'Ashlar Sandstone Chair',
    }, {
      'id': 'AshlarSandstoneDoorItem',
      'en': 'Ashlar Sandstone Door',
      'fr': 'Porte en grès taillé',
      'es': 'Puerta (sillar de arenisca)',
      'de': 'Sandsteinquadertür',
      'pl': 'Ciosane piaskowcowe drzwi',
      'ru': 'Дверь из резного песчаника',
      'uk': 'Двері з обтесаного піщаника',
      'ko': '각진 사암 문',
      'zh': '阿什拉尔砂岩门',
      'ja': 'Ashlar Sandstone Door',
    }, {
      'id': 'AshlarSandstoneFireplaceItem',
      'en': 'Ashlar Sandstone Fireplace',
      'fr': 'Cheminée en grès taillé',
      'es': 'Chimenea (sillar de arenisca)',
      'de': 'Sandsteinquaderfeuerstellen',
      'pl': 'Kominek z ciosanego piaskowca',
      'ru': 'Камин из резного песчаника',
      'uk': 'Камін із облицювального пісковику',
      'ko': '각진 사암 벽난로',
      'zh': '阿什拉尔砂岩壁炉',
      'ja': 'Ashlar Sandstone Fireplace',
    }, {
      'id': 'AshlarSandstoneTableItem',
      'en': 'Ashlar Sandstone Table',
      'fr': 'Table en grès taillé',
      'es': 'Mesa (sillar de arenisca)',
      'de': 'Sandsteinquadertisch',
      'pl': 'Stół z ciosanego piaskowca',
      'ru': 'Стол из резного песчаника',
      'uk': 'Стіл з обтесаного пісковику',
      'ko': '각진 사암 탁자',
      'zh': '阿什拉尔砂岩桌',
      'ja': 'Ashlar Sandstone Table',
    }, {
      'id': 'AshlarShaleItem',
      'en': 'Ashlar Shale',
      'fr': 'Schiste taillé',
      'es': 'Pizarra (sillar)',
      'de': 'Quader aus Schiefer',
      'pl': 'Ciosany łupek',
      'ru': 'Резной сланец',
      'uk': 'Обтесаний сланець',
      'ko': '각진 이판암',
      'zh': '阿什拉尔页岩',
      'ja': 'Ashlar Shale',
    }, {
      'id': 'AshlarShaleBenchItem',
      'en': 'Ashlar Shale Bench',
      'fr': 'Banc en schiste taillé',
      'es': 'Banco de pizarra (sillar)',
      'de': 'Schieferquaderbank',
      'pl': 'Ławka z ciosanego łupka',
      'ru': 'Лавка из резного сланца',
      'uk': 'Лавка з обтесаного сланцю',
      'ko': '각진 이판암 벤치',
      'zh': '阿什拉尔页岩长凳',
      'ja': 'Ashlar Shale Bench',
    }, {
      'id': 'AshlarShaleChairItem',
      'en': 'Ashlar Shale Chair',
      'fr': 'Chaise en schiste taillé',
      'es': 'Silla de pizarra (sillar)',
      'de': 'Schieferquaderbank',
      'pl': 'Krzesło z ciosanego łupka',
      'ru': 'Стул из резного сланца',
      'uk': 'Стілець з обтесаного сланцю',
      'ko': '각진 이판암 의자',
      'zh': '阿什拉尔页岩椅',
      'ja': 'Ashlar Shale Chair',
    }, {
      'id': 'AshlarShaleDoorItem',
      'en': 'Ashlar Shale Door',
      'fr': 'Porte en schiste taillé',
      'es': 'Puerta de pizarra (sillar)',
      'de': 'Schieferquadertür',
      'pl': 'Drzwi z ciosanego łupka',
      'ru': 'Дверь из резного сланца',
      'uk': 'Двері з обтесаного сланцю',
      'ko': '각진 이판암 문',
      'zh': '阿什拉尔页岩门',
      'ja': 'Ashlar Shale Door',
    }, {
      'id': 'AshlarShaleFireplaceItem',
      'en': 'Ashlar Shale Fireplace',
      'fr': 'Cheminée en schiste taillé',
      'es': 'Chimenea de pizarra (sillar)',
      'de': 'Schieferquaderfeuerstelle',
      'pl': 'Kominek z ciosanego łupka',
      'ru': 'Камин из резного сланца',
      'uk': 'Камін з обтесаного сланцю',
      'ko': '각진 이판암 벽난로',
      'zh': '阿什拉尔页岩壁炉',
      'ja': 'Ashlar Shale Fireplace',
    }, {
      'id': 'AshlarShaleTableItem',
      'en': 'Ashlar Shale Table',
      'fr': 'Table en schiste taillé',
      'es': 'Mesa de pizarra (sillar)',
      'de': 'Schieferquadertisch',
      'pl': 'Stół z ciosanego łupka',
      'ru': 'Стол из резного сланца',
      'uk': 'Стіл з обтесаного сланцю',
      'ko': '각진 이판암 탁자',
      'zh': '阿什拉尔页岩台',
      'ja': 'Ashlar Shale Table',
    }, {
      'id': 'AshlarSmallBasaltFountainItem',
      'en': 'Ashlar Small Basalt Fountain',
      'fr': 'Petite fontaine en basalte taillé',
      'es': 'Fuente pequeña de basalto (sillar)',
      'de': 'Kleiner Basaltquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego bazaltu',
      'ru': 'Маленький фонтан из резного базальта',
      'uk': 'Малий фонтан з обтесаного базальту',
      'ko': '각진 현무암 소형분수',
      'zh': '小型阿什拉尔玄武岩喷泉',
      'ja': 'Ashlar Small Basalt Fountain',
    }, {
      'id': 'AshlarSmallGneissFountainItem',
      'en': 'Ashlar Small Gneiss Fountain',
      'fr': 'Petite fontaine en gneiss taillé',
      'es': 'Fuente pequeña de gneis (sillar)',
      'de': 'Kleiner Gneisquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego gnejsu',
      'ru': 'Маленький фонтан из резного гнейса',
      'uk': 'Малий фонтан з обтесаного гнейсу',
      'ko': '각진 편마암 소형분수',
      'zh': '小型阿什拉尔片麻岩喷泉',
      'ja': 'Ashlar Small Gneiss Fountain',
    }, {
      'id': 'AshlarSmallGraniteFountainItem',
      'en': 'Ashlar Small Granite Fountain',
      'fr': 'Petite fontaine en granite taillé',
      'es': 'Fuente pequeña de granito (sillar)',
      'de': 'Kleiner Granitquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego granitu',
      'ru': 'Маленький фонтан из резного гранита',
      'uk': 'Малий фонтан з обтесаного граніту',
      'ko': '각진 화강암 소형분수',
      'zh': '小型阿什拉尔花岗岩喷泉',
      'ja': 'Ashlar Small Granite Fountain',
    }, {
      'id': 'AshlarSmallLimestoneFountainItem',
      'en': 'Ashlar Small Limestone Fountain',
      'fr': 'Petite fontaine en calcaire taillé',
      'es': 'Fuente pequeña de calcita (sillar)',
      'de': 'Kleiner Kalksteinquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego wapienia',
      'ru': 'Маленький фонтан из резного известняка',
      'uk': 'Малий фонтан з обтесаного вапняку',
      'ko': '각진 석회함 소형분수',
      'zh': '小型阿什拉尔石灰石喷泉',
      'ja': 'Ashlar Small Limestone Fountain',
    }, {
      'id': 'AshlarSmallSandstoneFountainItem',
      'en': 'Ashlar Small Sandstone Fountain',
      'fr': 'Petite fontaine en grès taillé',
      'es': 'Fuente pequeña (sillar de arenisca)',
      'de': 'Kleiner Sandsteinquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego piaskowca',
      'ru': 'Маленький фонтан из резного песчаника',
      'uk': 'Малий фонтан з обтесаного пісковику',
      'ko': '각진 사암 소형분수',
      'zh': '小型阿什拉尔砂岩喷泉',
      'ja': 'Ashlar Small Sandstone Fountain',
    }, {
      'id': 'AshlarSmallShaleFountainItem',
      'en': 'Ashlar Small Shale Fountain',
      'fr': 'Petite fontaine en schiste taillé',
      'es': 'Fuente pequeña de pizarra (sillar)',
      'de': 'Kleiner Schieferquaderbrunnen',
      'pl': 'Mała fontanna z ciosanego łupku',
      'ru': 'Маленький фонтан из резного сланца',
      'uk': 'Малий фонтан з обтесаного сланцю',
      'ko': '각진 소형 이판암 분수',
      'zh': '小型阿什拉尔页岩喷泉',
      'ja': 'Ashlar Small Shale Fountain',
    }, {
      'id': 'AshlarSmallStoneFountainItem',
      'en': 'Ashlar Small Stone Fountain',
      'fr': 'Petite fontaine en pierre taillée',
      'es': 'Fuente pequeña de piedra (sillar)',
      'de': 'Kleiner Quadersteinbrunnen',
      'pl': 'Mała fontanna z ciosanego kamienia',
      'ru': 'Маленький фонтан из резного камня',
      'uk': 'Малий фонтан з обтесаного каменю',
      'ko': '각진 석재 소형분수',
      'zh': '小型阿什拉尔石喷泉',
      'ja': 'Ashlar Small Stone Fountain',
    }, {
      'id': 'AshlarStone',
      'en': 'Ashlar Stone',
      'fr': 'Pierre taillé',
      'es': 'Sillar de piedra',
      'de': 'Quadersteine',
      'pl': 'Ciosany kamień',
      'ru': 'Резной камень',
      'uk': 'Ашларовий камінь',
      'ko': '각진 돌',
      'zh': '阿什拉尔石',
      'ja': 'Ashlar Stone',
    }, {
      'id': 'AshlarStoneBenchItem',
      'en': 'Ashlar Stone Bench',
      'fr': 'Banc en pierre taillée',
      'es': 'Banco de piedra (sillar)',
      'de': 'Quadersteinbank',
      'pl': 'Ciosana kamienna ławka',
      'ru': 'Лавка из резного камня',
      'uk': 'Лавка з обтесаного каменю',
      'ko': '각진 석재 벤치',
      'zh': '阿什拉尔石凳',
      'ja': 'Ashlar Stone Bench',
    }, {
      'id': 'AshlarStoneChairItem',
      'en': 'Ashlar Stone Chair',
      'fr': 'Chaise en pierre taillée',
      'es': 'Silla de piedra (sillar)',
      'de': 'Quadersteinstuhl',
      'pl': 'Ciosane kamienne krzesło',
      'ru': 'Стул из резного камня',
      'uk': 'Стілець з обтесаного каменю',
      'ko': '각진 석재 의자',
      'zh': '阿什拉尔石椅',
      'ja': 'Ashlar Stone Chair',
    }, {
      'id': 'AshlarStoneDoorItem',
      'en': 'Ashlar Stone Door',
      'fr': 'Porte en pierre taillée',
      'es': 'Puerta (sillar de piedra)',
      'de': 'Quadersteintür',
      'pl': 'Drzwi z ciosanego kamienia',
      'ru': 'Дверь из резного камня',
      'uk': 'Двері з обтесаного каменю',
      'ko': '각진 석재 문',
      'zh': '阿什拉尔石门',
      'ja': 'Ashlar Stone Door',
    }, {
      'id': 'AshlarStoneFireplaceItem',
      'en': 'Ashlar Stone Fireplace',
      'fr': 'Cheminée en pierre taillée',
      'es': 'Chimenea de piedra (sillar)',
      'de': 'Quadersteinfeuerstelle',
      'pl': 'Kominek z ciosanego kamienia',
      'ru': 'Камин из резного камня',
      'uk': 'Камін з обтесаного каменю',
      'ko': '각진 석재 벽난로',
      'zh': '阿什拉尔石壁炉',
      'ja': 'Ashlar Stone Fireplace',
    }, {
      'id': 'AshlarStoneTableItem',
      'en': 'Ashlar Stone Table',
      'fr': 'Table en pierre taillée',
      'es': 'Mesa de piedra (sillar)',
      'de': 'Quadersteintisch',
      'pl': 'Stół z ciosanego kamienia',
      'ru': 'Стол из резного камня',
      'uk': 'Стіл з обтесаного каменю',
      'ko': '각진 석재 탁자',
      'zh': '阿什拉尔石桌',
      'ja': 'Ashlar Stone Table',
    }, {
      'id': 'AsphaltConcreteItem',
      'en': 'Asphalt Concrete',
      'fr': 'Béton à base d\u0027asphalte',
      'es': 'Hormigón asfáltico',
      'de': 'Asphaltbeton',
      'pl': 'Asphalt Concrete',
      'ru': 'Асфальтобетон',
      'uk': 'Asphalt Concrete',
      'ko': '아스팔트 콘크리트',
      'zh': '沥青混凝土',
      'ja': 'Asphalt Concrete',
    }, {
      'id': 'AssemblyLineItem',
      'en': 'Assembly Line',
      'fr': 'Ligne de Montage',
      'es': 'Línea de Ensamblaje',
      'de': 'Mechanische Fertigungsstraße',
      'pl': 'Linia Produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія для збору',
      'ko': '조립 라인',
      'zh': '装配线',
      'ja': '組立ライン',
    }, {
      'id': 'AutomaticLoomItem',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar mecánico',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatic Loom',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Automatic Loom',
      'ko': '자동 베틀',
      'zh': '自动织布机',
      'ja': 'Automatic Loom',
    }, {
      'id': 'AutumnStewItem',
      'en': 'Autumn Stew',
      'fr': 'Ragoût d\u0027automne',
      'es': 'Estofado otoñal',
      'de': 'Herbsteintopf',
      'pl': 'Autumn Stew',
      'ru': 'Осеннее рагу',
      'uk': 'Autumn Stew',
      'ko': 'Autumn Stew',
      'zh': '秋季炖汤',
      'ja': 'Autumn Stew',
    }, {
      'id': 'AxeItem',
      'en': 'Axe',
      'fr': 'Hache',
      'es': 'Hacha',
      'de': 'Axt',
      'pl': 'Siekiera',
      'ru': 'Топор',
      'uk': 'Сокира',
      'ko': '도끼',
      'zh': '斧',
      'ja': 'オノ',
    }, {
      'id': 'BakedAgaveItem',
      'en': 'Baked Agave',
      'fr': 'Agave cuit',
      'es': 'Agave cocinado',
      'de': 'Gebackene Agave',
      'pl': 'Pieczona agawa',
      'ru': 'Запечённая агава',
      'uk': 'Запечена агава',
      'ko': '구운 용설란',
      'zh': '烘焙过的龙舌兰',
      'ja': '焼いたリュウゼツラン',
    }, {
      'id': 'BakedBeetItem',
      'en': 'Baked Beet',
      'fr': 'Betterave cuite',
      'es': 'Remolacha horneada',
      'de': 'Gebackene Rote Bete',
      'pl': 'Pieczony burak',
      'ru': 'Запечённая свекла',
      'uk': 'Запечений буряк',
      'ko': '구운 사탕무',
      'zh': '烤甜菜',
      'ja': 'Baked Beet',
    }, {
      'id': 'BakedCornItem',
      'en': 'Baked Corn',
      'fr': 'Maïs cuit',
      'es': 'Maíz horneado',
      'de': 'Gebackener Mais',
      'pl': 'Upieczona kukurydza',
      'ru': 'Запечённая кукуруза',
      'uk': 'Запечена кукурудза',
      'ko': '구운 옥수수',
      'zh': '烤玉米',
      'ja': 'Baked Corn',
    }, {
      'id': 'BakedHeartOfPalmItem',
      'en': 'Baked Heart Of Palm',
      'fr': 'Cœur de palmier cuit',
      'es': 'Palmito horneado',
      'de': 'Gebackene Palmherzen',
      'pl': 'Upieczone serce palmy',
      'ru': 'Запечённая сердцевина пальмы',
      'uk': 'Запечена серцевина пальми',
      'ko': '구운 대추야자 나무순',
      'zh': '掌心焗',
      'ja': 'Baked Heart Of Palm',
    }, {
      'id': 'BakedMeatItem',
      'en': 'Baked Meat',
      'fr': 'Viande cuite',
      'es': 'Carne Horneada',
      'de': 'Gebackenes Fleisch',
      'pl': 'Pieczone mięso',
      'ru': 'Запечённое мясо',
      'uk': 'Запечене м’ясо',
      'ko': '구운 고기',
      'zh': '熟肉',
      'ja': '焼いた肉',
    }, {
      'id': 'BakedRoastItem',
      'en': 'Baked Roast',
      'fr': 'Rôti cuit',
      'es': 'Asado Horneado',
      'de': 'Gebackener Braten',
      'pl': 'Zapiekana pieczeń',
      'ru': 'Запечённое жаркое',
      'uk': 'Запечена печеня',
      'ko': '구운 구이용 고기',
      'zh': '熟烤肉',
      'ja': '焼きたてのロースト',
    }, {
      'id': 'BakedTaroItem',
      'en': 'Baked Taro',
      'fr': 'Taro cuit',
      'es': 'Taro cocinado',
      'de': 'Gebackene Taro',
      'pl': 'Upieczone taro',
      'ru': 'Запечённый корень таро',
      'uk': 'Печений дашин',
      'ko': '구운 토란',
      'zh': '烤芋头',
      'ja': 'Baked Taro',
    }, {
      'id': 'BakedTomatoItem',
      'en': 'Baked Tomato',
      'fr': 'Tomate cuite',
      'es': 'Tomate horneado',
      'de': 'Gebackene Tomaten',
      'pl': 'Pieczony pomidor',
      'ru': 'Запеченный помидор',
      'uk': 'Печений томат',
      'ko': '구운 토마토',
      'zh': '烤番茄',
      'ja': 'Baked Tomato',
    }, {
      'id': 'BakedVegetable',
      'en': 'Baked Vegetable',
      'fr': 'Légume cuit',
      'es': 'Vegetal horneado',
      'de': 'Gebackenes Gemüse',
      'pl': 'Pieczone warzywo',
      'ru': 'Запеченные овощи',
      'uk': 'Запечений овоч',
      'ko': '구운 야채',
      'zh': '烤蔬菜',
      'ja': 'Baked Vegetable',
    }, {
      'id': 'BakeryOvenItem',
      'en': 'Bakery Oven',
      'fr': 'Four à pain',
      'es': 'Horno de Panadería',
      'de': 'Bäckereiofen',
      'pl': 'Piec piekarniczy',
      'ru': 'Печь для выпечки',
      'uk': 'Піч для випічки',
      'ko': '제빵 화덕',
      'zh': '烤炉',
      'ja': 'ベーカリーオーブン',
    }, {
      'id': 'BakingUpgradeItem',
      'en': 'Baking Upgrade',
      'fr': 'Amélioration Avancée : Boulangerie',
      'es': 'Mejora: Horneado',
      'de': 'Fortschrittliches Upgrade: Backen',
      'pl': 'Ulepszenie Pieczenia',
      'ru': 'Улучшение для выпечки',
      'uk': 'Покращення випічки',
      'ko': '제빵 기술 업그레이드',
      'zh': '烘烤升级',
      'ja': 'Baking Upgrade',
    }, {
      'id': 'BallotBoxItem',
      'en': 'Ballot Box',
      'fr': 'Urne électorale',
      'es': 'Urna electoral',
      'de': 'Wahlurne',
      'pl': 'Urna wyborcza',
      'ru': 'Урна для голосования',
      'uk': 'Урна для голосовуння',
      'ko': '투표함',
      'zh': '选票箱',
      'ja': 'Ballot Box',
    }, {
      'id': 'BandanaItem',
      'en': 'Bandana',
      'fr': 'Bandana',
      'es': 'Bandana',
      'de': 'Bandana',
      'pl': 'Bandana',
      'ru': 'Бандана',
      'uk': 'Бандана',
      'ko': '반다나',
      'zh': '头巾',
      'ja': 'Bandana',
    }, {
      'id': 'BanhXeoItem',
      'en': 'Banh Xeo',
      'fr': 'Crêpe vietnamienne',
      'es': 'Banh Xeo',
      'de': 'Banh Xeo',
      'pl': 'Banh Xeo',
      'ru': 'Блинчики Бан Хео',
      'uk': 'Banh Xeo',
      'ko': 'Banh Xeo',
      'zh': '越南煎饼',
      'ja': 'Banh Xeo',
    }, {
      'id': 'BankItem',
      'en': 'Bank',
      'fr': 'Banque',
      'es': 'Banco',
      'de': 'Banktresor',
      'pl': 'Bank',
      'ru': 'Банк',
      'uk': 'Банк',
      'ko': '은행',
      'zh': '银行',
      'ja': '銀行',
    }, {
      'id': 'BannockItem',
      'en': 'Bannock',
      'fr': 'Bannique',
      'es': 'Bannock',
      'de': 'Lagerfeuerbrot',
      'pl': 'Placek pszenny',
      'ru': 'Пресная лепёшка',
      'uk': 'Коржик',
      'ko': '과자빵',
      'zh': '麦饼',
      'ja': 'Placek mączny',
    }, {
      'id': 'BarrelItem',
      'en': 'Barrel',
      'fr': 'Tonneau',
      'es': 'Barril',
      'de': 'Fass',
      'pl': 'Beczka',
      'ru': 'Бочка',
      'uk': 'Діжка',
      'ko': '배럴통',
      'zh': '桶',
      'ja': 'ドラム缶',
    }, {
      'id': 'BarrelCactusSeedItem',
      'en': 'Barrel Cactus Seed',
      'fr': 'Graine de coussin de belle-mère',
      'es': 'Semilla de cactus erizo',
      'de': 'Samen (Kugelkaktus)',
      'pl': 'Nasiona okrągłego kaktusa',
      'ru': 'Семечко бочкообразного кактуса',
      'uk': 'Насіння діжкового кактуса',
      'ko': '고슴도치 선인장 씨앗',
      'zh': '桶形仙人掌种子',
      'ja': 'バレルサボテンの種',
    }, {
      'id': 'BasaltItem',
      'en': 'Basalt',
      'fr': 'Basalte',
      'es': 'Basalto',
      'de': 'Basalt',
      'pl': 'Basalt',
      'ru': 'Базальт',
      'uk': 'Базальт',
      'ko': '현무암',
      'zh': '玄武岩',
      'ja': '玄武岩',
    }, {
      'id': 'BasicBackpackItem',
      'en': 'Basic Backpack',
      'fr': 'Sac à dos basique',
      'es': 'Mochila básica',
      'de': 'Einfacher Rucksack',
      'pl': 'Zwykły Plecak',
      'ru': 'Простой рюкзак',
      'uk': 'Звичайний рюкзак',
      'ko': '기본 배낭',
      'zh': '基础背包',
      'ja': 'ベーシックバックパック',
    }, {
      'id': 'BasicCircuitItem',
      'en': 'Basic Circuit',
      'fr': 'Circuit basique',
      'es': 'Circuito básico',
      'de': 'Einfacher Schaltkreis',
      'pl': 'Podstawowy obwód',
      'ru': 'Базовая электросхема',
      'uk': 'Базова електросхема',
      'ko': '기초 회로',
      'zh': '基础电路',
      'ja': 'Basic Circuit',
    }, {
      'id': 'BasicEngineeringUpgradeItem',
      'en': 'Basic Engineering Upgrade',
      'fr': 'Amélioration Basique : Ingénierie basique',
      'es': 'Mejora básica: Ingeniería',
      'de': 'Grundlegendes Upgrade: Grundlegende Technik',
      'pl': 'Podstawowe ulepszenie Inżynierii',
      'ru': 'Улучшение для основ инженерного дела',
      'uk': 'Базове покращення інженерії',
      'ko': '기초 기계공학 기술 업그레이드',
      'zh': '基础工程升级',
      'ja': 'Basic Engineering Upgrade',
    }, {
      'id': 'Basic Research',
      'en': 'Basic Research',
      'fr': 'Recherche Basique',
      'es': 'Investigación básica',
      'de': 'Grundlagenforschung',
      'pl': 'Podstawowe badanie',
      'ru': 'Базовое исследование',
      'uk': 'Базове дослідження',
      'ko': '기초 연구',
      'zh': '基础研究',
      'ja': 'Basic Research',
    }, {
      'id': 'BasicSaladItem',
      'en': 'Basic Salad',
      'fr': 'Salade basique',
      'es': 'Ensalada Básica',
      'de': 'Einfacher Salat',
      'pl': 'Prosta sałatka',
      'ru': 'Простой салат',
      'uk': 'Простий салат',
      'ko': '평범한 샐러드',
      'zh': '简单沙拉',
      'ja': '普通のサラダ',
    }, {
      'id': 'BasicUpgradeLvl1Item',
      'en': 'Basic Upgrade 1',
      'fr': 'Amélioration Basique Nv1',
      'es': 'Mejora básica 1',
      'de': 'Grundlegendes Upgrade 1',
      'pl': 'Podstawowe ulepszenie 1',
      'ru': 'Базовое улучшение 1',
      'uk': 'Базове покращення 1',
      'ko': '기초 업그레이드 1',
      'zh': '基础升级1',
      'ja': '基礎アップグレード1',
    }, {
      'id': 'BasicUpgradeLvl2Item',
      'en': 'Basic Upgrade 2',
      'fr': 'Amélioration Basique Nv2',
      'es': 'Mejora básica 2',
      'de': 'Grundlegendes Upgrade 2',
      'pl': 'Podstawowe ulepszenie 2',
      'ru': 'Базовое улучшение 2',
      'uk': 'Базове покращення 2',
      'ko': '기초 업그레이드 2',
      'zh': '基础升级2',
      'ja': '基礎アップグレード2',
    }, {
      'id': 'BasicUpgradeLvl3Item',
      'en': 'Basic Upgrade 3',
      'fr': 'Amélioration Basique Nv3',
      'es': 'Mejora básica 3',
      'de': 'Grundlegendes Upgrade 3',
      'pl': 'Podstawowe ulepszenie 3',
      'ru': 'Базовое улучшение 3',
      'uk': 'Базове покращення 3',
      'ko': '기초 업그레이드 3',
      'zh': '基础升级3',
      'ja': '基礎アップグレード3',
    }, {
      'id': 'BasicUpgradeLvl4Item',
      'en': 'Basic Upgrade 4',
      'fr': 'Amélioration Basique Nv4',
      'es': 'Mejora básica 4',
      'de': 'Grundlegendes Upgrade 4',
      'pl': 'Podstawowe ulepszenie 4',
      'ru': 'Базовое улучшение 4',
      'uk': 'Базове покращення 4',
      'ko': '기초 업그레이드 4',
      'zh': '基础升级4',
      'ja': '基礎アップグレード4',
    }, {
      'id': 'BassItem',
      'en': 'Bass',
      'fr': 'Bar',
      'es': 'Lubina',
      'de': 'Barsch',
      'pl': 'Okoń',
      'ru': 'Окунь',
      'uk': 'Морський окунь',
      'ko': '큰입우럭',
      'zh': '鲈鱼',
      'ja': 'Bass',
    }, {
      'id': 'BathtubItem',
      'en': 'Bathtub',
      'fr': 'Baignoire',
      'es': 'Bañera',
      'de': 'Badewanne',
      'pl': 'Wanna',
      'ru': 'Ванна',
      'uk': 'Ванна',
      'ko': '욕조',
      'zh': '浴缸',
      'ja': 'Bathtub',
    }, {
      'id': 'BeanPasteItem',
      'en': 'Bean Paste',
      'fr': 'Pâte de haricots',
      'es': 'Pasta de Judías',
      'de': 'Bohnenpaste',
      'pl': 'Pasta z fasoli',
      'ru': 'Бобовая паста',
      'uk': 'Паста з бобів',
      'ko': '갈린 콩',
      'zh': '豆浆',
      'ja': 'ペースト状の豆',
    }, {
      'id': 'BeanSproutItem',
      'en': 'Bean Sprout',
      'fr': 'Pousses de haricots',
      'es': 'Germinado de Judías',
      'de': 'Bohnensprosse',
      'pl': 'Bean Sprout',
      'ru': 'Бобовый росток',
      'uk': 'Bean Sprout',
      'ko': '콩 새싹',
      'zh': '豆芽菜',
      'ja': 'Bean Sprout',
    }, {
      'id': 'BeansItem',
      'en': 'Beans',
      'fr': 'Haricots',
      'es': 'Frijoles',
      'de': 'Bohnen',
      'pl': 'Fasola',
      'ru': 'Бобы',
      'uk': 'Квасоля',
      'ko': '콩',
      'zh': '豆',
      'ja': '豆',
    }, {
      'id': 'BearSUPREMEItem',
      'en': 'Bear S U P R E M E',
      'fr': 'Suprême d\u0027ours',
      'es': 'Oso S U P R E M O',
      'de': 'Bärensteak',
      'pl': 'Nedzwiedź S U P R E M E',
      'ru': 'Блюдо «Матёрый медведь»',
      'uk': 'Ведмежий стейк',
      'ko': '쩔어주는 곰기',
      'zh': '顶级熊肉',
      'ja': 'クマのS U P R E M E',
    }, {
      'id': 'BearclawItem',
      'en': 'Bearclaw',
      'fr': 'Gâteau patte d\u0027ours',
      'es': 'Pastel Garra de Oso',
      'de': 'Bärenklaue',
      'pl': 'Niedźwiadka',
      'ru': 'Пирог «Медвежий коготь»',
      'uk': 'Пиріг «Ведмежий кіготь»',
      'ko': '곰 발톱 빵',
      'zh': '熊爪包',
      'ja': 'ベアクロウ',
    }, {
      'id': 'BearpackItem',
      'en': 'Bearpack',
      'fr': 'Sac à d\u0027ours',
      'es': 'Mochila de Oso',
      'de': 'Bärenrucksack',
      'pl': 'Plecak Olbrzymi',
      'ru': 'Медвежий рюкзак',
      'uk': 'Величезний наплічник',
      'ko': '곰낭',
      'zh': '熊背包',
      'ja': '巨大なバックパック',
    }, {
      'id': 'BeetItem',
      'en': 'Beet',
      'fr': 'Betterave',
      'es': 'Remolacha',
      'de': 'Rübe',
      'pl': 'Burak',
      'ru': 'Свёкла',
      'uk': 'Буряк',
      'ko': '사탕무',
      'zh': '甜菜',
      'ja': 'ビート',
    }, {
      'id': 'BeetCampfireSaladItem',
      'en': 'Beet Campfire Salad',
      'fr': 'Salade de betteraves cuite au feu de camp',
      'es': 'Ensalada de remolacha braseada',
      'de': 'Lagefeuer Rote Bete Salat',
      'pl': 'Sałatka z grillowanego buraka',
      'ru': 'Свекольный салат на костре',
      'uk': 'Буряковий салат, приготований на багатті',
      'ko': '사탕무 모닥불 스튜',
      'zh': '甜菜篝火沙拉',
      'ja': 'Beet Campfire Salad',
    }, {
      'id': 'BeetGreensItem',
      'en': 'Beet Greens',
      'fr': 'Feuilles de betteraves',
      'es': 'Hojas de remolacha',
      'de': 'Rote Bete Blätter',
      'pl': 'Botwina',
      'ru': 'Свекольная ботва',
      'uk': 'Листя буряка',
      'ko': '사탕무 잎',
      'zh': '甜菜叶',
      'ja': 'Beet Greens',
    }, {
      'id': 'BeetSeedItem',
      'en': 'Beet Seed',
      'fr': 'Graine de betterave',
      'es': 'Semilla de remolacha',
      'de': 'Samen (Rote Bete)',
      'pl': 'Nasiona buraka',
      'ru': 'Семечко свёклы',
      'uk': 'Насіння буряка',
      'ko': '사탕무 씨앗',
      'zh': '甜菜种子',
      'ja': 'ビートの種',
    }, {
      'id': 'BerryExtractFertilizerItem',
      'en': 'Berry Extract Fertilizer',
      'fr': 'Engrais à l\u0027extrait de baies',
      'es': 'Fertilizante de Extracto de Baya',
      'de': 'Dünger aus Beerenextrakt',
      'pl': 'Nawóz z ekstraktu jagodowego',
      'ru': 'Удобрение из ягодного экстракта',
      'uk': 'Добриво з ягідного екстракту',
      'ko': '월귤나무 열매 추출물 비료',
      'zh': '浆果萃取化肥',
      'ja': 'ベリーエキスの肥料',
    }, {
      'id': 'BigBackpackItem',
      'en': 'Big Backpack',
      'fr': 'Grand sac à dos',
      'es': 'Mochila Grande',
      'de': 'Großer Rucksack',
      'pl': 'Duży Plecak',
      'ru': 'Большой рюкзак',
      'uk': 'Великий рюкзак',
      'ko': '큰 배낭',
      'zh': '大背包',
      'ja': '大きなバックパック',
    }, {
      'id': 'BigBluestemSeedItem',
      'en': 'Big Bluestem Seed',
      'fr': 'Graine de Barbon de Gerard',
      'es': 'Semilla de Andropogon',
      'de': 'Samen (Großer-Blauhalm)',
      'pl': 'Nasiono palczatki Gerarda',
      'ru': 'Семечко бородача Жерара',
      'uk': 'Насіння бороданя Жерара',
      'ko': '큰 나도기름새 씨앗',
      'zh': '大须芒草种子',
      'ja': 'ビッグブルーステムシード',
    }, {
      'id': 'BighornCarcassItem',
      'en': 'Bighorn Carcass',
      'fr': 'Cadavre de mouflon',
      'es': 'Cadáver de borrego cimarrón',
      'de': 'Dickhornschafskadaver',
      'pl': 'Tusza muflona',
      'ru': 'Туша толсторога',
      'uk': 'Туша товсторога',
      'ko': '큰뿔양 사체',
      'zh': '大角羊遗骸',
      'ja': 'ビッグホーンの死体',
    }, {
      'id': 'BiodieselItem',
      'en': 'Biodiesel',
      'fr': 'Bio-gazole',
      'es': 'Biodiésel',
      'de': 'Biodiesel',
      'pl': 'Biodisel',
      'ru': 'Биодизель',
      'uk': 'Біодизель',
      'ko': '바이오디젤',
      'zh': '生物柴油',
      'ja': 'バイオディーゼル',
    }, {
      'id': 'BirchLogItem',
      'en': 'Birch Log',
      'fr': 'Bûche de Bouleau',
      'es': 'Tronco de abedul',
      'de': 'Birkenholzstamm',
      'pl': 'Kłoda brzozy',
      'ru': 'Бревно Березы',
      'uk': 'Березова колода',
      'ko': '자작나무 통나무',
      'zh': '桦木原木',
      'ja': 'Birch Log',
    }, {
      'id': 'BirchSeedItem',
      'en': 'Birch Seed',
      'fr': 'Graine de bouleau',
      'es': 'Semilla de abedul',
      'de': 'Samen (Birke)',
      'pl': 'Nasiona Brzozy',
      'ru': 'Семечко берёзы',
      'uk': 'Насіння берези',
      'ko': '자작나무 씨앗',
      'zh': '桦树种子',
      'ja': '白樺の種',
    }, {
      'id': 'BisonCarcassItem',
      'en': 'Bison Carcass',
      'fr': 'Carcasse de bison',
      'es': 'Cadáver de bisonte',
      'de': 'Bisonkadaver',
      'pl': 'Tusza Żubra',
      'ru': 'Туша бизона',
      'uk': 'Туша бізона',
      'ko': '들소 사체',
      'zh': '野牛遗骸',
      'ja': 'バイソンの死体',
    }, {
      'id': 'BisonChowFunItem',
      'en': 'Bison Chow Fun',
      'fr': 'Bison aux nouilles',
      'es': 'Chow Fun de Bisonte',
      'de': 'Bison Kau-Genuß',
      'pl': 'Chow fun z żubra',
      'ru': 'Фан-чау из бизона',
      'uk': 'Bison Chow Fun',
      'ko': 'Bison Chow Fun',
      'zh': '野牛炒粉',
      'ja': 'Bison Chow Fun',
    }, {
      'id': 'BisonMountItem',
      'en': 'Bison Mount',
      'fr': 'Trophée de bison',
      'es': 'Soporte para bisonte',
      'de': 'Ausgestopfter Bison',
      'pl': 'Żubr Górski',
      'ru': 'Голова бизона',
      'uk': 'Голова бізона',
      'ko': '들소 벽걸이 박제',
      'zh': '野牛头壁挂',
      'ja': 'バイソンマウント',
    }, {
      'id': 'BlastFurnaceItem',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto Horno',
      'de': 'Hochofen',
      'pl': 'Piec Chutniczy',
      'ru': 'Доменная печь',
      'uk': 'Домна',
      'ko': '용광로',
      'zh': '高炉',
      'ja': '高炉',
    }, {
      'id': 'Block',
      'en': 'Block',
      'fr': 'Bloc',
      'es': 'Bloque',
      'de': 'Block',
      'pl': 'Blokada',
      'ru': 'Блок',
      'uk': 'Блок',
      'ko': '블록',
      'zh': '地块',
      'ja': 'ブロック',
    }, {
      'id': 'BloodMealFertilizerItem',
      'en': 'Blood Meal Fertilizer',
      'fr': 'Engrais à base de farine de sang',
      'es': 'Fertilizante de Harina de Sangre',
      'de': 'Dünger aus Blutmahl',
      'pl': 'Nawóz z mączki krwistej',
      'ru': 'Удобрение из кровяной муки',
      'uk': 'Добриво з кров’яного борошна',
      'ko': '혈분비료',
      'zh': '血粉化肥',
      'ja': '血粉の肥料',
    }, {
      'id': 'BloomeryItem',
      'en': 'Bloomery',
      'fr': 'Bas fourneau',
      'es': 'Horno de fundición',
      'de': 'Schmelzofen',
      'pl': 'Dymarka',
      'ru': 'Сыродутная печь',
      'uk': 'Сиродутне горно',
      'ko': '괴철로',
      'zh': '锻铁炉',
      'ja': '塊鉄炉',
    }, {
      'id': 'BlueSharkItem',
      'en': 'Blue Shark',
      'fr': 'Requin bleu',
      'es': 'Tiburón azul',
      'de': 'Blauer Hai',
      'pl': 'Żarłacz błękitny',
      'ru': 'Синяя акула',
      'uk': 'Синя акула',
      'ko': '청새리상어',
      'zh': '蓝鲨',
      'ja': 'Blue Shark',
    }, {
      'id': 'BoardItem',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Tabla',
      'de': 'Bretter',
      'pl': 'Deska',
      'ru': 'Доска',
      'uk': 'Дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': '板',
    }, {
      'id': 'WoodBoard',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Tabla',
      'de': 'Bretter',
      'pl': 'Deska',
      'ru': 'Доска',
      'uk': 'Дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': '板',
    }, {
      'id': 'BoardOfElectionsItem',
      'en': 'Board Of Elections',
      'fr': 'Bureau des élections',
      'es': 'Tablón de elecciones',
      'de': 'Wahlvorstand',
      'pl': 'Rada Wyborcza',
      'ru': 'Избирательная комиссия',
      'uk': 'Виборча рада',
      'ko': '선거관리위원회',
      'zh': '推选面板',
      'ja': 'Board Of Elections',
    }, {
      'id': 'BoiledGrainsItem',
      'en': 'Boiled Grains',
      'fr': 'Grains bouillis',
      'es': 'Granos hervidos',
      'de': 'Einfaches Porridge',
      'pl': 'Ugotowane ziarna',
      'ru': 'Варёные зерна',
      'uk': 'Зварене зерно',
      'ko': '삶은 곡물',
      'zh': '水煮谷物',
      'ja': 'Boiled Grains',
    }, {
      'id': 'BoiledRiceItem',
      'en': 'Boiled Rice',
      'fr': 'Riz bouilli',
      'es': 'Arroz Hervido',
      'de': 'Gekochter Reis',
      'pl': 'Gotowany ryż',
      'ru': 'Отварной рис',
      'uk': 'Варений рис',
      'ko': '삶은 쌀',
      'zh': '煮熟的米',
      'ja': 'ご飯',
    }, {
      'id': 'BoiledSausageItem',
      'en': 'Boiled Sausage',
      'fr': 'Saucisse bouillie',
      'es': 'Salchicha Cocida',
      'de': 'Gekochte Wurst',
      'pl': 'Gotowana kiełbasa',
      'ru': 'Варёная сосиска',
      'uk': 'Варена сарделька',
      'ko': '삶은 소시지',
      'zh': '煮香肠',
      'ja': '茹でたソーセージ',
    }, {
      'id': 'BoilerItem',
      'en': 'Boiler',
      'fr': 'Chaudière',
      'es': 'Caldera',
      'de': 'Heizkessel',
      'pl': 'Bojler',
      'ru': 'Котёл',
      'uk': 'Котел',
      'ko': '보일러',
      'zh': '锅炉',
      'ja': 'ボイラー',
    }, {
      'id': 'BoleteMushroomSporesItem',
      'en': 'Bolete Mushroom Spores',
      'fr': 'Spores de cèpe de Bordeaux',
      'es': 'Esporas de Seta de Boleto',
      'de': 'Sporen (Steinpilz)',
      'pl': 'Zarodniki Grzybów Bolete',
      'ru': 'Споры белого гриба',
      'uk': 'Спори білого гриба',
      'ko': '그물버섯 포자',
      'zh': '香菇孢子',
      'ja': 'ヤマドリタケの胞子',
    }, {
      'id': 'BoleteMushroomsItem',
      'en': 'Bolete Mushrooms',
      'fr': 'Cèpes de Bordeaux',
      'es': 'Setas de Boleto',
      'de': 'Steinpilze',
      'pl': 'Bolete Mushrooms',
      'ru': 'Белые грибы',
      'uk': 'Білі гриби',
      'ko': '그물버섯',
      'zh': '牛肝菌菇',
      'ja': 'ヤマドリタケ',
    }, {
      'id': 'BookshelfItem',
      'en': 'Bookshelf',
      'fr': 'Bibliothèque',
      'es': 'Librería',
      'de': 'Bücherregal',
      'pl': 'Biblioteczka',
      'ru': 'Книжный шкаф',
      'uk': 'Книжкова полиця',
      'ko': '책장',
      'zh': '书架',
      'ja': '本棚',
    }, {
      'id': 'BowItem',
      'en': 'Bow',
      'fr': 'Saluer',
      'es': 'Arco',
      'de': 'Bogen',
      'pl': 'Łuk',
      'ru': 'Лук',
      'uk': 'Лук',
      'ko': '활',
      'zh': '弓',
      'ja': '弓',
    }, {
      'id': 'BrazierItem',
      'en': 'Brazier',
      'fr': 'Braséro en fer',
      'es': 'Bracero',
      'de': 'Feuerschale',
      'pl': 'Koksownik',
      'ru': 'Жаровня',
      'uk': 'Жаровня',
      'ko': '화로',
      'zh': '火盆',
      'ja': '火鉢',
    }, {
      'id': 'BreadItem',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン',
    }, {
      'id': 'Bread',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン',
    }, {
      'id': 'BrickItem',
      'en': 'Brick',
      'fr': 'Brique',
      'es': 'Ladrillo',
      'de': 'Ziegel aus Lehm',
      'pl': 'Cegła',
      'ru': 'Кирпич',
      'uk': 'Цегла',
      'ko': '벽돌',
      'zh': '砖块',
      'ja': 'レンガ',
    }, {
      'id': 'BrickFireplaceItem',
      'en': 'Brick Fireplace',
      'fr': 'Cheminée en briques',
      'es': 'Chimenea de ladrillos',
      'de': 'Backsteinkamin',
      'pl': 'Ceglany kominek',
      'ru': 'Кирпичный камин',
      'uk': 'Цегляний камін',
      'ko': '벽돌 벽난로',
      'zh': '砖壁炉',
      'ja': 'Brick Fireplace',
    }, {
      'id': 'BuilderBootsItem',
      'en': 'Builder Boots',
      'fr': 'Bottes de maçon',
      'es': 'Botas de constructor',
      'de': 'Baumeisterstiefel',
      'pl': 'Builder Boots',
      'ru': 'Ботинки Строителя',
      'uk': 'Builder Boots',
      'ko': '빌더 부츠',
      'zh': '建筑工的靴子',
      'ja': 'Builder Boots',
    }, {
      'id': 'BuilderGlovesItem',
      'en': 'Builder Gloves',
      'fr': 'Gants de maçon',
      'es': 'Guantes de constructor',
      'de': 'Baumeisterhandschuhe',
      'pl': 'Builder Gloves',
      'ru': 'Перчатки Строителя',
      'uk': 'Builder Gloves',
      'ko': '빌더 장갑',
      'zh': '建筑工的手套',
      'ja': 'Builder Gloves',
    }, {
      'id': 'BuilderHelmetItem',
      'en': 'Builder Helmet',
      'fr': 'Casque de maçon',
      'es': 'Casco de constructor',
      'de': 'Baumeisterhelm',
      'pl': 'Builder Helmet',
      'ru': 'Каска Строителя',
      'uk': 'Builder Helmet',
      'ko': '빌더 헬멧',
      'zh': '建筑工的安全帽',
      'ja': 'Builder Helmet',
    }, {
      'id': 'BuilderOverallsItem',
      'en': 'Builder Overalls',
      'fr': 'Salopette de maçon',
      'es': 'Mono de constructor',
      'de': 'Baumeisteroverall',
      'pl': 'Builder Overalls',
      'ru': 'Комбинезон Строителя',
      'uk': 'Builder Overalls',
      'ko': '빌더 작업복',
      'zh': '建筑工的工装裤',
      'ja': 'Builder Overalls',
    }, {
      'id': 'BuilderShirtItem',
      'en': 'Builder Shirt',
      'fr': 'Chemise de maçon',
      'es': 'Camisa de constructor',
      'de': 'Baumeisterhemd',
      'pl': 'Builder Shirt',
      'ru': 'Рубашка Строителя',
      'uk': 'Builder Shirt',
      'ko': '빌더 셔츠',
      'zh': '建筑工的衬衫',
      'ja': 'Builder Shirt',
    }, {
      'id': 'BullrushSeedItem',
      'en': 'Bullrush Seed',
      'fr': 'Graine de jonc',
      'es': 'Semilla de Junco',
      'de': 'Samen (Binsen)',
      'pl': 'Nasiona Pałki Wodnej',
      'ru': 'Семечко камыша',
      'uk': 'Насіння очерету',
      'ko': '부들 씨앗',
      'zh': '芦苇种子',
      'ja': 'ガマの種',
    }, {
      'id': 'BunchgrassSeedItem',
      'en': 'Bunchgrass Seed',
      'fr': 'Graine de graminées',
      'es': 'Semilla de tussok',
      'de': 'Samen (Büschelgras)',
      'pl': 'Nasiona Trawy kępiastej',
      'ru': 'Семечко осоки',
      'uk': 'Насіння купчастої трави',
      'ko': '다발풀 씨앗',
      'zh': '丛生禾草种子',
      'ja': 'カヤツリグサの種',
    }, {
      'id': 'ButcheryTableItem',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de carnicería',
      'de': 'Metzgertisch',
      'pl': 'Stół rzeźnicki',
      'ru': 'Разделочный стол',
      'uk': 'Різницький стіл',
      'ko': '도축 작업대',
      'zh': '肉加工工作台',
      'ja': '食肉加工台',
    }, {
      'id': 'ButcheryUpgradeItem',
      'en': 'Butchery Upgrade',
      'fr': 'Amélioration Basique : Boucherie',
      'es': 'Mejora: Carnicería',
      'de': 'Grundlegendes Upgrade: Metzgerei',
      'pl': 'Ulepszenie Rzeźnictwa',
      'ru': 'Улучшение разделки',
      'uk': 'Покращення різництва',
      'ko': '도축 기술 업그레이드',
      'zh': '加工升级组件',
      'ja': 'Butchery Upgrade',
    }, {
      'id': 'CO2CanisterItem',
      'en': 'C O2 Canister',
      'fr': 'Cartouche de C O2',
      'es': 'Frasco de C O2',
      'de': 'CO₂-Kanister',
      'pl': 'Zbiornik z CO2',
      'ru': 'Баллон углекислоты',
      'uk': 'Балон вуглекислого газу',
      'ko': 'CO2 가스통',
      'zh': '二氧化碳罐',
      'ja': 'Co2キャニスター',
    }, {
      'id': 'CamasAshFertilizerItem',
      'en': 'Camas Ash Fertilizer',
      'fr': 'Engrais à la cendre de camassia',
      'es': 'Fertilizante de cenizas de camasia',
      'de': 'Dünger aus Prärielilienasche',
      'pl': 'Nawóz z popiołu Kamasji',
      'ru': 'Удобрение из пепла камассии',
      'uk': 'Добриво з попелу камасії',
      'ko': '카마스 재 비료',
      'zh': '卡马斯灰化肥',
      'ja': 'カマシア灰の肥料',
    }, {
      'id': 'CamasBreadItem',
      'en': 'Camas Bread',
      'fr': 'Pain au camassia',
      'es': 'Pan de camasia',
      'de': 'Prärielilienbrot',
      'pl': 'Chleb Kamasjowy',
      'ru': 'Хлеб с камассией',
      'uk': 'Хліб з камасією',
      'ko': '카마스 빵',
      'zh': '卡马斯面包',
      'ja': 'カマシアパン',
    }, {
      'id': 'CamasBulbItem',
      'en': 'Camas Bulb',
      'fr': 'Bulbe de camassia',
      'es': 'Bulbo de camasia',
      'de': 'Prärielilienzwiebel',
      'pl': 'Bulwa Kamasji',
      'ru': 'Луковица камассии',
      'uk': 'Цибулина камасії',
      'ko': '카마스 구근',
      'zh': '卡马斯球茎',
      'ja': 'カマシアの球根',
    }, {
      'id': 'CamasBulbBakeItem',
      'en': 'Camas Bulb Bake',
      'fr': 'Bulbe de camassia cuit',
      'es': 'Bulbo de camasia horneado',
      'de': 'Gebackene Prärielilienzwiebel',
      'pl': 'Ciasto z bulw Kamasji',
      'ru': 'Запечённая луковица камассии',
      'uk': 'Запечена цибулина камасії',
      'ko': '구운 카마스 구근',
      'zh': '烤卡马斯球茎',
      'ja': '焼いたカマシアの球根',
    }, {
      'id': 'CamasPasteItem',
      'en': 'Camas Paste',
      'fr': 'Pâte de camassia',
      'es': 'Pasta de camasia',
      'de': 'Prärielilienpaste',
      'pl': 'Pasta z Kamasji',
      'ru': 'Паста из камассии',
      'uk': 'Паста з камасії',
      'ko': '갈린 카마스',
      'zh': '卡马斯浆',
      'ja': 'ペースト状のカマシア',
    }, {
      'id': 'CamoPantsItem',
      'en': 'Camo Pants',
      'fr': 'Pantalon de camouflage',
      'es': 'Pantalones de Camuflaje',
      'de': 'Tarnhose',
      'pl': 'Spodnie Moro',
      'ru': 'Камуфляжные штаны',
      'uk': 'Камуфляжні штани',
      'ko': '위장무늬 바지',
      'zh': '迷彩裤',
      'ja': 'カモパンツ',
    }, {
      'id': 'CamoShirtItem',
      'en': 'Camo Shirt',
      'fr': 'Chemise de camouflage',
      'es': 'Camiseta de Camuflaje',
      'de': 'Tarnshirt',
      'pl': 'Koszula Moro',
      'ru': 'Камуфляжная рубашка',
      'uk': 'Камуфляжна сорочка',
      'ko': '위장무늬 셔츠',
      'zh': '迷彩衬衫',
      'ja': 'カモシャツ',
    }, {
      'id': 'CampfireItem',
      'en': 'Campfire',
      'fr': 'Feu de camp',
      'es': 'Fogata',
      'de': 'Lagerfeuer',
      'pl': 'Ognisko',
      'ru': 'Костёр',
      'uk': 'Багаття',
      'ko': '모닥불',
      'zh': '篝火',
      'ja': '焚き火',
    }, {
      'id': 'CampfireCookingUpgradeItem',
      'en': 'Campfire Cooking Upgrade',
      'fr': 'Amélioration Basique : Cuisine au feu de camp',
      'es': 'Mejora: Cocina con fogata',
      'de': 'Grundlegendes Upgrade: Lagerfeuerkochen',
      'pl': 'Ulepszenie Gotowania Na Ognisku',
      'ru': 'Улучшение для готовки на костре',
      'uk': 'Покращення приготування їжі на багатті',
      'ko': '모닥불 요리 기술 업그레이드',
      'zh': '篝火烹饪升级',
      'ja': 'Campfire Cooking Upgrade',
    }, {
      'id': 'CampfireRoastItem',
      'en': 'Campfire Roast',
      'fr': 'Rôti cuit au feu de bois',
      'es': 'Asado a la Fogata',
      'de': 'Lagerfeuerbraten',
      'pl': 'Pieczeń z ogniska',
      'ru': 'Жаркое на костре',
      'uk': 'Печеня на багатті',
      'ko': '모닥불 구운 고기',
      'zh': '篝火烧肉',
      'ja': '野外調理のロースト',
    }, {
      'id': 'CampfireSaladItem',
      'en': 'Campfire Salad',
      'fr': 'Salade au feu de camp',
      'es': 'Ensalada braseada',
      'de': 'Lagerfeuersalat',
      'pl': 'Sałatka z ogniska',
      'ru': 'Салат на костре',
      'uk': 'Салат, приготований на багатті',
      'ko': '모닥불 샐러드',
      'zh': '篝火沙拉',
      'ja': 'Campfire Salad',
    }, {
      'id': 'CampfireSalad',
      'en': 'Campfire Salad',
      'fr': 'Salade au feu de camp',
      'es': 'Ensalada braseada',
      'de': 'Lagerfeuersalat',
      'pl': 'Sałatka z ogniska',
      'ru': 'Салат на костре',
      'uk': 'Салат, приготований на багатті',
      'ko': '모닥불 샐러드',
      'zh': '篝火沙拉',
      'ja': 'Campfire Salad',
    }, {
      'id': 'CampfireStewItem',
      'en': 'Campfire Stew',
      'fr': 'Ragoût cuit au feu de bois',
      'es': 'Estofado a la Fogata',
      'de': 'Lagerfeuer Eintopf',
      'pl': 'Gulasz z ogniska',
      'ru': 'Рагу на костре',
      'uk': 'Рагу на багатті',
      'ko': '모닥불 스튜',
      'zh': '篝火炖',
      'ja': '野外調理のシチュー',
    }, {
      'id': 'CampsiteItem',
      'en': 'Campsite',
      'fr': 'Camping',
      'es': 'Campamento',
      'de': 'Campingplatz',
      'pl': 'Obóz',
      'ru': 'Палатка',
      'uk': 'Кемпінг',
      'ko': '야영지',
      'zh': '营地',
      'ja': 'キャンプサイト',
    }, {
      'id': 'CandleStandItem',
      'en': 'Candle Stand',
      'fr': 'Bougeoir',
      'es': 'Soporte de Vela',
      'de': 'Kerzenständer',
      'pl': 'Stojak na świecę',
      'ru': 'Подсвечник',
      'uk': 'Підсвічник',
      'ko': '촛대',
      'zh': '烛台',
      'ja': 'ろうそく立て',
    }, {
      'id': 'CapitolItem',
      'en': 'Capitol',
      'fr': 'Pupitre de la Constitution',
      'es': 'Capitolio',
      'de': 'Tisch der Verfassung',
      'pl': 'Kapitol',
      'ru': 'Капитолий',
      'uk': 'Капітолій',
      'ko': '중앙정부',
      'zh': '公约台',
      'ja': 'Capitol',
    }, {
      'id': 'CaprisItem',
      'en': 'Capris',
      'fr': 'Corsaire',
      'es': 'Pantalones Caprí',
      'de': 'Caprihose',
      'pl': 'Rybaczki',
      'ru': 'Короткие брюки',
      'uk': 'Капрі',
      'ko': '칠부 바지',
      'zh': '紧身裤',
      'ja': 'カプリ',
    }, {
      'id': 'CarpentryAdvancedUpgradeItem',
      'en': 'Carpentry Advanced Upgrade',
      'fr': 'Amélioration Avancée : Menuiserie',
      'es': 'Mejora avanzada: Carpintería',
      'de': 'Fortschrittliches Upgrade: Schreinerei',
      'pl': 'Zaawansowane ulepszenie Stolarstwa',
      'ru': 'Продвинутое улучшение для плотницкого дела',
      'uk': 'Carpentry Advanced Upgrade',
      'ko': '고급 목공 기술 업그레이드',
      'zh': '木工高级升级',
      'ja': 'Carpentry Advanced Upgrade',
    }, {
      'id': 'CarpentryBasicUpgradeItem',
      'en': 'Carpentry Basic Upgrade',
      'fr': 'Amélioration Basique : Menuiserie',
      'es': 'Mejora básica: Carpintería',
      'de': 'Grundlegendes Upgrade: Schreinerei',
      'pl': 'Podstawowe ulepszenie Stolarstwa',
      'ru': 'Базовое улучшение для плотницкого дела',
      'uk': 'Carpentry Basic Upgrade',
      'ko': '기초 목공 기술 업그레이드',
      'zh': '木工基础升级',
      'ja': 'Carpentry Basic Upgrade',
    }, {
      'id': 'CarpentryTableItem',
      'en': 'Carpentry Table',
      'fr': 'Établi de menuiserie',
      'es': 'Mesa de carpintería',
      'de': 'Zimmermanntisch',
      'pl': 'Stół Stolarski',
      'ru': 'Плотницкий верстак',
      'uk': 'Стіл теслі',
      'ko': '목공 작업대',
      'zh': '木工工作台',
      'ja': '木工作業台',
    }, {
      'id': 'CarvedPumpkinItem',
      'en': 'Carved Pumpkin',
      'fr': 'Citrouille sculptée',
      'es': 'Calabaza tallada',
      'de': 'Geschnitzter Kürbis',
      'pl': 'Wydrążona dynia',
      'ru': 'Резная тыква',
      'uk': 'Різьблений гарбуз',
      'ko': '조각된 호박',
      'zh': '南瓜灯',
      'ja': '切り分けられたカボチャ',
    }, {
      'id': 'CastIronBedItem',
      'en': 'Cast Iron Bed',
      'fr': 'Lit en fer forgé',
      'es': 'Cama de hierro fundido',
      'de': 'Gusseisernes Bett',
      'pl': 'Cast Iron Bed',
      'ru': 'Чугунная кровать',
      'uk': 'Cast Iron Bed',
      'ko': '무쇠 침대',
      'zh': '铸铁床',
      'ja': 'Cast Iron Bed',
    }, {
      'id': 'CastIronRoyalBedItem',
      'en': 'Cast Iron Royal Bed',
      'fr': 'Lit royal en fer forgé',
      'es': 'Cama de lujo de hierro fundido',
      'de': 'Gusseisernes Königliches Bett',
      'pl': 'Cast Iron Royal Bed',
      'ru': 'Чугунная Королевская Кровать',
      'uk': 'Cast Iron Royal Bed',
      'ko': '무쇠 로얄 침대',
      'zh': '铸铁皇家床',
      'ja': 'Cast Iron Royal Bed',
    }, {
      'id': 'CastIronStoveItem',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Gusseiserner Ofen',
      'pl': 'Żeliwna kuchnia',
      'ru': 'Чугунная плита',
      'uk': 'Чавунна піч',
      'ko': '철재 화덕',
      'zh': '铸铁火炉',
      'ja': '鋳鉄のストーブ',
    }, {
      'id': 'CedarLogItem',
      'en': 'Cedar Log',
      'fr': 'Bûche de Cèdre',
      'es': 'Tronco de cedro',
      'de': 'Zedernholzstamm',
      'pl': 'Kłoda cedru',
      'ru': 'Бревно Кедра',
      'uk': 'Кедрова колода',
      'ko': '삼나무 통나무',
      'zh': '雪松原木',
      'ja': 'Cedar Log',
    }, {
      'id': 'CedarSeedItem',
      'en': 'Cedar Seed',
      'fr': 'Graine de cèdre',
      'es': 'Semilla de Cedro',
      'de': 'Samen (Zeder)',
      'pl': 'Nasiona Cedru',
      'ru': 'Семечко кедра',
      'uk': 'Кeдрове насіння',
      'ko': '삼나무 씨앗',
      'zh': '雪松种子',
      'ja': '杉の種',
    }, {
      'id': 'CeibaLogItem',
      'en': 'Ceiba Log',
      'fr': 'Bûche de Ceiba',
      'es': 'Tronco de ceiba',
      'de': 'Kapokholzstamm',
      'pl': 'Kłoda puchowca',
      'ru': 'Бревно Сейбы',
      'uk': 'Колода сейби',
      'ko': '명주나무 통나무',
      'zh': '木棉原木',
      'ja': 'Ceiba Log',
    }, {
      'id': 'CeibaSeedItem',
      'en': 'Ceiba Seed',
      'fr': 'Graine de ceiba',
      'es': 'Semilla de ceiba',
      'de': 'Samen (Kapokbaum)',
      'pl': 'Nasiono Puchowca',
      'ru': 'Семечко сейбы',
      'uk': 'Бавовняне насіння',
      'ko': '명주나무 씨앗',
      'zh': '雪松种子',
      'ja': 'パンヤノキの種',
    }, {
      'id': 'CeilingCandleItem',
      'en': 'Ceiling Candle',
      'fr': 'Lustre à bougies',
      'es': 'Vela de Techo',
      'de': 'Deckenlampe',
      'pl': 'Kandelabr',
      'ru': 'Люстра со свечами',
      'uk': 'Люстра зі свічками',
      'ko': '천장 촛대',
      'zh': '吊式烛灯',
      'ja': '吊り下げろうそく',
    }, {
      'id': 'CelluloseFiberItem',
      'en': 'Cellulose Fiber',
      'fr': 'Fibres de cellulose',
      'es': 'Fibra de celulosa',
      'de': 'Zellulosefaser',
      'pl': 'Włókna celulozowe',
      'ru': 'Целлюлозное волокно',
      'uk': 'Клітковина',
      'ko': '셀룰로오스 섬유',
      'zh': '人造纤维',
      'ja': 'セルロース繊維',
    }, {
      'id': 'CementItem',
      'en': 'Cement',
      'fr': 'Ciment',
      'es': 'Cemento',
      'de': 'Zement',
      'pl': 'Cement',
      'ru': 'Цемент',
      'uk': 'Цемент',
      'ko': '시멘트 제조 기술',
      'zh': '水泥',
      'ja': 'セメント',
    }, {
      'id': 'CementKilnItem',
      'en': 'Cement Kiln',
      'fr': 'Four à ciment',
      'es': 'Horno de Cemento',
      'de': 'Zementbrennofen',
      'pl': 'Cementownia',
      'ru': 'Барабанная печь',
      'uk': 'Піч для цементу',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントのかまど',
    }, {
      'id': 'CensusBureauItem',
      'en': 'Census Bureau',
      'fr': 'Bureau de recensement',
      'es': 'Oficina de censo',
      'de': 'Einwohnermeldeamt',
      'pl': 'Biuro spisowe',
      'ru': 'Бюро переписи населения',
      'uk': 'Бюро перепису населення',
      'ko': '인구조사국',
      'zh': '人口普查局',
      'ja': 'Census Bureau',
    }, {
      'id': 'CerealGermItem',
      'en': 'Cereal Germ',
      'fr': 'Germe de céréale',
      'es': 'Germen de Cereal',
      'de': 'Getreidekeim',
      'pl': 'Kiełki zbóżowe',
      'ru': 'Зародыш зерна',
      'uk': 'Зерновий зародок',
      'ko': '곡실눈',
      'zh': '谷物胚芽',
      'ja': '穀物粉',
    }, {
      'id': 'ChainsawItem',
      'en': 'Chainsaw',
      'fr': 'Tronçonneuse',
      'es': 'Motosierra',
      'de': 'Kettensäge',
      'pl': 'Piła Łańcuchowa',
      'ru': 'Бензопила',
      'uk': 'Бензопила',
      'ko': '전기톱',
      'zh': '链锯',
      'ja': 'チェーンソー',
    }, {
      'id': 'ChairItem',
      'en': 'Chair',
      'fr': 'Chaise',
      'es': 'Silla',
      'de': 'Stuhl',
      'pl': 'Krzesło',
      'ru': 'Стул',
      'uk': 'Стілець',
      'ko': '의자',
      'zh': '椅子',
      'ja': '椅子',
    }, {
      'id': 'CharcoalItem',
      'en': 'Charcoal',
      'fr': 'Charbon de bois',
      'es': 'Carbón vegetal',
      'de': 'Holzkohle',
      'pl': 'Węgiel drzewny',
      'ru': 'Древесный уголь',
      'uk': 'Вугілля з деревини',
      'ko': '숯',
      'zh': '木炭',
      'ja': '木炭',
    }, {
      'id': 'CharredAgaveItem',
      'en': 'Charred Agave',
      'fr': 'Agave carbonisé',
      'es': 'Agave carbonizado',
      'de': 'Verschmorte Agave',
      'pl': 'Opiekana Agawa',
      'ru': 'Агава на углях',
      'uk': 'Обвуглена агава',
      'ko': '그슬린 용설란',
      'zh': '烧焦的龙舌兰',
      'ja': '焦げたリュウゼツラン',
    }, {
      'id': 'CharredBeansItem',
      'en': 'Charred Beans',
      'fr': 'Haricots carbonisés',
      'es': 'Judías carbonizadas',
      'de': 'Verschmorte Bohnen',
      'pl': 'Opiekana Fasola',
      'ru': 'Бобы на углях',
      'uk': 'Квасоля, приготована на вугіллі',
      'ko': '그슬린 콩',
      'zh': '烧焦的豆',
      'ja': 'Charred Beans',
    }, {
      'id': 'CharredBeetItem',
      'en': 'Charred Beet',
      'fr': 'Betterave carbonisée',
      'es': 'Remolacha carbonizada',
      'de': 'Verschmorte Rote Bete',
      'pl': 'Opiekany burak',
      'ru': 'Свёкла на углях',
      'uk': 'Обвуглений буряк',
      'ko': '그슬린 사탕무',
      'zh': '烧焦的甜菜',
      'ja': '焦げたビート',
    }, {
      'id': 'CharredCactusFruitItem',
      'en': 'Charred Cactus Fruit',
      'fr': 'Fruit de Saguaro carbonisé',
      'es': 'Fruto de cactus carbonizado',
      'de': 'Verschmorte Kaktusfrucht',
      'pl': 'Opiekany Owoc Kaktusa',
      'ru': 'Плод сагуаро на углях',
      'uk': 'Опунція, приготована на вугіллі',
      'ko': '그슬린 백년초',
      'zh': '烧焦的仙人掌果',
      'ja': 'Charred Cactus Fruit',
    }, {
      'id': 'CharredCamasBulbItem',
      'en': 'Charred Camas Bulb',
      'fr': 'Bulbe de camassia carbonisé',
      'es': 'Bulbo de camasia carbonizado',
      'de': 'Verschmorte Prärielilienzwiebel',
      'pl': 'Opiekana Bulwa Kamasji',
      'ru': 'Обжаренная луковица камассии',
      'uk': 'Обвуглена цибулина камасії',
      'ko': '그슬린 카마스 구근',
      'zh': '烧焦的卡马斯球茎',
      'ja': '焦げたカマシアの球根',
    }, {
      'id': 'CharredCornItem',
      'en': 'Charred Corn',
      'fr': 'Maïs carbonisé',
      'es': 'Maíz carbonizado',
      'de': 'Verschmorter Mais',
      'pl': 'Opiekana Kukurydza',
      'ru': 'Кукуруза на углях',
      'uk': 'Обвуглений кукурудзяний качан',
      'ko': '그슬린 옥수수',
      'zh': '烧焦的玉米',
      'ja': '焦げたトウモロコシ',
    }, {
      'id': 'CharredFireweedShootsItem',
      'en': 'Charred Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe carbonisées',
      'es': 'Brotes de epilobio carbonizados',
      'de': 'Verschmorte Weidenröschenwurzel',
      'pl': 'Opiekane Pędy Wierzbówki',
      'ru': 'Иван-чай на углях',
      'uk': 'Іван-чай на вуглях',
      'ko': '그슬린 분홍바늘꽃 순',
      'zh': '烧焦的杂草芽',
      'ja': 'Charred Fireweed Shoots',
    }, {
      'id': 'CharredFishItem',
      'en': 'Charred Fish',
      'fr': 'Poisson carbonisé',
      'es': 'Pescado carbonizado',
      'de': 'Verschmorter Fisch',
      'pl': 'Opiekana Ryba',
      'ru': 'Жареная на костре рыба',
      'uk': 'Обвуглена риба',
      'ko': '그슬린 생선',
      'zh': '烧焦的鱼',
      'ja': '焦げた魚',
    }, {
      'id': 'CharredHeartOfPalmItem',
      'en': 'Charred Heart Of Palm',
      'fr': 'Cœur de palmier carbonisé',
      'es': 'Palmito carbonizado',
      'de': 'Verschmorte Palmherzen',
      'pl': 'Opiekane Serce Palmy',
      'ru': 'Сердцевина пальмы на углях',
      'uk': 'Серцевина пальми, приготована на вугіллі',
      'ko': '그슬린 대추야자 나무순',
      'zh': '烧焦的棕榈心',
      'ja': 'Charred Heart Of Palm',
    }, {
      'id': 'CharredMeatItem',
      'en': 'Charred Meat',
      'fr': 'Viande carbonisée',
      'es': 'Carne carbonizada',
      'de': 'Verschmortes Fleisch',
      'pl': 'Opiekane Mięso',
      'ru': 'Жареное на костре мясо',
      'uk': 'Обвуглене м’ясо',
      'ko': '그슬린 고기',
      'zh': '烧焦的肉',
      'ja': '焦げた肉',
    }, {
      'id': 'CharredMushroomsItem',
      'en': 'Charred Mushrooms',
      'fr': 'Champignons carbonisés',
      'es': 'Champiñones carbonizados',
      'de': 'Verschmorte Pilze',
      'pl': 'Opiekane Grzyby',
      'ru': 'Грибы на углях',
      'uk': 'Гриби на вугіллі',
      'ko': '그슬린 버섯',
      'zh': '烧焦的蘑菇',
      'ja': 'Charred Mushrooms',
    }, {
      'id': 'CharredPapayaItem',
      'en': 'Charred Papaya',
      'fr': 'Papaye carbonisée',
      'es': 'Papaya Carbonizada',
      'de': 'Verschmorte Papaya',
      'pl': 'Opiekana papaja',
      'ru': 'Папайя на углях',
      'uk': 'Обвуглена папая',
      'ko': '그슬린 파파야',
      'zh': '烧焦的木瓜',
      'ja': '焦げたパパイヤ',
    }, {
      'id': 'CharredPineappleItem',
      'en': 'Charred Pineapple',
      'fr': 'Ananas carbonisé',
      'es': 'Piña Carbonizada',
      'de': 'Verschmorte Ananas',
      'pl': 'Opiekany Ananas',
      'ru': 'Ананас на углях',
      'uk': 'Обвуглений ананас',
      'ko': '그슬린 파인애플',
      'zh': '烧焦的菠萝',
      'ja': '焦げたパイナップル',
    }, {
      'id': 'CharredSausageItem',
      'en': 'Charred Sausage',
      'fr': 'Saucisse carbonisée',
      'es': 'Salchicha Carbonizada',
      'de': 'Verschmorte Wurst',
      'pl': 'Opiekana Kiełbasa',
      'ru': 'Сарделька на углях',
      'uk': 'Обвуглена сарделька',
      'ko': '그슬린 소시지',
      'zh': '烧焦的香肠',
      'ja': '焦げたソーセージ',
    }, {
      'id': 'CharredTaroItem',
      'en': 'Charred Taro',
      'fr': 'Taro carbonisé',
      'es': 'Taro Carbonizado',
      'de': 'Verschmorte Taro',
      'pl': 'Opiekana Kolokazja',
      'ru': 'Таро на углях',
      'uk': 'Обвуглене таро',
      'ko': '그슬린 토란',
      'zh': '烧焦的芋头',
      'ja': '焦げたタロイモ',
    }, {
      'id': 'CharredTomatoItem',
      'en': 'Charred Tomato',
      'fr': 'Tomate carbonisée',
      'es': 'Tomate Carbonizado',
      'de': 'Verschmorte Tomate',
      'pl': 'Opiekany Pomidor',
      'ru': 'Помидор на углях',
      'uk': 'Обвуглений помідор',
      'ko': '그슬린 토마토',
      'zh': '烧焦的番茄',
      'ja': '焦げたトマト',
    }, {
      'id': 'ChefHatItem',
      'en': 'Chef Hat',
      'fr': 'Toque de cuisinier',
      'es': 'Gorro de cocinero',
      'de': 'Kochmütze',
      'pl': 'Chef Hat',
      'ru': 'Колпак Повара',
      'uk': 'Chef Hat',
      'ko': '요리사 모자',
      'zh': '厨师的帽子',
      'ja': 'Chef Hat',
    }, {
      'id': 'ChefPantsItem',
      'en': 'Chef Pants',
      'fr': 'Pantalon de cuisinier',
      'es': 'Pantalones de cocinero',
      'de': 'Kochhosen',
      'pl': 'Chef Pants',
      'ru': 'Штаны Повара',
      'uk': 'Chef Pants',
      'ko': '요리사 바지',
      'zh': '厨师的裤子',
      'ja': 'Chef Pants',
    }, {
      'id': 'ChefShirtItem',
      'en': 'Chef Shirt',
      'fr': 'Veste de cuisinier',
      'es': 'Camisa de cocinero',
      'de': 'Kochhemd',
      'pl': 'Chef Shirt',
      'ru': 'Китель Повара',
      'uk': 'Chef Shirt',
      'ko': '요리사 셔츠',
      'zh': '厨师的衬衫',
      'ja': 'Chef Shirt',
    }, {
      'id': 'ChefShoesItem',
      'en': 'Chef Shoes',
      'fr': 'Chaussures de sécurité de cuisiner',
      'es': 'Zapatos de cocinero',
      'de': 'Kochschuhe',
      'pl': 'Chef Shoes',
      'ru': 'Ботинки Повара',
      'uk': 'Chef Shoes',
      'ko': '요리사 신발',
      'zh': '厨师的鞋子',
      'ja': 'Chef Shoes',
    }, {
      'id': 'ClamItem',
      'en': 'Clam',
      'fr': 'Palourde',
      'es': 'Almeja',
      'de': 'Muschel',
      'pl': 'Małż',
      'ru': 'Моллюск',
      'uk': 'Молюск',
      'ko': '조개',
      'zh': '蚌',
      'ja': '貝',
    }, {
      'id': 'ClamChowderItem',
      'en': 'Clam Chowder',
      'fr': 'Chaudrée de palourdes',
      'es': 'Sopa de mariscos',
      'de': 'Suppe mit Muscheln',
      'pl': 'Clam Chowder',
      'ru': 'Похлебка из моллюсков',
      'uk': 'Clam Chowder',
      'ko': 'Clam Chowder',
      'zh': '蛤蜊汤',
      'ja': 'Clam Chowder',
    }, {
      'id': 'ClayItem',
      'en': 'Clay',
      'fr': 'Argile',
      'es': 'Arcilla',
      'de': 'Lehm',
      'pl': 'Clay',
      'ru': 'Глина',
      'uk': 'Глина',
      'ko': '점토',
      'zh': '黏土',
      'ja': '粘土',
    }, {
      'id': 'ClothItem',
      'en': 'Cloth',
      'fr': 'Tissu',
      'es': 'Tela',
      'de': 'Stoff',
      'pl': 'Tkanina',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': '천',
      'zh': '布料',
      'ja': '布',
    }, {
      'id': 'ClothBeltItem',
      'en': 'Cloth Belt',
      'fr': 'Ceinture en tissu',
      'es': 'Cinturón de tela',
      'de': 'Gürtel',
      'pl': 'Bluza na pasie',
      'ru': 'Тканый пояс',
      'uk': 'Тканинний ремінь',
      'ko': '천 벨트',
      'zh': '布带',
      'ja': 'Cloth Belt',
    }, {
      'id': 'ClothCapeItem',
      'en': 'Cloth Cape',
      'fr': 'Cape en tissu',
      'es': 'Capa de tela',
      'de': 'Stoffumhang',
      'pl': 'Płaszcz z tkaniny',
      'ru': 'Тканевая накидка',
      'uk': 'Тканинна накидка',
      'ko': '천 망토',
      'zh': '布斗篷',
      'ja': 'Cloth Cape',
    }, {
      'id': 'Clothes',
      'en': 'Clothes',
      'fr': 'Vêtements',
      'es': 'Ropas',
      'de': 'Kleider',
      'pl': 'Ubrania',
      'ru': 'Одежда',
      'uk': 'Одяг',
      'ko': '옷',
      'zh': '衣服',
      'ja': 'Clothes',
    }, {
      'id': 'CoalItem',
      'en': 'Coal',
      'fr': 'Charbon',
      'es': 'Carbón',
      'de': 'Kohle',
      'pl': 'Węgiel',
      'ru': 'Уголь',
      'uk': 'Вугілля',
      'ko': '석탄',
      'zh': '煤',
      'ja': '石炭',
    }, {
      'id': 'Coal',
      'en': 'Coal',
      'fr': 'Charbon',
      'es': 'Carbón',
      'de': 'Kohle',
      'pl': 'Węgiel',
      'ru': 'Уголь',
      'uk': 'Вугілля',
      'ko': '석탄',
      'zh': '煤',
      'ja': '石炭',
    }, {
      'id': 'CodItem',
      'en': 'Cod',
      'fr': 'Morue',
      'es': 'Bacalao',
      'de': 'Kabeljau',
      'pl': 'Dorsz',
      'ru': 'Треска',
      'uk': 'Тріска',
      'ko': '대구',
      'zh': '鳕鱼',
      'ja': 'Cod',
    }, {
      'id': 'CombustionEngineItem',
      'en': 'Combustion Engine',
      'fr': 'Moteur à combustion',
      'es': 'Motor de Combustión',
      'de': 'Verbrennungsmotor',
      'pl': 'Silnik spalinowy',
      'ru': 'Двигатель внутреннего сгорания',
      'uk': 'Двигун внутрішнього згоряння',
      'ko': '연소기관',
      'zh': '内燃机',
      'ja': '内燃機関',
    }, {
      'id': 'CombustionGeneratorItem',
      'en': 'Combustion Generator',
      'fr': 'Générateur à combustion',
      'es': 'Generador de Combustión',
      'de': 'Verbrennungsgenerator',
      'pl': 'Generator Spalinowy',
      'ru': 'Генератор внутреннего сгорания',
      'uk': 'Генератор внутрішнього згоряння',
      'ko': '연소 발전기',
      'zh': '内燃发电机',
      'ja': '火力発電機',
    }, {
      'id': 'CompositeBirchBenchItem',
      'en': 'Composite Birch Bench',
      'fr': 'Banc en composite de bouleau',
      'es': 'Banco de composite (abedul)',
      'de': 'Birken-Verbundholzbank',
      'pl': 'Kompozytowa ławka brzozowa',
      'ru': 'Лавка из композитных берёзовых пиломатериалов',
      'uk': 'Лавка із композиту берези',
      'ko': '합성 자작나무 목재 벤치',
      'zh': '复合桦木长凳',
      'ja': 'Composite Birch Bench',
    }, {
      'id': 'CompositeBirchChairItem',
      'en': 'Composite Birch Chair',
      'fr': 'Chaise en composite de bouleau',
      'es': 'Silla de composite (abedul)',
      'de': 'Birken-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z brzozy',
      'ru': 'Стул из композитных берёзовых пиломатериалов',
      'uk': 'Стілець із композиту берези',
      'ko': '합성 자작나무 목재 의자',
      'zh': '复合桦木椅子',
      'ja': 'Composite Birch Chair',
    }, {
      'id': 'CompositeBirchDoorItem',
      'en': 'Composite Birch Door',
      'fr': 'Porte en composite de bouleau',
      'es': 'Puerta de composite (abedul)',
      'de': 'Birken-Verbundholztür',
      'pl': 'Kompozytowe drzwi z brzozy',
      'ru': 'Дверь из композитных берёзовых пиломатериалов',
      'uk': 'Двері із композиту берези',
      'ko': '합성 자작나무 목재 문',
      'zh': '复合桦木门',
      'ja': 'Composite Birch Door',
    }, {
      'id': 'CompositeBirchLumberItem',
      'en': 'Composite Birch Lumber',
      'fr': 'Bois composite en bouleau',
      'es': 'Tronco de abedul (composite)',
      'de': 'Birken-Verbundholz',
      'pl': 'Kompozytowe drewno z brzozy',
      'ru': 'Композитные пиломатериалы из березы',
      'uk': 'Композитні березові пиломатеріали',
      'ko': '자작나무 합성 목재',
      'zh': '复合桦木',
      'ja': 'Composite Birch Lumber',
    }, {
      'id': 'CompositeBirchTableItem',
      'en': 'Composite Birch Table',
      'fr': 'Table en composite de bouleau',
      'es': 'Mesa de composite (abedul)',
      'de': 'Birken-Verbundholztisch',
      'pl': 'Kompozytowy stół z brzozy',
      'ru': 'Стол из композитных берёзовых пиломатериалов',
      'uk': 'Стіл із композиту берези',
      'ko': '합성 자작나무 목재 탁자',
      'zh': '复合桦木桌',
      'ja': 'Composite Birch Table',
    }, {
      'id': 'CompositeBowItem',
      'en': 'Composite Bow',
      'fr': 'Arc composite',
      'es': 'Arco de madera de composite',
      'de': 'Kompositbogen',
      'pl': 'Composite Bow',
      'ru': 'Композитный лук',
      'uk': 'Composite Bow',
      'ko': '합성 활',
      'zh': '复合弓',
      'ja': 'Composite Bow',
    }, {
      'id': 'CompositeCedarBenchItem',
      'en': 'Composite Cedar Bench',
      'fr': 'Banc en composite de cèdre',
      'es': 'Banco de composite (cedro)',
      'de': 'Zedern-Verbundholzbank',
      'pl': 'Kompozytowa ławka z cedru',
      'ru': 'Лавка из кедрового композита',
      'uk': 'Лавка з композиту кедра',
      'ko': '합성 삼나무 목재 벤치',
      'zh': '复合雪松木长凳',
      'ja': 'Composite Cedar Bench',
    }, {
      'id': 'CompositeCedarChairItem',
      'en': 'Composite Cedar Chair',
      'fr': 'Chaise en composite de cèdre',
      'es': 'Silla de composite (cedro)',
      'de': 'Zedern-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z cedru',
      'ru': 'Стул из кедрового композита',
      'uk': 'Стелець із композиту кедра',
      'ko': '합성 삼나무 목재 의자',
      'zh': '复合雪松木椅子',
      'ja': 'Composite Cedar Chair',
    }, {
      'id': 'CompositeCedarDoorItem',
      'en': 'Composite Cedar Door',
      'fr': 'Porte en composite de cèdre',
      'es': 'Puerta de composite (cedro)',
      'de': 'Zedern-Verbundholztür',
      'pl': 'Kompozytowe drzwi z cedru',
      'ru': 'Дверь из кедрового композита',
      'uk': 'Двері із композиту кедра',
      'ko': '합성 삼나무 목재 문',
      'zh': '复合雪松门',
      'ja': 'Composite Cedar Door',
    }, {
      'id': 'CompositeCedarLumberItem',
      'en': 'Composite Cedar Lumber',
      'fr': 'Bois composite en cèdre',
      'es': 'Tronco de cedro (composite)',
      'de': 'Zedern-Verbundholz',
      'pl': 'Kompozytowe drewno z cedru',
      'ru': 'Композитные пиломатериалы из кедра',
      'uk': 'Композитний кедровий пиломатеріал',
      'ko': '전나무 합성 목재',
      'zh': '复合雪松木材',
      'ja': 'Composite Cedar Lumber',
    }, {
      'id': 'CompositeCedarTableItem',
      'en': 'Composite Cedar Table',
      'fr': 'Table en composite de cèdre',
      'es': 'Mesa de composite (cedro)',
      'de': 'Zedern-Verbundholztisch',
      'pl': 'Kompozytowy stół z cedru',
      'ru': 'Стол из кедрового композита',
      'uk': 'Стіл із композиту кедра',
      'ko': '합성 삼나무 목재 탁자',
      'zh': '复合雪松桌',
      'ja': 'Composite Cedar Table',
    }, {
      'id': 'CompositeCeibaBenchItem',
      'en': 'Composite Ceiba Bench',
      'fr': 'Banc en composite de ceiba',
      'es': 'Banco de composite (ceiba)',
      'de': 'Kapok-Verbundholzbank',
      'pl': 'Kompozytowa ławka z puchowca',
      'ru': 'Лавка из композита сейбы',
      'uk': 'Лавка з композиту сейби',
      'ko': '합성 명주나무 목재 벤치',
      'zh': '复合木棉长凳',
      'ja': 'Composite Ceiba Bench',
    }, {
      'id': 'CompositeCeibaChairItem',
      'en': 'Composite Ceiba Chair',
      'fr': 'Chaise en composite de ceiba',
      'es': 'Silla de composite (ceiba)',
      'de': 'Kapok-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z puchowca',
      'ru': 'Стул из композита сейбы',
      'uk': 'Стілець із композиту сейби',
      'ko': '합성 명주나무 목재 의자',
      'zh': '复合木棉椅子',
      'ja': 'Composite Ceiba Chair',
    }, {
      'id': 'CompositeCeibaDoorItem',
      'en': 'Composite Ceiba Door',
      'fr': 'Porte en composite de ceiba',
      'es': 'Puerta de composite (ceiba)',
      'de': 'Kapok-Verbundholztür',
      'pl': 'Kompozytowe drzwi z puchowca',
      'ru': 'Дверь из композита сейбы',
      'uk': 'Двері із композиту сейби',
      'ko': '합성 명주나무 목재 문',
      'zh': '复合木棉门',
      'ja': 'Composite Ceiba Door',
    }, {
      'id': 'CompositeCeibaLumberItem',
      'en': 'Composite Ceiba Lumber',
      'fr': 'Bois composite en ceiba',
      'es': 'Tronco de ceiba (composite)',
      'de': 'Kapok-Verbundholz',
      'pl': 'Kompozytowe drewno z puchowca',
      'ru': 'Композитные пиломатериалы из сейбы',
      'uk': 'Композитний пиломатеріал сейба',
      'ko': '명주나무 합성 목재',
      'zh': '复合木棉木材',
      'ja': 'Composite Ceiba Lumber',
    }, {
      'id': 'CompositeCeibaTableItem',
      'en': 'Composite Ceiba Table',
      'fr': 'Table en composite de ceiba',
      'es': 'Mesa de composite (ceiba)',
      'de': 'Kapok-Verbundholztisch',
      'pl': 'Kompozytowy stół z puchowca',
      'ru': 'Стол из композита сейбы',
      'uk': 'Стіл із композиту сейби',
      'ko': '합성 명주나무 목재 탁자',
      'zh': '复合木棉桌子',
      'ja': 'Composite Ceiba Table',
    }, {
      'id': 'CompositeFillerItem',
      'en': 'Composite Filler',
      'fr': 'Garnissage mélangé',
      'es': 'Relleno de Compuesto',
      'de': 'Füller aus Verbundstoffen',
      'pl': 'Wypełniacz kompozytowy',
      'ru': 'Композитный наполнитель',
      'uk': 'Композитний наповнювач',
      'ko': '합성 보충제',
      'zh': '复合填料',
      'ja': '複合フィラー',
    }, {
      'id': 'CompositeFirBenchItem',
      'en': 'Composite Fir Bench',
      'fr': 'Banc en composite de sapin',
      'es': 'Banco de composite (abeto)',
      'de': 'Tannen-Verbundholzbank',
      'pl': 'Kompozytowa ławka z jodły',
      'ru': 'Лавка из композита пихты',
      'uk': 'Лавка з композиту ялини',
      'ko': '합성 전나무 목재 벤치',
      'zh': '复合杉木凳',
      'ja': 'Composite Fir Bench',
    }, {
      'id': 'CompositeFirChairItem',
      'en': 'Composite Fir Chair',
      'fr': 'Chaise en composite de sapin',
      'es': 'Silla de composite (abeto)',
      'de': 'Tannen-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z jodły',
      'ru': 'Стул из композита пихты',
      'uk': 'Стілець із композиту ялини',
      'ko': '합성 전나무 목재 의자',
      'zh': '复合杉木椅子',
      'ja': 'Composite Fir Chair',
    }, {
      'id': 'CompositeFirDoorItem',
      'en': 'Composite Fir Door',
      'fr': 'Porte en composite de sapin',
      'es': 'Puerta de composite (abeto)',
      'de': 'Tannen-Verbundholztür',
      'pl': 'Kompozytowe drzwi z jodły',
      'ru': 'Дверь из композита пихты',
      'uk': 'Двері з композиту ялини',
      'ko': '합성 전나무 목재 문',
      'zh': '复合杉木门',
      'ja': 'Composite Fir Door',
    }, {
      'id': 'CompositeFirLumberItem',
      'en': 'Composite Fir Lumber',
      'fr': 'Bois composite en sapin',
      'es': 'Tronco de abeto (composite)',
      'de': 'Tannen-Verbundholz',
      'pl': 'Kompozytowe drewno z jodły',
      'ru': 'Композитные пиломатериалы из пихты',
      'uk': 'Композитний ялинковий пиломатеріал',
      'ko': '전나무 합성 목재',
      'zh': '复合杉木木材',
      'ja': 'Composite Fir Lumber',
    }, {
      'id': 'CompositeFirTableItem',
      'en': 'Composite Fir Table',
      'fr': 'Table en composite de sapin',
      'es': 'Mesa de composite (abeto)',
      'de': 'Tannen-Verbundholztisch',
      'pl': 'Kompozytowy stół z jodły',
      'ru': 'Стол из композита пихты',
      'uk': 'Стіл із композиту ялини',
      'ko': '합성 전나무 목자 탁자',
      'zh': '复合杉木桌',
      'ja': 'Composite Fir Table',
    }, {
      'id': 'CompositeHardwoodBenchItem',
      'en': 'Composite Hardwood Bench',
      'fr': 'Banc en composite de bois dur',
      'es': 'Banco de composite (madera noble)',
      'de': 'Hartholz-Verbundholzbank',
      'pl': 'Kompozytowa ławka z drewna liściastego',
      'ru': 'Лавка из композитов лиственных пород',
      'uk': 'Лавка з твердолистяного композиту',
      'ko': '합성 견목재 벤치',
      'zh': '复合硬木长凳',
      'ja': 'Composite Hardwood Bench',
    }, {
      'id': 'CompositeHardwoodChairItem',
      'en': 'Composite Hardwood Chair',
      'fr': 'Chaise en composite de bois dur',
      'es': 'Silla de composite (madera noble)',
      'de': 'Hartholz-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z drewna liściastego',
      'ru': 'Стул из композитов лиственных пород',
      'uk': 'Стілець із твердолистяного композиту',
      'ko': '합성 견목재 의자',
      'zh': '复合硬木椅子',
      'ja': 'Composite Hardwood Chair',
    }, {
      'id': 'CompositeHardwoodDoorItem',
      'en': 'Composite Hardwood Door',
      'fr': 'Porte en composite de bois dur',
      'es': 'Puerta de composite (madera noble)',
      'de': 'Hartholz-Verbundholztür',
      'pl': 'Kompozytowe drzwi z drewna liściastego',
      'ru': 'Дверь из композитов лиственных пород',
      'uk': 'Двері з твердолистяного композиту',
      'ko': '합성 견목재 문',
      'zh': '复合硬木门',
      'ja': 'Composite Hardwood Door',
    }, {
      'id': 'CompositeHardwoodTableItem',
      'en': 'Composite Hardwood Table',
      'fr': 'Table en composite de bois dur',
      'es': 'Mesa de composite (madera noble)',
      'de': 'Hartholz-Verbundholztisch',
      'pl': 'Kompozytowy stół z drewna liściastego',
      'ru': 'Стол из композитов лиственных пород',
      'uk': 'Стіл із твердолистяного композиту',
      'ko': '합성 견목재 탁자',
      'zh': '复合硬木桌',
      'ja': 'Composite Hardwood Table',
    }, {
      'id': 'CompositeJoshuaBenchItem',
      'en': 'Composite Joshua Bench',
      'fr': 'Banc en composite de josué',
      'es': 'Banco de composite (joshua)',
      'de': 'Josua-Verbundholzbank',
      'pl': 'Kompozytowa ławka z drewna jukki',
      'ru': 'Лавка из композита юкки коротколистной',
      'uk': 'Лавка з композиту юкки',
      'ko': '합성 여호수아나무 목재 벤치',
      'zh': '复合约书亚长凳',
      'ja': 'Composite Joshua Bench',
    }, {
      'id': 'CompositeJoshuaChairItem',
      'en': 'Composite Joshua Chair',
      'fr': 'Chaise en composite de josué',
      'es': 'Silla de composite (joshua)',
      'de': 'Josua-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z drewna jukki',
      'ru': 'Стул из композита юкки коротколистной',
      'uk': 'Стілець із композиту юкки',
      'ko': '합성 여호수아나무 목재 의자',
      'zh': '复合约书亚椅',
      'ja': 'Composite Joshua Chair',
    }, {
      'id': 'CompositeJoshuaDoorItem',
      'en': 'Composite Joshua Door',
      'fr': 'Porte en composite de josué',
      'es': 'Puerta de composite (joshua)',
      'de': 'Josua-Verbundholztür',
      'pl': 'Kompozytowe drzwi z drewna jukki',
      'ru': 'Дверь из композита юкки коротколистной',
      'uk': 'Двері з композиту юкки',
      'ko': '합성 여호수아나무 목재 문',
      'zh': '复合约书亚门',
      'ja': 'Composite Joshua Door',
    }, {
      'id': 'CompositeJoshuaLumberItem',
      'en': 'Composite Joshua Lumber',
      'fr': 'Bois composite en josué',
      'es': 'Tronco de árbol de Josué (composite)',
      'de': 'Josua-Verbundholz',
      'pl': 'Kompozytowa tarcica z jukki',
      'ru': 'Композитные пиломатериалы из юкки',
      'uk': 'Композитний пиломатеріал із Карнегі',
      'ko': '여호수아나무 합성 목재',
      'zh': '复合约书亚木材',
      'ja': 'Composite Joshua Lumber',
    }, {
      'id': 'CompositeJoshuaTableItem',
      'en': 'Composite Joshua Table',
      'fr': 'Table en composite de josué',
      'es': 'Mesa de composite (joshua)',
      'de': 'Josua-Verbundholztisch',
      'pl': 'Kompozytowy stół z drewna jukki',
      'ru': 'Стол из композита юкки коротколистной',
      'uk': 'Стіл із композиту юкки',
      'ko': '합성 여호수아나무 목재 탁자',
      'zh': '复合约书亚桌',
      'ja': 'Composite Joshua Table',
    }, {
      'id': 'CompositeLumberItem',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'Tronco (composite)',
      'de': 'Verbundholz',
      'pl': 'Kompozytowe drewno',
      'ru': 'Композитные пиломатериалы',
      'uk': 'Композитні пиломатеріали',
      'ko': '가공된 합성 목재',
      'zh': '复合木材',
      'ja': 'Composite Lumber',
    }, {
      'id': 'CompositeLumber',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'Tronco (composite)',
      'de': 'Verbundholz',
      'pl': 'Kompozytowe drewno',
      'ru': 'Композитные пиломатериалы',
      'uk': 'Композитні пиломатеріали',
      'ko': '가공된 합성 목재',
      'zh': '复合木材',
      'ja': 'Composite Lumber',
    }, {
      'id': 'CompositeLumberBenchItem',
      'en': 'Composite Lumber Bench',
      'fr': 'Banc en composite',
      'es': 'Banco de composite (básica)',
      'de': 'Verbundholz-Bank',
      'pl': 'Kompozytowa ławka z drewna',
      'ru': 'Лавка из композитов',
      'uk': 'Лавка з композитних пиломатеріалів',
      'ko': '합성 가공 목재 벤치',
      'zh': '复合木材长凳',
      'ja': 'Composite Lumber Bench',
    }, {
      'id': 'CompositeLumberChairItem',
      'en': 'Composite Lumber Chair',
      'fr': 'Chaise en composite',
      'es': 'Silla de composite (básica)',
      'de': 'Verbundholz-Stuhl',
      'pl': 'Kompozytowe krzesło z drewna',
      'ru': 'Стул из композитов',
      'uk': 'Стілець із композитних пиломатеріалів',
      'ko': '합성 가공 목재 의자',
      'zh': '复合木椅',
      'ja': 'Composite Lumber Chair',
    }, {
      'id': 'CompositeLumberDoorItem',
      'en': 'Composite Lumber Door',
      'fr': 'Porte en composite',
      'es': 'Puerta de composite (básica)',
      'de': 'Verbundholz-Tür',
      'pl': 'Kompozytowe drzwi z drewna',
      'ru': 'Дверь из композитов',
      'uk': 'Двері з композитних пиломатеріалів',
      'ko': '합성 가공 목재 문',
      'zh': '复合木门',
      'ja': 'Composite Lumber Door',
    }, {
      'id': 'CompositeLumberTableItem',
      'en': 'Composite Lumber Table',
      'fr': 'Table en composite',
      'es': 'Mesa de composite (básica)',
      'de': 'Verbundholz-Tisch',
      'pl': 'Kompozytowy stół z drewna',
      'ru': 'Стол из композитов',
      'uk': 'Стіл із композитних пиломатеріалів',
      'ko': '합성 가공 목재 탁자',
      'zh': '复合木桌',
      'ja': 'Composite Lumber Table',
    }, {
      'id': 'CompositeOakBenchItem',
      'en': 'Composite Oak Bench',
      'fr': 'Banc en composite de chêne',
      'es': 'Banco de composite (roble)',
      'de': 'Eichen-Verbundholzbank',
      'pl': 'Kompozytowa ławka z dębu',
      'ru': 'Лавка из дубовых композитов',
      'uk': 'Лавка з композиту дуба',
      'ko': '합성 참나무 목재 벤치',
      'zh': '复合橡木长凳',
      'ja': 'Composite Oak Bench',
    }, {
      'id': 'CompositeOakChairItem',
      'en': 'Composite Oak Chair',
      'fr': 'Chaise en composite de chêne',
      'es': 'Silla de composite (roble)',
      'de': 'Eichen-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z dębu',
      'ru': 'Стул из дубовых композитов',
      'uk': 'Стілець із дубових композитів',
      'ko': '합성 참나무 목재 의자',
      'zh': '复合橡木椅子',
      'ja': 'Composite Oak Chair',
    }, {
      'id': 'CompositeOakDoorItem',
      'en': 'Composite Oak Door',
      'fr': 'Porte en composite de chêne',
      'es': 'Puerta de composite (roble)',
      'de': 'Eichen-Verbundholztür',
      'pl': 'Kompozytowe drzwi z dębu',
      'ru': 'Дверь из дубовых композитов',
      'uk': 'Двері з дубових композитів',
      'ko': '합성 참나무 목재 문',
      'zh': '复合橡木门',
      'ja': 'Composite Oak Door',
    }, {
      'id': 'CompositeOakLumberItem',
      'en': 'Composite Oak Lumber',
      'fr': 'Bois composite en chêne',
      'es': 'Tronco de roble (composite)',
      'de': 'Eichen-Verbundholz',
      'pl': 'Kompozytowe drewno z dębu',
      'ru': 'Композитные пиломатериалы из дуба',
      'uk': 'Композитний дубовий пиломатеріал',
      'ko': '참나무 합성 목재',
      'zh': '复合橡木木材',
      'ja': 'Composite Oak Lumber',
    }, {
      'id': 'CompositeOakTableItem',
      'en': 'Composite Oak Table',
      'fr': 'Table en composite de chêne',
      'es': 'Mesa de composite (roble)',
      'de': 'Eichen-Verbundholztisch',
      'pl': 'Kompozytowy stół z dębu',
      'ru': 'Стол из дубовых композитов',
      'uk': 'Стіл із дубових композитів',
      'ko': '합성 참나무 목재 탁자',
      'zh': '复合橡木桌',
      'ja': 'Composite Oak Table',
    }, {
      'id': 'CompositePalmBenchItem',
      'en': 'Composite Palm Bench',
      'fr': 'Banc en composite de palmier',
      'es': 'Banco de composite (palmera)',
      'de': 'Palmen-Verbundholzbank',
      'pl': 'Kompozytowa ławka z palmy',
      'ru': 'Лавка из пальмовых композитов',
      'uk': 'Лавка з композиту пальми',
      'ko': '합성 야자나무 목재 벤치',
      'zh': '复合棕榈长凳',
      'ja': 'Composite Palm Bench',
    }, {
      'id': 'CompositePalmChairItem',
      'en': 'Composite Palm Chair',
      'fr': 'Chaise en composite de palmier',
      'es': 'Silla de composite (palmera)',
      'de': 'Palmen-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z palmy',
      'ru': 'Стул из пальмовых композитов',
      'uk': 'Стілець із композиту пальми',
      'ko': '합성 야자나무 목재 의자',
      'zh': '复合棕榈椅',
      'ja': 'Composite Palm Chair',
    }, {
      'id': 'CompositePalmDoorItem',
      'en': 'Composite Palm Door',
      'fr': 'Porte en composite de palmier',
      'es': 'Puerta de composite (palmera)',
      'de': 'Palmen-Verbundholztür',
      'pl': 'Kompozytowe drzwi z palmy',
      'ru': 'Дверь из пальмовых композитов',
      'uk': 'Двері з композиту пальми',
      'ko': '합성 야자나무 목재 문',
      'zh': '复合棕榈门',
      'ja': 'Composite Palm Door',
    }, {
      'id': 'CompositePalmLumberItem',
      'en': 'Composite Palm Lumber',
      'fr': 'Bois composite en palmier',
      'es': 'Tronco de palmera (composite)',
      'de': 'Palmen-Verbundholz',
      'pl': 'Kompozytowe drewno z palmy',
      'ru': 'Композитные пиломатериалы из пальмы',
      'uk': 'Композитні пальмові пиломатеріали',
      'ko': '야자나무 합성 목재',
      'zh': '复合棕榈木材',
      'ja': 'Composite Palm Lumber',
    }, {
      'id': 'CompositePalmTableItem',
      'en': 'Composite Palm Table',
      'fr': 'Table en composite de palmier',
      'es': 'Mesa de composite (palmera)',
      'de': 'Palmen-Verbundholztisch',
      'pl': 'Kompozytowy stół z palmy',
      'ru': 'Стол из пальмовых композитов',
      'uk': 'Стіл із композиту пальми',
      'ko': '합성 야자나무 목재 탁자',
      'zh': '复合棕榈桌',
      'ja': 'Composite Palm Table',
    }, {
      'id': 'CompositeRedwoodBenchItem',
      'en': 'Composite Redwood Bench',
      'fr': 'Banc en composite de séquoia',
      'es': 'Banco de composite (secuoya)',
      'de': 'Rottanne-Verbundholzbank',
      'pl': 'Kompozytowa ławka z sekwoi',
      'ru': 'Лавка из композита секвойи',
      'uk': 'Лавка з композиту секвої',
      'ko': '합성 삼나무 목재 벤치',
      'zh': '复合红木长凳',
      'ja': 'Composite Redwood Bench',
    }, {
      'id': 'CompositeRedwoodChairItem',
      'en': 'Composite Redwood Chair',
      'fr': 'Chaise en composite de séquoia',
      'es': 'Silla de composite (secuoya)',
      'de': 'Rottanne-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z sekwoi',
      'ru': 'Стул из композита секвойи',
      'uk': 'Стілець із композиту секвої',
      'ko': '합성 삼나무 목재 의자',
      'zh': '复合红木椅子',
      'ja': 'Composite Redwood Chair',
    }, {
      'id': 'CompositeRedwoodDoorItem',
      'en': 'Composite Redwood Door',
      'fr': 'Porte en composite de séquoia',
      'es': 'Puerta de composite (secuoya)',
      'de': 'Rottanne-Verbundholztür',
      'pl': 'Kompozytowe drzwi z sekwoi',
      'ru': 'Дверь из композита секвойи',
      'uk': 'Двері з композиту секвої',
      'ko': '합성 삼나무 목재 문',
      'zh': '复合红木门',
      'ja': 'Composite Redwood Door',
    }, {
      'id': 'CompositeRedwoodLumberItem',
      'en': 'Composite Redwood Lumber',
      'fr': 'Bois composite en séquoia',
      'es': 'Tronco de secuoya (composite)',
      'de': 'Rottannen-Verbundholz',
      'pl': 'Kompozytowe drewno z sekwoi',
      'ru': 'Композитные пиломатериалы из секвойи',
      'uk': 'Композитні пиломатеріали червоного дерева',
      'ko': '삼나무 합성 목재',
      'zh': '复合红木木材',
      'ja': 'Composite Redwood Lumber',
    }, {
      'id': 'CompositeRedwoodTableItem',
      'en': 'Composite Redwood Table',
      'fr': 'Table en composite de séquoia',
      'es': 'Mesa de composite (secuoya)',
      'de': 'Rottanne-Verbundholztisch',
      'pl': 'Kompozytowy stół z sekwoi',
      'ru': 'Стол из композита секвойи',
      'uk': 'Стіл із композиту секвої',
      'ko': '합성 삼나무 목재 탁자',
      'zh': '复合红木桌',
      'ja': 'Composite Redwood Table',
    }, {
      'id': 'CompositeSaguaroBenchItem',
      'en': 'Composite Saguaro Bench',
      'fr': 'Banc en composite de saguaro',
      'es': 'Banco de composite (saguaro)',
      'de': 'Kaktus-Verbundholzbank',
      'pl': 'Kompozytowa ławka z saguaro',
      'ru': 'Лавка из композита карнегии',
      'uk': 'Лавка з композиту карнегії',
      'ko': '합성 사와로 골재 벤치',
      'zh': '复合仙人掌凳',
      'ja': 'Composite Saguaro Bench',
    }, {
      'id': 'CompositeSaguaroChairItem',
      'en': 'Composite Saguaro Chair',
      'fr': 'Chaise en composite de saguaro',
      'es': 'Silla de composite (saguaro)',
      'de': 'Kaktus-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z saguaro',
      'ru': 'Стул из композита карнегии',
      'uk': 'Стілець із композиту карнегії',
      'ko': '합성 사와로 골재 의자',
      'zh': '复合仙人掌椅',
      'ja': 'Composite Saguaro Chair',
    }, {
      'id': 'CompositeSaguaroDoorItem',
      'en': 'Composite Saguaro Door',
      'fr': 'Porte en composite de saguaro',
      'es': 'Puerta de composite (saguaro)',
      'de': 'Kaktus-Verbundholztür',
      'pl': 'Kompozytowe drzwi z saguaro',
      'ru': 'Дверь из композита карнегии',
      'uk': 'Двері з композиту карнегії',
      'ko': '합성 사와로 골재 문',
      'zh': '复合柱瓜门',
      'ja': 'Composite Saguaro Door',
    }, {
      'id': 'CompositeSaguaroLumberItem',
      'en': 'Composite Saguaro Lumber',
      'fr': 'Bois composite en saguaro',
      'es': 'Tronco de composite (saguaro)',
      'de': 'Kaktus-Verbundholz',
      'pl': 'Kompozytowe drewno z saguaro',
      'ru': 'Композитные пиломатериалы из карнегии',
      'uk': 'Композитний пиломатеріал із Карнегі',
      'ko': '사구로 합성 목재',
      'zh': '复合柱瓜木材',
      'ja': 'Composite Saguaro Lumber',
    }, {
      'id': 'CompositeSaguaroTableItem',
      'en': 'Composite Saguaro Table',
      'fr': 'Table en composite de saguaro',
      'es': 'Mesa de composite (saguaro)',
      'de': 'Kaktus-Verbundholztisch',
      'pl': 'Kompozytowy stół z saguaro',
      'ru': 'Стол из композита карнегии',
      'uk': 'Стіл із композита карнегії',
      'ko': '합성 사와로 골재 탁자',
      'zh': '复合柱仙人掌桌',
      'ja': 'Composite Saguaro Table',
    }, {
      'id': 'CompositeSoftwoodBenchItem',
      'en': 'Composite Softwood Bench',
      'fr': 'Banc en composite de tendre',
      'es': 'Banco de composite (madera blanda)',
      'de': 'Weichholz-Verbundholzbank',
      'pl': 'Kompozytowa ławka z drewna iglastego',
      'ru': 'Лавка из композита хвойных пород',
      'uk': 'Композитна лавка із хвойних дерев',
      'ko': '합성 연목재 벤치',
      'zh': '复合软木凳',
      'ja': 'Composite Softwood Bench',
    }, {
      'id': 'CompositeSoftwoodChairItem',
      'en': 'Composite Softwood Chair',
      'fr': 'Chaise en composite de bois tendre',
      'es': 'Silla de composite (madera blanda)',
      'de': 'Weichholz-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło z drewna iglastego',
      'ru': 'Стул из композита хвойных пород',
      'uk': 'Композитний стілець із хвойних дерев',
      'ko': '합성 연목재 의자',
      'zh': '复合软木椅子',
      'ja': 'Composite Softwood Chair',
    }, {
      'id': 'CompositeSoftwoodDoorItem',
      'en': 'Composite Softwood Door',
      'fr': 'Porte en composite de bois tendre',
      'es': 'Puerta de composite (madera blanda)',
      'de': 'Weichholz-Verbundholztür',
      'pl': 'Kompozytowe drzwi z drewna iglastego',
      'ru': 'Дверь из композита хвойных пород',
      'uk': 'Композитні двері із хвойних дерев',
      'ko': '합성 연목재 문',
      'zh': '复合软木门',
      'ja': 'Composite Softwood Door',
    }, {
      'id': 'CompositeSoftwoodTableItem',
      'en': 'Composite Softwood Table',
      'fr': 'Table en composite de bois tendre',
      'es': 'Mesa de composite (madera blanda)',
      'de': 'Weichholz-Verbundholztisch',
      'pl': 'Kompozytowy stół z drewna iglastego',
      'ru': 'Стол из композита хвойных пород',
      'uk': 'Композитний стіл із хвойних дерев',
      'ko': '합성 연목재 탁자',
      'zh': '复合软木桌',
      'ja': 'Composite Softwood Table',
    }, {
      'id': 'CompositeSpruceBenchItem',
      'en': 'Composite Spruce Bench',
      'fr': 'Banc en composite d\u0027épicéa',
      'es': 'Banco de composite (pícea)',
      'de': 'Fichte-Verbundholzbank',
      'pl': 'Ławka Ze Świerku',
      'ru': 'Лавка из елового композита',
      'uk': 'Ялинова композитна лавка',
      'ko': '합성 가문비 목재 벤치',
      'zh': '复合云杉长凳',
      'ja': 'Composite Spruce Bench',
    }, {
      'id': 'CompositeSpruceChairItem',
      'en': 'Composite Spruce Chair',
      'fr': 'Chaise en composite d\u0027épicéa',
      'es': 'Silla de composite (pícea)',
      'de': 'Fichte-Verbundholzstuhl',
      'pl': 'Kompozytowe krzesło ze świerku',
      'ru': 'Стул из елового композита',
      'uk': 'Ялиновий композитний стілець',
      'ko': '합성 가문비 목재 의자',
      'zh': '复合云杉椅',
      'ja': 'Composite Spruce Chair',
    }, {
      'id': 'CompositeSpruceDoorItem',
      'en': 'Composite Spruce Door',
      'fr': 'Porte en composite d\u0027épicéa',
      'es': 'Puerta de composite (pícea)',
      'de': 'Fichte-Verbundholztür',
      'pl': 'Kompozytowe drzwi ze świerku',
      'ru': 'Дверь из елового композита',
      'uk': 'Ялинові композитні двері',
      'ko': '합성 가문비 목재 문',
      'zh': '复合云杉门',
      'ja': 'Composite Spruce Door',
    }, {
      'id': 'CompositeSpruceLumberItem',
      'en': 'Composite Spruce Lumber',
      'fr': 'Bois composite en épicéa',
      'es': 'Tronco de composite (pícea)',
      'de': 'Fichten-Verbundholz',
      'pl': 'Kompozytowe drewno ze świerku',
      'ru': 'Композитные пиломатериалы из ели',
      'uk': 'Ялиновий композитний стіл',
      'ko': '가문비나무 합성 목재',
      'zh': '复合云杉木材',
      'ja': 'Composite Spruce Lumber',
    }, {
      'id': 'CompositeSpruceTableItem',
      'en': 'Composite Spruce Table',
      'fr': 'Table en composite d\u0027épicéa',
      'es': 'Mesa de composite (pícea)',
      'de': 'Fichte-Verbundholztisch',
      'pl': 'Kompozytowy stół ze świerku',
      'ru': 'Стол из елового композита',
      'uk': 'Ялиновий композитний стіл',
      'ko': '합성 가문비 목재 탁자',
      'zh': '复合云杉桌',
      'ja': 'Composite Spruce Table',
    }, {
      'id': 'CompositesUpgradeItem',
      'en': 'Composites Upgrade',
      'fr': 'Amélioration Moderne : Composites',
      'es': 'Mejora: Composites',
      'de': 'Upgrade Verbundhölzer',
      'pl': 'Ulepszenie Kompozytów',
      'ru': 'Улучшение для изготовления композитов',
      'uk': 'Покращення сполук',
      'ko': '복합 목재 기술 업그레이드',
      'zh': '复合材料升级',
      'ja': '複合材アップグレード',
    }, {
      'id': 'CompostItem',
      'en': 'Compost',
      'fr': 'Compost',
      'es': 'Abono',
      'de': 'Kompost',
      'pl': 'Kompost',
      'ru': 'Компост',
      'uk': 'Перегній',
      'ko': '퇴비',
      'zh': '堆肥',
      'ja': '堆肥',
    }, {
      'id': 'CompostFertilizerItem',
      'en': 'Compost Fertilizer',
      'fr': 'Engrais de compost',
      'es': 'Fertilizante de abono orgánico',
      'de': 'Dünger aus Kompost',
      'pl': 'Compost Fertilizer',
      'ru': 'Компостное удобрение',
      'uk': 'Компостне добриво',
      'ko': '퇴비 비료',
      'zh': '堆肥',
      'ja': '堆肥',
    }, {
      'id': 'ComputerLabItem',
      'en': 'Computer Lab',
      'fr': 'Ordinateur de contrôle',
      'es': 'Laboratorio de Computación',
      'de': 'Computerlabor',
      'pl': 'Laboratorium komputerowe',
      'ru': 'Компьютерная лаборатория',
      'uk': 'Комп’ютерна лабораторія',
      'ko': '컴퓨터 연구대',
      'zh': '实验室电脑',
      'ja': 'コンピューター室',
    }, {
      'id': 'Concrete',
      'en': 'Concrete',
      'fr': 'Béton',
      'es': 'Hormigón',
      'de': 'Beton',
      'pl': 'Beton',
      'ru': 'Цемент',
      'uk': 'Бетон',
      'ko': '콘크리트',
      'zh': '混凝土',
      'ja': 'コンクリート',
    }, {
      'id': 'ConstructionPostItem',
      'en': 'Construction Post',
      'fr': 'Piquet de construction',
      'es': 'Poste de Construcción',
      'de': 'Baupfosten',
      'pl': 'Stanowisko Budowlane',
      'ru': 'Строительный знак',
      'uk': 'Будівельний знак',
      'ko': '건설계약 기둥',
      'zh': '建筑标识',
      'ja': '建設標識',
    }, {
      'id': 'ContractBoardItem',
      'en': 'Contract Board',
      'fr': 'Tableau de contrats',
      'es': 'Tablero de Contratos',
      'de': 'Anschlagbrett',
      'pl': 'Tablica Zleceń',
      'ru': 'Доска объявлений',
      'uk': 'Дошка договорів',
      'ko': '계약 게시판',
      'zh': '合同公告板',
      'ja': '契約掲示板',
    }, {
      'id': 'CookeinaMushroomSporesItem',
      'en': 'Cookeina Mushroom Spores',
      'fr': 'Spores de cookeina',
      'es': 'Esporas de seta copa',
      'de': 'Sporen (Cookeina)',
      'pl': 'Zarodniki Grzybów Czarkowatych',
      'ru': 'Споры кукейны',
      'uk': 'Спори гриба кукейн',
      'ko': '술잔버섯 포자',
      'zh': '蘑菇孢子',
      'ja': 'クキーナキノコの胞子',
    }, {
      'id': 'CookeinaMushroomsItem',
      'en': 'Cookeina Mushrooms',
      'fr': 'Cookeinas',
      'es': 'Setas copa',
      'de': 'Cookeina',
      'pl': 'Cookeina Mushrooms',
      'ru': 'Кукейна',
      'uk': 'Гриби кукейн',
      'ko': '술잔버섯',
      'zh': '大孢毛菇',
      'ja': 'クキーナキノコ',
    }, {
      'id': 'CookingUpgradeItem',
      'en': 'Cooking Upgrade',
      'fr': 'Amélioration Avancée : Cuisine',
      'es': 'Mejora: Cocina',
      'de': 'Fortschrittliches Upgrade: Kochen',
      'pl': 'Ulepszenie Gotowania',
      'ru': 'Улучшение для готовки',
      'uk': 'Покращення приготування їжі',
      'ko': '요리 기술 업그레이드',
      'zh': '烹饪升级',
      'ja': 'Cooking Upgrade',
    }, {
      'id': 'CopperBarItem',
      'en': 'Copper Bar',
      'fr': 'Lingot de cuivre',
      'es': 'Barra de cobre',
      'de': 'Kupferbarren',
      'pl': 'Sztabka miedzi',
      'ru': 'Медный брусок',
      'uk': 'Мідний брусок',
      'ko': '구리괴',
      'zh': '铜条',
      'ja': '銅インゴット',
    }, {
      'id': 'CopperConcentrateItem',
      'en': 'Copper Concentrate',
      'fr': 'Concentré de cuivre',
      'es': 'Concentrado de cobre',
      'de': 'Kupferkonzentrat',
      'pl': 'Miedziany koncentrat',
      'ru': 'Концентрат меди',
      'uk': 'Концентрат міді',
      'ko': '정제된 구리 광석',
      'zh': '筛选铜矿石',
      'ja': 'Copper Concentrate',
    }, {
      'id': 'CopperOreItem',
      'en': 'Copper Ore',
      'fr': 'Minerai de cuivre',
      'es': 'Mineral de Cobre',
      'de': 'Kupfererz',
      'pl': 'Ruda miedzi',
      'ru': 'Медная руда',
      'uk': 'Мідна руда',
      'ko': '구리 광석',
      'zh': '铜矿',
      'ja': '銅鉱石',
    }, {
      'id': 'CopperPipeItem',
      'en': 'Copper Pipe',
      'fr': 'Tuyau en cuivre',
      'es': 'Tubo de Cobre',
      'de': 'Kupferrohr',
      'pl': 'Miedziana rura',
      'ru': 'Медная труба',
      'uk': 'Мідна труба',
      'ko': '구리 파이프',
      'zh': '铜管',
      'ja': '銅パイプ',
    }, {
      'id': 'CopperWiringItem',
      'en': 'Copper Wiring',
      'fr': 'Fil de cuivre',
      'es': 'Cableado de Cobre',
      'de': 'Kupferkabel',
      'pl': 'Miedziane przewody',
      'ru': 'Медный провод',
      'uk': 'Мідний дріт',
      'ko': '구리선',
      'zh': '铜线',
      'ja': '銅線',
    }, {
      'id': 'CornItem',
      'en': 'Corn',
      'fr': 'Maïs',
      'es': 'Maíz',
      'de': 'Mais',
      'pl': 'Kukurydza',
      'ru': 'Кукуруза',
      'uk': 'Кукурудза',
      'ko': '옥수수',
      'zh': '玉米',
      'ja': 'トウモロコシ',
    }, {
      'id': 'CornFrittersItem',
      'en': 'Corn Fritters',
      'fr': 'Beignets de maïs',
      'es': 'Buñuelos de maíz',
      'de': 'Frittierter Mais',
      'pl': 'Kukurydza w cieście',
      'ru': 'Кукурузные оладьи',
      'uk': 'Кукурудзяні оладки',
      'ko': '옥수수튀김',
      'zh': '玉米煎饼',
      'ja': 'Kukurydza w cieście',
    }, {
      'id': 'CornSeedItem',
      'en': 'Corn Seed',
      'fr': 'Graine de maïs',
      'es': 'Semilla de Maíz',
      'de': 'Samen (Mais)',
      'pl': 'Nasiona Kukurydzy',
      'ru': 'Семечко кукурузы',
      'uk': 'Насіння кукурудзи',
      'ko': '옥수수 씨앗',
      'zh': '玉米种子',
      'ja': 'トウモロコシの種',
    }, {
      'id': 'CornStarchItem',
      'en': 'Corn Starch',
      'fr': 'Fécule de maïs',
      'es': 'Almidón de maíz',
      'de': 'Maisstärke',
      'pl': 'Mąka kukurydziana',
      'ru': 'Кукурузный крахмал',
      'uk': 'Кукурудзяний крохмаль',
      'ko': '옥수수 녹말풀',
      'zh': '玉米淀粉',
      'ja': 'Mąka kukurydziana',
    }, {
      'id': 'CornmealItem',
      'en': 'Cornmeal',
      'fr': 'Farine de maïs',
      'es': 'Harina de Maíz',
      'de': 'Maismehl',
      'pl': 'Kasza kukurydziana',
      'ru': 'Кукурузная мука',
      'uk': 'Кукурудзянe борошно',
      'ko': '옥수수 가루',
      'zh': '玉米粉',
      'ja': 'Kasza kukurydziana',
    }, {
      'id': 'CorrugatedSteelItem',
      'en': 'Corrugated Steel',
      'fr': 'Tôle ondulée',
      'es': 'Acero Corrugado',
      'de': 'Wellblech',
      'pl': 'Stal ryflowana',
      'ru': 'Гофрированная сталь',
      'uk': 'Гофрована сталь',
      'ko': '파형 강철판',
      'zh': '波纹钢',
      'ja': '波形鋼',
    }, {
      'id': 'CorrugatedSteelDoorItem',
      'en': 'Corrugated Steel Door',
      'fr': 'Porte en tôle ondulée',
      'es': 'Puerta (acero corrugado)',
      'de': 'Wellstahltür',
      'pl': 'Corrugated Steel Door',
      'ru': 'Дверь из гофрированной стали',
      'uk': 'Corrugated Steel Door',
      'ko': '골판지 강철 문',
      'zh': '波纹钢制门',
      'ja': 'Corrugated Steel Door',
    }, {
      'id': 'CorrugatedSteelFenceDoorItem',
      'en': 'Corrugated Steel Fence Door',
      'fr': 'Porte de clôture en tôle ondulée',
      'es': 'Puerta de valla (acero corrugado)',
      'de': 'Wellstahl Gittertür',
      'pl': 'Corrugated Steel Fence Door',
      'ru': 'Дверь из решетки гофрированной стали',
      'uk': 'Corrugated Steel Fence Door',
      'ko': '골판지 강철 울타리 문',
      'zh': '波纹钢制栅栏门',
      'ja': 'Corrugated Steel Fence Door',
    }, {
      'id': 'CottonBollItem',
      'en': 'Cotton Boll',
      'fr': 'Capsule de coton',
      'es': 'Bellota de algodón',
      'de': 'Baumwoll Samenkapsel',
      'pl': 'Cotton Boll',
      'ru': 'Хлопковая коробочка',
      'uk': 'Cotton Boll',
      'ko': '코튼 볼',
      'zh': '棉桃',
      'ja': 'Cotton Boll',
    }, {
      'id': 'CottonCarpetItem',
      'en': 'Cotton Carpet',
      'fr': 'Tapis en coton',
      'es': 'Alfombra de algodón',
      'de': 'Baumwollteppich',
      'pl': 'Cotton Carpet',
      'ru': 'Хлопковый ковер',
      'uk': 'Cotton Carpet',
      'ko': '면 카펫',
      'zh': '棉制地毯',
      'ja': 'Cotton Carpet',
    }, {
      'id': 'CottonCurtainsItem',
      'en': 'Cotton Curtains',
      'fr': 'Rideaux en coton',
      'es': 'Cortinas de algodón',
      'de': 'Baumwollvorhänge',
      'pl': 'Cotton Curtains',
      'ru': 'Хлопковые шторы',
      'uk': 'Cotton Curtains',
      'ko': '면 커튼',
      'zh': '棉制窗帘',
      'ja': 'Cotton Curtains',
    }, {
      'id': 'CottonFabricItem',
      'en': 'Cotton Fabric',
      'fr': 'Tissu en coton',
      'es': 'Tela de algodón',
      'de': 'Baumwollstoff',
      'pl': 'Cotton Fabric',
      'ru': 'Хлопковая ткань',
      'uk': 'Cotton Fabric',
      'ko': '코튼 원단',
      'zh': '棉织物',
      'ja': 'Cotton Fabric',
    }, {
      'id': 'CottonSeedItem',
      'en': 'Cotton Seed',
      'fr': 'Graine de coton',
      'es': 'Semilla de algodón',
      'de': 'Samen (Baumwollpflanze)',
      'pl': 'Cotton Seed',
      'ru': 'Семечко хлопка',
      'uk': 'Cotton Seed',
      'ko': '목화씨',
      'zh': '棉花种子',
      'ja': 'Cotton Seed',
    }, {
      'id': 'CottonThreadItem',
      'en': 'Cotton Thread',
      'fr': 'Fil de coton',
      'es': 'Fibra de algodón',
      'de': 'Baumwollfaden',
      'pl': 'Cotton Thread',
      'ru': 'Хлопковая нить',
      'uk': 'Cotton Thread',
      'ko': '면사',
      'zh': '棉线',
      'ja': 'Cotton Thread',
    }, {
      'id': 'CouchItem',
      'en': 'Couch',
      'fr': 'Canapé',
      'es': 'Sofá',
      'de': 'Sofa',
      'pl': 'Kanapa',
      'ru': 'Диван',
      'uk': 'Диван',
      'ko': '소파',
      'zh': '沙发',
      'ja': 'ソファ',
    }, {
      'id': 'CourtItem',
      'en': 'Court',
      'fr': 'Tribunal',
      'es': 'Corte',
      'de': 'Parlament',
      'pl': 'Sąd',
      'ru': 'Суд',
      'uk': 'Суд',
      'ko': '법원',
      'zh': '法庭',
      'ja': 'Court',
    }, {
      'id': 'CoyoteCarcassItem',
      'en': 'Coyote Carcass',
      'fr': 'Cadavre de coyote',
      'es': 'Cadáver de coyote',
      'de': 'Kojotenkadaver',
      'pl': 'Tusza kojota',
      'ru': 'Туша койота',
      'uk': 'Туша койота',
      'ko': '코요테 사체',
      'zh': '郊狼遗骸',
      'ja': 'Coyote Carcass',
    }, {
      'id': 'CrabCarcassItem',
      'en': 'Crab Carcass',
      'fr': 'Cadavre de crabe',
      'es': 'Cadáver de cangrejo',
      'de': 'Krabbenkadaver',
      'pl': 'Tusza craba',
      'ru': 'Туша краба',
      'uk': 'Туша краба',
      'ko': '게 사체',
      'zh': '螃蟹遗骸',
      'ja': 'Crab Carcass',
    }, {
      'id': 'CrabPotItem',
      'en': 'Crab Pot',
      'fr': 'Casier à crabes',
      'es': 'Cazuela de cangrejo',
      'de': 'Krabbentopf',
      'pl': 'Crab Pot',
      'ru': 'Ловушка для крабов',
      'uk': 'Crab Pot',
      'ko': '게 냄비',
      'zh': '蟹笼',
      'ja': 'Crab Pot',
    }, {
      'id': 'Crafting Table',
      'en': 'Crafting Table',
      'fr': 'Table de fabrication',
      'es': 'Mesa de trabajo',
      'de': 'Herstellungstisch',
      'pl': 'Stół rzemieślniczy',
      'ru': 'Верстак',
      'uk': 'Верстат',
      'ko': '제작 작업대',
      'zh': '手工桌',
      'ja': 'Crafting Table',
    }, {
      'id': 'CraneItem',
      'en': 'Crane',
      'fr': 'Grue',
      'es': 'Grúa',
      'de': 'Kran',
      'pl': 'Dźwig',
      'ru': 'Кран',
      'uk': 'Кран',
      'ko': '크레인',
      'zh': '起重机',
      'ja': 'クレーン',
    }, {
      'id': 'CreosoteBushSeedItem',
      'en': 'Creosote Bush Seed',
      'fr': 'Graine de créosotier',
      'es': 'Semilla de planta gobernadora',
      'de': 'Samen (Kreosotbusch)',
      'pl': 'Nasiona Trójnika Pustynnego',
      'ru': 'Семечко ларреи',
      'uk': 'Насіння креозотового куща',
      'ko': '크레오소트 덤불 씨앗',
      'zh': '灌木种子',
      'ja': 'クレオソートブッシュの種',
    }, {
      'id': 'CriminiMushroomSporesItem',
      'en': 'Crimini Mushroom Spores',
      'fr': 'Spores de champignon de Paris',
      'es': 'Esporas de Champiñón Común',
      'de': 'Sporen (Champignon)',
      'pl': 'Zarodniki Pieczarki',
      'ru': 'Споры шампиньонов',
      'uk': 'Спори печериць',
      'ko': '양송이버섯 포자',
      'zh': '香啡菇孢子',
      'ja': 'マッシュルームの胞子',
    }, {
      'id': 'CriminiMushroomsItem',
      'en': 'Crimini Mushrooms',
      'fr': 'Champignons de Paris',
      'es': 'Champiñón Común',
      'de': 'Champignons',
      'pl': 'Pieczarki',
      'ru': 'Шампиньоны',
      'uk': 'Печериці',
      'ko': '양송이버섯',
      'zh': '香啡菇',
      'ja': 'マッシュルーム',
    }, {
      'id': 'CrimsonSaladItem',
      'en': 'Crimson Salad',
      'fr': 'Salade cramoisie',
      'es': 'Ensalada Carmesí',
      'de': 'Purpursalat',
      'pl': 'Karmazynowa sałatka',
      'ru': 'Винегрет',
      'uk': 'Вінегрет',
      'ko': '붉은 채소 샐러드',
      'zh': '深红沙拉',
      'ja': 'Karmazynowa sałatka',
    }, {
      'id': 'CrispyBaconItem',
      'en': 'Crispy Bacon',
      'fr': 'Bacon croustillant',
      'es': 'Tocino Crujiente',
      'de': 'Knuspriger Speck',
      'pl': 'Chrupiący boczek',
      'ru': 'Хрустящий бекон',
      'uk': 'Хрусткий бекон',
      'ko': '바삭한 베이컨',
      'zh': '香脆培根',
      'ja': 'カリカリに焼いたベーコン',
    }, {
      'id': 'Crop',
      'en': 'Crop',
      'fr': 'Culture',
      'es': 'Cultivo',
      'de': 'Ernte',
      'pl': 'Crop',
      'ru': 'Урожай',
      'uk': 'Зернові',
      'ko': '작물',
      'zh': '作物',
      'ja': '作物',
    }, {
      'id': 'CropSeed',
      'en': 'Crop Seed',
      'fr': 'Graine de culture',
      'es': 'Semilla de Cultivo',
      'de': 'Erntesamen',
      'pl': 'Crop Seed',
      'ru': 'Урожай',
      'uk': 'Crop Seed',
      'ko': 'Crop Seed',
      'zh': '作物种子',
      'ja': 'Crop Seed',
    }, {
      'id': 'CrushedBasaltItem',
      'en': 'Crushed Basalt',
      'fr': 'Basalte concassé',
      'es': 'Basalto triturado',
      'de': 'Zerkleinerter Basalt',
      'pl': 'Pokruszony bazalt',
      'ru': 'Базальтовый щебень',
      'uk': 'Подрібнений базальт',
      'ko': '파쇄된 현무암',
      'zh': '破碎玄武岩',
      'ja': 'Crushed Basalt',
    }, {
      'id': 'CrushedCoalItem',
      'en': 'Crushed Coal',
      'fr': 'Charbon concassé',
      'es': 'Carbón triturado',
      'de': 'Zerkleinerte Kohle',
      'pl': 'Pokruszony węgiel',
      'ru': 'Дроблёный уголь',
      'uk': 'Подрібнене вугілля',
      'ko': '파쇄된 석탄',
      'zh': '破碎煤矿石',
      'ja': 'Crushed Coal',
    }, {
      'id': 'CrushedCopperOreItem',
      'en': 'Crushed Copper Ore',
      'fr': 'Minerai de cuivre concassé',
      'es': 'Mineral de cobre triturado',
      'de': 'Zerkleinertes Kupfererz',
      'pl': 'Pokruszona ruda miedzi',
      'ru': 'Дроблёная медная руда',
      'uk': 'Подрібнена мідна руда',
      'ko': '파쇄된 구리 광석',
      'zh': '破碎铜矿石',
      'ja': 'Crushed Copper Ore',
    }, {
      'id': 'CrushedGneissItem',
      'en': 'Crushed Gneiss',
      'fr': 'Gneiss concassé',
      'es': 'Gneis triturada',
      'de': 'Zerkleinerter Gneis',
      'pl': 'Pokruszony gnejs',
      'ru': 'Щебень из гнейса',
      'uk': 'Подрібнений гнейс',
      'ko': '파쇄된 편마암',
      'zh': '破碎片麻岩',
      'ja': 'Crushed Gneiss',
    }, {
      'id': 'CrushedGoldOreItem',
      'en': 'Crushed Gold Ore',
      'fr': 'Minerai d\u0027or concassé',
      'es': 'Mineral de oro triturado',
      'de': 'Zerkleinertes Golderz',
      'pl': 'Pokruszona ruda złota',
      'ru': 'Дроблёная золотая руда',
      'uk': 'Подрібнена золота руда',
      'ko': '파쇄된 금광석',
      'zh': '破碎金矿石',
      'ja': 'Crushed Gold Ore',
    }, {
      'id': 'CrushedGraniteItem',
      'en': 'Crushed Granite',
      'fr': 'Granit concassé',
      'es': 'Granito triturado',
      'de': 'Zerkleinerter Granit',
      'pl': 'Pokruszony granit',
      'ru': 'Гранитный щебень',
      'uk': 'Подрібнений граніт',
      'ko': '파쇄된 화강암',
      'zh': '破碎花岗岩',
      'ja': 'Crushed Granite',
    }, {
      'id': 'CrushedIronOreItem',
      'en': 'Crushed Iron Ore',
      'fr': 'Minerai de fer concassé',
      'es': 'Mineral de hierro triturado',
      'de': 'Zerkleinertes Eisenerz',
      'pl': 'Pokruszona ruda żelaza',
      'ru': 'Дроблёная железная руда',
      'uk': 'Подрібнена залізна руда',
      'ko': '파쇄된 철광석',
      'zh': '破碎铁矿石',
      'ja': 'Crushed Iron Ore',
    }, {
      'id': 'CrushedLimestoneItem',
      'en': 'Crushed Limestone',
      'fr': 'Calcaire concassé',
      'es': 'Piedra caliza triturada',
      'de': 'Zerkleinerter Kalkstein',
      'pl': 'Pokruszony wapień',
      'ru': 'Известняковый щебень',
      'uk': 'Вапняковий щебінь',
      'ko': '파쇄된 석회암',
      'zh': '破碎石灰岩',
      'ja': 'Crushed Limestone',
    }, {
      'id': 'CrushedMixedRockItem',
      'en': 'Crushed Mixed Rock',
      'fr': 'Mélange de pierres concassées',
      'es': 'Mezcla de rocas triturada',
      'de': 'Zerstoßener gemischter Stein',
      'pl': 'Crushed Mixed Rock',
      'ru': 'Дробленый Смешанный Камень',
      'uk': 'Crushed Mixed Rock',
      'ko': '으깬 혼합 바위',
      'zh': '压碎的混合岩石',
      'ja': 'Crushed Mixed Rock',
    }, {
      'id': 'CrushedOilShaleItem',
      'en': 'Crushed Oil Shale',
      'fr': 'Schiste bitumineux concassé',
      'es': 'Pizarra bituminosa triturada',
      'de': 'Zerkleinertes Ölschiefer',
      'pl': 'Pokruszony łupek naftowy',
      'ru': 'Дроблёный нефтяной сланец',
      'uk': 'Подрібнений нафтовий сланець',
      'ko': '파쇄된 유혈암',
      'zh': '破碎油页岩',
      'ja': 'Crushed Oil Shale',
    }, {
      'id': 'CrushedRock',
      'en': 'Crushed Rock',
      'fr': 'Pierre concassée',
      'es': 'Roca triturada',
      'de': 'Zerkleinerter Stein',
      'pl': 'Pokruszona skała',
      'ru': 'Щебень',
      'uk': 'Щебінь',
      'ko': '으깬 바위',
      'zh': '破碎岩石',
      'ja': 'Crushed Rock',
    }, {
      'id': 'CrushedSandstoneItem',
      'en': 'Crushed Sandstone',
      'fr': 'Grès concassé',
      'es': 'Arenisca triturada',
      'de': 'Zerkleinerter Sandstein',
      'pl': 'Pokruszony piaskowiec',
      'ru': 'Щебень из песчаника',
      'uk': 'Подрібнений піщаник',
      'ko': '파쇄된 사암',
      'zh': '破碎砂岩',
      'ja': 'Crushed Sandstone',
    }, {
      'id': 'CrushedShaleItem',
      'en': 'Crushed Shale',
      'fr': 'Schiste concassé',
      'es': 'Pizarra triturada',
      'de': 'Zerkleinerter Schiefer',
      'pl': 'Pokruszony łupek',
      'ru': 'Сланцевый щебень',
      'uk': 'Подрібнений сланець',
      'ko': '파쇄된 이판암',
      'zh': '破碎页岩',
      'ja': 'Crushed Shale',
    }, {
      'id': 'CrushedSlagItem',
      'en': 'Crushed Slag',
      'fr': 'Scorie concassé',
      'es': 'Escoria triturada',
      'de': 'Zerkleinerte Schlacke',
      'pl': 'Pokruszony żużel',
      'ru': 'Дроблёный шлак',
      'uk': 'Подрібнена окалина',
      'ko': '파쇄된 광물 찌꺼지',
      'zh': '破碎矿渣',
      'ja': 'Crushed Slag',
    }, {
      'id': 'CrushedStoneItem',
      'en': 'Crushed Stone',
      'fr': 'Pierre concassée',
      'es': 'Piedra triturada',
      'de': 'Schotter',
      'pl': 'Pokruszony kamień',
      'ru': 'Щебень',
      'uk': 'Щебінь',
      'ko': '파쇄된 돌',
      'zh': '破碎岩石',
      'ja': 'Crushed Stone',
    }, {
      'id': 'CulinaryResearchPaperAdvancedItem',
      'en': 'Culinary Research Paper Advanced',
      'fr': 'Papier de recherche : Culinaire avancé',
      'es': 'Trabajo de investigación culinaria (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Kochkunst',
      'pl': 'Culinary Research Paper Advanced',
      'ru': 'Исследование по продвинутой кулинарии',
      'uk': 'Дослідження вдосконаленої кулінарії',
      'ko': '고급 요리 연구지',
      'zh': '高级烹饪研究论文',
      'ja': 'Culinary Research Paper Advanced',
    }, {
      'id': 'CulinaryResearchPaperBasicItem',
      'en': 'Culinary Research Paper Basic',
      'fr': 'Papier de recherche : Culinaire basique',
      'es': 'Trabajo de investigación culinaria (básico)',
      'de': 'Grundlegendes Forschungspapier: Kochkunst',
      'pl': 'Culinary Research Paper Basic',
      'ru': 'Исследование по базовой кулинарии',
      'uk': 'Дослідження базової кулінарії',
      'ko': '기초 요리 연구지',
      'zh': '基础烹饪研究论文',
      'ja': 'Culinary Research Paper Basic',
    }, {
      'id': 'CulinaryResearchPaperModernItem',
      'en': 'Culinary Research Paper Modern',
      'fr': 'Papier de recherche : Culinaire moderne',
      'es': 'Trabajo de investigación culinaria (moderno)',
      'de': 'Modernes Forschungspapier: Kochkunst',
      'pl': 'Nowoczesny artykuł badawczy Kulinarii',
      'ru': 'Исследование по современной кулинарии',
      'uk': 'Дослідження сучасної кулінарії',
      'ko': '현대식 요리 연구지',
      'zh': '现代烹饪研究论文',
      'ja': 'Culinary Research Paper Modern',
    }, {
      'id': 'CurrencyExchangeItem',
      'en': 'Currency Exchange',
      'fr': 'Bureau de change',
      'es': 'Cambio de Divisas',
      'de': 'Wechselstube',
      'pl': 'Wymiana walut',
      'ru': 'Пункт обмена валюты',
      'uk': 'Обмін валют',
      'ko': '환전소',
      'zh': '货币兑换',
      'ja': '両替機',
    }, {
      'id': 'CuttingEdgeCookingUpgradeItem',
      'en': 'Cutting Edge Cooking Upgrade',
      'fr': 'Amélioration Moderne : Cuisine moléculaire',
      'es': 'Mejora: Cocina innovadora',
      'de': 'Upgrade Innovatives Kochen',
      'pl': 'Ulepszenie Nowoczesnego Gotowania',
      'ru': 'Улучшение для передовой кулинарии',
      'uk': 'Покращення сучасної кухні',
      'ko': '식품공학 기술 업그레이드',
      'zh': '尖端烹饪升级',
      'ja': 'Cutting Edge Cooking Upgrade',
    }, {
      'id': 'DeerCarcassItem',
      'en': 'Deer Carcass',
      'fr': 'Cadavre de daim',
      'es': 'Cadáver de ciervo',
      'de': 'Hirschkadaver',
      'pl': 'Tusza sarny',
      'ru': 'Туша чернохвостого оленя',
      'uk': 'Туша оленя',
      'ko': '사슴 시체',
      'zh': '黑尾鹿遗骸',
      'ja': '鹿の死体',
    }, {
      'id': 'DendrologyResearchPaperAdvancedItem',
      'en': 'Dendrology Research Paper Advanced',
      'fr': 'Papier de recherche : Dendrologie avancée',
      'es': 'Trabajo de investigación en dendrología (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Dendrologie',
      'pl': 'Dendrology Research Paper Advanced',
      'ru': 'Исследование по продвинутой дендрологии',
      'uk': 'Дослідження вдосконаленої дендрології',
      'ko': '고급 산림학 연구지',
      'zh': '高级树木学研究论文',
      'ja': 'Dendrology Research Paper Advanced',
    }, {
      'id': 'DendrologyResearchPaperBasicItem',
      'en': 'Dendrology Research Paper Basic',
      'fr': 'Papier de recherche : Dendrologie basique',
      'es': 'Trabajo de investigación en dendrología (básico)',
      'de': 'Grundlegendes Forschungspapier: Dendrologie',
      'pl': 'Dendrology Research Paper Basic',
      'ru': 'Исследование по базовой дендрологии',
      'uk': 'Дослідження базової дендрології',
      'ko': '기초 산림학 연구지',
      'zh': '基础树木学研究论文',
      'ja': 'Dendrology Research Paper Basic',
    }, {
      'id': 'DendrologyResearchPaperModernItem',
      'en': 'Dendrology Research Paper Modern',
      'fr': 'Papier de recherche : Dendrologie moderne',
      'es': 'Trabajo de investigación en dendrología (moderno)',
      'de': 'Modernes Forschungspapier: Dendrologie',
      'pl': 'Nowoczesny artykuł badawczy Dendrologii',
      'ru': 'Исследование по современной дендрологии',
      'uk': 'Дослідження сучасної дендрології',
      'ko': '현대식 산림학 연구지',
      'zh': '现代树木学研究论文',
      'ja': 'Dendrology Research Paper Modern',
    }, {
      'id': 'DerpyHatItem',
      'en': 'Derpy Hat',
      'fr': 'Chapeau ridicule',
      'es': 'Sombrero Ridículo',
      'de': 'Trotteliger Hut',
      'pl': 'Durnowaty kapelusz',
      'ru': 'Неуклюжая шляпа',
      'uk': 'Недоладний капелюх',
      'ko': '이상한 모자',
      'zh': '德比帽',
      'ja': 'おかしな帽子',
    }, {
      'id': 'DirtItem',
      'en': 'Dirt',
      'fr': 'Terre',
      'es': 'Tierra',
      'de': 'Erde',
      'pl': 'Ziemia',
      'ru': 'Земля',
      'uk': 'Земля',
      'ko': '흙',
      'zh': '泥土',
      'ja': '土',
    }, {
      'id': 'DirtRampItem',
      'en': 'Dirt Ramp',
      'fr': 'Rampe en terre',
      'es': 'Rampa de Tierra',
      'de': 'Erdrampe',
      'pl': 'Podjazd ziemny',
      'ru': 'Земляная рампа',
      'uk': 'Земляний підйом',
      'ko': '흙 경사로',
      'zh': '泥土坡道',
      'ja': '土の坂道',
    }, {
      'id': 'DistributionStationItem',
      'en': 'Distribution Station',
      'fr': 'Station de distribution',
      'es': 'Estación de Distribución',
      'de': 'Verteilungsstation',
      'pl': 'Stacja Dystrybucyjna',
      'ru': 'Станция распределения',
      'uk': 'Станція розподілу',
      'ko': '물자 배급소',
      'zh': '分发站',
      'ja': '配布ステーション',
    }, {
      'id': 'DoorItem',
      'en': 'Door',
      'fr': 'Porte',
      'es': 'Puerta',
      'de': 'Tür',
      'pl': 'Drzwi',
      'ru': 'Дверь',
      'uk': 'Двері',
      'ko': '문',
      'zh': '门',
      'ja': 'ドア',
    }, {
      'id': 'DumpsterCompostItem',
      'en': 'Dumpster Compost',
      'fr': 'Benne à compost',
      'es': 'Contenedor de compostables',
      'de': 'Biomüllcontainer',
      'pl': 'Dumpster Compost',
      'ru': 'Мусорный контейнер',
      'uk': 'Dumpster Compost',
      'ko': '쓰레기통 퇴비',
      'zh': '肥料垃圾桶',
      'ja': 'Dumpster Compost',
    }, {
      'id': 'DumpsterGarbageItem',
      'en': 'Dumpster Garbage',
      'fr': 'Benne à ordures',
      'es': 'Contenedor de basura',
      'de': 'Müllcontainer',
      'pl': 'Dumpster Garbage',
      'ru': 'Мусорный контейнер',
      'uk': 'Dumpster Garbage',
      'ko': '쓰레기 수거통',
      'zh': '垃圾铁桶',
      'ja': 'Dumpster Garbage',
    }, {
      'id': 'DumpsterRecycleItem',
      'en': 'Dumpster Recycle',
      'fr': 'Benne à ordures recyclables',
      'es': 'Contenedor de reciclables',
      'de': 'Recyclingcontainer',
      'pl': 'Dumpster Recycle',
      'ru': 'Мусорный контейнер',
      'uk': 'Dumpster Recycle',
      'ko': '쓰레기 수거통 재활용',
      'zh': '垃圾回收桶',
      'ja': 'Dumpster Recycle',
    }, {
      'id': 'DwarfWillowSeedItem',
      'en': 'Dwarf Willow Seed',
      'fr': 'Graine de saule herbacé',
      'es': 'Semilla de sauce enano',
      'de': 'Samen (Krautweiden)',
      'pl': 'Nasiono wierzby karłowatej',
      'ru': 'Семечко ивы травянистой',
      'uk': 'Насіння верби трав’яної',
      'ko': '난장이버들 씨앗',
      'zh': '矮柳种子',
      'ja': 'ドワーフウィローの種',
    }, {
      'id': 'EaselItem',
      'en': 'Easel',
      'fr': 'Chevalet',
      'es': 'Caballete',
      'de': 'Staffelei',
      'pl': 'Easel',
      'ru': 'Мольберт',
      'uk': 'Easel',
      'ko': '화가',
      'zh': '画架',
      'ja': 'Easel',
    }, {
      'id': 'EckoStatueItem',
      'en': 'Ecko Statue',
      'fr': 'Statue d\u0027Ecko',
      'es': 'Estatua de Ecko',
      'de': 'Ecko Statue',
      'pl': 'Statua Ecko',
      'ru': 'Статуя Эcко',
      'uk': 'Статуя Еко',
      'ko': 'Ecko 동상',
      'zh': '埃克雕像',
      'ja': 'Ecko の像',
    }, {
      'id': 'EckoTheDolphinItem',
      'en': 'Ecko The Dolphin',
      'fr': 'Ecko le dauphin',
      'es': 'Ecko El Delfín',
      'de': 'Ecko der Delphin',
      'pl': 'Delfin Ecko',
      'ru': 'Дельфин Эcко',
      'uk': 'Дельфін Еко',
      'ko': 'Ecko 돌고래',
      'zh': '海豚埃克',
      'ja': 'イルカのEcko',
    }, {
      'id': 'EcoylentItem',
      'en': 'Ecoylent',
      'fr': 'Ecoylent',
      'es': 'Ecolixir',
      'de': 'Ecoylent',
      'pl': 'Eco Kokta',
      'ru': 'Эколиксир',
      'uk': 'Еколіксир',
      'ko': '에코일렌트',
      'zh': 'Ecoylent',
      'ja': 'イコレント',
    }, {
      'id': 'ElectricLatheItem',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'Torno eléctrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka Elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동식 선반 기계',
      'zh': '电动车床',
      'ja': '電気旋盤',
    }, {
      'id': 'ElectricMachinistTableItem',
      'en': 'Electric Machinist Table',
      'fr': 'Établi électrique',
      'es': 'Mesa eléctrica de maquinista',
      'de': 'Elektrischer Montagetisch',
      'pl': 'Elektryczny Stół Maszynowy',
      'ru': 'Электрический слесарный верстак',
      'uk': 'Стіл електромашиніста',
      'ko': '전동식 기계 정비공 작업대',
      'zh': '电动机械师工作台',
      'ja': '電気工作機械台',
    }, {
      'id': 'ElectricMotorItem',
      'en': 'Electric Motor',
      'fr': 'Moteur électrique',
      'es': 'Motor Eléctrico',
      'de': 'Elektromotor',
      'pl': 'Silnik elektryczny',
      'ru': 'Электродвигатель',
      'uk': 'Електродвигун',
      'ko': '전기 모터',
      'zh': '电动机',
      'ja': '電気モーター',
    }, {
      'id': 'ElectricPlanerItem',
      'en': 'Electric Planer',
      'fr': 'Fraiseuse électrique',
      'es': 'Cepilladora eléctrica',
      'de': 'Elektrische Hobelmaschine',
      'pl': 'Strug Elektryczny',
      'ru': 'Электрический строгальный станок',
      'uk': 'Електричний стругальний верстат',
      'ko': '전동식 대패',
      'zh': '电动刨床',
      'ja': '電気かんな盤',
    }, {
      'id': 'ElectricStampingPressItem',
      'en': 'Electric Stamping Press',
      'fr': 'Presse électrique',
      'es': 'Prensa de Estampado Hidráulica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический пресс',
      'uk': 'Електричний прес',
      'ko': '전동식 금속 가공기',
      'zh': '电动冲床',
      'ja': '電気スタンピングプレス機',
    }, {
      'id': 'ElectricWallLampItem',
      'en': 'Electric Wall Lamp',
      'fr': 'Lampe murale électrique',
      'es': 'Lámpara de Pared Eléctrica',
      'de': 'Elektrische Wandleuchte',
      'pl': 'Elektryczna lampa ścienna',
      'ru': 'Электрическая настенная лампа',
      'uk': 'Електричний настінний світильник',
      'ko': '벽걸이형 전등',
      'zh': '电壁灯',
      'ja': '壁掛け電灯',
    }, {
      'id': 'ElectricWaterPumpItem',
      'en': 'Electric Water Pump',
      'fr': 'Pompe à eau électrique',
      'es': 'Bomba de agua eléctrica',
      'de': 'Elektrische Wasserpumpe',
      'pl': 'Elektryczna pompa wodna',
      'ru': 'Электрический водяной насос',
      'uk': 'Електричний водяний насос',
      'ko': '전기 동력 물 펌프',
      'zh': '电动水泵',
      'ja': '電動ウォーター ポンプ',
    }, {
      'id': 'ElectronicsAssemblyItem',
      'en': 'Electronics Assembly',
      'fr': 'Atelier d\u0027électronique',
      'es': 'Sección de ensamblaje electrónico',
      'de': 'Elektronikfertigung',
      'pl': 'Montaż Elektroniki',
      'ru': 'Сборщик электроники',
      'uk': 'Збирач електроніки',
      'ko': '전자 공학 작업대',
      'zh': '电子装配套装',
      'ja': '電子機器組立機',
    }, {
      'id': 'ElectronicsUpgradeItem',
      'en': 'Electronics Upgrade',
      'fr': 'Amélioration Moderne : Électronique',
      'es': 'Mejora: Electrónica',
      'de': 'Upgrade Elektronik',
      'pl': 'Ulepszenie Elektroniki',
      'ru': 'Улучшение для электроники',
      'uk': 'Покращення електроніки',
      'ko': '전자공학 시술 업그레이드',
      'zh': '电子升级',
      'ja': 'Electronics Upgrade',
    }, {
      'id': 'ElevatorCallPostItem',
      'en': 'Elevator Call Post',
      'fr': 'Bouton d\u0027appel d\u0027ascenseur',
      'es': 'Punto de llamada del ascensor',
      'de': 'Holzaufzug-Rufposten',
      'pl': 'Elevator Call Post',
      'ru': 'Пульт управления лифтом',
      'uk': 'Elevator Call Post',
      'ko': '엘리베이터 호출 포스트',
      'zh': '电梯呼叫站',
      'ja': 'Elevator Call Post',
    }, {
      'id': 'ElkCarcassItem',
      'en': 'Elk Carcass',
      'fr': 'Cadavre de wapiti',
      'es': 'Cadáver de alce',
      'de': 'Elchkadaver',
      'pl': 'Tusza Jelenia',
      'ru': 'Туша вапити',
      'uk': 'Туша лося',
      'ko': '엘크 사체',
      'zh': '驼鹿遗骸',
      'ja': 'エルクの死体',
    }, {
      'id': 'ElkMountItem',
      'en': 'Elk Mount',
      'fr': 'Trophée de wapiti',
      'es': 'Montura de alce',
      'de': 'Ausgestopfter Wapiti',
      'pl': 'Elk Mount',
      'ru': 'Голова вапити',
      'uk': 'Голова оленя',
      'ko': '엘크 벽걸이 박제',
      'zh': '驼鹿壁挂',
      'ja': 'エルクマウント',
    }, {
      'id': 'ElkSkypiercerItem',
      'en': 'Elk Skypiercer',
      'fr': 'Wapiti Perce-ciel',
      'es': 'Cuerno de alce celestial',
      'de': 'Elch Himmelsstecher',
      'pl': 'Elk Skypiercer',
      'ru': 'Олень Небокол',
      'uk': 'Лось Протинач Неба',
      'ko': '엘크 천공지배자',
      'zh': '驼鹿高跃',
      'ja': 'エルク・スカイピアサー',
    }, {
      'id': 'ElkTacoItem',
      'en': 'Elk Taco',
      'fr': 'Taco de wapiti',
      'es': 'Taco de alce',
      'de': 'Elchtaco',
      'pl': 'Taco z Jelenia',
      'ru': 'Тако с олениной',
      'uk': 'Лосяче тако',
      'ko': '엘크 고기 타코',
      'zh': '鹿肉玉米卷',
      'ja': 'エルクのタコス',
    }, {
      'id': 'ElkWellingtonItem',
      'en': 'Elk Wellington',
      'fr': 'Rôti de wapiti façon Wellington',
      'es': 'Wellington de alce',
      'de': 'Wapitiwellington',
      'pl': 'Jeleń w Cieście',
      'ru': 'Оленина «Веллингтон»',
      'uk': 'Лосятина по-веллінгтонськи',
      'ko': '엘크 웰링턴',
      'zh': '惠灵顿鹿排',
      'ja': 'エルクウェリントン',
    }, {
      'id': 'EngineeringResearchPaperAdvancedItem',
      'en': 'Engineering Research Paper Advanced',
      'fr': 'Papier de recherche : Ingénierie avancée',
      'es': 'Trabajo de investigación en ingeniería (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Ingenieurswesen',
      'pl': 'Zaawansowany artykuł badawczy Inżynierii',
      'ru': 'Исследование по продвинутому инженерному делу',
      'uk': 'Дослідження вдосконаленої інженерії',
      'ko': '고급 기계공학 연구지',
      'zh': '高级工程学研究论文',
      'ja': 'Engineering Research Paper Advanced',
    }, {
      'id': 'EngineeringResearchPaperModernItem',
      'en': 'Engineering Research Paper Modern',
      'fr': 'Papier de recherche : Ingénierie moderne',
      'es': 'Trabajo de investigación en ingeniería (moderno)',
      'de': 'Modernes Forschungspapier: Ingenieurswesen',
      'pl': 'Nowoczesny artykuł badawczy Inżynierii',
      'ru': 'Исследование по современному инженерному делу',
      'uk': 'Дослідження сучасної інженерії',
      'ko': '현대식 기계공학 연구지',
      'zh': '现代工程学研究论文',
      'ja': 'Engineering Research Paper Modern',
    }, {
      'id': 'EpoxyItem',
      'en': 'Epoxy',
      'fr': 'Résine époxy',
      'es': 'Resina Epoxi',
      'de': 'Epoxidharz',
      'pl': 'Żywica epoksydowa',
      'ru': 'Эпоксидная смола',
      'uk': 'Епоксидна смола',
      'ko': '에폭시 수지',
      'zh': '环氧树脂',
      'ja': 'エポキシ樹脂',
    }, {
      'id': 'EthanolItem',
      'en': 'Ethanol',
      'fr': 'Éthanol',
      'es': 'Etanol',
      'de': 'Ethanol',
      'pl': 'Ethanol',
      'ru': 'Этанол',
      'uk': 'Ethanol',
      'ko': 'Ethanol',
      'zh': '乙醇',
      'ja': 'Ethanol',
    }, {
      'id': 'ExcavatorItem',
      'en': 'Excavator',
      'fr': 'Pelleteuse',
      'es': 'Excavadora',
      'de': 'Bagger',
      'pl': 'Koparka',
      'ru': 'Экскаватор',
      'uk': 'Екскаватор',
      'ko': '굴착기',
      'zh': '挖掘机',
      'ja': 'ショベルカー',
    }, {
      'id': 'ExecutiveOfficeItem',
      'en': 'Executive Office',
      'fr': 'Bureau de l\u0027exécutif',
      'es': 'Oficina ejecutiva',
      'de': 'Hauptamt',
      'pl': 'Biuro wykonawcze',
      'ru': 'Исполнительный офис',
      'uk': 'Адміністративний офіс',
      'ko': '행정 업무 책상',
      'zh': '行政办公室',
      'ja': 'Executive Office',
    }, {
      'id': 'ExplorerBeltItem',
      'en': 'Explorer Belt',
      'fr': 'Ceinture de l’explorateur',
      'es': 'Cinto de explorador',
      'de': 'Forschergürtel',
      'pl': 'Explorer Belt',
      'ru': 'Пояс Исследователя',
      'uk': 'Explorer Belt',
      'ko': '탐험가 허리띠',
      'zh': '探索者的腰带',
      'ja': 'Explorer Belt',
    }, {
      'id': 'ExplorerBootsItem',
      'en': 'Explorer Boots',
      'fr': 'Bottes d\u0027explorateur',
      'es': 'Botas de explorador',
      'de': 'Forscherstiefel',
      'pl': 'Explorer Boots',
      'ru': 'Ботинки Исследователя',
      'uk': 'Explorer Boots',
      'ko': '익스플로러 부츠',
      'zh': '探索者的靴子',
      'ja': 'Explorer Boots',
    }, {
      'id': 'ExplorerGlovesItem',
      'en': 'Explorer Gloves',
      'fr': 'Gants de l’explorateur',
      'es': 'Guantes de explorador',
      'de': 'Forscherhandschuhe',
      'pl': 'Explorer Gloves',
      'ru': 'Перчатки Исследователя',
      'uk': 'Explorer Gloves',
      'ko': '탐험가 장갑',
      'zh': '探索者的手套',
      'ja': 'Explorer Gloves',
    }, {
      'id': 'ExplorerHatItem',
      'en': 'Explorer Hat',
      'fr': 'Chapeau d\u0027explorateur',
      'es': 'Gorro de explorador',
      'de': 'Forscherhut',
      'pl': 'Explorer Hat',
      'ru': 'Пробковый шлем',
      'uk': 'Explorer Hat',
      'ko': '탐험가 모자',
      'zh': '探索者的帽子',
      'ja': 'Explorer Hat',
    }, {
      'id': 'ExplorerPantsItem',
      'en': 'Explorer Pants',
      'fr': 'Pantalon d\u0027explorateur',
      'es': 'Pantalones de explorador',
      'de': 'Forscherhose',
      'pl': 'Explorer Pants',
      'ru': 'Штаны Исследователя',
      'uk': 'Explorer Pants',
      'ko': '탐험가 바지',
      'zh': '探索者的裤子',
      'ja': 'Explorer Pants',
    }, {
      'id': 'ExplorerShirtItem',
      'en': 'Explorer Shirt',
      'fr': 'Chemise de l’explorateur',
      'es': 'Camisa de explorador',
      'de': 'Forscherhemd',
      'pl': 'Explorer Shirt',
      'ru': 'Китель Исследователя',
      'uk': 'Explorer Shirt',
      'ko': '탐험가 셔츠',
      'zh': '探索者的衬衫',
      'ja': 'Explorer Shirt',
    }, {
      'id': 'Fabric',
      'en': 'Fabric',
      'fr': 'Tissu',
      'es': 'Tejido',
      'de': 'Stoff',
      'pl': 'Fabric',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': 'Fabric',
      'zh': '织物',
      'ja': 'Fabric',
    }, {
      'id': 'FantasticForestPizzaItem',
      'en': 'Fantastic Forest Pizza',
      'fr': 'Pizza fantastique de la forêt',
      'es': 'Pizza del Bosque Fantástico',
      'de': 'Pizza Wald Fantastica',
      'pl': 'Fantastyczna leśna pizza',
      'ru': 'Фантастическая лесная пицца',
      'uk': 'Fantastic Forest Pizza',
      'ko': 'Fantastic Forest Pizza',
      'zh': '奇幻森林比萨',
      'ja': 'Fantastic Forest Pizza',
    }, {
      'id': 'FarmerBootsItem',
      'en': 'Farmer Boots',
      'fr': 'Bottes de fermier',
      'es': 'Botas de granjero',
      'de': 'Farmerstiefel',
      'pl': 'Farmer Boots',
      'ru': 'Ботинки Фермера',
      'uk': 'Farmer Boots',
      'ko': '농부 부츠',
      'zh': '农民的靴子',
      'ja': 'Farmer Boots',
    }, {
      'id': 'FarmerGlovesItem',
      'en': 'Farmer Gloves',
      'fr': 'Gants de fermier',
      'es': 'Guantes de granjero',
      'de': 'Farmerhandschuhe',
      'pl': 'Farmer Gloves',
      'ru': 'Перчатки Фермера',
      'uk': 'Farmer Gloves',
      'ko': '농부 장갑',
      'zh': '农民的手套',
      'ja': 'Farmer Gloves',
    }, {
      'id': 'FarmerHatItem',
      'en': 'Farmer Hat',
      'fr': 'Chapeau de fermier',
      'es': 'Sombrero de granjero',
      'de': 'Farmerhut',
      'pl': 'Farmer Hat',
      'ru': 'Шляпа Фермера',
      'uk': 'Farmer Hat',
      'ko': '농부 모자',
      'zh': '农民的帽子',
      'ja': 'Farmer Hat',
    }, {
      'id': 'FarmerOverallsItem',
      'en': 'Farmer Overalls',
      'fr': 'Salopette de fermier',
      'es': 'Mono de granjero',
      'de': 'Farmeroveralls',
      'pl': 'Farmer Overalls',
      'ru': 'Комбинезон Фермера',
      'uk': 'Farmer Overalls',
      'ko': '농부 작업복',
      'zh': '农民的工装裤',
      'ja': 'Farmer Overalls',
    }, {
      'id': 'FarmerShirtItem',
      'en': 'Farmer Shirt',
      'fr': 'Chemise de fermier',
      'es': 'Camisa de granjero',
      'de': 'Farmerhemd',
      'pl': 'Farmer Shirt',
      'ru': 'Рубашка Фермера',
      'uk': 'Farmer Shirt',
      'ko': '농부 셔츠',
      'zh': '农民的衬衫',
      'ja': 'Farmer Shirt',
    }, {
      'id': 'FarmersTableItem',
      'en': 'Farmers Table',
      'fr': 'Atelier d\u0027agriculture',
      'es': 'Mesa de Agricultor',
      'de': 'Landwirttisch',
      'pl': 'Stół Rolniczy',
      'ru': 'Фермерский стол',
      'uk': 'Фермерський стіл',
      'ko': '농업 작업대',
      'zh': '农业工作台',
      'ja': '園芸作業台',
    }, {
      'id': 'FarmingUpgradeItem',
      'en': 'Farming Upgrade',
      'fr': 'Amélioration Basique : Agriculture',
      'es': 'Mejora: Agricultura',
      'de': 'Upgrade Landwirtschaft',
      'pl': 'Ulepszenie Rolnictwa',
      'ru': 'Улучшение для фермерского дела',
      'uk': 'Покращення фермерства',
      'ko': '농업 기술 업그레이드',
      'zh': '农业升级',
      'ja': 'Farming Upgrade',
    }, {
      'id': 'Fat',
      'en': 'Fat',
      'fr': 'Matières grasses',
      'es': 'Grasa',
      'de': 'Fett',
      'pl': 'Tłuszcz',
      'ru': 'Жиры',
      'uk': 'Жир',
      'ko': '지방',
      'zh': '脂肪',
      'ja': '脂質',
    }, {
      'id': 'FernCampfireSaladItem',
      'en': 'Fern Campfire Salad',
      'fr': 'Salade de fougères cuite au feu de camp',
      'es': 'Ensalada braseada con helechos',
      'de': 'Lagerfeuer Farnspitzensalat',
      'pl': 'Paprociowa sałatka z ogniska',
      'ru': 'Салат из папоротника на костре',
      'uk': 'Салат із папороті, приготований на багатті',
      'ko': '고사리 모닥불 샐러드',
      'zh': '蕨篝火沙拉',
      'ja': 'Fern Campfire Salad',
    }, {
      'id': 'FernSporeItem',
      'en': 'Fern Spore',
      'fr': 'Spore de fougère',
      'es': 'Espora de Helecho',
      'de': 'Sporen (Farn)',
      'pl': 'Zarodniki Paproci',
      'ru': 'Спора папоротника',
      'uk': 'Спори папороті',
      'ko': '고사리 포자',
      'zh': '蕨类孢子',
      'ja': 'Zarodniki paproci',
    }, {
      'id': 'Fertilizer',
      'en': 'Fertilizer',
      'fr': 'Engrais',
      'es': 'Fertilizante',
      'de': 'Dünger',
      'pl': 'Fertilizer',
      'ru': 'Удобрение',
      'uk': 'Fertilizer',
      'ko': '비료',
      'zh': '化肥',
      'ja': 'Fertilizer',
    }, {
      'id': 'FertilizerFiller',
      'en': 'Fertilizer Filler',
      'fr': 'Garnissage d\u0027engrais',
      'es': 'Relleno de Fertilizante',
      'de': 'Füller aus Dünger',
      'pl': 'Fertilizer Filler',
      'ru': 'Наполнитель удобрений',
      'uk': 'Fertilizer Filler',
      'ko': 'Fertilizer Filler',
      'zh': '化肥填料',
      'ja': 'Fertilizer Filler',
    }, {
      'id': 'FertilizersUpgradeItem',
      'en': 'Fertilizers Upgrade',
      'fr': 'Amélioration Basique : Engrais',
      'es': 'Mejora: Fertilizantes',
      'de': 'Upgrade Dünger',
      'pl': 'Ulepszenie Nawozów',
      'ru': 'Улучшение для производства удобрений',
      'uk': 'Покращення виготовлення добрив',
      'ko': '비료제조 기술 업그레이드',
      'zh': '肥料升级',
      'ja': 'Fertilizers Upgrade',
    }, {
      'id': 'FiberFillerItem',
      'en': 'Fiber Filler',
      'fr': 'Garnissage de fibres végétales',
      'es': 'Relleno de Fibra',
      'de': 'Füller aus Fasern',
      'pl': 'Wypełniacz włóknowy',
      'ru': 'Волоконный наполнитель',
      'uk': 'Наповнювач із волокна',
      'ko': '식물섬유 보충제',
      'zh': '纤维填料',
      'ja': 'Wypełniacz włóknowy',
    }, {
      'id': 'FiberglassItem',
      'en': 'Fiberglass',
      'fr': 'Fibre de verre',
      'es': 'Fibra de Vidrio',
      'de': 'Glasfaserverstärkter Kunststoff',
      'pl': 'Włokno szklane',
      'ru': 'Стекловолокно',
      'uk': 'Скловолокно',
      'ko': '유리섬유',
      'zh': '玻璃钢',
      'ja': 'ガラス繊維',
    }, {
      'id': 'FiddleheadsItem',
      'en': 'Fiddleheads',
      'fr': 'Crosses de fougère',
      'es': 'Brotes de helecho',
      'de': 'Farnspitzen',
      'pl': 'Pędy Paproci',
      'ru': 'Побеги папоротника',
      'uk': 'Папороть',
      'ko': '고사리',
      'zh': '蕨菜',
      'ja': 'シダ',
    }, {
      'id': 'FieldCampfireStewItem',
      'en': 'Field Campfire Stew',
      'fr': 'Ragoût des prairies cuit au feu de camp',
      'es': 'Ensalada braseada campestre',
      'de': 'Lagerfeuer Feldeintopf',
      'pl': 'Chłopski gulasz z ogniska',
      'ru': 'Полевое рагу на костре',
      'uk': 'Польове рагу, приготоване на багатті',
      'ko': '들판 모닥불 스튜',
      'zh': '野营篝火炖汤',
      'ja': 'Field Campfire Stew',
    }, {
      'id': 'FilmyFernSporeItem',
      'en': 'Filmy Fern Spore',
      'fr': 'Spores d\u0027Hyménophylles',
      'es': 'Espora de Helechos Película',
      'de': 'Sporen (Schleierfarn)',
      'pl': 'Filmy Fern Spore',
      'ru': 'Спора тонколистника',
      'uk': 'Спори Тонколистника',
      'ko': '처녀이끼 포자',
      'zh': '瓶蕨袍子',
      'ja': 'マメゴケシダの胞子',
    }, {
      'id': 'FirLogItem',
      'en': 'Fir Log',
      'fr': 'Bûche de Sapin',
      'es': 'Tronco de abeto',
      'de': 'Tannenholzstamm',
      'pl': 'Kłoda jodły',
      'ru': 'Бревно Пихты',
      'uk': 'Ялинова колода',
      'ko': '전나무 통나무',
      'zh': '杉木原木',
      'ja': 'Fir Log',
    }, {
      'id': 'FirSeedItem',
      'en': 'Fir Seed',
      'fr': 'Graine de sapin',
      'es': 'Semilla de Abeto',
      'de': 'Samen (Tanne)',
      'pl': 'Nasiona Jodły',
      'ru': 'Семечко пихты',
      'uk': 'Насіння ялиці',
      'ko': '전나무 씨앗',
      'zh': '杉树种子',
      'ja': 'モミの種',
    }, {
      'id': 'FireweedSeedItem',
      'en': 'Fireweed Seed',
      'fr': 'Graine d\u0027épilobe',
      'es': 'Semilla de Epilobio',
      'de': 'Samen (Weidenröschen)',
      'pl': 'Nasiona Wierzbówki',
      'ru': 'Семечко иван-чая',
      'uk': 'Насіння дикого льону',
      'ko': '분홍바늘꽃 씨앗',
      'zh': '柳兰种子',
      'ja': 'ヤナギランの種',
    }, {
      'id': 'FireweedShootsItem',
      'en': 'Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe',
      'es': 'Brotes de Epilobio',
      'de': 'Weidenröschenwurzel',
      'pl': 'Pędy Wierzbówki',
      'ru': 'Побеги Иван-чая',
      'uk': 'Пагони дикого льону',
      'ko': '분홍바늘꽃 순',
      'zh': '柳兰芽',
      'ja': 'ヤナギランの新芽',
    }, {
      'id': 'Fish',
      'en': 'Fish',
      'fr': 'Poisson',
      'es': 'Pez',
      'de': 'Fisch',
      'pl': 'Ryba',
      'ru': 'Рыба',
      'uk': 'Риба',
      'ko': '물고기',
      'zh': '鱼',
      'ja': 'Fish',
    }, {
      'id': 'FishNChipsItem',
      'en': 'Fish N Chips',
      'fr': 'Fish and Chips',
      'es': 'Fish N Chips',
      'de': 'Fish N Chips',
      'pl': 'Fish N Chips',
      'ru': 'Рыбные чипсы',
      'uk': 'Fish N Chips',
      'ko': '피쉬엔칩스',
      'zh': '炸鱼薯条',
      'ja': 'Fish N Chips',
    }, {
      'id': 'FishTrapItem',
      'en': 'Fish Trap',
      'fr': 'Nasse à poisson',
      'es': 'Trampa para Peces',
      'de': 'Reuse',
      'pl': 'Samołówka',
      'ru': 'Верша',
      'uk': 'Рибна пастка',
      'ko': '통발',
      'zh': '捕鱼器',
      'ja': '梁（やな）',
    }, {
      'id': 'FisheryItem',
      'en': 'Fishery',
      'fr': 'Atelier de pêche',
      'es': 'Pesquería',
      'de': 'Fischereitisch',
      'pl': 'Rybołóstwo',
      'ru': 'Шкаф рыбака',
      'uk': 'Шафка рибалки',
      'ko': '어업 작업대',
      'zh': '渔具',
      'ja': '釣り具作業台',
    }, {
      'id': 'FlatSteelItem',
      'en': 'Flat Steel',
      'fr': 'Tôle d\u0027acier inoxydable',
      'es': 'Acero Plano',
      'de': 'Flachstahl',
      'pl': 'Blacha stalowa',
      'ru': 'Листовая сталь',
      'uk': 'Листова сталь',
      'ko': '강철판',
      'zh': '扁钢',
      'ja': '鋼板',
    }, {
      'id': 'FlatSteelDoorItem',
      'en': 'Flat Steel Door',
      'fr': 'Porte en tôle d\u0027acier inoxydable',
      'es': 'Puerta plana de acero',
      'de': 'Wohnungstüre aus Stahl',
      'pl': 'Flat Steel Door',
      'ru': 'Дверь из листовой стали',
      'uk': 'Flat Steel Door',
      'ko': '플랫 스틸 도어',
      'zh': '扁平铁门',
      'ja': 'Flat Steel Door',
    }, {
      'id': 'FlatbreadItem',
      'en': 'Flatbread',
      'fr': 'Galette de pain',
      'es': 'Pan Plano',
      'de': 'Fladenbrot',
      'pl': 'Podpłomyk',
      'ru': 'Лепёшка',
      'uk': 'Корж',
      'ko': '무발효빵',
      'zh': '大饼',
      'ja': 'Podpłomyk',
    }, {
      'id': 'FlourItem',
      'en': 'Flour',
      'fr': 'Farine',
      'es': 'Harina',
      'de': 'Mehl',
      'pl': 'Mąka',
      'ru': 'Мука',
      'uk': 'Борошно',
      'ko': '밀가루',
      'zh': '面粉',
      'ja': '小麦粉',
    }, {
      'id': 'Food',
      'en': 'Food',
      'fr': 'Nourriture',
      'es': 'Comida',
      'de': 'Nahrung',
      'pl': 'Żywność',
      'ru': 'Еда',
      'uk': 'Їжа',
      'ko': '음식',
      'zh': '食物',
      'ja': '食料',
    }, {
      'id': 'FoxCarcassItem',
      'en': 'Fox Carcass',
      'fr': 'Cadavre de renard',
      'es': 'Cadáver de zorro',
      'de': 'Fuchskadaver',
      'pl': 'Tuszka Lisa',
      'ru': 'Туша лисы',
      'uk': 'Туша лисиці',
      'ko': '여우 사체',
      'zh': '狐狸遗骸',
      'ja': 'キツネの死体',
    }, {
      'id': 'FramedGlassItem',
      'en': 'Framed Glass',
      'fr': 'Verre encadré',
      'es': 'Vidrio Enmarcado',
      'de': 'Gerahmtes Glas',
      'pl': 'Szyba oprawiona',
      'ru': 'Обрамлённое стекло',
      'uk': 'Рамкове скло',
      'ko': '유리창',
      'zh': '框式玻璃',
      'ja': 'ガラスの窓枠',
    }, {
      'id': 'FramedGlassDoorItem',
      'en': 'Framed Glass Door',
      'fr': 'Porte à encadrement vitrée',
      'es': 'Puerta de cristal enmarcado',
      'de': 'Gerahmte Glastür',
      'pl': 'Oprawione Szklane Drzwi',
      'ru': 'Стеклянная дверь',
      'uk': 'Скляні двері',
      'ko': '강철 틀 유리문',
      'zh': '带框架的玻璃门',
      'ja': '枠付きのガラス戸',
    }, {
      'id': 'FriedCamasItem',
      'en': 'Fried Camas',
      'fr': 'Camassias frits',
      'es': 'Camasia frita',
      'de': 'Frittierte Prärielilien',
      'pl': 'Smażone camas',
      'ru': 'Жареная камассия',
      'uk': 'Смажений Камас',
      'ko': '튀긴 카마스',
      'zh': '炸卡马斯',
      'ja': 'Fried Camas',
    }, {
      'id': 'FriedFiddleheadsItem',
      'en': 'Fried Fiddleheads',
      'fr': 'Fougères frits',
      'es': 'Brotes de helecho fritos',
      'de': 'Frittierte Farnspitzen',
      'pl': 'Smażone liście młodej paproci',
      'ru': 'Жареный папоротник',
      'uk': 'Смажена папороть',
      'ko': '튀긴 고사리',
      'zh': '炸羊肠',
      'ja': 'Fried Fiddleheads',
    }, {
      'id': 'FriedHareHaunchesItem',
      'en': 'Fried Hare Haunches',
      'fr': 'Cuisses de lièvre frites',
      'es': 'Ancas de Liebre Fritas',
      'de': 'Frittierte Hasenkeule',
      'pl': 'Smażony udziec z zająca',
      'ru': 'Жаренное филе зайца',
      'uk': 'Смажене заяче філе',
      'ko': '튀긴 토끼 뒷다리',
      'zh': '炸兔后腿',
      'ja': '野ウサギの唐揚げ',
    }, {
      'id': 'FriedHeartsOfPalmItem',
      'en': 'Fried Hearts Of Palm',
      'fr': 'Cœur de palmier frit',
      'es': 'Palmitos fritos',
      'de': 'Frittierte Palmherzen',
      'pl': 'Smażone serca palmy',
      'ru': 'Жаренная сердцевина пальмы',
      'uk': 'Смажені пальмові серцевини',
      'ko': '대추야자 나무순 튀김',
      'zh': '棕榈炒心',
      'ja': 'Fried Hearts Of Palm',
    }, {
      'id': 'FriedTaroItem',
      'en': 'Fried Taro',
      'fr': 'Taro frit',
      'es': 'Taro frito',
      'de': 'Frittierte Taro',
      'pl': 'Smażona kolokazja',
      'ru': 'Жареный таро',
      'uk': 'Смажене Таро',
      'ko': '튀긴 토란',
      'zh': '炸芋头',
      'ja': 'Fried Taro',
    }, {
      'id': 'FriedTomatoesItem',
      'en': 'Fried Tomatoes',
      'fr': 'Tomates frites',
      'es': 'Tomates fritos',
      'de': 'Frittierte Tomaten',
      'pl': 'Smażone pomidory',
      'ru': 'Жареные помидоры',
      'uk': 'Смажені помідори',
      'ko': '튀긴 토마토',
      'zh': '炸番茄',
      'ja': 'フライドトマト',
    }, {
      'id': 'FriedVegetable',
      'en': 'Fried Vegetable',
      'fr': 'Légumes frits',
      'es': 'Vegetal frito',
      'de': 'Frittiertes Gemüse',
      'pl': 'Smażone Warzywa',
      'ru': 'Жареный овощ',
      'uk': 'Підсмажений овоч',
      'ko': '튀긴 야채',
      'zh': '炒蔬菜',
      'ja': 'Fried Vegetable',
    }, {
      'id': 'FriedVegetablesItem',
      'en': 'Fried Vegetables',
      'fr': 'Légumes frits',
      'es': 'Vegetales fritos',
      'de': 'Frittiertes Gemüse',
      'pl': 'Smażone warzywa',
      'ru': 'Жареные овощи',
      'uk': 'Смажені овочі',
      'ko': '튀긴 야채',
      'zh': '炒蔬菜',
      'ja': 'Fried Vegetables',
    }, {
      'id': 'FrothFloatationCellItem',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation',
      'es': 'Celda de espuma flotante',
      'de': 'Schaumschwimmzelle',
      'pl': 'Pianka pływacka',
      'ru': 'Флотатор',
      'uk': 'Флотатор',
      'ko': '거품 부유 분별기',
      'zh': '泡沫浮选池',
      'ja': 'Froth Floatation Cell',
    }, {
      'id': 'Fruit',
      'en': 'Fruit',
      'fr': 'Fruit',
      'es': 'Fruta',
      'de': 'Frucht',
      'pl': 'Owoc',
      'ru': 'Фрукт',
      'uk': 'Фрукт',
      'ko': '과일',
      'zh': '水果',
      'ja': 'Fruit',
    }, {
      'id': 'FruitMuffinItem',
      'en': 'Fruit Muffin',
      'fr': 'Muffin aux fruits',
      'es': 'Muffin de fruta',
      'de': 'Fruchtmuffin',
      'pl': 'Babeczka owocowa',
      'ru': 'Фруктовый кекс',
      'uk': 'Фруктовий мафін',
      'ko': '과일 머핀',
      'zh': '水果松饼',
      'ja': 'Fruit Muffin',
    }, {
      'id': 'FruitSaladItem',
      'en': 'Fruit Salad',
      'fr': 'Salade de fruits',
      'es': 'Ensalada de Frutas',
      'de': 'Obstsalat',
      'pl': 'Sałatka owocowa',
      'ru': 'Фруктовый салат',
      'uk': 'Фруктовий салат',
      'ko': '과일 샐러드',
      'zh': '水果沙拉',
      'ja': 'フルーツサラダ',
    }, {
      'id': 'FruitTartItem',
      'en': 'Fruit Tart',
      'fr': 'Tarte aux fruits',
      'es': 'Tarta de frutas',
      'de': 'Obstkuchen',
      'pl': 'Tarta owocowa',
      'ru': 'Фруктовый тарт',
      'uk': 'Фруктовий тарт',
      'ko': '과일 타르트',
      'zh': '水果馅饼',
      'ja': 'Fruit Tart',
    }, {
      'id': 'Fuel',
      'en': 'Fuel',
      'fr': 'Carburant',
      'es': 'Combustible',
      'de': 'Kraftstoff',
      'pl': 'Fuel',
      'ru': 'Топливо',
      'uk': 'Паливо',
      'ko': '연료',
      'zh': '燃料',
      'ja': '燃料',
    }, {
      'id': 'Fungus',
      'en': 'Fungus',
      'fr': 'Champignon',
      'es': 'Hongo',
      'de': 'Pilz',
      'pl': 'Grzyb',
      'ru': 'Гриб',
      'uk': 'Гриб',
      'ko': '균류',
      'zh': '菌',
      'ja': 'Fungus',
    }, {
      'id': 'FurPeltItem',
      'en': 'Fur Pelt',
      'fr': 'Fourrure',
      'es': 'Pelaje',
      'de': 'Fellpelz',
      'pl': 'Futro',
      'ru': 'Мех',
      'uk': 'Хутро',
      'ko': '모피',
      'zh': '毛皮',
      'ja': '毛皮',
    }, {
      'id': 'GardenBootsItem',
      'en': 'Garden Boots',
      'fr': 'Bottes de jardinage',
      'es': 'Botas de Jardín',
      'de': 'Gartenschuhe',
      'pl': 'Buty ogrodnicze',
      'ru': 'Садовые сапоги',
      'uk': 'Садові чоботи',
      'ko': '정원 부츠',
      'zh': '花园靴',
      'ja': '金の靴',
    }, {
      'id': 'GasolineItem',
      'en': 'Gasoline',
      'fr': 'Essence',
      'es': 'Gasolina',
      'de': 'Benzin',
      'pl': 'Benzyna',
      'ru': 'Бензин',
      'uk': 'Бензин',
      'ko': '휘발유',
      'zh': '汽油',
      'ja': 'ガソリン',
    }, {
      'id': 'GatheringResearchPaperBasicItem',
      'en': 'Gathering Research Paper Basic',
      'fr': 'Papier de recherche : Récolte basique',
      'es': 'Trabajo de investigación en recolección (básico)',
      'de': 'Grundlegendes Forschungspapier: Sammeln',
      'pl': 'Podstawowy artykuł badawczy Zbieractwa',
      'ru': 'Исследование по базовому собирательству',
      'uk': 'Базове дослідження збирання',
      'ko': '기초 수확 연구지',
      'zh': '基础收集研究论文',
      'ja': 'Gathering Research Paper Basic',
    }, {
      'id': 'GearboxItem',
      'en': 'Gearbox',
      'fr': 'Boîte de vitesses',
      'es': 'Caja de Cambios',
      'de': 'Getriebe',
      'pl': 'Skrzynia Biegów',
      'ru': 'Коробка передач',
      'uk': 'Коробка передач',
      'ko': '변속 장치',
      'zh': '齿轮箱',
      'ja': 'ギアボックス',
    }, {
      'id': 'GeologyResearchPaperAdvancedItem',
      'en': 'Geology Research Paper Advanced',
      'fr': 'Papier de recherche : Géologie avancée',
      'es': 'Trabajo de investigación en geología (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Geologie',
      'pl': 'Zaawansowany artykuł badawczy Geologii',
      'ru': 'Исследование по продвинутой геологии',
      'uk': 'Дослідження вдосконаленої геології',
      'ko': '고급 지질학 연구지',
      'zh': '高级地质学研究论文',
      'ja': 'Geology Research Paper Advanced',
    }, {
      'id': 'GeologyResearchPaperBasicItem',
      'en': 'Geology Research Paper Basic',
      'fr': 'Papier de recherche : Géologie basique',
      'es': 'Trabajo de investigación en geología (básico)',
      'de': 'Grundlegendes Forschungspapier: Geologie',
      'pl': 'Podstawowy artykuł badawczy Geologii',
      'ru': 'Исследование по базовой геологии',
      'uk': 'Дослідження базової геології',
      'ko': '기초 지질한 연구지',
      'zh': '基础地质学研究论文',
      'ja': 'Geology Research Paper Basic',
    }, {
      'id': 'GeologyResearchPaperModernItem',
      'en': 'Geology Research Paper Modern',
      'fr': 'Papier de recherche : Géologie moderne',
      'es': 'Trabajo de investigación en geología (moderno)',
      'de': 'Modernes Forschungspapier: Geologie',
      'pl': 'Nowoczesny artykuł badawczy Geologii',
      'ru': 'Исследование по современной геологии',
      'uk': 'Дослідження сучасної геології',
      'ko': '현대식 지질학 연구지',
      'zh': '现代地质学研究论文',
      'ja': 'Geology Research Paper Modern',
    }, {
      'id': 'GiantCactusFruitItem',
      'en': 'Giant Cactus Fruit',
      'fr': 'Fruit de saguaro',
      'es': 'Fruta de cactus gigante',
      'de': 'Riesige Kaktusfrucht',
      'pl': 'Owoc Saguaro',
      'ru': 'Плод сагуаро',
      'uk': 'Плід сагуаро',
      'ko': '백년초',
      'zh': '巨型仙人掌果实',
      'ja': '巨大サボテンの実',
    }, {
      'id': 'GigotSleeveShirtItem',
      'en': 'Gigot Sleeve Shirt',
      'fr': 'Chemise à manches gigot',
      'es': 'Camisa de manga gigot',
      'de': 'Hülsenhemd',
      'pl': 'Bufiasta Koszula',
      'ru': 'Рубашка с пышными рукавами',
      'uk': 'Сорочка з пишними рукавами',
      'ko': '지고 소매 셔츠',
      'zh': '羊腿袖衬衫',
      'ja': '子羊の足を模ったシャツ',
    }, {
      'id': 'GlassItem',
      'en': 'Glass',
      'fr': 'Verre',
      'es': 'Vidrio',
      'de': 'Glas',
      'pl': 'Szkło',
      'ru': 'Стекло',
      'uk': 'Скло',
      'ko': '유리',
      'zh': '玻璃',
      'ja': 'ガラス',
    }, {
      'id': 'GlassworkingAdvancedUpgradeItem',
      'en': 'Glassworking Advanced Upgrade',
      'fr': 'Amélioration Avancée : Travail du verre',
      'es': 'Mejora avanzada: Artesanía de cristal',
      'de': 'Fortschrittliches Upgrade: Glasverarbeitung',
      'pl': 'Zaawansowane ulepszenie Obróbki Szkła',
      'ru': 'Продвинутое улучшение для стеклообработки',
      'uk': 'Glassworking Advanced Upgrade',
      'ko': '고급 유리 제조 기술 업그레이드',
      'zh': '玻璃加工高级升级',
      'ja': 'Glassworking Advanced Upgrade',
    }, {
      'id': 'GlassworkingModernUpgradeItem',
      'en': 'Glassworking Modern Upgrade',
      'fr': 'Amélioration Moderne : Travail du verre',
      'es': 'Mejora moderna: Artesanía del cristal',
      'de': 'Modernes Upgrade: Glasverarbeitung',
      'pl': 'Nowoczesne ulepszenie Obróbki Szkła',
      'ru': 'Современное улучшение для обработки стекла',
      'uk': 'Новітнє покращення обробки скла',
      'ko': '현대식 유리 제조 기술 업그레이드',
      'zh': '玻璃加工现代升级',
      'ja': 'Glassworking Modern Upgrade',
    }, {
      'id': 'GneissItem',
      'en': 'Gneiss',
      'fr': 'Gneiss',
      'es': 'Gneis',
      'de': 'Gneis',
      'pl': 'Gnejs',
      'ru': 'Гнейс',
      'uk': 'Гнейс',
      'ko': '편마암',
      'zh': '片麻岩',
      'ja': '片麻岩',
    }, {
      'id': 'GoatMountItem',
      'en': 'Goat Mount',
      'fr': 'Trophée de chèvre des montagnes',
      'es': 'Montura para cabra',
      'de': 'Ausgestopfte Bergziege',
      'pl': 'Goat Mount',
      'ru': 'Голова козы',
      'uk': 'Голова кози',
      'ko': '염소 벽걸이 박제',
      'zh': '山羊山',
      'ja': 'Goat Mount',
    }, {
      'id': 'GoldBarItem',
      'en': 'Gold Bar',
      'fr': 'Lingot d\u0027or',
      'es': 'Barra de oro',
      'de': 'Goldbarren',
      'pl': 'Sztabka złota',
      'ru': 'Золотой брусок',
      'uk': 'Золотий брусок',
      'ko': '금괴',
      'zh': '金条',
      'ja': '金のインゴット',
    }, {
      'id': 'GoldConcentrateItem',
      'en': 'Gold Concentrate',
      'fr': 'Concentré d\u0027or',
      'es': 'Concentrado de oro',
      'de': 'Goldkonzentrat',
      'pl': 'Złoty koncentrat',
      'ru': 'Концентрат золота',
      'uk': 'Концентрат золота',
      'ko': '정제된 금광석',
      'zh': '筛选金矿石',
      'ja': 'Gold Concentrate',
    }, {
      'id': 'GoldFlakesItem',
      'en': 'Gold Flakes',
      'fr': 'Paillettes d\u0027or',
      'es': 'Copos de Oro',
      'de': 'Blattgold',
      'pl': 'Płatki złota',
      'ru': 'Чешуйки золота',
      'uk': 'Золоті пластівці',
      'ko': '금조각',
      'zh': '金片',
      'ja': '金箔',
    }, {
      'id': 'GoldOreItem',
      'en': 'Gold Ore',
      'fr': 'Minerai d\u0027or',
      'es': 'Mineral de Oro',
      'de': 'Golderz',
      'pl': 'Ruda złota',
      'ru': 'Золотая руда',
      'uk': 'Золота руда',
      'ko': '금광석',
      'zh': '金矿',
      'ja': '金鉱石',
    }, {
      'id': 'GoldWiringItem',
      'en': 'Gold Wiring',
      'fr': 'Fil d\u0027or',
      'es': 'Cables de oro',
      'de': 'Goldverdrahtung',
      'pl': 'Złote Okablowanie',
      'ru': 'Золотой провод',
      'uk': 'Золотий дріт',
      'ko': '금전선',
      'zh': '金接线',
      'ja': 'Gold Wiring',
    }, {
      'id': 'GovernmentOfficeItem',
      'en': 'Government Office',
      'fr': 'Bureau des élus',
      'es': 'Oficina de gobierno',
      'de': 'Amtsverwaltung',
      'pl': 'Biuro rządowe',
      'ru': 'Правительственный офис',
      'uk': 'Державний офіс',
      'ko': '정부 부서',
      'zh': '公会办公室',
      'ja': 'Government Office',
    }, {
      'id': 'Grain',
      'en': 'Grain',
      'fr': 'Graine',
      'es': 'Grano',
      'de': 'Getreide',
      'pl': 'Ziarno',
      'ru': 'Зерно',
      'uk': 'Зерно',
      'ko': '곡물',
      'zh': '粮食',
      'ja': 'Grain',
    }, {
      'id': 'GraniteItem',
      'en': 'Granite',
      'fr': 'Granit',
      'es': 'Granito',
      'de': 'Granit',
      'pl': 'Granite',
      'ru': 'Гранит',
      'uk': 'Граніт',
      'ko': '화강암',
      'zh': '花岗岩',
      'ja': '花崗岩',
    }, {
      'id': 'GrassSeedItem',
      'en': 'Grass Seed',
      'fr': 'Graine d\u0027herbe',
      'es': 'Semilla de Pasto',
      'de': 'Samen (Gras)',
      'pl': 'Nasiona Trawy',
      'ru': 'Семечко травы',
      'uk': 'Насіння трави',
      'ko': '잔디 씨앗',
      'zh': '草种子',
      'ja': '雑草の種',
    }, {
      'id': 'Greens',
      'en': 'Greens',
      'fr': 'Feuilles',
      'es': 'Hojas',
      'de': 'Suppengrün',
      'pl': 'Warzywa',
      'ru': 'Зелень',
      'uk': 'Зелень',
      'ko': '녹색 야채',
      'zh': '青菜',
      'ja': 'Greens',
    }, {
      'id': 'HandPlowItem',
      'en': 'Hand Plow',
      'fr': 'Charrue à main',
      'es': 'Arado manual',
      'de': 'Handpflug',
      'pl': 'Hand Plow',
      'ru': 'Ручной плуг',
      'uk': 'Hand Plow',
      'ko': '손쟁기',
      'zh': '手犁',
      'ja': 'Hand Plow',
    }, {
      'id': 'HangingLongSteelSignItem',
      'en': 'Hanging Long Steel Sign',
      'fr': 'Long panneau suspendu en acier',
      'es': 'Letrero colgante largo (acero)',
      'de': 'Stahlschild (lang, hängend)',
      'pl': 'Hanging Long Steel Sign',
      'ru': 'Стальная длинная вывеска',
      'uk': 'Hanging Long Steel Sign',
      'ko': '교수형 긴 강철 기호',
      'zh': '长条钢制悬挂标志',
      'ja': 'Hanging Long Steel Sign',
    }, {
      'id': 'HangingSteelFramedSignItem',
      'en': 'Hanging Steel Framed Sign',
      'fr': 'Grand panneau suspendu encadré en acier',
      'es': 'Letrero colgante con marco (acero)',
      'de': 'Stahlschild (gerahmt, hängend)',
      'pl': 'Hanging Steel Framed Sign',
      'ru': 'Стальная обрамлённая вывеска',
      'uk': 'Hanging Steel Framed Sign',
      'ko': '교수형 강철 액자 기호',
      'zh': '钢制框式悬挂标志',
      'ja': 'Hanging Steel Framed Sign',
    }, {
      'id': 'HangingSteelMineSignItem',
      'en': 'Hanging Steel Mine Sign',
      'fr': 'Panneau moyen suspendu de mine en acier',
      'es': 'Letrero colgante de mina (acero)',
      'de': 'Stahlschild für Minen (hängend)',
      'pl': 'Hanging Steel Mine Sign',
      'ru': 'Стальная вывеска для шахты',
      'uk': 'Hanging Steel Mine Sign',
      'ko': '교수형 철강 광산 기호',
      'zh': '矿用钢悬挂标志',
      'ja': 'Hanging Steel Mine Sign',
    }, {
      'id': 'HangingSteelPlainSignItem',
      'en': 'Hanging Steel Plain Sign',
      'fr': 'Panneau moyen suspendu en plaque d’acier',
      'es': 'Letrero colgante (acero)',
      'de': 'Stahlschild (glatt, hängend)',
      'pl': 'Hanging Steel Plain Sign',
      'ru': 'Стальная обычная вывеска',
      'uk': 'Hanging Steel Plain Sign',
      'ko': '교수형 강철 일반 기호',
      'zh': '钢制平整悬挂标志',
      'ja': 'Hanging Steel Plain Sign',
    }, {
      'id': 'HangingSteelShopSignItem',
      'en': 'Hanging Steel Shop Sign',
      'fr': 'Panneau moyen suspendu de magasin en acier',
      'es': 'Letrero colgante de tienda (acero)',
      'de': 'Stahlschild für Geschäft (hängend)',
      'pl': 'Hanging Steel Shop Sign',
      'ru': 'Стальная магазинная вывеска',
      'uk': 'Hanging Steel Shop Sign',
      'ko': '교수형 철강 상점 기호',
      'zh': '钢制商店悬挂标志',
      'ja': 'Hanging Steel Shop Sign',
    }, {
      'id': 'Hardwood',
      'en': 'Hardwood',
      'fr': 'Bois dur',
      'es': 'Madera noble',
      'de': 'Hartholz',
      'pl': 'Drewno liściaste',
      'ru': 'Лиственные породы',
      'uk': 'Тверда деревина',
      'ko': '견목',
      'zh': '硬木',
      'ja': 'Hardwood',
    }, {
      'id': 'HardyBeardItem',
      'en': 'Hardy Beard',
      'fr': 'Barbe résistante',
      'es': 'Barba Vigorosa',
      'de': 'Vollbart',
      'pl': 'Drwalska Broda',
      'ru': 'Суровая борода',
      'uk': 'Сувора борода',
      'ko': '덥수룩한 수염',
      'zh': '茂密的胡子',
      'ja': '大胆なヒゲ',
    }, {
      'id': 'HareCarcassItem',
      'en': 'Hare Carcass',
      'fr': 'Cadavre de lièvre',
      'es': 'Cadáver de liebre',
      'de': 'Hasenkadaver',
      'pl': 'Padlina zająca',
      'ru': 'Тушка зайца',
      'uk': 'Туша зайця',
      'ko': '토끼 사체',
      'zh': '野兔遗骸',
      'ja': '野ウサギの死体',
    }, {
      'id': 'HeartOfPalmItem',
      'en': 'Heart Of Palm',
      'fr': 'Cœur de palmier',
      'es': 'Palmito',
      'de': 'Palmherz',
      'pl': 'Heart Of Palm',
      'ru': 'Пальмовая сердцевина',
      'uk': 'Серцевина пальми',
      'ko': '대추야자 나무순',
      'zh': '棕榈心',
      'ja': 'ヤシの芯',
    }, {
      'id': 'HeartyHometownPizzaItem',
      'en': 'Hearty Hometown Pizza',
      'fr': 'Pizza copieuse de mon enfance',
      'es': 'Pizza de la Ciudad Natal',
      'de': 'Pizza Home Sweet Home',
      'pl': 'Sycąca domowa pizza',
      'ru': 'Hearty Hometown Pizza',
      'uk': 'Hearty Hometown Pizza',
      'ko': 'Hearty Hometown Pizza',
      'zh': '温馨故乡比萨',
      'ja': 'Hearty Hometown Pizza',
    }, {
      'id': 'HeatSinkItem',
      'en': 'Heat Sink',
      'fr': 'Dissipateur de chaleur',
      'es': 'Disipador de calor',
      'de': 'Kühlkörper',
      'pl': 'Radiator',
      'ru': 'Теплообменник',
      'uk': 'Розсіювач тепла',
      'ko': '방열판',
      'zh': '散热片',
      'ja': 'ヒートシンク',
    }, {
      'id': 'HeliconiaSeedItem',
      'en': 'Heliconia Seed',
      'fr': 'Graine d\u0027heliconia',
      'es': 'Semilla de Heliconia',
      'de': 'Samen (Helikonien)',
      'pl': 'Nasiona Helikonii',
      'ru': 'Семечко геликонии',
      'uk': 'Насіння геліконії',
      'ko': '극락조화 씨앗',
      'zh': '海芋籽',
      'ja': 'ヘリコニアの種',
    }, {
      'id': 'HenleyItem',
      'en': 'Henley',
      'fr': 'Chemise Henley',
      'es': 'Henley',
      'de': 'Henleyshirt',
      'pl': 'Koszulka z Guzikami',
      'ru': 'Хенли',
      'uk': 'Хенлі',
      'ko': '헨리 셔츠',
      'zh': '亨利衫',
      'ja': '襟なしのシャツ',
    }, {
      'id': 'HewnBenchItem',
      'en': 'Hewn Bench',
      'fr': 'Banc taillé',
      'es': 'Banco tallado',
      'de': 'Massivholzbank',
      'pl': 'Ociosana ławka',
      'ru': 'Лавка из обтёсанной древесины',
      'uk': 'Лавка із обтесаного дерева',
      'ko': '다듬은 벤치',
      'zh': '凿台',
      'ja': 'Hewn Bench',
    }, {
      'id': 'HewnChairItem',
      'en': 'Hewn Chair',
      'fr': 'Chaise taillée',
      'es': 'Silla tallada',
      'de': 'Massivholzstuhl',
      'pl': 'Ociosane krzesło',
      'ru': 'Стул из обтёсанного дерева',
      'uk': 'Стілець із обтесаного дерева',
      'ko': '다듬은 의자',
      'zh': '椅子',
      'ja': 'Hewn Chair',
    }, {
      'id': 'HewnDoorItem',
      'en': 'Hewn Door',
      'fr': 'Porte taillée',
      'es': 'Puerta tallada',
      'de': 'Massivholztür',
      'pl': 'Ociosane drzwi',
      'ru': 'Дверь из обтёсанного дерева',
      'uk': 'Двері з обтісаних досок',
      'ko': '다듬은 문',
      'zh': '凿门',
      'ja': 'Hewn Door',
    }, {
      'id': 'HewnDresserItem',
      'en': 'Hewn Dresser',
      'fr': 'Commode taillée',
      'es': 'Vestidor tallado',
      'de': 'Massivholz Kommode',
      'pl': 'Hewn Dresser',
      'ru': 'Комод из тесаного дерева',
      'uk': 'Hewn Dresser',
      'ko': '손질한 드레서',
      'zh': '锯木化妆台',
      'ja': 'Hewn Dresser',
    }, {
      'id': 'HewnLogItem',
      'en': 'Hewn Log',
      'fr': 'Rondin taillé',
      'es': 'Tronco tallado',
      'de': 'Massivholz',
      'pl': 'Ociosana Kłoda',
      'ru': 'Тёсаное бревно',
      'uk': 'Обтесана колода',
      'ko': '잘라낸 통나무',
      'zh': '粗凿原木',
      'ja': '丸太材',
    }, {
      'id': 'HewnLog',
      'en': 'Hewn Log',
      'fr': 'Rondin taillé',
      'es': 'Tronco tallado',
      'de': 'Massivholz',
      'pl': 'Ociosana Kłoda',
      'ru': 'Тёсаное бревно',
      'uk': 'Обтесана колода',
      'ko': '잘라낸 통나무',
      'zh': '粗凿原木',
      'ja': '丸太材',
    }, {
      'id': 'HewnNightstandItem',
      'en': 'Hewn Nightstand',
      'fr': 'Table de chevet en bois taillé',
      'es': 'Mesa de noche tallada',
      'de': 'Massivholz Nachttisch',
      'pl': 'Hewn Nightstand',
      'ru': 'Тумбочка из тесаного дерева',
      'uk': 'Hewn Nightstand',
      'ko': '깎은 협탁',
      'zh': '锯木床头柜',
      'ja': 'Hewn Nightstand',
    }, {
      'id': 'HewnTableItem',
      'en': 'Hewn Table',
      'fr': 'Table taillée',
      'es': 'Mesa tallada',
      'de': 'Massivholztisch',
      'pl': 'Ociosany stół',
      'ru': 'Стол из обтёсанного дерева',
      'uk': 'Стіл із обтесаного дерева',
      'ko': '다듬은 탁자',
      'zh': '割台',
      'ja': 'Hewn Table',
    }, {
      'id': 'HideAshFertilizerItem',
      'en': 'Hide Ash Fertilizer',
      'fr': 'Engrais à base de cendres de peaux',
      'es': 'Fertilizante de Ceniza de Cuero',
      'de': 'Dünger aus Lederasche',
      'pl': 'Nawóz z popiołu skórzanego',
      'ru': 'Зольное удобрение из шкуры',
      'uk': 'Добриво з попелу від згорілої шкіри',
      'ko': '가죽 재 비료',
      'zh': '皮灰化肥',
      'ja': '皮灰の肥料',
    }, {
      'id': 'HosomakiItem',
      'en': 'Hosomaki',
      'fr': 'Hosomaki',
      'es': 'Hosomaki',
      'de': 'Hosomaki',
      'pl': 'Hosomaki',
      'ru': 'Хосомаки',
      'uk': 'Hosomaki',
      'ko': '김밥',
      'zh': '手握寿司',
      'ja': 'Hosomaki',
    }, {
      'id': 'Housing',
      'en': 'Housing',
      'fr': 'Résidence',
      'es': 'Vivienda',
      'de': 'Haus',
      'pl': 'Izba',
      'ru': 'Жилье',
      'uk': 'Житло',
      'ko': '하우징',
      'zh': '房屋',
      'ja': 'ハウジング',
    }, {
      'id': 'HuckleberriesItem',
      'en': 'Huckleberries',
      'fr': 'Myrtilles',
      'es': 'Arándanos',
      'de': 'Heidelbeeren',
      'pl': 'Czarna Jagoda',
      'ru': 'Черника',
      'uk': 'Чорниці',
      'ko': '월귤나무 열매',
      'zh': '越橘',
      'ja': 'ハックルベリー',
    }, {
      'id': 'HuckleberryExtractItem',
      'en': 'Huckleberry Extract',
      'fr': 'Extrait de myrtilles',
      'es': 'Extracto de Arándano',
      'de': 'Heidelbeerextrakt',
      'pl': 'Ekstrakt z Czarnej Jagody',
      'ru': 'Экстракт черники',
      'uk': 'Екстракт чорниці',
      'ko': '월귤나무 열매 추출물',
      'zh': '越橘汁',
      'ja': 'Ekstrakt jagodowy',
    }, {
      'id': 'HuckleberryFritterItem',
      'en': 'Huckleberry Fritter',
      'fr': 'Beignet aux myrtilles',
      'es': 'Buñuelo de Arándanos',
      'de': 'Gebackene Heidelbeeren',
      'pl': 'Huckleberry Fritter',
      'ru': 'Черничные Оладьи',
      'uk': 'Huckleberry Fritter',
      'ko': 'Huckleberry Fritter',
      'zh': '越橘油炸馅饼',
      'ja': 'Huckleberry Fritter',
    }, {
      'id': 'HuckleberryPieItem',
      'en': 'Huckleberry Pie',
      'fr': 'Tourte aux myrtilles',
      'es': 'Tarta de Arándanos',
      'de': 'Heidelbeerkuchen',
      'pl': 'Ciasto Jagodowe',
      'ru': 'Черничный пирог',
      'uk': 'Чорничний пиріг',
      'ko': '월귤나무 열매 파이',
      'zh': '越橘馅饼',
      'ja': 'Ciasto jagodowe',
    }, {
      'id': 'HuckleberrySeedItem',
      'en': 'Huckleberry Seed',
      'fr': 'Graine de myrtilles',
      'es': 'Semilla de Arándano',
      'de': 'Samen (Heidelbeere)',
      'pl': 'Nasiona Jagody',
      'ru': 'Семечко черники',
      'uk': 'Насіння чорниць',
      'ko': '월귤나무 씨앗',
      'zh': '越橘种子',
      'ja': 'ハックルベリーの種',
    }, {
      'id': 'HydrocolloidsItem',
      'en': 'Hydrocolloids',
      'fr': 'Hydrocolloïdes',
      'es': 'Hidrocoloides',
      'de': 'Hydrokolloide',
      'pl': 'Hydrokoloidy',
      'ru': 'Загуститель',
      'uk': 'Гідроколоїди',
      'ko': '하이드로콜로이드',
      'zh': '亲水胶体',
      'ja': 'Hydrokoloidy',
    }, {
      'id': 'IceboxItem',
      'en': 'Icebox',
      'fr': 'Glacière',
      'es': 'Nevera',
      'de': 'Eisschrank',
      'pl': 'Lodówka',
      'ru': 'Ледник',
      'uk': 'Льодовник',
      'ko': '아이스 박스',
      'zh': '冷藏箱',
      'ja': 'アイスボックス',
    }, {
      'id': 'IndustrialElevatorItem',
      'en': 'Industrial Elevator',
      'fr': 'Ascenseur industriel',
      'es': 'Montacargas industrial',
      'de': 'Industrieaufzug',
      'pl': 'Industrial Elevator',
      'ru': 'Промышленный лифт',
      'uk': 'Industrial Elevator',
      'ko': '산업용 엘리베이터',
      'zh': '工业化升降机',
      'ja': 'Industrial Elevator',
    }, {
      'id': 'IndustrialRefrigeratorItem',
      'en': 'Industrial Refrigerator',
      'fr': 'Réfrigérateur industriel',
      'es': 'Nevera industrial',
      'de': 'Industrieller Kühlschrank',
      'pl': 'Industrial Refrigerator',
      'ru': 'Промышленный Холодильник',
      'uk': 'Industrial Refrigerator',
      'ko': '산업용 냉장고',
      'zh': '工业冷藏库',
      'ja': 'Industrial Refrigerator',
    }, {
      'id': 'IndustryUpgradeItem',
      'en': 'Industry Upgrade',
      'fr': 'Amélioration Moderne : Industrie',
      'es': 'Mejora: Industria',
      'de': 'Upgrade Industrie',
      'pl': 'Ulepszenie Przemysłu',
      'ru': 'Улучшение для промышленности',
      'uk': 'Покращення промисловості',
      'ko': '산업 기술 업그레이드',
      'zh': '产业升级',
      'ja': 'Industry Upgrade',
    }, {
      'id': 'InfusedOilItem',
      'en': 'Infused Oil',
      'fr': 'Huile infusée',
      'es': 'Aceite Infusionado',
      'de': 'Raffiniertes Öl',
      'pl': 'Olej smakowy',
      'ru': 'Масляный настой',
      'uk': 'Насичена олія',
      'ko': '침출유',
      'zh': '浸泡油',
      'ja': '混合油',
    }, {
      'id': 'InjectionMoldMachineItem',
      'en': 'Injection Mold Machine',
      'fr': 'Triturateur',
      'es': 'Máquina de moldeo por inyección',
      'de': 'Spritzgußmaschine',
      'pl': 'Injection Mold Machine',
      'ru': 'Термопластавтомат',
      'uk': 'Injection Mold Machine',
      'ko': '사출 금형 기계',
      'zh': '模具注塑机',
      'ja': 'Injection Mold Machine',
    }, {
      'id': 'IronAxeItem',
      'en': 'Iron Axe',
      'fr': 'Hache en fer',
      'es': 'Hacha de Hierro',
      'de': 'Eisenaxt',
      'pl': 'Żelazna siekiera',
      'ru': 'Железный топор',
      'uk': 'Залізна сокира',
      'ko': '철 도끼',
      'zh': '铁斧',
      'ja': '鉄のオノ',
    }, {
      'id': 'IronAxleItem',
      'en': 'Iron Axle',
      'fr': 'Essieu en fer',
      'es': 'Eje de hierro',
      'de': 'Eisenachse',
      'pl': 'Żelazna siekiera',
      'ru': 'Железная ось',
      'uk': 'Залізна вісь',
      'ko': '철재 차축',
      'zh': '铁质车轴',
      'ja': '鉄の車軸',
    }, {
      'id': 'IronBarItem',
      'en': 'Iron Bar',
      'fr': 'Lingot de fer',
      'es': 'Barra de Hierro',
      'de': 'Eisenbarren',
      'pl': 'Sztabka żelaza',
      'ru': 'Железный брусок',
      'uk': 'Залізний брусок',
      'ko': '철괴',
      'zh': '铁条',
      'ja': '鉄のインゴット',
    }, {
      'id': 'IronConcentrateItem',
      'en': 'Iron Concentrate',
      'fr': 'Concentré de fer',
      'es': 'Concentrado de hierro',
      'de': 'Eisenkonzentrat',
      'pl': 'Żelazny koncentrat',
      'ru': 'Концентрат железа',
      'uk': 'Концентрат Заліза',
      'ko': '정제된 철광석',
      'zh': '筛选铁矿石',
      'ja': 'Iron Concentrate',
    }, {
      'id': 'IronGearItem',
      'en': 'Iron Gear',
      'fr': 'Engrenage en fer',
      'es': 'Engranaje de hierro',
      'de': 'Eisenzahnrad',
      'pl': 'Żelazne koło zębate',
      'ru': 'Железная шестерня',
      'uk': 'Залізна шестірня',
      'ko': '철재 톱니바퀴',
      'zh': '铁质齿轮',
      'ja': '鉄のギア',
    }, {
      'id': 'IronHammerItem',
      'en': 'Iron Hammer',
      'fr': 'Marteau en fer',
      'es': 'Martillo de Hierro',
      'de': 'Eisenhammer',
      'pl': 'Żelazny młotek',
      'ru': 'Железный молоток',
      'uk': 'Залізний молоток',
      'ko': '철 망치',
      'zh': '铁锤',
      'ja': '鉄のハンマー',
    }, {
      'id': 'IronHoeItem',
      'en': 'Iron Hoe',
      'fr': 'Binette en fer',
      'es': 'Azada de Hierro',
      'de': 'Eisenhacke',
      'pl': 'Żelazna motyka',
      'ru': 'Железная тяпка',
      'uk': 'Залізна мотика',
      'ko': '철 괭이',
      'zh': '铁锄',
      'ja': '鉄のクワ',
    }, {
      'id': 'IronMacheteItem',
      'en': 'Iron Machete',
      'fr': 'Machette en fer',
      'es': 'Machete de hierro',
      'de': 'Eisenmachete',
      'pl': 'Żelazna maczeta',
      'ru': 'Железное мачете',
      'uk': 'Залізне мачете',
      'ko': '철 마체테',
      'zh': '铁质砍刀',
      'ja': 'Iron Machete',
    }, {
      'id': 'IronOreItem',
      'en': 'Iron Ore',
      'fr': 'Minerai de fer',
      'es': 'Mineral de Hierro',
      'de': 'Eisenerz',
      'pl': 'Ruda żelaza',
      'ru': 'Железная руда',
      'uk': 'Залізна руда',
      'ko': '철광석',
      'zh': '铁矿',
      'ja': '鉄鉱石',
    }, {
      'id': 'IronPickaxeItem',
      'en': 'Iron Pickaxe',
      'fr': 'Pioche en fer',
      'es': 'Pico de Hierro',
      'de': 'Eisenspitzhacke',
      'pl': 'Żelazny kilof',
      'ru': 'Железная кирка',
      'uk': 'Залізне кайло',
      'ko': '철 곡괭이',
      'zh': '铁镐',
      'ja': '鉄のツルハシ',
    }, {
      'id': 'IronPipeItem',
      'en': 'Iron Pipe',
      'fr': 'Tuyau en fer',
      'es': 'Tuberia de Hierro',
      'de': 'Eisenrohr',
      'pl': 'Żelazna rura',
      'ru': 'Железная труба',
      'uk': 'Залізна труба',
      'ko': '철 파이프',
      'zh': '铁管',
      'ja': '鉄パイプ',
    }, {
      'id': 'PistonItem',
      'en': 'Iron Piston',
      'fr': 'Piston en fer',
      'es': 'Pistón de hierro',
      'de': 'Eisenkolben',
      'pl': 'Żelazny tłok',
      'ru': 'Железный поршень',
      'uk': 'Залізний поршень',
      'ko': '철재 피스톤',
      'zh': '铸铁活塞',
      'ja': '鉄のピストン',
    }, {
      'id': 'IronPlateItem',
      'en': 'Iron Plate',
      'fr': 'Plaque de fer',
      'es': 'Placa de Hierro',
      'de': 'Eisenplatte',
      'pl': 'Żelazny Talerz',
      'ru': 'Железная пластина',
      'uk': 'Залізна пластина',
      'ko': '철판',
      'zh': '铁板',
      'ja': '鉄板',
    }, {
      'id': 'IronRockDrillItem',
      'en': 'Iron Rock Drill',
      'fr': 'Foreuse de roche en fer',
      'es': 'Perforadora de hierro para rocas',
      'de': 'Eisenfelsbohrer',
      'pl': 'Żelazne wiertło skalne',
      'ru': 'Железный геологический бур',
      'uk': 'Залізний геологічний бур',
      'ko': '철재 착암기',
      'zh': '铁凿岩机',
      'ja': 'Iron Rock Drill',
    }, {
      'id': 'IronSawBladeItem',
      'en': 'Iron Saw Blade',
      'fr': 'Lame de scie en fer',
      'es': 'Sierra circular de hierro',
      'de': 'Eisensägeblatt',
      'pl': 'Żelazne Ostrze Piły',
      'ru': 'Железный пильный диск',
      'uk': 'Залізний пиляльний диск',
      'ko': '철 톱날',
      'zh': '铁锯片',
      'ja': 'Iron Saw Blade',
    }, {
      'id': 'IronShovelItem',
      'en': 'Iron Shovel',
      'fr': 'Pelle en fer',
      'es': 'Pala de Hierro',
      'de': 'Eisenschaufel',
      'pl': 'Żelazna łopata',
      'ru': 'Железная лопата',
      'uk': 'Залізна лопата',
      'ko': '철 삽',
      'zh': '铁铲',
      'ja': '鉄のシャベル',
    }, {
      'id': 'IronSickleItem',
      'en': 'Iron Sickle',
      'fr': 'Faucille en fer',
      'es': 'Hoz de hierro',
      'de': 'Eisensichel',
      'pl': 'Żelazny Sierp',
      'ru': 'Железный серп',
      'uk': 'Залізний серп',
      'ko': '철 낫',
      'zh': '铁镰',
      'ja': 'Iron Sickle',
    }, {
      'id': 'IronWheelItem',
      'en': 'Iron Wheel',
      'fr': 'Roue en fer',
      'es': 'Rueda de hierro',
      'de': 'Rad aus Eisen',
      'pl': 'Żelazne koło',
      'ru': 'Железное колесо',
      'uk': 'Залізне колесо',
      'ko': '철재 바퀴',
      'zh': '铁轮',
      'ja': '鉄の車輪',
    }, {
      'id': 'JaguarCarcassItem',
      'en': 'Jaguar Carcass',
      'fr': 'Cadavre de jaguar',
      'es': 'Cadáver de jaguar',
      'de': 'Jaguarkadaver',
      'pl': 'Tusza jaguara',
      'ru': 'Туша ягуара',
      'uk': 'Каркас ягуара',
      'ko': '재규어 사체',
      'zh': '美洲豹遗骸',
      'ja': 'Jaguar Carcass',
    }, {
      'id': 'JawCrusherItem',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires en acier',
      'es': 'Trituradora',
      'de': 'Kieferbrecher',
      'pl': 'Kruszarka szczękowa',
      'ru': 'Щековая дробилка',
      'uk': 'Щокова дробарка',
      'ko': '암석 패쇄기',
      'zh': '颚式破碎机',
      'ja': 'Jaw Crusher',
    }, {
      'id': 'JointfirSeedItem',
      'en': 'Jointfir Seed',
      'fr': 'Graine d\u0027ephedra',
      'es': 'Semilla de efedra',
      'de': 'Samen (Meerträubel)',
      'pl': 'Nasiona przęśli',
      'ru': 'Семечко хвойника',
      'uk': 'Насіння ефедри',
      'ko': '마황 씨앗',
      'zh': '麻黄种子',
      'ja': 'Jointfir Seed',
    }, {
      'id': 'JoshuaLogItem',
      'en': 'Joshua Log',
      'fr': 'Bûche de Josué',
      'es': 'Tronco de árbol de Josué',
      'de': 'Josuaholzstamm',
      'pl': 'Kłoda jukki',
      'ru': 'Бревно Юкки коротколистной',
      'uk': 'Колода юки коротколисної',
      'ko': '여호수아나무 통나무',
      'zh': '约书亚原木',
      'ja': 'Joshua Log',
    }, {
      'id': 'JoshuaSeedItem',
      'en': 'Joshua Seed',
      'fr': 'Graine d\u0027arbre de Josué',
      'es': 'Semilla de árbol de Josué',
      'de': 'Samen (Josua-Baum)',
      'pl': 'Nasiona jukki',
      'ru': 'Семечко юкки коротколистной',
      'uk': 'Насіння юкки коротколистної',
      'ko': '여호수아 나무 씨앗',
      'zh': '约书亚树种子',
      'ja': 'Joshua Seed',
    }, {
      'id': 'JungleCampfireSaladItem',
      'en': 'Jungle Campfire Salad',
      'fr': 'Salade de la jungle cuite au feu de camp',
      'es': 'Ensalada braseada con madera de jungla',
      'de': 'Lagerfeuer Dschungelsalat',
      'pl': 'Dżunglowa sałatka z ogniska',
      'ru': 'Джунглевый салат на костре',
      'uk': 'Салат, приготований в таборі у джунглях',
      'ko': '정글 모닥불 샐러드',
      'zh': '丛林篝火沙拉',
      'ja': 'Jungle Campfire Salad',
    }, {
      'id': 'JungleCampfireStewItem',
      'en': 'Jungle Campfire Stew',
      'fr': 'Ragoût de la jungle cuit au feu de camp',
      'es': 'Estofado braseado con madera de jungla',
      'de': 'Lagerfeuer Dschungeleintopf',
      'pl': 'Tropikalny gulasz z ogniska',
      'ru': 'Джунглевое рагу на костре',
      'uk': 'Рагу, приготоване на багатті в джунглях',
      'ko': '정글 모닥불 스튜',
      'zh': '丛林篝火炖汤',
      'ja': 'Jungle Campfire Stew',
    }, {
      'id': 'KelpItem',
      'en': 'Kelp',
      'fr': 'Varech',
      'es': 'Alga',
      'de': 'Seetang',
      'pl': 'Wodorosty',
      'ru': 'Ламинария',
      'uk': 'Ламінарія',
      'ko': '다시마',
      'zh': '海带',
      'ja': '海藻',
    }, {
      'id': 'KelpSeedItem',
      'en': 'Kelp Seed',
      'fr': 'Graine de varech',
      'es': 'Semilla de Alga',
      'de': 'Samen (Seetang)',
      'pl': 'Nasiona Listownicy',
      'ru': 'Семя бурой водоросли',
      'uk': 'Насіння ламінарії',
      'ko': '다시마 씨앗',
      'zh': '海带种子',
      'ja': '海藻の種',
    }, {
      'id': 'KelpyCrabRollItem',
      'en': 'Kelpy Crab Roll',
      'fr': 'Maki au crabe',
      'es': 'Rollo de Cangrejo con Algas',
      'de': 'Krabbenrolle mit Algen',
      'pl': 'Kelpy Crab Roll',
      'ru': 'Ролл Краб в ламинарии',
      'uk': 'Kelpy Crab Roll',
      'ko': 'Kelpy Crab Roll',
      'zh': '苏格兰蟹肉卷',
      'ja': 'Kelpy Crab Roll',
    }, {
      'id': 'KilnItem',
      'en': 'Kiln',
      'fr': 'Four à céramique',
      'es': 'Horno',
      'de': 'Brennofen',
      'pl': 'Piec do Wypalania',
      'ru': 'Печь для обжига',
      'uk': 'Промислова піч',
      'ko': '가마',
      'zh': '窑',
      'ja': 'かまど',
    }, {
      'id': 'KingFernSporeItem',
      'en': 'King Fern Spore',
      'fr': 'Spore de fougère royale',
      'es': 'Espora de helecho real',
      'de': 'Sporen (Königsfarn)',
      'pl': 'King Fern Spore',
      'ru': 'Спора королевского папоротника',
      'uk': 'Спори королівської папороті',
      'ko': '왕고비 포자',
      'zh': '国王蕨孢子',
      'ja': 'ゼンマイの胞子',
    }, {
      'id': 'KitchenItem',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '주방',
      'zh': '厨房',
      'ja': 'キッチン',
    }, {
      'id': 'LaboratoryItem',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Laboratorium',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'Лабораторія',
      'ko': '연구대',
      'zh': '实验室',
      'ja': '研究所',
    }, {
      'id': 'LandClaimStakeItem',
      'en': 'Land Claim Stake',
      'fr': 'Piquet de revendication territoriale',
      'es': 'Poste para reclamo de tierras',
      'de': 'Grundstück-Absteckpflock',
      'pl': 'Słupek Oznaczenia Ziemi',
      'ru': 'Колышек землемера',
      'uk': 'Кілок підтвердження права на власність',
      'ko': '부지 소유 말뚝',
      'zh': '领地界桩',
      'ja': '土地請求用の杭',
    }, {
      'id': 'LargeBathMatItem',
      'en': 'Large Bath Mat',
      'fr': 'Grand tapis de bain',
      'es': 'Alfombrilla de baño grande',
      'de': 'Große Badematte',
      'pl': 'Large Bath Mat',
      'ru': 'Большой коврик для ванной',
      'uk': 'Large Bath Mat',
      'ko': 'Large Bath Mat',
      'zh': '大型浴室防滑垫',
      'ja': 'Large Bath Mat',
    }, {
      'id': 'LargeCorrugatedSteelDoorItem',
      'en': 'Large Corrugated Steel Door',
      'fr': 'Porte de garage en tôle ondulée',
      'es': 'Puerta grande corrugada (acero)',
      'de': 'Große Wellstahltür',
      'pl': 'Duże drzwi ze stali falistej',
      'ru': 'Рольставни',
      'uk': 'Великі гофровані сталеві двері',
      'ko': '큰 파형 강철판 문',
      'zh': '大型波纹钢门',
      'ja': '波形鉄板でできた大きなドア',
    }, {
      'id': 'LargeFish',
      'en': 'Large Fish',
      'fr': 'Grand Poisson',
      'es': 'Pez grande',
      'de': 'Großer Fisch',
      'pl': 'Large Fish',
      'ru': 'Большая рыба',
      'uk': 'Велика риба',
      'ko': 'Large Fish',
      'zh': '大鱼',
      'ja': 'Large Fish',
    }, {
      'id': 'LargeHangingAshlarBasaltSignItem',
      'en': 'Large Hanging Ashlar Basalt Sign',
      'fr': 'Grand panneau suspendu en basalte taillé',
      'es': 'Letrero colgante grande (sillar de basalto)',
      'de': 'Steinquaderschild aus Basalt (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego bazaltu',
      'ru': 'Большая вывеска из резного базальта',
      'uk': 'Велика вивіска з обтесаного базальту',
      'ko': '큰 걸이형 각진 현무암 간판',
      'zh': '大型悬挂阿什拉尔玄武岩标志',
      'ja': 'Large Hanging Ashlar Basalt Sign',
    }, {
      'id': 'LargeHangingAshlarGneissSignItem',
      'en': 'Large Hanging Ashlar Gneiss Sign',
      'fr': 'Grand panneau suspendu en gneiss taillé',
      'es': 'Letrero colgante grande (sillar de gneis)',
      'de': 'Steinquaderschild aus Gneiss (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego gnejsu',
      'ru': 'Большая вывеска из резного гнейса',
      'uk': 'Велика вивіска з обтесаного гнейсу',
      'ko': '큰 걸이형 각진 편마암 간판',
      'zh': '大型悬挂阿什拉尔片麻岩标志',
      'ja': 'Large Hanging Ashlar Gneiss Sign',
    }, {
      'id': 'LargeHangingAshlarGraniteSignItem',
      'en': 'Large Hanging Ashlar Granite Sign',
      'fr': 'Grand panneau suspendu en granite taillé',
      'es': 'Letrero colgante grande (sillar de granito)',
      'de': 'Steinquaderschild aus Granit (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego granitu',
      'ru': 'Большая вывеска из резного гранита',
      'uk': 'Велика вивіска з обтесаного граніту',
      'ko': '큰 걸이형 각진 화강암 간판',
      'zh': '大型悬挂石板花岗岩标志',
      'ja': 'Large Hanging Ashlar Granite Sign',
    }, {
      'id': 'LargeHangingAshlarLimestoneSignItem',
      'en': 'Large Hanging Ashlar Limestone Sign',
      'fr': 'Grand panneau suspendu en calcaire taillé',
      'es': 'Letrero colgante grande (sillar de piedra caliza)',
      'de': 'Steinquaderschild aus Kalkstein (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego wapienia',
      'ru': 'Большая вывеска из резного известняка',
      'uk': 'Велика вивіска з обтесаного вапняку',
      'ko': '큰 걸이형 각진 석회암 간판',
      'zh': '大型悬挂阿什拉尔石灰石标志',
      'ja': 'Large Hanging Ashlar Limestone Sign',
    }, {
      'id': 'LargeHangingAshlarSandstoneSignItem',
      'en': 'Large Hanging Ashlar Sandstone Sign',
      'fr': 'Grand panneau suspendu en grès taillé',
      'es': 'Letrero colgante grande (sillar de arenisca)',
      'de': 'Steinquaderschild aus Sandstein (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego piaskowca',
      'ru': 'Большая вывеска из резного песчаника',
      'uk': 'Велика вивіска з обтесаного піщаника',
      'ko': '큰 걸이형 각진 사암 간판',
      'zh': '大型悬挂石板砂岩标志',
      'ja': 'Large Hanging Ashlar Sandstone Sign',
    }, {
      'id': 'LargeHangingAshlarShaleSignItem',
      'en': 'Large Hanging Ashlar Shale Sign',
      'fr': 'Grand panneau suspendu en schiste taillé',
      'es': 'Letrero colgante grande (sillar de pizarra)',
      'de': 'Steinquaderschild aus Schiefer (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego łupku',
      'ru': 'Большая вывеска из резного сланца',
      'uk': 'Велика вивіска з обтесаного сланцю',
      'ko': '큰 걸이형 각진 이판암 간판',
      'zh': '大型悬挂阿什拉尔页岩标志',
      'ja': 'Large Hanging Ashlar Shale Sign',
    }, {
      'id': 'LargeHangingAshlarStoneSignItem',
      'en': 'Large Hanging Ashlar Stone Sign',
      'fr': 'Grand panneau suspendu en pierre taillée',
      'es': 'Letrero colgante grande (sillar de piedra)',
      'de': 'Steinquaderschild (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego kamienia',
      'ru': 'Большая вывеска из резного камня',
      'uk': 'Велика вивіска з обтесаного каменю',
      'ko': '큰 걸이형 모르타르 마감 현무암 간판',
      'zh': '大型吊石板标志',
      'ja': 'Large Hanging Ashlar Stone Sign',
    }, {
      'id': 'LargeHangingBirchSignItem',
      'en': 'Large Hanging Birch Sign',
      'fr': 'Grand panneau suspendu en bouleau',
      'es': 'Letrero colgante grande (abedul)',
      'de': 'Holzschild aus Birkenholz (Groß, hängend)',
      'pl': 'Duży wiszący znak brzozowy',
      'ru': 'Большая берёзовая вывеска',
      'uk': 'Велика березова вивіска',
      'ko': '큰 걸이형 자작나무 간판',
      'zh': '大型悬挂桦木标志',
      'ja': 'Large Hanging Birch Sign',
    }, {
      'id': 'LargeHangingCedarSignItem',
      'en': 'Large Hanging Cedar Sign',
      'fr': 'Grand panneau suspendu en cèdre',
      'es': 'Letrero colgante grande (cedro)',
      'de': 'Holzschild aus Zedernholz (Groß, hängend)',
      'pl': 'Duży wiszący znak cedrowy',
      'ru': 'Большая кедровая вывеска',
      'uk': 'Велика кедрова вивіска',
      'ko': '큰 걸이형 삼나무 목재 간판',
      'zh': '大型悬挂雪松标志',
      'ja': 'Large Hanging Cedar Sign',
    }, {
      'id': 'LargeHangingCeibaSignItem',
      'en': 'Large Hanging Ceiba Sign',
      'fr': 'Grand panneau suspendu en ceiba',
      'es': 'Letrero colgante grande (ceiba)',
      'de': 'Holzschild aus Kapokholz (Groß, hängend)',
      'pl': 'Duży wiszący znak z puchowca',
      'ru': 'Большая вывеска из сейбы',
      'uk': 'Велика вивіска з сейби',
      'ko': '큰 걸이형 명주나무 간판',
      'zh': '大型悬挂木棉标志',
      'ja': 'Large Hanging Ceiba Sign',
    }, {
      'id': 'LargeHangingFirSignItem',
      'en': 'Large Hanging Fir Sign',
      'fr': 'Grand panneau suspendu en sapin',
      'es': 'Letrero colgante grande (abeto)',
      'de': 'Holzschild aus Tannenholz (Groß, hängend)',
      'pl': 'Duży wiszący znak jodłowy',
      'ru': 'Большая пихтовая вывеска',
      'uk': 'Велика вивіска з ялиці',
      'ko': '큰 걸이형 전나무 목재 간판',
      'zh': '大型悬挂冷杉标志',
      'ja': 'Large Hanging Fir Sign',
    }, {
      'id': 'LargeHangingHardwoodSignItem',
      'en': 'Large Hanging Hardwood Sign',
      'fr': 'Grand panneau suspendu en bois dur',
      'es': 'Letrero colgante grande (madera noble)',
      'de': 'Holzschild aus Hartholz (Groß, hängend)',
      'pl': 'Duży wiszący znak z drewna liściastego',
      'ru': 'Большая вывеска из лиственных пород',
      'uk': 'Велика вивіска із твердої деревини',
      'ko': '큰 걸이형 견목재 간판',
      'zh': '大型悬挂硬木标志',
      'ja': 'Large Hanging Hardwood Sign',
    }, {
      'id': 'LargeHangingJoshuaSignItem',
      'en': 'Large Hanging Joshua Sign',
      'fr': 'Grand panneau suspendu en josué',
      'es': 'Letrero colgante grande (joshua)',
      'de': 'Holzschild aus Josuaholz (Groß, hängend)',
      'pl': 'Duży wiszący znak z drewna jukki',
      'ru': 'Большая вывеска из юкки коротколистной',
      'uk': 'Велика вивіска з юки коротколисної',
      'ko': '큰 걸이형 여호수아 목재 간판',
      'zh': '大型悬挂约书亚标志',
      'ja': 'Large Hanging Joshua Sign',
    }, {
      'id': 'LargeHangingLumberSignItem',
      'en': 'Large Hanging Lumber Sign',
      'fr': 'Grand panneau suspendu en bois d\u0027oeuvre',
      'es': 'Letrero colgante grande (tablas de madera)',
      'de': 'Bauholzschild (Groß, hängend)',
      'pl': 'Large Hanging Lumber Sign',
      'ru': 'Большая вывеска из пиломатериалов',
      'uk': 'Велика навісна дерев’яна табличка',
      'ko': '큰 걸이형 가공 목재 간판',
      'zh': '大型木制标志',
      'ja': '木製の大きな掛け看板',
    }, {
      'id': 'LargeHangingMortaredGraniteSignItem',
      'en': 'Large Hanging Mortared Granite Sign',
      'fr': 'Grand panneau suspendu en granite cimenté',
      'es': 'Letrero colgante grande (granito con mortero)',
      'de': 'Steinziegelschild aus Granit (Groß, hängend)',
      'pl': 'Duży wiszący szyld ze spojonego zaprawą granitu',
      'ru': 'Большая вывеска из строительного гранита',
      'uk': 'Велика вивіска з будівельного граніту',
      'ko': '큰 걸이형 모르타르 마감 화강암 간판',
      'zh': '大型悬挂砂浆花岗岩标志',
      'ja': 'Large Hanging Mortared Granite Sign',
    }, {
      'id': 'LargeHangingMortaredLimestoneSignItem',
      'en': 'Large Hanging Mortared Limestone Sign',
      'fr': 'Grand panneau suspendu en calcaire cimenté',
      'es': 'Letrero colgante grande (piedra caliza con mortero)',
      'de': 'Steinziegelschild aus Kalkstein (Groß, hängend)',
      'pl': 'Duży wiszący szyld ze spojonego zaprawą wapienia',
      'ru': 'Большая вывеска из строительного известняка',
      'uk': 'Велика вивіска з будівельного вапняку',
      'ko': '큰 걸이형 모르타르 마감 석회암 간판',
      'zh': '大型悬挂砂浆石灰石标志',
      'ja': 'Large Hanging Mortared Limestone Sign',
    }, {
      'id': 'LargeHangingMortaredSandstoneSignItem',
      'en': 'Large Hanging Mortared Sandstone Sign',
      'fr': 'Grand panneau suspendu en grès cimenté',
      'es': 'Letrero colgante grande (arenisca con mortero)',
      'de': 'Steinziegelschild aus Sandstein (Groß, hängend)',
      'pl': 'Duży wiszący szyld ze spojonego zaprawą piaskowca',
      'ru': 'Большая вывеска из строительного песчаника',
      'uk': 'Велика вивіска з будівельного піщаника',
      'ko': '큰 걸이형 모르타르 마감 사암 간판',
      'zh': '大型悬挂砂浆砂岩标志',
      'ja': 'Large Hanging Mortared Sandstone Sign',
    }, {
      'id': 'LargeHangingMortaredStoneSignItem',
      'en': 'Large Hanging Mortared Stone Sign',
      'fr': 'Grand panneau suspendu en pierre cimentée',
      'es': 'Letrero colgante grande (piedra con mortero)',
      'de': 'Steinziegelschild (Groß, hängend)',
      'pl': 'Duży wiszący znak ze spojonego zaprawą kamienia',
      'ru': 'Большая вывеска из строительного камня',
      'uk': 'Велика вивіска з будівельного каменю',
      'ko': '큰 걸이형 모르타르 마감 석재 간판',
      'zh': '大型悬挂砂浆石标志',
      'ja': 'Large Hanging Mortared Stone Sign',
    }, {
      'id': 'LargeHangingOakSignItem',
      'en': 'Large Hanging Oak Sign',
      'fr': 'Grand panneau suspendu en chêne',
      'es': 'Letrero colgante grande (roble)',
      'de': 'Holzschild aus Eiche (Groß, hängend)',
      'pl': 'Duży wiszący znak dębowy',
      'ru': 'Большая дубовая вывеска',
      'uk': 'Велика дубова вивіска',
      'ko': '큰 걸이형 참나무 목재 간판',
      'zh': '大型悬挂橡木标志',
      'ja': 'Large Hanging Oak Sign',
    }, {
      'id': 'LargeHangingPalmSignItem',
      'en': 'Large Hanging Palm Sign',
      'fr': 'Grand panneau suspendu en palmier',
      'es': 'Letrero colgante grande (palmera)',
      'de': 'Holzschild aus Palmenholz (Groß, hängend)',
      'pl': 'Duży wiszący znak palmowy',
      'ru': 'Большая пальмовая вывеска',
      'uk': 'Велика пальмова вивіска',
      'ko': '큰 걸이형 야자나무 목재 간판',
      'zh': '大型悬挂棕榈标志',
      'ja': 'Large Hanging Palm Sign',
    }, {
      'id': 'LargeHangingRedwoodSignItem',
      'en': 'Large Hanging Redwood Sign',
      'fr': 'Grand panneau suspendu en séquoia',
      'es': 'Letrero colgante grande (secuoya)',
      'de': 'Holzschild aus Rottanne (Groß, hängend)',
      'pl': 'Duży wiszący znak sekwojowy',
      'ru': 'Большая вывеска из секвойи',
      'uk': 'Велика вивіска з секвої',
      'ko': '큰 걸이형 삼나무 목재 간판',
      'zh': '大型悬挂红木标志',
      'ja': 'Large Hanging Redwood Sign',
    }, {
      'id': 'LargeHangingSaguaroSignItem',
      'en': 'Large Hanging Saguaro Sign',
      'fr': 'Grand panneau suspendu en saguaro',
      'es': 'Letrero colgante grande (saguaro)',
      'de': 'Holzschild aus Kaktusholz (Groß, hängend)',
      'pl': 'Duży wiszący znak z saguaro',
      'ru': 'Большая вывеска из карнегии',
      'uk': 'Велика навісна табличка із саваро',
      'ko': '큰 걸이형 사와로 골재 간판',
      'zh': '大型悬挂仙人掌标志',
      'ja': 'Large Hanging Saguaro Sign',
    }, {
      'id': 'LargeHangingSoftwoodSignItem',
      'en': 'Large Hanging Softwood Sign',
      'fr': 'Grand panneau suspendu en bois tendre',
      'es': 'Letrero colgante grande (madera blanda)',
      'de': 'Holzschild aus Weichholz (Groß, hängend)',
      'pl': 'Duży wiszący znak z drewna iglastego',
      'ru': 'Большая вывеска из хвойных пород',
      'uk': 'Велика вивіска із хвойних дерев',
      'ko': '큰 걸이형 연목재 간판',
      'zh': '大型悬挂软木标志',
      'ja': 'Large Hanging Softwood Sign',
    }, {
      'id': 'LargeHangingSpruceSignItem',
      'en': 'Large Hanging Spruce Sign',
      'fr': 'Grand panneau suspendu en épicéa',
      'es': 'Letrero colgante grande (pícea)',
      'de': 'Holzschild aus Fichtenholz (Groß, hängend)',
      'pl': 'Duży wiszący znak świerkowy',
      'ru': 'Большая еловая вывеска',
      'uk': 'Велика ялинова вивіска',
      'ko': '큰 걸이형 가문비나무 목재 간판',
      'zh': '大型悬挂云杉标志',
      'ja': 'Large Hanging Spruce Sign',
    }, {
      'id': 'LargeHangingStoneSignItem',
      'en': 'Large Hanging Stone Sign',
      'fr': 'Grand panneau suspendu en pierre',
      'es': 'Letrero colgante grande (piedra)',
      'de': 'Steinschild (Groß, hängend)',
      'pl': 'Large Hanging Stone Sign',
      'ru': 'Большая вывеска из камня',
      'uk': 'Велика навісна кам’яна табличка',
      'ko': '큰 걸이형 석재 간판',
      'zh': '大型石制标志',
      'ja': '石の大きな掛け看板',
    }, {
      'id': 'LargeHangingWoodSignItem',
      'en': 'Large Hanging Wood Sign',
      'fr': 'Grand panneau suspendu en bois',
      'es': 'Letrero colgante grande (básico)',
      'de': 'Holzschild (Groß, hängend)',
      'pl': 'Duży wiszący znak drewniany',
      'ru': 'Большая деревянная вывеска',
      'uk': 'Велика дерев\u0027яна вивіска',
      'ko': '큰 걸이형 목재 간판',
      'zh': '大型悬挂木质标志',
      'ja': 'Large Hanging Wood Sign',
    }, {
      'id': 'LargeLumberDoorItem',
      'en': 'Large Lumber Door',
      'fr': 'Porte de garage en bois d\u0027oeuvre',
      'es': 'Puerta grande de madera',
      'de': 'Große Holztür',
      'pl': 'Large Lumber Door',
      'ru': 'Деревянные ворота',
      'uk': 'Великі дерев’яні двері',
      'ko': '큰 가공 목재 문',
      'zh': '大木门',
      'ja': '大きな製材のドア',
    }, {
      'id': 'LargeLumberStockpileItem',
      'en': 'Large Lumber Stockpile',
      'fr': 'Réserve en bois d\u0027oeuvre grande',
      'es': 'Pila grande de troncos',
      'de': 'Bauholzlager (Groß)',
      'pl': 'Large Lumber Stockpile',
      'ru': 'Большой склад из пиломатериалов',
      'uk': 'Великий склад з пиломатеріалів',
      'ko': '대형 가공 목재 자재 창고',
      'zh': '大型木制料堆',
      'ja': 'Large Lumber Stockpile',
    }, {
      'id': 'LargeStandingAshlarBasaltSignItem',
      'en': 'Large Standing Ashlar Basalt Sign',
      'fr': 'Grand panneau sur pied en basalte taillé',
      'es': 'Letrero grande (sillar de basalto)',
      'de': 'Steinquaderschild aus Basalt (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego bazaltu',
      'ru': 'Большая табличка из резного базальта',
      'uk': 'Велика табличка з обтесаного базальту',
      'ko': '큰 각진 현무암 선간판',
      'zh': '大型立式石拉玄武岩标志',
      'ja': 'Large Standing Ashlar Basalt Sign',
    }, {
      'id': 'LargeStandingAshlarGneissSignItem',
      'en': 'Large Standing Ashlar Gneiss Sign',
      'fr': 'Grand panneau sur pied en gneiss taillé',
      'es': 'Letrero grande (sillar de gneis)',
      'de': 'Steinquaderschild aus Gneiss (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego gnejsu',
      'ru': 'Большая табличка из резного гнейса',
      'uk': 'Велика табличка з обтесаного гнейсу',
      'ko': '큰 각진 편마암 선간판',
      'zh': '大型立式阿什拉尔片麻岩标志',
      'ja': 'Large Standing Ashlar Gneiss Sign',
    }, {
      'id': 'LargeStandingAshlarGraniteSignItem',
      'en': 'Large Standing Ashlar Granite Sign',
      'fr': 'Grand panneau sur pied en granite taillé',
      'es': 'Letrero grande (sillar de granito)',
      'de': 'Steinquaderschild aus Granit (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego granitu',
      'ru': 'Большая табличка из резного гранита',
      'uk': 'Велика табличка з обтесаного граніту',
      'ko': '큰 각진 화강암 선간판',
      'zh': '大型立阿什拉尔花岗岩标志',
      'ja': 'Large Standing Ashlar Granite Sign',
    }, {
      'id': 'LargeStandingAshlarLimestoneSignItem',
      'en': 'Large Standing Ashlar Limestone Sign',
      'fr': 'Grand panneau sur pied en calcaire taillé',
      'es': 'Letrero grande (sillar de piedra caliza)',
      'de': 'Steinquaderschild aus Kalkstein (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego wapienia',
      'ru': 'Большая табличка из резного известняка',
      'uk': 'Велика табличка з обтесаного вапняку',
      'ko': '큰 각진 석회암 선간판',
      'zh': '大型立式阿什拉尔石灰石标志',
      'ja': 'Large Standing Ashlar Limestone Sign',
    }, {
      'id': 'LargeStandingAshlarSandstoneSignItem',
      'en': 'Large Standing Ashlar Sandstone Sign',
      'fr': 'Grand panneau sur pied en grès taillé',
      'es': 'Letrero grande (sillar de arenisca)',
      'de': 'Steinquaderschild aus Sandstein (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego piaskowca',
      'ru': 'Большая табличка из резного песчаника',
      'uk': 'Велика табличка з обтесаного піщаника',
      'ko': '큰 각진 사암 선간판',
      'zh': '大型立阿什拉尔砂岩标志',
      'ja': 'Large Standing Ashlar Sandstone Sign',
    }, {
      'id': 'LargeStandingAshlarShaleSignItem',
      'en': 'Large Standing Ashlar Shale Sign',
      'fr': 'Grand panneau sur pied en schiste taillé',
      'es': 'Letrero grande (sillar de pizarra)',
      'de': 'Steinquaderschild aus Schiefer (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego łupku',
      'ru': 'Большая табличка из резного сланца',
      'uk': 'Велика табличка з обтесаного сланцю',
      'ko': '큰 각진 이판암 선간판',
      'zh': '大型立式石炭页岩标志',
      'ja': 'Large Standing Ashlar Shale Sign',
    }, {
      'id': 'LargeStandingAshlarStoneSignItem',
      'en': 'Large Standing Ashlar Stone Sign',
      'fr': 'Grand panneau sur pied en pierre taillée',
      'es': 'Letrero grande (sillar de piedra)',
      'de': 'Steinquaderschild (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego kamienia',
      'ru': 'Большая табличка из резного камня',
      'uk': 'Велика табличка з обтесаного каменю',
      'ko': '큰 각진 석재 선간판',
      'zh': '大型立阿什拉尔石标志',
      'ja': 'Large Standing Ashlar Stone Sign',
    }, {
      'id': 'LargeStandingBirchSignItem',
      'en': 'Large Standing Birch Sign',
      'fr': 'Grand panneau sur pied en bouleau',
      'es': 'Letrero grande (abedul)',
      'de': 'Holzschild aus Birkenholz (Groß, stehend)',
      'pl': 'Duży stojący znak brzozowy',
      'ru': 'Большая берёзовая табличка',
      'uk': 'Велика березова табличка',
      'ko': '큰 자작나무 목재 선간판',
      'zh': '大白桦树标志',
      'ja': 'Large Standing Birch Sign',
    }, {
      'id': 'LargeStandingCedarSignItem',
      'en': 'Large Standing Cedar Sign',
      'fr': 'Grand panneau sur pied en cèdre',
      'es': 'Letrero grande (cedro)',
      'de': 'Holzschild aus Zedernholz (Groß, stehend)',
      'pl': 'Duży stojący znak cedrowy',
      'ru': 'Большая кедровая табличка',
      'uk': 'Велика кедрова табличка',
      'ko': '큰 삼나무 목재 선간판',
      'zh': '大型立式雪松标志',
      'ja': 'Large Standing Cedar Sign',
    }, {
      'id': 'LargeStandingCeibaSignItem',
      'en': 'Large Standing Ceiba Sign',
      'fr': 'Grand panneau sur pied en ceiba',
      'es': 'Letrero grande (ceiba)',
      'de': 'Holzschild aus Kapokholz (Groß, stehend)',
      'pl': 'Duży stojący znak z puchowca',
      'ru': 'Большая табличка из сейбы',
      'uk': 'Велика табличка з сейби',
      'ko': '큰 명주나무 목재 선간판',
      'zh': '大型立式木棉标志',
      'ja': 'Large Standing Ceiba Sign',
    }, {
      'id': 'LargeStandingFirSignItem',
      'en': 'Large Standing Fir Sign',
      'fr': 'Grand panneau sur pied en sapin',
      'es': 'Letrero grande (abeto)',
      'de': 'Holzschild aus Tannenholz (Groß, stehend)',
      'pl': 'Duży stojący znak jodłowy',
      'ru': 'Большая пихтовая табличка',
      'uk': 'Велика табличка з ялиці',
      'ko': '큰 전나무 목재 선간판',
      'zh': '大型立式杉木标志',
      'ja': 'Large Standing Fir Sign',
    }, {
      'id': 'LargeStandingHardwoodSignItem',
      'en': 'Large Standing Hardwood Sign',
      'fr': 'Grand panneau sur pied en bois dur',
      'es': 'Letrero grande (madera dura)',
      'de': 'Holzschild aus Hartholz (Groß, stehend)',
      'pl': 'Duży stojący znak z drewna liściastego',
      'ru': 'Большая табличка из лиственных пород',
      'uk': 'Велика табличка із твердої деревини',
      'ko': '큰 견목재 선간판',
      'zh': '大型立式硬木标志',
      'ja': 'Large Standing Hardwood Sign',
    }, {
      'id': 'LargeStandingJoshuaSignItem',
      'en': 'Large Standing Joshua Sign',
      'fr': 'Grand panneau sur pied en josué',
      'es': 'Letrero grande (joshua)',
      'de': 'Holzschild aus Josuaholz (Groß, stehend)',
      'pl': 'Duży stojący znak z drewna jukki',
      'ru': 'Большая табличка из юкки коротколистной',
      'uk': 'Велика табличка з юки коротколисної',
      'ko': '큰 여호수아나무 목재 선간판',
      'zh': '大型约书亚标志',
      'ja': 'Large Standing Joshua Sign',
    }, {
      'id': 'LargeStandingLumberSignItem',
      'en': 'Large Standing Lumber Sign',
      'fr': 'Grand panneau sur pied en bois d\u0027oeuvre',
      'es': 'Letrero grande (tablas de madera)',
      'de': 'Bauholzschild (Groß, stehend)',
      'pl': 'Large Standing Lumber Sign',
      'ru': 'Большая табличка из пиломатериалов',
      'uk': 'Велика стояча дерев’яна табличка',
      'ko': '큰 가공 목재 선간판',
      'zh': '大块木制标志',
      'ja': '木製の大きな立て看板',
    }, {
      'id': 'LargeStandingMortaredGraniteSignItem',
      'en': 'Large Standing Mortared Granite Sign',
      'fr': 'Grand panneau sur pied en granite cimenté',
      'es': 'Letrero grande (granito con mortero)',
      'de': 'Steinziegelschild aus Granit (Groß, stehend)',
      'pl': 'Duży stojący szyld ze spojonego zaprawą granitu',
      'ru': 'Большая табличка из строительного гранита',
      'uk': 'Велика табличка з будівельного граніту',
      'ko': '큰 모르타르 마감 화강암 선간판',
      'zh': '大型砂浆花岗岩标志',
      'ja': 'Large Standing Mortared Granite Sign',
    }, {
      'id': 'LargeStandingMortaredLimestoneSignItem',
      'en': 'Large Standing Mortared Limestone Sign',
      'fr': 'Grand panneau sur pied en calcaire cimenté',
      'es': 'Letrero grande (piedra caliza con mortero)',
      'de': 'Steinziegelschild aus Kalkstein (Groß, stehend)',
      'pl': 'Duży stojący szyld ze spojonego zaprawą wapienia',
      'ru': 'Большая табличка из строительного известняка',
      'uk': 'Велика табличка з будівельного вапняку',
      'ko': '큰 모르타르 마감 석회암 선간판',
      'zh': '大型砂浆石灰石标志',
      'ja': 'Large Standing Mortared Limestone Sign',
    }, {
      'id': 'LargeStandingMortaredSandstoneSignItem',
      'en': 'Large Standing Mortared Sandstone Sign',
      'fr': 'Grand panneau sur pied en grès cimenté',
      'es': 'Letrero grande (arenisca con mortero)',
      'de': 'Steinziegelschild aus Sandstein (Groß, stehend)',
      'pl': 'Duży stojący szyld ze spojonego zaprawą piaskowca',
      'ru': 'Большая табличка из строительного песчаника',
      'uk': 'Велика табличка з будівельного піщаника',
      'ko': '큰 모르타르 마감 사암 선간판',
      'zh': '大型砂浆砂岩标志',
      'ja': 'Large Standing Mortared Sandstone Sign',
    }, {
      'id': 'LargeStandingMortaredStoneSignItem',
      'en': 'Large Standing Mortared Stone Sign',
      'fr': 'Grand panneau sur pied en pierre cimenté',
      'es': 'Letrero grande (piedra con mortero)',
      'de': 'Steinziegelschild (Groß, stehend)',
      'pl': 'Duży stojący szyld ze spojonego zaprawą kamienia',
      'ru': 'Большая табличка из строительного камня',
      'uk': 'Велика табличка з будівельного каменю',
      'ko': '큰 모르타르 마감 석재 선간판',
      'zh': '大型立式砂浆石标志',
      'ja': 'Large Standing Mortared Stone Sign',
    }, {
      'id': 'LargeStandingOakSignItem',
      'en': 'Large Standing Oak Sign',
      'fr': 'Grand panneau sur pied en chêne',
      'es': 'Letrero grande (roble)',
      'de': 'Holzschild aus Eiche (Groß, stehend)',
      'pl': 'Duży stojący znak dębowy',
      'ru': 'Большая дубовая табличка',
      'uk': 'Велика дубова табличка',
      'ko': '큰 참나무 목재 선간판',
      'zh': '大型橡木标志',
      'ja': 'Large Standing Oak Sign',
    }, {
      'id': 'LargeStandingPalmSignItem',
      'en': 'Large Standing Palm Sign',
      'fr': 'Grand panneau sur pied en palmier',
      'es': 'Letrero grande (palmera)',
      'de': 'Holzschild aus Palmenholz (Groß, stehend)',
      'pl': 'Duży stojący znak palmowy',
      'ru': 'Большая пальмовая табличка',
      'uk': 'Велика пальмова табличка',
      'ko': '큰 야자나무 목재 선간판',
      'zh': '大型立式棕榈标志',
      'ja': 'Large Standing Palm Sign',
    }, {
      'id': 'LargeStandingRedwoodSignItem',
      'en': 'Large Standing Redwood Sign',
      'fr': 'Grand panneau sur pied en séquoia',
      'es': 'Letrero grande (secuoya)',
      'de': 'Holzschild aus Rottanne (Groß, stehend)',
      'pl': 'Duży stojący znak sekwojowy',
      'ru': 'Большая табличка из секвойи',
      'uk': 'Велика табличка з секвої',
      'ko': '큰 삼나무 목재 선간판',
      'zh': '大型立式红木标志',
      'ja': 'Large Standing Redwood Sign',
    }, {
      'id': 'LargeStandingSaguaroSignItem',
      'en': 'Large Standing Saguaro Sign',
      'fr': 'Grand panneau sur pied en saguaro',
      'es': 'Letrero grande (saguaro)',
      'de': 'Holzschild aus Kaktusholz (Groß, stehend)',
      'pl': 'Duży stojący znak z saguaro',
      'ru': 'Большая табличка из карнегии',
      'uk': 'Велика табличка з карнегії',
      'ko': '큰 사와로 골재 선간판',
      'zh': '大柱仙人掌标志',
      'ja': 'Large Standing Saguaro Sign',
    }, {
      'id': 'LargeStandingSoftwoodSignItem',
      'en': 'Large Standing Softwood Sign',
      'fr': 'Grand panneau sur pied en bois tendre',
      'es': 'Letrero grande (madera blanda)',
      'de': 'Holzschild aus Weichholz (Groß, stehend)',
      'pl': 'Duży stojący znak z drewna iglastego',
      'ru': 'Большая табличка из хвойных пород',
      'uk': 'Велика табличка із хвойних дерев',
      'ko': '큰 연목재 선간판',
      'zh': '大型立式软木标志',
      'ja': 'Large Standing Softwood Sign',
    }, {
      'id': 'LargeStandingSpruceSignItem',
      'en': 'Large Standing Spruce Sign',
      'fr': 'Grand panneau sur pied en épicéa',
      'es': 'Letrero grande (pícea)',
      'de': 'Holzschild aus Fichtenholz (Groß, stehend)',
      'pl': 'Duży stojący znak świerkowy',
      'ru': 'Большая еловая табличка',
      'uk': 'Велика табличка з ялини',
      'ko': '큰 가문비나무 목재 선간판',
      'zh': '大型立式云杉标志',
      'ja': 'Large Standing Spruce Sign',
    }, {
      'id': 'LargeStandingStoneSignItem',
      'en': 'Large Standing Stone Sign',
      'fr': 'Grand panneau sur pied en pierre',
      'es': 'Letrero grande (piedra)',
      'de': 'Steinschild (Groß, stehend)',
      'pl': 'Large Standing Stone Sign',
      'ru': 'Большая табличка из камня',
      'uk': 'Велика стояча кам’яна табличка',
      'ko': '큰 석재 선간판',
      'zh': '大块石制标志',
      'ja': '石の大きな立て看板',
    }, {
      'id': 'LargeStandingWoodSignItem',
      'en': 'Large Standing Wood Sign',
      'fr': 'Grand panneau sur pied en bois',
      'es': 'Letrero grande (básico)',
      'de': 'Holzschild (Groß, stehend)',
      'pl': 'Duży Stojący Znak z Drewna',
      'ru': 'Большая деревянная табличка',
      'uk': 'Велика дерев\u0027яна табличка',
      'ko': '큰 목재 선간판',
      'zh': '大型立式木标志',
      'ja': 'Large Standing Wood Sign',
    }, {
      'id': 'LargeWindowedLumberDoorItem',
      'en': 'Large Windowed Lumber Door',
      'fr': 'Porte de garage vitrée en bois d\u0027oeuvre',
      'es': 'Puerta de troncos grande con ventana',
      'de': 'Große Holztür mit Fenster',
      'pl': 'Large Windowed Lumber Door',
      'ru': 'Деревянные ворота с окошками',
      'uk': 'Великі дерев’яні двері з віконцями',
      'ko': '창문 달린 큰 가공 목재 문',
      'zh': '带窗户的大木门',
      'ja': '窓付きの大きな木製ドア',
    }, {
      'id': 'LaserItem',
      'en': 'Laser',
      'fr': 'Laser',
      'es': 'Láser',
      'de': 'Laser',
      'pl': 'Laser',
      'ru': 'Лазер',
      'uk': 'Лазер',
      'ko': '레이저',
      'zh': '激光',
      'ja': 'レーザー砲',
    }, {
      'id': 'LatheItem',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehmaschine',
      'pl': 'Lathe',
      'ru': 'Токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반 기계',
      'zh': '车床',
      'ja': 'Lathe',
    }, {
      'id': 'LatticeMushroomSporesItem',
      'en': 'Lattice Mushroom Spores',
      'fr': 'Spores de clathre rouge',
      'es': 'Esporas de Jaula Roja',
      'de': 'Sporen (Roter-Gitterling)',
      'pl': 'Lattice Mushroom Spores',
      'ru': 'Споры решёточника красного',
      'uk': 'Спори решітника червоного',
      'ko': '붉은바구니버섯 포자',
      'zh': '格子蘑菇孢子',
      'ja': '格子きのこの胞子',
    }, {
      'id': 'LeatherHideItem',
      'en': 'Leather Hide',
      'fr': 'Cuir',
      'es': 'Cuero',
      'de': 'Leder',
      'pl': 'Skóra',
      'ru': 'Кожа',
      'uk': 'Шкіра',
      'ko': '가죽',
      'zh': '皮革',
      'ja': '皮革',
    }, {
      'id': 'LeavenedDoughItem',
      'en': 'Leavened Dough',
      'fr': 'Pâte au levain',
      'es': 'Masa con levadura',
      'de': 'Hefeteig',
      'pl': 'Ciasto drożdżowe',
      'ru': 'Дрожжевое тесто',
      'uk': 'Дріжджове тісто',
      'ko': '발효된 반죽',
      'zh': '发酵面团',
      'ja': 'Leavened Dough',
    }, {
      'id': 'LightBackpackItem',
      'en': 'Light Backpack',
      'fr': 'Sac à dos léger',
      'es': 'Mochila Ligera',
      'de': 'Leichter Rucksack',
      'pl': 'Lekki Plecak',
      'ru': 'Лёгкий рюкзак',
      'uk': 'Легкий рюкзак',
      'ko': '가벼운 배낭',
      'zh': '轻便背包',
      'ja': '軽量バックパック',
    }, {
      'id': 'LightBulbItem',
      'en': 'Light Bulb',
      'fr': 'Ampoule',
      'es': 'Bombilla',
      'de': 'Glühbirne',
      'pl': 'Żarówka',
      'ru': 'Лампочка',
      'uk': 'Лампочка',
      'ko': '전구',
      'zh': '灯泡',
      'ja': '電球',
    }, {
      'id': 'LimestoneItem',
      'en': 'Limestone',
      'fr': 'Calcaire',
      'es': 'Caliza',
      'de': 'Kalkstein',
      'pl': 'Wapień',
      'ru': 'Известняк',
      'uk': 'Вапняк',
      'ko': '석회암',
      'zh': '石灰石',
      'ja': '石灰岩',
    }, {
      'id': 'LimestoneBisonStatueItem',
      'en': 'Limestone Bison Statue',
      'fr': 'Statue de bison en calcaire',
      'es': 'Estatua de bisonte (piedra caliza)',
      'de': 'Kalksteinstatue Bison',
      'pl': 'Wapienna statua bizona',
      'ru': 'Статуя бизона из известняка',
      'uk': 'Статуя бізона з вапняку',
      'ko': '석회암 들소 조각상',
      'zh': '石灰石野牛雕像',
      'ja': 'Limestone Bison Statue',
    }, {
      'id': 'LimestoneOtterStatueItem',
      'en': 'Limestone Otter Statue',
      'fr': 'Statue de loutre en calcaire',
      'es': 'Estatua de nutria (piedra caliza)',
      'de': 'Kalksteinstatue Otter',
      'pl': 'Wapienna statua wydry',
      'ru': 'Статуя выдры из известняка',
      'uk': 'Статуя видри з вапняку',
      'ko': '석회암 수달 조각상',
      'zh': '石灰石水獭雕像',
      'ja': 'Limestone Otter Statue',
    }, {
      'id': 'LimestoneOwlStatueItem',
      'en': 'Limestone Owl Statue',
      'fr': 'Statue de hibou en calcaire',
      'es': 'Estatura de búho (piedra caliza)',
      'de': 'Kalksteinstatue Eule',
      'pl': 'Wapienna statua sowy',
      'ru': 'Статуя совы из известняка',
      'uk': 'Статуя сови з вапняку',
      'ko': '석회암 부엉이 조각상',
      'zh': '石灰石猫头鹰雕像',
      'ja': 'Limestone Owl Statue',
    }, {
      'id': 'LimestoneWolfStatueItem',
      'en': 'Limestone Wolf Statue',
      'fr': 'Statue de loup en calcaire',
      'es': 'Estatura de lobo (piedra caliza)',
      'de': 'Kalksteinstatue Wolf',
      'pl': 'Wapienna statua wilka',
      'ru': 'Статуя волка из известняка',
      'uk': 'Статуя вовка з вапняку',
      'ko': '석회암 늑대 조각상',
      'zh': '石灰石狼雕像',
      'ja': 'Limestone Wolf Statue',
    }, {
      'id': 'LiquidNitrogenItem',
      'en': 'Liquid Nitrogen',
      'fr': 'Azote liquide',
      'es': 'Nitrógeno Líquido',
      'de': 'Flüssiger Stickstoff',
      'pl': 'Ciekły azot',
      'ru': 'Жидкий азот',
      'uk': 'Рідкий азот',
      'ko': '액체 질소',
      'zh': '液氮',
      'ja': '液体窒素',
    }, {
      'id': 'LoadedTaroFriesItem',
      'en': 'Loaded Taro Fries',
      'fr': 'Frites de taro gras',
      'es': 'Patatas fritas de Taro Cargadas',
      'de': 'Überbackene Taro-Fritten',
      'pl': 'Loaded Taro Fries',
      'ru': 'Жареная колоказия с начинкой',
      'uk': 'Loaded Taro Fries',
      'ko': 'Loaded Taro Fries',
      'zh': '油炸芋头',
      'ja': 'Loaded Taro Fries',
    }, {
      'id': 'LogItem',
      'en': 'Log',
      'fr': 'Bûche',
      'es': 'Tronco',
      'de': 'Baumstamm',
      'pl': 'branches',
      'ru': 'Бревно',
      'uk': 'Колода',
      'ko': '통나무',
      'zh': '原木',
      'ja': 'account',
    }, {
      'id': 'LoggingAdvancedUpgradeItem',
      'en': 'Logging Advanced Upgrade',
      'fr': 'Amélioration Avancée : Abattage',
      'es': 'Mejora avanzada: Tala',
      'de': 'Fortschrittliches Upgrade: Holzfäller',
      'pl': 'Zaawansowane ulepszenie Wyrębu Drzew',
      'ru': 'Продвинутое улучшение для заготовки леса',
      'uk': 'Logging Advanced Upgrade',
      'ko': '고급 벌목 기술 업그레이드',
      'zh': '伐木高级升级',
      'ja': 'Logging Advanced Upgrade',
    }, {
      'id': 'LoggingBasicUpgradeItem',
      'en': 'Logging Basic Upgrade',
      'fr': 'Amélioration Basique : Abattage',
      'es': 'Mejora básica: Tala',
      'de': 'Grundlegendes Upgrade: Holzfäller',
      'pl': 'Podstawowe ulepszenie Wyrębu Drzew',
      'ru': 'Базовое улучшение для заготовки леса',
      'uk': 'Logging Basic Upgrade',
      'ko': '기초 벌목 기술 업그레이드',
      'zh': '伐木基础升级',
      'ja': 'Logging Basic Upgrade',
    }, {
      'id': 'LoomItem',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Loom',
      'ru': 'Ткацкий станок',
      'uk': 'Loom',
      'ko': '직조기',
      'zh': '织布机',
      'ja': 'Loom',
    }, {
      'id': 'LowTopShoesItem',
      'en': 'Low Top Shoes',
      'fr': 'Chaussures basses',
      'es': 'Zapatos Bajos',
      'de': 'Halbschuhe',
      'pl': 'Trampki',
      'ru': 'Кеды',
      'uk': 'Кеди',
      'ko': '로우탑 운동화',
      'zh': '低帮鞋',
      'ja': 'ロートップシューズ',
    }, {
      'id': 'LumberItem',
      'en': 'Lumber',
      'fr': 'Bois d\u0027oeuvre',
      'es': 'Maderas',
      'de': 'Bauholz',
      'pl': 'Tarcica',
      'ru': 'Пиломатериал',
      'uk': 'Пиломатеріали',
      'ko': '가공된 목재',
      'zh': '板材',
      'ja': '製材',
    }, {
      'id': 'Lumber',
      'en': 'Lumber',
      'fr': 'Bois d\u0027oeuvre',
      'es': 'Maderas',
      'de': 'Bauholz',
      'pl': 'Tarcica',
      'ru': 'Пиломатериал',
      'uk': 'Пиломатеріали',
      'ko': '가공된 목재',
      'zh': '板材',
      'ja': '製材',
    }, {
      'id': 'LumberBenchItem',
      'en': 'Lumber Bench',
      'fr': 'Banc en bois d\u0027œuvre',
      'es': 'Banco de troncos',
      'de': 'Bauholzbank',
      'pl': 'Ławka z Drewna',
      'ru': 'Лавка из пиломатериалов',
      'uk': 'Лава з пиломатеріалів',
      'ko': '가공된 목재 벤치',
      'zh': '木材长凳',
      'ja': 'Lumber Bench',
    }, {
      'id': 'LumberChairItem',
      'en': 'Lumber Chair',
      'fr': 'Chaise en bois d\u0027œuvre',
      'es': 'Silla de troncos',
      'de': 'Bauholzstuhl',
      'pl': 'Krzesło z Drewna',
      'ru': 'Стул из пиломатериалов',
      'uk': 'Стілець з пиломатеріалів',
      'ko': '가공된 목재 의자',
      'zh': '木材椅子',
      'ja': 'Lumber Chair',
    }, {
      'id': 'LumberDoorItem',
      'en': 'Lumber Door',
      'fr': 'Porte en bois',
      'es': 'Puerta de Madera',
      'de': 'Bauholztür',
      'pl': 'Drzwi z Drewna',
      'ru': 'Дверь из пиломатериалов',
      'uk': 'Дерев’яні двері',
      'ko': '가공 목재 문',
      'zh': '木门',
      'ja': '木製のドア',
    }, {
      'id': 'LumberDresserItem',
      'en': 'Lumber Dresser',
      'fr': 'Commode en bois d\u0027œuvre',
      'es': 'Cómoda de madera',
      'de': 'Bauholzkommode',
      'pl': 'Lumber Dresser',
      'ru': 'Комод из пиломатериалов',
      'uk': 'Lumber Dresser',
      'ko': '가공된 목재 드레서',
      'zh': '木衣柜',
      'ja': 'Lumber Dresser',
    }, {
      'id': 'LumberStockpileItem',
      'en': 'Lumber Stockpile',
      'fr': 'Réserve en bois d\u0027oeuvre',
      'es': 'Pila de almacenamiento para troncos',
      'de': 'Bauholzlager',
      'pl': 'Lumber Stockpile',
      'ru': 'Склад из пиломатериалов',
      'uk': 'Склад з пиломатеріалів',
      'ko': '가공 목재 자재창고',
      'zh': '木材库存',
      'ja': 'Lumber Stockpile',
    }, {
      'id': 'LumberTableItem',
      'en': 'Lumber Table',
      'fr': 'Table en bois d\u0027œuvre',
      'es': 'Mesa de troncos',
      'de': 'Bauholztisch',
      'pl': 'Stół do tarcicy',
      'ru': 'Стол из пиломатериалов',
      'uk': 'Стіл з пиломатеріалів',
      'ko': '가공된 목재 테이블',
      'zh': '木材桌',
      'ja': 'Lumber Table',
    }, {
      'id': 'LupineSeedItem',
      'en': 'Lupine Seed',
      'fr': 'Graine de lupin',
      'es': 'Semilla de Lupino',
      'de': 'Samen (Lupine)',
      'pl': 'Lupine Seed',
      'ru': 'Семечко люпина',
      'uk': 'Насіння люпину',
      'ko': '층층이부채꽃 씨앗',
      'zh': '羽扇豆种子',
      'ja': 'ルーピンの種',
    }, {
      'id': 'MacaroonsItem',
      'en': 'Macaroons',
      'fr': 'Macarons',
      'es': 'Macarrones',
      'de': 'Makronen',
      'pl': 'Makaroniki',
      'ru': 'Миндальное печенье',
      'uk': 'Макрони',
      'ko': '마카롱',
      'zh': '马卡龙',
      'ja': 'マカロン',
    }, {
      'id': 'MachinistTableItem',
      'en': 'Machinist Table',
      'fr': 'Établi de mécanicien',
      'es': 'Mesa de maquinista',
      'de': 'Mechanikertisch',
      'pl': 'Machinist Table',
      'ru': 'Слесарный верстак',
      'uk': 'Стіл машиніста',
      'ko': '기계공 작업대',
      'zh': '机械师工作台',
      'ja': '機械工のテーブル',
    }, {
      'id': 'MailboxItem',
      'en': 'Mailbox',
      'fr': 'Boites aux lettres',
      'es': 'Buzón',
      'de': 'Posteingang',
      'pl': 'Mailbox',
      'ru': 'Почтовый Ящик',
      'uk': 'Mailbox',
      'ko': '사서함',
      'zh': '信箱',
      'ja': 'Mailbox',
    }, {
      'id': 'MaltodextrinItem',
      'en': 'Maltodextrin',
      'fr': 'Maltodextrine',
      'es': 'Maltodextrina',
      'de': 'Maltodextrin',
      'pl': 'Maltodekstryna',
      'ru': 'Патока',
      'uk': 'Патока',
      'ko': '말토덱스트린',
      'zh': '麦芽糊精',
      'ja': 'Maltodekstryna',
    }, {
      'id': 'MasonryAdvancedUpgradeItem',
      'en': 'Masonry Advanced Upgrade',
      'fr': 'Amélioration Avancée : Maçonnerie',
      'es': 'Mejora avanzada: Mampostería',
      'de': 'Fortschrittliches Upgrade: Steinmetz',
      'pl': 'Zaawansowane ulepszenie Kamieniarstwa',
      'ru': 'Продвинутое улучшение для каменной кладки',
      'uk': 'Masonry Advanced Upgrade',
      'ko': '고급 석조 기술 업그레이드',
      'zh': '高级石工升级组件',
      'ja': 'Masonry Advanced Upgrade',
    }, {
      'id': 'MasonryBasicUpgradeItem',
      'en': 'Masonry Basic Upgrade',
      'fr': 'Amélioration Basique : Maçonnerie',
      'es': 'Mejora básica: Mampostería',
      'de': 'Grundlegendes Upgrade: Steinmetz',
      'pl': 'Podstawowe ulepszenie Kamieniarstwa',
      'ru': 'Базовое улучшение для каменной кладки',
      'uk': 'Masonry Basic Upgrade',
      'ko': '기초 석조 기술 업그레이드',
      'zh': '基础石工升级组件',
      'ja': 'Masonry Basic Upgrade',
    }, {
      'id': 'MasonryTableItem',
      'en': 'Masonry Table',
      'fr': 'Établi de maçonnerie',
      'es': 'Mesa de mampostería',
      'de': 'Steinmetztisch',
      'pl': 'Stół murarski',
      'ru': 'Верстак каменщика',
      'uk': 'Каменярський стіл',
      'ko': '석조 작업대',
      'zh': '石匠工作台',
      'ja': '石工作業台',
    }, {
      'id': 'MeatPieItem',
      'en': 'Meat Pie',
      'fr': 'Tourte à la viande',
      'es': 'Tarta de Carne',
      'de': 'Fleischpastete',
      'pl': 'Mięso w cieście',
      'ru': 'Мясной пирог',
      'uk': 'М’ясний пиріг',
      'ko': '고기 파이',
      'zh': '肉馅饼',
      'ja': 'ミートパイ',
    }, {
      'id': 'MeatStockItem',
      'en': 'Meat Stock',
      'fr': 'Bouillon de viande',
      'es': 'Caldo de Carne',
      'de': 'Brühe aus Fleisch',
      'pl': 'Rosół',
      'ru': 'Мясной бульон',
      'uk': 'М’ясний бульйон',
      'ko': '고기 육수',
      'zh': '肉汤料',
      'ja': '肉スープの素',
    }, {
      'id': 'MeatyStewItem',
      'en': 'Meaty Stew',
      'fr': 'Ragoût de viande',
      'es': 'Estofado de carne',
      'de': 'Lagerfeuer Fleischeintopf',
      'pl': 'Mięsny jeż',
      'ru': 'Мясное рагу',
      'uk': 'М\u0027ясна рагу',
      'ko': '고기 스튜',
      'zh': '肉炖',
      'ja': 'Meaty Stew',
    }, {
      'id': 'MechanicalWaterPumpItem',
      'en': 'Mechanical Water Pump',
      'fr': 'Pompe à eau mécanique',
      'es': 'Bomba de agua mecánica',
      'de': 'Mechanische Wasserpumpe',
      'pl': 'Mechaniczna pompa wodna',
      'ru': 'Механический водяной насос',
      'uk': 'Механічний водяний насос',
      'ko': '기계식 물 펌프',
      'zh': '机械能水泵',
      'ja': '機械式ウォーター ポンプ',
    }, {
      'id': 'MechanicsAdvancedUpgradeItem',
      'en': 'Mechanics Advanced Upgrade',
      'fr': 'Amélioration Avancée : Mécaniques',
      'es': 'Mejora avanzada: Mecánica',
      'de': 'Fortschrittliches Upgrade: Mechanik',
      'pl': 'Zaawansowane ulepszenie Mechaniki',
      'ru': 'Продвинутое улучшение для механики',
      'uk': 'Mechanics Advanced Upgrade',
      'ko': '고급 기계정비 기술 업그레이드',
      'zh': '机械高级升级',
      'ja': 'Mechanics Advanced Upgrade',
    }, {
      'id': 'MechanicsModernUpgradeItem',
      'en': 'Mechanics Modern Upgrade',
      'fr': 'Amélioration Moderne : Mécaniques',
      'es': 'Mejora moderna: Mecánica',
      'de': 'Modernes Upgrade: Mechanik',
      'pl': 'Nowoczesne ulepszenie Mechaniki',
      'ru': 'Современное улучшение для механики',
      'uk': 'Новітнє покращення механіки',
      'ko': '현대식 기계정비 기술 업그레이드',
      'zh': '机械现代升级',
      'ja': 'Mechanics Modern Upgrade',
    }, {
      'id': 'MediumCarcass',
      'en': 'Medium Carcass',
      'fr': 'Cadavre moyen',
      'es': 'Cadáver mediano',
      'de': 'Mittelgroßer Kadaver',
      'pl': 'Medium Carcass',
      'ru': 'Средняя Туша',
      'uk': 'Середня туша',
      'ko': '중간 시체',
      'zh': '中型遗骸',
      'ja': 'Medium Carcass',
    }, {
      'id': 'MediumFish',
      'en': 'Medium Fish',
      'fr': 'Poisson moyen',
      'es': 'Pez Mediano',
      'de': 'Mittlerer Fisch',
      'pl': 'Medium Fish',
      'ru': 'Средняя рыба',
      'uk': 'Середня риба',
      'ko': 'Medium Fish',
      'zh': '中鱼',
      'ja': 'Medium Fish',
    }, {
      'id': 'MediumLeatherCarcass',
      'en': 'Medium Leather Carcass',
      'fr': 'Cadavre moyen à cuir',
      'es': 'Cadáver Mediano con Cuero',
      'de': 'Lederkadaver (Mittel)',
      'pl': 'Medium Leather Carcass',
      'ru': 'Средняя Кожаная Туша',
      'uk': 'Medium Leather Carcass',
      'ko': 'Medium Leather Carcass',
      'zh': '中型皮革遗骸',
      'ja': 'Medium Leather Carcass',
    }, {
      'id': 'MediumWoolyCarcass',
      'en': 'Medium Wooly Carcass',
      'fr': 'Cadavre moyen à laine',
      'es': 'Cadáver Mediano Lanoso',
      'de': 'Wollkadaver (Mittel)',
      'pl': 'Medium Wooly Carcass',
      'ru': 'Средняя Шерстяная Туша',
      'uk': 'Середня шерстяна туша',
      'ko': 'Medium Wooly Carcass',
      'zh': '中型毛绒遗骸',
      'ja': 'Medium Wooly Carcass',
    }, {
      'id': 'Metal',
      'en': 'Metal',
      'fr': 'Métal',
      'es': 'Metal',
      'de': 'Metall',
      'pl': 'Metal',
      'ru': 'Металл',
      'uk': 'Метал',
      'ko': '금속',
      'zh': '金属',
      'ja': 'Metal',
    }, {
      'id': 'MetallurgyResearchPaperAdvancedItem',
      'en': 'Metallurgy Research Paper Advanced',
      'fr': 'Papier de recherche : Métallurgie avancée',
      'es': 'Trabajo de investigación en metalurgia (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Metallurgie',
      'pl': 'Zaawansowany artykuł badawczy Metalurgii',
      'ru': 'Исследование по продвинутой металлургии',
      'uk': 'Дослідження вдосконаленої металургії',
      'ko': '고급 금속공학 연구지',
      'zh': '高级冶金研究论文',
      'ja': 'Metallurgy Research Paper Advanced',
    }, {
      'id': 'MetallurgyResearchPaperBasicItem',
      'en': 'Metallurgy Research Paper Basic',
      'fr': 'Papier de recherche : Métallurgie basique',
      'es': 'Trabajo de investigación en metalurgia (básico)',
      'de': 'Grundlegendes Forschungspapier: Metallurgie',
      'pl': 'Podstawowy artykuł badawczy Metalurgii',
      'ru': 'Исследование по базовой металлургии',
      'uk': 'Дослідження базової металургії',
      'ko': '기초 금속공학 연구지',
      'zh': '基础冶金研究论文',
      'ja': 'Metallurgy Research Paper Basic',
    }, {
      'id': 'MetallurgyResearchPaperModernItem',
      'en': 'Metallurgy Research Paper Modern',
      'fr': 'Papier de recherche : Métallurgie moderne',
      'es': 'Trabajo de investigación en metalurgia (moderno)',
      'de': 'Modernes Forschungspapier: Metallurgie',
      'pl': 'Nowoczesny artykuł badawczy Metalurgii',
      'ru': 'Исследование по современной металлургии',
      'uk': 'Дослідження сучасної металургії',
      'ko': '현대식 금속공학 연구지',
      'zh': '现代冶金研究论文',
      'ja': 'Metallurgy Research Paper Modern',
    }, {
      'id': 'MilkItem',
      'en': 'Milk',
      'fr': 'Lait',
      'es': 'Leche',
      'de': 'Milch',
      'pl': 'Mleko',
      'ru': 'Молоко',
      'uk': 'Молоко',
      'ko': '우유',
      'zh': '奶',
      'ja': 'ミルク',
    }, {
      'id': 'MillItem',
      'en': 'Mill',
      'fr': 'Meule',
      'es': 'Molino',
      'de': 'Mahlwerk',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'Млин',
      'ko': '맷돌',
      'zh': '磨坊',
      'ja': '製粉機',
    }, {
      'id': 'MillingUpgradeItem',
      'en': 'Milling Upgrade',
      'fr': 'Amélioration Avancée : Mouture',
      'es': 'Mejora: Molienda',
      'de': 'Fortschrittliches Upgrade: Mahlen',
      'pl': 'Ulepszenie Młynarstwa',
      'ru': 'Улучшение для мельничного дела',
      'uk': 'Покращення млинарства',
      'ko': '제분 기술 업그레이드',
      'zh': '铣削升级',
      'ja': 'Milling Upgrade',
    }, {
      'id': 'MillionairesSaladItem',
      'en': 'Millionaires Salad',
      'fr': 'Salade du millionnaire',
      'es': 'Ensalada del millionario',
      'de': 'Millionär-Salat',
      'pl': 'Millionaires Salad',
      'ru': 'Салат Миллионера',
      'uk': 'Millionaires Salad',
      'ko': 'Millionaires Salad',
      'zh': '百万富翁沙拉',
      'ja': 'Millionaires Salad',
    }, {
      'id': 'MiningAdvancedUpgradeItem',
      'en': 'Mining Advanced Upgrade',
      'fr': 'Amélioration Avancée : Minage',
      'es': 'Mejora avanzada: Minería',
      'de': 'Fortschrittliches Upgrade: Bergbau',
      'pl': 'Zaawansowane ulepszenie Górnictwa',
      'ru': 'Продвинутое улучшение для горного дела',
      'uk': 'Просунуте покращення видобутку',
      'ko': '고급 채광 기술 업그레이드',
      'zh': '采矿高级升级',
      'ja': 'Mining Advanced Upgrade',
    }, {
      'id': 'MiningBasicUpgradeItem',
      'en': 'Mining Basic Upgrade',
      'fr': 'Amélioration Basique : Minage',
      'es': 'Mejora básica: Minería',
      'de': 'Grundlegendes Upgrade: Bergbau',
      'pl': 'Podstawowe ulepszenie Górnictwa',
      'ru': 'Базовое улучшение для горного дела',
      'uk': 'Базове покращення видобутку',
      'ko': '기초 채광 기술 업그레이드',
      'zh': '采矿基础升级',
      'ja': 'Mining Basic Upgrade',
    }, {
      'id': 'MiningModernUpgradeItem',
      'en': 'Mining Modern Upgrade',
      'fr': 'Amélioration Moderne : Minage',
      'es': 'Mejora moderna: Minería',
      'de': 'Modernes Upgrade: Bergbau',
      'pl': 'Nowoczesne ulepszenie Górnictwa',
      'ru': 'Современное улучшение для горного дела',
      'uk': 'Новітнє покращення видобутку',
      'ko': '현대식 채광 기술 업그레이드',
      'zh': '采矿现代化升级',
      'ja': 'Mining Modern Upgrade',
    }, {
      'id': 'MintItem',
      'en': 'Mint',
      'fr': 'Hôtel de monnaie',
      'es': 'Ceca',
      'de': 'Münzprägemaschine',
      'pl': 'Mennica',
      'ru': 'Пресс для чеканки монет',
      'uk': 'Карбувальний верстат',
      'ko': '조폐기',
      'zh': '铸币厂',
      'ja': '造幣機',
    }, {
      'id': 'MochiItem',
      'en': 'Mochi',
      'fr': 'Mochi',
      'es': 'Mochi',
      'de': 'Mochi',
      'pl': 'Mochi',
      'ru': 'Моти',
      'uk': 'Mochi',
      'ko': 'Mochi',
      'zh': '糯米团',
      'ja': 'Mochi',
    }, {
      'id': 'ModernAxeItem',
      'en': 'Modern Axe',
      'fr': 'Hache moderne',
      'es': 'Hacha moderna',
      'de': 'Moderne Axt',
      'pl': 'Nowoczesna Siekiera',
      'ru': 'Современный топор',
      'uk': 'Сучасна сокира',
      'ko': '현대식 도끼',
      'zh': '现代斧',
      'ja': '近代的なオノ',
    }, {
      'id': 'ModernDoubleStreetLightItem',
      'en': 'Modern Double Street Light',
      'fr': 'Lampadaire double moderne',
      'es': 'Farola doble moderna',
      'de': 'Moderne zweiarmige Straßenlaterne',
      'pl': 'Nowoczesne podwójne światło uliczne',
      'ru': 'Современный двойной уличный фонарь',
      'uk': 'Сучасний подвійний вуличний ліхтар',
      'ko': '현대식 이중 가로등',
      'zh': '现代双路灯',
      'ja': 'Modern Double Street Light',
    }, {
      'id': 'ModernHammerItem',
      'en': 'Modern Hammer',
      'fr': 'Marteau moderne',
      'es': 'Martillo Moderno',
      'de': 'Moderner Hammer',
      'pl': 'Nowoczesny Młotek',
      'ru': 'Современный молоток',
      'uk': 'Сучасний молоток',
      'ko': '현대식 망치',
      'zh': '现代锤',
      'ja': '近代的なハンマー',
    }, {
      'id': 'ModernHoeItem',
      'en': 'Modern Hoe',
      'fr': 'Binette moderne',
      'es': 'Azada Moderna',
      'de': 'Moderne Hacke',
      'pl': 'Nowoczesna Motyka',
      'ru': 'Современная тяпка',
      'uk': 'Сучасна мотика',
      'ko': '현대식 괭이',
      'zh': '现代锄',
      'ja': '近代的なクワ',
    }, {
      'id': 'ModernMacheteItem',
      'en': 'Modern Machete',
      'fr': 'Machette moderne',
      'es': 'Machete moderno',
      'de': 'Moderne Machete',
      'pl': 'Nowoczesna maczeta',
      'ru': 'Современное мачете',
      'uk': 'Сучасне мачете',
      'ko': '현대식 마체테',
      'zh': '现代砍刀',
      'ja': 'Modern Machete',
    }, {
      'id': 'ModernPickaxeItem',
      'en': 'Modern Pickaxe',
      'fr': 'Pioche moderne',
      'es': 'Pico Moderno',
      'de': 'Moderne Spitzhacke',
      'pl': 'Nowoczesny Kilof',
      'ru': 'Современная кирка',
      'uk': 'Сучасне кайло',
      'ko': '현대식 곡괭이',
      'zh': '现代镐',
      'ja': '近代的なツルハシ',
    }, {
      'id': 'Modern Research',
      'en': 'Modern Research',
      'fr': 'Recherche moderne',
      'es': 'Investigación moderna',
      'de': 'Moderne Forschung',
      'pl': 'Nowoczesne badanie',
      'ru': 'Современное исследование',
      'uk': 'Сучасне дослідження',
      'ko': '현대 연구',
      'zh': '现代研究',
      'ja': 'Modern Research',
    }, {
      'id': 'ModernRockDrillItem',
      'en': 'Modern Rock Drill',
      'fr': 'Foreuse de roche moderne',
      'es': 'Perforadora moderna',
      'de': 'Moderner Felsbohrer',
      'pl': 'Nowoczesne wiertło skalne',
      'ru': 'Современный геологический бур',
      'uk': 'Сучасний бур',
      'ko': '현대식 착암기',
      'zh': '现代凿岩机',
      'ja': 'Modern Rock Drill',
    }, {
      'id': 'ModernScytheItem',
      'en': 'Modern Scythe',
      'fr': 'Faucille moderne',
      'es': 'Guadaña moderna',
      'de': 'Moderne Sense',
      'pl': 'Nowoczesna Kosa',
      'ru': 'Современная коса',
      'uk': 'Сучасна коса',
      'ko': '현대식 낫',
      'zh': '现代镰刀',
      'ja': '近代的なカマ',
    }, {
      'id': 'ModernShovelItem',
      'en': 'Modern Shovel',
      'fr': 'Pelle moderne',
      'es': 'Pala Moderna',
      'de': 'Moderne Schaufel',
      'pl': 'Nowoczesna Łopata',
      'ru': 'Современная лопата',
      'uk': 'Сучасна лопата',
      'ko': '현대식 삽',
      'zh': '现代铲',
      'ja': '近代的なシャベル',
    }, {
      'id': 'ModernStreetLightItem',
      'en': 'Modern Street Light',
      'fr': 'Lampadaire moderne',
      'es': 'Farola moderna',
      'de': 'Moderne Straßenlaterne',
      'pl': 'Nowoczesne światło uliczne',
      'ru': 'Современный уличный фонарь',
      'uk': 'Сучасний вуличний ліхтар',
      'ko': '현대식 가로등',
      'zh': '现代路灯',
      'ja': 'Modern Street Light',
    }, {
      'id': 'ModernUpgradeLvl1Item',
      'en': 'Modern Upgrade 1',
      'fr': 'Amélioration Moderne Nv1',
      'es': 'Mejora moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesne ulepszenie 1',
      'ru': 'Современное улучшение 1',
      'uk': 'Новітнє покращення 1',
      'ko': '현대식 업그레이드 1',
      'zh': '现代升级1',
      'ja': '近代アップグレード1',
    }, {
      'id': 'ModernUpgradeLvl2Item',
      'en': 'Modern Upgrade 2',
      'fr': 'Amélioration Moderne Nv2',
      'es': 'Mejora moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesne ulepszenie 2',
      'ru': 'Современное улучшение 2',
      'uk': 'Новітнє покращення 2',
      'ko': '현대식 업그레이드 2',
      'zh': '现代升级2',
      'ja': '近代アップグレード2',
    }, {
      'id': 'ModernUpgradeLvl3Item',
      'en': 'Modern Upgrade 3',
      'fr': 'Amélioration Moderne Nv3',
      'es': 'Mejora moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesne ulepszenie 3',
      'ru': 'Современное улучшение 3',
      'uk': 'Новітнє покращення 3',
      'ko': '현대식 업그레이드 3',
      'zh': '现代升级3',
      'ja': '近代アップグレード3',
    }, {
      'id': 'ModernUpgradeLvl4Item',
      'en': 'Modern Upgrade 4',
      'fr': 'Amélioration Moderne Nv4',
      'es': 'Mejora moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesne ulepszenie 4',
      'ru': 'Современное улучшение 4',
      'uk': 'Новітнє покращення 4',
      'ko': '현대식 업그레이드 4',
      'zh': '现代升级4',
      'ja': '近代アップグレード4',
    }, {
      'id': 'MoonJellyfishItem',
      'en': 'Moon Jellyfish',
      'fr': 'Méduse lune',
      'es': 'Medusa luna',
      'de': 'Mondqualle',
      'pl': 'Moon Jellyfish',
      'ru': 'Ушастая аурелия',
      'uk': 'Аурелія',
      'ko': '달해파리',
      'zh': '月亮水母',
      'ja': 'Moon Jellyfish',
    }, {
      'id': 'MortarItem',
      'en': 'Mortar',
      'fr': 'Mortier',
      'es': 'Mortero',
      'de': 'Mörtel',
      'pl': 'Zaprawa',
      'ru': 'Строительный раствор',
      'uk': 'Будівельний розчин',
      'ko': '모르타르',
      'zh': '砂浆',
      'ja': 'モルタル',
    }, {
      'id': 'MortaredBasaltItem',
      'en': 'Mortared Basalt',
      'fr': 'Basalte cimenté',
      'es': 'Basalto con mortero',
      'de': 'Basaltziegel',
      'pl': 'Spojony zaprawą bazalt',
      'ru': 'Строительный базальт',
      'uk': 'Будівельний Базальт',
      'ko': '모르타르 마감 현무암',
      'zh': '砂浆玄武岩',
      'ja': 'Mortared Basalt',
    }, {
      'id': 'MortaredGneissItem',
      'en': 'Mortared Gneiss',
      'fr': 'Gneiss cimenté',
      'es': 'Gneis con mortero',
      'de': 'Gneisziegel',
      'pl': 'Spojony zaprawą gnejs',
      'ru': 'Строительный гнейс',
      'uk': 'Будівельний Гнейс',
      'ko': '모르타르 마감 편마암',
      'zh': '砂浆片麻岩',
      'ja': 'Mortared Gneiss',
    }, {
      'id': 'MortaredGraniteItem',
      'en': 'Mortared Granite',
      'fr': 'Granit cimenté',
      'es': 'Granito con mortero',
      'de': 'Ziegel aus Granit',
      'pl': 'Spojony zaprawą granit',
      'ru': 'Строительный гранит',
      'uk': 'Будівельний граніт',
      'ko': '모르타르 마감 화강암',
      'zh': '砂浆花岗岩',
      'ja': '花崗岩モルタル',
    }, {
      'id': 'MortaredGraniteBenchItem',
      'en': 'Mortared Granite Bench',
      'fr': 'Banc en granite cimenté',
      'es': 'Banco de granito con mortero',
      'de': 'Granitziegelbank',
      'pl': 'Ławka z granitu',
      'ru': 'Лавка из строительного гранита',
      'uk': 'Лавка з будівельного граніту',
      'ko': '모르타르 마감 화강암 벤치',
      'zh': '砂浆花岗岩长凳',
      'ja': 'Mortared Granite Bench',
    }, {
      'id': 'MortaredGraniteChairItem',
      'en': 'Mortared Granite Chair',
      'fr': 'Chaise en granite cimenté',
      'es': 'Silla de granito con mortero',
      'de': 'Granitziegelstuhl',
      'pl': 'Krzesło z granitu',
      'ru': 'Стул из строительного гранита',
      'uk': 'Стілець із будівельного граніту',
      'ko': '모르타르 마감 화강암 의자',
      'zh': '砂浆花岗岩椅子',
      'ja': 'Mortared Granite Chair',
    }, {
      'id': 'MortaredGraniteDoorItem',
      'en': 'Mortared Granite Door',
      'fr': 'Porte en granit cimenté',
      'es': 'Puerta de granito con mortero',
      'de': 'Granitziegeltür',
      'pl': 'Mortared Granite Door',
      'ru': 'Дверь из строительного гранита',
      'uk': 'Mortared Granite Door',
      'ko': '모르타르 처리된 화강암 문',
      'zh': '砂浆花岗岩门',
      'ja': 'Mortared Granite Door',
    }, {
      'id': 'MortaredGraniteFireplaceItem',
      'en': 'Mortared Granite Fireplace',
      'fr': 'Cheminée en granite cimenté',
      'es': 'Chimenea de granito con mortero',
      'de': 'Granitziegel Feuerstelle',
      'pl': 'Kominek z granitu spojonego zaprawą',
      'ru': 'Камин из строительного гранита',
      'uk': 'Камін із будівельного граніту',
      'ko': '모르타르 마감 화강암 벽난로',
      'zh': '砂浆花岗岩壁炉',
      'ja': 'Mortared Granite Fireplace',
    }, {
      'id': 'MortaredGraniteTableItem',
      'en': 'Mortared Granite Table',
      'fr': 'Table en granite cimenté',
      'es': 'Mesa de granito con mortero',
      'de': 'Granitziegeltisch',
      'pl': 'Granitowy stół',
      'ru': 'Стол из строительного гранита',
      'uk': 'Стіл із будівельного граніту',
      'ko': '모르타르 마감 화강암 탁자',
      'zh': '砂浆花岗岩桌子',
      'ja': 'Mortared Granite Table',
    }, {
      'id': 'MortaredLimestoneItem',
      'en': 'Mortared Limestone',
      'fr': 'Calcaire cimenté',
      'es': 'Piedra caliza con mortero',
      'de': 'Ziegel aus Kalkstein',
      'pl': 'Spojony zaprawą wapień',
      'ru': 'Строительный известняк',
      'uk': 'Будівельний вапняк',
      'ko': '모르타르 마감 석회암',
      'zh': '砂浆石灰石',
      'ja': '石灰モルタル',
    }, {
      'id': 'MortaredLimestoneBenchItem',
      'en': 'Mortared Limestone Bench',
      'fr': 'Banc en calcaire cimenté',
      'es': 'Banco de piedra caliza con mortero',
      'de': 'Steinziegelbank aus Kalkstein',
      'pl': 'Wapienna ławka',
      'ru': 'Лавка из строительного известняка',
      'uk': 'Лавка з будівельного вапняку',
      'ko': '모르타르 마감 석회암 벤치',
      'zh': '砂浆石灰石长凳',
      'ja': 'Mortared Limestone Bench',
    }, {
      'id': 'MortaredLimestoneChairItem',
      'en': 'Mortared Limestone Chair',
      'fr': 'Chaise en calcaire cimenté',
      'es': 'Silla de piedra caliza con mortero',
      'de': 'Steinziegelstuhl aus Kalkstein',
      'pl': 'Wapienne krzesło',
      'ru': 'Стул из строительного известняка',
      'uk': 'Стілець із будівельного вапняку',
      'ko': '모르타르 마감 석회암 의자',
      'zh': '砂浆石灰石椅子',
      'ja': 'Mortared Limestone Chair',
    }, {
      'id': 'MortaredLimestoneDoorItem',
      'en': 'Mortared Limestone Door',
      'fr': 'Porte en calcaire cimenté',
      'es': 'Puerta de piedra caliza con mortero',
      'de': 'Kalksteinziegeltür',
      'pl': 'Mortared Limestone Door',
      'ru': 'Дверь из строительного известняка',
      'uk': 'Mortared Limestone Door',
      'ko': '모르타르 처리된 석회암 문',
      'zh': '砂浆石灰石门',
      'ja': 'Mortared Limestone Door',
    }, {
      'id': 'MortaredLimestoneFireplaceItem',
      'en': 'Mortared Limestone Fireplace',
      'fr': 'Cheminée en calcaire cimenté',
      'es': 'Chimenea de piedra caliza con mortero',
      'de': 'Kalksteinziegel Feuerstelle',
      'pl': 'Kominek z wapienia spojonego zaprawą',
      'ru': 'Камин из строительного известняка',
      'uk': 'Камін із будівельного вапняку',
      'ko': '모르타르 마감 석회암 벽난로',
      'zh': '砂浆石灰石壁炉',
      'ja': 'Mortared Limestone Fireplace',
    }, {
      'id': 'MortaredLimestoneTableItem',
      'en': 'Mortared Limestone Table',
      'fr': 'Table en calcaire cimenté',
      'es': 'Mesa de piedra caliza con mortero',
      'de': 'Steinziegeltisch Kalkstein',
      'pl': 'Wapienny stół',
      'ru': 'Стол из строительного известняка',
      'uk': 'Стіл із будівельного вапняку',
      'ko': '모르타르 마감 석회암 탁자',
      'zh': '砂浆石灰石桌',
      'ja': 'Mortared Limestone Table',
    }, {
      'id': 'MortaredSandstoneItem',
      'en': 'Mortared Sandstone',
      'fr': 'Grès cimenté',
      'es': 'Arenisca con mortero',
      'de': 'Ziegel aus Sandstein',
      'pl': 'Spojony zaprawą piaskowiec',
      'ru': 'Строительный песчаник',
      'uk': 'Будівельний пісковик',
      'ko': '모르타르 마감 사암',
      'zh': '砂浆石',
      'ja': '砂岩モルタル',
    }, {
      'id': 'MortaredSandstoneBenchItem',
      'en': 'Mortared Sandstone Bench',
      'fr': 'Banc en grès cimenté',
      'es': 'Banco de arenisca con mortero',
      'de': 'Steinziegelbank aus Sandstein',
      'pl': 'Piaskowcowa ławka',
      'ru': 'Лавка из строительного песчаника',
      'uk': 'Лавка з каменя-пісковика',
      'ko': '모르타르 마감 사암 벤치',
      'zh': '砂浆石凳',
      'ja': 'Mortared Sandstone Bench',
    }, {
      'id': 'MortaredSandstoneChairItem',
      'en': 'Mortared Sandstone Chair',
      'fr': 'Chaise en grès cimenté',
      'es': 'Silla de arenisca con mortero',
      'de': 'Steinziegelstuhl aus Sandstein',
      'pl': 'Piaskowcowe krzesło',
      'ru': 'Стул из строительного песчаника',
      'uk': 'Стілець із каменя-пісковика',
      'ko': '모르타르 마감 사암 의자',
      'zh': '砂岩砂椅',
      'ja': 'Mortared Sandstone Chair',
    }, {
      'id': 'MortaredSandstoneDoorItem',
      'en': 'Mortared Sandstone Door',
      'fr': 'Porte en grès cimenté',
      'es': 'Puerta de arenisca con mortero',
      'de': 'Sandsteinziegeltür',
      'pl': 'Mortared Sandstone Door',
      'ru': 'Дверь из строительного песчаника',
      'uk': 'Mortared Sandstone Door',
      'ko': '모르타르 처리된 사암 문',
      'zh': '砂岩砂门',
      'ja': 'Mortared Sandstone Door',
    }, {
      'id': 'MortaredSandstoneFireplaceItem',
      'en': 'Mortared Sandstone Fireplace',
      'fr': 'Cheminée en grès cimenté',
      'es': 'Chimenea de arenisca con mortero',
      'de': 'Sandsteinziegel Feuerstelle',
      'pl': 'Kominek z piaskowca spojonego zaprawą',
      'ru': 'Камин из строительного песчаника',
      'uk': 'Камін із каменя-пісковика',
      'ko': '모르타르 마감 사암 벽난로',
      'zh': '砂浆石壁炉',
      'ja': 'Mortared Sandstone Fireplace',
    }, {
      'id': 'MortaredSandstoneTableItem',
      'en': 'Mortared Sandstone Table',
      'fr': 'Table en grès cimenté',
      'es': 'Mesa de arenisca con mortero',
      'de': 'Steinziegeltisch aus Sandstein',
      'pl': 'Piaskowcowy stół',
      'ru': 'Стол из строительного песчаника',
      'uk': 'Стіл із каменя-пісковика',
      'ko': '모르타르 마감 사암 탁자',
      'zh': '砂浆石桌',
      'ja': 'Mortared Sandstone Table',
    }, {
      'id': 'MortaredShaleItem',
      'en': 'Mortared Shale',
      'fr': 'Schiste cimenté',
      'es': 'Pizarra con mortero',
      'de': 'Schieferziegel',
      'pl': 'Spojony zaprawą łupek',
      'ru': 'Строительный сланец',
      'uk': 'Будівельний Сланець',
      'ko': '모르타르 마감 이판암',
      'zh': '砂浆页岩',
      'ja': 'Mortared Shale',
    }, {
      'id': 'MortaredStoneItem',
      'en': 'Mortared Stone',
      'fr': 'Pierre cimentée',
      'es': 'Piedra con mortero',
      'de': 'Ziegel aus Stein',
      'pl': 'Spojony zaprawą kamień',
      'ru': 'Строительный камень',
      'uk': 'Будівельне каміння',
      'ko': '모르타르 마감 석재',
      'zh': '浆砌石',
      'ja': 'モルタル',
    }, {
      'id': 'MortaredStone',
      'en': 'Mortared Stone',
      'fr': 'Pierre cimentée',
      'es': 'Piedra con mortero',
      'de': 'Ziegel aus Stein',
      'pl': 'Spojony zaprawą kamień',
      'ru': 'Строительный камень',
      'uk': 'Будівельне каміння',
      'ko': '모르타르 마감 석재',
      'zh': '浆砌石',
      'ja': 'モルタル',
    }, {
      'id': 'MortaredStoneBenchItem',
      'en': 'Mortared Stone Bench',
      'fr': 'Banc en pierre cimentée',
      'es': 'Banco de piedra con mortero',
      'de': 'Steinziegelbank',
      'pl': 'Kamienna ławka',
      'ru': 'Лавка из строительного камня',
      'uk': 'Лавка з будівельного каміння',
      'ko': '모르타르 마감 석재 벤치',
      'zh': '砂浆石凳',
      'ja': 'Mortared Stone Bench',
    }, {
      'id': 'MortaredStoneChairItem',
      'en': 'Mortared Stone Chair',
      'fr': 'Chaise en pierre cimentée',
      'es': 'Silla de piedra con mortero',
      'de': 'Steinziegelstuhl',
      'pl': 'Kamienne krzesło',
      'ru': 'Стул из строительного камня',
      'uk': 'Стілець із будівельного каміння',
      'ko': '모르타르 마감 석재 의자',
      'zh': '砂浆石椅',
      'ja': 'Mortared Stone Chair',
    }, {
      'id': 'MortaredStoneDoorItem',
      'en': 'Mortared Stone Door',
      'fr': 'Porte en pierre cimentée',
      'es': 'Puerta de piedra con mortero',
      'de': 'Steinziegeltür',
      'pl': 'Cementowane kamienne drzwi',
      'ru': 'Дверь из строительного камня',
      'uk': 'Двері з будівельного каміння',
      'ko': '모르타르 마감 석재 문',
      'zh': '砂浆石门',
      'ja': 'Mortared Stone Door',
    }, {
      'id': 'MortaredStoneFireplaceItem',
      'en': 'Mortared Stone Fireplace',
      'fr': 'Foyer en pierre cimentée',
      'es': 'Chimenea de piedra con mortero',
      'de': 'Steinziegel Feuerstelle',
      'pl': 'Kominek z kamienia spojonego zaprawą',
      'ru': 'Камин из строительного камня',
      'uk': 'Камін із будівельного каміння',
      'ko': '모르타르 마감 석재 벽난로',
      'zh': '砂浆石壁炉',
      'ja': 'Mortared Stone Fireplace',
    }, {
      'id': 'MortaredStoneTableItem',
      'en': 'Mortared Stone Table',
      'fr': 'Table en pierre cimentée',
      'es': 'Mesa de piedra con mortero',
      'de': 'Steinziegeltisch',
      'pl': 'Kamienny stół',
      'ru': 'Стол из строительного камня',
      'uk': 'Стіл з будівельного каміння',
      'ko': '모르타르 마감 석재 탁자',
      'zh': '砂浆石桌',
      'ja': 'Mortared Stone Table',
    }, {
      'id': 'MountainGoatCarcassItem',
      'en': 'Mountain Goat Carcass',
      'fr': 'Cadavre de chèvre des montagnes',
      'es': 'Cadáver de cabra montesa',
      'de': 'Bergziegenkadaver',
      'pl': 'Mountain Goat Carcass',
      'ru': 'Туша снежной козы',
      'uk': 'Туша снігового козла',
      'ko': '흰바위산양 사체',
      'zh': '高山山羊遗骸',
      'ja': 'シロイワヤギの死体',
    }, {
      'id': 'NailItem',
      'en': 'Nail',
      'fr': 'Clou',
      'es': 'Clavo',
      'de': 'Nagel',
      'pl': 'Gwóźdź',
      'ru': 'Гвоздь',
      'uk': 'Цвях',
      'ko': '못',
      'zh': '钉',
      'ja': 'Nail',
    }, {
      'id': 'NaturalFiber',
      'en': 'Natural Fiber',
      'fr': 'Fibre naturelle',
      'es': 'Fibra natural',
      'de': 'Naturfaser',
      'pl': 'Natural Fiber',
      'ru': 'Натуральное волокно',
      'uk': 'Природні волокна',
      'ko': '천연 섬유',
      'zh': '天然纤维',
      'ja': 'Natural Fiber',
    }, {
      'id': 'NormalHairItem',
      'en': 'Normal Hair',
      'fr': 'Cheveux normaux',
      'es': 'Pelo Normal',
      'de': 'Normales Haar',
      'pl': 'Zwykłe włosy',
      'ru': 'Обычные волосы',
      'uk': 'Нормальне волосся',
      'ko': '기본 머리',
      'zh': '普通头发',
      'ja': '普通の髪の毛',
    }, {
      'id': 'NuclearFuelItem',
      'en': 'Nuclear Fuel',
      'fr': 'Combustible nucléaire',
      'es': 'Combustible Nuclear',
      'de': 'Kernbrennstoff',
      'pl': 'Paliwo nuklearne',
      'ru': 'Ядерное топливо',
      'uk': 'Ядерне паливо',
      'ko': '핵 연료',
      'zh': '核燃料',
      'ja': '核燃料',
    }, {
      'id': 'NylonItem',
      'en': 'Nylon',
      'fr': 'Nylon',
      'es': 'Nailon',
      'de': 'Nylon',
      'pl': 'Nylon',
      'ru': 'Нейлон',
      'uk': 'Nylon',
      'ko': '나일론',
      'zh': '尼龙',
      'ja': 'Nylon',
    }, {
      'id': 'NylonCarpetItem',
      'en': 'Nylon Carpet',
      'fr': 'Tapis en nylon',
      'es': 'Alfombra de nailon',
      'de': 'Nylonteppich',
      'pl': 'Nylon Carpet',
      'ru': 'Нейлоновый ковер',
      'uk': 'Nylon Carpet',
      'ko': '나일론 카펫',
      'zh': '尼龙地毯',
      'ja': 'Nylon Carpet',
    }, {
      'id': 'NylonChipsItem',
      'en': 'Nylon Chips',
      'fr': 'Morceaux de Nylon',
      'es': 'Virutas de nailon',
      'de': 'Nylonchips',
      'pl': 'Nylon Chips',
      'ru': 'Нейлоновые гранулы',
      'uk': 'Nylon Chips',
      'ko': '나일론 칩',
      'zh': '尼龙碎屑',
      'ja': 'Nylon Chips',
    }, {
      'id': 'NylonCurtainsItem',
      'en': 'Nylon Curtains',
      'fr': 'Rideaux en nylon',
      'es': 'Cortinas de nailon',
      'de': 'Nylonvorhänge',
      'pl': 'Nylon Curtains',
      'ru': 'Нейлоновые шторы',
      'uk': 'Nylon Curtains',
      'ko': '나일론 커튼',
      'zh': '尼龙窗帘',
      'ja': 'Nylon Curtains',
    }, {
      'id': 'NylonFabricItem',
      'en': 'Nylon Fabric',
      'fr': 'Tissu en nylon',
      'es': 'Tela de nailon',
      'de': 'Nylonstoff',
      'pl': 'Nylon Fabric',
      'ru': 'Нейлоновая ткань',
      'uk': 'Nylon Fabric',
      'ko': '나일론 원단',
      'zh': '尼龙织物',
      'ja': 'Nylon Fabric',
    }, {
      'id': 'NylonFutonBedItem',
      'en': 'Nylon Futon Bed',
      'fr': 'Lit futon en nylon',
      'es': 'Cama-futón con funda de nailon',
      'de': 'Nylon Futon Bett',
      'pl': 'Nylon Futon Bed',
      'ru': 'Кровать с нейлоновым футоном',
      'uk': 'Nylon Futon Bed',
      'ko': 'Nylon Futon Bed',
      'zh': '尼龙沙发床',
      'ja': 'Nylon Futon Bed',
    }, {
      'id': 'NylonFutonCouchItem',
      'en': 'Nylon Futon Couch',
      'fr': 'Canapé futon en nylon',
      'es': 'Futón con funda de nailon',
      'de': 'Nylon Futon Couch',
      'pl': 'Nylon Futon Couch',
      'ru': 'Диван с нейлоновым футоном',
      'uk': 'Nylon Futon Couch',
      'ko': 'Nylon Futon Couch',
      'zh': '尼龙蒲团沙发',
      'ja': 'Nylon Futon Couch',
    }, {
      'id': 'NylonThreadItem',
      'en': 'Nylon Thread',
      'fr': 'Fil de nylon',
      'es': 'Fibra de nailon',
      'de': 'Nylonfaden',
      'pl': 'Nylon Thread',
      'ru': 'Нейлоновая нить',
      'uk': 'Nylon Thread',
      'ko': '나일론 실',
      'zh': '尼龙线',
      'ja': 'Nylon Thread',
    }, {
      'id': 'OakLogItem',
      'en': 'Oak Log',
      'fr': 'Bûche de Chêne',
      'es': 'Tronco de roble',
      'de': 'Eichenholzstamm',
      'pl': 'Kłoda dębu',
      'ru': 'Бревно Дуба',
      'uk': 'Дубова колода',
      'ko': '참나무 통나무',
      'zh': '橡木原木',
      'ja': 'Oak Log',
    }, {
      'id': 'OceanSpraySeedItem',
      'en': 'Ocean Spray Seed',
      'fr': 'Graine de holodisque discolore',
      'es': 'Semilla de Rocío Oceánico',
      'de': 'Samen (Schaumspieren)',
      'pl': 'Ocean Spray Seed',
      'ru': 'Семечко холодискуcа',
      'uk': 'Насіння холодискусу',
      'ko': '넌출월귤 씨앗',
      'zh': '海洋喷雾种子',
      'ja': 'オーシャンスプレーの種',
    }, {
      'id': 'OfficeMailboxItem',
      'en': 'Office Mailbox',
      'fr': 'Boite aux lettres collective',
      'es': 'Buzón de oficina',
      'de': 'Office-Mailbox',
      'pl': 'Office Mailbox',
      'ru': 'Офисный Почтовый Ящик',
      'uk': 'Office Mailbox',
      'ko': '사무실 사서함',
      'zh': '办公室信箱',
      'ja': 'Office Mailbox',
    }, {
      'id': 'OilItem',
      'en': 'Oil',
      'fr': 'Huile',
      'es': 'Aceite',
      'de': 'Öl',
      'pl': 'Olej',
      'ru': 'Масло',
      'uk': 'Олія',
      'ko': '식용유',
      'zh': '油',
      'ja': 'オイル',
    }, {
      'id': 'OilDrillingUpgradeItem',
      'en': 'Oil Drilling Upgrade',
      'fr': 'Amélioration Moderne : Forage pétrolier',
      'es': 'Mejora: Prospección de petróleo',
      'de': 'Modernes Upgrade: Ölgewinnung',
      'pl': 'Ulepszenie Wydobycia Ropy',
      'ru': 'Улучшение для добычи нефти',
      'uk': 'Покращення буріння',
      'ko': '유정 굴착 기술 업그레이드',
      'zh': '石油钻探升级',
      'ja': 'Oil Drilling Upgrade',
    }, {
      'id': 'OilRefineryItem',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de Petróleo',
      'de': 'Raffinerie',
      'pl': 'Rafineria',
      'ru': 'Нефтеперерабатывающий завод',
      'uk': 'Нафтопереробний завод',
      'ko': '석유 증류탑',
      'zh': '炼油厂',
      'ja': '石油精製所',
    }, {
      'id': 'OrchidSeedItem',
      'en': 'Orchid Seed',
      'fr': 'Graine d’Orchidée',
      'es': 'Semilla de orquídea',
      'de': 'Samen (Orchidee)',
      'pl': 'Nasiono orchidei',
      'ru': 'Семечко орхидеи',
      'uk': 'Насіння орхідеї',
      'ko': '난초 씨앗',
      'zh': '兰花种子',
      'ja': 'ランの種',
    }, {
      'id': 'Ore',
      'en': 'Ore',
      'fr': 'Minerai',
      'es': 'Mineral',
      'de': 'Erz',
      'pl': 'Ruda',
      'ru': 'Руда',
      'uk': 'Руда',
      'ko': '광석',
      'zh': '矿石',
      'ja': 'Ore',
    }, {
      'id': 'OtterCarcassItem',
      'en': 'Otter Carcass',
      'fr': 'Cadavre de loutre',
      'es': 'Cadáver de nutria',
      'de': 'Otterkadaver',
      'pl': 'Tusza wydry',
      'ru': 'Туша выдры',
      'uk': 'Туша видри',
      'ko': '수달 시체',
      'zh': '水獭遗骸',
      'ja': 'カワウソの死体',
    }, {
      'id': 'PacificSardineItem',
      'en': 'Pacific Sardine',
      'fr': 'Sardine du Pacifique',
      'es': 'Sardina del Pacífico',
      'de': 'Pazifische Sardine',
      'pl': 'Pacyficzna sardynka',
      'ru': 'Перуанская сардина',
      'uk': 'Перуанська сардина',
      'ko': '태평양 정어리',
      'zh': '太平洋沙丁鱼',
      'ja': 'Pacific Sardine',
    }, {
      'id': 'PaddedChairItem',
      'en': 'Padded Chair',
      'fr': 'Fauteuil',
      'es': 'Silla Acolchada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Fotel tapicerowany',
      'ru': 'Кресло',
      'uk': 'М’яке крісло',
      'ko': '푹신한 소파',
      'zh': '软垫椅',
      'ja': 'パッド入りの椅子',
    }, {
      'id': 'PalmLogItem',
      'en': 'Palm Log',
      'fr': 'Bûche de Palmier',
      'es': 'Tronco de palmera',
      'de': 'Palmenholzstamm',
      'pl': 'Kłoda palmy',
      'ru': 'Бревно Пальмы',
      'uk': 'Пальмова колода',
      'ko': '야자나무 통나무',
      'zh': '棕榈原木',
      'ja': 'Palm Log',
    }, {
      'id': 'PalmSeedItem',
      'en': 'Palm Seed',
      'fr': 'Graine de palmier',
      'es': 'Semilla de palmera',
      'de': 'Samen (Palme)',
      'pl': 'Nasiono palmy',
      'ru': 'Семечко пальмы',
      'uk': 'Насіння пальми',
      'ko': '야자나무 씨앗',
      'zh': '棕榈树种子',
      'ja': 'ヤシの種',
    }, {
      'id': 'PapayaItem',
      'en': 'Papaya',
      'fr': 'Papaye',
      'es': 'Papaya',
      'de': 'Papaya',
      'pl': 'Papaja',
      'ru': 'Папайя',
      'uk': 'Папая',
      'ko': '파파야',
      'zh': '木瓜',
      'ja': 'パパイヤ',
    }, {
      'id': 'PapayaSeedItem',
      'en': 'Papaya Seed',
      'fr': 'Graine de papaye',
      'es': 'Semilla de papaya',
      'de': 'Samen (Papaya)',
      'pl': 'Nasiono papai',
      'ru': 'Семечко папайи',
      'uk': 'Насіння папаї',
      'ko': '파파야 씨앗',
      'zh': '番木瓜籽',
      'ja': 'パパイヤの種',
    }, {
      'id': 'PaperItem',
      'en': 'Paper',
      'fr': 'Papier',
      'es': 'Papel',
      'de': 'Papier',
      'pl': 'Papier',
      'ru': 'Бумага',
      'uk': 'Папір',
      'ko': '종이',
      'zh': '纸',
      'ja': '紙',
    }, {
      'id': 'PaperMachineItem',
      'en': 'Paper Machine',
      'fr': 'Machine à papier',
      'es': 'Prensa de papel',
      'de': 'Papiermaschine',
      'pl': 'Paper Machine',
      'ru': 'Бумагоделательная машина',
      'uk': 'Paper Machine',
      'ko': '종이 기계',
      'zh': '造纸机',
      'ja': 'Paper Machine',
    }, {
      'id': 'PaperMillingUpgradeItem',
      'en': 'Paper Milling Upgrade',
      'fr': 'Amélioration Basique : Production de papier',
      'es': 'Mejora: Molienda de papel',
      'de': 'Fortgeschrittenes Upgrade: Papierherstellung',
      'pl': 'Ulepszenie Papierni',
      'ru': 'Улучшение для производства бумаги',
      'uk': 'Покращення виготовлення паперу',
      'ko': '제지 가공 기술 업그레이드',
      'zh': '造纸升级',
      'ja': '紙すきアップグレード',
    }, {
      'id': 'PastryDoughItem',
      'en': 'Pastry Dough',
      'fr': 'Pâte à tarte',
      'es': 'Masa de pastelería',
      'de': 'Teig',
      'pl': 'Kruche ciasto',
      'ru': 'Кондитерские изделия',
      'uk': 'Кондитерське тісто',
      'ko': '페이스트리 반죽',
      'zh': '糕点面团',
      'ja': 'Pastry Dough',
    }, {
      'id': 'PeasantHairItem',
      'en': 'Peasant Hair',
      'fr': 'Cheveux de paysan',
      'es': 'Pelo de Campesino',
      'de': 'Bauernhaar',
      'pl': 'Chłopskie Włosy',
      'ru': 'Косички',
      'uk': 'Зачіска селянина',
      'ko': '평범한 머리',
      'zh': '平民头发',
      'ja': '編み込んだ髪',
    }, {
      'id': 'PeltFertilizerItem',
      'en': 'Pelt Fertilizer',
      'fr': 'Engrais à base de fourrures',
      'es': 'Fertilizante de Pieles',
      'de': 'Dünger aus Pelz',
      'pl': 'Nawóz z futer',
      'ru': 'Удобрение из меха',
      'uk': 'Добриво з хутра',
      'ko': '모피 비료',
      'zh': '毛皮化肥',
      'ja': 'Nawoz z futra',
    }, {
      'id': 'PetroleumItem',
      'en': 'Petroleum',
      'fr': 'Pétrole',
      'es': 'Petróleo',
      'de': 'Petroleum',
      'pl': 'Ropa naftowa',
      'ru': 'Нефть',
      'uk': 'Нафта',
      'ko': '석유',
      'zh': '石油',
      'ja': '石油',
    }, {
      'id': 'PhadThaiItem',
      'en': 'Phad Thai',
      'fr': 'Nouilles sautées à la thaïlandaise',
      'es': 'Phad Thai',
      'de': 'Phad Thai',
      'pl': 'Phad Thai',
      'ru': 'Пад-тай',
      'uk': 'Phad Thai',
      'ko': 'Phad Thai',
      'zh': '泰式炒河粉',
      'ja': 'Phad Thai',
    }, {
      'id': 'PhosphateFertilizerItem',
      'en': 'Phosphate Fertilizer',
      'fr': 'Engrais à base de phosphate',
      'es': 'Fertilizante de Fosfato',
      'de': 'Dünger mit Phosphat',
      'pl': 'Nawóz fosforowy',
      'ru': 'Фосфорное удобрение',
      'uk': 'Фосфорні добрива',
      'ko': '인산염 비료',
      'zh': '磷肥',
      'ja': 'Nawóz fosforowy',
    }, {
      'id': 'PickaxeItem',
      'en': 'Pickaxe',
      'fr': 'Pioche',
      'es': 'Pico',
      'de': 'Spitzhacke',
      'pl': 'Kilof',
      'ru': 'Кирка',
      'uk': 'Кайло',
      'ko': '곡괭이',
      'zh': '镐',
      'ja': 'ツルハシ',
    }, {
      'id': 'PineappleItem',
      'en': 'Pineapple',
      'fr': 'Ananas',
      'es': 'Piña',
      'de': 'Ananas',
      'pl': 'Ananas',
      'ru': 'Ананас',
      'uk': 'Ананас',
      'ko': '파인애플',
      'zh': '菠萝',
      'ja': 'パイナップル',
    }, {
      'id': 'PineappleFriendRiceItem',
      'en': 'Pineapple Friend Rice',
      'fr': 'Riz frit à l\u0027ananas',
      'es': 'Arroz frito con piña',
      'de': 'Gebratener Reis mit Ananas',
      'pl': 'Twój przyjaciel ryż',
      'ru': 'Ананас и его друг рис',
      'uk': 'Ананас і його друг рис',
      'ko': '파인애플 볶음밥',
      'zh': '菠萝炒饭',
      'ja': 'パイナップルチャーハン',
    }, {
      'id': 'PineappleSeedItem',
      'en': 'Pineapple Seed',
      'fr': 'Graine d\u0027ananas',
      'es': 'Semilla de Piña',
      'de': 'Samen (Ananas)',
      'pl': 'Nasiono ananasa',
      'ru': 'Семечко ананаса',
      'uk': 'Насіння ананаса',
      'ko': '파인애플 씨앗',
      'zh': '菠萝种子',
      'ja': 'パイナップルの種',
    }, {
      'id': 'PirozhokItem',
      'en': 'Pirozhok',
      'fr': 'Chaussons à la viande',
      'es': 'Pirozhok',
      'de': 'Pirozhok',
      'pl': 'Kulebiak',
      'ru': 'Пирожок',
      'uk': 'Пиріжок',
      'ko': '피로시키',
      'zh': '皮罗佐克',
      'ja': 'Pirozhok',
    }, {
      'id': 'PlantFibersItem',
      'en': 'Plant Fibers',
      'fr': 'Fibres végétales',
      'es': 'Fibras vegetales',
      'de': 'Pflanzenfasern',
      'pl': 'Włókna roślinne',
      'ru': 'Растительные волокна',
      'uk': 'Рослинні волокна',
      'ko': '식물 섬유',
      'zh': '植物纤维',
      'ja': '植物繊維',
    }, {
      'id': 'PlasticItem',
      'en': 'Plastic',
      'fr': 'Plastique',
      'es': 'Plástico',
      'de': 'Kunststoff',
      'pl': 'Plastik',
      'ru': 'Пластик',
      'uk': 'Пластик',
      'ko': '플라스틱',
      'zh': '塑料',
      'ja': 'プラスチック',
    }, {
      'id': 'PokeBowlItem',
      'en': 'Poke Bowl',
      'fr': 'Bol hawaïen',
      'es': 'Poke',
      'de': 'Gemüse-Bowle',
      'pl': 'Poke Bowl',
      'ru': 'Поке Боул',
      'uk': 'Poke Bowl',
      'ko': 'Poke Bowl',
      'zh': '冲浪碗',
      'ja': 'Poke Bowl',
    }, {
      'id': 'PortableSteamEngineItem',
      'en': 'Portable Steam Engine',
      'fr': 'Moteur à vapeur portable',
      'es': 'Motor a vapor portátil',
      'de': 'Tragbarer Dampf-Stromgenerator',
      'pl': 'Przenośny Silnik Parowy',
      'ru': 'Портативный паровой двигатель',
      'uk': 'Портативний паровий двигун',
      'ko': '이동식 증기기관',
      'zh': '便携式蒸汽机',
      'ja': '携帯型蒸気エンジン',
    }, {
      'id': 'PotteryUpgradeItem',
      'en': 'Pottery Upgrade',
      'fr': 'Amélioration Avancée : Poterie',
      'es': 'Mejora: Cerámica',
      'de': 'Fortgeschrittenes Upgrade: Töpfern',
      'pl': 'Ulepszenie Garncarstwa',
      'ru': 'Улучшение для гончарного ремесла',
      'uk': 'Покращення гончарства',
      'ko': '도기 기술 업그레이드',
      'zh': '陶艺升级',
      'ja': '陶芸アップグレード',
    }, {
      'id': 'Power',
      'en': 'Power',
      'fr': 'Puissance',
      'es': 'Energía',
      'de': 'Leistung',
      'pl': 'Moc',
      'ru': 'Энергия',
      'uk': 'Енергія',
      'ko': '전력',
      'zh': '能源',
      'ja': 'Power',
    }, {
      'id': 'PoweredCartItem',
      'en': 'Powered Cart',
      'fr': 'Chariot motorisé',
      'es': 'Carro Motorizado',
      'de': 'Dampfbetriebener Wagen',
      'pl': 'Wózek z Napędem',
      'ru': 'Повозка с мотором',
      'uk': 'Возик із мотором',
      'ko': '전동 수레',
      'zh': '动力推车',
      'ja': '動力付カート',
    }, {
      'id': 'PoweredStorageSiloItem',
      'en': 'Powered Storage Silo',
      'fr': 'Silo de stockage électrique',
      'es': 'Silo de almacenamiento eléctronico',
      'de': 'Modernes Lagersilo',
      'pl': 'Powered Storage Silo',
      'ru': 'Электрическая Силосная башня',
      'uk': 'Powered Storage Silo',
      'ko': '파워드 스토리지 사일로',
      'zh': '已充电储料仓',
      'ja': 'Powered Storage Silo',
    }, {
      'id': 'PrairieDogCarcassItem',
      'en': 'Prairie Dog Carcass',
      'fr': 'Cadavre de chien de prairie',
      'es': 'Cadáver de perrito de las praderas',
      'de': 'Präriehundkadaver',
      'pl': 'Prairie Dog Carcass',
      'ru': 'Туша луговой собачки',
      'uk': 'Prairie Dog Carcass',
      'ko': '프레리 도그 시체',
      'zh': '草原犬鼠遗骸',
      'ja': 'Prairie Dog Carcass',
    }, {
      'id': 'PreparedMeatItem',
      'en': 'Prepared Meat',
      'fr': 'Viande préparée',
      'es': 'Carne Preparada',
      'de': 'Vorbereitetes Fleisch',
      'pl': 'Gotowe danie mięsne',
      'ru': 'Обработанное мясо',
      'uk': 'Оброблене м’ясо',
      'ko': '손질된 고기',
      'zh': '预加工肉',
      'ja': '下ごしらえした肉',
    }, {
      'id': 'PricklyPearFruitItem',
      'en': 'Prickly Pear Fruit',
      'fr': 'Figue de Barbarie',
      'es': 'Fruta de higo chumbo',
      'de': 'Kaktusfeige',
      'pl': 'Owoc Opuncji',
      'ru': 'Плод опунции',
      'uk': 'Плід опунції',
      'ko': '천년초 열매',
      'zh': '仙人球果实',
      'ja': 'ウチワサボテンの果実',
    }, {
      'id': 'PricklyPearSeedItem',
      'en': 'Prickly Pear Seed',
      'fr': 'Graine de figue de Barbarie',
      'es': 'Semilla de higo chumbo',
      'de': 'Samen (Kaktusfeigen)',
      'pl': 'Nasiona Opuncji',
      'ru': 'Семечко опунции',
      'uk': 'Насіння опунції',
      'ko': '천년초 씨앗',
      'zh': '仙人球种子',
      'ja': 'ウチワサボテンの種',
    }, {
      'id': 'PrimeCutItem',
      'en': 'Prime Cut',
      'fr': 'Morceau de choix',
      'es': 'Corte Primo',
      'de': 'Filet',
      'pl': 'Mięso prima sort',
      'ru': 'Вырезка',
      'uk': 'М’ясо найвищого ґатунку',
      'ko': '최고급 고기',
      'zh': '特级肉块',
      'ja': 'プライムカット',
    }, {
      'id': 'PrintingPressItem',
      'en': 'Printing Press',
      'fr': 'Presse à platine',
      'es': 'Imprenta',
      'de': 'Druckerpresse',
      'pl': 'Printing Press',
      'ru': 'Печатный станок',
      'uk': 'Printing Press',
      'ko': '인쇄기',
      'zh': '印刷机',
      'ja': 'Printing Press',
    }, {
      'id': 'PulpFillerItem',
      'en': 'Pulp Filler',
      'fr': 'Garnissage de copeaux de bois',
      'es': 'Relleno de Pulpa',
      'de': 'Füller aus Holzspähnen',
      'pl': 'Wypełniacz z miazgi',
      'ru': 'Древесный наполнитель',
      'uk': 'Наповнювач із деревини',
      'ko': '펄프 보충제',
      'zh': '纸浆填料',
      'ja': 'パルプフィラー',
    }, {
      'id': 'PumpJackItem',
      'en': 'Pump Jack',
      'fr': 'Chevalet de pompage',
      'es': 'Unidad de Bombeo',
      'de': 'Ölbohrturm',
      'pl': 'Kiwak',
      'ru': 'Нефтяная вышка',
      'uk': 'Нафтовий насос',
      'ko': '석유 시추기',
      'zh': '油压机',
      'ja': 'ポンプジャッキ',
    }, {
      'id': 'PumpkinItem',
      'en': 'Pumpkin',
      'fr': 'Citrouille',
      'es': 'Calabaza',
      'de': 'Kürbis',
      'pl': 'Dynia',
      'ru': 'Тыква',
      'uk': 'Гарбуз',
      'ko': '호박',
      'zh': '南瓜',
      'ja': 'カボチャ',
    }, {
      'id': 'PumpkinSeedItem',
      'en': 'Pumpkin Seed',
      'fr': 'Graine de citrouille',
      'es': 'Semilla de Calabaza',
      'de': 'Samen (Kürbis)',
      'pl': 'Nasiono dyni',
      'ru': 'Семечко тыквы',
      'uk': 'Насіння гарбуза',
      'ko': '호박 씨앗',
      'zh': '南瓜种子',
      'ja': 'カボチャの種',
    }, {
      'id': 'PupusasItem',
      'en': 'Pupusas',
      'fr': 'Pupusas',
      'es': 'Pupusas',
      'de': 'Pupusas',
      'pl': 'Pupusas',
      'ru': 'Пупусас',
      'uk': 'Pupusas',
      'ko': 'Pupusas',
      'zh': '奶酪猪肉玉米饼',
      'ja': 'Pupusas',
    }, {
      'id': 'QuicklimeItem',
      'en': 'Quicklime',
      'fr': 'Chaux vive',
      'es': 'Cal viva',
      'de': 'Branntkalk',
      'pl': 'Quicklime',
      'ru': 'Оксид кальция',
      'uk': 'Негашене вапно',
      'ko': '생석회',
      'zh': '生石灰',
      'ja': '生石灰',
    }, {
      'id': 'RadiatorItem',
      'en': 'Radiator',
      'fr': 'Radiateur',
      'es': 'Radiador',
      'de': 'Kühler',
      'pl': 'Chłodnica',
      'ru': 'Радиатор',
      'uk': 'Радіатор',
      'ko': '방열기',
      'zh': '散热器',
      'ja': 'ラジエーター',
    }, {
      'id': 'RawBaconItem',
      'en': 'Raw Bacon',
      'fr': 'Bacon cru',
      'es': 'Tocino Crudo',
      'de': 'Roher Speck',
      'pl': 'Surowy Boczek',
      'ru': 'Сырой бекон',
      'uk': 'Сирий бекон',
      'ko': '생 베이컨',
      'zh': '生培根',
      'ja': '生のベーコン',
    }, {
      'id': 'RawFishItem',
      'en': 'Raw Fish',
      'fr': 'Poisson cru',
      'es': 'Pescado Crudo',
      'de': 'Roher Fisch',
      'pl': 'Surowa ryba',
      'ru': 'Сырая рыба',
      'uk': 'Сира риба',
      'ko': '날생선',
      'zh': '生鱼',
      'ja': '生魚',
    }, {
      'id': 'RawFood',
      'en': 'Raw Food',
      'fr': 'Nourriture crue',
      'es': 'Comida cruda',
      'de': 'Rohe Nahrung',
      'pl': 'Surowe pożywienie',
      'ru': 'Сырая еда',
      'uk': 'Сира їжа',
      'ko': '날 것',
      'zh': '生食',
      'ja': 'Raw Food',
    }, {
      'id': 'RawMeatItem',
      'en': 'Raw Meat',
      'fr': 'Viande crue',
      'es': 'Carne Cruda',
      'de': 'Rohes Fleisch',
      'pl': 'Surowe mięso',
      'ru': 'Сырое мясо',
      'uk': 'Сире м’ясо',
      'ko': '생고기',
      'zh': '生肉',
      'ja': '生肉',
    }, {
      'id': 'RawRoastItem',
      'en': 'Raw Roast',
      'fr': 'Rôti cru',
      'es': 'Asado Crudo',
      'de': 'Roher Braten',
      'pl': 'Surowa pieczeń',
      'ru': 'Мясо для жаркого',
      'uk': 'Сира печеня',
      'ko': '안 익은 구이용 고기',
      'zh': '未烤肉',
      'ja': '生のロースト',
    }, {
      'id': 'RawSausageItem',
      'en': 'Raw Sausage',
      'fr': 'Saucisse crue',
      'es': 'Salchicha Cruda',
      'de': 'Rohe Wurst',
      'pl': 'Surowa kiełbasa',
      'ru': 'Сырая сарделька',
      'uk': 'Сира сарделька',
      'ko': '생 소시지',
      'zh': '生香肠',
      'ja': '生のソーセージ',
    }, {
      'id': 'RealEstateDeskItem',
      'en': 'Real Estate Desk',
      'fr': 'Bureau immobilier',
      'es': 'Escritorio inmobiliario',
      'de': 'Grundbesitztisch',
      'pl': 'Real Estate Desk',
      'ru': 'Стол риелтора',
      'uk': 'Бюро нерухомості',
      'ko': '부동산 중매대',
      'zh': '房地产交易所',
      'ja': '不動産デスク',
    }, {
      'id': 'RebarItem',
      'en': 'Rebar',
      'fr': 'Barre d\u0027armature',
      'es': 'Barra corrugada',
      'de': 'Bewehrungsstahl',
      'pl': 'Zbrojenie',
      'ru': 'Арматура',
      'uk': 'Арматура',
      'ko': '철근',
      'zh': '钢筋',
      'ja': '鉄筋',
    }, {
      'id': 'RecurveBowItem',
      'en': 'Recurve Bow',
      'fr': 'Arc recourbé',
      'es': 'Arco recurvo',
      'de': 'Recurvebogen',
      'pl': 'Łuk Refleksyjny',
      'ru': 'Изогнутый лук',
      'uk': 'Вигнутий лук',
      'ko': '곡궁',
      'zh': '反曲弓',
      'ja': 'Recurve Bow',
    }, {
      'id': 'RedwoodLogItem',
      'en': 'Redwood Log',
      'fr': 'Bûche de Séquoia',
      'es': 'Tronco de secuoya',
      'de': 'Rottannenholzstamm',
      'pl': 'Kłoda sekwoi',
      'ru': 'Бревно Секвойи',
      'uk': 'Колода секвої',
      'ko': '삼나무 통나무',
      'zh': '红木原木',
      'ja': 'Redwood Log',
    }, {
      'id': 'RedwoodSeedItem',
      'en': 'Redwood Seed',
      'fr': 'Graine de séquoia',
      'es': 'Semilla de Secuoya',
      'de': 'Samen (Rottanne)',
      'pl': 'Nasiona sekwoi',
      'ru': 'Семечко секвойи',
      'uk': 'Насіння секвої',
      'ko': '삼나무 씨앗',
      'zh': '红木种子',
      'ja': 'レッドウッドの種',
    }, {
      'id': 'RefrigeratorItem',
      'en': 'Refrigerator',
      'fr': 'Réfrigérateur',
      'es': 'Refrigerador',
      'de': 'Kühlschrank',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Холодильник',
      'ko': '냉장고',
      'zh': '冰箱',
      'ja': '冷蔵庫',
    }, {
      'id': 'RegistrarItem',
      'en': 'Registrar',
      'fr': 'Registre',
      'es': 'Registrador',
      'de': 'Registrar',
      'pl': 'Registrar',
      'ru': 'Регистратор',
      'uk': 'Реєстратор',
      'ko': '직위개설 부서',
      'zh': '登记员',
      'ja': 'レジストラー',
    }, {
      'id': 'ReinforcedConcreteItem',
      'en': 'Reinforced Concrete',
      'fr': 'Béton armé',
      'es': 'Hormigón reforzado',
      'de': 'Stahlbeton',
      'pl': 'Beton zbrojony',
      'ru': 'Железобетон',
      'uk': 'Вироби залізобетонні',
      'ko': '보강된 콘크리트',
      'zh': '钢筋混凝土',
      'ja': '鉄筋コンクリート',
    }, {
      'id': 'Research',
      'en': 'Research',
      'fr': 'Recherche',
      'es': 'Investigar',
      'de': 'Forschung',
      'pl': 'Badania',
      'ru': 'Исследование',
      'uk': 'Дослідження',
      'ko': '연구',
      'zh': '研究',
      'ja': 'Research',
    }, {
      'id': 'ResearchTableItem',
      'en': 'Research Table',
      'fr': 'Table de recherche',
      'es': 'Mesa de investigación',
      'de': 'Forschungstisch',
      'pl': 'Stół badawczy',
      'ru': 'Стол для исследований',
      'uk': 'Дослідницький стіл',
      'ko': '연구 작업대',
      'zh': '研究工作台',
      'ja': 'リサーチテーブル',
    }, {
      'id': 'RiceItem',
      'en': 'Rice',
      'fr': 'Riz',
      'es': 'Arroz',
      'de': 'Reis',
      'pl': 'Ryż',
      'ru': 'Рис',
      'uk': 'Рис',
      'ko': '쌀',
      'zh': '米',
      'ja': '米',
    }, {
      'id': 'RiceFlourItem',
      'en': 'Rice Flour',
      'fr': 'Farine de riz',
      'es': 'Harina de arroz',
      'de': 'Reismehl',
      'pl': 'Rice Flour',
      'ru': 'Рисовая мука',
      'uk': 'Rice Flour',
      'ko': '쌀가루',
      'zh': '米粉',
      'ja': 'Rice Flour',
    }, {
      'id': 'RiceNoodlesItem',
      'en': 'Rice Noodles',
      'fr': 'Nouilles de riz',
      'es': 'Fideos de arroz',
      'de': 'Reisnudeln',
      'pl': 'Rice Noodles',
      'ru': 'Рисовая лапша',
      'uk': 'Rice Noodles',
      'ko': '쌀 면',
      'zh': '米线',
      'ja': 'Rice Noodles',
    }, {
      'id': 'RivetItem',
      'en': 'Rivet',
      'fr': 'Rivet',
      'es': 'Remache',
      'de': 'Niete',
      'pl': 'Nit',
      'ru': 'Заклёпка',
      'uk': 'Заклепка',
      'ko': '대갈못',
      'zh': '铆钉',
      'ja': 'Nit',
    }, {
      'id': 'RoastPumpkinItem',
      'en': 'Roast Pumpkin',
      'fr': 'Citrouille cuite',
      'es': 'Calabaza asada',
      'de': 'Gerösteter Kürbis',
      'pl': 'Roast Pumpkin',
      'ru': 'Жареная тыква',
      'uk': 'Roast Pumpkin',
      'ko': '구운 호박',
      'zh': '烤南瓜',
      'ja': 'Roast Pumpkin',
    }, {
      'id': 'RoboticAssemblyLineItem',
      'en': 'Robotic Assembly Line',
      'fr': 'Ligne de montage robotisée',
      'es': 'Línea de Ensamblaje Robótica',
      'de': 'Robotische Fertigungsstraße',
      'pl': 'Robotic Assembly Line',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована лінія для збору',
      'ko': '자동화 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン',
    }, {
      'id': 'Rock',
      'en': 'Rock',
      'fr': 'Pierre',
      'es': 'roca',
      'de': 'stein',
      'pl': 'rock',
      'ru': 'рок',
      'uk': 'скала',
      'ko': '의 암지',
      'zh': '岩石',
      'ja': '岩',
    }, {
      'id': 'RockerBoxItem',
      'en': 'Rocker Box',
      'fr': 'Rampe de lavage',
      'es': 'Caja de balancines',
      'de': 'Bergbau-Waschtisch',
      'pl': 'Sito kołyskowe',
      'ru': 'Вашгерд',
      'uk': 'Накопичувач руди',
      'ko': '로커 박스',
      'zh': '摇臂箱',
      'ja': 'Rocker Box',
    }, {
      'id': 'RollingMillItem',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Molino de laminado',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Стан прокатний',
      'ko': '압연기',
      'zh': '轧机',
      'ja': '圧延機',
    }, {
      'id': 'RootCampfireSaladItem',
      'en': 'Root Campfire Salad',
      'fr': 'Salade de racines cuite au feu de camp',
      'es': 'Ensalada braseada con raíces',
      'de': 'Lagerfeuer Wurzelsalat',
      'pl': 'Korzenna sałatka z ogniska',
      'ru': 'Салат из корнеплодов на костре',
      'uk': 'Салат приготований на багатті',
      'ko': '구근 모닥불 샐러드',
      'zh': '根篝火沙拉',
      'ja': 'Root Campfire Salad',
    }, {
      'id': 'RootCampfireStewItem',
      'en': 'Root Campfire Stew',
      'fr': 'Ragoût de racines cuit au feu de camp',
      'es': 'Estofado braseado con raíces',
      'de': 'Lagerfeuer Wurzeleintopf',
      'pl': 'Korzenny gulasz z ogniska',
      'ru': 'Рагу из корнеплодов на костре',
      'uk': 'Рагу приготоване багатті',
      'ko': '구근 모닥불 스튜',
      'zh': '根篝火炖汤',
      'ja': 'Root Campfire Stew',
    }, {
      'id': 'PlanterPotRoundItem',
      'en': 'Round Pot',
      'fr': 'Pot rond',
      'es': 'Maceta Redonda',
      'de': 'Blumentopf (rund)',
      'pl': 'Okrągłą donica',
      'ru': 'Круглый горшок',
      'uk': 'Круглий горщик',
      'ko': '둥근 화분',
      'zh': '圆盆',
      'ja': '丸い植木鉢',
    }, {
      'id': 'RubberWheelItem',
      'en': 'Rubber Wheel',
      'fr': 'Roue en caoutchouc',
      'es': 'Rueda de caucho',
      'de': 'Gummirad',
      'pl': 'Gumowe Koło',
      'ru': 'Резиновое колесо',
      'uk': 'Гумове колесо',
      'ko': '고무 바퀴',
      'zh': '橡胶轮',
      'ja': 'ラバーホイール',
    }, {
      'id': 'RugLargeItem',
      'en': 'Rug Large',
      'fr': 'Grand tapis',
      'es': 'Alfombra grande',
      'de': 'Großer Teppich',
      'pl': 'Rug Large',
      'ru': 'Большой ковёр',
      'uk': 'Великий килим',
      'ko': '대형 양탄자',
      'zh': '大号地毯',
      'ja': '大きな絨毯',
    }, {
      'id': 'RugMediumItem',
      'en': 'Rug Medium',
      'fr': 'Tapis moyen',
      'es': 'Alfombra mediana',
      'de': 'Mittelgroßer Teppich',
      'pl': 'Rug Medium',
      'ru': 'Средний ковёр',
      'uk': 'Середній килим',
      'ko': '중형 양탄자',
      'zh': '中号地毯',
      'ja': '中くらいの絨毯',
    }, {
      'id': 'RugSmallItem',
      'en': 'Rug Small',
      'fr': 'Petit tapis',
      'es': 'Alfombra pequeña',
      'de': 'Kleiner Teppich',
      'pl': 'Rug Small',
      'ru': 'Маленький ковёр',
      'uk': 'Малий килим',
      'ko': '소형 양탄자',
      'zh': '小号地毯',
      'ja': '小さな絨毯',
    }, {
      'id': 'RunningShoesItem',
      'en': 'Running Shoes',
      'fr': 'Chaussures de course',
      'es': 'Zapatos de Correr',
      'de': 'Laufschuhe',
      'pl': 'Buty do biegania',
      'ru': 'Беговые кеды',
      'uk': 'Взуття для бігу',
      'ko': '운동화',
      'zh': '跑鞋',
      'ja': 'ランニングシューズ',
    }, {
      'id': 'SaguaroRibItem',
      'en': 'Saguaro Rib',
      'fr': 'Bûche de Saguaro',
      'es': 'Nervadura de saguaro',
      'de': 'Saguarostamm',
      'pl': 'Żebro saguaro',
      'ru': 'Обрубок карнегии',
      'uk': 'Ребро сагуаро',
      'ko': '사와로 선인장 골',
      'zh': '仙人掌柱',
      'ja': 'Saguaro Rib',
    }, {
      'id': 'SaguaroSeedItem',
      'en': 'Saguaro Seed',
      'fr': 'Graine de saguaro',
      'es': 'Semilla de saguaro',
      'de': 'Samen (Saguaro-Kaktus)',
      'pl': 'Nasiono karnegii',
      'ru': 'Семечко карнегии',
      'uk': 'Насіння діжкового кактусу',
      'ko': '사와로 선인장 씨앗',
      'zh': '树形仙人掌种子',
      'ja': 'ベンケイチュウの種',
    }, {
      'id': 'Salad',
      'en': 'Salad',
      'fr': 'Salade',
      'es': 'Ensalada',
      'de': 'Salat',
      'pl': 'Sałatka',
      'ru': 'Салат',
      'uk': 'Салат',
      'ko': '샐러드',
      'zh': '沙拉',
      'ja': 'Salad',
    }, {
      'id': 'SalmonItem',
      'en': 'Salmon',
      'fr': 'Saumon',
      'es': 'Salmón',
      'de': 'Lachs',
      'pl': 'Losoś',
      'ru': 'Лосось',
      'uk': 'Лосось',
      'ko': '연어',
      'zh': '鲑鱼肉',
      'ja': 'サケ',
    }, {
      'id': 'SaltBasketItem',
      'en': 'Salt Basket',
      'fr': 'Panier de sel',
      'es': 'Cesta de Sal',
      'de': 'Salzkorb',
      'pl': 'Kosz Soli',
      'ru': 'Корзина с солью',
      'uk': 'Кошик солі',
      'ko': '소금 바구니',
      'zh': '盐篓',
      'ja': 'カゴに入った塩',
    }, {
      'id': 'SandItem',
      'en': 'Sand',
      'fr': 'Sable',
      'es': 'Arena',
      'de': 'Sand',
      'pl': 'Piasek',
      'ru': 'Песок',
      'uk': 'Пісок',
      'ko': '모래',
      'zh': '沙子',
      'ja': '砂',
    }, {
      'id': 'SandstoneItem',
      'en': 'Sandstone',
      'fr': 'Grès',
      'es': 'Arenisca',
      'de': 'Sandstein',
      'pl': 'Sandstone',
      'ru': 'Песчаник',
      'uk': 'Пісковик',
      'ko': '사암',
      'zh': '沙石',
      'ja': '砂岩',
    }, {
      'id': 'SawmillItem',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопилка',
      'uk': 'Лісопилка',
      'ko': '제재대',
      'zh': '锯木台',
      'ja': '製材機',
    }, {
      'id': 'SaxifrageSeedItem',
      'en': 'Saxifrage Seed',
      'fr': 'Graine de saxifrage',
      'es': 'Semilla de Saxifraga',
      'de': 'Samen (Steinbrech)',
      'pl': 'Nasiono skalnicy',
      'ru': 'Семечко камнеломки',
      'uk': 'Насіння ломикаменю',
      'ko': '바위취 씨앗',
      'zh': '虎耳草种子',
      'ja': 'ユキノシタの種',
    }, {
      'id': 'ScrapMeatItem',
      'en': 'Scrap Meat',
      'fr': 'Restes de viande',
      'es': 'Carne de desechos',
      'de': 'Fleischreste',
      'pl': 'Ochłapy Mięsa',
      'ru': 'Мясные обрезки',
      'uk': 'Обрізки м’яса',
      'ko': '고기 조각',
      'zh': '碎肉',
      'ja': 'くず肉',
    }, {
      'id': 'ScreeningMachineItem',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de escaneo',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do Przesiewania',
      'ru': 'Вибрационный сортировщик',
      'uk': 'Просіювальна машина',
      'ko': '건식 제련 기계',
      'zh': '筛选机',
      'ja': '選別機',
    }, {
      'id': 'ScrewPressItem',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Prensa de tornillos',
      'de': 'Spindelpresse',
      'pl': 'Screw Press',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '압입식 조임 기계',
      'zh': '螺旋压榨机',
      'ja': 'ねじプレス',
    }, {
      'id': 'ScrewsItem',
      'en': 'Screws',
      'fr': 'Vis',
      'es': 'Tornillos',
      'de': 'Schrauben',
      'pl': 'Śruby',
      'ru': 'Винты',
      'uk': 'Гвинти',
      'ko': '나사',
      'zh': '螺钉',
      'ja': 'ネジ',
    }, {
      'id': 'ScruffyHairItem',
      'en': 'Scruffy Hair',
      'fr': 'Cheveux négligés',
      'es': 'Pelo Desaliñado',
      'de': 'Schmuddeliges Haar',
      'pl': 'Potargane włosy',
      'ru': 'Взлохмаченные волосы',
      'uk': 'Скуйовджене волосся',
      'ko': '지저분한 머리',
      'zh': '邋遢头发',
      'ja': 'ぼさぼさした髪',
    }, {
      'id': 'SeagrassSeedItem',
      'en': 'Seagrass Seed',
      'fr': 'Graine d\u0027herbier marin',
      'es': 'Semilla de alga marina',
      'de': 'Samen (Seegras)',
      'pl': 'Nasiona trawy morskiej',
      'ru': 'Семечко водоросли',
      'uk': 'Насіння водоростей',
      'ko': '해초 씨앗',
      'zh': '海草种子',
      'ja': 'Seagrass Seed',
    }, {
      'id': 'SearedMeatItem',
      'en': 'Seared Meat',
      'fr': 'Viande poêlée',
      'es': 'Carne Chamuscada',
      'de': 'Kurz angebratenes Fleisch',
      'pl': 'Obsmażone mięso',
      'ru': 'Обжаренное мясо',
      'uk': 'Обсмажене м’ясо',
      'ko': '직화 고기',
      'zh': '煎肉',
      'ja': '焦げた肉',
    }, {
      'id': 'SeededCamasRollItem',
      'en': 'Seeded Camas Roll',
      'fr': 'Rouleau aux graines de camassia',
      'es': 'Rollos de Camas con Semillas',
      'de': 'Bestreute Prärielilienrolle',
      'pl': 'Seeded Camas Roll',
      'ru': 'Ролл с семенами Камассии',
      'uk': 'Seeded Camas Roll',
      'ko': 'Seeded Camas Roll',
      'zh': '去籽卡马斯卷',
      'ja': 'Seeded Camas Roll',
    }, {
      'id': 'Seeds',
      'en': 'Seeds',
      'fr': 'Graines',
      'es': 'Semillas',
      'de': 'Samen',
      'pl': 'Seeds',
      'ru': 'Семена',
      'uk': 'Насіння',
      'ko': 'Seeds',
      'zh': '种子',
      'ja': 'Seeds',
    }, {
      'id': 'SensorBasedBeltSorterItem',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Tapis de tri à détecteurs',
      'es': 'Cinta organizadora con sensores',
      'de': 'Sensorenbasierter Gürtelsortierer',
      'pl': 'Sorter taśmowy oparty na czujnikach',
      'ru': 'Сенсорный конвейерный сортировщик',
      'uk': 'Сенсорний сортувальник конвеєрної лінії',
      'ko': '감지기 기반 자동 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'Sensor Based Belt Sorter',
    }, {
      'id': 'SensuousSeaPizzaItem',
      'en': 'Sensuous Sea Pizza',
      'fr': 'Pizza sensuelle de la mer',
      'es': 'Pizza de Mar Agradable a los Sentidos',
      'de': 'Pizza di Mare Fantastico',
      'pl': 'Smakowita morska pizza',
      'ru': 'Морская Пицца',
      'uk': 'Sensuous Sea Pizza',
      'ko': 'Sensuous Sea Pizza',
      'zh': '悠扬之海比萨',
      'ja': 'Sensuous Sea Pizza',
    }, {
      'id': 'ServoItem',
      'en': 'Servo',
      'fr': 'Servomoteur',
      'es': 'Servomotor',
      'de': 'Servomotor',
      'pl': 'Serwomechanizm',
      'ru': 'Сервопривод',
      'uk': 'Сервопривід',
      'ko': '자동 제어 장치',
      'zh': '传动装置',
      'ja': 'Serwomechanizm',
    }, {
      'id': 'ShaleItem',
      'en': 'Shale',
      'fr': 'Schiste',
      'es': 'Pizarra',
      'de': 'Schiefer',
      'pl': 'Shale',
      'ru': 'Сланец',
      'uk': 'Сланець',
      'ko': '이판암',
      'zh': '页岩',
      'ja': '頁岩',
    }, {
      'id': 'ShaperItem',
      'en': 'Shaper',
      'fr': 'Formeuse',
      'es': 'Modelador (m.) Modeladora (f.)',
      'de': 'Fräsmaschine',
      'pl': 'Shaper',
      'ru': 'Строгальный станок',
      'uk': 'Стругальний верстат',
      'ko': '형삭반',
      'zh': '刨床',
      'ja': '形削り盤',
    }, {
      'id': 'SharkFilletSoupItem',
      'en': 'Shark Fillet Soup',
      'fr': 'Soupe d\u0027ailerons de requin',
      'es': 'Sopa de Filete de Tiburón',
      'de': 'Suppe aus Haifilet',
      'pl': 'Zupa z płetwy rekina',
      'ru': 'Суп из филе акулы',
      'uk': 'Shark Fillet Soup',
      'ko': '상어 지느러미 수프',
      'zh': '鲨鱼片汤',
      'ja': 'Shark Fillet Soup',
    }, {
      'id': 'SheepMountItem',
      'en': 'Sheep Mount',
      'fr': 'Trophée de mouflon',
      'es': 'Montura de borrego',
      'de': 'Ausgestopftes Bergschaf',
      'pl': 'Sheep Mount',
      'ru': 'Голова барана',
      'uk': 'Голова барана',
      'ko': '양 벽걸이 박제',
      'zh': '羊山',
      'ja': 'Sheep Mount',
    }, {
      'id': 'ShelfCabinetItem',
      'en': 'Shelf Cabinet',
      'fr': 'Étagère',
      'es': 'Armario',
      'de': 'Regalschrank',
      'pl': 'Szafa z półkami',
      'ru': 'Сервант',
      'uk': 'Сервант',
      'ko': '선반 보관장',
      'zh': '柜架',
      'ja': '飾りつけた棚',
    }, {
      'id': 'ShippingContainerBlueItem',
      'en': 'Shipping Container Blue',
      'fr': 'Conteneur bleu',
      'es': 'Contenedor de carga azul',
      'de': 'Versandbehälter Blau',
      'pl': 'Shipping Container Blue',
      'ru': 'Синий Транспортный Контейнер',
      'uk': 'Shipping Container Blue',
      'ko': '배송 컨테이너 블루',
      'zh': '蓝色运输集装箱',
      'ja': 'Shipping Container Blue',
    }, {
      'id': 'ShippingContainerGreenItem',
      'en': 'Shipping Container Green',
      'fr': 'Conteneur vert',
      'es': 'Contenedor de carga verde',
      'de': 'Versandbehälter Grün',
      'pl': 'Shipping Container Green',
      'ru': 'Зеленый Транспортный Контейнер',
      'uk': 'Shipping Container Green',
      'ko': '선적 컨테이너 그린',
      'zh': '绿色运输集装箱',
      'ja': 'Shipping Container Green',
    }, {
      'id': 'ShippingContainerRedItem',
      'en': 'Shipping Container Red',
      'fr': 'Conteneur rouge',
      'es': 'Contenedor de carga rojo',
      'de': 'Versandbehälter Rot',
      'pl': 'Shipping Container Red',
      'ru': 'Красный Транспортный Контейнер',
      'uk': 'Shipping Container Red',
      'ko': '선적 컨테이너 레드',
      'zh': '红色运输集装箱',
      'ja': 'Shipping Container Red',
    }, {
      'id': 'ShornWoolItem',
      'en': 'Shorn Wool',
      'fr': 'Laine tondue',
      'es': 'Lana esquilada',
      'de': 'Geschorene Wolle',
      'pl': 'Shorn Wool',
      'ru': 'Стриженная шерсть',
      'uk': 'Shorn Wool',
      'ko': '뿔양털',
      'zh': '剪绒毛',
      'ja': 'Shorn Wool',
    }, {
      'id': 'ShortBeardItem',
      'en': 'Short Beard',
      'fr': 'Barbe courte',
      'es': 'Barba Corta',
      'de': 'Kurzer Bart',
      'pl': 'Krótka broda',
      'ru': 'Короткая борода',
      'uk': 'Коротка борода',
      'ko': '짧은 수염',
      'zh': '短胡子',
      'ja': '短いヒゲ',
    }, {
      'id': 'ShortsItem',
      'en': 'Shorts',
      'fr': 'Short',
      'es': 'Pantalones cortos',
      'de': 'Kurze Hose',
      'pl': 'Spodenki',
      'ru': 'Шорты',
      'uk': 'Шорти',
      'ko': '반바지',
      'zh': '短裤',
      'ja': 'Shorts',
    }, {
      'id': 'ShovelItem',
      'en': 'Shovel',
      'fr': 'Pelle',
      'es': 'Pala',
      'de': 'Schaufel',
      'pl': 'Łopata',
      'ru': 'Лопата',
      'uk': 'Лопата',
      'ko': '삽',
      'zh': '铲',
      'ja': 'シャベル',
    }, {
      'id': 'Silica',
      'en': 'Silica',
      'fr': 'Silice',
      'es': 'Sílice',
      'de': 'Silikate',
      'pl': 'Silica',
      'ru': 'Кремнезем',
      'uk': 'Силіка',
      'ko': '이산화 규소',
      'zh': '二氧化硅',
      'ja': 'Silica',
    }, {
      'id': 'SimmeredMeatItem',
      'en': 'Simmered Meat',
      'fr': 'Viande mijotée',
      'es': 'Carne Hervida',
      'de': 'Geschmortes Fleisch',
      'pl': 'Wolno gotowane mięso',
      'ru': 'Тушёное мясо',
      'uk': 'Тушковане м’ясо',
      'ko': '육즙을 가둔 고기',
      'zh': '炖肉',
      'ja': '煮込み肉',
    }, {
      'id': 'SimpleSyrupItem',
      'en': 'Simple Syrup',
      'fr': 'Sirop simple',
      'es': 'Jarabe Simple',
      'de': 'Zuckersirup',
      'pl': 'Prosty syrop',
      'ru': 'Простой сироп',
      'uk': 'Простий сироп',
      'ko': '간단한 시럽',
      'zh': '普通糖浆',
      'ja': 'シンプルシロップ',
    }, {
      'id': 'SinkItem',
      'en': 'Sink',
      'fr': 'Evier',
      'es': 'Fregadero',
      'de': 'Spüle',
      'pl': 'Zlew',
      'ru': 'Раковина',
      'uk': 'Мушля',
      'ko': '싱크대',
      'zh': '下沉',
      'ja': 'シンク',
    }, {
      'id': 'SkidSteerItem',
      'en': 'Skid Steer',
      'fr': 'Bulldozer',
      'es': 'Minicargador',
      'de': 'Kompaktlader',
      'pl': 'Skid Steer',
      'ru': 'Погрузчик',
      'uk': 'Міні-навантажувач',
      'ko': '스키드 스티어',
      'zh': '滑移装载机',
      'ja': 'スキッドステア',
    }, {
      'id': 'Skill Scrolls',
      'en': 'Skill Scrolls',
      'fr': 'Pages de compétence',
      'es': 'Pergaminos de Habilidad',
      'de': 'Skilschriftrollen',
      'pl': 'Skill Scrolls',
      'ru': 'Страницы навыков',
      'uk': 'Сувої вмінь',
      'ko': '기술 두루마리',
      'zh': '技能卷轴',
      'ja': 'スキルスクロール',
    }, {
      'id': 'SlagItem',
      'en': 'Slag',
      'fr': 'Scorie',
      'es': 'Escoria',
      'de': 'Schlacke',
      'pl': 'Żużel',
      'ru': 'Шлак',
      'uk': 'Окалина',
      'ko': '광물 찌꺼기',
      'zh': '矿渣',
      'ja': 'Slag',
    }, {
      'id': 'SmallBathMatItem',
      'en': 'Small Bath Mat',
      'fr': 'Petit tapis de bain',
      'es': 'Alfombrilla de baño pequeña',
      'de': 'Kleine Badematte',
      'pl': 'Small Bath Mat',
      'ru': 'Небольшой Коврик для ванной',
      'uk': 'Small Bath Mat',
      'ko': 'Small Bath Mat',
      'zh': '小型浴室防滑垫',
      'ja': 'Small Bath Mat',
    }, {
      'id': 'SmallCarcass',
      'en': 'Small Carcass',
      'fr': 'Petit cadavre',
      'es': 'Cadáver pequeño',
      'de': 'Kleiner Kadaver',
      'pl': 'Small Carcass',
      'ru': 'Маленькая Туша',
      'uk': 'Мала туша',
      'ko': '작은 시체',
      'zh': '小型遗骸',
      'ja': 'Small Carcass',
    }, {
      'id': 'SmallFish',
      'en': 'Small Fish',
      'fr': 'Petit poisson',
      'es': 'Pez Pequeño',
      'de': 'Kleiner Fisch',
      'pl': 'Small Fish',
      'ru': 'Маленькая рыба',
      'uk': 'Мала риба',
      'ko': 'Small Fish',
      'zh': '小鱼',
      'ja': 'Small Fish',
    }, {
      'id': 'SmallHangingAshlarBasaltSignItem',
      'en': 'Small Hanging Ashlar Basalt Sign',
      'fr': 'Petit panneau suspendu en basalte taillé',
      'es': 'Letrero colgante pequeño (sillar de basalto)',
      'de': 'Steinquaderschild aus Basalt (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego bazaltu',
      'ru': 'Маленькая вывеска из резного базальта',
      'uk': 'Мала вивіска з обтесаного базальту',
      'ko': '작은 걸이형 각진 현무암 간판',
      'zh': '小型悬挂石板玄武岩标志',
      'ja': 'Small Hanging Ashlar Basalt Sign',
    }, {
      'id': 'SmallHangingAshlarGneissSignItem',
      'en': 'Small Hanging Ashlar Gneiss Sign',
      'fr': 'Petit panneau suspendu en calcaire taillé',
      'es': 'Letrero colgante pequeño (sillar de gneis)',
      'de': 'Steinquaderschild aus Gneis (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego gnejsu',
      'ru': 'Маленькая вывеска из резного гнейса',
      'uk': 'Мала вивіска з обтесаного гнейсу',
      'ko': '작은 걸이형 각진 편마암 간판',
      'zh': '小型悬挂阿什拉尔片麻岩标志',
      'ja': 'Small Hanging Ashlar Gneiss Sign',
    }, {
      'id': 'SmallHangingAshlarGraniteSignItem',
      'en': 'Small Hanging Ashlar Granite Sign',
      'fr': 'Petit panneau suspendu en calcaire taillé',
      'es': 'Letrero colgante pequeño (sillar de granito)',
      'de': 'Steinquaderschild aus Granit (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego granitu',
      'ru': 'Маленькая вывеска из резного гранита',
      'uk': 'Мала вивіска з обтесаного граніту',
      'ko': '작은 걸이형 각진 화강암 간판',
      'zh': '小型悬挂石板花岗岩标志',
      'ja': 'Small Hanging Ashlar Granite Sign',
    }, {
      'id': 'SmallHangingAshlarLimestoneSignItem',
      'en': 'Small Hanging Ashlar Limestone Sign',
      'fr': 'Petit panneau suspendu en calcaire taillé',
      'es': 'Letrero colgante pequeño (sillar de piedra caliza)',
      'de': 'Steinquaderschild aus Kalkstein (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego wapienia',
      'ru': 'Маленькая вывеска из резного известняка',
      'uk': 'Мала вивіска з обтесаного вапняку',
      'ko': '작은 걸이형 각진 석회암 간판',
      'zh': '小型悬挂阿什拉尔石灰石标志',
      'ja': 'Small Hanging Ashlar Limestone Sign',
    }, {
      'id': 'SmallHangingAshlarSandstoneSignItem',
      'en': 'Small Hanging Ashlar Sandstone Sign',
      'fr': 'Petit panneau suspendu en calcaire taillé',
      'es': 'Letrero colgante pequeño (sillar de arenisca)',
      'de': 'Steinquaderschild aus Sandstein (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego piaskowca',
      'ru': 'Маленькая вывеска из резного песчаника',
      'uk': 'Мала вивіска з обтесаного піщаника',
      'ko': '작은 걸이형 각진 사암 간판',
      'zh': '小型悬挂石板砂岩标志',
      'ja': 'Small Hanging Ashlar Sandstone Sign',
    }, {
      'id': 'SmallHangingAshlarShaleSignItem',
      'en': 'Small Hanging Ashlar Shale Sign',
      'fr': 'Petit panneau suspendu en pierre taillé',
      'es': 'Letrero colgante pequeño (sillar de pizarra)',
      'de': 'Steinquaderschild aus Schiefer (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego łupku',
      'ru': 'Маленькая вывеска из резного сланца',
      'uk': 'Мала вивіска з обтесаного сланцю',
      'ko': '작은 걸이형 각진 이판암 간판',
      'zh': '小型悬挂阿什拉尔页岩标志',
      'ja': 'Small Hanging Ashlar Shale Sign',
    }, {
      'id': 'SmallHangingAshlarStoneSignItem',
      'en': 'Small Hanging Ashlar Stone Sign',
      'fr': 'Petit panneau suspendu en pierre taillé',
      'es': 'Letrero colgante pequeño (sillar de piedra)',
      'de': 'Steinquaderschild (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego kamienia',
      'ru': 'Маленькая вывеска из резного камня',
      'uk': 'Мала вивіска з обтесаного каменю',
      'ko': '작은 걸이형 각진 석재 간판',
      'zh': '小型悬挂阿什拉尔标志',
      'ja': 'Small Hanging Ashlar Stone Sign',
    }, {
      'id': 'SmallHangingBirchSignItem',
      'en': 'Small Hanging Birch Sign',
      'fr': 'Petit panneau suspendu en bouleau',
      'es': 'Letrero pequeño colgante (abedul)',
      'de': 'Holzschild aus Birke (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Brzozy',
      'ru': 'Маленькая берёзовая вывеска',
      'uk': 'Маленька вивіска з берези',
      'ko': '작은 걸이형 자작나무 목재 간판',
      'zh': '小型悬挂桦木标志',
      'ja': 'Small Hanging Birch Sign',
    }, {
      'id': 'SmallHangingCedarSignItem',
      'en': 'Small Hanging Cedar Sign',
      'fr': 'Petit panneau suspendu en cèdre',
      'es': 'Letrero pequeño colgante (cedro)',
      'de': 'Holzschild aus Zedernholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Cedra',
      'ru': 'Маленькая кедровая вывеска',
      'uk': 'Маленька вивіска з кедру',
      'ko': '작은 걸이형 삼나무 목재 간판',
      'zh': '小型悬挂雪松标志',
      'ja': 'Small Hanging Cedar Sign',
    }, {
      'id': 'SmallHangingCeibaSignItem',
      'en': 'Small Hanging Ceiba Sign',
      'fr': 'Petit panneau suspendu en ceiba',
      'es': 'Letrero pequeño colgante (ceiba)',
      'de': 'Holzschild aus Kapokholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Puchowca',
      'ru': 'Маленькая вывеска из сейбы',
      'uk': 'Маленька вивіска з сейби',
      'ko': '작은 걸이형 명주나무 목재 간판',
      'zh': '小型悬挂木棉标志',
      'ja': 'Small Hanging Ceiba Sign',
    }, {
      'id': 'SmallHangingFirSignItem',
      'en': 'Small Hanging Fir Sign',
      'fr': 'Petit panneau suspendu en sapin',
      'es': 'Letrero pequeño colgante (abeto)',
      'de': 'Holzschild aus Tannenholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Jodły',
      'ru': 'Маленькая пихтовая вывеска',
      'uk': 'Маленька вивіска з ялиці',
      'ko': '작은 걸이형 전나무 목재 간판',
      'zh': '小型悬挂冷杉标志',
      'ja': 'Small Hanging Fir Sign',
    }, {
      'id': 'SmallHangingHardwoodSignItem',
      'en': 'Small Hanging Hardwood Sign',
      'fr': 'Petit panneau suspendu en bois dur',
      'es': 'Letrero pequeño colgante (madera noble)',
      'de': 'Holzschild aus Hartholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Drzewa Liściastego',
      'ru': 'Маленькая вывеска из лиственных пород',
      'uk': 'Маленька вивіска з твердої деревини',
      'ko': '작은 걸이형 견목재 간판',
      'zh': '小型悬挂硬木标志',
      'ja': 'Small Hanging Hardwood Sign',
    }, {
      'id': 'SmallHangingJoshuaSignItem',
      'en': 'Small Hanging Joshua Sign',
      'fr': 'Petit panneau suspendu en josué',
      'es': 'Letrero pequeño colgante (joshua)',
      'de': 'Holzschild aus Josuaholz (klein, hängend)',
      'pl': 'Mały wiszący znak z drewna jukki',
      'ru': 'Маленькая вывеска из юкки коротколистной',
      'uk': 'Маленька вивіска з юки коротколисної',
      'ko': '작은 걸이형 여호수아나무 목재 간판',
      'zh': '小型悬挂约书亚标志',
      'ja': 'Small Hanging Joshua Sign',
    }, {
      'id': 'SmallHangingLumberSignItem',
      'en': 'Small Hanging Lumber Sign',
      'fr': 'Petit panneau suspendu en bois d\u0027oeuvre',
      'es': 'Letrero pequeño colgante (troncos)',
      'de': 'Bauholzschild (klein, hängend)',
      'pl': 'Small Hanging Lumber Sign',
      'ru': 'Маленькая вывеска из пиломатериалов',
      'uk': 'Мала навісна дерев’яна табличка',
      'ko': '작은 걸이형 가공 목재 간판',
      'zh': '小块木制标志',
      'ja': '木製の小さな掛け看板',
    }, {
      'id': 'SmallHangingMortaredGraniteSignItem',
      'en': 'Small Hanging Mortared Granite Sign',
      'fr': 'Petit panneau suspendu en granite cimenté',
      'es': 'Letrero colgante pequeño (granito con mortero)',
      'de': 'Steinziegelschild aus Granit (klein, hängend)',
      'pl': 'Mały wiszący szyld ze spojonego zaprawą granitu',
      'ru': 'Маленькая вывеска из строительного гранита',
      'uk': 'Мала вивіска з будівельного граніту',
      'ko': '작은 걸이형 모르타르 마감 화강암 선간판',
      'zh': '小型悬挂砂浆花岗岩标志',
      'ja': 'Small Hanging Mortared Granite Sign',
    }, {
      'id': 'SmallHangingMortaredLimestoneSignItem',
      'en': 'Small Hanging Mortared Limestone Sign',
      'fr': 'Petit panneau suspendu en calcaire cimenté',
      'es': 'Letrero colgante pequeño (piedra caliza con mortero)',
      'de': 'Steinziegelschild aus Kalkstein (klein, hängend)',
      'pl': 'Mały wiszący szyld ze spojonego zaprawą wapienia',
      'ru': 'Маленькая вывеска из строительного известняка',
      'uk': 'Мала вивіска з будівельного вапняку',
      'ko': '작은 걸이형 모르타르 마감 석회암 선간판',
      'zh': '小型悬挂砂浆石灰石标志',
      'ja': 'Small Hanging Mortared Limestone Sign',
    }, {
      'id': 'SmallHangingMortaredSandstoneSignItem',
      'en': 'Small Hanging Mortared Sandstone Sign',
      'fr': 'Petit panneau suspendu en grès cimenté',
      'es': 'Letrero colgante pequeño (arenisca con mortero)',
      'de': 'Steinziegelschild aus Sandstein (klein, hängend)',
      'pl': 'Mały wiszący szyld ze spojonego zaprawą piaskowca',
      'ru': 'Маленькая вывеска из строительного песчаника',
      'uk': 'Мала вивіска з будівельного піщаника',
      'ko': '작은 걸이형 모르타르 마감 사암 선간판',
      'zh': '小型悬挂砂浆砂岩标志',
      'ja': 'Small Hanging Mortared Sandstone Sign',
    }, {
      'id': 'SmallHangingMortaredStoneSignItem',
      'en': 'Small Hanging Mortared Stone Sign',
      'fr': 'Petit panneau suspendu en pierre cimentée',
      'es': 'Letrero colgante pequeño (mortero)',
      'de': 'Steinziegelschild (klein, hängend)',
      'pl': 'Mały wiszący szyld ze spojonego zaprawą kamienia',
      'ru': 'Маленькая вывеска из строительного камня',
      'uk': 'Мала вивіска з будівельного каменю',
      'ko': '작은 걸이형 모르타르 마감 석재 선간판',
      'zh': '小型悬挂砂浆石标志',
      'ja': 'Small Hanging Mortared Stone Sign',
    }, {
      'id': 'SmallHangingOakSignItem',
      'en': 'Small Hanging Oak Sign',
      'fr': 'Petit panneau suspendu en chêne',
      'es': 'Letrero pequeño colgante (roble)',
      'de': 'Holzschild aus Eiche (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Dąbu',
      'ru': 'Маленькая дубовая вывеска',
      'uk': 'Маленька дубова вивіска',
      'ko': '작은 걸이형 참나무 간판',
      'zh': '小型悬挂橡木标志',
      'ja': 'Small Hanging Oak Sign',
    }, {
      'id': 'SmallHangingPalmSignItem',
      'en': 'Small Hanging Palm Sign',
      'fr': 'Petit panneau suspendu en palmier',
      'es': 'Letrero pequeño colgante (palmera)',
      'de': 'Holzschild aus Palmenholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Palmy',
      'ru': 'Маленькая пальмовая вывеска',
      'uk': 'Маленька пальмова вивіска',
      'ko': '작은 걸이형 야자나무 목재 간판',
      'zh': '小型悬挂棕榈标志',
      'ja': 'Small Hanging Palm Sign',
    }, {
      'id': 'SmallHangingRedwoodSignItem',
      'en': 'Small Hanging Redwood Sign',
      'fr': 'Petit panneau suspendu en bois tendre',
      'es': 'Letrero pequeño colgante (secuoya)',
      'de': 'Holzschild aus Rottanne (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Sekwoi',
      'ru': 'Маленькая вывеска из секвойи',
      'uk': 'Маленька вивіска з секвої',
      'ko': '작은 걸이형 삼나무 목재 간판',
      'zh': '小型悬挂红木标志',
      'ja': 'Small Hanging Redwood Sign',
    }, {
      'id': 'SmallHangingSaguaroSignItem',
      'en': 'Small Hanging Saguaro Sign',
      'fr': 'Petit panneau suspendu en saguaro',
      'es': 'Letrero pequeño colgante (saguaro)',
      'de': 'Holzschild aus Kaktusholz (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Kaktusa',
      'ru': 'Маленькая вывеска из карнегии',
      'uk': 'Маленька навісна табличка із саваро',
      'ko': '작은 걸이형 사구아로 목재 간판',
      'zh': '小型悬挂仙人掌标志',
      'ja': 'Small Hanging Saguaro Sign',
    }, {
      'id': 'SmallHangingSoftwoodSignItem',
      'en': 'Small Hanging Softwood Sign',
      'fr': 'Petit panneau suspendu en bois tendre',
      'es': 'Letrero pequeño colgante (madera blanda)',
      'de': 'Holzschild aus Weichholz (klein, hängend)',
      'pl': 'Mały wiszący znak z drewna iglastego',
      'ru': 'Маленькая вывеска из хвойных пород',
      'uk': 'Маленька навісна табличка із сосни',
      'ko': '작은 걸이형 연목재 간판',
      'zh': '小型悬挂软木标志',
      'ja': 'Small Hanging Softwood Sign',
    }, {
      'id': 'SmallHangingSpruceSignItem',
      'en': 'Small Hanging Spruce Sign',
      'fr': 'Petit panneau suspendu en épicéa',
      'es': 'Letrero pequeño colgante (pícea)',
      'de': 'Holzschild aus Fichte (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Świerka',
      'ru': 'Маленькая еловая вывеска',
      'uk': 'Маленька навісна табличка з ялини',
      'ko': '작은 걸이형 가문비 목재 간판',
      'zh': '小型悬挂云杉标志',
      'ja': 'Small Hanging Spruce Sign',
    }, {
      'id': 'SmallHangingStoneSignItem',
      'en': 'Small Hanging Stone Sign',
      'fr': 'Petit panneau suspendu en pierre',
      'es': 'Letrero pequeño colgante (piedra)',
      'de': 'Steinschild (klein, hängend)',
      'pl': 'Small Hanging Stone Sign',
      'ru': 'Маленькая вывеска из камня',
      'uk': 'Мала навісна кам’яна табличка',
      'ko': '작은 걸이형 석재 간판',
      'zh': '小块石制标志',
      'ja': '石の小さな掛け看板',
    }, {
      'id': 'SmallHangingWoodSignItem',
      'en': 'Small Hanging Wood Sign',
      'fr': 'Petit panneau suspendu en bois',
      'es': 'Letrero pequeño colgante (básico)',
      'de': 'Holzschild (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Drewna',
      'ru': 'Маленькая деревянная вывеска',
      'uk': 'Маленька навісна дерев\u0027яна табличка',
      'ko': '작은 걸이형 목재 간판',
      'zh': '小型立式木质标志',
      'ja': 'Small Hanging Wood Sign',
    }, {
      'id': 'SmallSinkItem',
      'en': 'Small Sink',
      'fr': 'Petit lavabo',
      'es': 'Fregadero pequeño',
      'de': 'Kleines Waschbecken',
      'pl': 'Mały zlew',
      'ru': 'Маленькая раковина',
      'uk': 'Мала раковина',
      'ko': '작은 싱크대',
      'zh': '小水槽',
      'ja': 'Small Sink',
    }, {
      'id': 'SmallStandingAshlarBasaltSignItem',
      'en': 'Small Standing Ashlar Basalt Sign',
      'fr': 'Petit panneau sur pied en basalte taillé',
      'es': 'Letrero pequeño (sillar de basalto)',
      'de': 'Steinquaderschild aus Basalt (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego bazaltu',
      'ru': 'Маленькая табличка из резного базальта',
      'uk': 'Маленька табличка з обтесаного базальту',
      'ko': '작은 각진 현무암 선간판',
      'zh': '小型立式石拉玄武岩标志',
      'ja': 'Small Standing Ashlar Basalt Sign',
    }, {
      'id': 'SmallStandingAshlarGneissSignItem',
      'en': 'Small Standing Ashlar Gneiss Sign',
      'fr': 'Petit panneau sur pied en gneiss taillé',
      'es': 'LeLetrero pequeño (sillar de gneis)',
      'de': 'Steinquaderschild aus Gneis (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego gnejsu',
      'ru': 'Маленькая табличка из резного гнейса',
      'uk': 'Маленька табличка з обтесаного гнейсу',
      'ko': '작은 각진 편마암 선간판',
      'zh': '小型立式立石楠片麻岩标志',
      'ja': 'Small Standing Ashlar Gneiss Sign',
    }, {
      'id': 'SmallStandingAshlarGraniteSignItem',
      'en': 'Small Standing Ashlar Granite Sign',
      'fr': 'Petit panneau sur pied en granite taillé',
      'es': 'Letrero pequeño (sillar de granito)',
      'de': 'Steinquaderschild aus Granit (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego granitu',
      'ru': 'Маленькая табличка из резного гранита',
      'uk': 'Маленька табличка з обтесаного граніту',
      'ko': '작은 각진 화강암 선간판',
      'zh': '小型立式阿什拉尔花岗岩标志',
      'ja': 'Small Standing Ashlar Granite Sign',
    }, {
      'id': 'SmallStandingAshlarLimestoneSignItem',
      'en': 'Small Standing Ashlar Limestone Sign',
      'fr': 'Petit panneau sur pied en calcaire taillé',
      'es': 'Letrero pequeño (sillar de piedra caliza)',
      'de': 'Steinquaderschild aus Kalkstein (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego wapienia',
      'ru': 'Маленькая табличка из резного известняка',
      'uk': 'Маленька табличка з обтесаного вапняку',
      'ko': '작은 각진 석회암 선간판',
      'zh': '小型立式阿什拉尔石灰石标志',
      'ja': 'Small Standing Ashlar Limestone Sign',
    }, {
      'id': 'SmallStandingAshlarSandstoneSignItem',
      'en': 'Small Standing Ashlar Sandstone Sign',
      'fr': 'Petit panneau sur pied en calcaire taillé',
      'es': 'Letrero pequeño (sillar de arenisca)',
      'de': 'Steinquaderschild aus Sandstein (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego piaskowca',
      'ru': 'Маленькая табличка из резного песчаника',
      'uk': 'Маленька табличка з обтесаного піщаника',
      'ko': '작은 각진 사암 선간판',
      'zh': '小型立式阿什拉尔砂岩标志',
      'ja': 'Small Standing Ashlar Sandstone Sign',
    }, {
      'id': 'SmallStandingAshlarShaleSignItem',
      'en': 'Small Standing Ashlar Shale Sign',
      'fr': 'Petit panneau sur pied en pierre taillée',
      'es': 'Letrero pequeño de pizarra (sillar)',
      'de': 'Steinquaderschild aus Schiefer (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego łupku',
      'ru': 'Маленькая табличка из резного сланца',
      'uk': 'Маленька табличка з обтесаного сланцю',
      'ko': '작은 각진 이판암 선간판',
      'zh': '小型立式石板页岩标志',
      'ja': 'Small Standing Ashlar Shale Sign',
    }, {
      'id': 'SmallStandingAshlarStoneSignItem',
      'en': 'Small Standing Ashlar Stone Sign',
      'fr': 'Petit panneau sur pied en pierre taillé',
      'es': 'Letrero pequeño (sillar de piedra)',
      'de': 'Steinquaderschild (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego kamienia',
      'ru': 'Маленькая табличка из резного камня',
      'uk': 'Маленька табличка з обтесаного каменю',
      'ko': '작은 각진 석재 선간판',
      'zh': '小型立式阿什拉尔石标志',
      'ja': 'Small Standing Ashlar Stone Sign',
    }, {
      'id': 'SmallStandingBirchSignItem',
      'en': 'Small Standing Birch Sign',
      'fr': 'Petit panneau sur pied en bouleau',
      'es': 'Letrero pequeño (abedul)',
      'de': 'Holzschild aus Birke (klein, stehend)',
      'pl': 'Mały Znak Stojący z Brzozy',
      'ru': 'Маленькая берёзовая табличка',
      'uk': 'Маленька табличка з берези',
      'ko': '작은 자작나무 목재 선간판',
      'zh': '小型立式桦木标志',
      'ja': 'Small Standing Birch Sign',
    }, {
      'id': 'SmallStandingCedarSignItem',
      'en': 'Small Standing Cedar Sign',
      'fr': 'Petit panneau sur pied en cèdre',
      'es': 'Letrero pequeño (cedro)',
      'de': 'Holzschild aus Zedernholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Cedra',
      'ru': 'Маленькая кедровая табличка',
      'uk': 'Маленька табличка з кедру',
      'ko': '작은 삼나무 목재 선간판',
      'zh': '小型立式雪松标志',
      'ja': 'Small Standing Cedar Sign',
    }, {
      'id': 'SmallStandingCeibaSignItem',
      'en': 'Small Standing Ceiba Sign',
      'fr': 'Petit panneau sur pied en ceiba',
      'es': 'Letrero pequeño (ceiba)',
      'de': 'Holzschild aus Kapokholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Puchowca',
      'ru': 'Маленькая табличка из сейбы',
      'uk': 'Маленька табличка із сейби',
      'ko': '작은 명주나무 목재 선간판',
      'zh': '小型立式木棉标志',
      'ja': 'Small Standing Ceiba Sign',
    }, {
      'id': 'SmallStandingFirSignItem',
      'en': 'Small Standing Fir Sign',
      'fr': 'Petit panneau sur pied en sapin',
      'es': 'Letrero pequeño (abeto)',
      'de': 'Holzschild aus Tannenholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Jodły',
      'ru': 'Маленькая пихтовая табличка',
      'uk': 'Маленька табличка з ялини',
      'ko': '작은 전나무 목재 선간판',
      'zh': '小型立式杉木标志',
      'ja': 'Small Standing Fir Sign',
    }, {
      'id': 'SmallStandingHardwoodSignItem',
      'en': 'Small Standing Hardwood Sign',
      'fr': 'Petit panneau sur pied en bois dur',
      'es': 'Letrero pequeño (madera dura)',
      'de': 'Holzschild aus Hartholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Drzewa Liściastego',
      'ru': 'Маленькая табличка из лиственных пород',
      'uk': 'Маленька табличка з листяних порід',
      'ko': '작은 견목재 선간판',
      'zh': '小型立式硬木标志',
      'ja': 'Small Standing Hardwood Sign',
    }, {
      'id': 'SmallStandingJoshuaSignItem',
      'en': 'Small Standing Joshua Sign',
      'fr': 'Petit panneau sur pied en josué',
      'es': 'Letrero pequeño (joshua)',
      'de': 'Holzschild aus Josuaholz (klein, stehend)',
      'pl': 'Mały stojący znak z drewna jukki',
      'ru': 'Маленькая табличка из юкки коротколистной',
      'uk': 'Маленька табличка з юки',
      'ko': '작은 여호수아 나무 목재 선간판',
      'zh': '小型立式约书亚标志',
      'ja': 'Small Standing Joshua Sign',
    }, {
      'id': 'SmallStandingLumberSignItem',
      'en': 'Small Standing Lumber Sign',
      'fr': 'Petit panneau sur pied en bois d\u0027oeuvre',
      'es': 'Pequeño letrero de pie de madera',
      'de': 'Bauholzschild (klein, stehend)',
      'pl': 'Small Standing Lumber Sign',
      'ru': 'Маленькая табличка из пиломатериалов',
      'uk': 'Мала стояча дерев’яна табличка',
      'ko': '작은 가공 목재 선간판',
      'zh': '小块木制标志',
      'ja': '木製の小さな立て看板',
    }, {
      'id': 'SmallStandingMortaredGraniteSignItem',
      'en': 'Small Standing Mortared Granite Sign',
      'fr': 'Petit panneau sur pied en granite cimenté',
      'es': 'Letrero pequeño (granito con mortero)',
      'de': 'Steinziegelschild aus Granit (klein, stehend)',
      'pl': 'Mały stojący szyld ze spojonego zaprawą granitu',
      'ru': 'Маленькая табличка из строительного гранита',
      'uk': 'Мала стояча табличка з будівельного граніту',
      'ko': '작은 모르타르 마감 화강암 선간판',
      'zh': '小型立式砂浆花岗岩标志',
      'ja': 'Small Standing Mortared Granite Sign',
    }, {
      'id': 'SmallStandingMortaredLimestoneSignItem',
      'en': 'Small Standing Mortared Limestone Sign',
      'fr': 'Petit panneau sur pied en calcaire cimenté',
      'es': 'Letrero pequeño (piedra caliza con mortero)',
      'de': 'Steinziegelschild aus Kalkstein (klein, stehend)',
      'pl': 'Mały stojący szyld ze spojonego zaprawą wapienia',
      'ru': 'Маленькая табличка из строительного известняка',
      'uk': 'Мала стояча табличка з будівельного вапняку',
      'ko': '작은 모르타르 마감 석회암 선간판',
      'zh': '小型立式砂浆石灰石标志',
      'ja': 'Small Standing Mortared Limestone Sign',
    }, {
      'id': 'SmallStandingMortaredSandstoneSignItem',
      'en': 'Small Standing Mortared Sandstone Sign',
      'fr': 'Petit panneau sur pied en grès cimenté',
      'es': 'Letrero pequeño (arenisca con mortero)',
      'de': 'Steinziegelschild aus Sandstein (klein, stehend)',
      'pl': 'Mały stojący szyld ze spojonego zaprawą piaskowca',
      'ru': 'Маленькая табличка из строительного песчаника',
      'uk': 'Мала стояча табличка з будівельного піщаника',
      'ko': '작은 모르타르 마감 사암 선간판',
      'zh': '小型立式砂浆砂岩标志',
      'ja': 'Small Standing Mortared Sandstone Sign',
    }, {
      'id': 'SmallStandingMortaredStoneSignItem',
      'en': 'Small Standing Mortared Stone Sign',
      'fr': 'Petit panneau sur pied en pierre cimenté',
      'es': 'Letrero pequeño (piedra con mortero)',
      'de': 'Steinziegelschild (klein, stehend)',
      'pl': 'Mały stojący szyld ze spojonego zaprawą kamienia',
      'ru': 'Маленькая табличка из строительного камня',
      'uk': 'Мала стояча табличка з будівельного каменю',
      'ko': '작은 모르타르 마감 석재 선간판',
      'zh': '小型立式砂浆石标志',
      'ja': 'Small Standing Mortared Stone Sign',
    }, {
      'id': 'SmallStandingOakSignItem',
      'en': 'Small Standing Oak Sign',
      'fr': 'Petit panneau sur pied en chêne',
      'es': 'Letrero pequeño (roble)',
      'de': 'Holzschild aus Eiche (klein, stehend)',
      'pl': 'Mały Znak Stojący z Dąbu',
      'ru': 'Маленькая дубовая табличка',
      'uk': 'Маленька дубова табличка',
      'ko': '작은 참나무 목재 선간판',
      'zh': '小型立式立橡木标志',
      'ja': 'Small Standing Oak Sign',
    }, {
      'id': 'SmallStandingPalmSignItem',
      'en': 'Small Standing Palm Sign',
      'fr': 'Petit panneau sur pied en palmier',
      'es': 'Letrero pequeño (palmera)',
      'de': 'Holzschild aus Palmenholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Palmy',
      'ru': 'Маленькая пальмовая табличка',
      'uk': 'Маленька пальмова табличка',
      'ko': '작은 야자나무 목재 선간판',
      'zh': '小型立式棕榈标志',
      'ja': 'Small Standing Palm Sign',
    }, {
      'id': 'SmallStandingRedwoodSignItem',
      'en': 'Small Standing Redwood Sign',
      'fr': 'Petit panneau sur pied en séquoia',
      'es': 'Letrero pequeño (secuoya)',
      'de': 'Holzschild aus Rottanne (klein, stehend)',
      'pl': 'Mały Znak Stojący z Sekwoi',
      'ru': 'Маленькая табличка из секвойи',
      'uk': 'Маленька табличка з секвої',
      'ko': '작은 삼나무 목재 선간판',
      'zh': '小型立式红木标志',
      'ja': 'Small Standing Redwood Sign',
    }, {
      'id': 'SmallStandingSaguaroSignItem',
      'en': 'Small Standing Saguaro Sign',
      'fr': 'Petit panneau sur pied en saguaro',
      'es': 'Letrero pequeño (saguaro)',
      'de': 'Holzschild aus Kaktusholz (klein, stehend)',
      'pl': 'Mały Znak Stojący z Kaktusa',
      'ru': 'Маленькая табличка из карнегии',
      'uk': 'Маленька табличка із саваро',
      'ko': '작은 사구아로 목재 선간판',
      'zh': '小型立式柱仙人掌标志',
      'ja': 'Small Standing Saguaro Sign',
    }, {
      'id': 'SmallStandingSoftwoodSignItem',
      'en': 'Small Standing Softwood Sign',
      'fr': 'Petit panneau sur pied en bois tendre',
      'es': 'Letrero pequeño (madera blanda)',
      'de': 'Holzschild aus Weichholz (klein, stehend)',
      'pl': 'Mały stojący znak z drewna iglastego',
      'ru': 'Маленькая табличка из хвойных пород',
      'uk': 'Маленька табличка з хвойних порід',
      'ko': '작은 연목재 선간판',
      'zh': '小型立式软木标志',
      'ja': 'Small Standing Softwood Sign',
    }, {
      'id': 'SmallStandingSpruceSignItem',
      'en': 'Small Standing Spruce Sign',
      'fr': 'Petit panneau sur pied en épicéa',
      'es': 'Letrero pequeño (pícea)',
      'de': 'Holzschild aus Fichte (klein, stehend)',
      'pl': 'Mały Znak Stojący z Świerku',
      'ru': 'Маленькая еловая табличка',
      'uk': 'Маленька табличка з ялини',
      'ko': '작은 가문비 목재 선간판',
      'zh': '小型立式云杉标志',
      'ja': 'Small Standing Spruce Sign',
    }, {
      'id': 'SmallStandingStoneSignItem',
      'en': 'Small Standing Stone Sign',
      'fr': 'Petit panneau sur pied en pierre',
      'es': 'Pequeño letrero de pie de piedra',
      'de': 'Steinschild (klein, stehend)',
      'pl': 'Small Standing Stone Sign',
      'ru': 'Маленькая табличка из камня',
      'uk': 'Мала стояча кам’яна табличка',
      'ko': '작은 석재 선간판',
      'zh': '小块石制标志',
      'ja': '石の小さな立て看板',
    }, {
      'id': 'SmallStandingWoodSignItem',
      'en': 'Small Standing Wood Sign',
      'fr': 'Petit panneau sur pied en bois',
      'es': 'Letrero pequeño (básico)',
      'de': 'Holzschild (klein, stehend)',
      'pl': 'Mały Stojący Znak Drewna',
      'ru': 'Маленькая деревянная табличка',
      'uk': 'Маленька дерев\u0027яна табличка',
      'ko': '작은 목재 선간판',
      'zh': '小型立式木质标志',
      'ja': 'Small Standing Wood Sign',
    }, {
      'id': 'SmallStockpileItem',
      'en': 'Small Stockpile',
      'fr': 'Réserve petite',
      'es': 'Pila de almacenamiento pequeña',
      'de': 'Lager (Mittel)',
      'pl': 'Mały skład',
      'ru': 'Маленький склад',
      'uk': 'Мала комора',
      'ko': '소형 자재 창고',
      'zh': '小型料堆',
      'ja': '小さな倉庫',
    }, {
      'id': 'SmallTableItem',
      'en': 'Small Table',
      'fr': 'Petite table',
      'es': 'Mesa Pequeña',
      'de': 'Kleiner Tisch',
      'pl': 'Mały stół',
      'ru': 'Маленький столик',
      'uk': 'Малий стілець',
      'ko': '작은 탁자',
      'zh': '小桌子',
      'ja': '小さなテーブル',
    }, {
      'id': 'SmallWoodCartItem',
      'en': 'Small Wood Cart',
      'fr': 'Petit chariot en bois',
      'es': 'Carro de Madera Pequeño',
      'de': 'Kleiner Holzkarren',
      'pl': 'Mały drewniany wózek',
      'ru': 'Маленькая деревянная телега',
      'uk': 'Малий дерев’яний віз',
      'ko': '작은 목재 수레',
      'zh': '小木质拖车',
      'ja': '小さい木製カート',
    }, {
      'id': 'SmeltingUpgradeItem',
      'en': 'Smelting Upgrade',
      'fr': 'Amélioration Avancée : Fonte',
      'es': 'Mejora: Fundición',
      'de': 'Fortgeschrittenes Upgrade: Schmelzen',
      'pl': 'Ulepszenie Wytapiania',
      'ru': 'Улучшение для выплавки',
      'uk': 'Покращення виплавки',
      'ko': '제련 기술 업그레이드',
      'zh': '冶炼升级',
      'ja': '製錬アップグレード',
    }, {
      'id': 'SmithApronItem',
      'en': 'Smith Apron',
      'fr': 'Tablier de forgeron',
      'es': 'Delantal de herrero',
      'de': 'Schmiedeschürze',
      'pl': 'Smith Apron',
      'ru': 'Фартук Кузнеца',
      'uk': 'Smith Apron',
      'ko': '스미스 앞치마',
      'zh': '铁匠的围裙',
      'ja': 'Smith Apron',
    }, {
      'id': 'SmithBandanaItem',
      'en': 'Smith Bandana',
      'fr': 'Bandana de forgeron',
      'es': 'Pañuelo de herrero',
      'de': 'Schmiedbandana',
      'pl': 'Smith Bandana',
      'ru': 'Бандана Кузнеца',
      'uk': 'Smith Bandana',
      'ko': '스미스 반다나',
      'zh': '铁匠的头巾',
      'ja': 'Smith Bandana',
    }, {
      'id': 'SmithBootsItem',
      'en': 'Smith Boots',
      'fr': 'Bottes de forgeron',
      'es': 'Botas de herrero',
      'de': 'Schmiedstiefel',
      'pl': 'Smith Boots',
      'ru': 'Ботинки Кузнеца',
      'uk': 'Smith Boots',
      'ko': '스미스 부츠',
      'zh': '铁匠的靴子',
      'ja': 'Smith Boots',
    }, {
      'id': 'SmithGlovesItem',
      'en': 'Smith Gloves',
      'fr': 'Gants de forgeron',
      'es': 'Guantes de herrero',
      'de': 'Schmiedhandschuhe',
      'pl': 'Smith Gloves',
      'ru': 'Перчатки Кузнеца',
      'uk': 'Smith Gloves',
      'ko': '스미스 장갑',
      'zh': '铁匠的手套',
      'ja': 'Smith Gloves',
    }, {
      'id': 'SmithPantsItem',
      'en': 'Smith Pants',
      'fr': 'Pantalon de forgeron',
      'es': 'Pantalones de herrero',
      'de': 'Schmiedhose',
      'pl': 'Smith Pants',
      'ru': 'Штаны Кузнеца',
      'uk': 'Smith Pants',
      'ko': '스미스 팬츠',
      'zh': '铁匠的裤子',
      'ja': 'Smith Pants',
    }, {
      'id': 'SmoothGutNoodleRollItem',
      'en': 'Smooth Gut Noodle Roll',
      'fr': 'Rouleau de nouilles aux restes de viande',
      'es': 'Rollo de Fideos e Intestino Delgado',
      'de': 'Canelloni mit Hackfleisch',
      'pl': 'Smooth Gut Noodle Roll',
      'ru': 'Ролл из гладкой кишки с лапшой',
      'uk': 'Smooth Gut Noodle Roll',
      'ko': 'Smooth Gut Noodle Roll',
      'zh': '肠粉卷',
      'ja': 'Smooth Gut Noodle Roll',
    }, {
      'id': 'SnappingTurtleCarcassItem',
      'en': 'Snapping Turtle Carcass',
      'fr': 'Cadavre de tortue serpentine',
      'es': 'Cadáver de tortuga mordedora',
      'de': 'Schnappschildkröten-Kadaver',
      'pl': 'Tusza żółwia jaszczurowatego',
      'ru': 'Туша каймановой черепахи',
      'uk': 'Туша кайманової черепахи',
      'ko': '악어거북 사체',
      'zh': '鳄龟遗骸',
      'ja': 'Snapping Turtle Carcass',
    }, {
      'id': 'Softwood',
      'en': 'Softwood',
      'fr': 'Bois tendre',
      'es': 'Madera blanda',
      'de': 'Weichholz',
      'pl': 'Drewno iglaste',
      'ru': 'Хвойные породы',
      'uk': 'Хвойні дерева',
      'ko': '연목',
      'zh': '软木',
      'ja': 'Softwood',
    }, {
      'id': 'SoilSamplerItem',
      'en': 'Soil Sampler',
      'fr': 'Analyseur de sol',
      'es': 'Muestreador de suelo',
      'de': 'Bodenprüfer',
      'pl': 'Próbnik Gleby',
      'ru': 'Анализатор почвы',
      'uk': 'Аналізатор ґрунту',
      'ko': '토양 채취기',
      'zh': '土壤取样器',
      'ja': 'ソイルサンプラー',
    }, {
      'id': 'SolarGeneratorItem',
      'en': 'Solar Generator',
      'fr': 'Générateur solaire',
      'es': 'Generador Solar',
      'de': 'Solargenerator',
      'pl': 'Generator słoneczny',
      'ru': 'Солнечный генератор',
      'uk': 'Сонячний генератор',
      'ko': '태양광 발전기',
      'zh': '太阳能发电机',
      'ja': '太陽光発電機',
    }, {
      'id': 'SpikyRollItem',
      'en': 'Spiky Roll',
      'fr': 'Maki hérissé',
      'es': 'Rollo Puntiagudo',
      'de': 'Stachelige Rolle',
      'pl': 'Spiky Roll',
      'ru': 'Колючий ролл',
      'uk': 'Spiky Roll',
      'ko': 'Spiky Roll',
      'zh': '穗状花卷',
      'ja': 'Spiky Roll',
    }, {
      'id': 'SpinMelterItem',
      'en': 'Spin Melter',
      'fr': 'Fileuse-fondeuse',
      'es': 'Torno de fusión',
      'de': 'Schmelzschleuderer',
      'pl': 'Spin Melter',
      'ru': 'Прядильная машина',
      'uk': 'Spin Melter',
      'ko': '스핀 멜터',
      'zh': '旋转熔炉',
      'ja': 'Spin Melter',
    }, {
      'id': 'SpruceLogItem',
      'en': 'Spruce Log',
      'fr': 'Bûche d\u0027Épicéa',
      'es': 'Tronco de pícea',
      'de': 'Fichtenstamm',
      'pl': 'Kłoda świerku',
      'ru': 'Бревно Ели',
      'uk': 'Ялинова колода',
      'ko': '가문비 통나무',
      'zh': '云杉原木',
      'ja': 'Spruce Log',
    }, {
      'id': 'SpruceSeedItem',
      'en': 'Spruce Seed',
      'fr': 'Graine d\u0027épicéa',
      'es': 'Semilla de abeto',
      'de': 'Samen (Fichte)',
      'pl': 'Nasiona świerku',
      'ru': 'Семечко ели',
      'uk': 'Насіння ялинки',
      'ko': '가문비나무 씨앗',
      'zh': '云杉种子',
      'ja': '松の種',
    }, {
      'id': 'SquareBeltItem',
      'en': 'Square Belt',
      'fr': 'Ceinture carrée',
      'es': 'Cinturón Cuadrado',
      'de': 'Quadratgürtel',
      'pl': 'Pas z kwadratową sprzączką',
      'ru': 'Ремень с квадратной пряжкой',
      'uk': 'Ремінь із квадратною пряжкою',
      'ko': '사각 벨트',
      'zh': '方皮带',
      'ja': '角ばったベルト',
    }, {
      'id': 'PlanterPotSquareItem',
      'en': 'Square Pot',
      'fr': 'Pot carré',
      'es': 'Maceta Cuadrada',
      'de': 'Blumentopf (quadratisch)',
      'pl': 'Kwadratowa donica',
      'ru': 'Квадратный горшок',
      'uk': 'Квадратний горщик',
      'ko': '각진 화분',
      'zh': '方盆',
      'ja': '四角い植木鉢',
    }, {
      'id': 'StampMillItem',
      'en': 'Stamp Mill',
      'fr': 'Concasseur à percussions en fer',
      'es': 'Molino de pisón',
      'de': 'Pochwerk',
      'pl': 'Kruszarka',
      'ru': 'Штамповочная мельница',
      'uk': 'Штамповий млин',
      'ko': '쇄광기',
      'zh': '捣矿机',
      'ja': 'Stamp Mill',
    }, {
      'id': 'StandingGlassSignItem',
      'en': 'Standing Glass Sign',
      'fr': 'Grand panneau sur pied en verre',
      'es': 'Letrero de vidrio',
      'de': 'Glasschild (stehend)',
      'pl': 'Standing Glass Sign',
      'ru': 'Стеклянная табличка',
      'uk': 'Standing Glass Sign',
      'ko': '스탠딩 글라스 사인',
      'zh': '玻璃标志',
      'ja': 'Standing Glass Sign',
    }, {
      'id': 'StandingLongSteelSignItem',
      'en': 'Standing Long Steel Sign',
      'fr': 'Long panneau sur pied en acier',
      'es': 'Letrero largo (acero)',
      'de': 'Stahlschild (lang, stehend)',
      'pl': 'Standing Long Steel Sign',
      'ru': 'Стоящая длинная табличка из стали',
      'uk': 'Standing Long Steel Sign',
      'ko': '서 있는 긴 강철 기호',
      'zh': '长条钢制标志',
      'ja': 'Standing Long Steel Sign',
    }, {
      'id': 'StandingSteelBrickSignItem',
      'en': 'Standing Steel Brick Sign',
      'fr': 'Long panneau sur pied de brique et d\u0027acier',
      'es': 'Letrero de acero (ladrillos)',
      'de': 'Stahlschild mit Ziegelsteinfundament (stehend)',
      'pl': 'Standing Steel Brick Sign',
      'ru': 'Стальная табличка с кирпичным основанием',
      'uk': 'Standing Steel Brick Sign',
      'ko': '서 있는 강철 벽돌 기호',
      'zh': '钢砖标志',
      'ja': 'Standing Steel Brick Sign',
    }, {
      'id': 'SteamEngineItem',
      'en': 'Steam Engine',
      'fr': 'Machine à vapeur',
      'es': 'Motor de Vapor',
      'de': 'Dampf-Stromgenerator',
      'pl': 'Steam Engine',
      'ru': 'Паровой двигатель',
      'uk': 'Паровий двигун',
      'ko': '증기기관',
      'zh': '蒸汽机',
      'ja': '蒸気発電機',
    }, {
      'id': 'SteamTractorItem',
      'en': 'Steam Tractor',
      'fr': 'Tracteur à vapeur',
      'es': 'Tractor a vapor',
      'de': 'Dampftraktor',
      'pl': 'Ciągnik Parowy',
      'ru': 'Паровой трактор',
      'uk': 'Паровий трактор',
      'ko': '증기 트랙터',
      'zh': '蒸汽拖拉机',
      'ja': '蒸気トラクター',
    }, {
      'id': 'SteamTractorHarvesterItem',
      'en': 'Steam Tractor Harvester',
      'fr': 'Moissonneuse pour tracteur à vapeur',
      'es': 'Cosechadora a vapor',
      'de': 'Dampftraktor-Erntemaschine',
      'pl': 'Kombajn Parowy',
      'ru': 'Жатка парового трактора',
      'uk': 'Збирач для парового трактора',
      'ko': '증기기관 트랙터용 수확기',
      'zh': '蒸汽拖拉机式收割机',
      'ja': '蒸気トラクター用刈取り機',
    }, {
      'id': 'SteamTractorPlowItem',
      'en': 'Steam Tractor Plow',
      'fr': 'Charrue pour tracteur à vapeur',
      'es': 'Arado con tractor a vapor',
      'de': 'Dampftraktor-Pflug',
      'pl': 'Steam Tractor Plow',
      'ru': 'Плуг парового трактора',
      'uk': 'Steam Tractor Plow',
      'ko': '증기기관 트랙터 쟁기',
      'zh': '蒸汽拖拉机犁',
      'ja': 'Steam Tractor Plow',
    }, {
      'id': 'SteamTractorSowerItem',
      'en': 'Steam Tractor Sower',
      'fr': 'Semoir pour tracteur à vapeur',
      'es': 'Sembradora para el Tractor de Vapor',
      'de': 'Dampftraktor-Sämaschine',
      'pl': 'Siewnik Parowy',
      'ru': 'Сеялка парового трактора',
      'uk': 'Сіялка парового трактора',
      'ko': '증기기관 트랙터용 파종기',
      'zh': '蒸汽拖拉机用播种机',
      'ja': '蒸気トラクター用種蒔き機',
    }, {
      'id': 'SteamTruckItem',
      'en': 'Steam Truck',
      'fr': 'Camion à vapeur',
      'es': 'Camión a vapor',
      'de': 'Dampflastwagen',
      'pl': 'Steam Truck',
      'ru': 'Паровой грузовик',
      'uk': 'Парова вантажівка',
      'ko': '증기기관 트럭',
      'zh': '蒸汽卡车',
      'ja': '蒸気トラック',
    }, {
      'id': 'SteelAbstractFixtureItem',
      'en': 'Steel Abstract Fixture',
      'fr': 'Plafonnier abstrait en acier',
      'es': 'Accesorio abstracto (acero)',
      'de': 'Stählerne abstrakte Vorrichtung',
      'pl': 'Steel Abstract Fixture',
      'ru': 'Стальной абстрактный светильник',
      'uk': 'Steel Abstract Fixture',
      'ko': '강철 추상 정착물',
      'zh': '钢制抽象灯具',
      'ja': 'Steel Abstract Fixture',
    }, {
      'id': 'SteelAxeItem',
      'en': 'Steel Axe',
      'fr': 'Hache en acier',
      'es': 'Hacha de Acero',
      'de': 'Stahlaxt',
      'pl': 'Stalowa siekiera',
      'ru': 'Стальной топор',
      'uk': 'Сталева сокира',
      'ko': '강철 도끼',
      'zh': '钢斧',
      'ja': '鋼のオノ',
    }, {
      'id': 'SteelAxleItem',
      'en': 'Steel Axle',
      'fr': 'Essieu en acier',
      'es': 'Hacha de Acero',
      'de': 'Stahlachse',
      'pl': 'Oś stalowa',
      'ru': 'Стальная ось',
      'uk': 'Сталева вісь',
      'ko': '강철 차축',
      'zh': '钢质车轴',
      'ja': '鋼の車軸',
    }, {
      'id': 'SteelBarItem',
      'en': 'Steel Bar',
      'fr': 'Lingot d\u0027acier',
      'es': 'Lingote de acero',
      'de': 'Stahlbarren',
      'pl': 'Sztabka stali',
      'ru': 'Стальной брусок',
      'uk': 'Стальний брусок',
      'ko': '강철괴',
      'zh': '钢筋',
      'ja': 'Steel Bar',
    }, {
      'id': 'SteelCeilingLightItem',
      'en': 'Steel Ceiling Light',
      'fr': 'Plafonnier en acier',
      'es': 'Lámpara de techo de metal',
      'de': 'Stahl-Deckenlampe',
      'pl': 'Steel Ceiling Light',
      'ru': 'Стальной потолочный светильник',
      'uk': 'Сталева люстра',
      'ko': '강철 천장등',
      'zh': '钢制顶棚灯',
      'ja': '鋼製の天井ライト',
    }, {
      'id': 'SteelFloorLampItem',
      'en': 'Steel Floor Lamp',
      'fr': 'Lampe sur pied en acier',
      'es': 'Lámpara de suelo de metal',
      'de': 'Stählerne Stehlampe',
      'pl': 'Steel Floor Lamp',
      'ru': 'Стальной торшер',
      'uk': 'Сталевий торшер',
      'ko': '강철 스탠드형 전등',
      'zh': '钢制落地灯',
      'ja': '鋼製の室内灯',
    }, {
      'id': 'SteelGearItem',
      'en': 'Steel Gear',
      'fr': 'Engrenage en acier',
      'es': 'Engranaje de acero',
      'de': 'Stahlzahnrad',
      'pl': 'Stalowy bieg',
      'ru': 'Стальная шестерня',
      'uk': 'Сталева шестірня',
      'ko': '강철 기어',
      'zh': '钢质齿轮',
      'ja': '鋼のギア',
    }, {
      'id': 'SteelGearboxItem',
      'en': 'Steel Gearbox',
      'fr': 'Boîte de vitesses en acier',
      'es': 'Caja de engranajes de acero',
      'de': 'Stahlgetriebe',
      'pl': 'Stalowa Skrzynia Biegów',
      'ru': 'Стальная коробка передач',
      'uk': 'Сталева коробка передач',
      'ko': '강철 변속장치',
      'zh': '钢齿轮箱',
      'ja': 'Steel Gearbox',
    }, {
      'id': 'SteelHammerItem',
      'en': 'Steel Hammer',
      'fr': 'Marteau en acier',
      'es': 'Martillo de Acero',
      'de': 'Stahlhammer',
      'pl': 'Stalowy młotek',
      'ru': 'Стальной молоток',
      'uk': 'Сталевий молоток',
      'ko': '강철 망치',
      'zh': '钢锤',
      'ja': '鋼のハンマー',
    }, {
      'id': 'SteelHangingFixtureItem',
      'en': 'Steel Hanging Fixture',
      'fr': 'Plafonnier décoratif en acier',
      'es': 'Accesorio colgante (acero)',
      'de': 'Stählerne hängende Vorrichtung',
      'pl': 'Steel Hanging Fixture',
      'ru': 'Стальной подвесной светильник',
      'uk': 'Steel Hanging Fixture',
      'ko': '강철 걸이 고정구',
      'zh': '钢制悬挂式灯具',
      'ja': 'Steel Hanging Fixture',
    }, {
      'id': 'SteelHangingLampItem',
      'en': 'Steel Hanging Lamp',
      'fr': 'Plafonnier suspendu en acier',
      'es': 'Lámpara colgante (acero)',
      'de': 'Stählerne Hängelampe',
      'pl': 'Steel Hanging Lamp',
      'ru': 'Стальная подвесная лампа',
      'uk': 'Steel Hanging Lamp',
      'ko': '스틸 교수형 램프',
      'zh': '钢制悬挂式灯',
      'ja': 'Steel Hanging Lamp',
    }, {
      'id': 'SteelHoeItem',
      'en': 'Steel Hoe',
      'fr': 'Binette en acier',
      'es': 'Azada de Acero',
      'de': 'Stahlhacke',
      'pl': 'Stalowa motyka',
      'ru': 'Стальная тяпка',
      'uk': 'Сталева мотика',
      'ko': '강철 괭이',
      'zh': '钢锄',
      'ja': '鋼のクワ',
    }, {
      'id': 'SteelKitchenLampItem',
      'en': 'Steel Kitchen Lamp',
      'fr': 'Lustre de cuisine en acier',
      'es': 'Lámpara de cocina (acero)',
      'de': 'Stählerne Küchenlampe',
      'pl': 'Steel Kitchen Lamp',
      'ru': 'Стальная кухонная лампа',
      'uk': 'Steel Kitchen Lamp',
      'ko': '스틸 주방 램프',
      'zh': '钢制厨房灯',
      'ja': 'Steel Kitchen Lamp',
    }, {
      'id': 'SteelMacheteItem',
      'en': 'Steel Machete',
      'fr': 'Machette en acier',
      'es': 'Machete de acero',
      'de': 'Stahlmachete',
      'pl': 'Stalowa maczeta',
      'ru': 'Стальное мачете',
      'uk': 'Стальне мачете',
      'ko': '강철 마체테',
      'zh': '钢质砍刀',
      'ja': 'Steel Machete',
    }, {
      'id': 'SteelPickaxeItem',
      'en': 'Steel Pickaxe',
      'fr': 'Pioche en acier',
      'es': 'Pico de Acero',
      'de': 'Stahlspitzhacke',
      'pl': 'Stalowy kilof',
      'ru': 'Стальная кирка',
      'uk': 'Сталеве кайло',
      'ko': '강철 곡괭이',
      'zh': '钢镐',
      'ja': '鋼のツルハシ',
    }, {
      'id': 'SteelPipeItem',
      'en': 'Steel Pipe',
      'fr': 'Tuyau en acier',
      'es': 'Tubo de Acero',
      'de': 'Stahlrohr',
      'pl': 'Stalowa Rura',
      'ru': 'Стальная труба',
      'uk': 'Сталева труба',
      'ko': '강철 파이프',
      'zh': '钢管',
      'ja': '鋼パイプ',
    }, {
      'id': 'SteelPlateItem',
      'en': 'Steel Plate',
      'fr': 'Plaque d’acier',
      'es': 'Placa de Acero',
      'de': 'Stahlplatte',
      'pl': 'Blacha Stalowa',
      'ru': 'Стальная пластина',
      'uk': 'Сталева пластина',
      'ko': '강철판',
      'zh': '钢板',
      'ja': '鋼板',
    }, {
      'id': 'SteelRoadToolItem',
      'en': 'Steel Road Tool',
      'fr': 'Outil de route en acier',
      'es': 'Herramienta compactadora de acero',
      'de': 'Stahlstraßenwerkzeug',
      'pl': 'Stalowe narzędzie do dróg',
      'ru': 'Стальная трамбовка',
      'uk': 'Стальний дорожній інструмент',
      'ko': '강철 도로정비 도구',
      'zh': '钢质道路工具',
      'ja': 'Steel Road Tool',
    }, {
      'id': 'SteelSawBladeItem',
      'en': 'Steel Saw Blade',
      'fr': 'Lame de scie en acier',
      'es': 'Sierra circular de acero',
      'de': 'Stahlsägeblatt',
      'pl': 'Stalowe Ostrze Piły',
      'ru': 'Стальной пильный диск',
      'uk': 'Сталевий пиляльний диск',
      'ko': '강철 톱날',
      'zh': '钢锯片',
      'ja': 'Steel Saw Blade',
    }, {
      'id': 'SteelSearchlightItem',
      'en': 'Steel Searchlight',
      'fr': 'Projecteur en acier',
      'es': 'Reflector (acero)',
      'de': 'Stählerner Suchscheinwerver',
      'pl': 'Steel Searchlight',
      'ru': 'Стальной прожектор',
      'uk': 'Steel Searchlight',
      'ko': '강철 탐조등',
      'zh': '钢制探照灯',
      'ja': 'Steel Searchlight',
    }, {
      'id': 'SteelShovelItem',
      'en': 'Steel Shovel',
      'fr': 'Pelle en acier',
      'es': 'Pala de Acero',
      'de': 'Stahlschaufel',
      'pl': 'Stalowa łopata',
      'ru': 'Стальная лопата',
      'uk': 'Сталева лопата',
      'ko': '강철 삽',
      'zh': '钢铲',
      'ja': '鋼のシャベル',
    }, {
      'id': 'SteelSickleItem',
      'en': 'Steel Sickle',
      'fr': 'Faucille en acier',
      'es': 'Hoz de acero',
      'de': 'Stahlsichel',
      'pl': 'Stalowy sierp',
      'ru': 'Стальной серп',
      'uk': 'Стальний серп',
      'ko': '강철 낫',
      'zh': '钢质镰刀',
      'ja': 'Steel Sickle',
    }, {
      'id': 'SteelSquareFixtureItem',
      'en': 'Steel Square Fixture',
      'fr': 'Plafonnier carré en acier',
      'es': 'Accesorio cuadrado (acero)',
      'de': 'Stählerne quadratische Halterung',
      'pl': 'Steel Square Fixture',
      'ru': 'Стальной квадратный светильник',
      'uk': 'Steel Square Fixture',
      'ko': '스틸 스퀘어 비품',
      'zh': '钢制方形灯具',
      'ja': 'Steel Square Fixture',
    }, {
      'id': 'SteelTableLampItem',
      'en': 'Steel Table Lamp',
      'fr': 'Lampe de table en acier',
      'es': 'Lampara de acero para mesas',
      'de': 'Stahltischlampe',
      'pl': 'Steel Table Lamp',
      'ru': 'Стальная настольная лампа',
      'uk': 'Сталева настільна лампа',
      'ko': '강철 탁자 전등',
      'zh': '钢制台灯',
      'ja': '鋼製の電気スタンド',
    }, {
      'id': 'StockpileItem',
      'en': 'Stockpile',
      'fr': 'Réserve',
      'es': 'Pila de almacenamiento',
      'de': 'Lager (Groß)',
      'pl': 'Skład',
      'ru': 'Склад',
      'uk': 'Комора',
      'ko': '자재 창고',
      'zh': '料堆',
      'ja': 'ストックパイル',
    }, {
      'id': 'StoneItem',
      'en': 'Stone',
      'fr': 'Pierre',
      'es': 'Piedra',
      'de': 'Stein',
      'pl': 'Kamień',
      'ru': 'Камень',
      'uk': 'Камінь',
      'ko': '돌',
      'zh': '石头',
      'ja': '石',
    }, {
      'id': 'StoneAxeItem',
      'en': 'Stone Axe',
      'fr': 'Hache en pierre',
      'es': 'Hacha de piedra',
      'de': 'Steinaxt',
      'pl': 'Kamienna siekiera',
      'ru': 'Каменный топор',
      'uk': 'Кам’яна сокира',
      'ko': '돌 도끼',
      'zh': '石斧',
      'ja': '石のオノ',
    }, {
      'id': 'StoneBrazierItem',
      'en': 'Stone Brazier',
      'fr': 'Braséro en pierre',
      'es': 'Brasero de piedra',
      'de': 'Feuerschale aus Stein',
      'pl': 'Kamienny koksownik',
      'ru': 'Каменная жаровня',
      'uk': 'Кам’яна жаровня',
      'ko': '돌 화로',
      'zh': '石火盆',
      'ja': '石火鉢',
    }, {
      'id': 'StoneDoorItem',
      'en': 'Stone Door',
      'fr': 'Porte en pierre',
      'es': 'Puerta de piedra',
      'de': 'Steintür',
      'pl': 'Stone Door',
      'ru': 'Каменная дверь',
      'uk': 'Кам’яні двері',
      'ko': '석재 문',
      'zh': '石门',
      'ja': '石のドア',
    }, {
      'id': 'StoneHammerItem',
      'en': 'Stone Hammer',
      'fr': 'Marteau en pierre',
      'es': 'Martillo de Piedra',
      'de': 'Steinhammer',
      'pl': 'Kamienny młotek',
      'ru': 'Каменный молоток',
      'uk': 'Кам’яний молоток',
      'ko': '돌 망치',
      'zh': '石锤',
      'ja': '石のハンマー',
    }, {
      'id': 'StoneMacheteItem',
      'en': 'Stone Machete',
      'fr': 'Machette en pierre',
      'es': 'Machete de piedra',
      'de': 'Steinmachete',
      'pl': 'Kamienna maczeta',
      'ru': 'Каменное мачете',
      'uk': 'Кам\u0027яне мачете',
      'ko': '돌 마체테',
      'zh': '石质砍刀',
      'ja': 'Stone Machete',
    }, {
      'id': 'StonePickaxeItem',
      'en': 'Stone Pickaxe',
      'fr': 'Pioche en pierre',
      'es': 'Pico de piedra',
      'de': 'Steinspitzhacke',
      'pl': 'Kamienny kilof',
      'ru': 'Каменная кирка',
      'uk': 'Кам’яне кайло',
      'ko': '돌 곡괭이',
      'zh': '石镐',
      'ja': '石のツルハシ',
    }, {
      'id': 'StoneRampItem',
      'en': 'Stone Ramp',
      'fr': 'Rampe pavée',
      'es': 'Rampa de Piedra',
      'de': 'Steinrampe',
      'pl': 'Kamienny Podjazd',
      'ru': 'Каменная рампа',
      'uk': 'Кам’яний підйом',
      'ko': '돌 경사로',
      'zh': '石头坡道',
      'ja': '石の坂道',
    }, {
      'id': 'StoneRoadItem',
      'en': 'Stone Road',
      'fr': 'Route pavée',
      'es': 'Camino de Piedra',
      'de': 'Steinstraße',
      'pl': 'Kamienna droga',
      'ru': 'Каменная дорога',
      'uk': 'Кам’яна дорога',
      'ko': '돌 길',
      'zh': '石质道路',
      'ja': '石の道路',
    }, {
      'id': 'StoneRoadToolItem',
      'en': 'Stone Road Tool',
      'fr': 'Outil de route en pierre',
      'es': 'Herramienta compactadora de piedra',
      'de': 'Steinstraßenwerkzeug',
      'pl': 'Kamienne narzędzie do dróg',
      'ru': 'Каменная трамбовка',
      'uk': 'Кам\u0027яний дорожній інструмент',
      'ko': '돌 도로정비 도구',
      'zh': '石质道路工具',
      'ja': 'Stone Road Tool',
    }, {
      'id': 'StoneSickleItem',
      'en': 'Stone Sickle',
      'fr': 'Faucille en pierre',
      'es': 'Hoz de piedra',
      'de': 'Steinsichel',
      'pl': 'Kamienny sierp',
      'ru': 'Каменный серп',
      'uk': 'Кам\u0027яний серп',
      'ko': '돌 낫',
      'zh': '石质镰刀',
      'ja': 'Stone Sickle',
    }, {
      'id': 'StoneWellItem',
      'en': 'Stone Well',
      'fr': 'Puits en pierre',
      'es': 'Pozo de Piedra',
      'de': 'Steinbrunnen',
      'pl': 'Kamienna studnia',
      'ru': 'Каменный колодец',
      'uk': 'Кам’яний колодязь',
      'ko': '석재 우물',
      'zh': '石井',
      'ja': '井戸',
    }, {
      'id': 'StopSignItem',
      'en': 'Stop Sign',
      'fr': 'Panneau stop',
      'es': 'Señal de STOP',
      'de': 'Stoppschild',
      'pl': 'Stop Sign',
      'ru': 'Знак Стоп',
      'uk': 'Знак стоп',
      'ko': '일단정지 표지판',
      'zh': '停止标志',
      'ja': 'Stop Sign',
    }, {
      'id': 'StorageChestItem',
      'en': 'Storage Chest',
      'fr': 'Coffre',
      'es': 'Cofre de almacenamiento',
      'de': 'Truhe',
      'pl': 'Skrzynia',
      'ru': 'Сундук',
      'uk': 'Скриня',
      'ko': '보관함',
      'zh': '储物箱',
      'ja': 'ストレージチェスト',
    }, {
      'id': 'StorageSiloItem',
      'en': 'Storage Silo',
      'fr': 'Silo de stockage',
      'es': 'Silo de almacenamiento',
      'de': 'Hölzernes Vorratssilo',
      'pl': 'Storage Silo',
      'ru': 'Силосная башня',
      'uk': 'Storage Silo',
      'ko': '스토리지 사일로',
      'zh': '储料仓',
      'ja': 'Storage Silo',
    }, {
      'id': 'StoreItem',
      'en': 'Store',
      'fr': 'Magasin',
      'es': 'Tienda',
      'de': 'Shop-Name',
      'pl': 'Sklep',
      'ru': 'Магазин',
      'uk': 'Крамниця',
      'ko': '상점',
      'zh': '商店',
      'ja': 'お店',
    }, {
      'id': 'StoveItem',
      'en': 'Stove',
      'fr': 'Cuisinière',
      'es': 'Estufa',
      'de': 'Herd',
      'pl': 'Kuchnia',
      'ru': 'Плита',
      'uk': 'Плита',
      'ko': '화덕',
      'zh': '火炉',
      'ja': 'ストーブ',
    }, {
      'id': 'StrangeFuelItem',
      'en': 'Strange Fuel',
      'fr': 'Carburant étrange',
      'es': 'Combustible Extraño',
      'de': 'Seltsamer Kraftstoff',
      'pl': 'Dziwne Paliwo',
      'ru': 'Странное топливо',
      'uk': 'Дивне паливо',
      'ko': '이상한 연료',
      'zh': '奇怪的燃料',
      'ja': '奇妙な燃料',
    }, {
      'id': 'StreetSignItem',
      'en': 'Street Sign',
      'fr': 'Panneau de rue',
      'es': 'Letrero de calle',
      'de': 'Straßenschild',
      'pl': 'Znak Uliczny',
      'ru': 'Уличный указатель',
      'uk': 'Вуличний знак',
      'ko': '거리 표지판',
      'zh': '街道路标',
      'ja': 'Street Sign',
    }, {
      'id': 'StreetlampItem',
      'en': 'Streetlamp',
      'fr': 'Réverbère',
      'es': 'Farola',
      'de': 'Straßenlaterne',
      'pl': 'Lampa uliczna',
      'ru': 'Уличный фонарь',
      'uk': 'Вуличний ліхтар',
      'ko': '가로등',
      'zh': '街灯',
      'ja': '街灯',
    }, {
      'id': 'StuffedAlligatorItem',
      'en': 'Stuffed Alligator',
      'fr': 'Alligator empaillé',
      'es': 'Caimán disecado',
      'de': 'Ausgestopfter Alligator',
      'pl': 'Wypchany aligator',
      'ru': 'Чучело аллигатора',
      'uk': 'Опудало алігатора',
      'ko': '박제된 악어',
      'zh': '鳄鱼标本',
      'ja': 'Stuffed Alligator',
    }, {
      'id': 'StuffedBisonItem',
      'en': 'Stuffed Bison',
      'fr': 'Bison empaillé',
      'es': 'Bisón disecado',
      'de': 'Ausgestopftes Bison',
      'pl': 'Wypchany żubr',
      'ru': 'Чучело бизона',
      'uk': 'Опудало бізона',
      'ko': '박제된 들소',
      'zh': '野牛标本',
      'ja': 'Stuffed Bison',
    }, {
      'id': 'StuffedElkItem',
      'en': 'Stuffed Elk',
      'fr': 'Wapiti empaillé',
      'es': 'Alce disecado',
      'de': 'Ausgestopfter Wapiti',
      'pl': 'Nadziewany Łoś',
      'ru': 'Чучело вапити',
      'uk': 'Опудало лося',
      'ko': '박제된 엘크',
      'zh': '驼鹿标本',
      'ja': 'エルクのぬいぐるみ',
    }, {
      'id': 'StuffedGoatItem',
      'en': 'Stuffed Goat',
      'fr': 'Chèvre des montagnes empaillé',
      'es': 'Cabra disecada',
      'de': 'Ausgestopfte Ziege',
      'pl': 'Nadziewana koza',
      'ru': 'Чучело козы',
      'uk': 'Опудало кози',
      'ko': '박재된 염소',
      'zh': '山羊标本',
      'ja': 'Stuffed Goat',
    }, {
      'id': 'StuffedJaguarItem',
      'en': 'Stuffed Jaguar',
      'fr': 'Jaguar empaillé',
      'es': 'Jaguar disecado',
      'de': 'Ausgestopfter Jaguar',
      'pl': 'Wypchany jaguar',
      'ru': 'Чучело ягуара',
      'uk': 'Опудало ягуара',
      'ko': '박재된 재규어',
      'zh': '美洲豹标本',
      'ja': 'Stuffed Jaguar',
    }, {
      'id': 'StuffedTurkeyItem',
      'en': 'Stuffed Turkey',
      'fr': 'Dinde farcie',
      'es': 'Pavo Relleno',
      'de': 'Gefüllter Truthahn',
      'pl': 'Indyk faszerowany',
      'ru': 'Фаршированная индейка',
      'uk': 'Фарширована індичка',
      'ko': '속을 채운 칠면조',
      'zh': '填馅火鸡',
      'ja': '七面鳥の丸焼き',
    }, {
      'id': 'StuffedWolfItem',
      'en': 'Stuffed Wolf',
      'fr': 'Loup empaillé',
      'es': 'Lobo disecado',
      'de': 'Ausgestopfter Wolf',
      'pl': 'Wypchany wilk',
      'ru': 'Чучело волка',
      'uk': 'Опудало вовка',
      'ko': '박제된 늑대',
      'zh': '狼标本',
      'ja': 'Stuffed Wolf',
    }, {
      'id': 'SubstrateItem',
      'en': 'Substrate',
      'fr': 'Substrat',
      'es': 'Oblea',
      'de': 'Substrat',
      'pl': 'Płytka podkładowa',
      'ru': 'Подложка',
      'uk': 'Підкладка',
      'ko': '기판',
      'zh': '基底',
      'ja': '基板',
    }, {
      'id': 'SugarItem',
      'en': 'Sugar',
      'fr': 'Sucre',
      'es': 'Azúcar',
      'de': 'Zucker',
      'pl': 'Cukier',
      'ru': 'Сахар',
      'uk': 'Цукор',
      'ko': '설탕',
      'zh': '糖',
      'ja': '砂糖',
    }, {
      'id': 'SugarcaneItem',
      'en': 'Sugarcane',
      'fr': 'Canne à sucre',
      'es': 'Caña de Azúcar',
      'de': 'Zuckerrohr',
      'pl': 'Trzcina Cukrowa',
      'ru': 'Сахарный тростник',
      'uk': 'Цукрова тростина',
      'ko': '사탕수수',
      'zh': '甘蔗',
      'ja': 'サトウキビ',
    }, {
      'id': 'SunCheeseItem',
      'en': 'Sun Cheese',
      'fr': 'Fromage de tournesol',
      'es': 'Queso solar',
      'de': 'Sonnenblumenkäse',
      'pl': 'Sun Cheese',
      'ru': 'Сыр из семечек подсолнуха',
      'uk': 'Sun Cheese',
      'ko': 'Sun Cheese',
      'zh': '向日葵奶酪',
      'ja': 'Sun Cheese',
    }, {
      'id': 'SunflowerItem',
      'en': 'Sunflower Item',
      'fr': 'Article Tournesol',
      'es': 'Artículo de girasol',
      'de': 'Artikel Sonnenblume',
      'pl': 'Słonecznik!',
      'ru': 'Подсолнечник Пункт',
      'uk': 'Соняшник Пункт',
      'ko': '해바라기 아이템',
      'zh': '向日葵项目',
      'ja': 'ひまわりアイテム'
    }, {
      'id': 'SunflowerSeedItem',
      'en': 'Sunflower Seed',
      'fr': 'Graine de tournesol',
      'es': 'Semilla de girasol',
      'de': 'Samen (Sonnenblume)',
      'pl': 'Nasiona słonecznika',
      'ru': 'Семечко подсолнечника',
      'uk': 'Насіння соняшника',
      'ko': '해바라기 씨앗',
      'zh': '向日葵种子',
      'ja': 'ひまわりの種',
    }, {
      'id': 'SweetSaladItem',
      'en': 'Sweet Salad',
      'fr': 'Salade douce',
      'es': 'Ensalada Dulce',
      'de': 'Süßer Salat',
      'pl': 'Słodka sałatka',
      'ru': 'Сладкий салат',
      'uk': 'Солодкий салат',
      'ko': '달콤한 샐러드',
      'zh': '甜沙拉',
      'ja': 'スウィートサラダ',
    }, {
      'id': 'SyntheticRubberItem',
      'en': 'Synthetic Rubber',
      'fr': 'Caoutchouc synthétique',
      'es': 'Caucho Sintético',
      'de': 'Synthetischer Gummi',
      'pl': 'Kauczuk Syntetyczny',
      'ru': 'Синтетическая резина',
      'uk': 'Синтетична гума',
      'ko': '합성 고무',
      'zh': '合成橡胶',
      'ja': '合成ゴム',
    }, {
      'id': 'TableItem',
      'en': 'Table',
      'fr': 'Table',
      'es': 'Mesa',
      'de': 'Tisch',
      'pl': 'Stół',
      'ru': 'Стол',
      'uk': 'Стіл',
      'ko': '탁자',
      'zh': 'Tisch',
      'ja': 'テーブル',
    }, {
      'id': 'TailingsItem',
      'en': 'Tailings',
      'fr': 'Résidus',
      'es': 'Relaves',
      'de': 'Giftige Schlacke',
      'pl': 'Odpady hutnicze',
      'ru': 'Хвосты',
      'uk': 'Шлак',
      'ko': '광재',
      'zh': '残渣',
      'ja': '選鉱くず',
    }, {
      'id': 'TailorBowlerHatItem',
      'en': 'Tailor Bowler Hat',
      'fr': 'Chapeau melon de tailleur',
      'es': 'Bombín de sastre',
      'de': 'Schneidermelone',
      'pl': 'Tailor Bowler Hat',
      'ru': 'Шляпа-котелок Портного',
      'uk': 'Tailor Bowler Hat',
      'ko': '재단사 중산모',
      'zh': '裁缝的圆顶礼帽',
      'ja': 'Tailor Bowler Hat',
    }, {
      'id': 'TailorPantsItem',
      'en': 'Tailor Pants',
      'fr': 'Pantalon de tailleur',
      'es': 'Pantalones de sastre',
      'de': 'Schneiderhose',
      'pl': 'Tailor Pants',
      'ru': 'Штаны Портного',
      'uk': 'Tailor Pants',
      'ko': '재단사 바지',
      'zh': '裁缝的裤子',
      'ja': 'Tailor Pants',
    }, {
      'id': 'TailorShirtItem',
      'en': 'Tailor Shirt',
      'fr': 'Chemise de tailleur',
      'es': 'Camisa de sastre',
      'de': 'Schneiderhemd',
      'pl': 'Tailor Shirt',
      'ru': 'Рубашка Портного',
      'uk': 'Tailor Shirt',
      'ko': '재단사 셔츠',
      'zh': '裁缝的衬衫',
      'ja': 'Tailor Shirt',
    }, {
      'id': 'TailorShoesItem',
      'en': 'Tailor Shoes',
      'fr': 'Chaussures de tailleur',
      'es': 'Zapatos de sastre',
      'de': 'Schneiderschuhe',
      'pl': 'Tailor Shoes',
      'ru': 'Ботинки Портного',
      'uk': 'Tailor Shoes',
      'ko': '재단사 신발',
      'zh': '裁缝的鞋子',
      'ja': 'Tailor Shoes',
    }, {
      'id': 'TailoringBasicUpgradeItem',
      'en': 'Tailoring Basic Upgrade',
      'fr': 'Amélioration Basique : Couture',
      'es': 'Mejora básica: Sastrería',
      'de': 'Grundlegendes Upgrade: Schneidern',
      'pl': 'Podstawowe ulepszenie Krawiectwa',
      'ru': 'Обычное улучшение для портняжного дела',
      'uk': 'Tailoring Basic Upgrade',
      'ko': '기초 재단 기술 업그레이드',
      'zh': '裁缝基础升级',
      'ja': 'Tailoring Basic Upgrade',
    }, {
      'id': 'TailoringModernUpgradeItem',
      'en': 'Tailoring Modern Upgrade',
      'fr': 'Amélioration Moderne : Couture',
      'es': 'Mejora moderna: Sastrería',
      'de': 'Modernes Upgrade: Schneidern',
      'pl': 'Tailoring Modern Upgrade',
      'ru': 'Современное улучшение для портняжного дела',
      'uk': 'Tailoring Modern Upgrade',
      'ko': '현대적인 업그레이드 조정',
      'zh': '裁缝现代化升级',
      'ja': 'Tailoring Modern Upgrade',
    }, {
      'id': 'TailoringTableItem',
      'en': 'Tailoring Table',
      'fr': 'Atelier de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stacja Krawiecka',
      'ru': 'Стол портного',
      'uk': 'Кравецький стіл',
      'ko': '재단 작업대',
      'zh': '裁缝工作台',
      'ja': '裁縫作業台',
    }, {
      'id': 'TallBootsItem',
      'en': 'Tall Boots',
      'fr': 'Bottes hautes',
      'es': 'Botas altas',
      'de': 'Hohe Stiefel',
      'pl': 'Wysokie Buty',
      'ru': 'Сапоги',
      'uk': 'Високі чоботи',
      'ko': '롱부츠',
      'zh': '高筒靴',
      'ja': 'トールブーツ',
    }, {
      'id': 'TallowItem',
      'en': 'Tallow',
      'fr': 'Suif',
      'es': 'Sebo',
      'de': 'Talg',
      'pl': 'Łój',
      'ru': 'Сало',
      'uk': 'Сало',
      'ko': '동물성 수지',
      'zh': '脂油',
      'ja': '獣脂',
    }, {
      'id': 'TallowCandleItem',
      'en': 'Tallow Candle',
      'fr': 'Bougie en suif',
      'es': 'Vela de sebo',
      'de': 'Talgkerze',
      'pl': 'Świeca łojowa',
      'ru': 'Сальная свеча',
      'uk': 'Сальна свічка',
      'ko': '수지 양초',
      'zh': '油脂蜡烛',
      'ja': '獣脂ろうそく',
    }, {
      'id': 'TallowLampItem',
      'en': 'Tallow Lamp',
      'fr': 'Lampe à suif',
      'es': 'Lámpara de Sebo',
      'de': 'Talglampe',
      'pl': 'Lampa łojowa',
      'ru': 'Сальная лампа',
      'uk': 'Сальний світильник',
      'ko': '수지 램프',
      'zh': '油脂灯',
      'ja': '獣脂ランプ',
    }, {
      'id': 'TallowWallLampItem',
      'en': 'Tallow Wall Lamp',
      'fr': 'Lampe à suif murale',
      'es': 'Lámpara de Pared de Sebo',
      'de': 'Talgwandlampe',
      'pl': 'Ścienna Lampa Łojowa',
      'ru': 'Настенная сальная лампа',
      'uk': 'Сальний настінний світильник',
      'ko': '벽걸이형 수지 램프',
      'zh': '油脂壁灯',
      'ja': '壁掛け獣脂ろうそく',
    }, {
      'id': 'TaroFriesItem',
      'en': 'Taro Fries',
      'fr': 'Frites de taro',
      'es': 'Patatas fritas de taro',
      'de': 'Taro-Fritten',
      'pl': 'Taro Fries',
      'ru': 'Таро Фри',
      'uk': 'Taro Fries',
      'ko': 'Taro Fries',
      'zh': '芋头炸薯条',
      'ja': 'Taro Fries',
    }, {
      'id': 'TaroRootItem',
      'en': 'Taro Root',
      'fr': 'Racine de taro',
      'es': 'Raíz de taro',
      'de': 'Tarowurzel',
      'pl': 'Korzeń kolokazji',
      'ru': 'Корень таро',
      'uk': 'Корінь таро',
      'ko': '토란 뿌리',
      'zh': '芋头根',
      'ja': 'タロイモの根',
    }, {
      'id': 'TaroSeedItem',
      'en': 'Taro Seed',
      'fr': 'Graine de taro',
      'es': 'Semilla de taro',
      'de': 'Samen (Taro)',
      'pl': 'Nasiona kolokazji',
      'ru': 'Семечко таро',
      'uk': 'Насіння таро',
      'ko': '토란 씨앗',
      'zh': '芋头籽',
      'ja': 'タロイモの種',
    }, {
      'id': 'TastyTropicalPizzaItem',
      'en': 'Tasty Tropical Pizza',
      'fr': 'Pizza tropicale savoureuse',
      'es': 'Pizza tropical',
      'de': 'Pizza Tropica',
      'pl': 'Pyszna pizza tropikalna',
      'ru': 'Вкусная Тропическая Пицца',
      'uk': 'Tasty Tropical Pizza',
      'ko': 'Tasty Tropical Pizza',
      'zh': '可口热带比萨',
      'ja': 'Tasty Tropical Pizza',
    }, {
      'id': 'TinyCarcass',
      'en': 'Tiny Carcass',
      'fr': 'Minuscule cadavre',
      'es': 'Cadáver minúsculo',
      'de': 'Winziger Kadaver',
      'pl': 'Tiny Carcass',
      'ru': 'Крошечная Туша',
      'uk': 'Крихітна туша',
      'ko': '칠면조 사체',
      'zh': '微型遗骸',
      'ja': 'Tiny Carcass',
    }, {
      'id': 'TinyFurCarcass',
      'en': 'Tiny Fur Carcass',
      'fr': 'Minuscule cadavre à fourrure',
      'es': 'Cadáver minúsculo con piel',
      'de': 'Winziger Fellkadaver',
      'pl': 'Tiny Fur Carcass',
      'ru': 'Крошечная Меховая Туша',
      'uk': 'Крихітна шерстяна туша',
      'ko': '칠면조 사체',
      'zh': '微型毛皮遗骸',
      'ja': 'Tiny Fur Carcass',
    }, {
      'id': 'TinyLeatherCarcass',
      'en': 'Tiny Leather Carcass',
      'fr': 'Minuscule cadavre à cuir',
      'es': 'Cadáver minúsculo con cuero',
      'de': 'Winziger Lederkadaver',
      'pl': 'Tiny Leather Carcass',
      'ru': 'Крошечная Кожаная Туша',
      'uk': 'Крихітна шкіряна туша',
      'ko': '작은 가죽 시체',
      'zh': '微型皮革遗骸',
      'ja': 'Tiny Leather Carcass',
    }, {
      'id': 'TinyStockpileItem',
      'en': 'Tiny Stockpile',
      'fr': 'Réserve minuscule',
      'es': 'Pila de almacenamiento diminuta',
      'de': 'Lager (Winzig)',
      'pl': 'Mały skład',
      'ru': 'Крошечный склад',
      'uk': 'Крихітна комора',
      'ko': '초소형 자재 창고',
      'zh': '微型料堆',
      'ja': 'ごく小さな倉庫',
    }, {
      'id': 'ToiletItem',
      'en': 'Toilet',
      'fr': 'Toilette',
      'es': 'Baño',
      'de': 'Toilette',
      'pl': 'Toaleta',
      'ru': 'Туалет',
      'uk': 'Туалет',
      'ko': '화장실',
      'zh': '厕所',
      'ja': 'Toilet',
    }, {
      'id': 'TomatoItem',
      'en': 'Tomato',
      'fr': 'Tomate',
      'es': 'Tomate',
      'de': 'Tomate',
      'pl': 'Pomidor',
      'ru': 'Помидор',
      'uk': 'Помідор',
      'ko': '토마토',
      'zh': '番茄',
      'ja': 'トマト',
    }, {
      'id': 'TomatoSeedItem',
      'en': 'Tomato Seed',
      'fr': 'Graine de tomate',
      'es': 'Semilla de tomate',
      'de': 'Samen (Tomaten)',
      'pl': 'Nasiona Pomidora',
      'ru': 'Семечко помидора',
      'uk': 'Насіння помідору',
      'ko': '토마토 씨앗',
      'zh': '番茄种子',
      'ja': 'トマトの種',
    }, {
      'id': 'Tool',
      'en': 'Tool',
      'fr': 'Outil',
      'es': 'Herramienta',
      'de': 'Werkzeug',
      'pl': 'Narzędzie',
      'ru': 'Инструмент',
      'uk': 'Інструмент',
      'ko': '도구',
      'zh': '工具',
      'ja': 'ツール',
    }, {
      'id': 'ToolBenchItem',
      'en': 'Tool Bench',
      'fr': 'Établi d\u0027outillage',
      'es': 'Mesa de herramientas',
      'de': 'Werkzeugtisch',
      'pl': 'Stół narzędziowy',
      'ru': 'Стол для инструментов',
      'uk': 'Стіл для інструментів',
      'ko': '도구 작업대',
      'zh': '工具台',
      'ja': 'Tool Bench',
    }, {
      'id': 'ToppedPorridgeItem',
      'en': 'Topped Porridge',
      'fr': 'Porridge garni',
      'es': 'Gachas con fruta',
      'de': 'Verfeinertes Porridge',
      'pl': 'Polana owsianka',
      'ru': 'Каша с добавками',
      'uk': 'Каша з добавками',
      'ko': '뭔가 추가된 죽',
      'zh': '稀饭',
      'ja': 'Topped Porridge',
    }, {
      'id': 'TorchItem',
      'en': 'Torch',
      'fr': 'Torche',
      'es': 'Antorcha',
      'de': 'Fackel',
      'pl': 'Pochodnia',
      'ru': 'Факел',
      'uk': 'Факел',
      'ko': '횃불',
      'zh': '火把',
      'ja': '松明',
    }, {
      'id': 'TorchStandItem',
      'en': 'Torch Stand',
      'fr': 'Support de torche',
      'es': 'Soporte de antorcha',
      'de': 'Fackelhalter',
      'pl': 'Stojak na pochodnię',
      'ru': 'Стойка для факела',
      'uk': 'Факельна стійка',
      'ko': '횃불 받침대',
      'zh': '火把架',
      'ja': '松明スタンド',
    }, {
      'id': 'TortillaItem',
      'en': 'Tortilla',
      'fr': 'Tortilla',
      'es': 'Tortilla',
      'de': 'Tortilla',
      'pl': 'Tortilla',
      'ru': 'Тортилья',
      'uk': 'Тортилья',
      'ko': '또띠아',
      'zh': '玉米饼',
      'ja': 'トルティーヤ',
    }, {
      'id': 'TowelRackItem',
      'en': 'Towel Rack',
      'fr': 'Porte-serviettes',
      'es': 'Colgador de toalla',
      'de': 'Handtuchständer',
      'pl': 'Towel Rack',
      'ru': 'Вешалка для полотенец',
      'uk': 'Towel Rack',
      'ko': 'Towel Rack',
      'zh': '毛巾架',
      'ja': 'Towel Rack',
    }, {
      'id': 'TransglutaminaseItem',
      'en': 'Transglutaminase',
      'fr': 'Transglutaminase',
      'es': 'Transglutaminasa',
      'de': 'Transglutaminase',
      'pl': 'Transglutaminaza',
      'ru': 'Трансглютаминаза',
      'uk': 'Трансглютаміназа',
      'ko': '글루타미나제',
      'zh': '转谷氨酰胺酶',
      'ja': 'トランスグルタミナーゼ',
    }, {
      'id': 'TransmissionPoleItem',
      'en': 'Transmission Pole',
      'fr': 'Poteau de transmission',
      'es': 'Poste de Transmisión',
      'de': 'Übertragungsmast',
      'pl': 'Słup elektryczny',
      'ru': 'Опора линии электропередач',
      'uk': 'Опора ЛЕП',
      'ko': '전봇대',
      'zh': '传动杆',
      'ja': '電柱',
    }, {
      'id': 'TreasuryItem',
      'en': 'Treasury',
      'fr': 'Trésor public',
      'es': 'Tesorería',
      'de': 'Steuertresor',
      'pl': 'Skarbiec',
      'ru': 'Казна',
      'uk': 'Скарбниця',
      'ko': '정부 금고',
      'zh': '金库',
      'ja': '金庫',
    }, {
      'id': 'TreeDebrisItem',
      'en': 'Tree Debris',
      'fr': 'Débris d\u0027arbre',
      'es': 'Restos de árboles',
      'de': 'Baumrückstände',
      'pl': 'Pozostałości Drzewa',
      'ru': 'Обломки дерева',
      'uk': 'Залишки дерев',
      'ko': '나무 파편',
      'zh': '树木残枝',
      'ja': '木くず',
    }, {
      'id': 'TrilliumSeedItem',
      'en': 'Trillium Seed',
      'fr': 'Graine de trillium',
      'es': 'Semilla de trilio',
      'de': 'Waldliliensamen',
      'pl': 'Materiał siewny Trillium',
      'ru': 'Семечко триллиума',
      'uk': 'Насіння трилуму',
      'ko': '연령초 씨앗',
      'zh': '延龄草种子',
      'ja': 'トリリウムの種子',
    }, {
      'id': 'TrousersItem',
      'en': 'Trousers',
      'fr': 'Pantalon',
      'es': 'Pantalones',
      'de': 'Hosen',
      'pl': 'Spodnie',
      'ru': 'Брюки',
      'uk': 'Брюки',
      'ko': '바지',
      'zh': '裤子',
      'ja': 'ズボン',
    }, {
      'id': 'TroutItem',
      'en': 'Trout',
      'fr': 'Truite',
      'es': 'Trucha',
      'de': 'Forelle',
      'pl': 'Pstrąg',
      'ru': 'Форель',
      'uk': 'Форель',
      'ko': '송어',
      'zh': '鳟鱼',
      'ja': 'マス',
    }, {
      'id': 'TruckItem',
      'en': 'Truck',
      'fr': 'Camion',
      'es': 'Camión',
      'de': 'LKW',
      'pl': 'Ciężarówka',
      'ru': 'Грузовик',
      'uk': 'Вантажівка',
      'ko': '트럭',
      'zh': '卡车',
      'ja': 'トラック',
    }, {
      'id': 'TunaItem',
      'en': 'Tuna',
      'fr': 'Thon',
      'es': 'Atún',
      'de': 'Thunfisch',
      'pl': 'Tuńczyk',
      'ru': 'Тунец',
      'uk': 'Тунець',
      'ko': '참치',
      'zh': '金枪鱼',
      'ja': 'マグロ',
    }, {
      'id': 'TurkeyCarcassItem',
      'en': 'Turkey Carcass',
      'fr': 'Cadavre de dinde',
      'es': 'Cadáver de pavo',
      'de': 'Truthahnkadaver',
      'pl': 'Padlina indyka',
      'ru': 'Туша индейки',
      'uk': 'Туша індички',
      'ko': '칠면조 사체',
      'zh': '火鸡遗骸',
      'ja': '七面鳥の死体',
    }, {
      'id': 'Upgrade',
      'en': 'Upgrade',
      'fr': 'Amélioration',
      'es': 'Mejora',
      'de': 'Upgrade',
      'pl': 'Ulepszenie',
      'ru': 'Улучшение',
      'uk': 'Покращення',
      'ko': '업그레이드',
      'zh': '升级',
      'ja': 'Upgrade',
    }, {
      'id': 'UpholsteredChairItem',
      'en': 'Upholstered Chair',
      'fr': 'Fauteuil rembourré',
      'es': 'Silla tapizada',
      'de': 'Gepolsteter Stuhl',
      'pl': 'Upholstered Chair',
      'ru': 'Стул с обивкой',
      'uk': 'Upholstered Chair',
      'ko': '푹신한 의자',
      'zh': '铺软垫的椅子',
      'ja': 'Upholstered Chair',
    }, {
      'id': 'UpholsteredCouchItem',
      'en': 'Upholstered Couch',
      'fr': 'Canapé rembourré',
      'es': 'Sofá tapizado',
      'de': 'Gepolsterte Couch',
      'pl': 'Upholstered Couch',
      'ru': 'Диван с обивкой',
      'uk': 'Upholstered Couch',
      'ko': '푹신한 소파',
      'zh': '铺软垫的沙发',
      'ja': 'Upholstered Couch',
    }, {
      'id': 'UrchinItem',
      'en': 'Urchin',
      'fr': 'Oursin',
      'es': 'Erizo',
      'de': 'Seeigel',
      'pl': 'Jeżowiec',
      'ru': 'Морской ёж',
      'uk': 'Морський їжак',
      'ko': '성게',
      'zh': '海胆',
      'ja': 'ウニ',
    }, {
      'id': 'ValveItem',
      'en': 'Valve',
      'fr': 'Soupape',
      'es': 'Válvula',
      'de': 'Ventil',
      'pl': 'Zawór',
      'ru': 'Клапан',
      'uk': 'Вентиль',
      'ko': '밸브',
      'zh': '阀门',
      'ja': 'Zawór',
    }, {
      'id': 'Vegetable',
      'en': 'Vegetable',
      'fr': 'Légumes',
      'es': 'Vegetales',
      'de': 'Gemüse',
      'pl': 'Warzywo',
      'ru': 'Растительность',
      'uk': 'Овочі',
      'ko': '야채',
      'zh': '蔬菜',
      'ja': 'Vegetable',
    }, {
      'id': 'VegetableMedleyItem',
      'en': 'Vegetable Medley',
      'fr': 'Mélange de légumes',
      'es': 'Popurrí de Verduras',
      'de': 'Gemüsesalat',
      'pl': 'Mieszanka warzywna',
      'ru': 'Овощная смесь',
      'uk': 'Овочева суміш',
      'ko': '야채 모듬',
      'zh': '蔬菜拼盘',
      'ja': '野菜の盛り合わせ',
    }, {
      'id': 'VegetableSoupItem',
      'en': 'Vegetable Soup',
      'fr': 'Soupe de légumes',
      'es': 'Sopa de Verduras',
      'de': 'Suppe mit Gemüse',
      'pl': 'Zupa jarzynowa',
      'ru': 'Овощной суп',
      'uk': 'Овочевий суп',
      'ko': '야채 스프',
      'zh': '蔬菜汤',
      'ja': '野菜スープ',
    }, {
      'id': 'VegetableStockItem',
      'en': 'Vegetable Stock',
      'fr': 'Bouillon de légumes',
      'es': 'Caldo de Verduras',
      'de': 'Brühe aus Gemüse',
      'pl': 'Bulion warzywny',
      'ru': 'Овощной бульон',
      'uk': 'Овочевий бульйон',
      'ko': '야채 육수',
      'zh': '蔬菜汤料',
      'ja': '野菜の煮汁',
    }, {
      'id': 'Vehicles',
      'en': 'Vehicles',
      'fr': 'Véhicules',
      'es': 'Vehículos',
      'de': 'Fahrzeuge',
      'pl': 'Vehicles',
      'ru': 'Техника',
      'uk': 'Транспортні засоби',
      'ko': '운송수단',
      'zh': '车辆',
      'ja': '乗り物',
    }, {
      'id': 'WainwrightTableItem',
      'en': 'Wainwright Table',
      'fr': 'Établi d\u0027ingénierie routière',
      'es': 'Mesa de carretero',
      'de': 'Wagenmachertisch',
      'pl': 'Stół Powoźniczy',
      'ru': 'Верстак колесника',
      'uk': 'Стіл стельмаха',
      'ko': '짐수레 작업대',
      'zh': '车匠工作台',
      'ja': '荷車作業台',
    }, {
      'id': 'WallCandleItem',
      'en': 'Wall Candle',
      'fr': 'Bougie murale',
      'es': 'Vela de Pared',
      'de': 'Wandkerze',
      'pl': 'Świeca ścienna',
      'ru': 'Настенная свеча',
      'uk': 'Настінна свічка',
      'ko': '벽걸이형 촛불',
      'zh': '挂壁烛灯',
      'ja': '壁掛けろうそく',
    }, {
      'id': 'WashboardItem',
      'en': 'Washboard',
      'fr': 'Planche à laver',
      'es': 'Lavadero',
      'de': 'Waschbrett',
      'pl': 'Tara',
      'ru': 'Стиральная доска',
      'uk': 'Пральна дошка',
      'ko': '빨래판',
      'zh': '搓衣板',
      'ja': '洗濯板',
    }, {
      'id': 'WashingMachineItem',
      'en': 'Washing Machine',
      'fr': 'Machine à laver',
      'es': 'Lavadora',
      'de': 'Waschmaschine',
      'pl': 'Pralka',
      'ru': 'Стиральная машина',
      'uk': 'Пральна машина',
      'ko': '세탁기',
      'zh': '洗衣机',
      'ja': '洗濯機',
    }, {
      'id': 'WasteFilterItem',
      'en': 'Waste Filter',
      'fr': 'Filtre à déchets',
      'es': 'Filtro de Residuos',
      'de': 'Wasserfilter',
      'pl': 'Filtr Odpadów',
      'ru': 'Сточный фильтр',
      'uk': 'Фільтр відходів',
      'ko': '폐수 여과장치',
      'zh': '废物过滤器',
      'ja': '廃棄物フィルター',
    }, {
      'id': 'WaterweedSeedItem',
      'en': 'Waterweed Seed',
      'fr': 'Graine d\u0027élodée',
      'es': 'Semilla de Alga',
      'de': 'Samen (Wasserpest)',
      'pl': 'Nasiona Moczarki',
      'ru': 'Семечко элодеи',
      'uk': 'Насіння елодеї',
      'ko': '수초 씨앗',
      'zh': '伊乐藻种子',
      'ja': '水草の種',
    }, {
      'id': 'WaterwheelItem',
      'en': 'Waterwheel',
      'fr': 'Moulin à eau',
      'es': 'Molino de agua',
      'de': 'Wasserrad',
      'pl': 'Koło Wodne',
      'ru': 'Водяное колесо',
      'uk': 'Водяне колесо',
      'ko': '물레방아',
      'zh': '水车',
      'ja': '水車',
    }, {
      'id': 'WetTailingsItem',
      'en': 'Wet Tailings',
      'fr': 'Résidus Humides',
      'es': 'Relaves húmedos',
      'de': 'Giftiger Schlamm',
      'pl': 'Mokre Odpadki',
      'ru': 'Сырые хвосты',
      'uk': 'Сирі хвости',
      'ko': '축축한 광재',
      'zh': '湿尾矿',
      'ja': 'Wet Tailings',
    }, {
      'id': 'WheatItem',
      'en': 'Wheat',
      'fr': 'Blé',
      'es': 'Trigo',
      'de': 'Weizen',
      'pl': 'Pszenica',
      'ru': 'Пшеница',
      'uk': 'Пшениця',
      'ko': '밀',
      'zh': '小麦',
      'ja': '小麦',
    }, {
      'id': 'WheatSeedItem',
      'en': 'Wheat Seed',
      'fr': 'Graine de blé',
      'es': 'Semilla de Trigo',
      'de': 'Samen (Weizen)',
      'pl': 'Nasiona Pszenicy',
      'ru': 'Семечко пшеницы',
      'uk': 'Насіння пшениці',
      'ko': '밀 씨앗',
      'zh': '小麦种子',
      'ja': '小麦の種',
    }, {
      'id': 'WheelbarrowItem',
      'en': 'Wheelbarrow',
      'fr': 'Brouette',
      'es': 'Carretilla',
      'de': 'Schubkarre',
      'pl': 'Taczka',
      'ru': 'Тачка',
      'uk': 'Візок',
      'ko': '외바퀴 손수레',
      'zh': '独轮手推车',
      'ja': '手押し車',
    }, {
      'id': 'WhiteBursageSeedItem',
      'en': 'White Bursage Seed',
      'fr': 'Graine de bursage blanc',
      'es': 'Semilla de ambrosía',
      'de': 'Samen (Traubenkraut)',
      'pl': 'Nasiona Ambrozji dumosa',
      'ru': 'Семечко амброзии кустарниковой',
      'uk': 'Насіння амброзії кущової',
      'ko': '하얀 버세지 씨앗',
      'zh': '白豚草种子',
      'ja': 'White Bursage Seed',
    }, {
      'id': 'WildMixItem',
      'en': 'Wild Mix',
      'fr': 'Mélange sauvage',
      'es': 'Mezcla Silvestre',
      'de': 'Wildsalat',
      'pl': 'Dzika mieszanka',
      'ru': 'Смесь диких растений',
      'uk': 'Суміш диких трав',
      'ko': '야채 샐러드',
      'zh': '蔬菜捞',
      'ja': 'ワイルドミックス',
    }, {
      'id': 'WildStewItem',
      'en': 'Wild Stew',
      'fr': 'Ragoût sauvage',
      'es': 'Estofado silvestre',
      'de': 'Lagerfeuer Waldeintopf',
      'pl': 'Gulasz z dziczyzny',
      'ru': 'Рагу из диких растений',
      'uk': 'Рагу з диких трав',
      'ko': '야생 스튜',
      'zh': '蔬菜炖',
      'ja': 'ワイルドシチュー',
    }, {
      'id': 'WiltedFiddleheadsItem',
      'en': 'Wilted Fiddleheads',
      'fr': 'Crosses de fougère flétries',
      'es': 'Brotes de helecho marchitos',
      'de': 'Farnspitzen getrocknet',
      'pl': 'Blanszowane pędy paproci',
      'ru': 'Увядшие побеги папоротника',
      'uk': 'Зів’яла папороть',
      'ko': '살짝 익힌 고사리',
      'zh': '蕨菜干',
      'ja': 'しおれたシダ',
    }, {
      'id': 'WindTurbineItem',
      'en': 'Wind Turbine',
      'fr': 'Éolienne',
      'es': 'Turbina Eólica',
      'de': 'Windrad',
      'pl': 'Turbina powietrzna',
      'ru': 'Ветряная турбина',
      'uk': 'Вітрова турбіна',
      'ko': '풍력 발전기',
      'zh': '风力涡轮机',
      'ja': '風力タービン',
    }, {
      'id': 'WindmillItem',
      'en': 'Windmill',
      'fr': 'Moulin à vent',
      'es': 'Molino',
      'de': 'Windmühle',
      'pl': 'Wiatrak',
      'ru': 'Ветряная мельница',
      'uk': 'Вітряк',
      'ko': '풍차',
      'zh': '风车',
      'ja': '風車',
    }, {
      'id': 'WolfCarcassItem',
      'en': 'Wolf Carcass',
      'fr': 'Cadavre de loup',
      'es': 'Cadáver de lobo',
      'de': 'Wolfkadaver',
      'pl': 'Padlina wilka',
      'ru': 'Туша волка',
      'uk': 'Туша вовка',
      'ko': '늑대 사체',
      'zh': '狼遗骸',
      'ja': 'オオカミの死体',
    }, {
      'id': 'Wood',
      'en': 'Wood',
      'fr': 'Bois',
      'es': 'Madera',
      'de': 'Holz',
      'pl': 'Drewno',
      'ru': 'Дерево',
      'uk': 'Деревина',
      'ko': '나무',
      'zh': '木',
      'ja': '木材',
    }, {
      'id': 'WoodCartItem',
      'en': 'Wood Cart',
      'fr': 'Chariot en bois',
      'es': 'Carro de Madera',
      'de': 'Großer Holzkarren',
      'pl': 'Drewniany wózek',
      'ru': 'Деревянная тележка',
      'uk': 'Дерев’яний віз',
      'ko': '목재 수레',
      'zh': '木质拖车',
      'ja': '木製カート',
    }, {
      'id': 'WoodPulpItem',
      'en': 'Wood Pulp',
      'fr': 'Copeaux de bois',
      'es': 'Pulpa de madera',
      'de': 'Holzspan',
      'pl': 'Ścier drzewny',
      'ru': 'Древесная масса',
      'uk': 'Деревина',
      'ko': '목재 펄프',
      'zh': '木浆',
      'ja': '小枝',
    }, {
      'id': 'WoodSignItem',
      'en': 'Wood Sign',
      'fr': 'Panneau en bois',
      'es': 'Letrero de Madera',
      'de': 'Schild aus Holz',
      'pl': 'Drewniana Tablica',
      'ru': 'Деревянная табличка',
      'uk': 'Дерев’яний знак',
      'ko': '목재 간판',
      'zh': '木质标志',
      'ja': '木製の看板',
    }, {
      'id': 'WoodenBowItem',
      'en': 'Wooden Bow',
      'fr': 'Arc en bois',
      'es': 'Arco de madera',
      'de': 'Holzbogen',
      'pl': 'Drewniany łuk',
      'ru': 'Деревянный лук',
      'uk': 'Дерев\u0027яний лук',
      'ko': '목재 활',
      'zh': '木弓',
      'ja': 'Wooden Bow',
    }, {
      'id': 'WoodenCeilingLightItem',
      'en': 'Wooden Ceiling Light',
      'fr': 'Plafonnier en bois',
      'es': 'Lámpara de techo de madera',
      'de': 'Hölzerne Deckenlampe',
      'pl': 'Drewniane oświetlenie sufitowe',
      'ru': 'Деревянный потолочный светильник',
      'uk': 'Дерев’яна люстра',
      'ko': '목재 천장등',
      'zh': '木制顶棚灯',
      'ja': '木製の天井ライト',
    }, {
      'id': 'WoodenElevatorItem',
      'en': 'Wooden Elevator',
      'fr': 'Ascenseur en bois',
      'es': 'Ascensor de Madera',
      'de': 'Hölzerner Aufzug',
      'pl': 'Winda drewniana',
      'ru': 'Деревянный лифт',
      'uk': 'Дерев’яний ліфт',
      'ko': '목재 엘리베이터',
      'zh': '木制升降机',
      'ja': '木製エレベーター',
    }, {
      'id': 'WoodenElevatorCallPostItem',
      'en': 'Wooden Elevator Call Post',
      'fr': 'Poste d\u0027appel pour ascenseur en bois',
      'es': 'Poste de llamada del Elevador',
      'de': 'Holzaufzug-Rufposten',
      'pl': 'Drewniany wzywacz windy',
      'ru': 'Выносной пульт деревянного лифта',
      'uk': 'Пульт виклику дерев’яного ліфта',
      'ko': '목재 엘리베이터 호출대',
      'zh': '木质电梯呼叫站',
      'ja': '木製エレベーター呼び出しポスト',
    }, {
      'id': 'WoodenFabricBedItem',
      'en': 'Wooden Fabric Bed',
      'fr': 'Lit confortable en bois',
      'es': 'Cama de madera y tela',
      'de': 'Hölzernes Stoffbett',
      'pl': 'Drewniane łóżko z materacem',
      'ru': 'Деревянная кровать с матрасом',
      'uk': 'Дерев’яне ліжко з матрацем',
      'ko': '목재 천 침대',
      'zh': '木质布料床',
      'ja': '木製の布ベッド',
    }, {
      'id': 'WoodenFloorLampItem',
      'en': 'Wooden Floor Lamp',
      'fr': 'Lampe sur pied en bois',
      'es': 'Lámpara de suelo de madera',
      'de': 'Hölzerne Stehlampe',
      'pl': 'Drewniana lampa podłogowa',
      'ru': 'Деревянный торшер',
      'uk': 'Дерев’яний торшер',
      'ko': '목재 스탠드형 전등',
      'zh': '木制落地灯',
      'ja': '木製の室内灯',
    }, {
      'id': 'WoodenHoeItem',
      'en': 'Wooden Hoe',
      'fr': 'Binette en bois',
      'es': 'Azada de Madera',
      'de': 'Holzhacke',
      'pl': 'Drewniana motyka',
      'ru': 'Деревянная тяпка',
      'uk': 'Дерев’яна мотика',
      'ko': '나무 괭이',
      'zh': '木锄',
      'ja': '木のクワ',
    }, {
      'id': 'WoodenKitchenLampItem',
      'en': 'Wooden Kitchen Lamp',
      'fr': 'Lustre de cuisine en bois',
      'es': 'Lámpara de cocina (madera)',
      'de': 'Hölzerne Küchenlampe',
      'pl': 'Wooden Kitchen Lamp',
      'ru': 'Деревянная кухонная лампа',
      'uk': 'Дерев\u0027яна кухонна лампа',
      'ko': 'Wooden Kitchen Lamp',
      'zh': '木制厨房灯',
      'ja': 'Wooden Kitchen Lamp',
    }, {
      'id': 'WoodenLatrineItem',
      'en': 'Wooden Latrine',
      'fr': 'Latrines en bois',
      'es': 'Letrina de madera',
      'de': 'Holzlatrine',
      'pl': 'Drewniana Latryna',
      'ru': 'Деревянный туалет',
      'uk': 'Дерев’яний туалет',
      'ko': '나무 변소',
      'zh': '木质马桶',
      'ja': '木製トイレ',
    }, {
      'id': 'WoodenShovelItem',
      'en': 'Wooden Shovel',
      'fr': 'Pelle en bois',
      'es': 'Pala de Madera',
      'de': 'Holzschaufel',
      'pl': 'Drewniana łopata',
      'ru': 'Деревянная лопата',
      'uk': 'Дерев’яна лопата',
      'ko': '나무 삽',
      'zh': '木铲',
      'ja': '木のシャベル',
    }, {
      'id': 'WoodenStrawBedItem',
      'en': 'Wooden Straw Bed',
      'fr': 'Lit de paille en bois',
      'es': 'Cama de madera y paja',
      'de': 'Hölzernes Strohbett',
      'pl': 'Drewniane Łożko z Siennikiem',
      'ru': 'Деревянная кровать с соломой',
      'uk': 'Дерев\u0027яне ліжко з соломою',
      'ko': '목재 짚 침대',
      'zh': '木质稻草床',
      'ja': '木製の藁ベッド',
    }, {
      'id': 'WoodenTableLampItem',
      'en': 'Wooden Table Lamp',
      'fr': 'Lampe de table en bois',
      'es': 'Lámpara de madera para mesa',
      'de': 'Hölzerne Tischlampe',
      'pl': 'Drewniana lampa stołowa',
      'ru': 'Деревянная настольная лампа',
      'uk': 'Дерев’яний настільна лампа',
      'ko': '목재 탁자 전등',
      'zh': '木制台灯',
      'ja': '木製のテーブルランプ',
    }, {
      'id': 'WoodenWheelItem',
      'en': 'Wooden Wheel',
      'fr': 'Roue en bois',
      'es': 'Rueda de madera',
      'de': 'Rad aus Holz',
      'pl': 'Drewniane Koło',
      'ru': 'Деревянное колесо',
      'uk': 'Дерев’яне колесо',
      'ko': '목재 바퀴',
      'zh': '木轮',
      'ja': '木の車輪',
    }, {
      'id': 'WoolCarpetItem',
      'en': 'Wool Carpet',
      'fr': 'Tapis en laine',
      'es': 'Alfombra de lana',
      'de': 'Wollteppich',
      'pl': 'Wool Carpet',
      'ru': 'Шерстяной ковер',
      'uk': 'Wool Carpet',
      'ko': '양모 카펫',
      'zh': '羊毛地毯',
      'ja': 'Wool Carpet',
    }, {
      'id': 'WoolCurtainsItem',
      'en': 'Wool Curtains',
      'fr': 'Rideaux en laine',
      'es': 'Cortinas de lana',
      'de': 'Wollvorhänge',
      'pl': 'Wool Curtains',
      'ru': 'Шерстяные Шторы',
      'uk': 'Wool Curtains',
      'ko': '울 커튼',
      'zh': '羊毛窗帘',
      'ja': 'Wool Curtains',
    }, {
      'id': 'WoolFabricItem',
      'en': 'Wool Fabric',
      'fr': 'Tissu en laine',
      'es': 'Tela de lana',
      'de': 'Wollstoff',
      'pl': 'Wool Fabric',
      'ru': 'Шерстяная ткань',
      'uk': 'Wool Fabric',
      'ko': '울 원단',
      'zh': '呢绒',
      'ja': 'Wool Fabric',
    }, {
      'id': 'WoolYarnItem',
      'en': 'Wool Yarn',
      'fr': 'Fil de laine',
      'es': 'Hilo de lana',
      'de': 'Wollgarn',
      'pl': 'Wool Yarn',
      'ru': 'Шерстяная пряжа',
      'uk': 'Wool Yarn',
      'ko': '양모사',
      'zh': '毛纱',
      'ja': 'Wool Yarn',
    }, {
      'id': 'WorkBackpackItem',
      'en': 'Work Backpack',
      'fr': 'Sac à dos de travail',
      'es': 'Mochila de Trabajo',
      'de': 'Arbeitsrucksack',
      'pl': 'Plecak roboczy',
      'ru': 'Рабочий рюкзак',
      'uk': 'Робочий рюкзак',
      'ko': '작업 배낭',
      'zh': '工作背包',
      'ja': '作業バッグ',
    }, {
      'id': 'WorkBootsItem',
      'en': 'Work Boots',
      'fr': 'Bottes de travail',
      'es': 'Botas de Trabajo',
      'de': 'Arbeitsstiefel',
      'pl': 'Buty Robocze',
      'ru': 'Рабочие ботинки',
      'uk': 'Робочі чоботи',
      'ko': '작업화',
      'zh': '工作靴',
      'ja': '作業靴',
    }, {
      'id': 'WorkbenchItem',
      'en': 'Workbench',
      'fr': 'Établi de bricolage',
      'es': 'Mesa de Trabajo',
      'de': 'Werkbank',
      'pl': 'Stół Roboczy',
      'ru': 'Верстак',
      'uk': 'Верстат',
      'ko': '작업대',
      'zh': '工作台',
      'ja': '作業台',
    }, {
      'id': 'WorldlyDonutItem',
      'en': 'Worldly Donut',
      'fr': 'Beignet mondain',
      'es': 'Donut del mundo',
      'de': 'Schmackhafter Donut',
      'pl': 'Worldly Donut',
      'ru': 'Пончик мудрости',
      'uk': 'Worldly Donut',
      'ko': 'Worldly Donut',
      'zh': '惊世甜甜圈',
      'ja': 'Worldly Donut',
    }, {
      'id': 'YeastItem',
      'en': 'Yeast',
      'fr': 'Levure',
      'es': 'Levadura',
      'de': 'Hefe',
      'pl': 'Drożdże',
      'ru': 'Дрожжи',
      'uk': 'Дріжджі',
      'ko': '효모',
      'zh': '酵母',
      'ja': '酵母',
    }, {
      'id': 'ZoningOfficeItem',
      'en': 'Zoning Office',
      'fr': 'Bureau du territoire',
      'es': 'Oficina territorial',
      'de': 'Planungs- und Bauamt',
      'pl': 'Biuro zagospodarowania przestrzennego',
      'ru': 'Офис зонирования',
      'uk': 'Офіс зонування',
      'ko': '토지관리 부서',
      'zh': '分区办公室',
      'ja': 'Zoning Office',
    }]
  }, {
    'type': 'recipes', 'entries': [{
      'id': 'AcornPowder',
      'en': 'Acorn Powder',
      'fr': 'Poudre de gland',
      'es': 'Polvo de Bellota',
      'de': 'Eichelpulver',
      'pl': 'Mączka z żołędzi',
      'ru': 'Мука из желудей',
      'uk': 'Порошок із жолудів',
      'ko': '도토리 분말',
      'zh': '橡子粉',
      'ja': 'ドングリの粉',
    }, {
      'id': 'AdornedAshlarStoneBench',
      'en': 'Adorned Ashlar Stone Bench',
      'fr': 'Banc en pierre taillée ornée',
      'es': 'Banco adornado (sillar de piedra)',
      'de': 'Geschmückter Steinquaderbank',
      'pl': 'Zdobiona ławka z ciosanego kamienia',
      'ru': 'Украшенная лавка из резного камня',
      'uk': 'Прикрашена лавка з різьбленого каменю',
      'ko': '장식된 각진 석재 벤치',
      'zh': '装饰过的阿什拉尔石凳',
      'ja': 'Adorned Ashlar Stone Bench',
    }, {
      'id': 'AdornedAshlarStoneChair',
      'en': 'Adorned Ashlar Stone Chair',
      'fr': 'Chaise en pierre taillée ornée',
      'es': 'Silla adornada (sillar de piedra)',
      'de': 'Geschmückter Steinquaderstuhl',
      'pl': 'Zdobione krzesło z ciosanego kamienia',
      'ru': 'Украшенный стул из резного камня',
      'uk': 'Прикрашений стілець з різьбленого каменю',
      'ko': '장식된 각진 석재 의자',
      'zh': '装饰过的阿什拉尔石椅',
      'ja': 'Adorned Ashlar Stone Chair',
    }, {
      'id': 'AdornedAshlarStoneTable',
      'en': 'Adorned Ashlar Stone Table',
      'fr': 'Table en pierre taillée ornée',
      'es': 'Mesa adornada (sillar de piedra)',
      'de': 'Geschmückter Steinquadertisch',
      'pl': 'Zdobiony stół z ciosanego kamienia',
      'ru': 'Украшенный стол из резного камня',
      'uk': 'Прикрашений стіл з різьбленого каменю',
      'ko': '장식된 각진 석재 탁자',
      'zh': '装饰过的阿什拉尔石桌',
      'ja': 'Adorned Ashlar Stone Table',
    }, {
      'id': 'AdvancedBakingUpgrade',
      'en': 'Advanced Baking Upgrade',
      'fr': 'Amélioration Avancée : Boulangerie avancée',
      'es': 'Mejora avanzada: Horneado',
      'de': 'Fortschrittliches Upgrade: Backen',
      'pl': 'Ulepszenie Zaawansowanego Pieczenia',
      'ru': 'Улучшение для продвинутой выпечки',
      'uk': 'Просунуте покращення випічки',
      'ko': '고급 제빵 기술 업그레이드',
      'zh': '高级烘烤升级',
      'ja': 'Advanced Baking Upgrade',
    }, {
      'id': 'AdvancedCarpentryTable',
      'en': 'Advanced Carpentry Table',
      'fr': 'Établi de menuiserie avancé',
      'es': 'Mesa de carpintería avanzada',
      'de': 'Verbesserter Schreinerhandwerkstisch',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Продвинутый верстак плотника',
      'uk': 'Розширений теслярський стіл',
      'ko': '고급 목공 작업대',
      'zh': '高级木工桌',
      'ja': 'Advanced Carpentry Table',
    }, {
      'id': 'AdvancedCircuit',
      'en': 'Advanced Circuit',
      'fr': 'Circuit avancé',
      'es': 'Circuito avanzado',
      'de': 'Fortschrittlicher Schaltkreis',
      'pl': 'Zaawansowany Obwód',
      'ru': 'Продвинутая электросхема',
      'uk': 'Покращена електросхема',
      'ko': '고급 전자회로',
      'zh': '先进电路',
      'ja': 'Advanced Circuit',
    }, {
      'id': 'AdvancedCombustionEngine',
      'en': 'Advanced Combustion Engine',
      'fr': 'Moteur à combustion avancé',
      'es': 'Motor de Combustión Avanzado',
      'de': 'Fortschrittlicher Verbrennungsmotor',
      'pl': 'Zaawansowany silnik spalinowy',
      'ru': 'Улучшенный двигатель внутреннего сгорания',
      'uk': 'Удосконалений двигун внутрішнього згоряння',
      'ko': '고급 연소기관',
      'zh': '高级内燃机',
      'ja': '高度な内燃機関',
    }, {
      'id': 'AdvancedCookingUpgrade',
      'en': 'Advanced Cooking Upgrade',
      'fr': 'Amélioration Avancée : Cuisine avancée',
      'es': 'Mejora avanzada: Cocina',
      'de': 'Fortschrittliches Upgrade: Kochen',
      'pl': 'Zaawansowane ulepszenie Gotowania',
      'ru': 'Улучшение для продвинутой кулинарии',
      'uk': 'Просунуте покращення приготування їжі',
      'ko': '고급 요리 기술 업그레이드',
      'zh': '高级烹饪升级',
      'ja': 'Advanced Cooking Upgrade',
    }, {
      'id': 'AdvancedMasonryTable',
      'en': 'Advanced Masonry Table',
      'fr': 'Établi de maçonnerie avancé',
      'es': 'Mesa de mampostería avanzada',
      'de': 'Verbesserter Steinmetztisch',
      'pl': 'Zaawansowany stół kamieniarski',
      'ru': 'Продвинутый верстак каменщика',
      'uk': 'Покращенний верстак муляра',
      'ko': '고급 석공 작업대',
      'zh': '高级石工台',
      'ja': 'Advanced Masonry Table',
    }, {
      'id': 'AdvancedMasonryUpgrade',
      'en': 'Advanced Masonry Upgrade',
      'fr': 'Amélioration Moderne : Maçonnerie avancée',
      'es': 'Mejora: Mampostería avanzada',
      'de': 'Fortschrittliches Upgrade: Steinmetz',
      'pl': 'Zaawansowane ulepszenie Kamieniarstwa',
      'ru': 'Продвинутое улучшение для каменной кладки',
      'uk': 'Просунуте покращення кладки',
      'ko': '고급 석조 기술 업그레이드',
      'zh': '高级石工升级组件',
      'ja': 'Advanced Masonry Upgrade',
    }, {
      'id': 'AdvancedSmeltingUpgrade',
      'en': 'Advanced Smelting Upgrade',
      'fr': 'Amélioration Avancée : Fonte avancée',
      'es': 'Mejora avanzada: Fundición',
      'de': 'Fortschrittliches Upgrade: Schmelzen',
      'pl': 'Zaawansowane ulepszenie Wytapiania',
      'ru': 'Улучшение для продвинутой выплавки',
      'uk': 'Просунуте покращення виплавки',
      'ko': '고급 제련 기술 업그레이드',
      'zh': '高级冶炼升级',
      'ja': 'Advanced Smelting Upgrade',
    }, {
      'id': 'AdvancedTailoringTable',
      'en': 'Advanced Tailoring Table',
      'fr': 'Établi de couturier avancé',
      'es': 'Mesa de sastrería avanzada',
      'de': 'Verbesserter Schneidertisch',
      'pl': 'Advanced Tailoring Table',
      'ru': 'Продвинутый Стол Портного',
      'uk': 'Advanced Tailoring Table',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝台',
      'ja': 'Advanced Tailoring Table',
    }, {
      'id': 'AdvancedUpgradeLvl1',
      'en': 'Advanced Upgrade 1',
      'fr': 'Amélioration Avancée Nv1',
      'es': 'Mejora avanzada 1',
      'de': 'Fortschrittliches Upgrade 1',
      'pl': 'Zaawansowane ulepszenie 1',
      'ru': 'Продвинутое улучшение 1',
      'uk': 'Просунуте покращення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级1',
      'ja': 'Advanced Upgrade 1',
    }, {
      'id': 'AdvancedUpgradeLvl2',
      'en': 'Advanced Upgrade 2',
      'fr': 'Amélioration Avancée Nv2',
      'es': 'Mejora avanzada 2',
      'de': 'Fortschrittliches Upgrade 2',
      'pl': 'Zaawansowane ulepszenie 2',
      'ru': 'Продвинутое улучшение 2',
      'uk': 'Просунуте покращення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级2',
      'ja': 'Advanced Upgrade 2',
    }, {
      'id': 'AdvancedUpgradeLvl3',
      'en': 'Advanced Upgrade 3',
      'fr': 'Amélioration Avancée Nv3',
      'es': 'Mejora avanzada 3',
      'de': 'Fortschrittliches Upgrade 3',
      'pl': 'Zaawansowane ulepszenie 3',
      'ru': 'Продвинутое улучшение 3',
      'uk': 'Просунуте покращення 3',
      'ko': '고급 업그레이드 3',
      'zh': '高级升级3',
      'ja': 'Advanced Upgrade 3',
    }, {
      'id': 'AdvancedUpgradeLvl4',
      'en': 'Advanced Upgrade 4',
      'fr': 'Amélioration Avancée Nv4',
      'es': 'Mejora avanzada 4',
      'de': 'Fortschrittliches Upgrade 4',
      'pl': 'Zaawansowane ulepszenie 4',
      'ru': 'Продвинутое улучшение 4',
      'uk': 'Просунуте покращення 4',
      'ko': '고급 업그레이드 4',
      'zh': '高级升级4',
      'ja': 'Advanced Upgrade 4',
    }, {
      'id': 'AgaveSeed',
      'en': 'Agave Seed',
      'fr': 'Graine d\u0027agave',
      'es': 'Semilla de agave',
      'de': 'Samen (Agave)',
      'pl': 'Nasiono agawy',
      'ru': 'Семечко агавы',
      'uk': 'Насіння агави',
      'ko': '용설란 씨앗',
      'zh': '龙舌兰种子',
      'ja': 'アガベの種子',
    }, {
      'id': 'AgoutiEnchiladas',
      'en': 'Agouti Enchiladas',
      'fr': 'Enchiladas d\u0027agouti',
      'es': 'Enchiladas de agutí',
      'de': 'Agouti Enchiladas',
      'pl': 'Agouti Enchiladas',
      'ru': 'Энчиладас с агути',
      'uk': 'Agouti Enchiladas',
      'ko': 'Agouti Enchiladas',
      'zh': '刺鼠玉米卷',
      'ja': 'Agouti Enchiladas',
    }, {
      'id': 'AgricultureResearchPaperAdvanced',
      'en': 'Agriculture Research Paper Advanced',
      'fr': 'Papier de recherche : Agriculture avancée',
      'es': 'Trabajo de investigación en agricultura (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Landwirtschaft',
      'pl': 'Agriculture Research Paper Advanced',
      'ru': 'Исследование по продвинутому сельскому хозяйству',
      'uk': 'Дослідження вдосконаленого сільського господарства',
      'ko': '고급 농업 연구지',
      'zh': '高级农业研究论文',
      'ja': 'Agriculture Research Paper Advanced',
    }, {
      'id': 'AgricultureResearchPaperModern',
      'en': 'Agriculture Research Paper Modern',
      'fr': 'Papier de recherche : Agriculture moderne',
      'es': 'Trabajo de investigación en agricultura (moderno)',
      'de': 'Modernes Forschungspapier: Landwirtschaft',
      'pl': 'Nowoczesny artykuł badawczy Agrokultury',
      'ru': 'Исследование по современному сельскому хозяйству',
      'uk': 'Дослідження сучасного сільського господарства',
      'ko': '현대식 농업 연구지',
      'zh': '现代农业研究论文',
      'ja': 'Agriculture Research Paper Modern',
    }, {
      'id': 'AmanitaMushroomSpores',
      'en': 'Amanita Mushroom Spores',
      'fr': 'Spores d\u0027amanite tue-mouches',
      'es': 'Esporas de Amanita Muscaria',
      'de': 'Sporen (Fliegenpilz)',
      'pl': 'Zarodniki Muchomora Czerwonego',
      'ru': 'Споры мухоморов',
      'uk': 'Спори мухомора',
      'ko': '광대버섯 포자',
      'zh': '鹅膏菌孢子',
      'ja': 'ベニテングダケの胞子',
    }, {
      'id': 'Anvil',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Ковадло',
      'ko': '모루',
      'zh': '铁砧',
      'ja': '金床',
    }, {
      'id': 'Arrastra',
      'en': 'Arrastra',
      'fr': 'Concasseur à meules en pierre',
      'es': 'Arrastra',
      'de': 'Bergbau-Pochmühle',
      'pl': 'Opór',
      'ru': 'Аррастра',
      'uk': 'Аррастра',
      'ko': '돌 맷돌',
      'zh': '碎金研磨机',
      'ja': 'Arrastra',
    }, {
      'id': 'AshlarBasalt',
      'en': 'Ashlar Basalt',
      'fr': 'Basalte taillé',
      'es': 'Sillar de basalto',
      'de': 'Quader aus Basalt',
      'pl': 'Ciosany bazalt',
      'ru': 'Резной базальт',
      'uk': 'Різьблений Базальт',
      'ko': '각진 현무암',
      'zh': '阿什拉尔玄武岩',
      'ja': 'Ashlar Basalt',
    }, {
      'id': 'AshlarGneiss',
      'en': 'Ashlar Gneiss',
      'fr': 'Gneiss taillé',
      'es': 'Sillar de gneis',
      'de': 'Quader aus Gneis',
      'pl': 'Ciosany gnejs',
      'ru': 'Резной гнейс',
      'uk': 'Різьблений гнейс',
      'ko': '각진 편마암',
      'zh': '阿什拉尔片麻岩',
      'ja': 'Ashlar Gneiss',
    }, {
      'id': 'AshlarGranite',
      'en': 'Ashlar Granite',
      'fr': 'Granite taillé',
      'es': 'Sillar de granito',
      'de': 'Quader aus Granit',
      'pl': 'Ciosany granit',
      'ru': 'Резной гранит',
      'uk': 'Різьблений Граніт',
      'ko': '각진 화강암',
      'zh': '阿什拉尔花岗岩',
      'ja': 'Ashlar Granite',
    }, {
      'id': 'AshlarLargeStoneFountain',
      'en': 'Ashlar Large Stone Fountain',
      'fr': 'Grande fontaine en pierre taillée',
      'es': 'Fuente grande (sillar de piedra)',
      'de': 'Großer Steinquaderbrunnen',
      'pl': 'Duża fontanna z ciosanego kamienia',
      'ru': 'Фонтан из резного камня',
      'uk': 'Великий фонтан з обтесаного каменю',
      'ko': '각진 석재 대형분수',
      'zh': '大型阿什拉尔型石喷泉',
      'ja': 'Ashlar Large Stone Fountain',
    }, {
      'id': 'AshlarLimestone',
      'en': 'Ashlar Limestone',
      'fr': 'Calcaire taillé',
      'es': 'Sillar de piedra caliza',
      'de': 'Quader aus Kalkstein',
      'pl': 'Ciosany wapień',
      'ru': 'Резной известняк',
      'uk': 'Різьблений Вапняк',
      'ko': '각진 석회암',
      'zh': '阿什拉尔石灰石',
      'ja': 'Ashlar Limestone',
    }, {
      'id': 'AshlarSandstone',
      'en': 'Ashlar Sandstone',
      'fr': 'Grès taillé',
      'es': 'Sillar de arenisca',
      'de': 'Quader aus Sandstein',
      'pl': 'Ciosany piaskowiec',
      'ru': 'Резной песчаник',
      'uk': ' Обтесаний піщаник',
      'ko': '각진 사암',
      'zh': '阿什拉尔砂岩',
      'ja': 'Ashlar Sandstone',
    }, {
      'id': 'AshlarShale',
      'en': 'Ashlar Shale',
      'fr': 'Schiste taillé',
      'es': 'Pizarra (sillar)',
      'de': 'Quader aus Schiefer',
      'pl': 'Ciosany łupek',
      'ru': 'Резной сланец',
      'uk': 'Обтесаний сланець',
      'ko': '각진 이판암',
      'zh': '阿什拉尔页岩',
      'ja': 'Ashlar Shale',
    }, {
      'id': 'AshlarSmallStoneFountain',
      'en': 'Ashlar Small Stone Fountain',
      'fr': 'Petite fontaine en pierre taillée',
      'es': 'Fuente pequeña de piedra (sillar)',
      'de': 'Kleiner Quadersteinbrunnen',
      'pl': 'Mała fontanna z ciosanego kamienia',
      'ru': 'Маленький фонтан из резного камня',
      'uk': 'Малий фонтан з обтесаного каменю',
      'ko': '각진 석재 소형분수',
      'zh': '小型阿什拉尔石喷泉',
      'ja': 'Ashlar Small Stone Fountain',
    }, {
      'id': 'AshlarStoneBench',
      'en': 'Ashlar Stone Bench',
      'fr': 'Banc en pierre taillée',
      'es': 'Banco de piedra (sillar)',
      'de': 'Quadersteinbank',
      'pl': 'Ciosana kamienna ławka',
      'ru': 'Лавка из резного камня',
      'uk': 'Лавка з обтесаного каменю',
      'ko': '각진 석재 벤치',
      'zh': '阿什拉尔石凳',
      'ja': 'Ashlar Stone Bench',
    }, {
      'id': 'AshlarStoneChair',
      'en': 'Ashlar Stone Chair',
      'fr': 'Chaise en pierre taillée',
      'es': 'Silla de piedra (sillar)',
      'de': 'Quadersteinstuhl',
      'pl': 'Ciosane kamienne krzesło',
      'ru': 'Стул из резного камня',
      'uk': 'Стілець з обтесаного каменю',
      'ko': '각진 석재 의자',
      'zh': '阿什拉尔石椅',
      'ja': 'Ashlar Stone Chair',
    }, {
      'id': 'AshlarStoneDoor',
      'en': 'Ashlar Stone Door',
      'fr': 'Porte en pierre taillée',
      'es': 'Puerta (sillar de piedra)',
      'de': 'Quadersteintür',
      'pl': 'Drzwi z ciosanego kamienia',
      'ru': 'Дверь из резного камня',
      'uk': 'Двері з обтесаного каменю',
      'ko': '각진 석재 문',
      'zh': '阿什拉尔石门',
      'ja': 'Ashlar Stone Door',
    }, {
      'id': 'AshlarStoneFireplace',
      'en': 'Ashlar Stone Fireplace',
      'fr': 'Cheminée en pierre taillée',
      'es': 'Chimenea de piedra (sillar)',
      'de': 'Quadersteinfeuerstelle',
      'pl': 'Kominek z ciosanego kamienia',
      'ru': 'Камин из резного камня',
      'uk': 'Камін з обтесаного каменю',
      'ko': '각진 석재 벽난로',
      'zh': '阿什拉尔石壁炉',
      'ja': 'Ashlar Stone Fireplace',
    }, {
      'id': 'AshlarStoneTable',
      'en': 'Ashlar Stone Table',
      'fr': 'Table en pierre taillée',
      'es': 'Mesa de piedra (sillar)',
      'de': 'Quadersteintisch',
      'pl': 'Stół z ciosanego kamienia',
      'ru': 'Стол из резного камня',
      'uk': 'Стіл з обтесаного каменю',
      'ko': '각진 석재 탁자',
      'zh': '阿什拉尔石桌',
      'ja': 'Ashlar Stone Table',
    }, {
      'id': 'AsphaltConcrete',
      'en': 'Asphalt Concrete',
      'fr': 'Béton à base d\u0027asphalte',
      'es': 'Hormigón asfáltico',
      'de': 'Asphaltbeton',
      'pl': 'Asphalt Concrete',
      'ru': 'Асфальтобетон',
      'uk': 'Asphalt Concrete',
      'ko': '아스팔트 콘크리트',
      'zh': '沥青混凝土',
      'ja': 'Asphalt Concrete',
    }, {
      'id': 'AssemblyLine',
      'en': 'Assembly Line',
      'fr': 'Ligne de Montage',
      'es': 'Línea de Ensamblaje',
      'de': 'Mechanische Fertigungsstraße',
      'pl': 'Linia Produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія для збору',
      'ko': '조립 라인',
      'zh': '装配线',
      'ja': '組立ライン',
    }, {
      'id': 'AutomaticLoom',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar mecánico',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatic Loom',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Automatic Loom',
      'ko': '자동 베틀',
      'zh': '自动织布机',
      'ja': 'Automatic Loom',
    }, {
      'id': 'AutumnStew',
      'en': 'Autumn Stew',
      'fr': 'Ragoût d\u0027automne',
      'es': 'Estofado otoñal',
      'de': 'Herbsteintopf',
      'pl': 'Autumn Stew',
      'ru': 'Осеннее рагу',
      'uk': 'Autumn Stew',
      'ko': 'Autumn Stew',
      'zh': '秋季炖汤',
      'ja': 'Autumn Stew',
    }, {
      'id': 'BakedAgave',
      'en': 'Baked Agave',
      'fr': 'Agave cuit',
      'es': 'Agave cocinado',
      'de': 'Gebackene Agave',
      'pl': 'Pieczona agawa',
      'ru': 'Запечённая агава',
      'uk': 'Запечена агава',
      'ko': '구운 용설란',
      'zh': '烘焙过的龙舌兰',
      'ja': '焼いたリュウゼツラン',
    }, {
      'id': 'BakedBeet',
      'en': 'Baked Beet',
      'fr': 'Betterave cuite',
      'es': 'Remolacha horneada',
      'de': 'Gebackene Rote Bete',
      'pl': 'Pieczony burak',
      'ru': 'Запечённая свекла',
      'uk': 'Запечений буряк',
      'ko': '구운 사탕무',
      'zh': '烤甜菜',
      'ja': 'Baked Beet',
    }, {
      'id': 'BakedCorn',
      'en': 'Baked Corn',
      'fr': 'Maïs cuit',
      'es': 'Maíz horneado',
      'de': 'Gebackener Mais',
      'pl': 'Upieczona kukurydza',
      'ru': 'Запечённая кукуруза',
      'uk': 'Запечена кукурудза',
      'ko': '구운 옥수수',
      'zh': '烤玉米',
      'ja': 'Baked Corn',
    }, {
      'id': 'BakedHeartOfPalm',
      'en': 'Baked Heart Of Palm',
      'fr': 'Cœur de palmier cuit',
      'es': 'Palmito horneado',
      'de': 'Gebackene Palmherzen',
      'pl': 'Upieczone serce palmy',
      'ru': 'Запечённая сердцевина пальмы',
      'uk': 'Запечена серцевина пальми',
      'ko': '구운 대추야자 나무순',
      'zh': '掌心焗',
      'ja': 'Baked Heart Of Palm',
    }, {
      'id': 'BakedMeat',
      'en': 'Baked Meat',
      'fr': 'Viande cuite',
      'es': 'Carne Horneada',
      'de': 'Gebackenes Fleisch',
      'pl': 'Pieczone mięso',
      'ru': 'Запечённое мясо',
      'uk': 'Запечене м’ясо',
      'ko': '구운 고기',
      'zh': '熟肉',
      'ja': '焼いた肉',
    }, {
      'id': 'BakedRoast',
      'en': 'Baked Roast',
      'fr': 'Rôti cuit',
      'es': 'Asado Horneado',
      'de': 'Gebackener Braten',
      'pl': 'Zapiekana pieczeń',
      'ru': 'Запечённое жаркое',
      'uk': 'Запечена печеня',
      'ko': '구운 구이용 고기',
      'zh': '熟烤肉',
      'ja': '焼きたてのロースト',
    }, {
      'id': 'BakedTaro',
      'en': 'Baked Taro',
      'fr': 'Taro cuit',
      'es': 'Taro cocinado',
      'de': 'Gebackene Taro',
      'pl': 'Upieczone taro',
      'ru': 'Запечённый корень таро',
      'uk': 'Печений дашин',
      'ko': '구운 토란',
      'zh': '烤芋头',
      'ja': 'Baked Taro',
    }, {
      'id': 'BakedTomato',
      'en': 'Baked Tomato',
      'fr': 'Tomate cuite',
      'es': 'Tomate horneado',
      'de': 'Gebackene Tomaten',
      'pl': 'Pieczony pomidor',
      'ru': 'Запеченный помидор',
      'uk': 'Печений томат',
      'ko': '구운 토마토',
      'zh': '烤番茄',
      'ja': 'Baked Tomato',
    }, {
      'id': 'BakeryOven',
      'en': 'Bakery Oven',
      'fr': 'Four à pain',
      'es': 'Horno de Panadería',
      'de': 'Bäckereiofen',
      'pl': 'Piec piekarniczy',
      'ru': 'Печь для выпечки',
      'uk': 'Піч для випічки',
      'ko': '제빵 화덕',
      'zh': '烤炉',
      'ja': 'ベーカリーオーブン',
    }, {
      'id': 'BakingUpgrade',
      'en': 'Baking Upgrade',
      'fr': 'Amélioration Avancée : Boulangerie',
      'es': 'Mejora: Horneado',
      'de': 'Fortschrittliches Upgrade: Backen',
      'pl': 'Ulepszenie Pieczenia',
      'ru': 'Улучшение для выпечки',
      'uk': 'Покращення випічки',
      'ko': '제빵 기술 업그레이드',
      'zh': '烘烤升级',
      'ja': 'Baking Upgrade',
    }, {
      'id': 'Bandana',
      'en': 'Bandana',
      'fr': 'Bandana',
      'es': 'Bandana',
      'de': 'Bandana',
      'pl': 'Bandana',
      'ru': 'Бандана',
      'uk': 'Бандана',
      'ko': '반다나',
      'zh': '头巾',
      'ja': 'Bandana',
    }, {
      'id': 'BanhXeo',
      'en': 'Banh Xeo',
      'fr': 'Crêpe vietnamienne',
      'es': 'Banh Xeo',
      'de': 'Banh Xeo',
      'pl': 'Banh Xeo',
      'ru': 'Блинчики Бан Хео',
      'uk': 'Banh Xeo',
      'ko': 'Banh Xeo',
      'zh': '越南煎饼',
      'ja': 'Banh Xeo',
    }, {
      'id': 'Bank',
      'en': 'Bank',
      'fr': 'Banque',
      'es': 'Banco',
      'de': 'Banktresor',
      'pl': 'Bank',
      'ru': 'Банк',
      'uk': 'Банк',
      'ko': '은행',
      'zh': '银行',
      'ja': '銀行',
    }, {
      'id': 'Bannock',
      'en': 'Bannock',
      'fr': 'Bannique',
      'es': 'Bannock',
      'de': 'Lagerfeuerbrot',
      'pl': 'Placek pszenny',
      'ru': 'Пресная лепёшка',
      'uk': 'Коржик',
      'ko': '과자빵',
      'zh': '麦饼',
      'ja': 'Placek mączny',
    }, {
      'id': 'Barrel',
      'en': 'Barrel',
      'fr': 'Tonneau',
      'es': 'Barril',
      'de': 'Fass',
      'pl': 'Beczka',
      'ru': 'Бочка',
      'uk': 'Діжка',
      'ko': '배럴통',
      'zh': '桶',
      'ja': 'ドラム缶',
    }, {
      'id': 'BasicCircuit',
      'en': 'Basic Circuit',
      'fr': 'Circuit basique',
      'es': 'Circuito básico',
      'de': 'Einfacher Schaltkreis',
      'pl': 'Podstawowy obwód',
      'ru': 'Базовая электросхема',
      'uk': 'Базова електросхема',
      'ko': '기초 회로',
      'zh': '基础电路',
      'ja': 'Basic Circuit',
    }, {
      'id': 'BasicEngineeringUpgrade',
      'en': 'Basic Engineering Upgrade',
      'fr': 'Amélioration Basique : Ingénierie basique',
      'es': 'Mejora básica: Ingeniería',
      'de': 'Grundlegendes Upgrade: Grundlegende Technik',
      'pl': 'Podstawowe ulepszenie Inżynierii',
      'ru': 'Улучшение для основ инженерного дела',
      'uk': 'Базове покращення інженерії',
      'ko': '기초 기계공학 기술 업그레이드',
      'zh': '基础工程升级',
      'ja': 'Basic Engineering Upgrade',
    }, {
      'id': 'ExoticSalad',
      'en': 'Exotic Salad',
      'fr': 'Salade exotique',
      'es': 'Ensalada Exótica',
      'de': 'Exotischer Salat',
      'pl': 'Sałatka tropikalna',
      'ru': 'Экзотический салат',
      'uk': 'Екзотичний салат',
      'ko': '이국적인 샐러드',
      'zh': '异国风味沙拉',
      'ja': 'エキゾチックサラダ',
    }, {
      'id': 'ForestSalad',
      'en': 'Forest Salad',
      'fr': 'Salade forestière',
      'es': 'Ensalada del bosque',
      'de': 'Waldsalat',
      'pl': 'Sałatka Leśna',
      'ru': 'Лесной салат',
      'uk': 'Лісовий салат',
      'ko': '숲 샐러드',
      'zh': '森林沙拉',
      'ja': '森のサラダ',
    }, {
      'id': 'GrasslandSalad',
      'en': 'Grassland Salad',
      'fr': 'Salade des prairies',
      'es': 'Ensalada de las praderas',
      'de': 'Wiesensalat',
      'pl': 'Sałatka pastewna',
      'ru': 'Равнинный салат',
      'uk': 'Рівнинний салат',
      'ko': '초원 샐러드',
      'zh': '草原沙拉',
      'ja': '草原サラダ',
    }, {
      'id': 'MixedSalad',
      'en': 'Mixed Salad',
      'fr': 'Salade mixte',
      'es': 'Ensalada Mixta',
      'de': 'Gemischter Salat',
      'pl': 'Sałatka Mieszana',
      'ru': 'Смешанный салат',
      'uk': 'Змішаний салат',
      'ko': '혼합 샐러드',
      'zh': '什锦沙拉',
      'ja': 'ミックスサラダ',
    }, {
      'id': 'RainforestSalad',
      'en': 'Rainforest Salad',
      'fr': 'Salade de la jungle',
      'es': 'Ensalada de la jungla',
      'de': 'Regenwaldsalat',
      'pl': 'Rainforest Salad',
      'ru': 'Тропический салат',
      'uk': 'Тропічний салат',
      'ko': '열대우림 샐러드',
      'zh': '雨林沙拉',
      'ja': '熱帯雨林のサラダ',
    }, {
      'id': 'BasicUpgradeLvl1',
      'en': 'Basic Upgrade 1',
      'fr': 'Amélioration Basique Nv1',
      'es': 'Mejora básica 1',
      'de': 'Grundlegendes Upgrade 1',
      'pl': 'Podstawowe ulepszenie 1',
      'ru': 'Базовое улучшение 1',
      'uk': 'Базове покращення 1',
      'ko': '기초 업그레이드 1',
      'zh': '基础升级1',
      'ja': '基礎アップグレード1',
    }, {
      'id': 'BasicUpgradeLvl2',
      'en': 'Basic Upgrade 2',
      'fr': 'Amélioration Basique Nv2',
      'es': 'Mejora básica 2',
      'de': 'Grundlegendes Upgrade 2',
      'pl': 'Podstawowe ulepszenie 2',
      'ru': 'Базовое улучшение 2',
      'uk': 'Базове покращення 2',
      'ko': '기초 업그레이드 2',
      'zh': '基础升级2',
      'ja': '基礎アップグレード2',
    }, {
      'id': 'BasicUpgradeLvl3',
      'en': 'Basic Upgrade 3',
      'fr': 'Amélioration Basique Nv3',
      'es': 'Mejora básica 3',
      'de': 'Grundlegendes Upgrade 3',
      'pl': 'Podstawowe ulepszenie 3',
      'ru': 'Базовое улучшение 3',
      'uk': 'Базове покращення 3',
      'ko': '기초 업그레이드 3',
      'zh': '基础升级3',
      'ja': '基礎アップグレード3',
    }, {
      'id': 'BasicUpgradeLvl4',
      'en': 'Basic Upgrade 4',
      'fr': 'Amélioration Basique Nv4',
      'es': 'Mejora básica 4',
      'de': 'Grundlegendes Upgrade 4',
      'pl': 'Podstawowe ulepszenie 4',
      'ru': 'Базовое улучшение 4',
      'uk': 'Базове покращення 4',
      'ko': '기초 업그레이드 4',
      'zh': '基础升级4',
      'ja': '基礎アップグレード4',
    }, {
      'id': 'Bathtub',
      'en': 'Bathtub',
      'fr': 'Baignoire',
      'es': 'Bañera',
      'de': 'Badewanne',
      'pl': 'Wanna',
      'ru': 'Ванна',
      'uk': 'Ванна',
      'ko': '욕조',
      'zh': '浴缸',
      'ja': 'Bathtub',
    }, {
      'id': 'BeanPaste',
      'en': 'Bean Paste',
      'fr': 'Pâte de haricots',
      'es': 'Pasta de Judías',
      'de': 'Bohnenpaste',
      'pl': 'Pasta z fasoli',
      'ru': 'Бобовая паста',
      'uk': 'Паста з бобів',
      'ko': '갈린 콩',
      'zh': '豆浆',
      'ja': 'ペースト状の豆',
    }, {
      'id': 'BeanSprout',
      'en': 'Bean Sprout',
      'fr': 'Pousses de haricots',
      'es': 'Germinado de Judías',
      'de': 'Bohnensprosse',
      'pl': 'Bean Sprout',
      'ru': 'Бобовый росток',
      'uk': 'Bean Sprout',
      'ko': '콩 새싹',
      'zh': '豆芽菜',
      'ja': 'Bean Sprout',
    }, {
      'id': 'BearSUPREME',
      'en': 'Bear S U P R E M E',
      'fr': 'Suprême d\u0027ours',
      'es': 'Oso S U P R E M O',
      'de': 'Bärensteak',
      'pl': 'Nedzwiedź S U P R E M E',
      'ru': 'Блюдо «Матёрый медведь»',
      'uk': 'Ведмежий стейк',
      'ko': '쩔어주는 곰기',
      'zh': '顶级熊肉',
      'ja': 'クマのS U P R E M E',
    }, {
      'id': 'Bearclaw',
      'en': 'Bearclaw',
      'fr': 'Gâteau patte d\u0027ours',
      'es': 'Pastel Garra de Oso',
      'de': 'Bärenklaue',
      'pl': 'Niedźwiadka',
      'ru': 'Пирог «Медвежий коготь»',
      'uk': 'Пиріг «Ведмежий кіготь»',
      'ko': '곰 발톱 빵',
      'zh': '熊爪包',
      'ja': 'ベアクロウ',
    }, {
      'id': 'Bearpack',
      'en': 'Bearpack',
      'fr': 'Sac à d\u0027ours',
      'es': 'Mochila de Oso',
      'de': 'Bärenrucksack',
      'pl': 'Plecak Olbrzymi',
      'ru': 'Медвежий рюкзак',
      'uk': 'Величезний наплічник',
      'ko': '곰낭',
      'zh': '熊背包',
      'ja': '巨大なバックパック',
    }, {
      'id': 'BeetCampfireSalad',
      'en': 'Beet Campfire Salad',
      'fr': 'Salade de betteraves cuite au feu de camp',
      'es': 'Ensalada de remolacha braseada',
      'de': 'Lagefeuer Rote Bete Salat',
      'pl': 'Sałatka z grillowanego buraka',
      'ru': 'Свекольный салат на костре',
      'uk': 'Буряковий салат, приготований на багатті',
      'ko': '사탕무 모닥불 스튜',
      'zh': '甜菜篝火沙拉',
      'ja': 'Beet Campfire Salad',
    }, {
      'id': 'BeetSeed',
      'en': 'Beet Seed',
      'fr': 'Graine de betterave',
      'es': 'Semilla de remolacha',
      'de': 'Samen (Rote Bete)',
      'pl': 'Nasiona buraka',
      'ru': 'Семечко свёклы',
      'uk': 'Насіння буряка',
      'ko': '사탕무 씨앗',
      'zh': '甜菜种子',
      'ja': 'ビートの種',
    }, {
      'id': 'BerryExtractFertilizer',
      'en': 'Berry Extract Fertilizer',
      'fr': 'Engrais à l\u0027extrait de baies',
      'es': 'Fertilizante de Extracto de Baya',
      'de': 'Dünger aus Beerenextrakt',
      'pl': 'Nawóz z ekstraktu jagodowego',
      'ru': 'Удобрение из ягодного экстракта',
      'uk': 'Добриво з ягідного екстракту',
      'ko': '월귤나무 열매 추출물 비료',
      'zh': '浆果萃取化肥',
      'ja': 'ベリーエキスの肥料',
    }, {
      'id': 'BigBackpack',
      'en': 'Big Backpack',
      'fr': 'Grand sac à dos',
      'es': 'Mochila Grande',
      'de': 'Großer Rucksack',
      'pl': 'Duży Plecak',
      'ru': 'Большой рюкзак',
      'uk': 'Великий рюкзак',
      'ko': '큰 배낭',
      'zh': '大背包',
      'ja': '大きなバックパック',
    }, {
      'id': 'Biodiesel',
      'en': 'Biodiesel',
      'fr': 'Bio-gazole',
      'es': 'Biodiésel',
      'de': 'Biodiesel',
      'pl': 'Biodisel',
      'ru': 'Биодизель',
      'uk': 'Біодизель',
      'ko': '바이오디젤',
      'zh': '生物柴油',
      'ja': 'バイオディーゼル',
    }, {
      'id': 'BisonChowFun',
      'en': 'Bison Chow Fun',
      'fr': 'Bison aux nouilles',
      'es': 'Chow Fun de Bisonte',
      'de': 'Bison Kau-Genuß',
      'pl': 'Chow fun z żubra',
      'ru': 'Фан-чау из бизона',
      'uk': 'Bison Chow Fun',
      'ko': 'Bison Chow Fun',
      'zh': '野牛炒粉',
      'ja': 'Bison Chow Fun',
    }, {
      'id': 'BisonMount',
      'en': 'Bison Mount',
      'fr': 'Trophée de bison',
      'es': 'Soporte para bisonte',
      'de': 'Ausgestopfter Bison',
      'pl': 'Żubr Górski',
      'ru': 'Голова бизона',
      'uk': 'Голова бізона',
      'ko': '들소 벽걸이 박제',
      'zh': '野牛头壁挂',
      'ja': 'バイソンマウント',
    }, {
      'id': 'BlastFurnace',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto Horno',
      'de': 'Hochofen',
      'pl': 'Piec Chutniczy',
      'ru': 'Доменная печь',
      'uk': 'Домна',
      'ko': '용광로',
      'zh': '高炉',
      'ja': '高炉',
    }, {
      'id': 'BloodMealFertilizer',
      'en': 'Blood Meal Fertilizer',
      'fr': 'Engrais à base de farine de sang',
      'es': 'Fertilizante de Harina de Sangre',
      'de': 'Dünger aus Blutmahl',
      'pl': 'Nawóz z mączki krwistej',
      'ru': 'Удобрение из кровяной муки',
      'uk': 'Добриво з кров’яного борошна',
      'ko': '혈분비료',
      'zh': '血粉化肥',
      'ja': '血粉の肥料',
    }, {
      'id': 'Bloomery',
      'en': 'Bloomery',
      'fr': 'Bas fourneau',
      'es': 'Horno de fundición',
      'de': 'Schmelzofen',
      'pl': 'Dymarka',
      'ru': 'Сыродутная печь',
      'uk': 'Сиродутне горно',
      'ko': '괴철로',
      'zh': '锻铁炉',
      'ja': '塊鉄炉',
    }, {
      'id': 'Board',
      'en': 'Board',
      'fr': 'Planche',
      'es': 'Tabla',
      'de': 'Bretter',
      'pl': 'Deska',
      'ru': 'Доска',
      'uk': 'Дошка',
      'ko': '판자',
      'zh': '木板',
      'ja': '板',
    }, {
      'id': 'SawBoards',
      'en': 'Saw Boards',
      'fr': 'Scier des planches',
      'es': 'Tablas de Sierra',
      'de': 'Holzbretter',
      'pl': 'Saw Boards',
      'ru': 'Пилить доски',
      'uk': 'Розпилити дошки',
      'ko': '판자 자르기',
      'zh': '粗凿原木板',
      'ja': '丸太をひいて板にする',
    }, {
      'id': 'BoiledGrains',
      'en': 'Boiled Grains',
      'fr': 'Grains bouillis',
      'es': 'Granos hervidos',
      'de': 'Einfaches Porridge',
      'pl': 'Ugotowane ziarna',
      'ru': 'Варёные зерна',
      'uk': 'Зварене зерно',
      'ko': '삶은 곡물',
      'zh': '水煮谷物',
      'ja': 'Boiled Grains',
    }, {
      'id': 'BoiledRice',
      'en': 'Boiled Rice',
      'fr': 'Riz bouilli',
      'es': 'Arroz Hervido',
      'de': 'Gekochter Reis',
      'pl': 'Gotowany ryż',
      'ru': 'Отварной рис',
      'uk': 'Варений рис',
      'ko': '삶은 쌀',
      'zh': '煮熟的米',
      'ja': 'ご飯',
    }, {
      'id': 'BoiledSausage',
      'en': 'Boiled Sausage',
      'fr': 'Saucisse bouillie',
      'es': 'Salchicha Cocida',
      'de': 'Gekochte Wurst',
      'pl': 'Gotowana kiełbasa',
      'ru': 'Варёная сосиска',
      'uk': 'Варена сарделька',
      'ko': '삶은 소시지',
      'zh': '煮香肠',
      'ja': '茹でたソーセージ',
    }, {
      'id': 'Boiler',
      'en': 'Boiler',
      'fr': 'Chaudière',
      'es': 'Caldera',
      'de': 'Heizkessel',
      'pl': 'Bojler',
      'ru': 'Котёл',
      'uk': 'Котел',
      'ko': '보일러',
      'zh': '锅炉',
      'ja': 'ボイラー',
    }, {
      'id': 'BoleteMushroomSpores',
      'en': 'Bolete Mushroom Spores',
      'fr': 'Spores de cèpe de Bordeaux',
      'es': 'Esporas de Seta de Boleto',
      'de': 'Sporen (Steinpilz)',
      'pl': 'Zarodniki Grzybów Bolete',
      'ru': 'Споры белого гриба',
      'uk': 'Спори білого гриба',
      'ko': '그물버섯 포자',
      'zh': '香菇孢子',
      'ja': 'ヤマドリタケの胞子',
    }, {
      'id': 'Bookshelf',
      'en': 'Bookshelf',
      'fr': 'Bibliothèque',
      'es': 'Librería',
      'de': 'Bücherregal',
      'pl': 'Biblioteczka',
      'ru': 'Книжный шкаф',
      'uk': 'Книжкова полиця',
      'ko': '책장',
      'zh': '书架',
      'ja': '本棚',
    }, {
      'id': 'Brazier',
      'en': 'Brazier',
      'fr': 'Braséro en fer',
      'es': 'Bracero',
      'de': 'Feuerschale',
      'pl': 'Koksownik',
      'ru': 'Жаровня',
      'uk': 'Жаровня',
      'ko': '화로',
      'zh': '火盆',
      'ja': '火鉢',
    }, {
      'id': 'Bread',
      'en': 'Bread',
      'fr': 'Pain',
      'es': 'Pan',
      'de': 'Brot',
      'pl': 'Chleb',
      'ru': 'Хлеб',
      'uk': 'Хліб',
      'ko': '빵',
      'zh': '面包',
      'ja': 'パン',
    }, {
      'id': 'BrickFireplace',
      'en': 'Brick Fireplace',
      'fr': 'Cheminée en briques',
      'es': 'Chimenea de ladrillos',
      'de': 'Backsteinkamin',
      'pl': 'Ceglany kominek',
      'ru': 'Кирпичный камин',
      'uk': 'Цегляний камін',
      'ko': '벽돌 벽난로',
      'zh': '砖壁炉',
      'ja': 'Brick Fireplace',
    }, {
      'id': 'Brick',
      'en': 'Brick',
      'fr': 'Brique',
      'es': 'Ladrillo',
      'de': 'Ziegel aus Lehm',
      'pl': 'Cegła',
      'ru': 'Кирпич',
      'uk': 'Цегла',
      'ko': '벽돌',
      'zh': '砖块',
      'ja': 'レンガ',
    }, {
      'id': 'ShaleBrick',
      'en': 'Shale Brick',
      'fr': 'Brique de schiste',
      'es': 'Ladrillo de pizarra',
      'de': 'Lehmziegel mit Schiefer',
      'pl': 'Cegła łupkowa',
      'ru': 'Сланцевый кирпич',
      'uk': 'Сланцева цегла',
      'ko': '이판암 벽돌',
      'zh': '页岩砖',
      'ja': 'Shale Brick',
    }, {
      'id': 'BuilderBoots',
      'en': 'Builder Boots',
      'fr': 'Bottes de maçon',
      'es': 'Botas de constructor',
      'de': 'Baumeisterstiefel',
      'pl': 'Builder Boots',
      'ru': 'Ботинки Строителя',
      'uk': 'Builder Boots',
      'ko': '빌더 부츠',
      'zh': '建筑工的靴子',
      'ja': 'Builder Boots',
    }, {
      'id': 'BuilderGloves',
      'en': 'Builder Gloves',
      'fr': 'Gants de maçon',
      'es': 'Guantes de constructor',
      'de': 'Baumeisterhandschuhe',
      'pl': 'Builder Gloves',
      'ru': 'Перчатки Строителя',
      'uk': 'Builder Gloves',
      'ko': '빌더 장갑',
      'zh': '建筑工的手套',
      'ja': 'Builder Gloves',
    }, {
      'id': 'BuilderHelmet',
      'en': 'Builder Helmet',
      'fr': 'Casque de maçon',
      'es': 'Casco de constructor',
      'de': 'Baumeisterhelm',
      'pl': 'Builder Helmet',
      'ru': 'Каска Строителя',
      'uk': 'Builder Helmet',
      'ko': '빌더 헬멧',
      'zh': '建筑工的安全帽',
      'ja': 'Builder Helmet',
    }, {
      'id': 'BuilderOveralls',
      'en': 'Builder Overalls',
      'fr': 'Salopette de maçon',
      'es': 'Mono de constructor',
      'de': 'Baumeisteroverall',
      'pl': 'Builder Overalls',
      'ru': 'Комбинезон Строителя',
      'uk': 'Builder Overalls',
      'ko': '빌더 작업복',
      'zh': '建筑工的工装裤',
      'ja': 'Builder Overalls',
    }, {
      'id': 'BuilderShirt',
      'en': 'Builder Shirt',
      'fr': 'Chemise de maçon',
      'es': 'Camisa de constructor',
      'de': 'Baumeisterhemd',
      'pl': 'Builder Shirt',
      'ru': 'Рубашка Строителя',
      'uk': 'Builder Shirt',
      'ko': '빌더 셔츠',
      'zh': '建筑工的衬衫',
      'ja': 'Builder Shirt',
    }, {
      'id': 'ButcheryTable',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de carnicería',
      'de': 'Metzgertisch',
      'pl': 'Stół rzeźnicki',
      'ru': 'Разделочный стол',
      'uk': 'Різницький стіл',
      'ko': '도축 작업대',
      'zh': '肉加工工作台',
      'ja': '食肉加工台',
    }, {
      'id': 'ButcheryUpgrade',
      'en': 'Butchery Upgrade',
      'fr': 'Amélioration Basique : Boucherie',
      'es': 'Mejora: Carnicería',
      'de': 'Grundlegendes Upgrade: Metzgerei',
      'pl': 'Ulepszenie Rzeźnictwa',
      'ru': 'Улучшение разделки',
      'uk': 'Покращення різництва',
      'ko': '도축 기술 업그레이드',
      'zh': '加工升级组件',
      'ja': 'Butchery Upgrade',
    }, {
      'id': 'CO2Canister',
      'en': 'CO2 Canister',
      'fr': 'Cartouche de CO2',
      'es': 'Botella de CO2',
      'de': 'CO₂-Kanister',
      'pl': 'CO2 Canister',
      'ru': 'Баллон CO2',
      'uk': 'CO2 Canister',
      'ko': 'CO2 통',
      'zh': '二氧化碳罐',
      'ja': 'CO2 Canister',
    }, {
      'id': 'CamasAshFertilizer',
      'en': 'Camas Ash Fertilizer',
      'fr': 'Engrais à la cendre de camassia',
      'es': 'Fertilizante de cenizas de camasia',
      'de': 'Dünger aus Prärielilienasche',
      'pl': 'Nawóz z popiołu Kamasji',
      'ru': 'Удобрение из пепла камассии',
      'uk': 'Добриво з попелу камасії',
      'ko': '카마스 재 비료',
      'zh': '卡马斯灰化肥',
      'ja': 'カマシア灰の肥料',
    }, {
      'id': 'CamasBread',
      'en': 'Camas Bread',
      'fr': 'Pain au camassia',
      'es': 'Pan de camasia',
      'de': 'Prärielilienbrot',
      'pl': 'Chleb Kamasjowy',
      'ru': 'Хлеб с камассией',
      'uk': 'Хліб з камасією',
      'ko': '카마스 빵',
      'zh': '卡马斯面包',
      'ja': 'カマシアパン',
    }, {
      'id': 'CamasBulbBake',
      'en': 'Camas Bulb Bake',
      'fr': 'Bulbe de camassia cuit',
      'es': 'Bulbo de camasia horneado',
      'de': 'Gebackene Prärielilienzwiebel',
      'pl': 'Ciasto z bulw Kamasji',
      'ru': 'Запечённая луковица камассии',
      'uk': 'Запечена цибулина камасії',
      'ko': '구운 카마스 구근',
      'zh': '烤卡马斯球茎',
      'ja': '焼いたカマシアの球根',
    }, {
      'id': 'CamasPaste',
      'en': 'Camas Paste',
      'fr': 'Pâte de camassia',
      'es': 'Pasta de camasia',
      'de': 'Prärielilienpaste',
      'pl': 'Pasta z Kamasji',
      'ru': 'Паста из камассии',
      'uk': 'Паста з камасії',
      'ko': '갈린 카마스',
      'zh': '卡马斯浆',
      'ja': 'ペースト状のカマシア',
    }, {
      'id': 'CamoPants',
      'en': 'Camo Pants',
      'fr': 'Pantalon de camouflage',
      'es': 'Pantalones de Camuflaje',
      'de': 'Tarnhose',
      'pl': 'Spodnie Moro',
      'ru': 'Камуфляжные штаны',
      'uk': 'Камуфляжні штани',
      'ko': '위장무늬 바지',
      'zh': '迷彩裤',
      'ja': 'カモパンツ',
    }, {
      'id': 'CamoShirt',
      'en': 'Camo Shirt',
      'fr': 'Chemise de camouflage',
      'es': 'Camiseta de Camuflaje',
      'de': 'Tarnshirt',
      'pl': 'Koszula Moro',
      'ru': 'Камуфляжная рубашка',
      'uk': 'Камуфляжна сорочка',
      'ko': '위장무늬 셔츠',
      'zh': '迷彩衬衫',
      'ja': 'カモシャツ',
    }, {
      'id': 'CampfireCookingUpgrade',
      'en': 'Campfire Cooking Upgrade',
      'fr': 'Amélioration Basique : Cuisine au feu de camp',
      'es': 'Mejora: Cocina con fogata',
      'de': 'Grundlegendes Upgrade: Lagerfeuerkochen',
      'pl': 'Ulepszenie Gotowania Na Ognisku',
      'ru': 'Улучшение для готовки на костре',
      'uk': 'Покращення приготування їжі на багатті',
      'ko': '모닥불 요리 기술 업그레이드',
      'zh': '篝火烹饪升级',
      'ja': 'Campfire Cooking Upgrade',
    }, {
      'id': 'CampfireRoast',
      'en': 'Campfire Roast',
      'fr': 'Rôti cuit au feu de bois',
      'es': 'Asado a la Fogata',
      'de': 'Lagerfeuerbraten',
      'pl': 'Pieczeń z ogniska',
      'ru': 'Жаркое на костре',
      'uk': 'Печеня на багатті',
      'ko': '모닥불 구운 고기',
      'zh': '篝火烧肉',
      'ja': '野外調理のロースト',
    }, {
      'id': 'Campsite',
      'en': 'Campsite',
      'fr': 'Camping',
      'es': 'Campamento',
      'de': 'Campingplatz',
      'pl': 'Obóz',
      'ru': 'Палатка',
      'uk': 'Кемпінг',
      'ko': '야영지',
      'zh': '营地',
      'ja': 'キャンプサイト',
    }, {
      'id': 'CandleStand',
      'en': 'Candle Stand',
      'fr': 'Bougeoir',
      'es': 'Soporte de Vela',
      'de': 'Kerzenständer',
      'pl': 'Stojak na świecę',
      'ru': 'Подсвечник',
      'uk': 'Підсвічник',
      'ko': '촛대',
      'zh': '烛台',
      'ja': 'ろうそく立て',
    }, {
      'id': 'Capris',
      'en': 'Capris',
      'fr': 'Corsaire',
      'es': 'Pantalones Caprí',
      'de': 'Caprihose',
      'pl': 'Rybaczki',
      'ru': 'Короткие брюки',
      'uk': 'Капрі',
      'ko': '칠부 바지',
      'zh': '紧身裤',
      'ja': 'カプリ',
    }, {
      'id': 'CarpentryAdvancedUpgrade',
      'en': 'Carpentry Advanced Upgrade',
      'fr': 'Amélioration Avancée : Menuiserie',
      'es': 'Mejora avanzada: Carpintería',
      'de': 'Fortschrittliches Upgrade: Schreinerei',
      'pl': 'Zaawansowane ulepszenie Stolarstwa',
      'ru': 'Продвинутое улучшение для плотницкого дела',
      'uk': 'Carpentry Advanced Upgrade',
      'ko': '고급 목공 기술 업그레이드',
      'zh': '木工高级升级',
      'ja': 'Carpentry Advanced Upgrade',
    }, {
      'id': 'CarpentryBasicUpgrade',
      'en': 'Carpentry Basic Upgrade',
      'fr': 'Amélioration Basique : Menuiserie',
      'es': 'Mejora básica: Carpintería',
      'de': 'Grundlegendes Upgrade: Schreinerei',
      'pl': 'Podstawowe ulepszenie Stolarstwa',
      'ru': 'Базовое улучшение для плотницкого дела',
      'uk': 'Carpentry Basic Upgrade',
      'ko': '기초 목공 기술 업그레이드',
      'zh': '木工基础升级',
      'ja': 'Carpentry Basic Upgrade',
    }, {
      'id': 'CarvedPumpkin',
      'en': 'Carved Pumpkin',
      'fr': 'Citrouille sculptée',
      'es': 'Calabaza tallada',
      'de': 'Geschnitzter Kürbis',
      'pl': 'Wydrążona dynia',
      'ru': 'Резная тыква',
      'uk': 'Різьблений гарбуз',
      'ko': '조각된 호박',
      'zh': '南瓜灯',
      'ja': '切り分けられたカボチャ',
    }, {
      'id': 'CastIronBed',
      'en': 'Cast Iron Bed',
      'fr': 'Lit en fer forgé',
      'es': 'Cama de hierro fundido',
      'de': 'Gusseisernes Bett',
      'pl': 'Cast Iron Bed',
      'ru': 'Чугунная кровать',
      'uk': 'Cast Iron Bed',
      'ko': '무쇠 침대',
      'zh': '铸铁床',
      'ja': 'Cast Iron Bed',
    }, {
      'id': 'CastIronRoyalBed',
      'en': 'Cast Iron Royal Bed',
      'fr': 'Lit royal en fer forgé',
      'es': 'Cama de lujo de hierro fundido',
      'de': 'Gusseisernes Königliches Bett',
      'pl': 'Cast Iron Royal Bed',
      'ru': 'Чугунная Королевская Кровать',
      'uk': 'Cast Iron Royal Bed',
      'ko': '무쇠 로얄 침대',
      'zh': '铸铁皇家床',
      'ja': 'Cast Iron Royal Bed',
    }, {
      'id': 'CastIronStove',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Gusseiserner Ofen',
      'pl': 'Żeliwna kuchnia',
      'ru': 'Чугунная плита',
      'uk': 'Чавунна піч',
      'ko': '철재 화덕',
      'zh': '铸铁火炉',
      'ja': '鋳鉄のストーブ',
    }, {
      'id': 'CeilingCandle',
      'en': 'Ceiling Candle',
      'fr': 'Lustre à bougies',
      'es': 'Vela de Techo',
      'de': 'Deckenlampe',
      'pl': 'Kandelabr',
      'ru': 'Люстра со свечами',
      'uk': 'Люстра зі свічками',
      'ko': '천장 촛대',
      'zh': '吊式烛灯',
      'ja': '吊り下げろうそく',
    }, {
      'id': 'CelluloseFiber',
      'en': 'Cellulose Fiber',
      'fr': 'Fibres de cellulose',
      'es': 'Fibra de celulosa',
      'de': 'Zellulosefaser',
      'pl': 'Włókna celulozowe',
      'ru': 'Целлюлозное волокно',
      'uk': 'Клітковина',
      'ko': '셀룰로오스 섬유',
      'zh': '人造纤维',
      'ja': 'セルロース繊維',
    }, {
      'id': 'Cement',
      'en': 'Cement',
      'fr': 'Ciment',
      'es': 'Cemento',
      'de': 'Zement',
      'pl': 'Cement',
      'ru': 'Цемент',
      'uk': 'Цемент',
      'ko': '시멘트 제조 기술',
      'zh': '水泥',
      'ja': 'セメント',
    }, {
      'id': 'CementKiln',
      'en': 'Cement Kiln',
      'fr': 'Four à ciment',
      'es': 'Horno de Cemento',
      'de': 'Zementbrennofen',
      'pl': 'Cementownia',
      'ru': 'Барабанная печь',
      'uk': 'Піч для цементу',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントのかまど',
    }, {
      'id': 'Chainsaw',
      'en': 'Chainsaw',
      'fr': 'Tronçonneuse',
      'es': 'Motosierra',
      'de': 'Kettensäge',
      'pl': 'Piła Łańcuchowa',
      'ru': 'Бензопила',
      'uk': 'Бензопила',
      'ko': '전기톱',
      'zh': '链锯',
      'ja': 'チェーンソー',
    }, {
      'id': 'Charcoal',
      'en': 'Charcoal',
      'fr': 'Charbon de bois',
      'es': 'Carbón vegetal',
      'de': 'Holzkohle',
      'pl': 'Węgiel drzewny',
      'ru': 'Древесный уголь',
      'uk': 'Вугілля з деревини',
      'ko': '숯',
      'zh': '木炭',
      'ja': '木炭',
    }, {
      'id': 'CharredAgave',
      'en': 'Charred Agave',
      'fr': 'Agave carbonisé',
      'es': 'Agave carbonizado',
      'de': 'Verschmorte Agave',
      'pl': 'Opiekana Agawa',
      'ru': 'Агава на углях',
      'uk': 'Обвуглена агава',
      'ko': '그슬린 용설란',
      'zh': '烧焦的龙舌兰',
      'ja': '焦げたリュウゼツラン',
    }, {
      'id': 'CharredBeans',
      'en': 'Charred Beans',
      'fr': 'Haricots carbonisés',
      'es': 'Judías carbonizadas',
      'de': 'Verschmorte Bohnen',
      'pl': 'Opiekana Fasola',
      'ru': 'Бобы на углях',
      'uk': 'Квасоля, приготована на вугіллі',
      'ko': '그슬린 콩',
      'zh': '烧焦的豆',
      'ja': 'Charred Beans',
    }, {
      'id': 'CharredBeet',
      'en': 'Charred Beet',
      'fr': 'Betterave carbonisée',
      'es': 'Remolacha carbonizada',
      'de': 'Verschmorte Rote Bete',
      'pl': 'Opiekany burak',
      'ru': 'Свёкла на углях',
      'uk': 'Обвуглений буряк',
      'ko': '그슬린 사탕무',
      'zh': '烧焦的甜菜',
      'ja': '焦げたビート',
    }, {
      'id': 'CharredCactusFruit',
      'en': 'Charred Cactus Fruit',
      'fr': 'Fruit de Saguaro carbonisé',
      'es': 'Fruto de cactus carbonizado',
      'de': 'Verschmorte Kaktusfrucht',
      'pl': 'Opiekany Owoc Kaktusa',
      'ru': 'Плод сагуаро на углях',
      'uk': 'Опунція, приготована на вугіллі',
      'ko': '그슬린 백년초',
      'zh': '烧焦的仙人掌果',
      'ja': 'Charred Cactus Fruit',
    }, {
      'id': 'CharredCamasBulb',
      'en': 'Charred Camas Bulb',
      'fr': 'Bulbe de camassia carbonisé',
      'es': 'Bulbo de camasia carbonizado',
      'de': 'Verschmorte Prärielilienzwiebel',
      'pl': 'Opiekana Bulwa Kamasji',
      'ru': 'Обжаренная луковица камассии',
      'uk': 'Обвуглена цибулина камасії',
      'ko': '그슬린 카마스 구근',
      'zh': '烧焦的卡马斯球茎',
      'ja': '焦げたカマシアの球根',
    }, {
      'id': 'CharredCorn',
      'en': 'Charred Corn',
      'fr': 'Maïs carbonisé',
      'es': 'Maíz carbonizado',
      'de': 'Verschmorter Mais',
      'pl': 'Opiekana Kukurydza',
      'ru': 'Кукуруза на углях',
      'uk': 'Обвуглений кукурудзяний качан',
      'ko': '그슬린 옥수수',
      'zh': '烧焦的玉米',
      'ja': '焦げたトウモロコシ',
    }, {
      'id': 'CharredFireweedShoots',
      'en': 'Charred Fireweed Shoots',
      'fr': 'Pousses d\u0027épilobe carbonisées',
      'es': 'Brotes de epilobio carbonizados',
      'de': 'Verschmorte Weidenröschenwurzel',
      'pl': 'Opiekane Pędy Wierzbówki',
      'ru': 'Иван-чай на углях',
      'uk': 'Іван-чай на вуглях',
      'ko': '그슬린 분홍바늘꽃 순',
      'zh': '烧焦的杂草芽',
      'ja': 'Charred Fireweed Shoots',
    }, {
      'id': 'CampfireFishLarge',
      'en': 'Campfire Fish Large',
      'fr': 'Poisson moyen grand au feu de camp',
      'es': 'Pescado a la brasa (animal grande)',
      'de': 'Gegrillter Fisch - groß',
      'pl': 'Campfire Fish Large',
      'ru': 'Пожарить большую рыбу',
      'uk': 'Campfire Fish Large',
      'ko': '캠프파이어 피쉬 라지',
      'zh': '篝火慢烤鱼（大型）',
      'ja': 'Campfire Fish Large',
    }, {
      'id': 'CampfireFishMedium',
      'en': 'Campfire Fish Medium',
      'fr': 'Poisson moyen cuit au feu de camp',
      'es': 'Pescado a la brasa (animal mediano)',
      'de': 'Gegrillter Fisch - normal',
      'pl': 'Campfire Fish Medium',
      'ru': 'Пожарить среднюю рыбу',
      'uk': 'Campfire Fish Medium',
      'ko': '캠프파이어 피쉬 미디엄',
      'zh': '篝火慢烤鱼（中型）',
      'ja': 'Campfire Fish Medium',
    }, {
      'id': 'CampfireFishSmall',
      'en': 'Campfire Fish Small',
      'fr': 'Poisson petit cuit au feu de camp',
      'es': 'Pescado pequeño a la brasa',
      'de': 'Lagerfeuer Fisch (klein)',
      'pl': 'Campfire Fish Small',
      'ru': 'Маленькая рыба на костре',
      'uk': 'Мала риба на вогнищі',
      'ko': 'Campfire Fish Small',
      'zh': '篝火慢烤鱼（小型）',
      'ja': 'Campfire Fish Small',
    }, {
      'id': 'CampfirePacificSardine',
      'en': 'Campfire Pacific Sardine',
      'fr': 'Sardine du Pacifique cuite au feu de camp',
      'es': 'Sardina del Pacífico braseada',
      'de': 'Gegrillte Pazifische Sardine',
      'pl': 'Pacyficzna sardynka z ogniska',
      'ru': 'Жареная на костре перуанская сардина',
      'uk': 'Перуанська сардина на багатті',
      'ko': '태평양 정어리 모닥불 요리',
      'zh': '篝火太平洋沙丁鱼',
      'ja': 'Campfire Pacific Sardine',
    }, {
      'id': 'CharredFish',
      'en': 'Charred Fish',
      'fr': 'Poisson carbonisé',
      'es': 'Pescado carbonizado',
      'de': 'Verschmorter Fisch',
      'pl': 'Opiekana Ryba',
      'ru': 'Жареная на костре рыба',
      'uk': 'Обвуглена риба',
      'ko': '그슬린 생선',
      'zh': '烧焦的鱼',
      'ja': '焦げた魚',
    }, {
      'id': 'CharredHeartOfPalm',
      'en': 'Charred Heart Of Palm',
      'fr': 'Cœur de palmier carbonisé',
      'es': 'Palmito carbonizado',
      'de': 'Verschmorte Palmherzen',
      'pl': 'Opiekane Serce Palmy',
      'ru': 'Сердцевина пальмы на углях',
      'uk': 'Серцевина пальми, приготована на вугіллі',
      'ko': '그슬린 대추야자 나무순',
      'zh': '烧焦的棕榈心',
      'ja': 'Charred Heart Of Palm',
    }, {
      'id': 'CampfireAnimalMedium',
      'en': 'Campfire Animal Medium',
      'fr': 'Animal moyen cuit au feu de camp',
      'es': 'Solomillo a la brasa (animal mediano)',
      'de': 'Gegrilltes Tierfleisch - normal',
      'pl': 'Średnie zwierzę z ogniska',
      'ru': 'Жареное на костре среднее животное',
      'uk': 'Середня тварина на вогнищі',
      'ko': '중형 동물 모닥불 구이',
      'zh': '篝火动物（中型）',
      'ja': 'Campfire Animal Medium',
    }, {
      'id': 'CampfireAnimalSmall',
      'en': 'Campfire Animal Small',
      'fr': 'Animal petit cuit au feu de camp',
      'es': 'Solomillo a la brasa (animal pequeño)',
      'de': 'Gegrilltes Tierfleisch - klein',
      'pl': 'Małe zwierzę z ogniska',
      'ru': 'Жареное на костре маленькое животное',
      'uk': 'Мала тварина на вогнищі',
      'ko': '소형 동물 모닥불 구이',
      'zh': '篝火动物（小型）',
      'ja': 'Campfire Animal Small',
    }, {
      'id': 'CampfireAnimalTiny',
      'en': 'Campfire Animal Tiny',
      'fr': 'Animal minucule cuit au feu de camp',
      'es': 'Solomillo a la brasa (animal diminuto)',
      'de': 'Gegrilltes Tierfleisch - winzig',
      'pl': 'Malutkie zwierzę z ogniska',
      'ru': 'Жареное на костре крошечное животное',
      'uk': 'Крихітна тварина на вогнищі',
      'ko': '극소형 동물 모닥불 구이',
      'zh': '篝火动物（迷你）',
      'ja': 'Campfire Animal Tiny',
    }, {
      'id': 'CampfireBison',
      'en': 'Campfire Bison',
      'fr': 'Bison cuit au feu de bois',
      'es': 'Bisonte a la brasa',
      'de': 'Lagerfeuerbison',
      'pl': 'Mięso żubra z ogniska',
      'ru': 'Жареный на костре бизон',
      'uk': 'Бізоняче м’ясо на багатті',
      'ko': '들소 모닥불 요리',
      'zh': '篝火慢烤野牛肉',
      'ja': '野外調理のバイソン',
    }, {
      'id': 'CharredMeat',
      'en': 'Charred Meat',
      'fr': 'Viande carbonisée',
      'es': 'Carne carbonizada',
      'de': 'Verschmortes Fleisch',
      'pl': 'Opiekane Mięso',
      'ru': 'Жареное на костре мясо',
      'uk': 'Обвуглене м’ясо',
      'ko': '그슬린 고기',
      'zh': '烧焦的肉',
      'ja': '焦げた肉',
    }, {
      'id': 'CharredMushrooms',
      'en': 'Charred Mushrooms',
      'fr': 'Champignons carbonisés',
      'es': 'Champiñones carbonizados',
      'de': 'Verschmorte Pilze',
      'pl': 'Opiekane Grzyby',
      'ru': 'Грибы на углях',
      'uk': 'Гриби на вугіллі',
      'ko': '그슬린 버섯',
      'zh': '烧焦的蘑菇',
      'ja': 'Charred Mushrooms',
    }, {
      'id': 'CharredPapaya',
      'en': 'Charred Papaya',
      'fr': 'Papaye carbonisée',
      'es': 'Papaya Carbonizada',
      'de': 'Verschmorte Papaya',
      'pl': 'Opiekana papaja',
      'ru': 'Папайя на углях',
      'uk': 'Обвуглена папая',
      'ko': '그슬린 파파야',
      'zh': '烧焦的木瓜',
      'ja': '焦げたパパイヤ',
    }, {
      'id': 'CharredPineapple',
      'en': 'Charred Pineapple',
      'fr': 'Ananas carbonisé',
      'es': 'Piña Carbonizada',
      'de': 'Verschmorte Ananas',
      'pl': 'Opiekany Ananas',
      'ru': 'Ананас на углях',
      'uk': 'Обвуглений ананас',
      'ko': '그슬린 파인애플',
      'zh': '烧焦的菠萝',
      'ja': '焦げたパイナップル',
    }, {
      'id': 'CharredSausage',
      'en': 'Charred Sausage',
      'fr': 'Saucisse carbonisée',
      'es': 'Salchicha Carbonizada',
      'de': 'Verschmorte Wurst',
      'pl': 'Opiekana Kiełbasa',
      'ru': 'Сарделька на углях',
      'uk': 'Обвуглена сарделька',
      'ko': '그슬린 소시지',
      'zh': '烧焦的香肠',
      'ja': '焦げたソーセージ',
    }, {
      'id': 'CharredTaro',
      'en': 'Charred Taro',
      'fr': 'Taro carbonisé',
      'es': 'Taro Carbonizado',
      'de': 'Verschmorte Taro',
      'pl': 'Opiekana Kolokazja',
      'ru': 'Таро на углях',
      'uk': 'Обвуглене таро',
      'ko': '그슬린 토란',
      'zh': '烧焦的芋头',
      'ja': '焦げたタロイモ',
    }, {
      'id': 'CharredTomato',
      'en': 'Charred Tomato',
      'fr': 'Tomate carbonisée',
      'es': 'Tomate Carbonizado',
      'de': 'Verschmorte Tomate',
      'pl': 'Opiekany Pomidor',
      'ru': 'Помидор на углях',
      'uk': 'Обвуглений помідор',
      'ko': '그슬린 토마토',
      'zh': '烧焦的番茄',
      'ja': '焦げたトマト',
    }, {
      'id': 'ChefHat',
      'en': 'Chef Hat',
      'fr': 'Toque de cuisinier',
      'es': 'Gorro de cocinero',
      'de': 'Kochmütze',
      'pl': 'Chef Hat',
      'ru': 'Колпак Повара',
      'uk': 'Chef Hat',
      'ko': '요리사 모자',
      'zh': '厨师的帽子',
      'ja': 'Chef Hat',
    }, {
      'id': 'ChefPants',
      'en': 'Chef Pants',
      'fr': 'Pantalon de cuisinier',
      'es': 'Pantalones de cocinero',
      'de': 'Kochhosen',
      'pl': 'Chef Pants',
      'ru': 'Штаны Повара',
      'uk': 'Chef Pants',
      'ko': '요리사 바지',
      'zh': '厨师的裤子',
      'ja': 'Chef Pants',
    }, {
      'id': 'ChefShirt',
      'en': 'Chef Shirt',
      'fr': 'Veste de cuisinier',
      'es': 'Camisa de cocinero',
      'de': 'Kochhemd',
      'pl': 'Chef Shirt',
      'ru': 'Китель Повара',
      'uk': 'Chef Shirt',
      'ko': '요리사 셔츠',
      'zh': '厨师的衬衫',
      'ja': 'Chef Shirt',
    }, {
      'id': 'ChefShoes',
      'en': 'Chef Shoes',
      'fr': 'Chaussures de sécurité de cuisiner',
      'es': 'Zapatos de cocinero',
      'de': 'Kochschuhe',
      'pl': 'Chef Shoes',
      'ru': 'Ботинки Повара',
      'uk': 'Chef Shoes',
      'ko': '요리사 신발',
      'zh': '厨师的鞋子',
      'ja': 'Chef Shoes',
    }, {
      'id': 'ClamChowder',
      'en': 'Clam Chowder',
      'fr': 'Chaudrée de palourdes',
      'es': 'Sopa de mariscos',
      'de': 'Suppe mit Muscheln',
      'pl': 'Clam Chowder',
      'ru': 'Похлебка из моллюсков',
      'uk': 'Clam Chowder',
      'ko': 'Clam Chowder',
      'zh': '蛤蜊汤',
      'ja': 'Clam Chowder',
    }, {
      'id': 'ClothBelt',
      'en': 'Cloth Belt',
      'fr': 'Ceinture en tissu',
      'es': 'Cinturón de tela',
      'de': 'Gürtel',
      'pl': 'Bluza na pasie',
      'ru': 'Тканый пояс',
      'uk': 'Тканинний ремінь',
      'ko': '천 벨트',
      'zh': '布带',
      'ja': 'Cloth Belt',
    }, {
      'id': 'ClothCape',
      'en': 'Cloth Cape',
      'fr': 'Cape en tissu',
      'es': 'Capa de tela',
      'de': 'Stoffumhang',
      'pl': 'Płaszcz z tkaniny',
      'ru': 'Тканевая накидка',
      'uk': 'Тканинна накидка',
      'ko': '천 망토',
      'zh': '布斗篷',
      'ja': 'Cloth Cape',
    }, {
      'id': 'Cloth',
      'en': 'Cloth',
      'fr': 'Tissu',
      'es': 'Tela',
      'de': 'Stoff',
      'pl': 'Tkanina',
      'ru': 'Ткань',
      'uk': 'Тканина',
      'ko': '천',
      'zh': '布料',
      'ja': '布',
    }, {
      'id': 'CombustionEngine',
      'en': 'Combustion Engine',
      'fr': 'Moteur à combustion',
      'es': 'Motor de Combustión',
      'de': 'Verbrennungsmotor',
      'pl': 'Silnik spalinowy',
      'ru': 'Двигатель внутреннего сгорания',
      'uk': 'Двигун внутрішнього згоряння',
      'ko': '연소기관',
      'zh': '内燃机',
      'ja': '内燃機関',
    }, {
      'id': 'CombustionGenerator',
      'en': 'Combustion Generator',
      'fr': 'Générateur à combustion',
      'es': 'Generador de Combustión',
      'de': 'Verbrennungsgenerator',
      'pl': 'Generator Spalinowy',
      'ru': 'Генератор внутреннего сгорания',
      'uk': 'Генератор внутрішнього згоряння',
      'ko': '연소 발전기',
      'zh': '内燃发电机',
      'ja': '火力発電機',
    }, {
      'id': 'CompositeBow',
      'en': 'Composite Bow',
      'fr': 'Arc composite',
      'es': 'Arco de madera de composite',
      'de': 'Kompositbogen',
      'pl': 'Composite Bow',
      'ru': 'Композитный лук',
      'uk': 'Composite Bow',
      'ko': '합성 활',
      'zh': '复合弓',
      'ja': 'Composite Bow',
    }, {
      'id': 'CompositeFiller',
      'en': 'Composite Filler',
      'fr': 'Garnissage mélangé',
      'es': 'Relleno de Compuesto',
      'de': 'Füller aus Verbundstoffen',
      'pl': 'Wypełniacz kompozytowy',
      'ru': 'Композитный наполнитель',
      'uk': 'Композитний наповнювач',
      'ko': '합성 보충제',
      'zh': '复合填料',
      'ja': '複合フィラー',
    }, {
      'id': 'CompositeLumberBench',
      'en': 'Composite Lumber Bench',
      'fr': 'Banc en composite',
      'es': 'Banco de composite (básica)',
      'de': 'Verbundholz-Bank',
      'pl': 'Kompozytowa ławka z drewna',
      'ru': 'Лавка из композитов',
      'uk': 'Лавка з композитних пиломатеріалів',
      'ko': '합성 가공 목재 벤치',
      'zh': '复合木材长凳',
      'ja': 'Composite Lumber Bench',
    }, {
      'id': 'CompositeLumberChair',
      'en': 'Composite Lumber Chair',
      'fr': 'Chaise en composite',
      'es': 'Silla de composite (básica)',
      'de': 'Verbundholz-Stuhl',
      'pl': 'Kompozytowe krzesło z drewna',
      'ru': 'Стул из композитов',
      'uk': 'Стілець із композитних пиломатеріалів',
      'ko': '합성 가공 목재 의자',
      'zh': '复合木椅',
      'ja': 'Composite Lumber Chair',
    }, {
      'id': 'CompositeLumberDoor',
      'en': 'Composite Lumber Door',
      'fr': 'Porte en composite',
      'es': 'Puerta de composite (básica)',
      'de': 'Verbundholz-Tür',
      'pl': 'Kompozytowe drzwi z drewna',
      'ru': 'Дверь из композитов',
      'uk': 'Двері з композитних пиломатеріалів',
      'ko': '합성 가공 목재 문',
      'zh': '复合木门',
      'ja': 'Composite Lumber Door',
    }, {
      'id': 'CompositeLumber',
      'en': 'Composite Lumber',
      'fr': 'Bois composite',
      'es': 'Tronco (composite)',
      'de': 'Verbundholz',
      'pl': 'Kompozytowe drewno',
      'ru': 'Композитные пиломатериалы',
      'uk': 'Композитні пиломатеріали',
      'ko': '가공된 합성 목재',
      'zh': '复合木材',
      'ja': 'Composite Lumber',
    }, {
      'id': 'CompositeLumberTable',
      'en': 'Composite Lumber Table',
      'fr': 'Table en composite',
      'es': 'Mesa de composite (básica)',
      'de': 'Verbundholz-Tisch',
      'pl': 'Kompozytowy stół z drewna',
      'ru': 'Стол из композитов',
      'uk': 'Стіл із композитних пиломатеріалів',
      'ko': '합성 가공 목재 탁자',
      'zh': '复合木桌',
      'ja': 'Composite Lumber Table',
    }, {
      'id': 'CompositesUpgrade',
      'en': 'Composites Upgrade',
      'fr': 'Amélioration Moderne : Composites',
      'es': 'Mejora: Composites',
      'de': 'Upgrade Verbundhölzer',
      'pl': 'Ulepszenie Kompozytów',
      'ru': 'Улучшение для изготовления композитов',
      'uk': 'Покращення сполук',
      'ko': '복합 목재 기술 업그레이드',
      'zh': '复合材料升级',
      'ja': '複合材アップグレード',
    }, {
      'id': 'CompostFertilizer',
      'en': 'Compost Fertilizer',
      'fr': 'Engrais de compost',
      'es': 'Fertilizante de abono orgánico',
      'de': 'Dünger aus Kompost',
      'pl': 'Compost Fertilizer',
      'ru': 'Компостное удобрение',
      'uk': 'Компостне добриво',
      'ko': '퇴비 비료',
      'zh': '堆肥',
      'ja': '堆肥',
    }, {
      'id': 'ComputerLab',
      'en': 'Computer Lab',
      'fr': 'Ordinateur de contrôle',
      'es': 'Laboratorio de Computación',
      'de': 'Computerlabor',
      'pl': 'Laboratorium komputerowe',
      'ru': 'Компьютерная лаборатория',
      'uk': 'Комп’ютерна лабораторія',
      'ko': '컴퓨터 연구대',
      'zh': '实验室电脑',
      'ja': 'コンピューター室',
    }, {
      'id': 'CookeinaMushroomSpores',
      'en': 'Cookeina Mushroom Spores',
      'fr': 'Spores de cookeina',
      'es': 'Esporas de seta copa',
      'de': 'Sporen (Cookeina)',
      'pl': 'Zarodniki Grzybów Czarkowatych',
      'ru': 'Споры кукейны',
      'uk': 'Спори гриба кукейн',
      'ko': '술잔버섯 포자',
      'zh': '蘑菇孢子',
      'ja': 'クキーナキノコの胞子',
    }, {
      'id': 'CookingUpgrade',
      'en': 'Cooking Upgrade',
      'fr': 'Amélioration Avancée : Cuisine',
      'es': 'Mejora: Cocina',
      'de': 'Fortschrittliches Upgrade: Kochen',
      'pl': 'Ulepszenie Gotowania',
      'ru': 'Улучшение для готовки',
      'uk': 'Покращення приготування їжі',
      'ko': '요리 기술 업그레이드',
      'zh': '烹饪升级',
      'ja': 'Cooking Upgrade',
    }, {
      'id': 'CopperBar',
      'en': 'Copper Bar',
      'fr': 'Lingot de cuivre',
      'es': 'Barra de cobre',
      'de': 'Kupferbarren',
      'pl': 'Sztabka miedzi',
      'ru': 'Медный брусок',
      'uk': 'Мідний брусок',
      'ko': '구리괴',
      'zh': '铜条',
      'ja': '銅インゴット',
    }, {
      'id': 'SmeltCopper',
      'en': 'Smelt Copper',
      'fr': 'Fondre du cuivre',
      'es': 'Fundir Cobre',
      'de': 'Kupfer schmelzen',
      'pl': 'Smelt Copper',
      'ru': 'Плавить медь',
      'uk': 'Виплавити мідь',
      'ko': '구리 제련법',
      'zh': '冶铜',
      'ja': '銅の精錬',
    }, {
      'id': 'ConcentrateCopperLv2',
      'en': 'Concentrate Copper Lv2',
      'fr': 'Concentré de cuivre Nv2',
      'es': 'Concentrado de cobre (niv. 2)',
      'de': 'Kupferkonzentrat Lv2',
      'pl': 'Koncentrat miedzi Poz2',
      'ru': 'Концентрировать медь Ур.2',
      'uk': 'Концентрування міді Рів. 2',
      'ko': '정제된 구리 광석 Lv2',
      'zh': '浮选铜矿石 等级2',
      'ja': 'Concentrate Copper Lv2',
    }, {
      'id': 'CopperConcentrate',
      'en': 'Copper Concentrate',
      'fr': 'Concentré de cuivre',
      'es': 'Concentrado de cobre',
      'de': 'Kupferkonzentrat',
      'pl': 'Miedziany koncentrat',
      'ru': 'Концентрат меди',
      'uk': 'Концентрат міді',
      'ko': '정제된 구리 광석',
      'zh': '筛选铜矿石',
      'ja': 'Copper Concentrate',
    }, {
      'id': 'CopperPipe',
      'en': 'Copper Pipe',
      'fr': 'Tuyau en cuivre',
      'es': 'Tubo de Cobre',
      'de': 'Kupferrohr',
      'pl': 'Miedziana rura',
      'ru': 'Медная труба',
      'uk': 'Мідна труба',
      'ko': '구리 파이프',
      'zh': '铜管',
      'ja': '銅パイプ',
    }, {
      'id': 'CopperWiring',
      'en': 'Copper Wiring',
      'fr': 'Fil de cuivre',
      'es': 'Cableado de Cobre',
      'de': 'Kupferkabel',
      'pl': 'Miedziane przewody',
      'ru': 'Медный провод',
      'uk': 'Мідний дріт',
      'ko': '구리선',
      'zh': '铜线',
      'ja': '銅線',
    }, {
      'id': 'CornFritters',
      'en': 'Corn Fritters',
      'fr': 'Beignets de maïs',
      'es': 'Buñuelos de maíz',
      'de': 'Frittierter Mais',
      'pl': 'Kukurydza w cieście',
      'ru': 'Кукурузные оладьи',
      'uk': 'Кукурудзяні оладки',
      'ko': '옥수수튀김',
      'zh': '玉米煎饼',
      'ja': 'Kukurydza w cieście',
    }, {
      'id': 'CornSeed',
      'en': 'Corn Seed',
      'fr': 'Graine de maïs',
      'es': 'Semilla de Maíz',
      'de': 'Samen (Mais)',
      'pl': 'Nasiona Kukurydzy',
      'ru': 'Семечко кукурузы',
      'uk': 'Насіння кукурудзи',
      'ko': '옥수수 씨앗',
      'zh': '玉米种子',
      'ja': 'トウモロコシの種',
    }, {
      'id': 'CornStarch',
      'en': 'Corn Starch',
      'fr': 'Fécule de maïs',
      'es': 'Almidón de maíz',
      'de': 'Maisstärke',
      'pl': 'Mąka kukurydziana',
      'ru': 'Кукурузный крахмал',
      'uk': 'Кукурудзяний крохмаль',
      'ko': '옥수수 녹말풀',
      'zh': '玉米淀粉',
      'ja': 'Mąka kukurydziana',
    }, {
      'id': 'Cornmeal',
      'en': 'Cornmeal',
      'fr': 'Farine de maïs',
      'es': 'Harina de Maíz',
      'de': 'Maismehl',
      'pl': 'Kasza kukurydziana',
      'ru': 'Кукурузная мука',
      'uk': 'Кукурудзянe борошно',
      'ko': '옥수수 가루',
      'zh': '玉米粉',
      'ja': 'Kasza kukurydziana',
    }, {
      'id': 'CorrugatedSteelDoor',
      'en': 'Corrugated Steel Door',
      'fr': 'Porte en tôle ondulée',
      'es': 'Puerta (acero corrugado)',
      'de': 'Wellstahltür',
      'pl': 'Corrugated Steel Door',
      'ru': 'Дверь из гофрированной стали',
      'uk': 'Corrugated Steel Door',
      'ko': '골판지 강철 문',
      'zh': '波纹钢制门',
      'ja': 'Corrugated Steel Door',
    }, {
      'id': 'CorrugatedSteelFenceDoor',
      'en': 'Corrugated Steel Fence Door',
      'fr': 'Porte de clôture en tôle ondulée',
      'es': 'Puerta de valla (acero corrugado)',
      'de': 'Wellstahl Gittertür',
      'pl': 'Corrugated Steel Fence Door',
      'ru': 'Дверь из решетки гофрированной стали',
      'uk': 'Corrugated Steel Fence Door',
      'ko': '골판지 강철 울타리 문',
      'zh': '波纹钢制栅栏门',
      'ja': 'Corrugated Steel Fence Door',
    }, {
      'id': 'CorrugatedSteel',
      'en': 'Corrugated Steel',
      'fr': 'Tôle ondulée',
      'es': 'Acero Corrugado',
      'de': 'Wellblech',
      'pl': 'Stal ryflowana',
      'ru': 'Гофрированная сталь',
      'uk': 'Гофрована сталь',
      'ko': '파형 강철판',
      'zh': '波纹钢',
      'ja': '波形鋼',
    }, {
      'id': 'CottonCarpet',
      'en': 'Cotton Carpet',
      'fr': 'Tapis en coton',
      'es': 'Alfombra de algodón',
      'de': 'Baumwollteppich',
      'pl': 'Cotton Carpet',
      'ru': 'Хлопковый ковер',
      'uk': 'Cotton Carpet',
      'ko': '면 카펫',
      'zh': '棉制地毯',
      'ja': 'Cotton Carpet',
    }, {
      'id': 'CottonCurtains',
      'en': 'Cotton Curtains',
      'fr': 'Rideaux en coton',
      'es': 'Cortinas de algodón',
      'de': 'Baumwollvorhänge',
      'pl': 'Cotton Curtains',
      'ru': 'Хлопковые шторы',
      'uk': 'Cotton Curtains',
      'ko': '면 커튼',
      'zh': '棉制窗帘',
      'ja': 'Cotton Curtains',
    }, {
      'id': 'WeaveCottonCurtains',
      'en': 'Weave Cotton Curtains',
      'fr': 'Tisser des rideaux en coton',
      'es': 'Cortinas de Algodón Tejidas',
      'de': 'Webe Baumwollvorhänge',
      'pl': 'Weave Cotton Curtains',
      'ru': 'Ткать Хлопковые шторы',
      'uk': 'Weave Cotton Curtains',
      'ko': 'Weave Cotton Curtains',
      'zh': '纺织棉窗帘',
      'ja': 'Weave Cotton Curtains',
    }, {
      'id': 'CottonFabric',
      'en': 'Cotton Fabric',
      'fr': 'Tissu en coton',
      'es': 'Tela de algodón',
      'de': 'Baumwollstoff',
      'pl': 'Cotton Fabric',
      'ru': 'Хлопковая ткань',
      'uk': 'Cotton Fabric',
      'ko': '코튼 원단',
      'zh': '棉织物',
      'ja': 'Cotton Fabric',
    }, {
      'id': 'WeaveCottonFabric',
      'en': 'Weave Cotton Fabric',
      'fr': 'Tissu en coton à tisser',
      'es': 'Tela de algodón',
      'de': 'Baumwollstoff Weben',
      'pl': 'Weave Cotton Fabric',
      'ru': 'Ткать Хлопковую Ткань',
      'uk': 'Weave Cotton Fabric',
      'ko': '면직물을 짜다',
      'zh': '编织棉花织物',
      'ja': 'Weave Cotton Fabric',
    }, {
      'id': 'CottonThread',
      'en': 'Cotton Thread',
      'fr': 'Fil de coton',
      'es': 'Fibra de algodón',
      'de': 'Baumwollfaden',
      'pl': 'Cotton Thread',
      'ru': 'Хлопковая нить',
      'uk': 'Cotton Thread',
      'ko': '면사',
      'zh': '棉线',
      'ja': 'Cotton Thread',
    }, {
      'id': 'Couch',
      'en': 'Couch',
      'fr': 'Canapé',
      'es': 'Sofá',
      'de': 'Sofa',
      'pl': 'Kanapa',
      'ru': 'Диван',
      'uk': 'Диван',
      'ko': '소파',
      'zh': '沙发',
      'ja': 'ソファ',
    }, {
      'id': 'CrabPot',
      'en': 'Crab Pot',
      'fr': 'Casier à crabes',
      'es': 'Cazuela de cangrejo',
      'de': 'Krabbentopf',
      'pl': 'Crab Pot',
      'ru': 'Ловушка для крабов',
      'uk': 'Crab Pot',
      'ko': '게 냄비',
      'zh': '蟹笼',
      'ja': 'Crab Pot',
    }, {
      'id': 'Crane',
      'en': 'Crane',
      'fr': 'Grue',
      'es': 'Grúa',
      'de': 'Kran',
      'pl': 'Dźwig',
      'ru': 'Кран',
      'uk': 'Кран',
      'ko': '크레인',
      'zh': '起重机',
      'ja': 'クレーン',
    }, {
      'id': 'CriminiMushroomSpores',
      'en': 'Crimini Mushroom Spores',
      'fr': 'Spores de champignon de Paris',
      'es': 'Esporas de Champiñón Común',
      'de': 'Sporen (Champignon)',
      'pl': 'Zarodniki Pieczarki',
      'ru': 'Споры шампиньонов',
      'uk': 'Спори печериць',
      'ko': '양송이버섯 포자',
      'zh': '香啡菇孢子',
      'ja': 'マッシュルームの胞子',
    }, {
      'id': 'CrimsonSalad',
      'en': 'Crimson Salad',
      'fr': 'Salade cramoisie',
      'es': 'Ensalada Carmesí',
      'de': 'Purpursalat',
      'pl': 'Karmazynowa sałatka',
      'ru': 'Винегрет',
      'uk': 'Вінегрет',
      'ko': '붉은 채소 샐러드',
      'zh': '深红沙拉',
      'ja': 'Karmazynowa sałatka',
    }, {
      'id': 'CrispyBacon',
      'en': 'Crispy Bacon',
      'fr': 'Bacon croustillant',
      'es': 'Tocino Crujiente',
      'de': 'Knuspriger Speck',
      'pl': 'Chrupiący boczek',
      'ru': 'Хрустящий бекон',
      'uk': 'Хрусткий бекон',
      'ko': '바삭한 베이컨',
      'zh': '香脆培根',
      'ja': 'カリカリに焼いたベーコン',
    }, {
      'id': 'CrushedBasaltLv2',
      'en': 'Crushed Basalt Lv2',
      'fr': 'Basalte concassé Nv2',
      'es': 'Basalto triturado (niv. 2)',
      'de': 'Zerkleinerter Basalt Lv2',
      'pl': 'Pokruszony bazalt Poz2',
      'ru': 'Дробление базальта Ур.2',
      'uk': 'Подрібнений базальт Рів. 2',
      'ko': '파쇄된 현무암 Lv2',
      'zh': '捣碎玄武岩 等级2',
      'ja': 'Crushed Basalt Lv2',
    }, {
      'id': 'CrushedBasaltLv3',
      'en': 'Crushed Basalt Lv3',
      'fr': 'Basalte concassé Nv3',
      'es': 'Basalto triturado (niv. 3)',
      'de': 'Zerkleinerter Basalt Lv3',
      'pl': 'Pokruszony bazalt Poz3',
      'ru': 'Дробление базальта Ур.3',
      'uk': 'Подрібнений базальт Рів. 3',
      'ko': '파쇄된 현무암 Lv3',
      'zh': '磨碎玄武岩 等级3',
      'ja': 'Crushed Basalt Lv3',
    }, {
      'id': 'CrushedCopperLv2',
      'en': 'Crushed Copper Lv2',
      'fr': 'Minerai de cuivre concassé Nv2',
      'es': 'Cobre triturado (niv. 2)',
      'de': 'Zerkleinertes Kupfer Lv2',
      'pl': 'Pokruszona miedź Poz2',
      'ru': 'Дробление меди Ур.2',
      'uk': 'Подрібнена мідна руда Рів. 2',
      'ko': '파쇄된 구리 Lv2',
      'zh': '捣碎铜矿石 等级2',
      'ja': 'Crushed Copper Lv2',
    }, {
      'id': 'CrushedCopperLv3',
      'en': 'Crushed Copper Lv3',
      'fr': 'Minerai de cuivre concassé Nv3',
      'es': 'Cobre triturado (niv. 3)',
      'de': 'Zerkleinertes Kupfer Lv3',
      'pl': 'Pokruszona miedź Poz3',
      'ru': 'Дробление меди Ур.3',
      'uk': 'Подрібнена мідна руда Рів. 3',
      'ko': '파쇄된 구리 3Lv',
      'zh': '磨碎铜矿石 等级3',
      'ja': 'Crushed Copper Lv3',
    }, {
      'id': 'CrushedCopperOre',
      'en': 'Crushed Copper Ore',
      'fr': 'Minerai de cuivre concassé',
      'es': 'Mineral de cobre triturado',
      'de': 'Zerkleinertes Kupfererz',
      'pl': 'Pokruszona ruda miedzi',
      'ru': 'Дроблёная медная руда',
      'uk': 'Подрібнена мідна руда',
      'ko': '파쇄된 구리 광석',
      'zh': '破碎铜矿石',
      'ja': 'Crushed Copper Ore',
    }, {
      'id': 'CrushedGneissLv2',
      'en': 'Crushed Gneiss Lv2',
      'fr': 'Gneiss concassé Nv2',
      'es': 'Gneis triturado (niv. 2)',
      'de': 'Zerkleinertes Gneis Lv2',
      'pl': 'Pokruszony gnejs Poz2',
      'ru': 'Дробление гнейса Ур.2',
      'uk': 'Подрібнений гнейс Рів. 2',
      'ko': '파쇄된 편마암 2Lv',
      'zh': '捣碎片麻岩 等级2',
      'ja': 'Crushed Gneiss Lv2',
    }, {
      'id': 'CrushedGneissLv3',
      'en': 'Crushed Gneiss Lv3',
      'fr': 'Gneiss concassé Nv3',
      'es': 'Gneis triturado (niv. 3)',
      'de': 'Zerkleinertes Gneis Lv3',
      'pl': 'Pokruszony gnejs Poz3',
      'ru': 'Дробление гнейса Ур.3',
      'uk': 'Подрібнений гнейс Рів. 3',
      'ko': '파쇄된 편마암 Lv3',
      'zh': '粉碎片麻岩 等级3',
      'ja': 'Crushed Gneiss Lv3',
    }, {
      'id': 'CrushedGoldLv2',
      'en': 'Crushed Gold Lv2',
      'fr': 'Minerai d\u0027or concassé Nv2',
      'es': 'Oro triturado (niv. 2)',
      'de': 'Zerkleinertes Gold Lv2',
      'pl': 'Pokruszone złoto Poz2',
      'ru': 'Дробление Золота Ур.2',
      'uk': 'Подрібнена золота руда Рів. 2',
      'ko': '파쇄된 금 Lv2',
      'zh': '捣碎金矿石 等级2',
      'ja': 'Crushed Gold Lv2',
    }, {
      'id': 'CrushedGoldLv3',
      'en': 'Crushed Gold Lv3',
      'fr': 'Minerai d\u0027or concassé Nv3',
      'es': 'Oro triturado (niv. 3)',
      'de': 'Zerkleinertes Gold Lv3',
      'pl': 'Pokruszone złoto Poz3',
      'ru': 'Дробление Золота Ур.3',
      'uk': 'Подрібнена золота руда Рів. 3',
      'ko': '파쇄된 금 Lv3',
      'zh': '粉碎金矿石 等级3',
      'ja': 'Crushed Gold Lv3',
    }, {
      'id': 'CrushedGoldOre',
      'en': 'Crushed Gold Ore',
      'fr': 'Minerai d\u0027or concassé',
      'es': 'Mineral de oro triturado',
      'de': 'Zerkleinertes Golderz',
      'pl': 'Pokruszona ruda złota',
      'ru': 'Дроблёная золотая руда',
      'uk': 'Подрібнена золота руда',
      'ko': '파쇄된 금광석',
      'zh': '破碎金矿石',
      'ja': 'Crushed Gold Ore',
    }, {
      'id': 'CrushedGranite',
      'en': 'Crushed Granite',
      'fr': 'Granit concassé',
      'es': 'Granito triturado',
      'de': 'Zerkleinerter Granit',
      'pl': 'Pokruszony granit',
      'ru': 'Гранитный щебень',
      'uk': 'Подрібнений граніт',
      'ko': '파쇄된 화강암',
      'zh': '破碎花岗岩',
      'ja': 'Crushed Granite',
    }, {
      'id': 'CrushedGraniteLv2',
      'en': 'Crushed Granite Lv2',
      'fr': 'Granit concassé Nv2',
      'es': 'Granito triturado (niv. 2)',
      'de': 'Zerkleinerter Granit Lv2',
      'pl': 'Pokruszony granit Poz2',
      'ru': 'Дробление гранита Ур.2',
      'uk': 'Подрібнений граніт Рів. 2',
      'ko': '파쇄된 화강암 Lv2',
      'zh': '捣碎花岗岩 等级2',
      'ja': 'Crushed Granite Lv2',
    }, {
      'id': 'CrushedGraniteLv3',
      'en': 'Crushed Granite Lv3',
      'fr': 'Granit concassé Nv3',
      'es': 'Granito triturado (niv. 3)',
      'de': 'Zerkleinerter Granit Lv3',
      'pl': 'Pokruszony granit Poz3',
      'ru': 'Дробление гранита Ур.3',
      'uk': 'Подрібнений граніт Рів. 3',
      'ko': '파쇄된 화강암 Lv3',
      'zh': '粉碎花岗岩 等级3',
      'ja': 'Crushed Granite Lv3',
    }, {
      'id': 'CrushedIronLv2',
      'en': 'Crushed Iron Lv2',
      'fr': 'Minerai de fer concassé Nv2',
      'es': 'Hierro triturado (niv. 2)',
      'de': 'Zerkleinertes Eisen Lv2',
      'pl': 'Pokruszone żelazo Poz2',
      'ru': 'Дробление железа Ур.2',
      'uk': 'Подрібнена залізна руда Рів. 2',
      'ko': '파쇄된 철 2Lv',
      'zh': '捣碎铁矿石 等级2',
      'ja': 'Crushed Iron Lv2',
    }, {
      'id': 'CrushedIronLv3',
      'en': 'Crushed Iron Lv3',
      'fr': 'Minerai de fer concassé Nv3',
      'es': 'Hierro triturado (niv. 3)',
      'de': 'Zerkleinertes Eisen Lv3',
      'pl': 'Pokruszone żelazo Poz3',
      'ru': 'Дробление железа Ур.3',
      'uk': 'Подрібнена залізна руда Рів. 3',
      'ko': '파쇄된 철 3Lv',
      'zh': '粉碎铁矿石 等级3',
      'ja': 'Crushed Iron Lv3',
    }, {
      'id': 'CrushedIronOre',
      'en': 'Crushed Iron Ore',
      'fr': 'Minerai de fer concassé',
      'es': 'Mineral de hierro triturado',
      'de': 'Zerkleinertes Eisenerz',
      'pl': 'Pokruszona ruda żelaza',
      'ru': 'Дроблёная железная руда',
      'uk': 'Подрібнена залізна руда',
      'ko': '파쇄된 철광석',
      'zh': '破碎铁矿石',
      'ja': 'Crushed Iron Ore',
    }, {
      'id': 'CrushedLimestone',
      'en': 'Crushed Limestone',
      'fr': 'Calcaire concassé',
      'es': 'Piedra caliza triturada',
      'de': 'Zerkleinerter Kalkstein',
      'pl': 'Pokruszony wapień',
      'ru': 'Известняковый щебень',
      'uk': 'Вапняковий щебінь',
      'ko': '파쇄된 석회암',
      'zh': '破碎石灰岩',
      'ja': 'Crushed Limestone',
    }, {
      'id': 'CrushedLimestoneLv2',
      'en': 'Crushed Limestone Lv2',
      'fr': 'Calcaire concassé Nv2',
      'es': 'Arenisca triturada (niv. 2)',
      'de': 'Zerkleinerter Kalkstein Lv2',
      'pl': 'Pokruszony wapień Poz2',
      'ru': 'Дробление известняка Ур.2',
      'uk': 'Подрібнений вапняк Рів. 2',
      'ko': '파쇄된 석회암 2Lv',
      'zh': '捣碎石灰石 等级2',
      'ja': 'Crushed Limestone Lv2',
    }, {
      'id': 'CrushedLimestoneLv3',
      'en': 'Crushed Limestone Lv3',
      'fr': 'Calcaire concassé Nv3',
      'es': 'Piedra caliza triturada (niv. 3)',
      'de': 'Zerkleinerter Kalkstein Lv3',
      'pl': 'Pokruszony wapień Poz3',
      'ru': 'Дробление известняка Ур.3',
      'uk': 'Подрібнений вапняк Рів. 3',
      'ko': '파쇄된 석회암 Lv3',
      'zh': '粉碎石灰石 等级3',
      'ja': 'Crushed Limestone Lv3',
    }, {
      'id': 'CrushedMortaredStone',
      'en': 'Crushed Mortared Stone',
      'fr': 'Pierre cimentée concassée',
      'es': 'Piedra triturada con mortero',
      'de': 'Zerkleinerte Steinziegel',
      'pl': 'Crushed Mortared Stone',
      'ru': 'Дробление Строительного камня',
      'uk': 'Crushed Mortared Stone',
      'ko': 'Crushed Mortared Stone',
      'zh': '砂浆碎石',
      'ja': 'Crushed Mortared Stone',
    }, {
      'id': 'CrushedMortaredStoneLv2',
      'en': 'Crushed Mortared Stone Lv2',
      'fr': 'Pierre cimentée concassée Nv2',
      'es': 'Piedra triturada con mortero (niv. 2)',
      'de': 'Zerkleinerte Steinziegel Lv2',
      'pl': 'Crushed Mortared Stone Lv2',
      'ru': 'Дробление Строительного камня Ур.2',
      'uk': 'Crushed Mortared Stone Lv2',
      'ko': 'Crushed Mortared Stone Lv2',
      'zh': '砂浆碎石 Lv2',
      'ja': 'Crushed Mortared Stone Lv2',
    }, {
      'id': 'CrushedStoneRamp',
      'en': 'Crushed Stone Ramp',
      'fr': 'Rampe en pierre concassée',
      'es': 'Rampa de piedra triturada',
      'de': 'Zerkleinerte Steinrampe',
      'pl': 'Crushed Stone Ramp',
      'ru': 'Дробление Каменной рампы',
      'uk': 'Crushed Stone Ramp',
      'ko': 'Crushed Stone Ramp',
      'zh': '碎石坡道',
      'ja': 'Crushed Stone Ramp',
    }, {
      'id': 'CrushedStoneRampLv2',
      'en': 'Crushed Stone Ramp Lv2',
      'fr': 'Rampe en pierre concassée Nv2',
      'es': 'Rampa de piedra triturada (niv. 2)',
      'de': 'Zerkleinerte Steinrampe Stufe 2',
      'pl': 'Crushed Stone Ramp Lv2',
      'ru': 'Дробление Каменной рампы Ур.2',
      'uk': 'Crushed Stone Ramp Lv2',
      'ko': 'Crushed Stone Ramp Lv2',
      'zh': '碎石坡道 Lv2',
      'ja': 'Crushed Stone Ramp Lv2',
    }, {
      'id': 'CrushedStoneRoad',
      'en': 'Crushed Stone Road',
      'fr': 'Route en pierre concassée',
      'es': 'Camino de piedra triturada',
      'de': 'Zerkleinerte Steinstraße',
      'pl': 'Crushed Stone Road',
      'ru': 'Дробление Каменной дороги',
      'uk': 'Crushed Stone Road',
      'ko': 'Crushed Stone Road',
      'zh': '碎石路',
      'ja': 'Crushed Stone Road',
    }, {
      'id': 'CrushedStoneRoadLv2',
      'en': 'Crushed Stone Road Lv2',
      'fr': 'Route en pierre concassée Nv2',
      'es': 'Camino de piedra triturada (niv. 2)',
      'de': 'Zerkleinerte Steinstraße Stufe 2',
      'pl': 'Crushed Stone Road Lv2',
      'ru': 'Дробление Каменной дороги Ур.2',
      'uk': 'Crushed Stone Road Lv2',
      'ko': 'Crushed Stone Road Lv2',
      'zh': '碎石路 Lv2',
      'ja': 'Crushed Stone Road Lv2',
    }, {
      'id': 'CrushedSandstone',
      'en': 'Crushed Sandstone',
      'fr': 'Grès concassé',
      'es': 'Arenisca triturada',
      'de': 'Zerkleinerter Sandstein',
      'pl': 'Pokruszony piaskowiec',
      'ru': 'Щебень из песчаника',
      'uk': 'Подрібнений піщаник',
      'ko': '파쇄된 사암',
      'zh': '破碎砂岩',
      'ja': 'Crushed Sandstone',
    }, {
      'id': 'CrushedSandstoneLv2',
      'en': 'Crushed Sandstone Lv2',
      'fr': 'Grès concassé Nv2',
      'es': 'Arenisca triturada (niv. 2)',
      'de': 'Zerkleinerter Sandstein Lv2',
      'pl': 'Pokruszony piaskowiec Poz2',
      'ru': 'Дробление песчаника Ур.2',
      'uk': 'Подрібнений піщаник Рів. 2',
      'ko': '파쇄된 사암 2Lv',
      'zh': '捣碎砂岩 等级2',
      'ja': 'Crushed Sandstone Lv2',
    }, {
      'id': 'CrushedSandstoneLv3',
      'en': 'Crushed Sandstone Lv3',
      'fr': 'Grès concassé Nv3',
      'es': 'Arenisca triturada (niv. 3)',
      'de': 'Zerkleinerter Sandstein Lv3',
      'pl': 'Pokruszony piaskowiec Poz3',
      'ru': 'Дробление песчаника Ур.3',
      'uk': 'Подрібнений піщаник Рів. 3',
      'ko': '파쇄된 사암 Lv3',
      'zh': '粉碎砂岩 等级3',
      'ja': 'Crushed Sandstone Lv3',
    }, {
      'id': 'CrushedShale',
      'en': 'Crushed Shale',
      'fr': 'Schiste concassé',
      'es': 'Pizarra triturada',
      'de': 'Zerkleinerter Schiefer',
      'pl': 'Pokruszony łupek',
      'ru': 'Сланцевый щебень',
      'uk': 'Подрібнений сланець',
      'ko': '파쇄된 이판암',
      'zh': '破碎页岩',
      'ja': 'Crushed Shale',
    }, {
      'id': 'CrushedShaleLv2',
      'en': 'Crushed Shale Lv2',
      'fr': 'Schiste concassé Nv2',
      'es': 'Pizarra triturada (niv. 2)',
      'de': 'Zerkleinertes Schiefer Lv2',
      'pl': 'Pokruszony łupek Poz2',
      'ru': 'Дробление сланца Ур.2',
      'uk': 'Подрібнений сланець Рів. 2',
      'ko': '파쇄된 이판암 Lv2',
      'zh': '捣碎页岩 等级2',
      'ja': 'Crushed Shale Lv2',
    }, {
      'id': 'CrushedShaleLv3',
      'en': 'Crushed Shale Lv3',
      'fr': 'Schiste concassé Nv3',
      'es': 'Pizarra triturada (niv. 3)',
      'de': 'Zerkleinertes Schiefer Lv3',
      'pl': 'Pokruszony łupek Poz3',
      'ru': 'Дробление сланца Ур.3',
      'uk': 'Подрібнений сланець Рів. 3',
      'ko': '파쇄된 이판암 Lv3',
      'zh': '粉碎页岩 等级3',
      'ja': 'Crushed Shale Lv3',
    }, {
      'id': 'CrushedSlagLv2',
      'en': 'Crushed Slag Lv2',
      'fr': 'Scories concassées Nv2',
      'es': 'Escoria triturada (niv. 2)',
      'de': 'Zerkleinerte Schlacke Lv2',
      'pl': 'Pokruszony żużel Poz2',
      'ru': 'Дробление шлака Ур.2',
      'uk': 'Подрібнений шлак Рів. 2',
      'ko': '파쇄된 광물 찌꺼기 Lv2',
      'zh': '捣碎矿渣 等级2',
      'ja': 'Crushed Slag Lv2',
    }, {
      'id': 'CrushedSlagLv3',
      'en': 'Crushed Slag Lv3',
      'fr': 'Scories concassées Nv3',
      'es': 'Escoria triturada (niv. 3)',
      'de': 'Zerkleinerte Schlacke Lv3',
      'pl': 'Pokruszony żużel Poz3',
      'ru': 'Дробление шлака Ур.3',
      'uk': 'Подрібнений шлак Рів. 3',
      'ko': '파쇄된 광물 찌꺼기 Lv3',
      'zh': '粉碎矿渣 等级3',
      'ja': 'Crushed Slag Lv3',
    }, {
      'id': 'CulinaryResearchPaperAdvanced',
      'en': 'Culinary Research Paper Advanced',
      'fr': 'Papier de recherche : Culinaire avancé',
      'es': 'Trabajo de investigación culinaria (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Kochkunst',
      'pl': 'Culinary Research Paper Advanced',
      'ru': 'Исследование по продвинутой кулинарии',
      'uk': 'Дослідження вдосконаленої кулінарії',
      'ko': '고급 요리 연구지',
      'zh': '高级烹饪研究论文',
      'ja': 'Culinary Research Paper Advanced',
    }, {
      'id': 'CulinaryResearchPaperAdvancedMeat',
      'en': 'Culinary Research Paper Advanced Meat',
      'fr': 'Papier de recherche : Culinaire viande avancée',
      'es': 'Trabajo de investigación culinaria sobre carne (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Kochkunst mit Fleisch',
      'pl': 'Culinary Research Paper Advanced Meat',
      'ru': 'Исследование по продвинутой кулинарии - мясо',
      'uk': 'Дослідження вдосконаленої кулінарії - м\u0027ясо',
      'ko': '고급 고기 요리 연구지',
      'zh': '高级肉类烹饪研究论文',
      'ja': 'Culinary Research Paper Advanced Meat',
    }, {
      'id': 'CulinaryResearchPaperBasic',
      'en': 'Culinary Research Paper Basic',
      'fr': 'Papier de recherche : Culinaire basique',
      'es': 'Trabajo de investigación culinaria (básico)',
      'de': 'Grundlegendes Forschungspapier: Kochkunst',
      'pl': 'Culinary Research Paper Basic',
      'ru': 'Исследование по базовой кулинарии',
      'uk': 'Дослідження базової кулінарії',
      'ko': '기초 요리 연구지',
      'zh': '基础烹饪研究论文',
      'ja': 'Culinary Research Paper Basic',
    }, {
      'id': 'CulinaryResearchPaperBasicFish',
      'en': 'Culinary Research Paper Basic Fish',
      'fr': 'Papier de recherche : Culinaire poisson basique',
      'es': 'Trabajo de investigación culinaria sobre pescado (básico)',
      'de': 'Grundlegendes Forschungspapier: Kochkunst mit Fisch',
      'pl': 'Culinary Research Paper Basic Fish',
      'ru': 'Исследование по базовой кулинарии - рыба',
      'uk': 'Culinary Research Paper Basic Fish',
      'ko': '요리 연구 논문 기초 생선',
      'zh': '基础鱼类烹饪研究论文',
      'ja': 'Culinary Research Paper Basic Fish',
    }, {
      'id': 'CulinaryResearchPaperBasicMeat',
      'en': 'Culinary Research Paper Basic Meat',
      'fr': 'Papier de recherche : Culinaire viande basique',
      'es': 'Trabajo de investigación culinaria sobre carne (básico)',
      'de': 'Grundlegendes Forschungspapier: Kochkunst mit Fleisch',
      'pl': 'Culinary Research Paper Basic Meat',
      'ru': 'Исследование по базовой кулинарии - мясо',
      'uk': 'Дослідження базової кулінарії - м\u0027ясо',
      'ko': '기초 요리 연구지',
      'zh': '基础肉类烹饪研究论文',
      'ja': 'Culinary Research Paper Basic Meat',
    }, {
      'id': 'CulinaryResearchPaperModern',
      'en': 'Culinary Research Paper Modern',
      'fr': 'Papier de recherche : Culinaire moderne',
      'es': 'Trabajo de investigación culinaria (moderno)',
      'de': 'Modernes Forschungspapier: Kochkunst',
      'pl': 'Nowoczesny artykuł badawczy Kulinarii',
      'ru': 'Исследование по современной кулинарии',
      'uk': 'Дослідження сучасної кулінарії',
      'ko': '현대식 요리 연구지',
      'zh': '现代烹饪研究论文',
      'ja': 'Culinary Research Paper Modern',
    }, {
      'id': 'CurrencyExchange',
      'en': 'Currency Exchange',
      'fr': 'Bureau de change',
      'es': 'Cambio de Divisas',
      'de': 'Wechselstube',
      'pl': 'Wymiana walut',
      'ru': 'Пункт обмена валюты',
      'uk': 'Обмін валют',
      'ko': '환전소',
      'zh': '货币兑换',
      'ja': '両替機',
    }, {
      'id': 'CuttingEdgeCookingUpgrade',
      'en': 'Cutting Edge Cooking Upgrade',
      'fr': 'Amélioration Moderne : Cuisine moléculaire',
      'es': 'Mejora: Cocina innovadora',
      'de': 'Upgrade Innovatives Kochen',
      'pl': 'Ulepszenie Nowoczesnego Gotowania',
      'ru': 'Улучшение для передовой кулинарии',
      'uk': 'Покращення сучасної кухні',
      'ko': '식품공학 기술 업그레이드',
      'zh': '尖端烹饪升级',
      'ja': 'Cutting Edge Cooking Upgrade',
    }, {
      'id': 'DendrologyResearchPaperAdvanced',
      'en': 'Dendrology Research Paper Advanced',
      'fr': 'Papier de recherche : Dendrologie avancée',
      'es': 'Trabajo de investigación en dendrología (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Dendrologie',
      'pl': 'Dendrology Research Paper Advanced',
      'ru': 'Исследование по продвинутой дендрологии',
      'uk': 'Дослідження вдосконаленої дендрології',
      'ko': '고급 산림학 연구지',
      'zh': '高级树木学研究论文',
      'ja': 'Dendrology Research Paper Advanced',
    }, {
      'id': 'DendrologyResearchPaperBasic',
      'en': 'Dendrology Research Paper Basic',
      'fr': 'Papier de recherche : Dendrologie basique',
      'es': 'Trabajo de investigación en dendrología (básico)',
      'de': 'Grundlegendes Forschungspapier: Dendrologie',
      'pl': 'Dendrology Research Paper Basic',
      'ru': 'Исследование по базовой дендрологии',
      'uk': 'Дослідження базової дендрології',
      'ko': '기초 산림학 연구지',
      'zh': '基础树木学研究论文',
      'ja': 'Dendrology Research Paper Basic',
    }, {
      'id': 'DendrologyResearchPaperModern',
      'en': 'Dendrology Research Paper Modern',
      'fr': 'Papier de recherche : Dendrologie moderne',
      'es': 'Trabajo de investigación en dendrología (moderno)',
      'de': 'Modernes Forschungspapier: Dendrologie',
      'pl': 'Nowoczesny artykuł badawczy Dendrologii',
      'ru': 'Исследование по современной дендрологии',
      'uk': 'Дослідження сучасної дендрології',
      'ko': '현대식 산림학 연구지',
      'zh': '现代树木学研究论文',
      'ja': 'Dendrology Research Paper Modern',
    }, {
      'id': 'DerpyHat',
      'en': 'Derpy Hat',
      'fr': 'Chapeau ridicule',
      'es': 'Sombrero Ridículo',
      'de': 'Trotteliger Hut',
      'pl': 'Durnowaty kapelusz',
      'ru': 'Неуклюжая шляпа',
      'uk': 'Недоладний капелюх',
      'ko': '이상한 모자',
      'zh': '德比帽',
      'ja': 'おかしな帽子',
    }, {
      'id': 'DistributionStation',
      'en': 'Distribution Station',
      'fr': 'Station de distribution',
      'es': 'Estación de Distribución',
      'de': 'Verteilungsstation',
      'pl': 'Stacja Dystrybucyjna',
      'ru': 'Станция распределения',
      'uk': 'Станція розподілу',
      'ko': '물자 배급소',
      'zh': '分发站',
      'ja': '配布ステーション',
    }, {
      'id': 'ElectricLathe',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'Torno eléctrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka Elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동식 선반 기계',
      'zh': '电动车床',
      'ja': '電気旋盤',
    }, {
      'id': 'ElectricMachinistTable',
      'en': 'Electric Machinist Table',
      'fr': 'Établi électrique',
      'es': 'Mesa eléctrica de maquinista',
      'de': 'Elektrischer Montagetisch',
      'pl': 'Elektryczny Stół Maszynowy',
      'ru': 'Электрический слесарный верстак',
      'uk': 'Стіл електромашиніста',
      'ko': '전동식 기계 정비공 작업대',
      'zh': '电动机械师工作台',
      'ja': '電気工作機械台',
    }, {
      'id': 'ElectricMotor',
      'en': 'Electric Motor',
      'fr': 'Moteur électrique',
      'es': 'Motor Eléctrico',
      'de': 'Elektromotor',
      'pl': 'Silnik elektryczny',
      'ru': 'Электродвигатель',
      'uk': 'Електродвигун',
      'ko': '전기 모터',
      'zh': '电动机',
      'ja': '電気モーター',
    }, {
      'id': 'ElectricPlaner',
      'en': 'Electric Planer',
      'fr': 'Fraiseuse électrique',
      'es': 'Cepilladora eléctrica',
      'de': 'Elektrische Hobelmaschine',
      'pl': 'Strug Elektryczny',
      'ru': 'Электрический строгальный станок',
      'uk': 'Електричний стругальний верстат',
      'ko': '전동식 대패',
      'zh': '电动刨床',
      'ja': '電気かんな盤',
    }, {
      'id': 'ElectricStampingPress',
      'en': 'Electric Stamping Press',
      'fr': 'Presse électrique',
      'es': 'Prensa de Estampado Hidráulica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический пресс',
      'uk': 'Електричний прес',
      'ko': '전동식 금속 가공기',
      'zh': '电动冲床',
      'ja': '電気スタンピングプレス機',
    }, {
      'id': 'ElectricWallLamp',
      'en': 'Electric Wall Lamp',
      'fr': 'Lampe murale électrique',
      'es': 'Lámpara de Pared Eléctrica',
      'de': 'Elektrische Wandleuchte',
      'pl': 'Elektryczna lampa ścienna',
      'ru': 'Электрическая настенная лампа',
      'uk': 'Електричний настінний світильник',
      'ko': '벽걸이형 전등',
      'zh': '电壁灯',
      'ja': '壁掛け電灯',
    }, {
      'id': 'ElectricWaterPump',
      'en': 'Electric Water Pump',
      'fr': 'Pompe à eau électrique',
      'es': 'Bomba de agua eléctrica',
      'de': 'Elektrische Wasserpumpe',
      'pl': 'Elektryczna pompa wodna',
      'ru': 'Электрический водяной насос',
      'uk': 'Електричний водяний насос',
      'ko': '전기 동력 물 펌프',
      'zh': '电动水泵',
      'ja': '電動ウォーター ポンプ',
    }, {
      'id': 'ElectronicsAssembly',
      'en': 'Electronics Assembly',
      'fr': 'Atelier d\u0027électronique',
      'es': 'Sección de ensamblaje electrónico',
      'de': 'Elektronikfertigung',
      'pl': 'Montaż Elektroniki',
      'ru': 'Сборщик электроники',
      'uk': 'Збирач електроніки',
      'ko': '전자 공학 작업대',
      'zh': '电子装配套装',
      'ja': '電子機器組立機',
    }, {
      'id': 'ElectronicsUpgrade',
      'en': 'Electronics Upgrade',
      'fr': 'Amélioration Moderne : Électronique',
      'es': 'Mejora: Electrónica',
      'de': 'Upgrade Elektronik',
      'pl': 'Ulepszenie Elektroniki',
      'ru': 'Улучшение для электроники',
      'uk': 'Покращення електроніки',
      'ko': '전자공학 시술 업그레이드',
      'zh': '电子升级',
      'ja': 'Electronics Upgrade',
    }, {
      'id': 'ElevatorCallPost',
      'en': 'Elevator Call Post',
      'fr': 'Bouton d\u0027appel d\u0027ascenseur',
      'es': 'Punto de llamada del ascensor',
      'de': 'Holzaufzug-Rufposten',
      'pl': 'Elevator Call Post',
      'ru': 'Пульт управления лифтом',
      'uk': 'Elevator Call Post',
      'ko': '엘리베이터 호출 포스트',
      'zh': '电梯呼叫站',
      'ja': 'Elevator Call Post',
    }, {
      'id': 'ElkMount',
      'en': 'Elk Mount',
      'fr': 'Trophée de wapiti',
      'es': 'Montura de alce',
      'de': 'Ausgestopfter Wapiti',
      'pl': 'Elk Mount',
      'ru': 'Голова вапити',
      'uk': 'Голова оленя',
      'ko': '엘크 벽걸이 박제',
      'zh': '驼鹿壁挂',
      'ja': 'エルクマウント',
    }, {
      'id': 'ElkTaco',
      'en': 'Elk Taco',
      'fr': 'Taco de wapiti',
      'es': 'Taco de alce',
      'de': 'Elchtaco',
      'pl': 'Taco z Jelenia',
      'ru': 'Тако с олениной',
      'uk': 'Лосяче тако',
      'ko': '엘크 고기 타코',
      'zh': '鹿肉玉米卷',
      'ja': 'エルクのタコス',
    }, {
      'id': 'ElkWellington',
      'en': 'Elk Wellington',
      'fr': 'Rôti de wapiti façon Wellington',
      'es': 'Wellington de alce',
      'de': 'Wapitiwellington',
      'pl': 'Jeleń w Cieście',
      'ru': 'Оленина «Веллингтон»',
      'uk': 'Лосятина по-веллінгтонськи',
      'ko': '엘크 웰링턴',
      'zh': '惠灵顿鹿排',
      'ja': 'エルクウェリントン',
    }, {
      'id': 'EngineeringResearchPaperAdvanced',
      'en': 'Engineering Research Paper Advanced',
      'fr': 'Papier de recherche : Ingénierie avancée',
      'es': 'Trabajo de investigación en ingeniería (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Ingenieurswesen',
      'pl': 'Zaawansowany artykuł badawczy Inżynierii',
      'ru': 'Исследование по продвинутому инженерному делу',
      'uk': 'Дослідження вдосконаленої інженерії',
      'ko': '고급 기계공학 연구지',
      'zh': '高级工程学研究论文',
      'ja': 'Engineering Research Paper Advanced',
    }, {
      'id': 'EngineeringResearchPaperModern',
      'en': 'Engineering Research Paper Modern',
      'fr': 'Papier de recherche : Ingénierie moderne',
      'es': 'Trabajo de investigación en ingeniería (moderno)',
      'de': 'Modernes Forschungspapier: Ingenieurswesen',
      'pl': 'Nowoczesny artykuł badawczy Inżynierii',
      'ru': 'Исследование по современному инженерному делу',
      'uk': 'Дослідження сучасної інженерії',
      'ko': '현대식 기계공학 연구지',
      'zh': '现代工程学研究论文',
      'ja': 'Engineering Research Paper Modern',
    }, {
      'id': 'Epoxy',
      'en': 'Epoxy',
      'fr': 'Résine époxy',
      'es': 'Resina Epoxi',
      'de': 'Epoxidharz',
      'pl': 'Żywica epoksydowa',
      'ru': 'Эпоксидная смола',
      'uk': 'Епоксидна смола',
      'ko': '에폭시 수지',
      'zh': '环氧树脂',
      'ja': 'エポキシ樹脂',
    }, {
      'id': 'CornEthanol',
      'en': 'Corn Ethanol',
      'fr': 'Éthanol de maïs',
      'es': 'Etanol de maíz',
      'de': 'Mais Ethanol',
      'pl': 'Corn Ethanol',
      'ru': 'Этанол из кукурузы',
      'uk': 'Кукурудзяний етанол',
      'ko': 'Corn Ethanol',
      'zh': '玉米乙醇',
      'ja': 'Corn Ethanol',
    }, {
      'id': 'WheatEthanol',
      'en': 'Wheat Ethanol',
      'fr': 'Éthanol de blé',
      'es': 'Etanol de Trigo',
      'de': 'Weizen Ethanol',
      'pl': 'Wheat Ethanol',
      'ru': 'Этанол из пшеницы',
      'uk': 'Пшеничний етанол',
      'ko': 'Wheat Ethanol',
      'zh': '小麦乙醇',
      'ja': 'Wheat Ethanol',
    }, {
      'id': 'Excavator',
      'en': 'Excavator',
      'fr': 'Pelleteuse',
      'es': 'Excavadora',
      'de': 'Bagger',
      'pl': 'Koparka',
      'ru': 'Экскаватор',
      'uk': 'Екскаватор',
      'ko': '굴착기',
      'zh': '挖掘机',
      'ja': 'ショベルカー',
    }, {
      'id': 'ExplorerBelt',
      'en': 'Explorer Belt',
      'fr': 'Ceinture de l’explorateur',
      'es': 'Cinto de explorador',
      'de': 'Forschergürtel',
      'pl': 'Explorer Belt',
      'ru': 'Пояс Исследователя',
      'uk': 'Explorer Belt',
      'ko': '탐험가 허리띠',
      'zh': '探索者的腰带',
      'ja': 'Explorer Belt',
    }, {
      'id': 'ExplorerBoots',
      'en': 'Explorer Boots',
      'fr': 'Bottes d\u0027explorateur',
      'es': 'Botas de explorador',
      'de': 'Forscherstiefel',
      'pl': 'Explorer Boots',
      'ru': 'Ботинки Исследователя',
      'uk': 'Explorer Boots',
      'ko': '익스플로러 부츠',
      'zh': '探索者的靴子',
      'ja': 'Explorer Boots',
    }, {
      'id': 'ExplorerGloves',
      'en': 'Explorer Gloves',
      'fr': 'Gants de l’explorateur',
      'es': 'Guantes de explorador',
      'de': 'Forscherhandschuhe',
      'pl': 'Explorer Gloves',
      'ru': 'Перчатки Исследователя',
      'uk': 'Explorer Gloves',
      'ko': '탐험가 장갑',
      'zh': '探索者的手套',
      'ja': 'Explorer Gloves',
    }, {
      'id': 'ExplorerHat',
      'en': 'Explorer Hat',
      'fr': 'Chapeau d\u0027explorateur',
      'es': 'Gorro de explorador',
      'de': 'Forscherhut',
      'pl': 'Explorer Hat',
      'ru': 'Пробковый шлем',
      'uk': 'Explorer Hat',
      'ko': '탐험가 모자',
      'zh': '探索者的帽子',
      'ja': 'Explorer Hat',
    }, {
      'id': 'ExplorerPants',
      'en': 'Explorer Pants',
      'fr': 'Pantalon d\u0027explorateur',
      'es': 'Pantalones de explorador',
      'de': 'Forscherhose',
      'pl': 'Explorer Pants',
      'ru': 'Штаны Исследователя',
      'uk': 'Explorer Pants',
      'ko': '탐험가 바지',
      'zh': '探索者的裤子',
      'ja': 'Explorer Pants',
    }, {
      'id': 'ExplorerShirt',
      'en': 'Explorer Shirt',
      'fr': 'Chemise de l’explorateur',
      'es': 'Camisa de explorador',
      'de': 'Forscherhemd',
      'pl': 'Explorer Shirt',
      'ru': 'Китель Исследователя',
      'uk': 'Explorer Shirt',
      'ko': '탐험가 셔츠',
      'zh': '探索者的衬衫',
      'ja': 'Explorer Shirt',
    }, {
      'id': 'FantasticForestPizza',
      'en': 'Fantastic Forest Pizza',
      'fr': 'Pizza fantastique de la forêt',
      'es': 'Pizza del Bosque Fantástico',
      'de': 'Pizza Wald Fantastica',
      'pl': 'Fantastyczna leśna pizza',
      'ru': 'Фантастическая лесная пицца',
      'uk': 'Fantastic Forest Pizza',
      'ko': 'Fantastic Forest Pizza',
      'zh': '奇幻森林比萨',
      'ja': 'Fantastic Forest Pizza',
    }, {
      'id': 'FarmerBoots',
      'en': 'Farmer Boots',
      'fr': 'Bottes de fermier',
      'es': 'Botas de granjero',
      'de': 'Farmerstiefel',
      'pl': 'Farmer Boots',
      'ru': 'Ботинки Фермера',
      'uk': 'Farmer Boots',
      'ko': '농부 부츠',
      'zh': '农民的靴子',
      'ja': 'Farmer Boots',
    }, {
      'id': 'FarmerGloves',
      'en': 'Farmer Gloves',
      'fr': 'Gants de fermier',
      'es': 'Guantes de granjero',
      'de': 'Farmerhandschuhe',
      'pl': 'Farmer Gloves',
      'ru': 'Перчатки Фермера',
      'uk': 'Farmer Gloves',
      'ko': '농부 장갑',
      'zh': '农民的手套',
      'ja': 'Farmer Gloves',
    }, {
      'id': 'FarmerHat',
      'en': 'Farmer Hat',
      'fr': 'Chapeau de fermier',
      'es': 'Sombrero de granjero',
      'de': 'Farmerhut',
      'pl': 'Farmer Hat',
      'ru': 'Шляпа Фермера',
      'uk': 'Farmer Hat',
      'ko': '농부 모자',
      'zh': '农民的帽子',
      'ja': 'Farmer Hat',
    }, {
      'id': 'FarmerOveralls',
      'en': 'Farmer Overalls',
      'fr': 'Salopette de fermier',
      'es': 'Mono de granjero',
      'de': 'Farmeroveralls',
      'pl': 'Farmer Overalls',
      'ru': 'Комбинезон Фермера',
      'uk': 'Farmer Overalls',
      'ko': '농부 작업복',
      'zh': '农民的工装裤',
      'ja': 'Farmer Overalls',
    }, {
      'id': 'FarmerShirt',
      'en': 'Farmer Shirt',
      'fr': 'Chemise de fermier',
      'es': 'Camisa de granjero',
      'de': 'Farmerhemd',
      'pl': 'Farmer Shirt',
      'ru': 'Рубашка Фермера',
      'uk': 'Farmer Shirt',
      'ko': '농부 셔츠',
      'zh': '农民的衬衫',
      'ja': 'Farmer Shirt',
    }, {
      'id': 'FarmersTable',
      'en': 'Farmers Table',
      'fr': 'Atelier d\u0027agriculture',
      'es': 'Mesa de Agricultor',
      'de': 'Landwirttisch',
      'pl': 'Stół Rolniczy',
      'ru': 'Фермерский стол',
      'uk': 'Фермерський стіл',
      'ko': '농업 작업대',
      'zh': '农业工作台',
      'ja': '園芸作業台',
    }, {
      'id': 'FarmingUpgrade',
      'en': 'Farming Upgrade',
      'fr': 'Amélioration Basique : Agriculture',
      'es': 'Mejora: Agricultura',
      'de': 'Upgrade Landwirtschaft',
      'pl': 'Ulepszenie Rolnictwa',
      'ru': 'Улучшение для фермерского дела',
      'uk': 'Покращення фермерства',
      'ko': '농업 기술 업그레이드',
      'zh': '农业升级',
      'ja': 'Farming Upgrade',
    }, {
      'id': 'FernCampfireSalad',
      'en': 'Fern Campfire Salad',
      'fr': 'Salade de fougères cuite au feu de camp',
      'es': 'Ensalada braseada con helechos',
      'de': 'Lagerfeuer Farnspitzensalat',
      'pl': 'Paprociowa sałatka z ogniska',
      'ru': 'Салат из папоротника на костре',
      'uk': 'Салат із папороті, приготований на багатті',
      'ko': '고사리 모닥불 샐러드',
      'zh': '蕨篝火沙拉',
      'ja': 'Fern Campfire Salad',
    }, {
      'id': 'FernSpore',
      'en': 'Fern Spore',
      'fr': 'Spore de fougère',
      'es': 'Espora de Helecho',
      'de': 'Sporen (Farn)',
      'pl': 'Zarodniki Paproci',
      'ru': 'Спора папоротника',
      'uk': 'Спори папороті',
      'ko': '고사리 포자',
      'zh': '蕨类孢子',
      'ja': 'Zarodniki paproci',
    }, {
      'id': 'FertilizersUpgrade',
      'en': 'Fertilizers Upgrade',
      'fr': 'Amélioration Basique : Engrais',
      'es': 'Mejora: Fertilizantes',
      'de': 'Upgrade Dünger',
      'pl': 'Ulepszenie Nawozów',
      'ru': 'Улучшение для производства удобрений',
      'uk': 'Покращення виготовлення добрив',
      'ko': '비료제조 기술 업그레이드',
      'zh': '肥料升级',
      'ja': 'Fertilizers Upgrade',
    }, {
      'id': 'FiberFiller',
      'en': 'Fiber Filler',
      'fr': 'Garnissage de fibres végétales',
      'es': 'Relleno de Fibra',
      'de': 'Füller aus Fasern',
      'pl': 'Wypełniacz włóknowy',
      'ru': 'Волоконный наполнитель',
      'uk': 'Наповнювач із волокна',
      'ko': '식물섬유 보충제',
      'zh': '纤维填料',
      'ja': 'Wypełniacz włóknowy',
    }, {
      'id': 'Fiberglass',
      'en': 'Fiberglass',
      'fr': 'Fibre de verre',
      'es': 'Fibra de Vidrio',
      'de': 'Glasfaserverstärkter Kunststoff',
      'pl': 'Włokno szklane',
      'ru': 'Стекловолокно',
      'uk': 'Скловолокно',
      'ko': '유리섬유',
      'zh': '玻璃钢',
      'ja': 'ガラス繊維',
    }, {
      'id': 'FieldCampfireStew',
      'en': 'Field Campfire Stew',
      'fr': 'Ragoût des prairies cuit au feu de camp',
      'es': 'Ensalada braseada campestre',
      'de': 'Lagerfeuer Feldeintopf',
      'pl': 'Chłopski gulasz z ogniska',
      'ru': 'Полевое рагу на костре',
      'uk': 'Польове рагу, приготоване на багатті',
      'ko': '들판 모닥불 스튜',
      'zh': '野营篝火炖汤',
      'ja': 'Field Campfire Stew',
    }, {
      'id': 'FireweedSeed',
      'en': 'Fireweed Seed',
      'fr': 'Graine d\u0027épilobe',
      'es': 'Semilla de Epilobio',
      'de': 'Samen (Weidenröschen)',
      'pl': 'Nasiona Wierzbówki',
      'ru': 'Семечко иван-чая',
      'uk': 'Насіння дикого льону',
      'ko': '분홍바늘꽃 씨앗',
      'zh': '柳兰种子',
      'ja': 'ヤナギランの種',
    }, {
      'id': 'FishNChips',
      'en': 'Fish N Chips',
      'fr': 'Fish and Chips',
      'es': 'Fish N Chips',
      'de': 'Fish N Chips',
      'pl': 'Fish N Chips',
      'ru': 'Рыбные чипсы',
      'uk': 'Fish N Chips',
      'ko': '피쉬엔칩스',
      'zh': '炸鱼薯条',
      'ja': 'Fish N Chips',
    }, {
      'id': 'FishTrap',
      'en': 'Fish Trap',
      'fr': 'Nasse à poisson',
      'es': 'Trampa para Peces',
      'de': 'Reuse',
      'pl': 'Samołówka',
      'ru': 'Верша',
      'uk': 'Рибна пастка',
      'ko': '통발',
      'zh': '捕鱼器',
      'ja': '梁（やな）',
    }, {
      'id': 'Fishery',
      'en': 'Fishery',
      'fr': 'Atelier de pêche',
      'es': 'Pesquería',
      'de': 'Fischereitisch',
      'pl': 'Rybołóstwo',
      'ru': 'Шкаф рыбака',
      'uk': 'Шафка рибалки',
      'ko': '어업 작업대',
      'zh': '渔具',
      'ja': '釣り具作業台',
    }, {
      'id': 'FlatSteelDoor',
      'en': 'Flat Steel Door',
      'fr': 'Porte en tôle d\u0027acier inoxydable',
      'es': 'Puerta plana de acero',
      'de': 'Wohnungstüre aus Stahl',
      'pl': 'Flat Steel Door',
      'ru': 'Дверь из листовой стали',
      'uk': 'Flat Steel Door',
      'ko': '플랫 스틸 도어',
      'zh': '扁平铁门',
      'ja': 'Flat Steel Door',
    }, {
      'id': 'FlatSteel',
      'en': 'Flat Steel',
      'fr': 'Tôle d\u0027acier inoxydable',
      'es': 'Acero Plano',
      'de': 'Flachstahl',
      'pl': 'Blacha stalowa',
      'ru': 'Листовая сталь',
      'uk': 'Листова сталь',
      'ko': '강철판',
      'zh': '扁钢',
      'ja': '鋼板',
    }, {
      'id': 'Flatbread',
      'en': 'Flatbread',
      'fr': 'Galette de pain',
      'es': 'Pan Plano',
      'de': 'Fladenbrot',
      'pl': 'Podpłomyk',
      'ru': 'Лепёшка',
      'uk': 'Корж',
      'ko': '무발효빵',
      'zh': '大饼',
      'ja': 'Podpłomyk',
    }, {
      'id': 'Flour',
      'en': 'Flour',
      'fr': 'Farine',
      'es': 'Harina',
      'de': 'Mehl',
      'pl': 'Mąka',
      'ru': 'Мука',
      'uk': 'Борошно',
      'ko': '밀가루',
      'zh': '面粉',
      'ja': '小麦粉',
    }, {
      'id': 'FramedGlassDoor',
      'en': 'Framed Glass Door',
      'fr': 'Porte à encadrement vitrée',
      'es': 'Puerta de cristal enmarcado',
      'de': 'Gerahmte Glastür',
      'pl': 'Oprawione Szklane Drzwi',
      'ru': 'Стеклянная дверь',
      'uk': 'Скляні двері',
      'ko': '강철 틀 유리문',
      'zh': '带框架的玻璃门',
      'ja': '枠付きのガラス戸',
    }, {
      'id': 'FramedGlass',
      'en': 'Framed Glass',
      'fr': 'Verre encadré',
      'es': 'Vidrio Enmarcado',
      'de': 'Gerahmtes Glas',
      'pl': 'Szyba oprawiona',
      'ru': 'Обрамлённое стекло',
      'uk': 'Рамкове скло',
      'ko': '유리창',
      'zh': '框式玻璃',
      'ja': 'ガラスの窓枠',
    }, {
      'id': 'FriedCamas',
      'en': 'Fried Camas',
      'fr': 'Camassias frits',
      'es': 'Camasia frita',
      'de': 'Frittierte Prärielilien',
      'pl': 'Smażone camas',
      'ru': 'Жареная камассия',
      'uk': 'Смажений Камас',
      'ko': '튀긴 카마스',
      'zh': '炸卡马斯',
      'ja': 'Fried Camas',
    }, {
      'id': 'FriedFiddleheads',
      'en': 'Fried Fiddleheads',
      'fr': 'Fougères frits',
      'es': 'Brotes de helecho fritos',
      'de': 'Frittierte Farnspitzen',
      'pl': 'Smażone liście młodej paproci',
      'ru': 'Жареный папоротник',
      'uk': 'Смажена папороть',
      'ko': '튀긴 고사리',
      'zh': '炸羊肠',
      'ja': 'Fried Fiddleheads',
    }, {
      'id': 'FriedHareHaunches',
      'en': 'Fried Hare Haunches',
      'fr': 'Cuisses de lièvre frites',
      'es': 'Ancas de Liebre Fritas',
      'de': 'Frittierte Hasenkeule',
      'pl': 'Smażony udziec z zająca',
      'ru': 'Жаренное филе зайца',
      'uk': 'Смажене заяче філе',
      'ko': '튀긴 토끼 뒷다리',
      'zh': '炸兔后腿',
      'ja': '野ウサギの唐揚げ',
    }, {
      'id': 'FriedHeartsOfPalm',
      'en': 'Fried Hearts Of Palm',
      'fr': 'Cœur de palmier frit',
      'es': 'Palmitos fritos',
      'de': 'Frittierte Palmherzen',
      'pl': 'Smażone serca palmy',
      'ru': 'Жаренная сердцевина пальмы',
      'uk': 'Смажені пальмові серцевини',
      'ko': '대추야자 나무순 튀김',
      'zh': '棕榈炒心',
      'ja': 'Fried Hearts Of Palm',
    }, {
      'id': 'FriedTaro',
      'en': 'Fried Taro',
      'fr': 'Taro frit',
      'es': 'Taro frito',
      'de': 'Frittierte Taro',
      'pl': 'Smażona kolokazja',
      'ru': 'Жареный таро',
      'uk': 'Смажене Таро',
      'ko': '튀긴 토란',
      'zh': '炸芋头',
      'ja': 'Fried Taro',
    }, {
      'id': 'FriedTomatoes',
      'en': 'Fried Tomatoes',
      'fr': 'Tomates frites',
      'es': 'Tomates fritos',
      'de': 'Frittierte Tomaten',
      'pl': 'Smażone pomidory',
      'ru': 'Жареные помидоры',
      'uk': 'Смажені помідори',
      'ko': '튀긴 토마토',
      'zh': '炸番茄',
      'ja': 'フライドトマト',
    }, {
      'id': 'FrothFloatationCell',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation',
      'es': 'Celda de espuma flotante',
      'de': 'Schaumschwimmzelle',
      'pl': 'Pianka pływacka',
      'ru': 'Флотатор',
      'uk': 'Флотатор',
      'ko': '거품 부유 분별기',
      'zh': '泡沫浮选池',
      'ja': 'Froth Floatation Cell',
    }, {
      'id': 'FruitMuffin',
      'en': 'Fruit Muffin',
      'fr': 'Muffin aux fruits',
      'es': 'Muffin de fruta',
      'de': 'Fruchtmuffin',
      'pl': 'Babeczka owocowa',
      'ru': 'Фруктовый кекс',
      'uk': 'Фруктовий мафін',
      'ko': '과일 머핀',
      'zh': '水果松饼',
      'ja': 'Fruit Muffin',
    }, {
      'id': 'ExoticFruitSalad',
      'en': 'Exotic Fruit Salad',
      'fr': 'Salade de fruit exotique',
      'es': 'Ensalada de Frutas Exóticas',
      'de': 'Exotischer Fruchtsalat',
      'pl': 'Tropikalna sałatka owocowa',
      'ru': 'Экзотический фруктовый салат',
      'uk': 'Екзотичний фруктовий салат',
      'ko': '이국적인 과일 샐러드',
      'zh': '异国风味的水果沙拉',
      'ja': 'エキゾチックフルーツサラダ',
    }, {
      'id': 'MixedFruitSalad',
      'en': 'Mixed Fruit Salad',
      'fr': 'Salade de fruit',
      'es': 'Ensalada Mixta de Frutas',
      'de': 'Gemischter Fruchtsalat',
      'pl': 'Sałatka Owocowo-mieszana',
      'ru': 'Смешанный фруктовый салат',
      'uk': 'Змішаний фруктовий салат',
      'ko': '혼합 과일 샐러드',
      'zh': '什果沙拉',
      'ja': 'ミックスフルーツサラダ',
    }, {
      'id': 'RainforestFruitSalad',
      'en': 'Rainforest Fruit Salad',
      'fr': 'Salade de fruit de la jungle',
      'es': 'Ensalada de frutas de la jungla',
      'de': 'Regenwaldfruchtsalat',
      'pl': 'Rainforest Fruit Salad',
      'ru': 'Тропический фруктовый салат',
      'uk': 'Тропічний фруктовий салат',
      'ko': '열대우림 과일 샐러드',
      'zh': '雨林水果沙拉',
      'ja': '熱帯雨林のフルーツ サラダ',
    }, {
      'id': 'FruitTart',
      'en': 'Fruit Tart',
      'fr': 'Tarte aux fruits',
      'es': 'Tarta de frutas',
      'de': 'Obstkuchen',
      'pl': 'Tarta owocowa',
      'ru': 'Фруктовый тарт',
      'uk': 'Фруктовий тарт',
      'ko': '과일 타르트',
      'zh': '水果馅饼',
      'ja': 'Fruit Tart',
    }, {
      'id': 'GardenBoots',
      'en': 'Garden Boots',
      'fr': 'Bottes de jardinage',
      'es': 'Botas de Jardín',
      'de': 'Gartenschuhe',
      'pl': 'Buty ogrodnicze',
      'ru': 'Садовые сапоги',
      'uk': 'Садові чоботи',
      'ko': '정원 부츠',
      'zh': '花园靴',
      'ja': '金の靴',
    }, {
      'id': 'Gasoline',
      'en': 'Gasoline',
      'fr': 'Essence',
      'es': 'Gasolina',
      'de': 'Benzin',
      'pl': 'Benzyna',
      'ru': 'Бензин',
      'uk': 'Бензин',
      'ko': '휘발유',
      'zh': '汽油',
      'ja': 'ガソリン',
    }, {
      'id': 'GatheringResearchPaperBasic',
      'en': 'Gathering Research Paper Basic',
      'fr': 'Papier de recherche : Récolte basique',
      'es': 'Trabajo de investigación en recolección (básico)',
      'de': 'Grundlegendes Forschungspapier: Sammeln',
      'pl': 'Podstawowy artykuł badawczy Zbieractwa',
      'ru': 'Исследование по базовому собирательству',
      'uk': 'Базове дослідження збирання',
      'ko': '기초 수확 연구지',
      'zh': '基础收集研究论文',
      'ja': 'Gathering Research Paper Basic',
    }, {
      'id': 'Gearbox',
      'en': 'Gearbox',
      'fr': 'Boîte de vitesses',
      'es': 'Caja de Cambios',
      'de': 'Getriebe',
      'pl': 'Skrzynia Biegów',
      'ru': 'Коробка передач',
      'uk': 'Коробка передач',
      'ko': '변속 장치',
      'zh': '齿轮箱',
      'ja': 'ギアボックス',
    }, {
      'id': 'GeologyResearchPaperAdvanced',
      'en': 'Geology Research Paper Advanced',
      'fr': 'Papier de recherche : Géologie avancée',
      'es': 'Trabajo de investigación en geología (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Geologie',
      'pl': 'Zaawansowany artykuł badawczy Geologii',
      'ru': 'Исследование по продвинутой геологии',
      'uk': 'Дослідження вдосконаленої геології',
      'ko': '고급 지질학 연구지',
      'zh': '高级地质学研究论文',
      'ja': 'Geology Research Paper Advanced',
    }, {
      'id': 'GeologyResearchPaperBasic',
      'en': 'Geology Research Paper Basic',
      'fr': 'Papier de recherche : Géologie basique',
      'es': 'Trabajo de investigación en geología (básico)',
      'de': 'Grundlegendes Forschungspapier: Geologie',
      'pl': 'Podstawowy artykuł badawczy Geologii',
      'ru': 'Исследование по базовой геологии',
      'uk': 'Дослідження базової геології',
      'ko': '기초 지질한 연구지',
      'zh': '基础地质学研究论文',
      'ja': 'Geology Research Paper Basic',
    }, {
      'id': 'GeologyResearchPaperModern',
      'en': 'Geology Research Paper Modern',
      'fr': 'Papier de recherche : Géologie moderne',
      'es': 'Trabajo de investigación en geología (moderno)',
      'de': 'Modernes Forschungspapier: Geologie',
      'pl': 'Nowoczesny artykuł badawczy Geologii',
      'ru': 'Исследование по современной геологии',
      'uk': 'Дослідження сучасної геології',
      'ko': '현대식 지질학 연구지',
      'zh': '现代地质学研究论文',
      'ja': 'Geology Research Paper Modern',
    }, {
      'id': 'GigotSleeveShirt',
      'en': 'Gigot Sleeve Shirt',
      'fr': 'Chemise à manches gigot',
      'es': 'Camisa de manga gigot',
      'de': 'Hülsenhemd',
      'pl': 'Bufiasta Koszula',
      'ru': 'Рубашка с пышными рукавами',
      'uk': 'Сорочка з пишними рукавами',
      'ko': '지고 소매 셔츠',
      'zh': '羊腿袖衬衫',
      'ja': '子羊の足を模ったシャツ',
    }, {
      'id': 'Glass',
      'en': 'Glass',
      'fr': 'Verre',
      'es': 'Vidrio',
      'de': 'Glas',
      'pl': 'Szkło',
      'ru': 'Стекло',
      'uk': 'Скло',
      'ko': '유리',
      'zh': '玻璃',
      'ja': 'ガラス',
    }, {
      'id': 'GlassworkingAdvancedUpgrade',
      'en': 'Glassworking Advanced Upgrade',
      'fr': 'Amélioration Avancée : Travail du verre',
      'es': 'Mejora avanzada: Artesanía de cristal',
      'de': 'Fortschrittliches Upgrade: Glasverarbeitung',
      'pl': 'Zaawansowane ulepszenie Obróbki Szkła',
      'ru': 'Продвинутое улучшение для стеклообработки',
      'uk': 'Glassworking Advanced Upgrade',
      'ko': '고급 유리 제조 기술 업그레이드',
      'zh': '玻璃加工高级升级',
      'ja': 'Glassworking Advanced Upgrade',
    }, {
      'id': 'GlassworkingModernUpgrade',
      'en': 'Glassworking Modern Upgrade',
      'fr': 'Amélioration Moderne : Travail du verre',
      'es': 'Mejora moderna: Artesanía del cristal',
      'de': 'Modernes Upgrade: Glasverarbeitung',
      'pl': 'Nowoczesne ulepszenie Obróbki Szkła',
      'ru': 'Современное улучшение для обработки стекла',
      'uk': 'Новітнє покращення обробки скла',
      'ko': '현대식 유리 제조 기술 업그레이드',
      'zh': '玻璃加工现代升级',
      'ja': 'Glassworking Modern Upgrade',
    }, {
      'id': 'GoatMount',
      'en': 'Goat Mount',
      'fr': 'Trophée de chèvre des montagnes',
      'es': 'Montura para cabra',
      'de': 'Ausgestopfte Bergziege',
      'pl': 'Goat Mount',
      'ru': 'Голова козы',
      'uk': 'Голова кози',
      'ko': '염소 벽걸이 박제',
      'zh': '山羊山',
      'ja': 'Goat Mount',
    }, {
      'id': 'GoldBar',
      'en': 'Gold Bar',
      'fr': 'Lingot d\u0027or',
      'es': 'Barra de oro',
      'de': 'Goldbarren',
      'pl': 'Sztabka złota',
      'ru': 'Золотой брусок',
      'uk': 'Золотий брусок',
      'ko': '금괴',
      'zh': '金条',
      'ja': '金のインゴット',
    }, {
      'id': 'SmeltGold',
      'en': 'Smelt Gold',
      'fr': 'Fondre de l\u0027or',
      'es': 'Fundir Oro',
      'de': 'Gold schmelzen',
      'pl': 'Smelt Gold',
      'ru': 'Плавить золото',
      'uk': 'Виплавити золото',
      'ko': '금 제련법',
      'zh': '炼金',
      'ja': '金の精錬',
    }, {
      'id': 'ConcentrateGoldLv2',
      'en': 'Concentrate Gold Lv2',
      'fr': 'Concentré d\u0027or Nv2',
      'es': 'Concentrado de oro (niv. 2)',
      'de': 'Goldkonzentrat Lv2',
      'pl': 'Koncentrat złota Poz2',
      'ru': 'Концентрировать золото Ур.2',
      'uk': 'Концентрування золота Рів. 2',
      'ko': '정제된 금광석 Lv2',
      'zh': '浮选金矿石 等级2',
      'ja': 'Concentrate Gold Lv2',
    }, {
      'id': 'GoldConcentrate',
      'en': 'Gold Concentrate',
      'fr': 'Concentré d\u0027or',
      'es': 'Concentrado de oro',
      'de': 'Goldkonzentrat',
      'pl': 'Złoty koncentrat',
      'ru': 'Концентрат золота',
      'uk': 'Концентрат золота',
      'ko': '정제된 금광석',
      'zh': '筛选金矿石',
      'ja': 'Gold Concentrate',
    }, {
      'id': 'GoldFlakes',
      'en': 'Gold Flakes',
      'fr': 'Paillettes d\u0027or',
      'es': 'Copos de Oro',
      'de': 'Blattgold',
      'pl': 'Płatki złota',
      'ru': 'Чешуйки золота',
      'uk': 'Золоті пластівці',
      'ko': '금조각',
      'zh': '金片',
      'ja': '金箔',
    }, {
      'id': 'GoldWiring',
      'en': 'Gold Wiring',
      'fr': 'Fil d\u0027or',
      'es': 'Cables de oro',
      'de': 'Goldverdrahtung',
      'pl': 'Złote Okablowanie',
      'ru': 'Золотой провод',
      'uk': 'Золотий дріт',
      'ko': '금전선',
      'zh': '金接线',
      'ja': 'Gold Wiring',
    }, {
      'id': 'HandPlow',
      'en': 'Hand Plow',
      'fr': 'Charrue à main',
      'es': 'Arado manual',
      'de': 'Handpflug',
      'pl': 'Hand Plow',
      'ru': 'Ручной плуг',
      'uk': 'Hand Plow',
      'ko': '손쟁기',
      'zh': '手犁',
      'ja': 'Hand Plow',
    }, {
      'id': 'HangingLongSteelSign',
      'en': 'Hanging Long Steel Sign',
      'fr': 'Long panneau suspendu en acier',
      'es': 'Letrero colgante largo (acero)',
      'de': 'Stahlschild (lang, hängend)',
      'pl': 'Hanging Long Steel Sign',
      'ru': 'Стальная длинная вывеска',
      'uk': 'Hanging Long Steel Sign',
      'ko': '교수형 긴 강철 기호',
      'zh': '长条钢制悬挂标志',
      'ja': 'Hanging Long Steel Sign',
    }, {
      'id': 'HangingSteelFramedSign',
      'en': 'Hanging Steel Framed Sign',
      'fr': 'Grand panneau suspendu encadré en acier',
      'es': 'Letrero colgante con marco (acero)',
      'de': 'Stahlschild (gerahmt, hängend)',
      'pl': 'Hanging Steel Framed Sign',
      'ru': 'Стальная обрамлённая вывеска',
      'uk': 'Hanging Steel Framed Sign',
      'ko': '교수형 강철 액자 기호',
      'zh': '钢制框式悬挂标志',
      'ja': 'Hanging Steel Framed Sign',
    }, {
      'id': 'HangingSteelMineSign',
      'en': 'Hanging Steel Mine Sign',
      'fr': 'Panneau moyen suspendu de mine en acier',
      'es': 'Letrero colgante de mina (acero)',
      'de': 'Stahlschild für Minen (hängend)',
      'pl': 'Hanging Steel Mine Sign',
      'ru': 'Стальная вывеска для шахты',
      'uk': 'Hanging Steel Mine Sign',
      'ko': '교수형 철강 광산 기호',
      'zh': '矿用钢悬挂标志',
      'ja': 'Hanging Steel Mine Sign',
    }, {
      'id': 'HangingSteelPlainSign',
      'en': 'Hanging Steel Plain Sign',
      'fr': 'Panneau moyen suspendu en plaque d’acier',
      'es': 'Letrero colgante (acero)',
      'de': 'Stahlschild (glatt, hängend)',
      'pl': 'Hanging Steel Plain Sign',
      'ru': 'Стальная обычная вывеска',
      'uk': 'Hanging Steel Plain Sign',
      'ko': '교수형 강철 일반 기호',
      'zh': '钢制平整悬挂标志',
      'ja': 'Hanging Steel Plain Sign',
    }, {
      'id': 'HangingSteelShopSign',
      'en': 'Hanging Steel Shop Sign',
      'fr': 'Panneau moyen suspendu de magasin en acier',
      'es': 'Letrero colgante de tienda (acero)',
      'de': 'Stahlschild für Geschäft (hängend)',
      'pl': 'Hanging Steel Shop Sign',
      'ru': 'Стальная магазинная вывеска',
      'uk': 'Hanging Steel Shop Sign',
      'ko': '교수형 철강 상점 기호',
      'zh': '钢制商店悬挂标志',
      'ja': 'Hanging Steel Shop Sign',
    }, {
      'id': 'HeartyHometownPizza',
      'en': 'Hearty Hometown Pizza',
      'fr': 'Pizza copieuse de mon enfance',
      'es': 'Pizza de la Ciudad Natal',
      'de': 'Pizza Home Sweet Home',
      'pl': 'Sycąca domowa pizza',
      'ru': 'Hearty Hometown Pizza',
      'uk': 'Hearty Hometown Pizza',
      'ko': 'Hearty Hometown Pizza',
      'zh': '温馨故乡比萨',
      'ja': 'Hearty Hometown Pizza',
    }, {
      'id': 'HeatSink',
      'en': 'Heat Sink',
      'fr': 'Dissipateur de chaleur',
      'es': 'Disipador de calor',
      'de': 'Kühlkörper',
      'pl': 'Radiator',
      'ru': 'Теплообменник',
      'uk': 'Розсіювач тепла',
      'ko': '방열판',
      'zh': '散热片',
      'ja': 'ヒートシンク',
    }, {
      'id': 'Henley',
      'en': 'Henley',
      'fr': 'Chemise Henley',
      'es': 'Henley',
      'de': 'Henleyshirt',
      'pl': 'Koszulka z Guzikami',
      'ru': 'Хенли',
      'uk': 'Хенлі',
      'ko': '헨리 셔츠',
      'zh': '亨利衫',
      'ja': '襟なしのシャツ',
    }, {
      'id': 'HewnBench',
      'en': 'Hewn Bench',
      'fr': 'Banc taillé',
      'es': 'Banco tallado',
      'de': 'Massivholzbank',
      'pl': 'Ociosana ławka',
      'ru': 'Лавка из обтёсанной древесины',
      'uk': 'Лавка із обтесаного дерева',
      'ko': '다듬은 벤치',
      'zh': '凿台',
      'ja': 'Hewn Bench',
    }, {
      'id': 'HewnChair',
      'en': 'Hewn Chair',
      'fr': 'Chaise taillée',
      'es': 'Silla tallada',
      'de': 'Massivholzstuhl',
      'pl': 'Ociosane krzesło',
      'ru': 'Стул из обтёсанного дерева',
      'uk': 'Стілець із обтесаного дерева',
      'ko': '다듬은 의자',
      'zh': '椅子',
      'ja': 'Hewn Chair',
    }, {
      'id': 'HewnDoor',
      'en': 'Hewn Door',
      'fr': 'Porte taillée',
      'es': 'Puerta tallada',
      'de': 'Massivholztür',
      'pl': 'Ociosane drzwi',
      'ru': 'Дверь из обтёсанного дерева',
      'uk': 'Двері з обтісаних досок',
      'ko': '다듬은 문',
      'zh': '凿门',
      'ja': 'Hewn Door',
    }, {
      'id': 'HewnDresser',
      'en': 'Hewn Dresser',
      'fr': 'Commode taillée',
      'es': 'Vestidor tallado',
      'de': 'Massivholz Kommode',
      'pl': 'Hewn Dresser',
      'ru': 'Комод из тесаного дерева',
      'uk': 'Hewn Dresser',
      'ko': '손질한 드레서',
      'zh': '锯木化妆台',
      'ja': 'Hewn Dresser',
    }, {
      'id': 'HewnLogs',
      'en': 'Hewn Logs',
      'fr': 'Rondins taillés',
      'es': 'Troncos tallados',
      'de': 'Massivholz',
      'pl': 'Ociosane kłody',
      'ru': 'Тёсаные брёвна',
      'uk': 'Обтесані колоди',
      'ko': '잘라낸 통나무',
      'zh': '粗凿原木',
      'ja': '丸太材',
    }, {
      'id': 'HewnNightstand',
      'en': 'Hewn Nightstand',
      'fr': 'Table de chevet en bois taillé',
      'es': 'Mesa de noche tallada',
      'de': 'Massivholz Nachttisch',
      'pl': 'Hewn Nightstand',
      'ru': 'Тумбочка из тесаного дерева',
      'uk': 'Hewn Nightstand',
      'ko': '깎은 협탁',
      'zh': '锯木床头柜',
      'ja': 'Hewn Nightstand',
    }, {
      'id': 'HewnTable',
      'en': 'Hewn Table',
      'fr': 'Table taillée',
      'es': 'Mesa tallada',
      'de': 'Massivholztisch',
      'pl': 'Ociosany stół',
      'ru': 'Стол из обтёсанного дерева',
      'uk': 'Стіл із обтесаного дерева',
      'ko': '다듬은 탁자',
      'zh': '割台',
      'ja': 'Hewn Table',
    }, {
      'id': 'HideAshFertilizer',
      'en': 'Hide Ash Fertilizer',
      'fr': 'Engrais à base de cendres de peaux',
      'es': 'Fertilizante de Ceniza de Cuero',
      'de': 'Dünger aus Lederasche',
      'pl': 'Nawóz z popiołu skórzanego',
      'ru': 'Зольное удобрение из шкуры',
      'uk': 'Добриво з попелу від згорілої шкіри',
      'ko': '가죽 재 비료',
      'zh': '皮灰化肥',
      'ja': '皮灰の肥料',
    }, {
      'id': 'Hosomaki',
      'en': 'Hosomaki',
      'fr': 'Hosomaki',
      'es': 'Hosomaki',
      'de': 'Hosomaki',
      'pl': 'Hosomaki',
      'ru': 'Хосомаки',
      'uk': 'Hosomaki',
      'ko': '김밥',
      'zh': '手握寿司',
      'ja': 'Hosomaki',
    }, {
      'id': 'HuckleberryExtract',
      'en': 'Huckleberry Extract',
      'fr': 'Extrait de myrtilles',
      'es': 'Extracto de Arándano',
      'de': 'Heidelbeerextrakt',
      'pl': 'Ekstrakt z Czarnej Jagody',
      'ru': 'Экстракт черники',
      'uk': 'Екстракт чорниці',
      'ko': '월귤나무 열매 추출물',
      'zh': '越橘汁',
      'ja': 'Ekstrakt jagodowy',
    }, {
      'id': 'HuckleberryFritter',
      'en': 'Huckleberry Fritter',
      'fr': 'Beignet aux myrtilles',
      'es': 'Buñuelo de Arándanos',
      'de': 'Gebackene Heidelbeeren',
      'pl': 'Huckleberry Fritter',
      'ru': 'Черничные Оладьи',
      'uk': 'Huckleberry Fritter',
      'ko': 'Huckleberry Fritter',
      'zh': '越橘油炸馅饼',
      'ja': 'Huckleberry Fritter',
    }, {
      'id': 'HuckleberryPie',
      'en': 'Huckleberry Pie',
      'fr': 'Tourte aux myrtilles',
      'es': 'Tarta de Arándanos',
      'de': 'Heidelbeerkuchen',
      'pl': 'Ciasto Jagodowe',
      'ru': 'Черничный пирог',
      'uk': 'Чорничний пиріг',
      'ko': '월귤나무 열매 파이',
      'zh': '越橘馅饼',
      'ja': 'Ciasto jagodowe',
    }, {
      'id': 'HuckleberrySeed',
      'en': 'Huckleberry Seed',
      'fr': 'Graine de myrtilles',
      'es': 'Semilla de Arándano',
      'de': 'Samen (Heidelbeere)',
      'pl': 'Nasiona Jagody',
      'ru': 'Семечко черники',
      'uk': 'Насіння чорниць',
      'ko': '월귤나무 씨앗',
      'zh': '越橘种子',
      'ja': 'ハックルベリーの種',
    }, {
      'id': 'Hydrocolloids',
      'en': 'Hydrocolloids',
      'fr': 'Hydrocolloïdes',
      'es': 'Hidrocoloides',
      'de': 'Hydrokolloide',
      'pl': 'Hydrokoloidy',
      'ru': 'Загуститель',
      'uk': 'Гідроколоїди',
      'ko': '하이드로콜로이드',
      'zh': '亲水胶体',
      'ja': 'Hydrokoloidy',
    }, {
      'id': 'RefineFish',
      'en': 'Refine Fish',
      'fr': 'Affiner le poisson',
      'es': 'Pescado Refinado',
      'de': 'Fisch aufbereiten',
      'pl': 'Udoskonal ryby',
      'ru': 'Переработать рыбу',
      'uk': 'Переробити рибу',
      'ko': '생선 가공법',
      'zh': '精制鱼肉',
      'ja': '魚を精製する',
    }, {
      'id': 'RefineKelp',
      'en': 'Refine Kelp',
      'fr': 'Affiner le varech',
      'es': 'Algas Refinadas',
      'de': 'Seetang aufbereiten',
      'pl': 'Refine Kelp',
      'ru': 'Переработать ламинарию',
      'uk': 'Переробити ламінарію',
      'ko': '다시마 가공법',
      'zh': '精制海带',
      'ja': '昆布を精製する',
    }, {
      'id': 'RefineMeat',
      'en': 'Refine Meat',
      'fr': 'Affiner la viande',
      'es': 'Refinar Carne',
      'de': 'Fleisch aufbereiten',
      'pl': 'Oczyszczone mięso',
      'ru': 'Переработать мясо',
      'uk': 'Переробити м’ясо',
      'ko': '고기 가공법',
      'zh': '精制肉食',
      'ja': '肉を精製する',
    }, {
      'id': 'Icebox',
      'en': 'Icebox',
      'fr': 'Glacière',
      'es': 'Nevera',
      'de': 'Eisschrank',
      'pl': 'Lodówka',
      'ru': 'Ледник',
      'uk': 'Льодовник',
      'ko': '아이스 박스',
      'zh': '冷藏箱',
      'ja': 'アイスボックス',
    }, {
      'id': 'IndustrialElevator',
      'en': 'Industrial Elevator',
      'fr': 'Ascenseur industriel',
      'es': 'Montacargas industrial',
      'de': 'Industrieaufzug',
      'pl': 'Industrial Elevator',
      'ru': 'Промышленный лифт',
      'uk': 'Industrial Elevator',
      'ko': '산업용 엘리베이터',
      'zh': '工业化升降机',
      'ja': 'Industrial Elevator',
    }, {
      'id': 'IndustryUpgrade',
      'en': 'Industry Upgrade',
      'fr': 'Amélioration Moderne : Industrie',
      'es': 'Mejora: Industria',
      'de': 'Upgrade Industrie',
      'pl': 'Ulepszenie Przemysłu',
      'ru': 'Улучшение для промышленности',
      'uk': 'Покращення промисловості',
      'ko': '산업 기술 업그레이드',
      'zh': '产业升级',
      'ja': 'Industry Upgrade',
    }, {
      'id': 'InfusedOil',
      'en': 'Infused Oil',
      'fr': 'Huile infusée',
      'es': 'Aceite Infusionado',
      'de': 'Raffiniertes Öl',
      'pl': 'Olej smakowy',
      'ru': 'Масляный настой',
      'uk': 'Насичена олія',
      'ko': '침출유',
      'zh': '浸泡油',
      'ja': '混合油',
    }, {
      'id': 'IronAxe',
      'en': 'Iron Axe',
      'fr': 'Hache en fer',
      'es': 'Hacha de Hierro',
      'de': 'Eisenaxt',
      'pl': 'Żelazna siekiera',
      'ru': 'Железный топор',
      'uk': 'Залізна сокира',
      'ko': '철 도끼',
      'zh': '铁斧',
      'ja': '鉄のオノ',
    }, {
      'id': 'IronAxle',
      'en': 'Iron Axle',
      'fr': 'Essieu en fer',
      'es': 'Eje de hierro',
      'de': 'Eisenachse',
      'pl': 'Żelazna siekiera',
      'ru': 'Железная ось',
      'uk': 'Залізна вісь',
      'ko': '철재 차축',
      'zh': '铁质车轴',
      'ja': '鉄の車軸',
    }, {
      'id': 'IronBar',
      'en': 'Iron Bar',
      'fr': 'Lingot de fer',
      'es': 'Barra de Hierro',
      'de': 'Eisenbarren',
      'pl': 'Sztabka żelaza',
      'ru': 'Железный брусок',
      'uk': 'Залізний брусок',
      'ko': '철괴',
      'zh': '铁条',
      'ja': '鉄のインゴット',
    }, {
      'id': 'SmeltIron',
      'en': 'Smelt Iron',
      'fr': 'Fondre du fer',
      'es': 'Fundir Hierro',
      'de': 'Eisen schmelzen',
      'pl': 'Smelt Iron',
      'ru': 'Плавить железо',
      'uk': 'Виплавити залізо',
      'ko': '철 제련법',
      'zh': '炼铁',
      'ja': '鉄の精錬',
    }, {
      'id': 'ConcentrateDryIron',
      'en': 'Concentrate Dry Iron',
      'fr': 'Concentré de fer sec',
      'es': 'Concentrado de hierro seco',
      'de': 'Eisenkonzentrat',
      'pl': 'Koncentrat suchego żelaza',
      'ru': 'Сухое концентрирование железа',
      'uk': 'Сухе концентрування заліза',
      'ko': '건식 정제된 철광석',
      'zh': '筛选干铁矿石',
      'ja': 'Concentrate Dry Iron',
    }, {
      'id': 'ConcentrateDryIronLv2',
      'en': 'Concentrate Dry Iron Lv2',
      'fr': 'Concentré de fer sec Nv2',
      'es': 'Concentrado de hierro seco (niv. 2)',
      'de': 'Eisenkonzentrat Lv2',
      'pl': 'Koncentrat suchego żelaza Poz2',
      'ru': 'Сухое концентрирование железа Ур.2',
      'uk': 'Сухе концентрування заліза Рів. 2',
      'ko': '건식 정제된 철광석 Lv2',
      'zh': '筛选干铁矿石 等级2',
      'ja': 'Concentrate Dry Iron Lv2',
    }, {
      'id': 'ConcentrateIronLv2',
      'en': 'Concentrate Iron Lv2',
      'fr': 'Concentré de fer Nv2',
      'es': 'Concentrado de hierro (niv. 2)',
      'de': 'Eisenkonzentrat Lv2',
      'pl': 'Koncentrat żelaza Poz2',
      'ru': 'Концентрировать железо Ур.2',
      'uk': 'Концентрування заліза Рів. 2',
      'ko': '정제된 철광석 Lv2',
      'zh': '浮选铁矿石 等级2',
      'ja': 'Concentrate Iron Lv2',
    }, {
      'id': 'IronConcentrate',
      'en': 'Iron Concentrate',
      'fr': 'Concentré de fer',
      'es': 'Concentrado de hierro',
      'de': 'Eisenkonzentrat',
      'pl': 'Żelazny koncentrat',
      'ru': 'Концентрат железа',
      'uk': 'Концентрат Заліза',
      'ko': '정제된 철광석',
      'zh': '筛选铁矿石',
      'ja': 'Iron Concentrate',
    }, {
      'id': 'IronGear',
      'en': 'Iron Gear',
      'fr': 'Engrenage en fer',
      'es': 'Engranaje de hierro',
      'de': 'Eisenzahnrad',
      'pl': 'Żelazne koło zębate',
      'ru': 'Железная шестерня',
      'uk': 'Залізна шестірня',
      'ko': '철재 톱니바퀴',
      'zh': '铁质齿轮',
      'ja': '鉄のギア',
    }, {
      'id': 'IronHammer',
      'en': 'Iron Hammer',
      'fr': 'Marteau en fer',
      'es': 'Martillo de Hierro',
      'de': 'Eisenhammer',
      'pl': 'Żelazny młotek',
      'ru': 'Железный молоток',
      'uk': 'Залізний молоток',
      'ko': '철 망치',
      'zh': '铁锤',
      'ja': '鉄のハンマー',
    }, {
      'id': 'IronHoe',
      'en': 'Iron Hoe',
      'fr': 'Binette en fer',
      'es': 'Azada de Hierro',
      'de': 'Eisenhacke',
      'pl': 'Żelazna motyka',
      'ru': 'Железная тяпка',
      'uk': 'Залізна мотика',
      'ko': '철 괭이',
      'zh': '铁锄',
      'ja': '鉄のクワ',
    }, {
      'id': 'IronMachete',
      'en': 'Iron Machete',
      'fr': 'Machette en fer',
      'es': 'Machete de hierro',
      'de': 'Eisenmachete',
      'pl': 'Żelazna maczeta',
      'ru': 'Железное мачете',
      'uk': 'Залізне мачете',
      'ko': '철 마체테',
      'zh': '铁质砍刀',
      'ja': 'Iron Machete',
    }, {
      'id': 'IronPickaxe',
      'en': 'Iron Pickaxe',
      'fr': 'Pioche en fer',
      'es': 'Pico de Hierro',
      'de': 'Eisenspitzhacke',
      'pl': 'Żelazny kilof',
      'ru': 'Железная кирка',
      'uk': 'Залізне кайло',
      'ko': '철 곡괭이',
      'zh': '铁镐',
      'ja': '鉄のツルハシ',
    }, {
      'id': 'IronPipe',
      'en': 'Iron Pipe',
      'fr': 'Tuyau en fer',
      'es': 'Tuberia de Hierro',
      'de': 'Eisenrohr',
      'pl': 'Żelazna rura',
      'ru': 'Железная труба',
      'uk': 'Залізна труба',
      'ko': '철 파이프',
      'zh': '铁管',
      'ja': '鉄パイプ',
    }, {
      'id': 'IronPlate',
      'en': 'Iron Plate',
      'fr': 'Plaque de fer',
      'es': 'Placa de Hierro',
      'de': 'Eisenplatte',
      'pl': 'Żelazny Talerz',
      'ru': 'Железная пластина',
      'uk': 'Залізна пластина',
      'ko': '철판',
      'zh': '铁板',
      'ja': '鉄板',
    }, {
      'id': 'IronRockDrill',
      'en': 'Iron Rock Drill',
      'fr': 'Foreuse de roche en fer',
      'es': 'Perforadora de hierro para rocas',
      'de': 'Eisenfelsbohrer',
      'pl': 'Żelazne wiertło skalne',
      'ru': 'Железный геологический бур',
      'uk': 'Залізний геологічний бур',
      'ko': '철재 착암기',
      'zh': '铁凿岩机',
      'ja': 'Iron Rock Drill',
    }, {
      'id': 'IronSawBlade',
      'en': 'Iron Saw Blade',
      'fr': 'Lame de scie en fer',
      'es': 'Sierra circular de hierro',
      'de': 'Eisensägeblatt',
      'pl': 'Żelazne Ostrze Piły',
      'ru': 'Железный пильный диск',
      'uk': 'Залізний пиляльний диск',
      'ko': '철 톱날',
      'zh': '铁锯片',
      'ja': 'Iron Saw Blade',
    }, {
      'id': 'IronShovel',
      'en': 'Iron Shovel',
      'fr': 'Pelle en fer',
      'es': 'Pala de Hierro',
      'de': 'Eisenschaufel',
      'pl': 'Żelazna łopata',
      'ru': 'Железная лопата',
      'uk': 'Залізна лопата',
      'ko': '철 삽',
      'zh': '铁铲',
      'ja': '鉄のシャベル',
    }, {
      'id': 'IronSickle',
      'en': 'Iron Sickle',
      'fr': 'Faucille en fer',
      'es': 'Hoz de hierro',
      'de': 'Eisensichel',
      'pl': 'Żelazny Sierp',
      'ru': 'Железный серп',
      'uk': 'Залізний серп',
      'ko': '철 낫',
      'zh': '铁镰',
      'ja': 'Iron Sickle',
    }, {
      'id': 'IronWheel',
      'en': 'Iron Wheel',
      'fr': 'Roue en fer',
      'es': 'Rueda de hierro',
      'de': 'Rad aus Eisen',
      'pl': 'Żelazne koło',
      'ru': 'Железное колесо',
      'uk': 'Залізне колесо',
      'ko': '철재 바퀴',
      'zh': '铁轮',
      'ja': '鉄の車輪',
    }, {
      'id': 'JawCrusher',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires en acier',
      'es': 'Trituradora',
      'de': 'Kieferbrecher',
      'pl': 'Kruszarka szczękowa',
      'ru': 'Щековая дробилка',
      'uk': 'Щокова дробарка',
      'ko': '암석 패쇄기',
      'zh': '颚式破碎机',
      'ja': 'Jaw Crusher',
    }, {
      'id': 'JungleCampfireSalad',
      'en': 'Jungle Campfire Salad',
      'fr': 'Salade de la jungle cuite au feu de camp',
      'es': 'Ensalada braseada con madera de jungla',
      'de': 'Lagerfeuer Dschungelsalat',
      'pl': 'Dżunglowa sałatka z ogniska',
      'ru': 'Джунглевый салат на костре',
      'uk': 'Салат, приготований в таборі у джунглях',
      'ko': '정글 모닥불 샐러드',
      'zh': '丛林篝火沙拉',
      'ja': 'Jungle Campfire Salad',
    }, {
      'id': 'JungleCampfireStew',
      'en': 'Jungle Campfire Stew',
      'fr': 'Ragoût de la jungle cuit au feu de camp',
      'es': 'Estofado braseado con madera de jungla',
      'de': 'Lagerfeuer Dschungeleintopf',
      'pl': 'Tropikalny gulasz z ogniska',
      'ru': 'Джунглевое рагу на костре',
      'uk': 'Рагу, приготоване на багатті в джунглях',
      'ko': '정글 모닥불 스튜',
      'zh': '丛林篝火炖汤',
      'ja': 'Jungle Campfire Stew',
    }, {
      'id': 'KelpyCrabRoll',
      'en': 'Kelpy Crab Roll',
      'fr': 'Maki au crabe',
      'es': 'Rollo de Cangrejo con Algas',
      'de': 'Krabbenrolle mit Algen',
      'pl': 'Kelpy Crab Roll',
      'ru': 'Ролл Краб в ламинарии',
      'uk': 'Kelpy Crab Roll',
      'ko': 'Kelpy Crab Roll',
      'zh': '苏格兰蟹肉卷',
      'ja': 'Kelpy Crab Roll',
    }, {
      'id': 'Kiln',
      'en': 'Kiln',
      'fr': 'Four à céramique',
      'es': 'Horno',
      'de': 'Brennofen',
      'pl': 'Piec do Wypalania',
      'ru': 'Печь для обжига',
      'uk': 'Промислова піч',
      'ko': '가마',
      'zh': '窑',
      'ja': 'かまど',
    }, {
      'id': 'Kitchen',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '주방',
      'zh': '厨房',
      'ja': 'キッチン',
    }, {
      'id': 'Laboratory',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Laboratorium',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'Лабораторія',
      'ko': '연구대',
      'zh': '实验室',
      'ja': '研究所',
    }, {
      'id': 'LargeBathMat',
      'en': 'Large Bath Mat',
      'fr': 'Grand tapis de bain',
      'es': 'Alfombrilla de baño grande',
      'de': 'Große Badematte',
      'pl': 'Large Bath Mat',
      'ru': 'Большой коврик для ванной',
      'uk': 'Large Bath Mat',
      'ko': 'Large Bath Mat',
      'zh': '大型浴室防滑垫',
      'ja': 'Large Bath Mat',
    }, {
      'id': 'WeaveLargeBathMat',
      'en': 'Weave Large Bath Mat',
      'fr': 'Tisser un grand tapis de bain',
      'es': 'Alfombra Grande de Baño Tejida',
      'de': 'Große Badematte weben',
      'pl': 'Weave Large Bath Mat',
      'ru': 'Ткать Большой коврик для ванной',
      'uk': 'Weave Large Bath Mat',
      'ko': 'Weave Large Bath Mat',
      'zh': '纺织大号浴室地垫',
      'ja': 'Weave Large Bath Mat',
    }, {
      'id': 'LargeCorrugatedSteelDoor',
      'en': 'Large Corrugated Steel Door',
      'fr': 'Porte de garage en tôle ondulée',
      'es': 'Puerta grande corrugada (acero)',
      'de': 'Große Wellstahltür',
      'pl': 'Duże drzwi ze stali falistej',
      'ru': 'Рольставни',
      'uk': 'Великі гофровані сталеві двері',
      'ko': '큰 파형 강철판 문',
      'zh': '大型波纹钢门',
      'ja': '波形鉄板でできた大きなドア',
    }, {
      'id': 'LargeHangingAshlarStoneSign',
      'en': 'Large Hanging Ashlar Stone Sign',
      'fr': 'Grand panneau suspendu en pierre taillée',
      'es': 'Letrero colgante grande (sillar de piedra)',
      'de': 'Steinquaderschild (Groß, hängend)',
      'pl': 'Duży wiszący znak z ciosanego kamienia',
      'ru': 'Большая вывеска из резного камня',
      'uk': 'Велика вивіска з обтесаного каменю',
      'ko': '큰 걸이형 모르타르 마감 현무암 간판',
      'zh': '大型吊石板标志',
      'ja': 'Large Hanging Ashlar Stone Sign',
    }, {
      'id': 'LargeHangingLumberSign',
      'en': 'Large Hanging Lumber Sign',
      'fr': 'Grand panneau suspendu en bois d\u0027oeuvre',
      'es': 'Letrero colgante grande (tablas de madera)',
      'de': 'Bauholzschild (Groß, hängend)',
      'pl': 'Large Hanging Lumber Sign',
      'ru': 'Большая вывеска из пиломатериалов',
      'uk': 'Велика навісна дерев’яна табличка',
      'ko': '큰 걸이형 가공 목재 간판',
      'zh': '大型木制标志',
      'ja': '木製の大きな掛け看板',
    }, {
      'id': 'LargeHangingMortaredStoneSign',
      'en': 'Large Hanging Mortared Stone Sign',
      'fr': 'Grand panneau suspendu en pierre cimentée',
      'es': 'Letrero colgante grande (piedra con mortero)',
      'de': 'Steinziegelschild (Groß, hängend)',
      'pl': 'Duży wiszący znak ze spojonego zaprawą kamienia',
      'ru': 'Большая вывеска из строительного камня',
      'uk': 'Велика вивіска з будівельного каменю',
      'ko': '큰 걸이형 모르타르 마감 석재 간판',
      'zh': '大型悬挂砂浆石标志',
      'ja': 'Large Hanging Mortared Stone Sign',
    }, {
      'id': 'LargeHangingWoodSign',
      'en': 'Large Hanging Wood Sign',
      'fr': 'Grand panneau suspendu en bois',
      'es': 'Letrero colgante grande (básico)',
      'de': 'Holzschild (Groß, hängend)',
      'pl': 'Duży wiszący znak drewniany',
      'ru': 'Большая деревянная вывеска',
      'uk': 'Велика дерев\u0027яна вивіска',
      'ko': '큰 걸이형 목재 간판',
      'zh': '大型悬挂木质标志',
      'ja': 'Large Hanging Wood Sign',
    }, {
      'id': 'LargeLumberDoor',
      'en': 'Large Lumber Door',
      'fr': 'Porte de garage en bois d\u0027oeuvre',
      'es': 'Puerta grande de madera',
      'de': 'Große Holztür',
      'pl': 'Large Lumber Door',
      'ru': 'Деревянные ворота',
      'uk': 'Великі дерев’яні двері',
      'ko': '큰 가공 목재 문',
      'zh': '大木门',
      'ja': '大きな製材のドア',
    }, {
      'id': 'LargeLumberStockpile',
      'en': 'Large Lumber Stockpile',
      'fr': 'Réserve en bois d\u0027oeuvre grande',
      'es': 'Pila grande de troncos',
      'de': 'Bauholzlager (Groß)',
      'pl': 'Large Lumber Stockpile',
      'ru': 'Большой склад из пиломатериалов',
      'uk': 'Великий склад з пиломатеріалів',
      'ko': '대형 가공 목재 자재 창고',
      'zh': '大型木制料堆',
      'ja': 'Large Lumber Stockpile',
    }, {
      'id': 'LargeStandingAshlarStoneSign',
      'en': 'Large Standing Ashlar Stone Sign',
      'fr': 'Grand panneau sur pied en pierre taillée',
      'es': 'Letrero grande (sillar de piedra)',
      'de': 'Steinquaderschild (Groß, stehend)',
      'pl': 'Duży stojący znak z ciosanego kamienia',
      'ru': 'Большая табличка из резного камня',
      'uk': 'Велика табличка з обтесаного каменю',
      'ko': '큰 각진 석재 선간판',
      'zh': '大型立阿什拉尔石标志',
      'ja': 'Large Standing Ashlar Stone Sign',
    }, {
      'id': 'LargeStandingLumberSign',
      'en': 'Large Standing Lumber Sign',
      'fr': 'Grand panneau sur pied en bois d\u0027oeuvre',
      'es': 'Letrero grande (tablas de madera)',
      'de': 'Bauholzschild (Groß, stehend)',
      'pl': 'Large Standing Lumber Sign',
      'ru': 'Большая табличка из пиломатериалов',
      'uk': 'Велика стояча дерев’яна табличка',
      'ko': '큰 가공 목재 선간판',
      'zh': '大块木制标志',
      'ja': '木製の大きな立て看板',
    }, {
      'id': 'LargeStandingMortaredStoneSign',
      'en': 'Large Standing Mortared Stone Sign',
      'fr': 'Grand panneau sur pied en pierre cimenté',
      'es': 'Letrero grande (piedra con mortero)',
      'de': 'Steinziegelschild (Groß, stehend)',
      'pl': 'Duży stojący szyld ze spojonego zaprawą kamienia',
      'ru': 'Большая табличка из строительного камня',
      'uk': 'Велика табличка з будівельного каменю',
      'ko': '큰 모르타르 마감 석재 선간판',
      'zh': '大型立式砂浆石标志',
      'ja': 'Large Standing Mortared Stone Sign',
    }, {
      'id': 'LargeStandingWoodSign',
      'en': 'Large Standing Wood Sign',
      'fr': 'Grand panneau sur pied en bois',
      'es': 'Letrero grande (básico)',
      'de': 'Holzschild (Groß, stehend)',
      'pl': 'Duży Stojący Znak z Drewna',
      'ru': 'Большая деревянная табличка',
      'uk': 'Велика дерев\u0027яна табличка',
      'ko': '큰 목재 선간판',
      'zh': '大型立式木标志',
      'ja': 'Large Standing Wood Sign',
    }, {
      'id': 'LargeWindowedLumberDoor',
      'en': 'Large Windowed Lumber Door',
      'fr': 'Porte de garage vitrée en bois d\u0027oeuvre',
      'es': 'Puerta de troncos grande con ventana',
      'de': 'Große Holztür mit Fenster',
      'pl': 'Large Windowed Lumber Door',
      'ru': 'Деревянные ворота с окошками',
      'uk': 'Великі дерев’яні двері з віконцями',
      'ko': '창문 달린 큰 가공 목재 문',
      'zh': '带窗户的大木门',
      'ja': '窓付きの大きな木製ドア',
    }, {
      'id': 'Laser',
      'en': 'Laser',
      'fr': 'Laser',
      'es': 'Láser',
      'de': 'Laser',
      'pl': 'Laser',
      'ru': 'Лазер',
      'uk': 'Лазер',
      'ko': '레이저',
      'zh': '激光',
      'ja': 'レーザー砲',
    }, {
      'id': 'Lathe',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehmaschine',
      'pl': 'Lathe',
      'ru': 'Токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반 기계',
      'zh': '车床',
      'ja': 'Lathe',
    }, {
      'id': 'LeavenedDough',
      'en': 'Leavened Dough',
      'fr': 'Pâte au levain',
      'es': 'Masa con levadura',
      'de': 'Hefeteig',
      'pl': 'Ciasto drożdżowe',
      'ru': 'Дрожжевое тесто',
      'uk': 'Дріжджове тісто',
      'ko': '발효된 반죽',
      'zh': '发酵面团',
      'ja': 'Leavened Dough',
    }, {
      'id': 'LightBackpack',
      'en': 'Light Backpack',
      'fr': 'Sac à dos léger',
      'es': 'Mochila Ligera',
      'de': 'Leichter Rucksack',
      'pl': 'Lekki Plecak',
      'ru': 'Лёгкий рюкзак',
      'uk': 'Легкий рюкзак',
      'ko': '가벼운 배낭',
      'zh': '轻便背包',
      'ja': '軽量バックパック',
    }, {
      'id': 'LightBulb',
      'en': 'Light Bulb',
      'fr': 'Ampoule',
      'es': 'Bombilla',
      'de': 'Glühbirne',
      'pl': 'Żarówka',
      'ru': 'Лампочка',
      'uk': 'Лампочка',
      'ko': '전구',
      'zh': '灯泡',
      'ja': '電球',
    }, {
      'id': 'LimestoneBisonStatue',
      'en': 'Limestone Bison Statue',
      'fr': 'Statue de bison en calcaire',
      'es': 'Estatua de bisonte (piedra caliza)',
      'de': 'Kalksteinstatue Bison',
      'pl': 'Wapienna statua bizona',
      'ru': 'Статуя бизона из известняка',
      'uk': 'Статуя бізона з вапняку',
      'ko': '석회암 들소 조각상',
      'zh': '石灰石野牛雕像',
      'ja': 'Limestone Bison Statue',
    }, {
      'id': 'LimestoneOtterStatue',
      'en': 'Limestone Otter Statue',
      'fr': 'Statue de loutre en calcaire',
      'es': 'Estatua de nutria (piedra caliza)',
      'de': 'Kalksteinstatue Otter',
      'pl': 'Wapienna statua wydry',
      'ru': 'Статуя выдры из известняка',
      'uk': 'Статуя видри з вапняку',
      'ko': '석회암 수달 조각상',
      'zh': '石灰石水獭雕像',
      'ja': 'Limestone Otter Statue',
    }, {
      'id': 'LimestoneOwlStatue',
      'en': 'Limestone Owl Statue',
      'fr': 'Statue de hibou en calcaire',
      'es': 'Estatura de búho (piedra caliza)',
      'de': 'Kalksteinstatue Eule',
      'pl': 'Wapienna statua sowy',
      'ru': 'Статуя совы из известняка',
      'uk': 'Статуя сови з вапняку',
      'ko': '석회암 부엉이 조각상',
      'zh': '石灰石猫头鹰雕像',
      'ja': 'Limestone Owl Statue',
    }, {
      'id': 'LimestoneWolfStatue',
      'en': 'Limestone Wolf Statue',
      'fr': 'Statue de loup en calcaire',
      'es': 'Estatura de lobo (piedra caliza)',
      'de': 'Kalksteinstatue Wolf',
      'pl': 'Wapienna statua wilka',
      'ru': 'Статуя волка из известняка',
      'uk': 'Статуя вовка з вапняку',
      'ko': '석회암 늑대 조각상',
      'zh': '石灰石狼雕像',
      'ja': 'Limestone Wolf Statue',
    }, {
      'id': 'LiquidNitrogen',
      'en': 'Liquid Nitrogen',
      'fr': 'Azote liquide',
      'es': 'Nitrógeno Líquido',
      'de': 'Flüssiger Stickstoff',
      'pl': 'Ciekły azot',
      'ru': 'Жидкий азот',
      'uk': 'Рідкий азот',
      'ko': '액체 질소',
      'zh': '液氮',
      'ja': '液体窒素',
    }, {
      'id': 'LoadedTaroFries',
      'en': 'Loaded Taro Fries',
      'fr': 'Frites de taro gras',
      'es': 'Patatas fritas de Taro Cargadas',
      'de': 'Überbackene Taro-Fritten',
      'pl': 'Loaded Taro Fries',
      'ru': 'Жареная колоказия с начинкой',
      'uk': 'Loaded Taro Fries',
      'ko': 'Loaded Taro Fries',
      'zh': '油炸芋头',
      'ja': 'Loaded Taro Fries',
    }, {
      'id': 'LoggingAdvancedUpgrade',
      'en': 'Logging Advanced Upgrade',
      'fr': 'Amélioration Avancée : Abattage',
      'es': 'Mejora avanzada: Tala',
      'de': 'Fortschrittliches Upgrade: Holzfäller',
      'pl': 'Zaawansowane ulepszenie Wyrębu Drzew',
      'ru': 'Продвинутое улучшение для заготовки леса',
      'uk': 'Logging Advanced Upgrade',
      'ko': '고급 벌목 기술 업그레이드',
      'zh': '伐木高级升级',
      'ja': 'Logging Advanced Upgrade',
    }, {
      'id': 'LoggingBasicUpgrade',
      'en': 'Logging Basic Upgrade',
      'fr': 'Amélioration Basique : Abattage',
      'es': 'Mejora básica: Tala',
      'de': 'Grundlegendes Upgrade: Holzfäller',
      'pl': 'Podstawowe ulepszenie Wyrębu Drzew',
      'ru': 'Базовое улучшение для заготовки леса',
      'uk': 'Logging Basic Upgrade',
      'ko': '기초 벌목 기술 업그레이드',
      'zh': '伐木基础升级',
      'ja': 'Logging Basic Upgrade',
    }, {
      'id': 'Loom',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Loom',
      'ru': 'Ткацкий станок',
      'uk': 'Loom',
      'ko': '직조기',
      'zh': '织布机',
      'ja': 'Loom',
    }, {
      'id': 'LowTopShoes',
      'en': 'Low Top Shoes',
      'fr': 'Chaussures basses',
      'es': 'Zapatos Bajos',
      'de': 'Halbschuhe',
      'pl': 'Trampki',
      'ru': 'Кеды',
      'uk': 'Кеди',
      'ko': '로우탑 운동화',
      'zh': '低帮鞋',
      'ja': 'ロートップシューズ',
    }, {
      'id': 'LumberBench',
      'en': 'Lumber Bench',
      'fr': 'Banc en bois d\u0027œuvre',
      'es': 'Banco de troncos',
      'de': 'Bauholzbank',
      'pl': 'Ławka z Drewna',
      'ru': 'Лавка из пиломатериалов',
      'uk': 'Лава з пиломатеріалів',
      'ko': '가공된 목재 벤치',
      'zh': '木材长凳',
      'ja': 'Lumber Bench',
    }, {
      'id': 'LumberChair',
      'en': 'Lumber Chair',
      'fr': 'Chaise en bois d\u0027œuvre',
      'es': 'Silla de troncos',
      'de': 'Bauholzstuhl',
      'pl': 'Krzesło z Drewna',
      'ru': 'Стул из пиломатериалов',
      'uk': 'Стілець з пиломатеріалів',
      'ko': '가공된 목재 의자',
      'zh': '木材椅子',
      'ja': 'Lumber Chair',
    }, {
      'id': 'LumberDoor',
      'en': 'Lumber Door',
      'fr': 'Porte en bois',
      'es': 'Puerta de Madera',
      'de': 'Bauholztür',
      'pl': 'Drzwi z Drewna',
      'ru': 'Дверь из пиломатериалов',
      'uk': 'Дерев’яні двері',
      'ko': '가공 목재 문',
      'zh': '木门',
      'ja': '木製のドア',
    }, {
      'id': 'LumberDresser',
      'en': 'Lumber Dresser',
      'fr': 'Commode en bois d\u0027œuvre',
      'es': 'Cómoda de madera',
      'de': 'Bauholzkommode',
      'pl': 'Lumber Dresser',
      'ru': 'Комод из пиломатериалов',
      'uk': 'Lumber Dresser',
      'ko': '가공된 목재 드레서',
      'zh': '木衣柜',
      'ja': 'Lumber Dresser',
    }, {
      'id': 'Lumber',
      'en': 'Lumber',
      'fr': 'Bois d\u0027oeuvre',
      'es': 'Maderas',
      'de': 'Bauholz',
      'pl': 'Tarcica',
      'ru': 'Пиломатериал',
      'uk': 'Пиломатеріали',
      'ko': '가공된 목재',
      'zh': '板材',
      'ja': '製材',
    }, {
      'id': 'LumberStockpile',
      'en': 'Lumber Stockpile',
      'fr': 'Réserve en bois d\u0027oeuvre',
      'es': 'Pila de almacenamiento para troncos',
      'de': 'Bauholzlager',
      'pl': 'Lumber Stockpile',
      'ru': 'Склад из пиломатериалов',
      'uk': 'Склад з пиломатеріалів',
      'ko': '가공 목재 자재창고',
      'zh': '木材库存',
      'ja': 'Lumber Stockpile',
    }, {
      'id': 'LumberTable',
      'en': 'Lumber Table',
      'fr': 'Table en bois d\u0027œuvre',
      'es': 'Mesa de troncos',
      'de': 'Bauholztisch',
      'pl': 'Stół do tarcicy',
      'ru': 'Стол из пиломатериалов',
      'uk': 'Стіл з пиломатеріалів',
      'ko': '가공된 목재 테이블',
      'zh': '木材桌',
      'ja': 'Lumber Table',
    }, {
      'id': 'Macarons',
      'en': 'Macarons',
      'fr': 'Macarons',
      'es': 'Macarones',
      'de': 'Makaronen',
      'pl': 'Macarons',
      'ru': 'Макарон',
      'uk': 'Macarons',
      'ko': 'Macarons',
      'zh': '马卡龙',
      'ja': 'Macarons',
    }, {
      'id': 'MachinistTable',
      'en': 'Machinist Table',
      'fr': 'Établi de mécanicien',
      'es': 'Mesa de maquinista',
      'de': 'Mechanikertisch',
      'pl': 'Machinist Table',
      'ru': 'Слесарный верстак',
      'uk': 'Стіл машиніста',
      'ko': '기계공 작업대',
      'zh': '机械师工作台',
      'ja': '機械工のテーブル',
    }, {
      'id': 'Maltodextrin',
      'en': 'Maltodextrin',
      'fr': 'Maltodextrine',
      'es': 'Maltodextrina',
      'de': 'Maltodextrin',
      'pl': 'Maltodekstryna',
      'ru': 'Патока',
      'uk': 'Патока',
      'ko': '말토덱스트린',
      'zh': '麦芽糊精',
      'ja': 'Maltodekstryna',
    }, {
      'id': 'MasonryAdvancedUpgrade',
      'en': 'Masonry Advanced Upgrade',
      'fr': 'Amélioration Avancée : Maçonnerie',
      'es': 'Mejora avanzada: Mampostería',
      'de': 'Fortschrittliches Upgrade: Steinmetz',
      'pl': 'Zaawansowane ulepszenie Kamieniarstwa',
      'ru': 'Продвинутое улучшение для каменной кладки',
      'uk': 'Masonry Advanced Upgrade',
      'ko': '고급 석조 기술 업그레이드',
      'zh': '高级石工升级组件',
      'ja': 'Masonry Advanced Upgrade',
    }, {
      'id': 'MasonryBasicUpgrade',
      'en': 'Masonry Basic Upgrade',
      'fr': 'Amélioration Basique : Maçonnerie',
      'es': 'Mejora básica: Mampostería',
      'de': 'Grundlegendes Upgrade: Steinmetz',
      'pl': 'Podstawowe ulepszenie Kamieniarstwa',
      'ru': 'Базовое улучшение для каменной кладки',
      'uk': 'Masonry Basic Upgrade',
      'ko': '기초 석조 기술 업그레이드',
      'zh': '基础石工升级组件',
      'ja': 'Masonry Basic Upgrade',
    }, {
      'id': 'MeatPie',
      'en': 'Meat Pie',
      'fr': 'Tourte à la viande',
      'es': 'Tarta de Carne',
      'de': 'Fleischpastete',
      'pl': 'Mięso w cieście',
      'ru': 'Мясной пирог',
      'uk': 'М’ясний пиріг',
      'ko': '고기 파이',
      'zh': '肉馅饼',
      'ja': 'ミートパイ',
    }, {
      'id': 'MeatStock',
      'en': 'Meat Stock',
      'fr': 'Bouillon de viande',
      'es': 'Caldo de Carne',
      'de': 'Brühe aus Fleisch',
      'pl': 'Rosół',
      'ru': 'Мясной бульон',
      'uk': 'М’ясний бульйон',
      'ko': '고기 육수',
      'zh': '肉汤料',
      'ja': '肉スープの素',
    }, {
      'id': 'FishStew',
      'en': 'Fish Stew',
      'fr': 'Ragoût de poisson',
      'es': 'Estofado de pescado',
      'de': 'Lagerfeuer Fischeintopf',
      'pl': 'Fish Stew',
      'ru': 'Рыбное рагу',
      'uk': 'Fish Stew',
      'ko': '생선 스튜',
      'zh': '鱼汤',
      'ja': 'Fish Stew',
    }, {
      'id': 'MeatyStew',
      'en': 'Meaty Stew',
      'fr': 'Ragoût de viande',
      'es': 'Estofado de carne',
      'de': 'Lagerfeuer Fleischeintopf',
      'pl': 'Mięsny jeż',
      'ru': 'Мясное рагу',
      'uk': 'М\u0027ясна рагу',
      'ko': '고기 스튜',
      'zh': '肉炖',
      'ja': 'Meaty Stew',
    }, {
      'id': 'MechanicalWaterPump',
      'en': 'Mechanical Water Pump',
      'fr': 'Pompe à eau mécanique',
      'es': 'Bomba de agua mecánica',
      'de': 'Mechanische Wasserpumpe',
      'pl': 'Mechaniczna pompa wodna',
      'ru': 'Механический водяной насос',
      'uk': 'Механічний водяний насос',
      'ko': '기계식 물 펌프',
      'zh': '机械能水泵',
      'ja': '機械式ウォーター ポンプ',
    }, {
      'id': 'MechanicsAdvancedUpgrade',
      'en': 'Mechanics Advanced Upgrade',
      'fr': 'Amélioration Avancée : Mécaniques',
      'es': 'Mejora avanzada: Mecánica',
      'de': 'Fortschrittliches Upgrade: Mechanik',
      'pl': 'Zaawansowane ulepszenie Mechaniki',
      'ru': 'Продвинутое улучшение для механики',
      'uk': 'Mechanics Advanced Upgrade',
      'ko': '고급 기계정비 기술 업그레이드',
      'zh': '机械高级升级',
      'ja': 'Mechanics Advanced Upgrade',
    }, {
      'id': 'MechanicsModernUpgrade',
      'en': 'Mechanics Modern Upgrade',
      'fr': 'Amélioration Moderne : Mécaniques',
      'es': 'Mejora moderna: Mecánica',
      'de': 'Modernes Upgrade: Mechanik',
      'pl': 'Nowoczesne ulepszenie Mechaniki',
      'ru': 'Современное улучшение для механики',
      'uk': 'Новітнє покращення механіки',
      'ko': '현대식 기계정비 기술 업그레이드',
      'zh': '机械现代升级',
      'ja': 'Mechanics Modern Upgrade',
    }, {
      'id': 'MetallurgyResearchPaperAdvanced',
      'en': 'Metallurgy Research Paper Advanced',
      'fr': 'Papier de recherche : Métallurgie avancée',
      'es': 'Trabajo de investigación en metalurgia (avanzado)',
      'de': 'Fortgeschrittenes Forschungspapier: Metallurgie',
      'pl': 'Zaawansowany artykuł badawczy Metalurgii',
      'ru': 'Исследование по продвинутой металлургии',
      'uk': 'Дослідження вдосконаленої металургії',
      'ko': '고급 금속공학 연구지',
      'zh': '高级冶金研究论文',
      'ja': 'Metallurgy Research Paper Advanced',
    }, {
      'id': 'MetallurgyResearchPaperBasic',
      'en': 'Metallurgy Research Paper Basic',
      'fr': 'Papier de recherche : Métallurgie basique',
      'es': 'Trabajo de investigación en metalurgia (básico)',
      'de': 'Grundlegendes Forschungspapier: Metallurgie',
      'pl': 'Podstawowy artykuł badawczy Metalurgii',
      'ru': 'Исследование по базовой металлургии',
      'uk': 'Дослідження базової металургії',
      'ko': '기초 금속공학 연구지',
      'zh': '基础冶金研究论文',
      'ja': 'Metallurgy Research Paper Basic',
    }, {
      'id': 'MetallurgyResearchPaperModern',
      'en': 'Metallurgy Research Paper Modern',
      'fr': 'Papier de recherche : Métallurgie moderne',
      'es': 'Trabajo de investigación en metalurgia (moderno)',
      'de': 'Modernes Forschungspapier: Metallurgie',
      'pl': 'Nowoczesny artykuł badawczy Metalurgii',
      'ru': 'Исследование по современной металлургии',
      'uk': 'Дослідження сучасної металургії',
      'ko': '현대식 금속공학 연구지',
      'zh': '现代冶金研究论文',
      'ja': 'Metallurgy Research Paper Modern',
    }, {
      'id': 'Mill',
      'en': 'Mill',
      'fr': 'Meule',
      'es': 'Molino',
      'de': 'Mahlwerk',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'Млин',
      'ko': '맷돌',
      'zh': '磨坊',
      'ja': '製粉機',
    }, {
      'id': 'MillingUpgrade',
      'en': 'Milling Upgrade',
      'fr': 'Amélioration Avancée : Mouture',
      'es': 'Mejora: Molienda',
      'de': 'Fortschrittliches Upgrade: Mahlen',
      'pl': 'Ulepszenie Młynarstwa',
      'ru': 'Улучшение для мельничного дела',
      'uk': 'Покращення млинарства',
      'ko': '제분 기술 업그레이드',
      'zh': '铣削升级',
      'ja': 'Milling Upgrade',
    }, {
      'id': 'MillionairesSalad',
      'en': 'Millionaires Salad',
      'fr': 'Salade du millionnaire',
      'es': 'Ensalada del millionario',
      'de': 'Millionär-Salat',
      'pl': 'Millionaires Salad',
      'ru': 'Салат Миллионера',
      'uk': 'Millionaires Salad',
      'ko': 'Millionaires Salad',
      'zh': '百万富翁沙拉',
      'ja': 'Millionaires Salad',
    }, {
      'id': 'MiningAdvancedUpgrade',
      'en': 'Mining Advanced Upgrade',
      'fr': 'Amélioration Avancée : Minage',
      'es': 'Mejora avanzada: Minería',
      'de': 'Fortschrittliches Upgrade: Bergbau',
      'pl': 'Zaawansowane ulepszenie Górnictwa',
      'ru': 'Продвинутое улучшение для горного дела',
      'uk': 'Просунуте покращення видобутку',
      'ko': '고급 채광 기술 업그레이드',
      'zh': '采矿高级升级',
      'ja': 'Mining Advanced Upgrade',
    }, {
      'id': 'MiningBasicUpgrade',
      'en': 'Mining Basic Upgrade',
      'fr': 'Amélioration Basique : Minage',
      'es': 'Mejora básica: Minería',
      'de': 'Grundlegendes Upgrade: Bergbau',
      'pl': 'Podstawowe ulepszenie Górnictwa',
      'ru': 'Базовое улучшение для горного дела',
      'uk': 'Базове покращення видобутку',
      'ko': '기초 채광 기술 업그레이드',
      'zh': '采矿基础升级',
      'ja': 'Mining Basic Upgrade',
    }, {
      'id': 'MiningModernUpgrade',
      'en': 'Mining Modern Upgrade',
      'fr': 'Amélioration Moderne : Minage',
      'es': 'Mejora moderna: Minería',
      'de': 'Modernes Upgrade: Bergbau',
      'pl': 'Nowoczesne ulepszenie Górnictwa',
      'ru': 'Современное улучшение для горного дела',
      'uk': 'Новітнє покращення видобутку',
      'ko': '현대식 채광 기술 업그레이드',
      'zh': '采矿现代化升级',
      'ja': 'Mining Modern Upgrade',
    }, {
      'id': 'Mint',
      'en': 'Mint',
      'fr': 'Hôtel de monnaie',
      'es': 'Ceca',
      'de': 'Münzprägemaschine',
      'pl': 'Mennica',
      'ru': 'Пресс для чеканки монет',
      'uk': 'Карбувальний верстат',
      'ko': '조폐기',
      'zh': '铸币厂',
      'ja': '造幣機',
    }, {
      'id': 'Mochi',
      'en': 'Mochi',
      'fr': 'Mochi',
      'es': 'Mochi',
      'de': 'Mochi',
      'pl': 'Mochi',
      'ru': 'Моти',
      'uk': 'Mochi',
      'ko': 'Mochi',
      'zh': '糯米团',
      'ja': 'Mochi',
    }, {
      'id': 'ModernAxe',
      'en': 'Modern Axe',
      'fr': 'Hache moderne',
      'es': 'Hacha moderna',
      'de': 'Moderne Axt',
      'pl': 'Nowoczesna Siekiera',
      'ru': 'Современный топор',
      'uk': 'Сучасна сокира',
      'ko': '현대식 도끼',
      'zh': '现代斧',
      'ja': '近代的なオノ',
    }, {
      'id': 'ModernDoubleStreetLight',
      'en': 'Modern Double Street Light',
      'fr': 'Lampadaire double moderne',
      'es': 'Farola doble moderna',
      'de': 'Moderne zweiarmige Straßenlaterne',
      'pl': 'Nowoczesne podwójne światło uliczne',
      'ru': 'Современный двойной уличный фонарь',
      'uk': 'Сучасний подвійний вуличний ліхтар',
      'ko': '현대식 이중 가로등',
      'zh': '现代双路灯',
      'ja': 'Modern Double Street Light',
    }, {
      'id': 'ModernHammer',
      'en': 'Modern Hammer',
      'fr': 'Marteau moderne',
      'es': 'Martillo Moderno',
      'de': 'Moderner Hammer',
      'pl': 'Nowoczesny Młotek',
      'ru': 'Современный молоток',
      'uk': 'Сучасний молоток',
      'ko': '현대식 망치',
      'zh': '现代锤',
      'ja': '近代的なハンマー',
    }, {
      'id': 'ModernHoe',
      'en': 'Modern Hoe',
      'fr': 'Binette moderne',
      'es': 'Azada Moderna',
      'de': 'Moderne Hacke',
      'pl': 'Nowoczesna Motyka',
      'ru': 'Современная тяпка',
      'uk': 'Сучасна мотика',
      'ko': '현대식 괭이',
      'zh': '现代锄',
      'ja': '近代的なクワ',
    }, {
      'id': 'ModernMachete',
      'en': 'Modern Machete',
      'fr': 'Machette moderne',
      'es': 'Machete moderno',
      'de': 'Moderne Machete',
      'pl': 'Nowoczesna maczeta',
      'ru': 'Современное мачете',
      'uk': 'Сучасне мачете',
      'ko': '현대식 마체테',
      'zh': '现代砍刀',
      'ja': 'Modern Machete',
    }, {
      'id': 'ModernPickaxe',
      'en': 'Modern Pickaxe',
      'fr': 'Pioche moderne',
      'es': 'Pico Moderno',
      'de': 'Moderne Spitzhacke',
      'pl': 'Nowoczesny Kilof',
      'ru': 'Современная кирка',
      'uk': 'Сучасне кайло',
      'ko': '현대식 곡괭이',
      'zh': '现代镐',
      'ja': '近代的なツルハシ',
    }, {
      'id': 'ModernRockDrill',
      'en': 'Modern Rock Drill',
      'fr': 'Foreuse de roche moderne',
      'es': 'Perforadora moderna',
      'de': 'Moderner Felsbohrer',
      'pl': 'Nowoczesne wiertło skalne',
      'ru': 'Современный геологический бур',
      'uk': 'Сучасний бур',
      'ko': '현대식 착암기',
      'zh': '现代凿岩机',
      'ja': 'Modern Rock Drill',
    }, {
      'id': 'ModernScythe',
      'en': 'Modern Scythe',
      'fr': 'Faucille moderne',
      'es': 'Guadaña moderna',
      'de': 'Moderne Sense',
      'pl': 'Nowoczesna Kosa',
      'ru': 'Современная коса',
      'uk': 'Сучасна коса',
      'ko': '현대식 낫',
      'zh': '现代镰刀',
      'ja': '近代的なカマ',
    }, {
      'id': 'ModernShovel',
      'en': 'Modern Shovel',
      'fr': 'Pelle moderne',
      'es': 'Pala Moderna',
      'de': 'Moderne Schaufel',
      'pl': 'Nowoczesna Łopata',
      'ru': 'Современная лопата',
      'uk': 'Сучасна лопата',
      'ko': '현대식 삽',
      'zh': '现代铲',
      'ja': '近代的なシャベル',
    }, {
      'id': 'ModernStreetLight',
      'en': 'Modern Street Light',
      'fr': 'Lampadaire moderne',
      'es': 'Farola moderna',
      'de': 'Moderne Straßenlaterne',
      'pl': 'Nowoczesne światło uliczne',
      'ru': 'Современный уличный фонарь',
      'uk': 'Сучасний вуличний ліхтар',
      'ko': '현대식 가로등',
      'zh': '现代路灯',
      'ja': 'Modern Street Light',
    }, {
      'id': 'ModernUpgradeLvl1',
      'en': 'Modern Upgrade 1',
      'fr': 'Amélioration Moderne Nv1',
      'es': 'Mejora moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesne ulepszenie 1',
      'ru': 'Современное улучшение 1',
      'uk': 'Новітнє покращення 1',
      'ko': '현대식 업그레이드 1',
      'zh': '现代升级1',
      'ja': '近代アップグレード1',
    }, {
      'id': 'ModernUpgradeLvl2',
      'en': 'Modern Upgrade 2',
      'fr': 'Amélioration Moderne Nv2',
      'es': 'Mejora moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesne ulepszenie 2',
      'ru': 'Современное улучшение 2',
      'uk': 'Новітнє покращення 2',
      'ko': '현대식 업그레이드 2',
      'zh': '现代升级2',
      'ja': '近代アップグレード2',
    }, {
      'id': 'ModernUpgradeLvl3',
      'en': 'Modern Upgrade 3',
      'fr': 'Amélioration Moderne Nv3',
      'es': 'Mejora moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesne ulepszenie 3',
      'ru': 'Современное улучшение 3',
      'uk': 'Новітнє покращення 3',
      'ko': '현대식 업그레이드 3',
      'zh': '现代升级3',
      'ja': '近代アップグレード3',
    }, {
      'id': 'ModernUpgradeLvl4',
      'en': 'Modern Upgrade 4',
      'fr': 'Amélioration Moderne Nv4',
      'es': 'Mejora moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesne ulepszenie 4',
      'ru': 'Современное улучшение 4',
      'uk': 'Новітнє покращення 4',
      'ko': '현대식 업그레이드 4',
      'zh': '现代升级4',
      'ja': '近代アップグレード4',
    }, {
      'id': 'BakedMortar',
      'en': 'Baked Mortar',
      'fr': 'Mortier au four',
      'es': 'Mortero cocido',
      'de': 'Gebackener Mörtel',
      'pl': 'Wypalona zaprawa',
      'ru': 'Вытопленный раствор',
      'uk': 'Витоплений розчин',
      'ko': '구운 모르타르',
      'zh': '烘烤砂浆',
      'ja': '焼けたモルタル',
    }, {
      'id': 'MasonryMortar',
      'en': 'Masonry Mortar',
      'fr': 'Mortier de maçonnerie',
      'es': 'Mortero de mampostería',
      'de': 'Steinmörtel',
      'pl': 'Zaprawa murarska',
      'ru': 'Раствор каменщика',
      'uk': 'Розчин для кам\u0027яної кладки',
      'ko': '석조 모르타르',
      'zh': '石料砂浆',
      'ja': '石工モルタル',
    }, {
      'id': 'WheatMortar',
      'en': 'Wheat Mortar',
      'fr': 'Mortier de blé',
      'es': 'Mortero de trigo',
      'de': 'Weizenmörtel',
      'pl': 'Pszenna zaprawa',
      'ru': 'Раствор из пшеницы',
      'uk': 'Мелена пшениця',
      'ko': '밀 모르타르',
      'zh': '小麦砂浆',
      'ja': '小麦モルタル',
    }, {
      'id': 'MortaredStoneBench',
      'en': 'Mortared Stone Bench',
      'fr': 'Banc en pierre cimentée',
      'es': 'Banco de piedra con mortero',
      'de': 'Steinziegelbank',
      'pl': 'Kamienna ławka',
      'ru': 'Лавка из строительного камня',
      'uk': 'Лавка з будівельного каміння',
      'ko': '모르타르 마감 석재 벤치',
      'zh': '砂浆石凳',
      'ja': 'Mortared Stone Bench',
    }, {
      'id': 'MortaredStoneChair',
      'en': 'Mortared Stone Chair',
      'fr': 'Chaise en pierre cimentée',
      'es': 'Silla de piedra con mortero',
      'de': 'Steinziegelstuhl',
      'pl': 'Kamienne krzesło',
      'ru': 'Стул из строительного камня',
      'uk': 'Стілець із будівельного каміння',
      'ko': '모르타르 마감 석재 의자',
      'zh': '砂浆石椅',
      'ja': 'Mortared Stone Chair',
    }, {
      'id': 'MortaredStoneDoor',
      'en': 'Mortared Stone Door',
      'fr': 'Porte en pierre cimentée',
      'es': 'Puerta de piedra con mortero',
      'de': 'Steinziegeltür',
      'pl': 'Cementowane kamienne drzwi',
      'ru': 'Дверь из строительного камня',
      'uk': 'Двері з будівельного каміння',
      'ko': '모르타르 마감 석재 문',
      'zh': '砂浆石门',
      'ja': 'Mortared Stone Door',
    }, {
      'id': 'MortaredStoneFireplace',
      'en': 'Mortared Stone Fireplace',
      'fr': 'Foyer en pierre cimentée',
      'es': 'Chimenea de piedra con mortero',
      'de': 'Steinziegel Feuerstelle',
      'pl': 'Kominek z kamienia spojonego zaprawą',
      'ru': 'Камин из строительного камня',
      'uk': 'Камін із будівельного каміння',
      'ko': '모르타르 마감 석재 벽난로',
      'zh': '砂浆石壁炉',
      'ja': 'Mortared Stone Fireplace',
    }, {
      'id': 'MortaredStone',
      'en': 'Mortared Stone',
      'fr': 'Pierre cimentée',
      'es': 'Piedra con mortero',
      'de': 'Ziegel aus Stein',
      'pl': 'Spojony zaprawą kamień',
      'ru': 'Строительный камень',
      'uk': 'Будівельне каміння',
      'ko': '모르타르 마감 석재',
      'zh': '浆砌石',
      'ja': 'モルタル',
    }, {
      'id': 'MortaredStoneTable',
      'en': 'Mortared Stone Table',
      'fr': 'Table en pierre cimentée',
      'es': 'Mesa de piedra con mortero',
      'de': 'Steinziegeltisch',
      'pl': 'Kamienny stół',
      'ru': 'Стол из строительного камня',
      'uk': 'Стіл з будівельного каміння',
      'ko': '모르타르 마감 석재 탁자',
      'zh': '砂浆石桌',
      'ja': 'Mortared Stone Table',
    }, {
      'id': 'Nail',
      'en': 'Nail',
      'fr': 'Clou',
      'es': 'Clavo',
      'de': 'Nagel',
      'pl': 'Gwóźdź',
      'ru': 'Гвоздь',
      'uk': 'Цвях',
      'ko': '못',
      'zh': '钉',
      'ja': 'Nail',
    }, {
      'id': 'NylonCarpet',
      'en': 'Nylon Carpet',
      'fr': 'Tapis en nylon',
      'es': 'Alfombra de nailon',
      'de': 'Nylonteppich',
      'pl': 'Nylon Carpet',
      'ru': 'Нейлоновый ковер',
      'uk': 'Nylon Carpet',
      'ko': '나일론 카펫',
      'zh': '尼龙地毯',
      'ja': 'Nylon Carpet',
    }, {
      'id': 'WeaveNylonCurtains',
      'en': 'Weave Nylon Curtains',
      'fr': 'Tisser des rideaux en nylon',
      'es': 'Cortinas de nailon',
      'de': 'Webe Nylonvorhänge',
      'pl': 'Weave Nylon Curtains',
      'ru': 'Ткать Нейлоновые шторы',
      'uk': 'Weave Nylon Curtains',
      'ko': 'Weave Nylon Curtains',
      'zh': '纺织尼龙窗帘',
      'ja': 'Weave Nylon Curtains',
    }, {
      'id': 'WeaveNylonFabric',
      'en': 'Weave Nylon Fabric',
      'fr': 'Tissu en nylon à tisser',
      'es': 'Tela de nailon',
      'de': 'Nylonstoff Weben',
      'pl': 'Weave Nylon Fabric',
      'ru': 'Ткать Нейлоновую Ткань',
      'uk': 'Weave Nylon Fabric',
      'ko': '나일론 원단을 짜다',
      'zh': '编织尼龙织物',
      'ja': 'Weave Nylon Fabric',
    }, {
      'id': 'NylonFutonBed',
      'en': 'Nylon Futon Bed',
      'fr': 'Lit futon en nylon',
      'es': 'Cama-futón con funda de nailon',
      'de': 'Nylon Futon Bett',
      'pl': 'Nylon Futon Bed',
      'ru': 'Кровать с нейлоновым футоном',
      'uk': 'Nylon Futon Bed',
      'ko': 'Nylon Futon Bed',
      'zh': '尼龙沙发床',
      'ja': 'Nylon Futon Bed',
    }, {
      'id': 'NylonFutonCouch',
      'en': 'Nylon Futon Couch',
      'fr': 'Canapé futon en nylon',
      'es': 'Futón con funda de nailon',
      'de': 'Nylon Futon Couch',
      'pl': 'Nylon Futon Couch',
      'ru': 'Диван с нейлоновым футоном',
      'uk': 'Nylon Futon Couch',
      'ko': 'Nylon Futon Couch',
      'zh': '尼龙蒲团沙发',
      'ja': 'Nylon Futon Couch',
    }, {
      'id': 'Nylon',
      'en': 'Nylon',
      'fr': 'Nylon',
      'es': 'Nailon',
      'de': 'Nylon',
      'pl': 'Nylon',
      'ru': 'Нейлон',
      'uk': 'Nylon',
      'ko': '나일론',
      'zh': '尼龙',
      'ja': 'Nylon',
    }, {
      'id': 'NylonThread',
      'en': 'Nylon Thread',
      'fr': 'Fil de nylon',
      'es': 'Fibra de nailon',
      'de': 'Nylonfaden',
      'pl': 'Nylon Thread',
      'ru': 'Нейлоновая нить',
      'uk': 'Nylon Thread',
      'ko': '나일론 실',
      'zh': '尼龙线',
      'ja': 'Nylon Thread',
    }, {
      'id': 'OilDrillingUpgrade',
      'en': 'Oil Drilling Upgrade',
      'fr': 'Amélioration Moderne : Forage pétrolier',
      'es': 'Mejora: Prospección de petróleo',
      'de': 'Modernes Upgrade: Ölgewinnung',
      'pl': 'Ulepszenie Wydobycia Ropy',
      'ru': 'Улучшение для добычи нефти',
      'uk': 'Покращення буріння',
      'ko': '유정 굴착 기술 업그레이드',
      'zh': '石油钻探升级',
      'ja': 'Oil Drilling Upgrade',
    }, {
      'id': 'Oil',
      'en': 'Oil',
      'fr': 'Huile',
      'es': 'Aceite',
      'de': 'Öl',
      'pl': 'Olej',
      'ru': 'Масло',
      'uk': 'Олія',
      'ko': '식용유',
      'zh': '油',
      'ja': 'オイル',
    }, {
      'id': 'RefineTallow',
      'en': 'Refine Tallow',
      'fr': 'Affiner le Suif',
      'es': 'Refinar sebo',
      'de': 'Talg aufbereiten',
      'pl': 'Oczyszczony tłuszcz',
      'ru': 'Переработать жир',
      'uk': 'Переробити сало',
      'ko': '수지 가공법',
      'zh': '精制牛油',
      'ja': '獣脂を精製する',
    }, {
      'id': 'SunflowerOil',
      'en': 'Sunflower Oil',
      'fr': 'Huile de tournesol',
      'es': 'Aceite de girasol',
      'de': 'Sonnenblumenöl',
      'pl': 'Sunflower Oil',
      'ru': 'Подсолнечное масло',
      'uk': 'Sunflower Oil',
      'ko': 'Sunflower Oil',
      'zh': '葵花籽油',
      'ja': 'Sunflower Oil',
    }, {
      'id': 'OilRefinery',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de Petróleo',
      'de': 'Raffinerie',
      'pl': 'Rafineria',
      'ru': 'Нефтеперерабатывающий завод',
      'uk': 'Нафтопереробний завод',
      'ko': '석유 증류탑',
      'zh': '炼油厂',
      'ja': '石油精製所',
    }, {
      'id': 'PaddedChair',
      'en': 'Padded Chair',
      'fr': 'Fauteuil',
      'es': 'Silla Acolchada',
      'de': 'Gepolsterter Stuhl',
      'pl': 'Fotel tapicerowany',
      'ru': 'Кресло',
      'uk': 'М’яке крісло',
      'ko': '푹신한 소파',
      'zh': '软垫椅',
      'ja': 'パッド入りの椅子',
    }, {
      'id': 'PapayaSeed',
      'en': 'Papaya Seed',
      'fr': 'Graine de papaye',
      'es': 'Semilla de papaya',
      'de': 'Samen (Papaya)',
      'pl': 'Nasiono papai',
      'ru': 'Семечко папайи',
      'uk': 'Насіння папаї',
      'ko': '파파야 씨앗',
      'zh': '番木瓜籽',
      'ja': 'パパイヤの種',
    }, {
      'id': 'Paper',
      'en': 'Paper',
      'fr': 'Papier',
      'es': 'Papel',
      'de': 'Papier',
      'pl': 'Papier',
      'ru': 'Бумага',
      'uk': 'Папір',
      'ko': '종이',
      'zh': '纸',
      'ja': '紙',
    }, {
      'id': 'PaperMillingUpgrade',
      'en': 'Paper Milling Upgrade',
      'fr': 'Amélioration Basique : Production de papier',
      'es': 'Mejora: Molienda de papel',
      'de': 'Fortgeschrittenes Upgrade: Papierherstellung',
      'pl': 'Ulepszenie Papierni',
      'ru': 'Улучшение для производства бумаги',
      'uk': 'Покращення виготовлення паперу',
      'ko': '제지 가공 기술 업그레이드',
      'zh': '造纸升级',
      'ja': '紙すきアップグレード',
    }, {
      'id': 'PastryDough',
      'en': 'Pastry Dough',
      'fr': 'Pâte à tarte',
      'es': 'Masa de pastelería',
      'de': 'Teig',
      'pl': 'Kruche ciasto',
      'ru': 'Кондитерские изделия',
      'uk': 'Кондитерське тісто',
      'ko': '페이스트리 반죽',
      'zh': '糕点面团',
      'ja': 'Pastry Dough',
    }, {
      'id': 'PeltFertilizer',
      'en': 'Pelt Fertilizer',
      'fr': 'Engrais à base de fourrures',
      'es': 'Fertilizante de Pieles',
      'de': 'Dünger aus Pelz',
      'pl': 'Nawóz z futer',
      'ru': 'Удобрение из меха',
      'uk': 'Добриво з хутра',
      'ko': '모피 비료',
      'zh': '毛皮化肥',
      'ja': 'Nawoz z futra',
    }, {
      'id': 'Petroleum',
      'en': 'Petroleum',
      'fr': 'Pétrole',
      'es': 'Petróleo',
      'de': 'Petroleum',
      'pl': 'Ropa naftowa',
      'ru': 'Нефть',
      'uk': 'Нафта',
      'ko': '석유',
      'zh': '石油',
      'ja': '石油',
    }, {
      'id': 'PhadThai',
      'en': 'Phad Thai',
      'fr': 'Nouilles sautées à la thaïlandaise',
      'es': 'Phad Thai',
      'de': 'Phad Thai',
      'pl': 'Phad Thai',
      'ru': 'Пад-тай',
      'uk': 'Phad Thai',
      'ko': 'Phad Thai',
      'zh': '泰式炒河粉',
      'ja': 'Phad Thai',
    }, {
      'id': 'PhosphateFertilizer',
      'en': 'Phosphate Fertilizer',
      'fr': 'Engrais à base de phosphate',
      'es': 'Fertilizante de Fosfato',
      'de': 'Dünger mit Phosphat',
      'pl': 'Nawóz fosforowy',
      'ru': 'Фосфорное удобрение',
      'uk': 'Фосфорні добрива',
      'ko': '인산염 비료',
      'zh': '磷肥',
      'ja': 'Nawóz fosforowy',
    }, {
      'id': 'PineappleFriendRice',
      'en': 'Pineapple Friend Rice',
      'fr': 'Riz frit à l\u0027ananas',
      'es': 'Arroz frito con piña',
      'de': 'Gebratener Reis mit Ananas',
      'pl': 'Twój przyjaciel ryż',
      'ru': 'Ананас и его друг рис',
      'uk': 'Ананас і його друг рис',
      'ko': '파인애플 볶음밥',
      'zh': '菠萝炒饭',
      'ja': 'パイナップルチャーハン',
    }, {
      'id': 'PineappleSeed',
      'en': 'Pineapple Seed',
      'fr': 'Graine d\u0027ananas',
      'es': 'Semilla de Piña',
      'de': 'Samen (Ananas)',
      'pl': 'Nasiono ananasa',
      'ru': 'Семечко ананаса',
      'uk': 'Насіння ананаса',
      'ko': '파인애플 씨앗',
      'zh': '菠萝种子',
      'ja': 'パイナップルの種',
    }, {
      'id': 'Pirozhok',
      'en': 'Pirozhok',
      'fr': 'Chaussons à la viande',
      'es': 'Pirozhok',
      'de': 'Pirozhok',
      'pl': 'Kulebiak',
      'ru': 'Пирожок',
      'uk': 'Пиріжок',
      'ko': '피로시키',
      'zh': '皮罗佐克',
      'ja': 'Pirozhok',
    }, {
      'id': 'Piston',
      'en': 'Piston',
      'fr': 'Piston',
      'es': 'Pistón',
      'de': 'Kolben',
      'pl': 'Tłok',
      'ru': 'Поршень',
      'uk': 'Поршень',
      'ko': '피스톤',
      'zh': '活塞',
      'ja': 'Tłok',
    }, {
      'id': 'RoundPot',
      'en': 'Round Pot',
      'fr': 'Pot rond',
      'es': 'Maceta Redonda',
      'de': 'Blumentopf (rund)',
      'pl': 'Okrągłą donica',
      'ru': 'Круглый горшок',
      'uk': 'Круглий горщик',
      'ko': '둥근 화분',
      'zh': '圆盆',
      'ja': '丸い植木鉢',
    }, {
      'id': 'SquarePot',
      'en': 'Square Pot',
      'fr': 'Pot carré',
      'es': 'Maceta Cuadrada',
      'de': 'Blumentopf (quadratisch)',
      'pl': 'Kwadratowa donica',
      'ru': 'Квадратный горшок',
      'uk': 'Квадратний горщик',
      'ko': '각진 화분',
      'zh': '方盆',
      'ja': '四角い植木鉢',
    }, {
      'id': 'Plastic',
      'en': 'Plastic',
      'fr': 'Plastique',
      'es': 'Plástico',
      'de': 'Kunststoff',
      'pl': 'Plastik',
      'ru': 'Пластик',
      'uk': 'Пластик',
      'ko': '플라스틱',
      'zh': '塑料',
      'ja': 'プラスチック',
    }, {
      'id': 'PokeBowl',
      'en': 'Poke Bowl',
      'fr': 'Bol hawaïen',
      'es': 'Poke',
      'de': 'Gemüse-Bowle',
      'pl': 'Poke Bowl',
      'ru': 'Поке Боул',
      'uk': 'Poke Bowl',
      'ko': 'Poke Bowl',
      'zh': '冲浪碗',
      'ja': 'Poke Bowl',
    }, {
      'id': 'PortableSteamEngine',
      'en': 'Portable Steam Engine',
      'fr': 'Moteur à vapeur portable',
      'es': 'Motor a vapor portátil',
      'de': 'Tragbarer Dampf-Stromgenerator',
      'pl': 'Przenośny Silnik Parowy',
      'ru': 'Портативный паровой двигатель',
      'uk': 'Портативний паровий двигун',
      'ko': '이동식 증기기관',
      'zh': '便携式蒸汽机',
      'ja': '携帯型蒸気エンジン',
    }, {
      'id': 'PotteryUpgrade',
      'en': 'Pottery Upgrade',
      'fr': 'Amélioration Avancée : Poterie',
      'es': 'Mejora: Cerámica',
      'de': 'Fortgeschrittenes Upgrade: Töpfern',
      'pl': 'Ulepszenie Garncarstwa',
      'ru': 'Улучшение для гончарного ремесла',
      'uk': 'Покращення гончарства',
      'ko': '도기 기술 업그레이드',
      'zh': '陶艺升级',
      'ja': '陶芸アップグレード',
    }, {
      'id': 'PoweredCart',
      'en': 'Powered Cart',
      'fr': 'Chariot motorisé',
      'es': 'Carro Motorizado',
      'de': 'Dampfbetriebener Wagen',
      'pl': 'Wózek z Napędem',
      'ru': 'Повозка с мотором',
      'uk': 'Возик із мотором',
      'ko': '전동 수레',
      'zh': '动力推车',
      'ja': '動力付カート',
    }, {
      'id': 'PreparedMeat',
      'en': 'Prepared Meat',
      'fr': 'Viande préparée',
      'es': 'Carne Preparada',
      'de': 'Vorbereitetes Fleisch',
      'pl': 'Gotowe danie mięsne',
      'ru': 'Обработанное мясо',
      'uk': 'Оброблене м’ясо',
      'ko': '손질된 고기',
      'zh': '预加工肉',
      'ja': '下ごしらえした肉',
    }, {
      'id': 'PricklyPearSeed',
      'en': 'Prickly Pear Seed',
      'fr': 'Graine de figue de Barbarie',
      'es': 'Semilla de higo chumbo',
      'de': 'Samen (Kaktusfeigen)',
      'pl': 'Nasiona Opuncji',
      'ru': 'Семечко опунции',
      'uk': 'Насіння опунції',
      'ko': '천년초 씨앗',
      'zh': '仙人球种子',
      'ja': 'ウチワサボテンの種',
    }, {
      'id': 'PrimeCut',
      'en': 'Prime Cut',
      'fr': 'Morceau de choix',
      'es': 'Corte Primo',
      'de': 'Filet',
      'pl': 'Mięso prima sort',
      'ru': 'Вырезка',
      'uk': 'М’ясо найвищого ґатунку',
      'ko': '최고급 고기',
      'zh': '特级肉块',
      'ja': 'プライムカット',
    }, {
      'id': 'PulpFiller',
      'en': 'Pulp Filler',
      'fr': 'Garnissage de copeaux de bois',
      'es': 'Relleno de Pulpa',
      'de': 'Füller aus Holzspähnen',
      'pl': 'Wypełniacz z miazgi',
      'ru': 'Древесный наполнитель',
      'uk': 'Наповнювач із деревини',
      'ko': '펄프 보충제',
      'zh': '纸浆填料',
      'ja': 'パルプフィラー',
    }, {
      'id': 'PumpJack',
      'en': 'Pump Jack',
      'fr': 'Chevalet de pompage',
      'es': 'Unidad de Bombeo',
      'de': 'Ölbohrturm',
      'pl': 'Kiwak',
      'ru': 'Нефтяная вышка',
      'uk': 'Нафтовий насос',
      'ko': '석유 시추기',
      'zh': '油压机',
      'ja': 'ポンプジャッキ',
    }, {
      'id': 'PumpkinSeed',
      'en': 'Pumpkin Seed',
      'fr': 'Graine de citrouille',
      'es': 'Semilla de Calabaza',
      'de': 'Samen (Kürbis)',
      'pl': 'Nasiono dyni',
      'ru': 'Семечко тыквы',
      'uk': 'Насіння гарбуза',
      'ko': '호박 씨앗',
      'zh': '南瓜种子',
      'ja': 'カボチャの種',
    }, {
      'id': 'Pupusas',
      'en': 'Pupusas',
      'fr': 'Pupusas',
      'es': 'Pupusas',
      'de': 'Pupusas',
      'pl': 'Pupusas',
      'ru': 'Пупусас',
      'uk': 'Pupusas',
      'ko': 'Pupusas',
      'zh': '奶酪猪肉玉米饼',
      'ja': 'Pupusas',
    }, {
      'id': 'Quicklime',
      'en': 'Quicklime',
      'fr': 'Chaux vive',
      'es': 'Cal viva',
      'de': 'Branntkalk',
      'pl': 'Quicklime',
      'ru': 'Оксид кальция',
      'uk': 'Негашене вапно',
      'ko': '생석회',
      'zh': '生石灰',
      'ja': '生石灰',
    }, {
      'id': 'Radiator',
      'en': 'Radiator',
      'fr': 'Radiateur',
      'es': 'Radiador',
      'de': 'Kühler',
      'pl': 'Chłodnica',
      'ru': 'Радиатор',
      'uk': 'Радіатор',
      'ko': '방열기',
      'zh': '散热器',
      'ja': 'ラジエーター',
    }, {
      'id': 'RawBacon',
      'en': 'Raw Bacon',
      'fr': 'Bacon cru',
      'es': 'Tocino Crudo',
      'de': 'Roher Speck',
      'pl': 'Surowy Boczek',
      'ru': 'Сырой бекон',
      'uk': 'Сирий бекон',
      'ko': '생 베이컨',
      'zh': '生培根',
      'ja': '生のベーコン',
    }, {
      'id': 'ButcherBison',
      'en': 'Butcher Bison',
      'fr': 'Découper un bison',
      'es': 'Trocear Bisonte',
      'de': 'Schlachte Bison',
      'pl': 'Przerób bizona',
      'ru': 'Разделка бизона',
      'uk': 'Оброблення бізонячої туші',
      'ko': '들소 도축법',
      'zh': '肉加工野牛',
      'ja': 'バイソンを解体',
    }, {
      'id': 'ButcherHare',
      'en': 'Butcher Hare',
      'fr': 'Découper un lièvre',
      'es': 'Trocear Liebre',
      'de': 'Schlachte Hase',
      'pl': 'Przerób królika',
      'ru': 'Разделка зайца',
      'uk': 'Оброблення заячої туші',
      'ko': '토끼 도축법',
      'zh': '肉加工野兔',
      'ja': '野ウサギを解体',
    }, {
      'id': 'ButcherMediumAnimal',
      'en': 'Butcher Medium Animal',
      'fr': 'Découper un animal moyen',
      'es': 'Descuartizar animal mediano',
      'de': 'Mittleres Tier schlachten',
      'pl': 'Butcher Medium Animal',
      'ru': 'Разделать среднее животное',
      'uk': 'Різництво середньої тварини',
      'ko': '중형 동물 도살법',
      'zh': '加工中型动物',
      'ja': 'Butcher Medium Animal',
    }, {
      'id': 'ButcherMediumWoolyAnimal',
      'en': 'Butcher Medium Wooly Animal',
      'fr': 'Découper un animal moyen à laine',
      'es': 'Descuartizar animal mediano (con lana)',
      'de': 'Mittleres Wolltier schlachten',
      'pl': 'Butcher Medium Wooly Animal',
      'ru': 'Разделать среднее шерстяное животное',
      'uk': 'Butcher Medium Wooly Animal',
      'ko': '정육점 중간 양털 동물',
      'zh': '加工中型毛茸茸的动物',
      'ja': 'Butcher Medium Wooly Animal',
    }, {
      'id': 'ButcherSmallAnimal',
      'en': 'Butcher Small Animal',
      'fr': 'Découper un petit animal',
      'es': 'Descuartizar animal pequeño',
      'de': 'Kleines Tier schlachten',
      'pl': 'Butcher Small Animal',
      'ru': 'Разделать маленькое животное',
      'uk': 'Різництво малої тварини',
      'ko': '소형 동물 도살법',
      'zh': '加工小型动物',
      'ja': 'Butcher Small Animal',
    }, {
      'id': 'ButcherTinyFurAnimal',
      'en': 'Butcher Tiny Fur Animal',
      'fr': 'Découper un minuscule animal à fourrure',
      'es': 'Descuartizar animal minúsculo (pelaje)',
      'de': 'Winziges Felltier schlachten',
      'pl': 'Butcher Tiny Fur Animal',
      'ru': 'Разделать крошечное меховое животное',
      'uk': 'Різництво маленької тварини з хутром',
      'ko': '극소형 동물 모피 분리법',
      'zh': '加工微型皮革动物',
      'ja': 'Butcher Tiny Fur Animal',
    }, {
      'id': 'ButcherTinyLeatherAnimal',
      'en': 'Butcher Tiny Leather Animal',
      'fr': 'Découper un minuscule animal à peau de cuir',
      'es': 'Descuartizar animal minúsculo (cuero)',
      'de': 'Winziges Ledertier schlachten',
      'pl': 'Butcher Tiny Leather Animal',
      'ru': 'Разделать крошечное животное с ценной кожей',
      'uk': 'Різництво маленької тварини зі шкірою',
      'ko': '극소형 동물 가죽 분리법',
      'zh': '加工微型毛皮动物',
      'ja': 'Butcher Tiny Leather Animal',
    }, {
      'id': 'RawRoast',
      'en': 'Raw Roast',
      'fr': 'Rôti cru',
      'es': 'Asado Crudo',
      'de': 'Roher Braten',
      'pl': 'Surowa pieczeń',
      'ru': 'Мясо для жаркого',
      'uk': 'Сира печеня',
      'ko': '안 익은 구이용 고기',
      'zh': '未烤肉',
      'ja': '生のロースト',
    }, {
      'id': 'RawSausage',
      'en': 'Raw Sausage',
      'fr': 'Saucisse crue',
      'es': 'Salchicha Cruda',
      'de': 'Rohe Wurst',
      'pl': 'Surowa kiełbasa',
      'ru': 'Сырая сарделька',
      'uk': 'Сира сарделька',
      'ko': '생 소시지',
      'zh': '生香肠',
      'ja': '生のソーセージ',
    }, {
      'id': 'RealEstateDesk',
      'en': 'Real Estate Desk',
      'fr': 'Bureau immobilier',
      'es': 'Escritorio inmobiliario',
      'de': 'Grundbesitztisch',
      'pl': 'Real Estate Desk',
      'ru': 'Стол риелтора',
      'uk': 'Бюро нерухомості',
      'ko': '부동산 중매대',
      'zh': '房地产交易所',
      'ja': '不動産デスク',
    }, {
      'id': 'Rebar',
      'en': 'Rebar',
      'fr': 'Barre d\u0027armature',
      'es': 'Barra corrugada',
      'de': 'Bewehrungsstahl',
      'pl': 'Zbrojenie',
      'ru': 'Арматура',
      'uk': 'Арматура',
      'ko': '철근',
      'zh': '钢筋',
      'ja': '鉄筋',
    }, {
      'id': 'RecurveBow',
      'en': 'Recurve Bow',
      'fr': 'Arc recourbé',
      'es': 'Arco recurvo',
      'de': 'Recurvebogen',
      'pl': 'Łuk Refleksyjny',
      'ru': 'Изогнутый лук',
      'uk': 'Вигнутий лук',
      'ko': '곡궁',
      'zh': '反曲弓',
      'ja': 'Recurve Bow',
    }, {
      'id': 'Refrigerator',
      'en': 'Refrigerator',
      'fr': 'Réfrigérateur',
      'es': 'Refrigerador',
      'de': 'Kühlschrank',
      'pl': 'Lodówka',
      'ru': 'Холодильник',
      'uk': 'Холодильник',
      'ko': '냉장고',
      'zh': '冰箱',
      'ja': '冷蔵庫',
    }, {
      'id': 'Registrar',
      'en': 'Registrar',
      'fr': 'Registre',
      'es': 'Registrador',
      'de': 'Registrar',
      'pl': 'Registrar',
      'ru': 'Регистратор',
      'uk': 'Реєстратор',
      'ko': '직위개설 부서',
      'zh': '登记员',
      'ja': 'レジストラー',
    }, {
      'id': 'ReinforcedConcrete',
      'en': 'Reinforced Concrete',
      'fr': 'Béton armé',
      'es': 'Hormigón reforzado',
      'de': 'Stahlbeton',
      'pl': 'Beton zbrojony',
      'ru': 'Железобетон',
      'uk': 'Вироби залізобетонні',
      'ko': '보강된 콘크리트',
      'zh': '钢筋混凝土',
      'ja': '鉄筋コンクリート',
    }, {
      'id': 'RiceFlour',
      'en': 'Rice Flour',
      'fr': 'Farine de riz',
      'es': 'Harina de arroz',
      'de': 'Reismehl',
      'pl': 'Rice Flour',
      'ru': 'Рисовая мука',
      'uk': 'Rice Flour',
      'ko': '쌀가루',
      'zh': '米粉',
      'ja': 'Rice Flour',
    }, {
      'id': 'RiceNoodles',
      'en': 'Rice Noodles',
      'fr': 'Nouilles de riz',
      'es': 'Fideos de arroz',
      'de': 'Reisnudeln',
      'pl': 'Rice Noodles',
      'ru': 'Рисовая лапша',
      'uk': 'Rice Noodles',
      'ko': '쌀 면',
      'zh': '米线',
      'ja': 'Rice Noodles',
    }, {
      'id': 'Rivet',
      'en': 'Rivet',
      'fr': 'Rivet',
      'es': 'Remache',
      'de': 'Niete',
      'pl': 'Nit',
      'ru': 'Заклёпка',
      'uk': 'Заклепка',
      'ko': '대갈못',
      'zh': '铆钉',
      'ja': 'Nit',
    }, {
      'id': 'RoastPumpkin',
      'en': 'Roast Pumpkin',
      'fr': 'Citrouille cuite',
      'es': 'Calabaza asada',
      'de': 'Gerösteter Kürbis',
      'pl': 'Roast Pumpkin',
      'ru': 'Жареная тыква',
      'uk': 'Roast Pumpkin',
      'ko': '구운 호박',
      'zh': '烤南瓜',
      'ja': 'Roast Pumpkin',
    }, {
      'id': 'RoboticAssemblyLine',
      'en': 'Robotic Assembly Line',
      'fr': 'Ligne de montage robotisée',
      'es': 'Línea de Ensamblaje Robótica',
      'de': 'Robotische Fertigungsstraße',
      'pl': 'Robotic Assembly Line',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована лінія для збору',
      'ko': '자동화 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン',
    }, {
      'id': 'RockerBox',
      'en': 'Rocker Box',
      'fr': 'Rampe de lavage',
      'es': 'Caja de balancines',
      'de': 'Bergbau-Waschtisch',
      'pl': 'Sito kołyskowe',
      'ru': 'Вашгерд',
      'uk': 'Накопичувач руди',
      'ko': '로커 박스',
      'zh': '摇臂箱',
      'ja': 'Rocker Box',
    }, {
      'id': 'RollingMill',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Molino de laminado',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Стан прокатний',
      'ko': '압연기',
      'zh': '轧机',
      'ja': '圧延機',
    }, {
      'id': 'RootCampfireSalad',
      'en': 'Root Campfire Salad',
      'fr': 'Salade de racines cuite au feu de camp',
      'es': 'Ensalada braseada con raíces',
      'de': 'Lagerfeuer Wurzelsalat',
      'pl': 'Korzenna sałatka z ogniska',
      'ru': 'Салат из корнеплодов на костре',
      'uk': 'Салат приготований на багатті',
      'ko': '구근 모닥불 샐러드',
      'zh': '根篝火沙拉',
      'ja': 'Root Campfire Salad',
    }, {
      'id': 'RootCampfireStew',
      'en': 'Root Campfire Stew',
      'fr': 'Ragoût de racines cuit au feu de camp',
      'es': 'Estofado braseado con raíces',
      'de': 'Lagerfeuer Wurzeleintopf',
      'pl': 'Korzenny gulasz z ogniska',
      'ru': 'Рагу из корнеплодов на костре',
      'uk': 'Рагу приготоване багатті',
      'ko': '구근 모닥불 스튜',
      'zh': '根篝火炖汤',
      'ja': 'Root Campfire Stew',
    }, {
      'id': 'RubberWheel',
      'en': 'Rubber Wheel',
      'fr': 'Roue en caoutchouc',
      'es': 'Rueda de caucho',
      'de': 'Gummirad',
      'pl': 'Gumowe Koło',
      'ru': 'Резиновое колесо',
      'uk': 'Гумове колесо',
      'ko': '고무 바퀴',
      'zh': '橡胶轮',
      'ja': 'ラバーホイール',
    }, {
      'id': 'RugLarge',
      'en': 'Rug Large',
      'fr': 'Grand tapis',
      'es': 'Alfombra grande',
      'de': 'Großer Teppich',
      'pl': 'Rug Large',
      'ru': 'Большой ковёр',
      'uk': 'Великий килим',
      'ko': '대형 양탄자',
      'zh': '大号地毯',
      'ja': '大きな絨毯',
    }, {
      'id': 'RugMedium',
      'en': 'Rug Medium',
      'fr': 'Tapis moyen',
      'es': 'Alfombra mediana',
      'de': 'Mittelgroßer Teppich',
      'pl': 'Rug Medium',
      'ru': 'Средний ковёр',
      'uk': 'Середній килим',
      'ko': '중형 양탄자',
      'zh': '中号地毯',
      'ja': '中くらいの絨毯',
    }, {
      'id': 'RugSmall',
      'en': 'Rug Small',
      'fr': 'Petit tapis',
      'es': 'Alfombra pequeña',
      'de': 'Kleiner Teppich',
      'pl': 'Rug Small',
      'ru': 'Маленький ковёр',
      'uk': 'Малий килим',
      'ko': '소형 양탄자',
      'zh': '小号地毯',
      'ja': '小さな絨毯',
    }, {
      'id': 'RunningShoes',
      'en': 'Running Shoes',
      'fr': 'Chaussures de course',
      'es': 'Zapatos de Correr',
      'de': 'Laufschuhe',
      'pl': 'Buty do biegania',
      'ru': 'Беговые кеды',
      'uk': 'Взуття для бігу',
      'ko': '운동화',
      'zh': '跑鞋',
      'ja': 'ランニングシューズ',
    }, {
      'id': 'SaltBasket',
      'en': 'Salt Basket',
      'fr': 'Panier de sel',
      'es': 'Cesta de Sal',
      'de': 'Salzkorb',
      'pl': 'Kosz Soli',
      'ru': 'Корзина с солью',
      'uk': 'Кошик солі',
      'ko': '소금 바구니',
      'zh': '盐篓',
      'ja': 'カゴに入った塩',
    }, {
      'id': 'SandConcentrate',
      'en': 'Sand Concentrate',
      'fr': 'Concentré de sable',
      'es': 'Concentrado de arena',
      'de': 'Sand',
      'pl': 'Piaskowy koncentrat',
      'ru': 'Получить песок',
      'uk': 'Отримати пісок',
      'ko': '정제된 모래',
      'zh': '筛选沙子',
      'ja': 'Sand Concentrate',
    }, {
      'id': 'SandConcentrateLv2',
      'en': 'Sand Concentrate Lv2',
      'fr': 'Concentré de sable Nv2',
      'es': 'Concentrado de arena (niv. 2)',
      'de': 'Sand Lv2',
      'pl': 'Sand Concentrate Lv2',
      'ru': 'Получить песок Lv2',
      'uk': 'Sand Concentrate Lv2',
      'ko': 'Sand Concentrate Lv2',
      'zh': '筛选沙子 等级2',
      'ja': 'Sand Concentrate Lv2',
    }, {
      'id': 'SandConcentrateLv3',
      'en': 'Sand Concentrate Lv3',
      'fr': 'Concentré de sable Nv3',
      'es': 'Concentrado de arena (niv. 3)',
      'de': 'Sand Lv3',
      'pl': 'Sand Concentrate Lv3',
      'ru': 'Получить песок Lv3',
      'uk': 'Sand Concentrate Lv3',
      'ko': 'Sand Concentrate Lv3',
      'zh': '筛选沙子 等级3',
      'ja': 'Sand Concentrate Lv3',
    }, {
      'id': 'Sawmill',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопилка',
      'uk': 'Лісопилка',
      'ko': '제재대',
      'zh': '锯木台',
      'ja': '製材機',
    }, {
      'id': 'ScrapMeat',
      'en': 'Scrap Meat',
      'fr': 'Restes de viande',
      'es': 'Carne de desechos',
      'de': 'Fleischreste',
      'pl': 'Ochłapy Mięsa',
      'ru': 'Мясные обрезки',
      'uk': 'Обрізки м’яса',
      'ko': '고기 조각',
      'zh': '碎肉',
      'ja': 'くず肉',
    }, {
      'id': 'ScreeningMachine',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de escaneo',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do Przesiewania',
      'ru': 'Вибрационный сортировщик',
      'uk': 'Просіювальна машина',
      'ko': '건식 제련 기계',
      'zh': '筛选机',
      'ja': '選別機',
    }, {
      'id': 'ScrewPress',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Prensa de tornillos',
      'de': 'Spindelpresse',
      'pl': 'Screw Press',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '압입식 조임 기계',
      'zh': '螺旋压榨机',
      'ja': 'ねじプレス',
    }, {
      'id': 'Screws',
      'en': 'Screws',
      'fr': 'Vis',
      'es': 'Tornillos',
      'de': 'Schrauben',
      'pl': 'Śruby',
      'ru': 'Винты',
      'uk': 'Гвинти',
      'ko': '나사',
      'zh': '螺钉',
      'ja': 'ネジ',
    }, {
      'id': 'SearedMeat',
      'en': 'Seared Meat',
      'fr': 'Viande poêlée',
      'es': 'Carne Chamuscada',
      'de': 'Kurz angebratenes Fleisch',
      'pl': 'Obsmażone mięso',
      'ru': 'Обжаренное мясо',
      'uk': 'Обсмажене м’ясо',
      'ko': '직화 고기',
      'zh': '煎肉',
      'ja': '焦げた肉',
    }, {
      'id': 'SeededCamasRoll',
      'en': 'Seeded Camas Roll',
      'fr': 'Rouleau aux graines de camassia',
      'es': 'Rollos de Camas con Semillas',
      'de': 'Bestreute Prärielilienrolle',
      'pl': 'Seeded Camas Roll',
      'ru': 'Ролл с семенами Камассии',
      'uk': 'Seeded Camas Roll',
      'ko': 'Seeded Camas Roll',
      'zh': '去籽卡马斯卷',
      'ja': 'Seeded Camas Roll',
    }, {
      'id': 'SensorBasedBeltSorter',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Tapis de tri à détecteurs',
      'es': 'Cinta organizadora con sensores',
      'de': 'Sensorenbasierter Gürtelsortierer',
      'pl': 'Sorter taśmowy oparty na czujnikach',
      'ru': 'Сенсорный конвейерный сортировщик',
      'uk': 'Сенсорний сортувальник конвеєрної лінії',
      'ko': '감지기 기반 자동 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'Sensor Based Belt Sorter',
    }, {
      'id': 'SensuousSeaPizza',
      'en': 'Sensuous Sea Pizza',
      'fr': 'Pizza sensuelle de la mer',
      'es': 'Pizza de Mar Agradable a los Sentidos',
      'de': 'Pizza di Mare Fantastico',
      'pl': 'Smakowita morska pizza',
      'ru': 'Морская Пицца',
      'uk': 'Sensuous Sea Pizza',
      'ko': 'Sensuous Sea Pizza',
      'zh': '悠扬之海比萨',
      'ja': 'Sensuous Sea Pizza',
    }, {
      'id': 'Servo',
      'en': 'Servo',
      'fr': 'Servomoteur',
      'es': 'Servomotor',
      'de': 'Servomotor',
      'pl': 'Serwomechanizm',
      'ru': 'Сервопривод',
      'uk': 'Сервопривід',
      'ko': '자동 제어 장치',
      'zh': '传动装置',
      'ja': 'Serwomechanizm',
    }, {
      'id': 'Shaper',
      'en': 'Shaper',
      'fr': 'Formeuse',
      'es': 'Modelador (m.) Modeladora (f.)',
      'de': 'Fräsmaschine',
      'pl': 'Shaper',
      'ru': 'Строгальный станок',
      'uk': 'Стругальний верстат',
      'ko': '형삭반',
      'zh': '刨床',
      'ja': '形削り盤',
    }, {
      'id': 'SharkFilletSoup',
      'en': 'Shark Fillet Soup',
      'fr': 'Soupe d\u0027ailerons de requin',
      'es': 'Sopa de Filete de Tiburón',
      'de': 'Suppe aus Haifilet',
      'pl': 'Zupa z płetwy rekina',
      'ru': 'Суп из филе акулы',
      'uk': 'Shark Fillet Soup',
      'ko': '상어 지느러미 수프',
      'zh': '鲨鱼片汤',
      'ja': 'Shark Fillet Soup',
    }, {
      'id': 'SheepMount',
      'en': 'Sheep Mount',
      'fr': 'Trophée de mouflon',
      'es': 'Montura de borrego',
      'de': 'Ausgestopftes Bergschaf',
      'pl': 'Sheep Mount',
      'ru': 'Голова барана',
      'uk': 'Голова барана',
      'ko': '양 벽걸이 박제',
      'zh': '羊山',
      'ja': 'Sheep Mount',
    }, {
      'id': 'ShelfCabinet',
      'en': 'Shelf Cabinet',
      'fr': 'Étagère',
      'es': 'Armario',
      'de': 'Regalschrank',
      'pl': 'Szafa z półkami',
      'ru': 'Сервант',
      'uk': 'Сервант',
      'ko': '선반 보관장',
      'zh': '柜架',
      'ja': '飾りつけた棚',
    }, {
      'id': 'Shorts',
      'en': 'Shorts',
      'fr': 'Short',
      'es': 'Pantalones cortos',
      'de': 'Kurze Hose',
      'pl': 'Spodenki',
      'ru': 'Шорты',
      'uk': 'Шорти',
      'ko': '반바지',
      'zh': '短裤',
      'ja': 'Shorts',
    }, {
      'id': 'SimmeredMeat',
      'en': 'Simmered Meat',
      'fr': 'Viande mijotée',
      'es': 'Carne Hervida',
      'de': 'Geschmortes Fleisch',
      'pl': 'Wolno gotowane mięso',
      'ru': 'Тушёное мясо',
      'uk': 'Тушковане м’ясо',
      'ko': '육즙을 가둔 고기',
      'zh': '炖肉',
      'ja': '煮込み肉',
    }, {
      'id': 'SimpleSyrup',
      'en': 'Simple Syrup',
      'fr': 'Sirop simple',
      'es': 'Jarabe Simple',
      'de': 'Zuckersirup',
      'pl': 'Prosty syrop',
      'ru': 'Простой сироп',
      'uk': 'Простий сироп',
      'ko': '간단한 시럽',
      'zh': '普通糖浆',
      'ja': 'シンプルシロップ',
    }, {
      'id': 'Sink',
      'en': 'Sink',
      'fr': 'Evier',
      'es': 'Fregadero',
      'de': 'Spüle',
      'pl': 'Zlew',
      'ru': 'Раковина',
      'uk': 'Мушля',
      'ko': '싱크대',
      'zh': '下沉',
      'ja': 'シンク',
    }, {
      'id': 'SkidSteer',
      'en': 'Skid Steer',
      'fr': 'Bulldozer',
      'es': 'Minicargador',
      'de': 'Kompaktlader',
      'pl': 'Skid Steer',
      'ru': 'Погрузчик',
      'uk': 'Міні-навантажувач',
      'ko': '스키드 스티어',
      'zh': '滑移装载机',
      'ja': 'スキッドステア',
    }, {
      'id': 'SmallBathMat',
      'en': 'Small Bath Mat',
      'fr': 'Petit tapis de bain',
      'es': 'Alfombrilla de baño pequeña',
      'de': 'Kleine Badematte',
      'pl': 'Small Bath Mat',
      'ru': 'Небольшой Коврик для ванной',
      'uk': 'Small Bath Mat',
      'ko': 'Small Bath Mat',
      'zh': '小型浴室防滑垫',
      'ja': 'Small Bath Mat',
    }, {
      'id': 'WeaveSmallBathMat',
      'en': 'Weave Small Bath Mat',
      'fr': 'Tisser un petit tapis de bain',
      'es': 'Alfombra de Baño Tejida Pequeña',
      'de': 'Kleine Badematte weben',
      'pl': 'Weave Small Bath Mat',
      'ru': 'Ткать Небольшой Коврик для ванной',
      'uk': 'Weave Small Bath Mat',
      'ko': 'Weave Small Bath Mat',
      'zh': '纺织小号浴室地垫',
      'ja': 'Weave Small Bath Mat',
    }, {
      'id': 'SmallHangingAshlarStoneSign',
      'en': 'Small Hanging Ashlar Stone Sign',
      'fr': 'Petit panneau suspendu en pierre taillé',
      'es': 'Letrero colgante pequeño (sillar de piedra)',
      'de': 'Steinquaderschild (klein, hängend)',
      'pl': 'Mały wiszący znak z ciosanego kamienia',
      'ru': 'Маленькая вывеска из резного камня',
      'uk': 'Мала вивіска з обтесаного каменю',
      'ko': '작은 걸이형 각진 석재 간판',
      'zh': '小型悬挂阿什拉尔标志',
      'ja': 'Small Hanging Ashlar Stone Sign',
    }, {
      'id': 'SmallHangingLumberSign',
      'en': 'Small Hanging Lumber Sign',
      'fr': 'Petit panneau suspendu en bois d\u0027oeuvre',
      'es': 'Letrero pequeño colgante (troncos)',
      'de': 'Bauholzschild (klein, hängend)',
      'pl': 'Small Hanging Lumber Sign',
      'ru': 'Маленькая вывеска из пиломатериалов',
      'uk': 'Мала навісна дерев’яна табличка',
      'ko': '작은 걸이형 가공 목재 간판',
      'zh': '小块木制标志',
      'ja': '木製の小さな掛け看板',
    }, {
      'id': 'SmallHangingMortaredStoneSign',
      'en': 'Small Hanging Mortared Stone Sign',
      'fr': 'Petit panneau suspendu en pierre cimentée',
      'es': 'Letrero colgante pequeño (mortero)',
      'de': 'Steinziegelschild (klein, hängend)',
      'pl': 'Mały wiszący szyld ze spojonego zaprawą kamienia',
      'ru': 'Маленькая вывеска из строительного камня',
      'uk': 'Мала вивіска з будівельного каменю',
      'ko': '작은 걸이형 모르타르 마감 석재 선간판',
      'zh': '小型悬挂砂浆石标志',
      'ja': 'Small Hanging Mortared Stone Sign',
    }, {
      'id': 'SmallHangingWoodSign',
      'en': 'Small Hanging Wood Sign',
      'fr': 'Petit panneau suspendu en bois',
      'es': 'Letrero pequeño colgante (básico)',
      'de': 'Holzschild (klein, hängend)',
      'pl': 'Mały Wiszący Znak z Drewna',
      'ru': 'Маленькая деревянная вывеска',
      'uk': 'Маленька навісна дерев\u0027яна табличка',
      'ko': '작은 걸이형 목재 간판',
      'zh': '小型立式木质标志',
      'ja': 'Small Hanging Wood Sign',
    }, {
      'id': 'SmallSink',
      'en': 'Small Sink',
      'fr': 'Petit lavabo',
      'es': 'Fregadero pequeño',
      'de': 'Kleines Waschbecken',
      'pl': 'Mały zlew',
      'ru': 'Маленькая раковина',
      'uk': 'Мала раковина',
      'ko': '작은 싱크대',
      'zh': '小水槽',
      'ja': 'Small Sink',
    }, {
      'id': 'SmallStandingAshlarStoneSign',
      'en': 'Small Standing Ashlar Stone Sign',
      'fr': 'Petit panneau sur pied en pierre taillé',
      'es': 'Letrero pequeño (sillar de piedra)',
      'de': 'Steinquaderschild (klein, stehend)',
      'pl': 'Mały stojący znak z ciosanego kamienia',
      'ru': 'Маленькая табличка из резного камня',
      'uk': 'Маленька табличка з обтесаного каменю',
      'ko': '작은 각진 석재 선간판',
      'zh': '小型立式阿什拉尔石标志',
      'ja': 'Small Standing Ashlar Stone Sign',
    }, {
      'id': 'SmallStandingLumberSign',
      'en': 'Small Standing Lumber Sign',
      'fr': 'Petit panneau sur pied en bois d\u0027oeuvre',
      'es': 'Pequeño letrero de pie de madera',
      'de': 'Bauholzschild (klein, stehend)',
      'pl': 'Small Standing Lumber Sign',
      'ru': 'Маленькая табличка из пиломатериалов',
      'uk': 'Мала стояча дерев’яна табличка',
      'ko': '작은 가공 목재 선간판',
      'zh': '小块木制标志',
      'ja': '木製の小さな立て看板',
    }, {
      'id': 'SmallStandingMortaredStoneSign',
      'en': 'Small Standing Mortared Stone Sign',
      'fr': 'Petit panneau sur pied en pierre cimenté',
      'es': 'Letrero pequeño (piedra con mortero)',
      'de': 'Steinziegelschild (klein, stehend)',
      'pl': 'Mały stojący szyld ze spojonego zaprawą kamienia',
      'ru': 'Маленькая табличка из строительного камня',
      'uk': 'Мала стояча табличка з будівельного каменю',
      'ko': '작은 모르타르 마감 석재 선간판',
      'zh': '小型立式砂浆石标志',
      'ja': 'Small Standing Mortared Stone Sign',
    }, {
      'id': 'SmallStandingWoodSign',
      'en': 'Small Standing Wood Sign',
      'fr': 'Petit panneau sur pied en bois',
      'es': 'Letrero pequeño (básico)',
      'de': 'Holzschild (klein, stehend)',
      'pl': 'Mały Stojący Znak Drewna',
      'ru': 'Маленькая деревянная табличка',
      'uk': 'Маленька дерев\u0027яна табличка',
      'ko': '작은 목재 선간판',
      'zh': '小型立式木质标志',
      'ja': 'Small Standing Wood Sign',
    }, {
      'id': 'SmallWoodCart',
      'en': 'Small Wood Cart',
      'fr': 'Petit chariot en bois',
      'es': 'Carro de Madera Pequeño',
      'de': 'Kleiner Holzkarren',
      'pl': 'Mały drewniany wózek',
      'ru': 'Маленькая деревянная телега',
      'uk': 'Малий дерев’яний віз',
      'ko': '작은 목재 수레',
      'zh': '小木质拖车',
      'ja': '小さい木製カート',
    }, {
      'id': 'SmeltingUpgrade',
      'en': 'Smelting Upgrade',
      'fr': 'Amélioration Avancée : Fonte',
      'es': 'Mejora: Fundición',
      'de': 'Fortgeschrittenes Upgrade: Schmelzen',
      'pl': 'Ulepszenie Wytapiania',
      'ru': 'Улучшение для выплавки',
      'uk': 'Покращення виплавки',
      'ko': '제련 기술 업그레이드',
      'zh': '冶炼升级',
      'ja': '製錬アップグレード',
    }, {
      'id': 'SmithApron',
      'en': 'Smith Apron',
      'fr': 'Tablier de forgeron',
      'es': 'Delantal de herrero',
      'de': 'Schmiedeschürze',
      'pl': 'Smith Apron',
      'ru': 'Фартук Кузнеца',
      'uk': 'Smith Apron',
      'ko': '스미스 앞치마',
      'zh': '铁匠的围裙',
      'ja': 'Smith Apron',
    }, {
      'id': 'SmithBandana',
      'en': 'Smith Bandana',
      'fr': 'Bandana de forgeron',
      'es': 'Pañuelo de herrero',
      'de': 'Schmiedbandana',
      'pl': 'Smith Bandana',
      'ru': 'Бандана Кузнеца',
      'uk': 'Smith Bandana',
      'ko': '스미스 반다나',
      'zh': '铁匠的头巾',
      'ja': 'Smith Bandana',
    }, {
      'id': 'SmithBoots',
      'en': 'Smith Boots',
      'fr': 'Bottes de forgeron',
      'es': 'Botas de herrero',
      'de': 'Schmiedstiefel',
      'pl': 'Smith Boots',
      'ru': 'Ботинки Кузнеца',
      'uk': 'Smith Boots',
      'ko': '스미스 부츠',
      'zh': '铁匠的靴子',
      'ja': 'Smith Boots',
    }, {
      'id': 'SmithGloves',
      'en': 'Smith Gloves',
      'fr': 'Gants de forgeron',
      'es': 'Guantes de herrero',
      'de': 'Schmiedhandschuhe',
      'pl': 'Smith Gloves',
      'ru': 'Перчатки Кузнеца',
      'uk': 'Smith Gloves',
      'ko': '스미스 장갑',
      'zh': '铁匠的手套',
      'ja': 'Smith Gloves',
    }, {
      'id': 'SmithPants',
      'en': 'Smith Pants',
      'fr': 'Pantalon de forgeron',
      'es': 'Pantalones de herrero',
      'de': 'Schmiedhose',
      'pl': 'Smith Pants',
      'ru': 'Штаны Кузнеца',
      'uk': 'Smith Pants',
      'ko': '스미스 팬츠',
      'zh': '铁匠的裤子',
      'ja': 'Smith Pants',
    }, {
      'id': 'SmoothGutNoodleRoll',
      'en': 'Smooth Gut Noodle Roll',
      'fr': 'Rouleau de nouilles aux restes de viande',
      'es': 'Rollo de Fideos e Intestino Delgado',
      'de': 'Canelloni mit Hackfleisch',
      'pl': 'Smooth Gut Noodle Roll',
      'ru': 'Ролл из гладкой кишки с лапшой',
      'uk': 'Smooth Gut Noodle Roll',
      'ko': 'Smooth Gut Noodle Roll',
      'zh': '肠粉卷',
      'ja': 'Smooth Gut Noodle Roll',
    }, {
      'id': 'SoilSampler',
      'en': 'Soil Sampler',
      'fr': 'Analyseur de sol',
      'es': 'Muestreador de suelo',
      'de': 'Bodenprüfer',
      'pl': 'Próbnik Gleby',
      'ru': 'Анализатор почвы',
      'uk': 'Аналізатор ґрунту',
      'ko': '토양 채취기',
      'zh': '土壤取样器',
      'ja': 'ソイルサンプラー',
    }, {
      'id': 'SolarGenerator',
      'en': 'Solar Generator',
      'fr': 'Générateur solaire',
      'es': 'Generador Solar',
      'de': 'Solargenerator',
      'pl': 'Generator słoneczny',
      'ru': 'Солнечный генератор',
      'uk': 'Сонячний генератор',
      'ko': '태양광 발전기',
      'zh': '太阳能发电机',
      'ja': '太陽光発電機',
    }, {
      'id': 'SpikyRoll',
      'en': 'Spiky Roll',
      'fr': 'Maki hérissé',
      'es': 'Rollo Puntiagudo',
      'de': 'Stachelige Rolle',
      'pl': 'Spiky Roll',
      'ru': 'Колючий ролл',
      'uk': 'Spiky Roll',
      'ko': 'Spiky Roll',
      'zh': '穗状花卷',
      'ja': 'Spiky Roll',
    }, {
      'id': 'SpinMelter',
      'en': 'Spin Melter',
      'fr': 'Fileuse-fondeuse',
      'es': 'Torno de fusión',
      'de': 'Schmelzschleuderer',
      'pl': 'Spin Melter',
      'ru': 'Прядильная машина',
      'uk': 'Spin Melter',
      'ko': '스핀 멜터',
      'zh': '旋转熔炉',
      'ja': 'Spin Melter',
    }, {
      'id': 'SquareBelt',
      'en': 'Square Belt',
      'fr': 'Ceinture carrée',
      'es': 'Cinturón Cuadrado',
      'de': 'Quadratgürtel',
      'pl': 'Pas z kwadratową sprzączką',
      'ru': 'Ремень с квадратной пряжкой',
      'uk': 'Ремінь із квадратною пряжкою',
      'ko': '사각 벨트',
      'zh': '方皮带',
      'ja': '角ばったベルト',
    }, {
      'id': 'StampMill',
      'en': 'Stamp Mill',
      'fr': 'Concasseur à percussions en fer',
      'es': 'Molino de pisón',
      'de': 'Pochwerk',
      'pl': 'Kruszarka',
      'ru': 'Штамповочная мельница',
      'uk': 'Штамповий млин',
      'ko': '쇄광기',
      'zh': '捣矿机',
      'ja': 'Stamp Mill',
    }, {
      'id': 'StandingGlassSign',
      'en': 'Standing Glass Sign',
      'fr': 'Grand panneau sur pied en verre',
      'es': 'Letrero de vidrio',
      'de': 'Glasschild (stehend)',
      'pl': 'Standing Glass Sign',
      'ru': 'Стеклянная табличка',
      'uk': 'Standing Glass Sign',
      'ko': '스탠딩 글라스 사인',
      'zh': '玻璃标志',
      'ja': 'Standing Glass Sign',
    }, {
      'id': 'StandingLongSteelSign',
      'en': 'Standing Long Steel Sign',
      'fr': 'Long panneau sur pied en acier',
      'es': 'Letrero largo (acero)',
      'de': 'Stahlschild (lang, stehend)',
      'pl': 'Standing Long Steel Sign',
      'ru': 'Стоящая длинная табличка из стали',
      'uk': 'Standing Long Steel Sign',
      'ko': '서 있는 긴 강철 기호',
      'zh': '长条钢制标志',
      'ja': 'Standing Long Steel Sign',
    }, {
      'id': 'StandingSteelBrickSign',
      'en': 'Standing Steel Brick Sign',
      'fr': 'Long panneau sur pied de brique et d\u0027acier',
      'es': 'Letrero de acero (ladrillos)',
      'de': 'Stahlschild mit Ziegelsteinfundament (stehend)',
      'pl': 'Standing Steel Brick Sign',
      'ru': 'Стальная табличка с кирпичным основанием',
      'uk': 'Standing Steel Brick Sign',
      'ko': '서 있는 강철 벽돌 기호',
      'zh': '钢砖标志',
      'ja': 'Standing Steel Brick Sign',
    }, {
      'id': 'SteamEngine',
      'en': 'Steam Engine',
      'fr': 'Machine à vapeur',
      'es': 'Motor de Vapor',
      'de': 'Dampf-Stromgenerator',
      'pl': 'Steam Engine',
      'ru': 'Паровой двигатель',
      'uk': 'Паровий двигун',
      'ko': '증기기관',
      'zh': '蒸汽机',
      'ja': '蒸気発電機',
    }, {
      'id': 'SteamTractorHarvester',
      'en': 'Steam Tractor Harvester',
      'fr': 'Moissonneuse pour tracteur à vapeur',
      'es': 'Cosechadora a vapor',
      'de': 'Dampftraktor-Erntemaschine',
      'pl': 'Kombajn Parowy',
      'ru': 'Жатка парового трактора',
      'uk': 'Збирач для парового трактора',
      'ko': '증기기관 트랙터용 수확기',
      'zh': '蒸汽拖拉机式收割机',
      'ja': '蒸気トラクター用刈取り機',
    }, {
      'id': 'SteamTractor',
      'en': 'Steam Tractor',
      'fr': 'Tracteur à vapeur',
      'es': 'Tractor a vapor',
      'de': 'Dampftraktor',
      'pl': 'Ciągnik Parowy',
      'ru': 'Паровой трактор',
      'uk': 'Паровий трактор',
      'ko': '증기 트랙터',
      'zh': '蒸汽拖拉机',
      'ja': '蒸気トラクター',
    }, {
      'id': 'SteamTractorPlow',
      'en': 'Steam Tractor Plow',
      'fr': 'Charrue pour tracteur à vapeur',
      'es': 'Arado con tractor a vapor',
      'de': 'Dampftraktor-Pflug',
      'pl': 'Steam Tractor Plow',
      'ru': 'Плуг парового трактора',
      'uk': 'Steam Tractor Plow',
      'ko': '증기기관 트랙터 쟁기',
      'zh': '蒸汽拖拉机犁',
      'ja': 'Steam Tractor Plow',
    }, {
      'id': 'SteamTractorSower',
      'en': 'Steam Tractor Sower',
      'fr': 'Semoir pour tracteur à vapeur',
      'es': 'Sembradora para el Tractor de Vapor',
      'de': 'Dampftraktor-Sämaschine',
      'pl': 'Siewnik Parowy',
      'ru': 'Сеялка парового трактора',
      'uk': 'Сіялка парового трактора',
      'ko': '증기기관 트랙터용 파종기',
      'zh': '蒸汽拖拉机用播种机',
      'ja': '蒸気トラクター用種蒔き機',
    }, {
      'id': 'SteamTruck',
      'en': 'Steam Truck',
      'fr': 'Camion à vapeur',
      'es': 'Camión a vapor',
      'de': 'Dampflastwagen',
      'pl': 'Steam Truck',
      'ru': 'Паровой грузовик',
      'uk': 'Парова вантажівка',
      'ko': '증기기관 트럭',
      'zh': '蒸汽卡车',
      'ja': '蒸気トラック',
    }, {
      'id': 'SteelAxe',
      'en': 'Steel Axe',
      'fr': 'Hache en acier',
      'es': 'Hacha de Acero',
      'de': 'Stahlaxt',
      'pl': 'Stalowa siekiera',
      'ru': 'Стальной топор',
      'uk': 'Сталева сокира',
      'ko': '강철 도끼',
      'zh': '钢斧',
      'ja': '鋼のオノ',
    }, {
      'id': 'SteelAxle',
      'en': 'Steel Axle',
      'fr': 'Essieu en acier',
      'es': 'Hacha de Acero',
      'de': 'Stahlachse',
      'pl': 'Oś stalowa',
      'ru': 'Стальная ось',
      'uk': 'Сталева вісь',
      'ko': '강철 차축',
      'zh': '钢质车轴',
      'ja': '鋼の車軸',
    }, {
      'id': 'SteelBar',
      'en': 'Steel Bar',
      'fr': 'Lingot d\u0027acier',
      'es': 'Lingote de acero',
      'de': 'Stahlbarren',
      'pl': 'Sztabka stali',
      'ru': 'Стальной брусок',
      'uk': 'Стальний брусок',
      'ko': '강철괴',
      'zh': '钢筋',
      'ja': 'Steel Bar',
    }, {
      'id': 'SteelCeilingLight',
      'en': 'Steel Ceiling Light',
      'fr': 'Plafonnier en acier',
      'es': 'Lámpara de techo de metal',
      'de': 'Stahl-Deckenlampe',
      'pl': 'Steel Ceiling Light',
      'ru': 'Стальной потолочный светильник',
      'uk': 'Сталева люстра',
      'ko': '강철 천장등',
      'zh': '钢制顶棚灯',
      'ja': '鋼製の天井ライト',
    }, {
      'id': 'SteelFloorLamp',
      'en': 'Steel Floor Lamp',
      'fr': 'Lampe sur pied en acier',
      'es': 'Lámpara de suelo de metal',
      'de': 'Stählerne Stehlampe',
      'pl': 'Steel Floor Lamp',
      'ru': 'Стальной торшер',
      'uk': 'Сталевий торшер',
      'ko': '강철 스탠드형 전등',
      'zh': '钢制落地灯',
      'ja': '鋼製の室内灯',
    }, {
      'id': 'SteelGear',
      'en': 'Steel Gear',
      'fr': 'Engrenage en acier',
      'es': 'Engranaje de acero',
      'de': 'Stahlzahnrad',
      'pl': 'Stalowy bieg',
      'ru': 'Стальная шестерня',
      'uk': 'Сталева шестірня',
      'ko': '강철 기어',
      'zh': '钢质齿轮',
      'ja': '鋼のギア',
    }, {
      'id': 'SteelGearbox',
      'en': 'Steel Gearbox',
      'fr': 'Boîte de vitesses en acier',
      'es': 'Caja de engranajes de acero',
      'de': 'Stahlgetriebe',
      'pl': 'Stalowa Skrzynia Biegów',
      'ru': 'Стальная коробка передач',
      'uk': 'Сталева коробка передач',
      'ko': '강철 변속장치',
      'zh': '钢齿轮箱',
      'ja': 'Steel Gearbox',
    }, {
      'id': 'SteelHammer',
      'en': 'Steel Hammer',
      'fr': 'Marteau en acier',
      'es': 'Martillo de Acero',
      'de': 'Stahlhammer',
      'pl': 'Stalowy młotek',
      'ru': 'Стальной молоток',
      'uk': 'Сталевий молоток',
      'ko': '강철 망치',
      'zh': '钢锤',
      'ja': '鋼のハンマー',
    }, {
      'id': 'SteelHoe',
      'en': 'Steel Hoe',
      'fr': 'Binette en acier',
      'es': 'Azada de Acero',
      'de': 'Stahlhacke',
      'pl': 'Stalowa motyka',
      'ru': 'Стальная тяпка',
      'uk': 'Сталева мотика',
      'ko': '강철 괭이',
      'zh': '钢锄',
      'ja': '鋼のクワ',
    }, {
      'id': 'SteelMachete',
      'en': 'Steel Machete',
      'fr': 'Machette en acier',
      'es': 'Machete de acero',
      'de': 'Stahlmachete',
      'pl': 'Stalowa maczeta',
      'ru': 'Стальное мачете',
      'uk': 'Стальне мачете',
      'ko': '강철 마체테',
      'zh': '钢质砍刀',
      'ja': 'Steel Machete',
    }, {
      'id': 'SteelPickaxe',
      'en': 'Steel Pickaxe',
      'fr': 'Pioche en acier',
      'es': 'Pico de Acero',
      'de': 'Stahlspitzhacke',
      'pl': 'Stalowy kilof',
      'ru': 'Стальная кирка',
      'uk': 'Сталеве кайло',
      'ko': '강철 곡괭이',
      'zh': '钢镐',
      'ja': '鋼のツルハシ',
    }, {
      'id': 'SteelPipe',
      'en': 'Steel Pipe',
      'fr': 'Tuyau en acier',
      'es': 'Tubo de Acero',
      'de': 'Stahlrohr',
      'pl': 'Stalowa Rura',
      'ru': 'Стальная труба',
      'uk': 'Сталева труба',
      'ko': '강철 파이프',
      'zh': '钢管',
      'ja': '鋼パイプ',
    }, {
      'id': 'SteelPlate',
      'en': 'Steel Plate',
      'fr': 'Plaque d’acier',
      'es': 'Placa de Acero',
      'de': 'Stahlplatte',
      'pl': 'Blacha Stalowa',
      'ru': 'Стальная пластина',
      'uk': 'Сталева пластина',
      'ko': '강철판',
      'zh': '钢板',
      'ja': '鋼板',
    }, {
      'id': 'SteelRoadTool',
      'en': 'Steel Road Tool',
      'fr': 'Outil de route en acier',
      'es': 'Herramienta compactadora de acero',
      'de': 'Stahlstraßenwerkzeug',
      'pl': 'Stalowe narzędzie do dróg',
      'ru': 'Стальная трамбовка',
      'uk': 'Стальний дорожній інструмент',
      'ko': '강철 도로정비 도구',
      'zh': '钢质道路工具',
      'ja': 'Steel Road Tool',
    }, {
      'id': 'SteelSawBlade',
      'en': 'Steel Saw Blade',
      'fr': 'Lame de scie en acier',
      'es': 'Sierra circular de acero',
      'de': 'Stahlsägeblatt',
      'pl': 'Stalowe Ostrze Piły',
      'ru': 'Стальной пильный диск',
      'uk': 'Сталевий пиляльний диск',
      'ko': '강철 톱날',
      'zh': '钢锯片',
      'ja': 'Steel Saw Blade',
    }, {
      'id': 'SteelShovel',
      'en': 'Steel Shovel',
      'fr': 'Pelle en acier',
      'es': 'Pala de Acero',
      'de': 'Stahlschaufel',
      'pl': 'Stalowa łopata',
      'ru': 'Стальная лопата',
      'uk': 'Сталева лопата',
      'ko': '강철 삽',
      'zh': '钢铲',
      'ja': '鋼のシャベル',
    }, {
      'id': 'SteelSickle',
      'en': 'Steel Sickle',
      'fr': 'Faucille en acier',
      'es': 'Hoz de acero',
      'de': 'Stahlsichel',
      'pl': 'Stalowy sierp',
      'ru': 'Стальной серп',
      'uk': 'Стальний серп',
      'ko': '강철 낫',
      'zh': '钢质镰刀',
      'ja': 'Steel Sickle',
    }, {
      'id': 'SteelTableLamp',
      'en': 'Steel Table Lamp',
      'fr': 'Lampe de table en acier',
      'es': 'Lampara de acero para mesas',
      'de': 'Stahltischlampe',
      'pl': 'Steel Table Lamp',
      'ru': 'Стальная настольная лампа',
      'uk': 'Сталева настільна лампа',
      'ko': '강철 탁자 전등',
      'zh': '钢制台灯',
      'ja': '鋼製の電気スタンド',
    }, {
      'id': 'StoneBrazier',
      'en': 'Stone Brazier',
      'fr': 'Braséro en pierre',
      'es': 'Brasero de piedra',
      'de': 'Feuerschale aus Stein',
      'pl': 'Kamienny koksownik',
      'ru': 'Каменная жаровня',
      'uk': 'Кам’яна жаровня',
      'ko': '돌 화로',
      'zh': '石火盆',
      'ja': '石火鉢',
    }, {
      'id': 'StoneRamp',
      'en': 'Stone Ramp',
      'fr': 'Rampe pavée',
      'es': 'Rampa de Piedra',
      'de': 'Steinrampe',
      'pl': 'Kamienny Podjazd',
      'ru': 'Каменная рампа',
      'uk': 'Кам’яний підйом',
      'ko': '돌 경사로',
      'zh': '石头坡道',
      'ja': '石の坂道',
    }, {
      'id': 'StoneRoad',
      'en': 'Stone Road',
      'fr': 'Route pavée',
      'es': 'Camino de Piedra',
      'de': 'Steinstraße',
      'pl': 'Kamienna droga',
      'ru': 'Каменная дорога',
      'uk': 'Кам’яна дорога',
      'ko': '돌 길',
      'zh': '石质道路',
      'ja': '石の道路',
    }, {
      'id': 'StoneRoadTool',
      'en': 'Stone Road Tool',
      'fr': 'Outil de route en pierre',
      'es': 'Herramienta compactadora de piedra',
      'de': 'Steinstraßenwerkzeug',
      'pl': 'Kamienne narzędzie do dróg',
      'ru': 'Каменная трамбовка',
      'uk': 'Кам\u0027яний дорожній інструмент',
      'ko': '돌 도로정비 도구',
      'zh': '石质道路工具',
      'ja': 'Stone Road Tool',
    }, {
      'id': 'StopSign',
      'en': 'Stop Sign',
      'fr': 'Panneau stop',
      'es': 'Señal de STOP',
      'de': 'Stoppschild',
      'pl': 'Stop Sign',
      'ru': 'Знак Стоп',
      'uk': 'Знак стоп',
      'ko': '일단정지 표지판',
      'zh': '停止标志',
      'ja': 'Stop Sign',
    }, {
      'id': 'StorageSilo',
      'en': 'Storage Silo',
      'fr': 'Silo de stockage',
      'es': 'Silo de almacenamiento',
      'de': 'Hölzernes Vorratssilo',
      'pl': 'Storage Silo',
      'ru': 'Силосная башня',
      'uk': 'Storage Silo',
      'ko': '스토리지 사일로',
      'zh': '储料仓',
      'ja': 'Storage Silo',
    }, {
      'id': 'Stove',
      'en': 'Stove',
      'fr': 'Cuisinière',
      'es': 'Estufa',
      'de': 'Herd',
      'pl': 'Kuchnia',
      'ru': 'Плита',
      'uk': 'Плита',
      'ko': '화덕',
      'zh': '火炉',
      'ja': 'ストーブ',
    }, {
      'id': 'StreetSign',
      'en': 'Street Sign',
      'fr': 'Panneau de rue',
      'es': 'Letrero de calle',
      'de': 'Straßenschild',
      'pl': 'Znak Uliczny',
      'ru': 'Уличный указатель',
      'uk': 'Вуличний знак',
      'ko': '거리 표지판',
      'zh': '街道路标',
      'ja': 'Street Sign',
    }, {
      'id': 'Streetlamp',
      'en': 'Streetlamp',
      'fr': 'Réverbère',
      'es': 'Farola',
      'de': 'Straßenlaterne',
      'pl': 'Lampa uliczna',
      'ru': 'Уличный фонарь',
      'uk': 'Вуличний ліхтар',
      'ko': '가로등',
      'zh': '街灯',
      'ja': '街灯',
    }, {
      'id': 'StuffedAlligator',
      'en': 'Stuffed Alligator',
      'fr': 'Alligator empaillé',
      'es': 'Caimán disecado',
      'de': 'Ausgestopfter Alligator',
      'pl': 'Wypchany aligator',
      'ru': 'Чучело аллигатора',
      'uk': 'Опудало алігатора',
      'ko': '박제된 악어',
      'zh': '鳄鱼标本',
      'ja': 'Stuffed Alligator',
    }, {
      'id': 'StuffedBison',
      'en': 'Stuffed Bison',
      'fr': 'Bison empaillé',
      'es': 'Bisón disecado',
      'de': 'Ausgestopftes Bison',
      'pl': 'Wypchany żubr',
      'ru': 'Чучело бизона',
      'uk': 'Опудало бізона',
      'ko': '박제된 들소',
      'zh': '野牛标本',
      'ja': 'Stuffed Bison',
    }, {
      'id': 'StuffedElk',
      'en': 'Stuffed Elk',
      'fr': 'Wapiti empaillé',
      'es': 'Alce disecado',
      'de': 'Ausgestopfter Wapiti',
      'pl': 'Nadziewany Łoś',
      'ru': 'Чучело вапити',
      'uk': 'Опудало лося',
      'ko': '박제된 엘크',
      'zh': '驼鹿标本',
      'ja': 'エルクのぬいぐるみ',
    }, {
      'id': 'StuffedGoat',
      'en': 'Stuffed Goat',
      'fr': 'Chèvre des montagnes empaillé',
      'es': 'Cabra disecada',
      'de': 'Ausgestopfte Ziege',
      'pl': 'Nadziewana koza',
      'ru': 'Чучело козы',
      'uk': 'Опудало кози',
      'ko': '박재된 염소',
      'zh': '山羊标本',
      'ja': 'Stuffed Goat',
    }, {
      'id': 'StuffedJaguar',
      'en': 'Stuffed Jaguar',
      'fr': 'Jaguar empaillé',
      'es': 'Jaguar disecado',
      'de': 'Ausgestopfter Jaguar',
      'pl': 'Wypchany jaguar',
      'ru': 'Чучело ягуара',
      'uk': 'Опудало ягуара',
      'ko': '박재된 재규어',
      'zh': '美洲豹标本',
      'ja': 'Stuffed Jaguar',
    }, {
      'id': 'StuffedTurkey',
      'en': 'Stuffed Turkey',
      'fr': 'Dinde farcie',
      'es': 'Pavo Relleno',
      'de': 'Gefüllter Truthahn',
      'pl': 'Indyk faszerowany',
      'ru': 'Фаршированная индейка',
      'uk': 'Фарширована індичка',
      'ko': '속을 채운 칠면조',
      'zh': '填馅火鸡',
      'ja': '七面鳥の丸焼き',
    }, {
      'id': 'StuffedWolf',
      'en': 'Stuffed Wolf',
      'fr': 'Loup empaillé',
      'es': 'Lobo disecado',
      'de': 'Ausgestopfter Wolf',
      'pl': 'Wypchany wilk',
      'ru': 'Чучело волка',
      'uk': 'Опудало вовка',
      'ko': '박제된 늑대',
      'zh': '狼标本',
      'ja': 'Stuffed Wolf',
    }, {
      'id': 'Substrate',
      'en': 'Substrate',
      'fr': 'Substrat',
      'es': 'Oblea',
      'de': 'Substrat',
      'pl': 'Płytka podkładowa',
      'ru': 'Подложка',
      'uk': 'Підкладка',
      'ko': '기판',
      'zh': '基底',
      'ja': '基板',
    }, {
      'id': 'BeetSugar',
      'en': 'Beet Sugar',
      'fr': 'Sucre de betterave',
      'es': 'Azúcar de remolacha',
      'de': 'Zucker aus Rote Bete',
      'pl': 'Cukier buraczany',
      'ru': 'Свекольный сахар',
      'uk': 'Цукор буряковий',
      'ko': '사탕무 설탕',
      'zh': '甜菜糖',
      'ja': 'てんさい糖',
    }, {
      'id': 'Sugar',
      'en': 'Sugar',
      'fr': 'Sucre',
      'es': 'Azúcar',
      'de': 'Zucker',
      'pl': 'Cukier',
      'ru': 'Сахар',
      'uk': 'Цукор',
      'ko': '설탕',
      'zh': '糖',
      'ja': '砂糖',
    }, {
      'id': 'SunCheese',
      'en': 'Sun Cheese',
      'fr': 'Fromage de tournesol',
      'es': 'Queso solar',
      'de': 'Sonnenblumenkäse',
      'pl': 'Sun Cheese',
      'ru': 'Сыр из семечек подсолнуха',
      'uk': 'Sun Cheese',
      'ko': 'Sun Cheese',
      'zh': '向日葵奶酪',
      'ja': 'Sun Cheese',
    }, {
      'id': 'SunflowerSeed',
      'en': 'Sunflower Seed',
      'fr': 'Graine de tournesol',
      'es': 'Semilla de girasol',
      'de': 'Samen (Sonnenblume)',
      'pl': 'Nasiona słonecznika',
      'ru': 'Семечко подсолнечника',
      'uk': 'Насіння соняшника',
      'ko': '해바라기 씨앗',
      'zh': '向日葵种子',
      'ja': 'ひまわりの種',
    }, {
      'id': 'SweetSalad',
      'en': 'Sweet Salad',
      'fr': 'Salade douce',
      'es': 'Ensalada Dulce',
      'de': 'Süßer Salat',
      'pl': 'Słodka sałatka',
      'ru': 'Сладкий салат',
      'uk': 'Солодкий салат',
      'ko': '달콤한 샐러드',
      'zh': '甜沙拉',
      'ja': 'スウィートサラダ',
    }, {
      'id': 'SyntheticRubber',
      'en': 'Synthetic Rubber',
      'fr': 'Caoutchouc synthétique',
      'es': 'Caucho Sintético',
      'de': 'Synthetischer Gummi',
      'pl': 'Kauczuk Syntetyczny',
      'ru': 'Синтетическая резина',
      'uk': 'Синтетична гума',
      'ko': '합성 고무',
      'zh': '合成橡胶',
      'ja': '合成ゴム',
    }, {
      'id': 'TailorBowlerHat',
      'en': 'Tailor Bowler Hat',
      'fr': 'Chapeau melon de tailleur',
      'es': 'Bombín de sastre',
      'de': 'Schneidermelone',
      'pl': 'Tailor Bowler Hat',
      'ru': 'Шляпа-котелок Портного',
      'uk': 'Tailor Bowler Hat',
      'ko': '재단사 중산모',
      'zh': '裁缝的圆顶礼帽',
      'ja': 'Tailor Bowler Hat',
    }, {
      'id': 'TailorPants',
      'en': 'Tailor Pants',
      'fr': 'Pantalon de tailleur',
      'es': 'Pantalones de sastre',
      'de': 'Schneiderhose',
      'pl': 'Tailor Pants',
      'ru': 'Штаны Портного',
      'uk': 'Tailor Pants',
      'ko': '재단사 바지',
      'zh': '裁缝的裤子',
      'ja': 'Tailor Pants',
    }, {
      'id': 'TailorShirt',
      'en': 'Tailor Shirt',
      'fr': 'Chemise de tailleur',
      'es': 'Camisa de sastre',
      'de': 'Schneiderhemd',
      'pl': 'Tailor Shirt',
      'ru': 'Рубашка Портного',
      'uk': 'Tailor Shirt',
      'ko': '재단사 셔츠',
      'zh': '裁缝的衬衫',
      'ja': 'Tailor Shirt',
    }, {
      'id': 'TailorShoes',
      'en': 'Tailor Shoes',
      'fr': 'Chaussures de tailleur',
      'es': 'Zapatos de sastre',
      'de': 'Schneiderschuhe',
      'pl': 'Tailor Shoes',
      'ru': 'Ботинки Портного',
      'uk': 'Tailor Shoes',
      'ko': '재단사 신발',
      'zh': '裁缝的鞋子',
      'ja': 'Tailor Shoes',
    }, {
      'id': 'TailoringBasicUpgrade',
      'en': 'Tailoring Basic Upgrade',
      'fr': 'Amélioration Basique : Couture',
      'es': 'Mejora básica: Sastrería',
      'de': 'Grundlegendes Upgrade: Schneidern',
      'pl': 'Podstawowe ulepszenie Krawiectwa',
      'ru': 'Обычное улучшение для портняжного дела',
      'uk': 'Tailoring Basic Upgrade',
      'ko': '기초 재단 기술 업그레이드',
      'zh': '裁缝基础升级',
      'ja': 'Tailoring Basic Upgrade',
    }, {
      'id': 'TailoringModernUpgrade',
      'en': 'Tailoring Modern Upgrade',
      'fr': 'Amélioration Moderne : Couture',
      'es': 'Mejora moderna: Sastrería',
      'de': 'Modernes Upgrade: Schneidern',
      'pl': 'Tailoring Modern Upgrade',
      'ru': 'Современное улучшение для портняжного дела',
      'uk': 'Tailoring Modern Upgrade',
      'ko': '현대적인 업그레이드 조정',
      'zh': '裁缝现代化升级',
      'ja': 'Tailoring Modern Upgrade',
    }, {
      'id': 'TailoringTable',
      'en': 'Tailoring Table',
      'fr': 'Atelier de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stacja Krawiecka',
      'ru': 'Стол портного',
      'uk': 'Кравецький стіл',
      'ko': '재단 작업대',
      'zh': '裁缝工作台',
      'ja': '裁縫作業台',
    }, {
      'id': 'TallBoots',
      'en': 'Tall Boots',
      'fr': 'Bottes hautes',
      'es': 'Botas altas',
      'de': 'Hohe Stiefel',
      'pl': 'Wysokie Buty',
      'ru': 'Сапоги',
      'uk': 'Високі чоботи',
      'ko': '롱부츠',
      'zh': '高筒靴',
      'ja': 'トールブーツ',
    }, {
      'id': 'TallowCandle',
      'en': 'Tallow Candle',
      'fr': 'Bougie en suif',
      'es': 'Vela de sebo',
      'de': 'Talgkerze',
      'pl': 'Świeca łojowa',
      'ru': 'Сальная свеча',
      'uk': 'Сальна свічка',
      'ko': '수지 양초',
      'zh': '油脂蜡烛',
      'ja': '獣脂ろうそく',
    }, {
      'id': 'MeltingFat',
      'en': 'Melting Fat',
      'fr': 'Fondre la graisse',
      'es': 'Grasa fundida',
      'de': 'Schmelzfett',
      'pl': 'Melting Fat',
      'ru': 'Плавить Жир',
      'uk': 'Витопити жир',
      'ko': 'Melting Fat',
      'zh': '炼制脂肪',
      'ja': 'Melting Fat',
    }, {
      'id': 'RenderFat',
      'en': 'Render Fat',
      'fr': 'Affiner la graisse',
      'es': 'Extracción de grasas',
      'de': 'Fett auslassen',
      'pl': 'Render Fat',
      'ru': 'Вытопить жир',
      'uk': 'Витопити жир',
      'ko': '지방 가공법',
      'zh': '提炼脂肪',
      'ja': '脂肪を精製する',
    }, {
      'id': 'TallowLamp',
      'en': 'Tallow Lamp',
      'fr': 'Lampe à suif',
      'es': 'Lámpara de Sebo',
      'de': 'Talglampe',
      'pl': 'Lampa łojowa',
      'ru': 'Сальная лампа',
      'uk': 'Сальний світильник',
      'ko': '수지 램프',
      'zh': '油脂灯',
      'ja': '獣脂ランプ',
    }, {
      'id': 'TallowWallLamp',
      'en': 'Tallow Wall Lamp',
      'fr': 'Lampe à suif murale',
      'es': 'Lámpara de Pared de Sebo',
      'de': 'Talgwandlampe',
      'pl': 'Ścienna Lampa Łojowa',
      'ru': 'Настенная сальная лампа',
      'uk': 'Сальний настінний світильник',
      'ko': '벽걸이형 수지 램프',
      'zh': '油脂壁灯',
      'ja': '壁掛け獣脂ろうそく',
    }, {
      'id': 'TaroFries',
      'en': 'Taro Fries',
      'fr': 'Frites de taro',
      'es': 'Patatas fritas de taro',
      'de': 'Taro-Fritten',
      'pl': 'Taro Fries',
      'ru': 'Таро Фри',
      'uk': 'Taro Fries',
      'ko': 'Taro Fries',
      'zh': '芋头炸薯条',
      'ja': 'Taro Fries',
    }, {
      'id': 'TaroSeed',
      'en': 'Taro Seed',
      'fr': 'Graine de taro',
      'es': 'Semilla de taro',
      'de': 'Samen (Taro)',
      'pl': 'Nasiona kolokazji',
      'ru': 'Семечко таро',
      'uk': 'Насіння таро',
      'ko': '토란 씨앗',
      'zh': '芋头籽',
      'ja': 'タロイモの種',
    }, {
      'id': 'TastyTropicalPizza',
      'en': 'Tasty Tropical Pizza',
      'fr': 'Pizza tropicale savoureuse',
      'es': 'Pizza tropical',
      'de': 'Pizza Tropica',
      'pl': 'Pyszna pizza tropikalna',
      'ru': 'Вкусная Тропическая Пицца',
      'uk': 'Tasty Tropical Pizza',
      'ko': 'Tasty Tropical Pizza',
      'zh': '可口热带比萨',
      'ja': 'Tasty Tropical Pizza',
    }, {
      'id': 'Toilet',
      'en': 'Toilet',
      'fr': 'Toilette',
      'es': 'Baño',
      'de': 'Toilette',
      'pl': 'Toaleta',
      'ru': 'Туалет',
      'uk': 'Туалет',
      'ko': '화장실',
      'zh': '厕所',
      'ja': 'Toilet',
    }, {
      'id': 'TomatoSeed',
      'en': 'Tomato Seed',
      'fr': 'Graine de tomate',
      'es': 'Semilla de tomate',
      'de': 'Samen (Tomaten)',
      'pl': 'Nasiona Pomidora',
      'ru': 'Семечко помидора',
      'uk': 'Насіння помідору',
      'ko': '토마토 씨앗',
      'zh': '番茄种子',
      'ja': 'トマトの種',
    }, {
      'id': 'ToppedPorridge',
      'en': 'Topped Porridge',
      'fr': 'Porridge garni',
      'es': 'Gachas con fruta',
      'de': 'Verfeinertes Porridge',
      'pl': 'Polana owsianka',
      'ru': 'Каша с добавками',
      'uk': 'Каша з добавками',
      'ko': '뭔가 추가된 죽',
      'zh': '稀饭',
      'ja': 'Topped Porridge',
    }, {
      'id': 'Tortilla',
      'en': 'Tortilla',
      'fr': 'Tortilla',
      'es': 'Tortilla',
      'de': 'Tortilla',
      'pl': 'Tortilla',
      'ru': 'Тортилья',
      'uk': 'Тортилья',
      'ko': '또띠아',
      'zh': '玉米饼',
      'ja': 'トルティーヤ',
    }, {
      'id': 'TowelRack',
      'en': 'Towel Rack',
      'fr': 'Porte-serviettes',
      'es': 'Colgador de toalla',
      'de': 'Handtuchständer',
      'pl': 'Towel Rack',
      'ru': 'Вешалка для полотенец',
      'uk': 'Towel Rack',
      'ko': 'Towel Rack',
      'zh': '毛巾架',
      'ja': 'Towel Rack',
    }, {
      'id': 'Transglutaminase',
      'en': 'Transglutaminase',
      'fr': 'Transglutaminase',
      'es': 'Transglutaminasa',
      'de': 'Transglutaminase',
      'pl': 'Transglutaminaza',
      'ru': 'Трансглютаминаза',
      'uk': 'Трансглютаміназа',
      'ko': '글루타미나제',
      'zh': '转谷氨酰胺酶',
      'ja': 'トランスグルタミナーゼ',
    }, {
      'id': 'TransmissionPole',
      'en': 'Transmission Pole',
      'fr': 'Poteau de transmission',
      'es': 'Poste de Transmisión',
      'de': 'Übertragungsmast',
      'pl': 'Słup elektryczny',
      'ru': 'Опора линии электропередач',
      'uk': 'Опора ЛЕП',
      'ko': '전봇대',
      'zh': '传动杆',
      'ja': '電柱',
    }, {
      'id': 'Treasury',
      'en': 'Treasury',
      'fr': 'Trésor public',
      'es': 'Tesorería',
      'de': 'Steuertresor',
      'pl': 'Skarbiec',
      'ru': 'Казна',
      'uk': 'Скарбниця',
      'ko': '정부 금고',
      'zh': '金库',
      'ja': '金庫',
    }, {
      'id': 'Trousers',
      'en': 'Trousers',
      'fr': 'Pantalon',
      'es': 'Pantalones',
      'de': 'Hosen',
      'pl': 'Spodnie',
      'ru': 'Брюки',
      'uk': 'Брюки',
      'ko': '바지',
      'zh': '裤子',
      'ja': 'ズボン',
    }, {
      'id': 'Truck',
      'en': 'Truck',
      'fr': 'Camion',
      'es': 'Camión',
      'de': 'LKW',
      'pl': 'Ciężarówka',
      'ru': 'Грузовик',
      'uk': 'Вантажівка',
      'ko': '트럭',
      'zh': '卡车',
      'ja': 'トラック',
    }, {
      'id': 'UpholsteredChair',
      'en': 'Upholstered Chair',
      'fr': 'Fauteuil rembourré',
      'es': 'Silla tapizada',
      'de': 'Gepolsteter Stuhl',
      'pl': 'Upholstered Chair',
      'ru': 'Стул с обивкой',
      'uk': 'Upholstered Chair',
      'ko': '푹신한 의자',
      'zh': '铺软垫的椅子',
      'ja': 'Upholstered Chair',
    }, {
      'id': 'UpholsteredCouch',
      'en': 'Upholstered Couch',
      'fr': 'Canapé rembourré',
      'es': 'Sofá tapizado',
      'de': 'Gepolsterte Couch',
      'pl': 'Upholstered Couch',
      'ru': 'Диван с обивкой',
      'uk': 'Upholstered Couch',
      'ko': '푹신한 소파',
      'zh': '铺软垫的沙发',
      'ja': 'Upholstered Couch',
    }, {
      'id': 'Valve',
      'en': 'Valve',
      'fr': 'Soupape',
      'es': 'Válvula',
      'de': 'Ventil',
      'pl': 'Zawór',
      'ru': 'Клапан',
      'uk': 'Вентиль',
      'ko': '밸브',
      'zh': '阀门',
      'ja': 'Zawór',
    }, {
      'id': 'ExoticVegetableMedley',
      'en': 'Exotic Vegetable Medley',
      'fr': 'Mélange de légumes exotiques',
      'es': 'Mezcla de Verduras Exóticas',
      'de': 'Exotische Gemüsemischung',
      'pl': 'Tropikalna mieszanka warzywna',
      'ru': 'Экзотическая овощная смесь',
      'uk': 'Екзотична овочева суміш',
      'ko': '이국적인 야채 모듬',
      'zh': '异国风味蔬菜拼盘',
      'ja': 'エキゾチックな野菜の盛り合せ',
    }, {
      'id': 'MixedVegetableMedley',
      'en': 'Mixed Vegetable Medley',
      'fr': 'Salade de végétaux',
      'es': 'Mezcla de Verduras Mixtas',
      'de': 'Gemischtes Gemüsepotpourri',
      'pl': 'Różnorodna mieszanka warzywna',
      'ru': 'Сложная овощная смесь',
      'uk': 'Змішана овочева суміш',
      'ko': '혼합 야채 모듬',
      'zh': '什锦蔬菜拼盘',
      'ja': 'ミックス野菜盛り合わせ',
    }, {
      'id': 'MushroomMedley',
      'en': 'Mushroom Medley',
      'fr': 'Assortiment de champignons',
      'es': 'Mezcla de champiñones',
      'de': 'Pilzpotpourri',
      'pl': 'Mieszanka grzybów',
      'ru': 'Грибное попурри',
      'uk': 'Грибна суміш',
      'ko': '버섯 모듬',
      'zh': '菌菇拼盘',
      'ja': 'キノコのメドレー',
    }, {
      'id': 'VegetableSoup',
      'en': 'Vegetable Soup',
      'fr': 'Soupe de légumes',
      'es': 'Sopa de Verduras',
      'de': 'Suppe mit Gemüse',
      'pl': 'Zupa jarzynowa',
      'ru': 'Овощной суп',
      'uk': 'Овочевий суп',
      'ko': '야채 스프',
      'zh': '蔬菜汤',
      'ja': '野菜スープ',
    }, {
      'id': 'VegetableStock',
      'en': 'Vegetable Stock',
      'fr': 'Bouillon de légumes',
      'es': 'Caldo de Verduras',
      'de': 'Brühe aus Gemüse',
      'pl': 'Bulion warzywny',
      'ru': 'Овощной бульон',
      'uk': 'Овочевий бульйон',
      'ko': '야채 육수',
      'zh': '蔬菜汤料',
      'ja': '野菜の煮汁',
    }, {
      'id': 'WainwrightTable',
      'en': 'Wainwright Table',
      'fr': 'Établi d\u0027ingénierie routière',
      'es': 'Mesa de carretero',
      'de': 'Wagenmachertisch',
      'pl': 'Stół Powoźniczy',
      'ru': 'Верстак колесника',
      'uk': 'Стіл стельмаха',
      'ko': '짐수레 작업대',
      'zh': '车匠工作台',
      'ja': '荷車作業台',
    }, {
      'id': 'WallCandle',
      'en': 'Wall Candle',
      'fr': 'Bougie murale',
      'es': 'Vela de Pared',
      'de': 'Wandkerze',
      'pl': 'Świeca ścienna',
      'ru': 'Настенная свеча',
      'uk': 'Настінна свічка',
      'ko': '벽걸이형 촛불',
      'zh': '挂壁烛灯',
      'ja': '壁掛けろうそく',
    }, {
      'id': 'Washboard',
      'en': 'Washboard',
      'fr': 'Planche à laver',
      'es': 'Lavadero',
      'de': 'Waschbrett',
      'pl': 'Tara',
      'ru': 'Стиральная доска',
      'uk': 'Пральна дошка',
      'ko': '빨래판',
      'zh': '搓衣板',
      'ja': '洗濯板',
    }, {
      'id': 'WashingMachine',
      'en': 'Washing Machine',
      'fr': 'Machine à laver',
      'es': 'Lavadora',
      'de': 'Waschmaschine',
      'pl': 'Pralka',
      'ru': 'Стиральная машина',
      'uk': 'Пральна машина',
      'ko': '세탁기',
      'zh': '洗衣机',
      'ja': '洗濯機',
    }, {
      'id': 'WasteFilter',
      'en': 'Waste Filter',
      'fr': 'Filtre à déchets',
      'es': 'Filtro de Residuos',
      'de': 'Wasserfilter',
      'pl': 'Filtr Odpadów',
      'ru': 'Сточный фильтр',
      'uk': 'Фільтр відходів',
      'ko': '폐수 여과장치',
      'zh': '废物过滤器',
      'ja': '廃棄物フィルター',
    }, {
      'id': 'Waterwheel',
      'en': 'Waterwheel',
      'fr': 'Moulin à eau',
      'es': 'Molino de agua',
      'de': 'Wasserrad',
      'pl': 'Koło Wodne',
      'ru': 'Водяное колесо',
      'uk': 'Водяне колесо',
      'ko': '물레방아',
      'zh': '水车',
      'ja': '水車',
    }, {
      'id': 'WheatSeed',
      'en': 'Wheat Seed',
      'fr': 'Graine de blé',
      'es': 'Semilla de Trigo',
      'de': 'Samen (Weizen)',
      'pl': 'Nasiona Pszenicy',
      'ru': 'Семечко пшеницы',
      'uk': 'Насіння пшениці',
      'ko': '밀 씨앗',
      'zh': '小麦种子',
      'ja': '小麦の種',
    }, {
      'id': 'Wheelbarrow',
      'en': 'Wheelbarrow',
      'fr': 'Brouette',
      'es': 'Carretilla',
      'de': 'Schubkarre',
      'pl': 'Taczka',
      'ru': 'Тачка',
      'uk': 'Візок',
      'ko': '외바퀴 손수레',
      'zh': '独轮手推车',
      'ja': '手押し車',
    }, {
      'id': 'WildMix',
      'en': 'Wild Mix',
      'fr': 'Mélange sauvage',
      'es': 'Mezcla Silvestre',
      'de': 'Wildsalat',
      'pl': 'Dzika mieszanka',
      'ru': 'Смесь диких растений',
      'uk': 'Суміш диких трав',
      'ko': '야채 샐러드',
      'zh': '蔬菜捞',
      'ja': 'ワイルドミックス',
    }, {
      'id': 'WildStew',
      'en': 'Wild Stew',
      'fr': 'Ragoût sauvage',
      'es': 'Estofado silvestre',
      'de': 'Lagerfeuer Waldeintopf',
      'pl': 'Gulasz z dziczyzny',
      'ru': 'Рагу из диких растений',
      'uk': 'Рагу з диких трав',
      'ko': '야생 스튜',
      'zh': '蔬菜炖',
      'ja': 'ワイルドシチュー',
    }, {
      'id': 'WiltedFiddleheads',
      'en': 'Wilted Fiddleheads',
      'fr': 'Crosses de fougère flétries',
      'es': 'Brotes de helecho marchitos',
      'de': 'Farnspitzen getrocknet',
      'pl': 'Blanszowane pędy paproci',
      'ru': 'Увядшие побеги папоротника',
      'uk': 'Зів’яла папороть',
      'ko': '살짝 익힌 고사리',
      'zh': '蕨菜干',
      'ja': 'しおれたシダ',
    }, {
      'id': 'WindTurbine',
      'en': 'Wind Turbine',
      'fr': 'Éolienne',
      'es': 'Turbina Eólica',
      'de': 'Windrad',
      'pl': 'Turbina powietrzna',
      'ru': 'Ветряная турбина',
      'uk': 'Вітрова турбіна',
      'ko': '풍력 발전기',
      'zh': '风力涡轮机',
      'ja': '風力タービン',
    }, {
      'id': 'Windmill',
      'en': 'Windmill',
      'fr': 'Moulin à vent',
      'es': 'Molino',
      'de': 'Windmühle',
      'pl': 'Wiatrak',
      'ru': 'Ветряная мельница',
      'uk': 'Вітряк',
      'ko': '풍차',
      'zh': '风车',
      'ja': '風車',
    }, {
      'id': 'WoodCart',
      'en': 'Wood Cart',
      'fr': 'Chariot en bois',
      'es': 'Carro de Madera',
      'de': 'Großer Holzkarren',
      'pl': 'Drewniany wózek',
      'ru': 'Деревянная тележка',
      'uk': 'Дерев’яний віз',
      'ko': '목재 수레',
      'zh': '木质拖车',
      'ja': '木製カート',
    }, {
      'id': 'WoodenCeilingLight',
      'en': 'Wooden Ceiling Light',
      'fr': 'Plafonnier en bois',
      'es': 'Lámpara de techo de madera',
      'de': 'Hölzerne Deckenlampe',
      'pl': 'Drewniane oświetlenie sufitowe',
      'ru': 'Деревянный потолочный светильник',
      'uk': 'Дерев’яна люстра',
      'ko': '목재 천장등',
      'zh': '木制顶棚灯',
      'ja': '木製の天井ライト',
    }, {
      'id': 'WoodenElevator',
      'en': 'Wooden Elevator',
      'fr': 'Ascenseur en bois',
      'es': 'Ascensor de Madera',
      'de': 'Hölzerner Aufzug',
      'pl': 'Winda drewniana',
      'ru': 'Деревянный лифт',
      'uk': 'Дерев’яний ліфт',
      'ko': '목재 엘리베이터',
      'zh': '木制升降机',
      'ja': '木製エレベーター',
    }, {
      'id': 'WoodenFabricBed',
      'en': 'Wooden Fabric Bed',
      'fr': 'Lit confortable en bois',
      'es': 'Cama de madera y tela',
      'de': 'Hölzernes Stoffbett',
      'pl': 'Drewniane łóżko z materacem',
      'ru': 'Деревянная кровать с матрасом',
      'uk': 'Дерев’яне ліжко з матрацем',
      'ko': '목재 천 침대',
      'zh': '木质布料床',
      'ja': '木製の布ベッド',
    }, {
      'id': 'WoodenFloorLamp',
      'en': 'Wooden Floor Lamp',
      'fr': 'Lampe sur pied en bois',
      'es': 'Lámpara de suelo de madera',
      'de': 'Hölzerne Stehlampe',
      'pl': 'Drewniana lampa podłogowa',
      'ru': 'Деревянный торшер',
      'uk': 'Дерев’яний торшер',
      'ko': '목재 스탠드형 전등',
      'zh': '木制落地灯',
      'ja': '木製の室内灯',
    }, {
      'id': 'WoodenKitchenLamp',
      'en': 'Wooden Kitchen Lamp',
      'fr': 'Lustre de cuisine en bois',
      'es': 'Lámpara de cocina (madera)',
      'de': 'Hölzerne Küchenlampe',
      'pl': 'Wooden Kitchen Lamp',
      'ru': 'Деревянная кухонная лампа',
      'uk': 'Дерев\u0027яна кухонна лампа',
      'ko': 'Wooden Kitchen Lamp',
      'zh': '木制厨房灯',
      'ja': 'Wooden Kitchen Lamp',
    }, {
      'id': 'WoodenLatrine',
      'en': 'Wooden Latrine',
      'fr': 'Latrines en bois',
      'es': 'Letrina de madera',
      'de': 'Holzlatrine',
      'pl': 'Drewniana Latryna',
      'ru': 'Деревянный туалет',
      'uk': 'Дерев’яний туалет',
      'ko': '나무 변소',
      'zh': '木质马桶',
      'ja': '木製トイレ',
    }, {
      'id': 'WoodenStrawBed',
      'en': 'Wooden Straw Bed',
      'fr': 'Lit de paille en bois',
      'es': 'Cama de madera y paja',
      'de': 'Hölzernes Strohbett',
      'pl': 'Drewniane Łożko z Siennikiem',
      'ru': 'Деревянная кровать с соломой',
      'uk': 'Дерев\u0027яне ліжко з соломою',
      'ko': '목재 짚 침대',
      'zh': '木质稻草床',
      'ja': '木製の藁ベッド',
    }, {
      'id': 'WoodenTableLamp',
      'en': 'Wooden Table Lamp',
      'fr': 'Lampe de table en bois',
      'es': 'Lámpara de madera para mesa',
      'de': 'Hölzerne Tischlampe',
      'pl': 'Drewniana lampa stołowa',
      'ru': 'Деревянная настольная лампа',
      'uk': 'Дерев’яний настільна лампа',
      'ko': '목재 탁자 전등',
      'zh': '木制台灯',
      'ja': '木製のテーブルランプ',
    }, {
      'id': 'WoodenWheel',
      'en': 'Wooden Wheel',
      'fr': 'Roue en bois',
      'es': 'Rueda de madera',
      'de': 'Rad aus Holz',
      'pl': 'Drewniane Koło',
      'ru': 'Деревянное колесо',
      'uk': 'Дерев’яне колесо',
      'ko': '목재 바퀴',
      'zh': '木轮',
      'ja': '木の車輪',
    }, {
      'id': 'WoolCarpet',
      'en': 'Wool Carpet',
      'fr': 'Tapis en laine',
      'es': 'Alfombra de lana',
      'de': 'Wollteppich',
      'pl': 'Wool Carpet',
      'ru': 'Шерстяной ковер',
      'uk': 'Wool Carpet',
      'ko': '양모 카펫',
      'zh': '羊毛地毯',
      'ja': 'Wool Carpet',
    }, {
      'id': 'WeaveWoolCurtains',
      'en': 'Weave Wool Curtains',
      'fr': 'Tisser des rideaux en laine',
      'es': 'Cortinas de Lana Tejida',
      'de': 'Webe Wollvorhänge',
      'pl': 'Weave Wool Curtains',
      'ru': 'Ткать Шерстяные шторы',
      'uk': 'Weave Wool Curtains',
      'ko': 'Weave Wool Curtains',
      'zh': '纺织毛线窗帘',
      'ja': 'Weave Wool Curtains',
    }, {
      'id': 'WoolCurtains',
      'en': 'Wool Curtains',
      'fr': 'Rideaux en laine',
      'es': 'Cortinas de lana',
      'de': 'Wollvorhänge',
      'pl': 'Wool Curtains',
      'ru': 'Шерстяные Шторы',
      'uk': 'Wool Curtains',
      'ko': '울 커튼',
      'zh': '羊毛窗帘',
      'ja': 'Wool Curtains',
    }, {
      'id': 'WeaveWoolFabric',
      'en': 'Weave Wool Fabric',
      'fr': 'Tissu en laine à tisser',
      'es': 'Tela de lana',
      'de': 'Wollstoff Weben',
      'pl': 'Weave Wool Fabric',
      'ru': 'Ткать Шерстяную Ткань',
      'uk': 'Weave Wool Fabric',
      'ko': '양모 원단을 짜다',
      'zh': '编织呢绒',
      'ja': 'Weave Wool Fabric',
    }, {
      'id': 'WoolFabric',
      'en': 'Wool Fabric',
      'fr': 'Tissu en laine',
      'es': 'Tela de lana',
      'de': 'Wollstoff',
      'pl': 'Wool Fabric',
      'ru': 'Шерстяная ткань',
      'uk': 'Wool Fabric',
      'ko': '울 원단',
      'zh': '呢绒',
      'ja': 'Wool Fabric',
    }, {
      'id': 'SpinWoolYarn',
      'en': 'Spin Wool Yarn',
      'fr': 'Fil de laine filé',
      'es': 'Hilar lana',
      'de': 'Wollgarn Spinnen',
      'pl': 'Spin Wool Yarn',
      'ru': 'Пряжа из шерсти',
      'uk': 'Spin Wool Yarn',
      'ko': '방적사',
      'zh': '纺织毛纱',
      'ja': 'Spin Wool Yarn',
    }, {
      'id': 'WoolYarn',
      'en': 'Wool Yarn',
      'fr': 'Fil de laine',
      'es': 'Hilo de lana',
      'de': 'Wollgarn',
      'pl': 'Wool Yarn',
      'ru': 'Шерстяная пряжа',
      'uk': 'Wool Yarn',
      'ko': '양모사',
      'zh': '毛纱',
      'ja': 'Wool Yarn',
    }, {
      'id': 'WorkBackpack',
      'en': 'Work Backpack',
      'fr': 'Sac à dos de travail',
      'es': 'Mochila de Trabajo',
      'de': 'Arbeitsrucksack',
      'pl': 'Plecak roboczy',
      'ru': 'Рабочий рюкзак',
      'uk': 'Робочий рюкзак',
      'ko': '작업 배낭',
      'zh': '工作背包',
      'ja': '作業バッグ',
    }, {
      'id': 'WorkBoots',
      'en': 'Work Boots',
      'fr': 'Bottes de travail',
      'es': 'Botas de Trabajo',
      'de': 'Arbeitsstiefel',
      'pl': 'Buty Robocze',
      'ru': 'Рабочие ботинки',
      'uk': 'Робочі чоботи',
      'ko': '작업화',
      'zh': '工作靴',
      'ja': '作業靴',
    }, {
      'id': 'WorldlyDonut',
      'en': 'Worldly Donut',
      'fr': 'Beignet mondain',
      'es': 'Donut del mundo',
      'de': 'Schmackhafter Donut',
      'pl': 'Worldly Donut',
      'ru': 'Пончик мудрости',
      'uk': 'Worldly Donut',
      'ko': 'Worldly Donut',
      'zh': '惊世甜甜圈',
      'ja': 'Worldly Donut',
    }, {
      'id': 'Yeast',
      'en': 'Yeast',
      'fr': 'Levure',
      'es': 'Levadura',
      'de': 'Hefe',
      'pl': 'Drożdże',
      'ru': 'Дрожжи',
      'uk': 'Дріжджі',
      'ko': '효모',
      'zh': '酵母',
      'ja': '酵母',
    }]
  }, {
    'type': 'skills', 'entries': [{
      'id': 'AdvancedBakingSkill',
      'en': 'Advanced Baking',
      'fr': 'Boulangerie avancée',
      'es': 'Horneado Avanzado',
      'de': 'Fortgeschrittenes Backen',
      'pl': 'Zaawansowane Pieczenie',
      'ru': 'Продвинутая выпечка',
      'uk': 'Розвинена випічка',
      'ko': '고급 제빵 기술',
      'zh': '高级烘烤',
      'ja': '高度な焼き料理',
    }, {
      'id': 'AdvancedCookingSkill',
      'en': 'Advanced Cooking',
      'fr': 'Cuisine avancée',
      'es': 'Cocina Avanzada',
      'de': 'Fortgeschrittenes Kochen',
      'pl': 'Zaawansowane Gotowanie',
      'ru': 'Продвинутая кулинария',
      'uk': 'Розвинена готівля',
      'ko': '고급 요리 기술',
      'zh': '高级烹饪',
      'ja': '高度な料理',
    }, {
      'id': 'AdvancedMasonrySkill',
      'en': 'Advanced Masonry',
      'fr': 'Maçonnerie Avancée',
      'es': 'Mampostería avanzada',
      'de': 'Verbesserter Steinmetz',
      'pl': 'Zaawansowane Kamieniarstwo',
      'ru': 'Продвинутая каменная кладка',
      'uk': 'Покращена кам\u0027яна кладка',
      'ko': '고급 석조 기술',
      'zh': '高级石工',
      'ja': 'Advanced Masonry',
    }, {
      'id': 'AdvancedSmeltingSkill',
      'en': 'Advanced Smelting',
      'fr': 'Fonte avancée',
      'es': 'Fundición Avanzada',
      'de': 'Fortgeschrittenes Schmelzen',
      'pl': 'Zaawansowane Hutnictwo',
      'ru': 'Продвинутая выплавка',
      'uk': 'Розвинене плавлення',
      'ko': '고급 제련 기술',
      'zh': '高级冶炼',
      'ja': '高度な精錬',
    }, {
      'id': 'BakingSkill',
      'en': 'Baking',
      'fr': 'Boulangerie',
      'es': 'Horneado',
      'de': 'Backen',
      'pl': 'Piekarwsto',
      'ru': 'Выпечка',
      'uk': 'Випічка',
      'ko': '제빵 기술',
      'zh': '烘烤',
      'ja': '焼成',
    }, {
      'id': 'BasicEngineeringSkill',
      'en': 'Basic Engineering',
      'fr': 'Ingénierie basique',
      'es': 'Ingeniería Básica',
      'de': 'Grundlegende Technik',
      'pl': 'Podstawy Inżynierii',
      'ru': 'Основы инженерного дела',
      'uk': 'Основи інженерії',
      'ko': '기초 기계공학 기술',
      'zh': '基础工程',
      'ja': '基礎工学',
    }, {
      'id': 'ButcherySkill',
      'en': 'Butchery',
      'fr': 'Boucherie',
      'es': 'Carnicería',
      'de': 'Metzgerhandwerk',
      'pl': 'Rzeźnictwo',
      'ru': 'Разделка животных',
      'uk': 'Різництво',
      'ko': '도축 기술',
      'zh': '肉加工',
      'ja': '食肉加工',
    }, {
      'id': 'CampfireCookingSkill',
      'en': 'Campfire Cooking',
      'fr': 'Cuisine au feu de camp',
      'es': 'Cocina con Fogata',
      'de': 'Lagerfeuerkochen',
      'pl': 'Gotowanie na Ognisku',
      'ru': 'Готовка на костре',
      'uk': 'Приготування їжі на багатті',
      'ko': '모닥불 요리 기술',
      'zh': '篝火烹饪',
      'ja': '野外簡易料理',
    }, {
      'id': 'CarpentrySkill',
      'en': 'Carpentry',
      'fr': 'Menuiserie',
      'es': 'Carpintería',
      'de': 'Schreinerei',
      'pl': 'Stolarstwo',
      'ru': 'Плотницкое дело',
      'uk': 'Теслярська справа',
      'ko': '목공 기술',
      'zh': '木工',
      'ja': '木工',
    }, {
      'id': 'CompositesSkill',
      'en': 'Composites',
      'fr': 'Composites',
      'es': 'Composites',
      'de': 'Verbundholzstoffe',
      'pl': 'Kompozyty',
      'ru': 'Композиты',
      'uk': 'Композити',
      'ko': '복합 목재 기술',
      'zh': '复合材料',
      'ja': '複合材',
    }, {
      'id': 'CookingSkill',
      'en': 'Cooking',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Kochen',
      'pl': 'Gotowanie',
      'ru': 'Готовка',
      'uk': 'Приготування їжі',
      'ko': '요리 기술',
      'zh': '烹饪',
      'ja': '料理',
    }, {
      'id': 'CuttingEdgeCookingSkill',
      'en': 'Cutting Edge Cooking',
      'fr': 'Cuisine moléculaire',
      'es': 'Cocina Innovadora',
      'de': 'Innovatives Kochen',
      'pl': 'Nowoczesne Gotowanie',
      'ru': 'Передовая кулинария',
      'uk': 'Сучасна кулінарія',
      'ko': '식품공학 기술',
      'zh': '尖端烹饪',
      'ja': '最先端料理',
    }, {
      'id': 'ElectronicsSkill',
      'en': 'Electronics',
      'fr': 'Électroniques',
      'es': 'Electrónica',
      'de': 'Elektronik',
      'pl': 'Elektronika',
      'ru': 'Электроника',
      'uk': 'Електроніка',
      'ko': '전자공학 기술',
      'zh': '电气',
      'ja': '電子工学',
    }, {
      'id': 'FarmingSkill',
      'en': 'Farming',
      'fr': 'Agriculture',
      'es': 'Agricultura',
      'de': 'Landwirtschaft',
      'pl': 'Rolnictwo',
      'ru': 'Фермерство',
      'uk': 'Фермерство',
      'ko': '농업 기술',
      'zh': '农业',
      'ja': '農業',
    }, {
      'id': 'FertilizersSkill',
      'en': 'Fertilizers',
      'fr': 'Engrais',
      'es': 'Fertilizantes',
      'de': 'Dünger',
      'pl': 'Nawozy',
      'ru': 'Удобрения',
      'uk': 'Добрива',
      'ko': '비료제조 기술',
      'zh': '化肥',
      'ja': '肥料',
    }, {
      'id': 'GatheringSkill',
      'en': 'Gathering',
      'fr': 'Récolte',
      'es': 'Recolección',
      'de': 'Sammeln',
      'pl': 'Zbieractwo',
      'ru': 'Собирательство',
      'uk': 'Збирання',
      'ko': '채집 기술',
      'zh': '采集',
      'ja': '採集',
    }, {
      'id': 'GlassworkingSkill',
      'en': 'Glassworking',
      'fr': 'Travail du verre',
      'es': 'Vidriería',
      'de': 'Glasverarbeitung',
      'pl': 'Obróbka szkła',
      'ru': 'Обработка стекла',
      'uk': 'Обробка скла',
      'ko': '유리 제조 기술',
      'zh': '玻璃加工',
      'ja': 'ガラス加工',
    }, {
      'id': 'HuntingSkill',
      'en': 'Hunting',
      'fr': 'Chasse',
      'es': 'Caza',
      'de': 'Jagen',
      'pl': 'Łowiectwo',
      'ru': 'Охота',
      'uk': 'Полювання',
      'ko': '사냥 기술',
      'zh': '狩猎',
      'ja': '狩猟',
    }, {
      'id': 'IndustrySkill',
      'en': 'Industry',
      'fr': 'Industrie',
      'es': 'Industria',
      'de': 'Industrie',
      'pl': 'Przemysł',
      'ru': 'Промышленность',
      'uk': 'Промисловість',
      'ko': '산업 기술',
      'zh': '工业',
      'ja': '産業',
    }, {
      'id': 'LoggingSkill',
      'en': 'Logging',
      'fr': 'Abattage',
      'es': 'Tala',
      'de': 'Holzfällen',
      'pl': 'Wyrąb drzew',
      'ru': 'Заготовка леса',
      'uk': 'Заготівля лісу',
      'ko': '벌목 기술',
      'zh': '伐木',
      'ja': '木こり',
    }, {
      'id': 'MasonrySkill',
      'en': 'Masonry',
      'fr': 'Maçonnerie',
      'es': 'Mampostería',
      'de': 'Steinmetz',
      'pl': 'Kamieniarstwo',
      'ru': 'Каменная кладка',
      'uk': 'Кам\u0027яна кладка',
      'ko': '석조 기술',
      'zh': '石工',
      'ja': 'Masonry',
    }, {
      'id': 'MechanicsSkill',
      'en': 'Mechanics',
      'fr': 'Mécaniques',
      'es': 'Mecánica',
      'de': 'Mechanik',
      'pl': 'Mechanika',
      'ru': 'Механика',
      'uk': 'Механіка',
      'ko': '기계정비 기술',
      'zh': '机械',
      'ja': '機械',
    }, {
      'id': 'MillingSkill',
      'en': 'Milling',
      'fr': 'Mouture',
      'es': 'Molinería',
      'de': 'Mahlen',
      'pl': 'Młynarstwo',
      'ru': 'Мельничное дело',
      'uk': 'Млинарство',
      'ko': '제분 기술',
      'zh': '研磨',
      'ja': '製粉',
    }, {
      'id': 'MiningSkill',
      'en': 'Mining',
      'fr': 'Minage',
      'es': 'Minería',
      'de': 'Bergbau',
      'pl': 'Górnictwo',
      'ru': 'Горное дело',
      'uk': 'Гірництво',
      'ko': '채광 기술',
      'zh': '采矿',
      'ja': '採掘',
    }, {
      'id': 'OilDrillingSkill',
      'en': 'Oil Drilling',
      'fr': 'Forage pétrolier',
      'es': 'Perforación de Petróleo',
      'de': 'Ölbohrung',
      'pl': 'Wydobycie Ropy',
      'ru': 'Добыча нефти',
      'uk': 'Добування нафти',
      'ko': '유정 굴착 기술',
      'zh': '油井',
      'ja': '原油採掘',
    }, {
      'id': 'PaperMillingSkill',
      'en': 'Paper Milling',
      'fr': 'Production de papier',
      'es': 'Molienda de Papel',
      'de': 'Papierherstellung',
      'pl': 'Papiernia',
      'ru': 'Производство бумаги',
      'uk': 'Папірництво',
      'ko': '제지 가공 기술',
      'zh': '造纸',
      'ja': '製紙',
    }, {
      'id': 'PotterySkill',
      'en': 'Pottery',
      'fr': 'Poterie',
      'es': 'Cerámica',
      'de': 'Töpfern',
      'pl': 'Garncarstwo',
      'ru': 'Гончарство',
      'uk': 'Гончарна справа',
      'ko': '도기 기술',
      'zh': '陶器',
      'ja': 'Pottery',
    }, {
      'id': 'SmeltingSkill',
      'en': 'Smelting',
      'fr': 'Fonte',
      'es': 'Fundición',
      'de': 'Schmelzen',
      'pl': 'Hutnictwo',
      'ru': 'Выплавка',
      'uk': 'Плавлення',
      'ko': '제련 기술',
      'zh': '冶炼',
      'ja': '精錬',
    }, {
      'id': 'TailoringSkill',
      'en': 'Tailoring',
      'fr': 'Couture',
      'es': 'Sastrería',
      'de': 'Schneidern',
      'pl': 'Krawiectwo',
      'ru': 'Работа с тканью',
      'uk': 'Кравецтво',
      'ko': '재단 기술',
      'zh': '裁缝',
      'ja': '裁縫',
    }]
  }, {
    'type': 'tables', 'entries': [{
      'id': 'AdvancedCarpentryTableObject',
      'en': 'Advanced Carpentry Table',
      'fr': 'Établi de menuiserie avancé',
      'es': 'Mesa de carpintería avanzada',
      'de': 'Verbesserter Schreinerhandwerkstisch',
      'pl': 'Zaawansowany stół stolarski',
      'ru': 'Продвинутый верстак плотника',
      'uk': 'Розширений теслярський стіл',
      'ko': '고급 목공 작업대',
      'zh': '高级木工桌',
      'ja': 'Advanced Carpentry Table',
    }, {
      'id': 'AdvancedMasonryTableObject',
      'en': 'Advanced Masonry Table',
      'fr': 'Établi de maçonnerie avancé',
      'es': 'Mesa de mampostería avanzada',
      'de': 'Verbesserter Steinmetztisch',
      'pl': 'Zaawansowany stół kamieniarski',
      'ru': 'Продвинутый верстак каменщика',
      'uk': 'Покращенний верстак муляра',
      'ko': '고급 석공 작업대',
      'zh': '高级石工台',
      'ja': 'Advanced Masonry Table',
    }, {
      'id': 'AdvancedTailoringTableObject',
      'en': 'Advanced Tailoring Table',
      'fr': 'Établi de couturier avancé',
      'es': 'Mesa de sastrería avanzada',
      'de': 'Verbesserter Schneidertisch',
      'pl': 'Advanced Tailoring Table',
      'ru': 'Продвинутый Стол Портного',
      'uk': 'Advanced Tailoring Table',
      'ko': '고급 재봉 테이블',
      'zh': '高级裁缝台',
      'ja': 'Advanced Tailoring Table',
    }, {
      'id': 'AnvilObject',
      'en': 'Anvil',
      'fr': 'Enclume',
      'es': 'Yunque',
      'de': 'Amboss',
      'pl': 'Kowadło',
      'ru': 'Наковальня',
      'uk': 'Ковадло',
      'ko': '모루',
      'zh': '铁砧',
      'ja': '金床',
    }, {
      'id': 'ArrastraObject',
      'en': 'Arrastra',
      'fr': 'Concasseur à meules en pierre',
      'es': 'Arrastra',
      'de': 'Bergbau-Pochmühle',
      'pl': 'Opór',
      'ru': 'Аррастра',
      'uk': 'Аррастра',
      'ko': '돌 맷돌',
      'zh': '碎金研磨机',
      'ja': 'Arrastra',
    }, {
      'id': 'AssemblyLineObject',
      'en': 'Assembly Line',
      'fr': 'Ligne de Montage',
      'es': 'Línea de Ensamblaje',
      'de': 'Mechanische Fertigungsstraße',
      'pl': 'Linia Produkcyjna',
      'ru': 'Сборочная линия',
      'uk': 'Лінія для збору',
      'ko': '조립 라인',
      'zh': '装配线',
      'ja': '組立ライン',
    }, {
      'id': 'AutomaticLoomObject',
      'en': 'Automatic Loom',
      'fr': 'Métier à tisser automatique',
      'es': 'Telar mecánico',
      'de': 'Automatischer Webstuhl',
      'pl': 'Automatic Loom',
      'ru': 'Автоматический ткацкий станок',
      'uk': 'Automatic Loom',
      'ko': '자동 베틀',
      'zh': '自动织布机',
      'ja': 'Automatic Loom',
    }, {
      'id': 'BakeryOvenObject',
      'en': 'Bakery Oven',
      'fr': 'Four à pain',
      'es': 'Horno de Panadería',
      'de': 'Bäckereiofen',
      'pl': 'Piec piekarniczy',
      'ru': 'Печь для выпечки',
      'uk': 'Піч для випічки',
      'ko': '제빵 화덕',
      'zh': '烤炉',
      'ja': 'ベーカリーオーブン',
    }, {
      'id': 'BlastFurnaceObject',
      'en': 'Blast Furnace',
      'fr': 'Haut fourneau',
      'es': 'Alto Horno',
      'de': 'Hochofen',
      'pl': 'Piec Chutniczy',
      'ru': 'Доменная печь',
      'uk': 'Домна',
      'ko': '용광로',
      'zh': '高炉',
      'ja': '高炉',
    }, {
      'id': 'BloomeryObject',
      'en': 'Bloomery',
      'fr': 'Bas fourneau',
      'es': 'Horno de fundición',
      'de': 'Schmelzofen',
      'pl': 'Dymarka',
      'ru': 'Сыродутная печь',
      'uk': 'Сиродутне горно',
      'ko': '괴철로',
      'zh': '锻铁炉',
      'ja': '塊鉄炉',
    }, {
      'id': 'ButcheryTableObject',
      'en': 'Butchery Table',
      'fr': 'Table de boucherie',
      'es': 'Mesa de carnicería',
      'de': 'Metzgertisch',
      'pl': 'Stół rzeźnicki',
      'ru': 'Разделочный стол',
      'uk': 'Різницький стіл',
      'ko': '도축 작업대',
      'zh': '肉加工工作台',
      'ja': '食肉加工台',
    }, {
      'id': 'CampfireObject',
      'en': 'Campfire',
      'fr': 'Feu de camp',
      'es': 'Fogata',
      'de': 'Lagerfeuer',
      'pl': 'Ognisko',
      'ru': 'Костёр',
      'uk': 'Багаття',
      'ko': '모닥불',
      'zh': '篝火',
      'ja': '焚き火',
    }, {
      'id': 'CampsiteObject',
      'en': 'Campsite',
      'fr': 'Camping',
      'es': 'Campamento',
      'de': 'Campingplatz',
      'pl': 'Obóz',
      'ru': 'Палатка',
      'uk': 'Кемпінг',
      'ko': '야영지',
      'zh': '营地',
      'ja': 'キャンプサイト',
    }, {
      'id': 'CapitolObject',
      'en': 'Capitol',
      'fr': 'Pupitre de la Constitution',
      'es': 'Capitolio',
      'de': 'Tisch der Verfassung',
      'pl': 'Kapitol',
      'ru': 'Капитолий',
      'uk': 'Капітолій',
      'ko': '중앙정부',
      'zh': '公约台',
      'ja': 'Capitol',
    }, {
      'id': 'CarpentryTableObject',
      'en': 'Carpentry Table',
      'fr': 'Établi de menuiserie',
      'es': 'Mesa de carpintería',
      'de': 'Zimmermanntisch',
      'pl': 'Stół Stolarski',
      'ru': 'Плотницкий верстак',
      'uk': 'Стіл теслі',
      'ko': '목공 작업대',
      'zh': '木工工作台',
      'ja': '木工作業台',
    }, {
      'id': 'CastIronStoveObject',
      'en': 'Cast Iron Stove',
      'fr': 'Poêle en fonte',
      'es': 'Estufa de hierro fundido',
      'de': 'Gusseiserner Ofen',
      'pl': 'Żeliwna kuchnia',
      'ru': 'Чугунная плита',
      'uk': 'Чавунна піч',
      'ko': '철재 화덕',
      'zh': '铸铁火炉',
      'ja': '鋳鉄のストーブ',
    }, {
      'id': 'CementKilnObject',
      'en': 'Cement Kiln',
      'fr': 'Four à ciment',
      'es': 'Horno de Cemento',
      'de': 'Zementbrennofen',
      'pl': 'Cementownia',
      'ru': 'Барабанная печь',
      'uk': 'Піч для цементу',
      'ko': '시멘트 가마',
      'zh': '水泥窑',
      'ja': 'セメントのかまど',
    }, {
      'id': 'ElectricLatheObject',
      'en': 'Electric Lathe',
      'fr': 'Tour électrique',
      'es': 'Torno eléctrico',
      'de': 'Elektrische Drehmaschine',
      'pl': 'Tokarka Elektryczna',
      'ru': 'Электрический токарный станок',
      'uk': 'Електричний токарний верстат',
      'ko': '전동식 선반 기계',
      'zh': '电动车床',
      'ja': '電気旋盤',
    }, {
      'id': 'ElectricMachinistTableObject',
      'en': 'Electric Machinist Table',
      'fr': 'Établi électrique',
      'es': 'Mesa eléctrica de maquinista',
      'de': 'Elektrischer Montagetisch',
      'pl': 'Elektryczny Stół Maszynowy',
      'ru': 'Электрический слесарный верстак',
      'uk': 'Стіл електромашиніста',
      'ko': '전동식 기계 정비공 작업대',
      'zh': '电动机械师工作台',
      'ja': '電気工作機械台',
    }, {
      'id': 'ElectricPlanerObject',
      'en': 'Electric Planer',
      'fr': 'Fraiseuse électrique',
      'es': 'Cepilladora eléctrica',
      'de': 'Elektrische Hobelmaschine',
      'pl': 'Strug Elektryczny',
      'ru': 'Электрический строгальный станок',
      'uk': 'Електричний стругальний верстат',
      'ko': '전동식 대패',
      'zh': '电动刨床',
      'ja': '電気かんな盤',
    }, {
      'id': 'ElectricStampingPressObject',
      'en': 'Electric Stamping Press',
      'fr': 'Presse électrique',
      'es': 'Prensa de Estampado Hidráulica',
      'de': 'Elektrische Stanzpresse',
      'pl': 'Elektryczna prasa do tłoczenia',
      'ru': 'Электрический пресс',
      'uk': 'Електричний прес',
      'ko': '전동식 금속 가공기',
      'zh': '电动冲床',
      'ja': '電気スタンピングプレス機',
    }, {
      'id': 'ElectronicsAssemblyObject',
      'en': 'Electronics Assembly',
      'fr': 'Atelier d\u0027électronique',
      'es': 'Sección de ensamblaje electrónico',
      'de': 'Elektronikfertigung',
      'pl': 'Montaż Elektroniki',
      'ru': 'Сборщик электроники',
      'uk': 'Збирач електроніки',
      'ko': '전자 공학 작업대',
      'zh': '电子装配套装',
      'ja': '電子機器組立機',
    }, {
      'id': 'FarmersTableObject',
      'en': 'Farmers Table',
      'fr': 'Atelier d\u0027agriculture',
      'es': 'Mesa de Agricultor',
      'de': 'Landwirttisch',
      'pl': 'Stół Rolniczy',
      'ru': 'Фермерский стол',
      'uk': 'Фермерський стіл',
      'ko': '농업 작업대',
      'zh': '农业工作台',
      'ja': '園芸作業台',
    }, {
      'id': 'FisheryObject',
      'en': 'Fishery',
      'fr': 'Atelier de pêche',
      'es': 'Pesquería',
      'de': 'Fischereitisch',
      'pl': 'Rybołóstwo',
      'ru': 'Шкаф рыбака',
      'uk': 'Шафка рибалки',
      'ko': '어업 작업대',
      'zh': '渔具',
      'ja': '釣り具作業台',
    }, {
      'id': 'FrothFloatationCellObject',
      'en': 'Froth Floatation Cell',
      'fr': 'Cellule de flottation',
      'es': 'Celda de espuma flotante',
      'de': 'Schaumschwimmzelle',
      'pl': 'Pianka pływacka',
      'ru': 'Флотатор',
      'uk': 'Флотатор',
      'ko': '거품 부유 분별기',
      'zh': '泡沫浮选池',
      'ja': 'Froth Floatation Cell',
    }, {
      'id': 'JawCrusherObject',
      'en': 'Jaw Crusher',
      'fr': 'Concasseur à mâchoires en acier',
      'es': 'Trituradora',
      'de': 'Kieferbrecher',
      'pl': 'Kruszarka szczękowa',
      'ru': 'Щековая дробилка',
      'uk': 'Щокова дробарка',
      'ko': '암석 패쇄기',
      'zh': '颚式破碎机',
      'ja': 'Jaw Crusher',
    }, {
      'id': 'KilnObject',
      'en': 'Kiln',
      'fr': 'Four à céramique',
      'es': 'Horno',
      'de': 'Brennofen',
      'pl': 'Piec do Wypalania',
      'ru': 'Печь для обжига',
      'uk': 'Промислова піч',
      'ko': '가마',
      'zh': '窑',
      'ja': 'かまど',
    }, {
      'id': 'KitchenObject',
      'en': 'Kitchen',
      'fr': 'Cuisine',
      'es': 'Cocina',
      'de': 'Küche',
      'pl': 'Kuchnia',
      'ru': 'Кухня',
      'uk': 'Кухня',
      'ko': '주방',
      'zh': '厨房',
      'ja': 'キッチン',
    }, {
      'id': 'LaboratoryObject',
      'en': 'Laboratory',
      'fr': 'Laboratoire',
      'es': 'Laboratorio',
      'de': 'Laboratorium',
      'pl': 'Laboratorium',
      'ru': 'Лаборатория',
      'uk': 'Лабораторія',
      'ko': '연구대',
      'zh': '实验室',
      'ja': '研究所',
    }, {
      'id': 'LatheObject',
      'en': 'Lathe',
      'fr': 'Tour',
      'es': 'Torno',
      'de': 'Drehmaschine',
      'pl': 'Lathe',
      'ru': 'Токарный станок',
      'uk': 'Токарний верстат',
      'ko': '선반 기계',
      'zh': '车床',
      'ja': 'Lathe',
    }, {
      'id': 'LoomObject',
      'en': 'Loom',
      'fr': 'Métier à tisser',
      'es': 'Telar',
      'de': 'Webstuhl',
      'pl': 'Loom',
      'ru': 'Ткацкий станок',
      'uk': 'Loom',
      'ko': '직조기',
      'zh': '织布机',
      'ja': 'Loom',
    }, {
      'id': 'MachinistTableObject',
      'en': 'Machinist Table',
      'fr': 'Établi de mécanicien',
      'es': 'Mesa de maquinista',
      'de': 'Mechanikertisch',
      'pl': 'Machinist Table',
      'ru': 'Слесарный верстак',
      'uk': 'Стіл машиніста',
      'ko': '기계공 작업대',
      'zh': '机械师工作台',
      'ja': '機械工のテーブル',
    }, {
      'id': 'MasonryTableObject',
      'en': 'Masonry Table',
      'fr': 'Établi de maçonnerie',
      'es': 'Mesa de mampostería',
      'de': 'Steinmetztisch',
      'pl': 'Stół murarski',
      'ru': 'Верстак каменщика',
      'uk': 'Каменярський стіл',
      'ko': '석조 작업대',
      'zh': '石匠工作台',
      'ja': '石工作業台',
    }, {
      'id': 'MillObject',
      'en': 'Mill',
      'fr': 'Meule',
      'es': 'Molino',
      'de': 'Mahlwerk',
      'pl': 'Młyn',
      'ru': 'Мельница',
      'uk': 'Млин',
      'ko': '맷돌',
      'zh': '磨坊',
      'ja': '製粉機',
    }, {
      'id': 'OilRefineryObject',
      'en': 'Oil Refinery',
      'fr': 'Raffinerie de pétrole',
      'es': 'Refinería de Petróleo',
      'de': 'Raffinerie',
      'pl': 'Rafineria',
      'ru': 'Нефтеперерабатывающий завод',
      'uk': 'Нафтопереробний завод',
      'ko': '석유 증류탑',
      'zh': '炼油厂',
      'ja': '石油精製所',
    }, {
      'id': 'PumpJackObject',
      'en': 'Pump Jack',
      'fr': 'Chevalet de pompage',
      'es': 'Unidad de Bombeo',
      'de': 'Ölbohrturm',
      'pl': 'Kiwak',
      'ru': 'Нефтяная вышка',
      'uk': 'Нафтовий насос',
      'ko': '석유 시추기',
      'zh': '油压机',
      'ja': 'ポンプジャッキ',
    }, {
      'id': 'ResearchTableObject',
      'en': 'Research Table',
      'fr': 'Table de recherche',
      'es': 'Mesa de investigación',
      'de': 'Forschungstisch',
      'pl': 'Stół badawczy',
      'ru': 'Стол для исследований',
      'uk': 'Дослідницький стіл',
      'ko': '연구 작업대',
      'zh': '研究工作台',
      'ja': 'リサーチテーブル',
    }, {
      'id': 'RoboticAssemblyLineObject',
      'en': 'Robotic Assembly Line',
      'fr': 'Ligne de montage robotisée',
      'es': 'Línea de Ensamblaje Robótica',
      'de': 'Robotische Fertigungsstraße',
      'pl': 'Robotic Assembly Line',
      'ru': 'Роботизированная сборочная линия',
      'uk': 'Роботизована лінія для збору',
      'ko': '자동화 조립 라인',
      'zh': '机器人装配线',
      'ja': 'ロボット組立ライン',
    }, {
      'id': 'RockerBoxObject',
      'en': 'Rocker Box',
      'fr': 'Rampe de lavage',
      'es': 'Caja de balancines',
      'de': 'Bergbau-Waschtisch',
      'pl': 'Sito kołyskowe',
      'ru': 'Вашгерд',
      'uk': 'Накопичувач руди',
      'ko': '로커 박스',
      'zh': '摇臂箱',
      'ja': 'Rocker Box',
    }, {
      'id': 'RollingMillObject',
      'en': 'Rolling Mill',
      'fr': 'Laminoir',
      'es': 'Molino de laminado',
      'de': 'Walzwerk',
      'pl': 'Walcownia',
      'ru': 'Прокатный стан',
      'uk': 'Стан прокатний',
      'ko': '압연기',
      'zh': '轧机',
      'ja': '圧延機',
    }, {
      'id': 'SawmillObject',
      'en': 'Sawmill',
      'fr': 'Scierie',
      'es': 'Aserradero',
      'de': 'Sägewerk',
      'pl': 'Tartak',
      'ru': 'Лесопилка',
      'uk': 'Лісопилка',
      'ko': '제재대',
      'zh': '锯木台',
      'ja': '製材機',
    }, {
      'id': 'ScreeningMachineObject',
      'en': 'Screening Machine',
      'fr': 'Machine de criblage',
      'es': 'Máquina de escaneo',
      'de': 'Siebmaschine',
      'pl': 'Maszyna do Przesiewania',
      'ru': 'Вибрационный сортировщик',
      'uk': 'Просіювальна машина',
      'ko': '건식 제련 기계',
      'zh': '筛选机',
      'ja': '選別機',
    }, {
      'id': 'ScrewPressObject',
      'en': 'Screw Press',
      'fr': 'Presse à vis',
      'es': 'Prensa de tornillos',
      'de': 'Spindelpresse',
      'pl': 'Screw Press',
      'ru': 'Винтовой пресс',
      'uk': 'Гвинтовий прес',
      'ko': '압입식 조임 기계',
      'zh': '螺旋压榨机',
      'ja': 'ねじプレス',
    }, {
      'id': 'SensorBasedBeltSorterObject',
      'en': 'Sensor Based Belt Sorter',
      'fr': 'Tapis de tri à détecteurs',
      'es': 'Cinta organizadora con sensores',
      'de': 'Sensorenbasierter Gürtelsortierer',
      'pl': 'Sorter taśmowy oparty na czujnikach',
      'ru': 'Сенсорный конвейерный сортировщик',
      'uk': 'Сенсорний сортувальник конвеєрної лінії',
      'ko': '감지기 기반 자동 분류기',
      'zh': '基于传感器的皮带分拣机',
      'ja': 'Sensor Based Belt Sorter',
    }, {
      'id': 'ShaperObject',
      'en': 'Shaper',
      'fr': 'Formeuse',
      'es': 'Modelador (m.) Modeladora (f.)',
      'de': 'Fräsmaschine',
      'pl': 'Shaper',
      'ru': 'Строгальный станок',
      'uk': 'Стругальний верстат',
      'ko': '형삭반',
      'zh': '刨床',
      'ja': '形削り盤',
    }, {
      'id': 'SpinMelterObject',
      'en': 'Spin Melter',
      'fr': 'Fileuse-fondeuse',
      'es': 'Torno de fusión',
      'de': 'Schmelzschleuderer',
      'pl': 'Spin Melter',
      'ru': 'Прядильная машина',
      'uk': 'Spin Melter',
      'ko': '스핀 멜터',
      'zh': '旋转熔炉',
      'ja': 'Spin Melter',
    }, {
      'id': 'StampMillObject',
      'en': 'Stamp Mill',
      'fr': 'Concasseur à percussions en fer',
      'es': 'Molino de pisón',
      'de': 'Pochwerk',
      'pl': 'Kruszarka',
      'ru': 'Штамповочная мельница',
      'uk': 'Штамповий млин',
      'ko': '쇄광기',
      'zh': '捣矿机',
      'ja': 'Stamp Mill',
    }, {
      'id': 'StoveObject',
      'en': 'Stove',
      'fr': 'Cuisinière',
      'es': 'Estufa',
      'de': 'Herd',
      'pl': 'Kuchnia',
      'ru': 'Плита',
      'uk': 'Плита',
      'ko': '화덕',
      'zh': '火炉',
      'ja': 'ストーブ',
    }, {
      'id': 'TailoringTableObject',
      'en': 'Tailoring Table',
      'fr': 'Atelier de couture',
      'es': 'Mesa de sastrería',
      'de': 'Schneidertisch',
      'pl': 'Stacja Krawiecka',
      'ru': 'Стол портного',
      'uk': 'Кравецький стіл',
      'ko': '재단 작업대',
      'zh': '裁缝工作台',
      'ja': '裁縫作業台',
    }, {
      'id': 'ToolBenchObject',
      'en': 'Tool Bench',
      'fr': 'Établi d\u0027outillage',
      'es': 'Mesa de herramientas',
      'de': 'Werkzeugtisch',
      'pl': 'Stół narzędziowy',
      'ru': 'Стол для инструментов',
      'uk': 'Стіл для інструментів',
      'ko': '도구 작업대',
      'zh': '工具台',
      'ja': 'Tool Bench',
    }, {
      'id': 'WainwrightTableObject',
      'en': 'Wainwright Table',
      'fr': 'Établi d\u0027ingénierie routière',
      'es': 'Mesa de carretero',
      'de': 'Wagenmachertisch',
      'pl': 'Stół Powoźniczy',
      'ru': 'Верстак колесника',
      'uk': 'Стіл стельмаха',
      'ko': '짐수레 작업대',
      'zh': '车匠工作台',
      'ja': '荷車作業台',
    }, {
      'id': 'WorkbenchObject',
      'en': 'Workbench',
      'fr': 'Établi de bricolage',
      'es': 'Mesa de Trabajo',
      'de': 'Werkbank',
      'pl': 'Stół Roboczy',
      'ru': 'Верстак',
      'uk': 'Верстат',
      'ko': '작업대',
      'zh': '工作台',
      'ja': '作業台',
    }]
  }, {
    'type': 'upgrades', 'entries': [{
      'id': 'AdvancedUpgrade1',
      'en': 'Advanced Upgrade 1',
      'fr': 'Amélioration Avancée Nv1',
      'es': 'Mejora avanzada 1',
      'de': 'Fortschrittliches Upgrade 1',
      'pl': 'Zaawansowane ulepszenie 1',
      'ru': 'Продвинутое улучшение 1',
      'uk': 'Просунуте покращення 1',
      'ko': '고급 업그레이드 1',
      'zh': '高级升级1',
      'ja': 'Advanced Upgrade 1',
    }, {
      'id': 'AdvancedUpgrade2',
      'en': 'Advanced Upgrade 2',
      'fr': 'Amélioration Avancée Nv2',
      'es': 'Mejora avanzada 2',
      'de': 'Fortschrittliches Upgrade 2',
      'pl': 'Zaawansowane ulepszenie 2',
      'ru': 'Продвинутое улучшение 2',
      'uk': 'Просунуте покращення 2',
      'ko': '고급 업그레이드 2',
      'zh': '高级升级2',
      'ja': 'Advanced Upgrade 2',
    }, {
      'id': 'AdvancedUpgrade3',
      'en': 'Advanced Upgrade 3',
      'fr': 'Amélioration Avancée Nv3',
      'es': 'Mejora avanzada 3',
      'de': 'Fortschrittliches Upgrade 3',
      'pl': 'Zaawansowane ulepszenie 3',
      'ru': 'Продвинутое улучшение 3',
      'uk': 'Просунуте покращення 3',
      'ko': '고급 업그레이드 3',
      'zh': '高级升级3',
      'ja': 'Advanced Upgrade 3',
    }, {
      'id': 'AdvancedUpgrade4',
      'en': 'Advanced Upgrade 4',
      'fr': 'Amélioration Avancée Nv4',
      'es': 'Mejora avanzada 4',
      'de': 'Fortschrittliches Upgrade 4',
      'pl': 'Zaawansowane ulepszenie 4',
      'ru': 'Продвинутое улучшение 4',
      'uk': 'Просунуте покращення 4',
      'ko': '고급 업그레이드 4',
      'zh': '高级升级4',
      'ja': 'Advanced Upgrade 4',
    }, {
      'id': 'BasicUpgrade1',
      'en': 'Basic Upgrade 1',
      'fr': 'Amélioration Basique Nv1',
      'es': 'Mejora básica 1',
      'de': 'Grundlegendes Upgrade 1',
      'pl': 'Podstawowe ulepszenie 1',
      'ru': 'Базовое улучшение 1',
      'uk': 'Базове покращення 1',
      'ko': '기초 업그레이드 1',
      'zh': '基础升级1',
      'ja': '基礎アップグレード1',
    }, {
      'id': 'BasicUpgrade2',
      'en': 'Basic Upgrade 2',
      'fr': 'Amélioration Basique Nv2',
      'es': 'Mejora básica 2',
      'de': 'Grundlegendes Upgrade 2',
      'pl': 'Podstawowe ulepszenie 2',
      'ru': 'Базовое улучшение 2',
      'uk': 'Базове покращення 2',
      'ko': '기초 업그레이드 2',
      'zh': '基础升级2',
      'ja': '基礎アップグレード2',
    }, {
      'id': 'BasicUpgrade3',
      'en': 'Basic Upgrade 3',
      'fr': 'Amélioration Basique Nv3',
      'es': 'Mejora básica 3',
      'de': 'Grundlegendes Upgrade 3',
      'pl': 'Podstawowe ulepszenie 3',
      'ru': 'Базовое улучшение 3',
      'uk': 'Базове покращення 3',
      'ko': '기초 업그레이드 3',
      'zh': '基础升级3',
      'ja': '基礎アップグレード3',
    }, {
      'id': 'BasicUpgrade4',
      'en': 'Basic Upgrade 4',
      'fr': 'Amélioration Basique Nv4',
      'es': 'Mejora básica 4',
      'de': 'Grundlegendes Upgrade 4',
      'pl': 'Podstawowe ulepszenie 4',
      'ru': 'Базовое улучшение 4',
      'uk': 'Базове покращення 4',
      'ko': '기초 업그레이드 4',
      'zh': '基础升级4',
      'ja': '基礎アップグレード4',
    }, {
      'id': 'ModernUpgrade1',
      'en': 'Modern Upgrade 1',
      'fr': 'Amélioration Moderne Nv1',
      'es': 'Mejora moderna 1',
      'de': 'Modernes Upgrade 1',
      'pl': 'Nowoczesne ulepszenie 1',
      'ru': 'Современное улучшение 1',
      'uk': 'Новітнє покращення 1',
      'ko': '현대식 업그레이드 1',
      'zh': '现代升级1',
      'ja': '近代アップグレード1',
    }, {
      'id': 'ModernUpgrade2',
      'en': 'Modern Upgrade 2',
      'fr': 'Amélioration Moderne Nv2',
      'es': 'Mejora moderna 2',
      'de': 'Modernes Upgrade 2',
      'pl': 'Nowoczesne ulepszenie 2',
      'ru': 'Современное улучшение 2',
      'uk': 'Новітнє покращення 2',
      'ko': '현대식 업그레이드 2',
      'zh': '现代升级2',
      'ja': '近代アップグレード2',
    }, {
      'id': 'ModernUpgrade3',
      'en': 'Modern Upgrade 3',
      'fr': 'Amélioration Moderne Nv3',
      'es': 'Mejora moderna 3',
      'de': 'Modernes Upgrade 3',
      'pl': 'Nowoczesne ulepszenie 3',
      'ru': 'Современное улучшение 3',
      'uk': 'Новітнє покращення 3',
      'ko': '현대식 업그레이드 3',
      'zh': '现代升级3',
      'ja': '近代アップグレード3',
    }, {
      'id': 'ModernUpgrade4',
      'en': 'Modern Upgrade 4',
      'fr': 'Amélioration Moderne Nv4',
      'es': 'Mejora moderna 4',
      'de': 'Modernes Upgrade 4',
      'pl': 'Nowoczesne ulepszenie 4',
      'ru': 'Современное улучшение 4',
      'uk': 'Новітнє покращення 4',
      'ko': '현대식 업그레이드 4',
      'zh': '现代升级4',
      'ja': '近代アップグレード4',
    }, {
      'id': 'NoUpgradeBasic',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeAdvanced',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeModern',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'NoUpgradeNone',
      'en': 'No Upgrade',
      'fr': 'Pas de mise à niveau',
      'es': 'Sin actualización',
      'de': 'Kein Upgrade',
      'pl': 'Bez aktualizacji',
      'ru': 'Без обновления',
      'uk': 'Без оновлення',
      'ko': '업그레이드 없음',
      'zh': '无升级',
      'ja': 'アップグレードなし'
    }, {
      'id': 'SpecializedAdvancedUpgrade',
      'en': 'Specialized Advanced Upgrade',
      'fr': 'Mise à niveau avancée spécialisée',
      'es': 'Actualización avanzada especializada',
      'de': 'Spezialisiertes erweitertes Upgrade',
      'pl': 'Specjalistyczne zaawansowane ulepszenie',
      'ru': 'Специализированное расширенное обновление',
      'uk': 'Спеціалізоване розширене оновлення',
      'ko': '전문화된 고급 업그레이드',
      'zh': '专业进阶升级',
      'ja': '専門の高度なアップグレード'
    }, {
      'id': 'SpecializedBasicUpgrade',
      'en': 'Specialized Basic Upgrade',
      'fr': 'Mise à niveau de base spécialisée',
      'es': 'Actualización básica especializada',
      'de': 'Spezialisiertes Basis-Upgrade',
      'pl': 'Specjalistyczne podstawowe ulepszenie',
      'ru': 'Специализированное базовое обновление',
      'uk': 'Спеціалізоване базове оновлення',
      'ko': '전문화된 기본 업그레이드',
      'zh': '专业基础升级',
      'ja': '専門の基本アップグレード'
    }, {
      'id': 'SpecializedModernUpgrade',
      'en': 'Specialized Modern Upgrade',
      'fr': 'Mise à niveau moderne spécialisée',
      'es': 'Actualización moderna especializada',
      'de': 'Spezialisiertes modernes Upgrade',
      'pl': 'Specjalistyczne nowoczesne ulepszenie',
      'ru': 'Специализированное современное обновление',
      'uk': 'Спеціалізоване сучасне оновлення',
      'ko': '전문화된 현대 업그레이드',
      'zh': '专业现代升级',
      'ja': 'スペシャライズドモダンアップグレード'
    }]
  }];
